/**
 * Generated by orval v8.8.1 🍺
 * Do not edit manually.
 * Services.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import { fetcher } from './fetcher';
export interface ActivateAgentProcedureVersionRequest {
  sha256?: string;
}

export interface AdditionalInfoDto {
  /** @nullable */
  deliveryPoint?: string | null;
  /** @nullable */
  carrierRoute?: string | null;
  /** @nullable */
  dpvConfirmation?: string | null;
  /** @nullable */
  dpvcmra?: string | null;
  /** @nullable */
  business?: string | null;
  /** @nullable */
  centralDeliveryPoint?: string | null;
  /** @nullable */
  vacant?: string | null;
}

export interface AddMarketAttemptRequest {
  carrierPartyId?: string;
  /** @nullable */
  carrierCatalogId?: string | null;
  /** @nullable */
  appetiteMatch?: string | null;
  /** @nullable */
  status?: string | null;
  /** @nullable */
  sentAt?: string | null;
  /** @nullable */
  responseAt?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
     */
  quotePremium?: number | null;
  /** @nullable */
  declineReason?: string | null;
  /** @nullable */
  notes?: string | null;
}

export interface AddressDto {
  street1?: string;
  /** @nullable */
  street2?: string | null;
  city?: string;
  state?: string;
  zip?: string;
}

export interface AddressValidateRequest {
  street1?: string;
  /** @nullable */
  street2?: string | null;
  city?: string;
  state?: string;
  zip?: string;
}

export interface CorrectionDto {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  text?: string | null;
}

export interface MatchDto {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  text?: string | null;
}

export interface AddressValidateResponse {
  isValid?: boolean;
  validatedAddress?: null | AddressDto;
  /** @nullable */
  suggestions?: AddressDto[] | null;
  /** @nullable */
  error?: string | null;
  additionalInfo?: null | AdditionalInfoDto;
  /** @nullable */
  corrections?: CorrectionDto[] | null;
  /** @nullable */
  matches?: MatchDto[] | null;
  /** @nullable */
  warnings?: string[] | null;
}

export interface AddTeamMemberRequest {
  userId: string;
  /**
     * @maxLength 20
     * @nullable
     */
  role?: string | null;
}

export interface AdminCarrierCatalogPayload {
  carrierCatalogId: string;
  displayName: string;
  marketTypeCode: string;
  statusCode: string;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  naicCompanyCode: number | null;
  /** @nullable */
  carrierPartyId: string | null;
  /** @nullable */
  carrierPartyName: string | null;
  /** @nullable */
  websiteUrl: string | null;
  /** @nullable */
  domicileState: string | null;
  /** @nullable */
  insuranceTypes: string | null;
  /** @nullable */
  licensedStates: string | null;
  /** @nullable */
  fullCompanyName: string | null;
  /** @nullable */
  realm: string | null;
  /** @nullable */
  submissionEmail: string | null;
  /** @nullable */
  notes: string | null;
  createdAt: string;
  /** @nullable */
  updatedAt: string | null;
}

export interface AdminDemoAccountUserDto {
  email?: string;
  authSubject?: string;
  userId?: string;
  role?: string;
  isPrimary?: boolean;
}

export interface AdminDemoAccountDto {
  kind?: string;
  email?: string;
  password?: string;
  authSubject?: string;
  userId?: string;
  teamId?: string;
  teamName?: string;
  agencyName?: string;
  expiresAtUtc?: string;
  createdAtUtc?: string;
  users?: AdminDemoAccountUserDto[];
}

export interface AdminDemoAccountListItemDto {
  email?: string;
  authSubject?: string;
  userId?: string;
  teamId?: string;
  teamName?: string;
  agencyName?: string;
  kind?: string;
  canManage?: boolean;
  /** @nullable */
  expiresAtUtc?: string | null;
  createdAtUtc?: string;
  isExpired?: boolean;
  users?: AdminDemoAccountUserDto[];
}

export interface AdminFormFileAttachmentDto {
  uploadId?: string;
  formVersionId?: string;
  /** @nullable */
  container?: string | null;
  /** @nullable */
  blobPath?: string | null;
  /** @nullable */
  fileName?: string | null;
  /** @nullable */
  contentType?: string | null;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  bytes?: number;
  /** @nullable */
  sha256?: string | null;
}

export interface AdminFormFileListItemDto {
  /** @nullable */
  uploadId?: string | null;
  formVersionId?: string;
  teamId?: string;
  /** @nullable */
  container?: string | null;
  /** @nullable */
  blobPath?: string | null;
  /** @nullable */
  fileName?: string | null;
  /** @nullable */
  contentType?: string | null;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  bytes?: number;
  /** @nullable */
  sha256?: string | null;
  /** @nullable */
  uploadedAt?: string | null;
}

export interface AdminSubmissionPackagePacketReadinessPayload {
  formSubmissionId?: string;
  teamFormVersionId?: string;
  teamFormId?: string;
  teamId?: string;
  packetRole?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  formNumber?: number;
  formName?: string;
  renderStatus?: string;
  renderMessage?: string;
  /** @nullable */
  staleReason?: string | null;
  /** @nullable */
  workerId?: string | null;
  /** @nullable */
  workerStatus?: string | null;
  needsRender?: boolean;
  isRendering?: boolean;
  blocksBuild?: boolean;
  nextAction?: string;
}

export interface AdminSubmissionPackageReadinessBlockerPayload {
  code?: string;
  message?: string;
  /** @nullable */
  formSubmissionId?: string | null;
  /** @nullable */
  workerId?: string | null;
}

export interface AdminSubmissionPackageReadinessPayload {
  crmSubmissionId?: string;
  /** @nullable */
  teamId?: string | null;
  status?: string;
  message?: string;
  canBuildPackage?: boolean;
  canQueuePacketRenders?: boolean;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  packetCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  activeRenderCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  needsRenderCount?: number;
  blockers?: AdminSubmissionPackageReadinessBlockerPayload[];
  packets?: AdminSubmissionPackagePacketReadinessPayload[];
}

export interface AdminSubmissionPacketRenderPayload {
  formSubmissionId?: string;
  /** @nullable */
  workerId?: string | null;
  /** @nullable */
  status?: string | null;
  reusedExisting?: boolean;
  /** @nullable */
  message?: string | null;
}

export interface AdminSubmissionPackageRenderQueuePayload {
  crmSubmissionId?: string;
  /** @nullable */
  teamId?: string | null;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  queuedCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  skippedCount?: number;
  message?: string;
  queued?: AdminSubmissionPacketRenderPayload[];
  skipped?: AdminSubmissionPackagePacketReadinessPayload[];
}

export interface AgentEpisodeResponse {
  episodeId?: string;
  runId?: string;
  executionId?: string;
  toolName?: string;
  summary?: string;
  executedAt?: string;
  derivedAt?: string;
  suppressed?: boolean;
  /** @nullable */
  suppressedByUserId?: string | null;
  /** @nullable */
  suppressedAt?: string | null;
}

export interface AgentEpisodeDerivationResponse {
  episodes?: AgentEpisodeResponse[];
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  newlyDerivedCount?: number;
}

export interface AgentEpisodeListResponse {
  episodes?: AgentEpisodeResponse[];
}

export interface AgentEpisodeSuppressionResponse {
  episode?: AgentEpisodeResponse;
  wasAlreadySuppressed?: boolean;
}

export interface AgentMemoryEntryResponse {
  memoryId?: string;
  kind?: string;
  key?: string;
  value?: string;
  provenance?: string;
  status?: string;
  /** @nullable */
  sourceRunId?: string | null;
  source?: string;
  evidence?: string;
  /** @nullable */
  supersededByMemoryId?: string | null;
  /** @nullable */
  deletedByUserId?: string | null;
  /** @nullable */
  deletedAt?: string | null;
  createdAt?: string;
  lastConfirmedAt?: string;
}

export interface AgentMemoryDeleteResponse {
  tombstone?: AgentMemoryEntryResponse;
  wasAlreadyDeleted?: boolean;
}

export interface AgentMemoryListResponse {
  entries?: AgentMemoryEntryResponse[];
}

export interface AgentProcedureVersionResponse {
  versionId?: string;
  procedureId?: string;
  name?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  versionNumber?: number;
  content?: string;
  contentSha256?: string;
  createdByUserId?: string;
  createdAt?: string;
}

export interface AgentProcedureActivationResponse {
  version?: AgentProcedureVersionResponse;
  wasAlreadyActive?: boolean;
}

export interface AgentProcedureDetailResponse {
  versions?: AgentProcedureVersionResponse[];
  activeVersion?: null | AgentProcedureVersionResponse;
}

export interface AgentProcedureSummaryResponse {
  procedureId?: string;
  name?: string;
  /** @nullable */
  activeVersionId?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  activeVersionNumber?: number | null;
  createdAt?: string;
  updatedAt?: string;
}

export interface AgentProcedureListResponse {
  procedures?: AgentProcedureSummaryResponse[];
}

export interface AgentThreadResponse {
  threadId?: string;
  title?: string;
  createdByActorId?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface AgentThreadRunResponse {
  runId?: string;
  agentName?: string;
  agentVersion?: string;
  status?: string;
  startedAt?: string;
  /** @nullable */
  completedAt?: string | null;
  /** @nullable */
  outputSummary?: string | null;
}

export interface AgentThreadDetailResponse {
  thread?: AgentThreadResponse;
  runs?: AgentThreadRunResponse[];
}

export interface AgentThreadListResponse {
  threads?: AgentThreadResponse[];
}

export interface DraftSlotGeometryDto {
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  page?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
     */
  x?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
     */
  y?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
     */
  w?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
     */
  h?: number | null;
}

export interface DraftSlotDto {
  /** @nullable */
  clientId?: string | null;
  /** @nullable */
  id?: string | null;
  /** @nullable */
  label?: string | null;
  /** @nullable */
  type?: string | null;
  /** @nullable */
  required?: boolean | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  uiOrder?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  page?: number | null;
  geometry?: null | DraftSlotGeometryDto;
}

export interface DraftSectionDto {
  /** @nullable */
  clientId?: string | null;
  /** @nullable */
  id?: string | null;
  /** @nullable */
  label?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  sequence?: number | null;
  slots?: DraftSlotDto[];
}

export interface AppFormDraftDto {
  sections?: DraftSectionDto[];
}

export interface ApplyInboundEmailActionRequest {
  action?: string;
  /** @nullable */
  note?: string | null;
  /** @nullable */
  declineReason?: string | null;
}

export interface AppRoleAssignment {
  appId: string;
  roleIds: string[];
}

export interface CrmPolicyDocumentImportDraftPayload {
  /** @nullable */
  carrierPartyId?: string | null;
  /** @nullable */
  carrierName?: string | null;
  /** @nullable */
  lobCode?: string | null;
  /** @nullable */
  insuranceTypeCode?: string | null;
  /** @nullable */
  policyNumber?: string | null;
  /** @nullable */
  effectiveFrom?: string | null;
  /** @nullable */
  effectiveTo?: string | null;
  /** @nullable */
  policyStatusCode?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
     */
  annualPremium?: number | null;
}

export interface ApprovePolicyDocumentImportRequest {
  confirmDuplicate?: boolean;
  draft?: CrmPolicyDocumentImportDraftPayload;
}

export interface AppSlotGeometryUpdate {
  /** @nullable */
  slotId?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  page?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
     */
  x?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
     */
  y?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
     */
  w?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
     */
  h?: number | null;
}

export interface AppUpdateGeometryRequest {
  slots?: AppSlotGeometryUpdate[];
}

export interface AttachCrmDocumentRequest {
  documentId: string;
  /** @nullable */
  linkType?: string | null;
  /** @nullable */
  notes?: string | null;
}

export interface AttachFromUploadRequest {
  uploadId?: string;
}

export interface Auth0ConnectionDto {
  id?: string;
  name?: string;
  strategy?: string;
}

/**
 * @nullable
 */
export type Auth0CreateUserRequestUserMetadata = null | { [key: string]: unknown };

/**
 * @nullable
 */
export type Auth0CreateUserRequestAppMetadata = null | { [key: string]: unknown };

export interface Auth0CreateUserRequest {
  connection?: string;
  email?: string;
  /** @nullable */
  password?: string | null;
  /** @nullable */
  given_name?: string | null;
  /** @nullable */
  family_name?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  phone_number?: string | null;
  /** @nullable */
  user_metadata?: Auth0CreateUserRequestUserMetadata;
  /** @nullable */
  app_metadata?: Auth0CreateUserRequestAppMetadata;
  /** @nullable */
  email_verified?: boolean | null;
  /** @nullable */
  verify_email?: boolean | null;
}

/**
 * @nullable
 */
export type Auth0UserDtoAppMetadata = null | { [key: string]: unknown };

/**
 * @nullable
 */
export type Auth0UserDtoUserMetadata = null | { [key: string]: unknown };

export interface Auth0UserIdentityDto {
  /** @nullable */
  connection?: string | null;
  /** @nullable */
  provider?: string | null;
  /** @nullable */
  user_id?: string | null;
  /** @nullable */
  isSocial?: boolean | null;
}

export interface Auth0UserDto {
  user_id?: string;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  nickname?: string | null;
  /** @nullable */
  picture?: string | null;
  /** @nullable */
  created_at?: string | null;
  /** @nullable */
  updated_at?: string | null;
  /** @nullable */
  last_login?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  logins_count?: number | null;
  /** @nullable */
  blocked?: boolean | null;
  /** @nullable */
  email_verified?: boolean | null;
  /** @nullable */
  identities?: Auth0UserIdentityDto[] | null;
  /** @nullable */
  app_metadata?: Auth0UserDtoAppMetadata;
  /** @nullable */
  user_metadata?: Auth0UserDtoUserMetadata;
}

/**
 * @nullable
 */
export type Auth0UserWithPresenceDtoAppMetadata = null | { [key: string]: unknown };

/**
 * @nullable
 */
export type Auth0UserWithPresenceDtoUserMetadata = null | { [key: string]: unknown };

export interface Auth0UserWithPresenceDto {
  inApp?: boolean;
  user_id?: string;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  nickname?: string | null;
  /** @nullable */
  picture?: string | null;
  /** @nullable */
  created_at?: string | null;
  /** @nullable */
  updated_at?: string | null;
  /** @nullable */
  last_login?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  logins_count?: number | null;
  /** @nullable */
  blocked?: boolean | null;
  /** @nullable */
  email_verified?: boolean | null;
  /** @nullable */
  identities?: Auth0UserIdentityDto[] | null;
  /** @nullable */
  app_metadata?: Auth0UserWithPresenceDtoAppMetadata;
  /** @nullable */
  user_metadata?: Auth0UserWithPresenceDtoUserMetadata;
}

export interface AutocompletePrediction {
  placeId?: string;
  description?: string;
  /** @nullable */
  mainText?: string | null;
  /** @nullable */
  secondaryText?: string | null;
}

export interface AutocompleteResponse {
  status?: string;
  /** @nullable */
  error?: string | null;
  predictions?: AutocompletePrediction[];
}

export interface B2BInvitationResult {
  success?: boolean;
  /** @nullable */
  userId?: string | null;
  /** @nullable */
  userPrincipalName?: string | null;
  /** @nullable */
  inviteRedeemUrl?: string | null;
  /** @nullable */
  message?: string | null;
  errors?: string[];
  groupsAdded?: string[];
  rolesAssigned?: string[];
}

export interface BindQuoteRequest {
  /** @nullable */
  transactionTypeCode?: string | null;
}

export interface BookOfBusinessRow {
  clientName?: string;
  policyNumber?: string;
  lobCode?: string;
  carrier?: string;
  effectiveDate?: string;
  expirationDate?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  premiumWritten?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  expectedCommission?: number;
  commissionStatus?: string;
  producer?: string;
}

export interface BookOfBusinessSummary {
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  totalPremium?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  totalExpectedCommission?: number;
}

export interface BookReviewAgentRunResponse {
  runId?: string;
  agentName?: string;
  agentVersion?: string;
  status?: string;
  teamId?: string;
  actorId?: string;
  asOfDate?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  inForcePolicyCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  totalInForceWrittenPremium?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  renewalNext12MonthsPolicyCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  renewalNext12MonthsWrittenPremium?: number;
  facts?: string[];
  factsUsed?: string[];
  observation?: string;
  reviewQuestion?: string;
  evidenceSource?: string;
  modelProvider?: string;
  model?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  recordedEventCount?: number;
}

export interface TeamAgentActionPreviewFieldResponse {
  label?: string;
  value?: string;
}

export interface TeamAgentActionPreviewResponse {
  action?: string;
  fields?: TeamAgentActionPreviewFieldResponse[];
}

export interface BrowserReadCheckpointResponse {
  name?: string;
  proposalId?: string;
  status?: string;
  toolName?: string;
  toolVersion?: string;
  actionSummary?: string;
  workerId?: string;
  task?: string;
  preview?: TeamAgentActionPreviewResponse;
  source?: string;
  evidence?: string;
  proposedAt?: string;
  /** @nullable */
  resolvedByActorId?: string | null;
  /** @nullable */
  resolvedAt?: string | null;
  /** @nullable */
  executionId?: string | null;
  /** @nullable */
  executedAt?: string | null;
  /** @nullable */
  executionSummary?: string | null;
  /** @nullable */
  recordedResultJson?: string | null;
}

export interface BrowserReadRunResponse {
  runId?: string;
  agentName?: string;
  agentVersion?: string;
  status?: string;
  teamId?: string;
  actorId?: string;
  workerId?: string;
  workerType?: string;
  task?: string;
  evidenceSource?: string;
  resultCheckpoint?: BrowserReadCheckpointResponse;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  recordedEventCount?: number;
}

export interface BrowserReadWorkItemStateResponse {
  workerId?: string;
  workerType?: string;
  status?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  attempts?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  maxAttempts?: number;
  /** @nullable */
  completedAtUtc?: string | null;
  /** @nullable */
  openInterventionReason?: string | null;
  /** @nullable */
  openInterventionRequestedAtUtc?: string | null;
}

export interface TeamAgentRunEventResponse {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  sequence?: number;
  eventType?: string;
  message?: string;
  createdAt?: string;
}

export interface BrowserReadRunStateResponse {
  runId?: string;
  agentName?: string;
  agentVersion?: string;
  status?: string;
  teamId?: string;
  actorId?: string;
  startedAt?: string;
  /** @nullable */
  completedAt?: string | null;
  /** @nullable */
  outputSummary?: string | null;
  resultCheckpoint?: BrowserReadCheckpointResponse;
  edgeWork?: null | BrowserReadWorkItemStateResponse;
  events?: TeamAgentRunEventResponse[];
  /** @nullable */
  resolutionKind?: string | null;
  /** @nullable */
  resumeOutcome?: string | null;
}

export interface CheckLeadMatchRequest {
  /** @nullable */
  proposedPartyTypeCode?: string | null;
  /** @nullable */
  proposedName?: string | null;
  /** @nullable */
  proposedCompanyName?: string | null;
  /** @nullable */
  proposedPhone?: string | null;
  /** @nullable */
  proposedEmail?: string | null;
}

export interface CheckoutRequest {
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  priceId?: string | null;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  quantity?: number;
  /** @nullable */
  customerEmail?: string | null;
  /** @nullable */
  successUrl?: string | null;
  /** @nullable */
  cancelUrl?: string | null;
  /** @nullable */
  checkoutType?: string | null;
  /** @nullable */
  planKey?: string | null;
}

export interface CityStateLookupResponse {
  isValid?: boolean;
  /** @nullable */
  city?: string | null;
  /** @nullable */
  state?: string | null;
  /** @nullable */
  zipCode?: string | null;
  /** @nullable */
  error?: string | null;
}

export interface ClaimedEdgeWorkItemResponse {
  workerId?: string;
  workerType?: string;
  teamId?: string;
  status?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  attempts?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  maxAttempts?: number;
  /** @nullable */
  inputJson?: string | null;
  claimToken?: string;
  claimedAtUtc?: string;
}

export interface ClaimEdgeWorkRequest {
  /** @nullable */
  capabilities?: string[] | null;
  /** @nullable */
  workerId?: string | null;
}

export interface ClaimEdgeWorkResponse {
  claimed?: boolean;
  workItem?: null | ClaimedEdgeWorkItemResponse;
}

export interface CloseSubmissionRequest {
  closeReasonCode?: string;
}

export interface CompileAppFormRequest {
  /** @nullable */
  reason?: string | null;
}

export interface CompleteDemoDto {
  outcome?: string;
  created?: boolean;
  userId?: string;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  teamName?: string | null;
  /** @nullable */
  teamRole?: string | null;
  isTeamAdmin?: boolean;
  /** @nullable */
  expiresAtUtc?: string | null;
  /** @nullable */
  sourceTeamId?: string | null;
  /** @nullable */
  sourceTeamName?: string | null;
}

export interface CompleteEdgeWorkRequest {
  /** @nullable */
  claimToken?: string | null;
  succeeded?: boolean;
  retryable?: boolean;
  canceled?: boolean;
  /** @nullable */
  statusMessage?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  outputJson?: string | null;
  /** @nullable */
  errorJson?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  observedDurationMs?: number | null;
}

export interface CompleteEdgeWorkResponse {
  workerId?: string;
  status?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  attempts?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  maxAttempts?: number;
  willRetry?: boolean;
  /** @nullable */
  completedAtUtc?: string | null;
}

export interface ConvertLeadRequest {
  /** @nullable */
  matchedPartyId?: string | null;
  /** @nullable */
  matchedClientAccountId?: string | null;
  createNewClientAccount?: boolean;
}

export interface CreateAdditionalInterestRequest {
  /** @nullable */
  partyId?: string | null;
  interestType?: string;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  addressId?: string | null;
  /** @nullable */
  referenceNumber?: string | null;
  /** @nullable */
  loanNumber?: string | null;
}

export interface CreateAdminDemoAccountRequestDto {
  workspaceName?: string;
  /** @nullable */
  loginSlug?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  expiresInDays?: number | null;
}

export interface CreateAgencyLicenseRequest {
  /** @maxLength 2 */
  stateCode: string;
  /**
     * @maxLength 50
     * @nullable
     */
  licenseNumber?: string | null;
  /**
     * @maxLength 20
     * @nullable
     */
  npn?: string | null;
  /**
     * @maxLength 200
     * @nullable
     */
  linesAuthorized?: string | null;
  effectiveFrom: string;
  /** @nullable */
  effectiveTo?: string | null;
}

export interface CreateAgencyRequest {
  name?: string;
  /** @nullable */
  doingBusinessAs?: string | null;
  /** @nullable */
  website?: string | null;
}

export interface CreateAgentProcedureVersionRequest {
  content?: string;
}

export interface CreateAgentThreadRequest {
  title?: string;
}

export interface CreateAppFormRequest {
  title?: string;
  /** @nullable */
  type?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  formNumber?: number | null;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  yaml?: string | null;
  isSystem?: boolean;
}

export interface CreateAppFormVersionRequest {
  yaml?: string;
  /** @nullable */
  changeNotes?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  version?: number | null;
}

export interface CreateBuildingRequest {
  locationId?: string;
  /** @nullable */
  buildingNumber?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  occupancy?: string | null;
  /** @nullable */
  constructionType?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  yearBuilt?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
     */
  stories?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  squareFeet?: number | null;
  /** @nullable */
  roofType?: string | null;
  /** @nullable */
  sprinklered?: boolean | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
     */
  tiv?: number | null;
}

export interface CreateCarrierAppointmentRequest {
  producerPartyId: string;
  /** @nullable */
  carrierPartyId?: string | null;
  /** @nullable */
  carrierCatalogId?: string | null;
  /** @maxLength 2 */
  stateCode: string;
  effectiveFrom: string;
  /** @nullable */
  effectiveTo?: string | null;
  /**
     * @maxLength 50
     * @nullable
     */
  appointmentNumber?: string | null;
}

export interface CreateDataKeyRequest {
  dataKey?: string;
  valueType?: string;
  displayName?: string;
  /** @nullable */
  schemaJson?: string | null;
  /** @nullable */
  dataKeyRole?: string | null;
  /** @nullable */
  askInsured?: boolean | null;
  /** @nullable */
  isActive?: boolean | null;
}

export interface CreateDriverRequest {
  clientAccountId?: string;
  /** @nullable */
  partyId?: string | null;
  firstName?: string;
  lastName?: string;
  /** @nullable */
  licenseNumber?: string | null;
  /** @nullable */
  licenseState?: string | null;
  /** @nullable */
  dateOfBirth?: string | null;
  /** @nullable */
  hireDate?: string | null;
  /** @nullable */
  terminationDate?: string | null;
}

export interface CreateEdgeClientEnrollmentRequest {
  /** @nullable */
  displayName?: string | null;
  /** @nullable */
  capabilities?: string[] | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  expiresInMinutes?: number | null;
}

export interface CreateEdgeClientEnrollmentResponse {
  enrollmentId?: string;
  teamId?: string;
  enrollmentToken?: string;
  /** @nullable */
  displayName?: string | null;
  capabilities?: string[];
  expiresAtUtc?: string;
  createdAtUtc?: string;
}

export interface CreateEdgeWorkItemRequest {
  /** @nullable */
  workerType?: string | null;
  /** @nullable */
  inputJson?: string | null;
}

export interface CreateEntraUserRequest {
  displayName: string;
  userPrincipalName: string;
  givenName: string;
  surname: string;
  /** @nullable */
  mail?: string | null;
  /** @nullable */
  jobTitle?: string | null;
  /** @nullable */
  department?: string | null;
  /** @nullable */
  officeLocation?: string | null;
  /** @nullable */
  mobilePhone?: string | null;
  /** @nullable */
  businessPhone?: string | null;
  forceChangePasswordNextSignIn?: boolean;
  accountEnabled?: boolean;
  /** @nullable */
  usageLocation?: string | null;
}

export interface CreateFromBlobRequest {
  /** @nullable */
  container?: string | null;
  blobPath?: string;
  /** @nullable */
  displayName?: string | null;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  contentType?: string | null;
}

export interface CreateLeadRequest {
  /** @nullable */
  sourceTypeCode?: string | null;
  /** @nullable */
  sourceOccurredAt?: string | null;
  /** @nullable */
  proposedPartyTypeCode?: string | null;
  /** @nullable */
  proposedName?: string | null;
  /** @nullable */
  proposedCompanyName?: string | null;
  /** @nullable */
  proposedPhone?: string | null;
  /** @nullable */
  proposedEmail?: string | null;
  /** @nullable */
  proposedAddressLine1?: string | null;
  /** @nullable */
  proposedAddressLine2?: string | null;
  /** @nullable */
  proposedCity?: string | null;
  /** @nullable */
  proposedStateCode?: string | null;
  /** @nullable */
  proposedPostalCode?: string | null;
  /** @nullable */
  proposedWebsiteUrl?: string | null;
  /** @nullable */
  rawNotes?: string | null;
  /** @nullable */
  summary?: string | null;
  /** @nullable */
  assignedToUserId?: string | null;
  /** @nullable */
  qualificationNotes?: string | null;
  /** @nullable */
  sourceMetadataJson?: string | null;
  /** @nullable */
  matchedPartyId?: string | null;
  /** @nullable */
  matchedClientAccountId?: string | null;
  confirmNoCrmMatch?: boolean;
}

export interface CreateLocationRequest {
  clientAccountId?: string;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  code?: string | null;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  addressLine1?: string | null;
  /** @nullable */
  addressLine2?: string | null;
  /** @nullable */
  city?: string | null;
  /** @nullable */
  stateProv?: string | null;
  /** @nullable */
  postalCode?: string | null;
  /** @nullable */
  country?: string | null;
  /** @nullable */
  constructionType?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  yearBuilt?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
     */
  stories?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  squareFeet?: number | null;
  /** @nullable */
  sprinklered?: boolean | null;
  /** @nullable */
  alarmFire?: boolean | null;
  /** @nullable */
  alarmBurglary?: boolean | null;
  /** @nullable */
  protectionClass?: string | null;
  /** @nullable */
  territoryCode?: string | null;
  /** @nullable */
  floodZone?: string | null;
}

export interface CreateLossRequest {
  clientAccountId?: string;
  /** @nullable */
  lobCode?: string | null;
  occurrenceDate?: string;
  /** @nullable */
  description?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
     */
  paid?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
     */
  reserved?: number | null;
  /** @nullable */
  status?: string | null;
  /** @nullable */
  claimNumber?: string | null;
  /** @nullable */
  carrierPartyId?: string | null;
  /** @nullable */
  locationId?: string | null;
  /** @nullable */
  buildingId?: string | null;
}

export interface CreatePartyRequest {
  type?: string;
  /** @nullable */
  displayName?: string | null;
  /** @nullable */
  firstName?: string | null;
  /** @nullable */
  lastName?: string | null;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  legalName?: string | null;
  /** @nullable */
  doingBusinessAs?: string | null;
  /** @nullable */
  website?: string | null;
  /** @nullable */
  naics?: string | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  roles?: string[] | null;
}

export interface CreatePaymentLinkCheckoutSessionRequest {
  /** @nullable */
  successUrl?: string | null;
  /** @nullable */
  cancelUrl?: string | null;
  /** @nullable */
  customerEmail?: string | null;
}

export interface CreatePaymentLinkRequest {
  teamId?: string;
  /** @nullable */
  clientAccountId?: string | null;
  /** @nullable */
  policyId?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  amountCents?: number | null;
  /** @nullable */
  currencyCode?: string | null;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  clientContext?: string | null;
  /** @nullable */
  customerEmail?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  maxUses?: number | null;
  /** @nullable */
  expiresAt?: string | null;
}

/**
 * @nullable
 */
export type CreatePdfWorkerRequestInputs = null | { [key: string]: unknown };

export interface CreatePdfWorkerRequest {
  teamId?: string;
  /** @nullable */
  formId?: string | null;
  /** @nullable */
  teamFormVersionId?: string | null;
  /** @nullable */
  submissionId?: string | null;
  /** @nullable */
  pdfType?: string | null;
  /** @nullable */
  flatten?: boolean | null;
  persist?: boolean;
  /** @nullable */
  inputs?: CreatePdfWorkerRequestInputs;
}

export interface CreateProducerLicenseRequest {
  producerPartyId: string;
  /** @maxLength 2 */
  stateCode: string;
  /**
     * @maxLength 50
     * @nullable
     */
  licenseNumber?: string | null;
  /**
     * @maxLength 20
     * @nullable
     */
  npn?: string | null;
  /**
     * @maxLength 200
     * @nullable
     */
  linesAuthorized?: string | null;
  effectiveFrom: string;
  /** @nullable */
  effectiveTo?: string | null;
}

export interface CreateServicingCertificateDraftRequest {
  /** @nullable */
  holderPartyId?: string | null;
  /** @nullable */
  holderName?: string | null;
  /** @nullable */
  deliveryEmail?: string | null;
  /** @nullable */
  certificateTypeCode?: string | null;
  /** @nullable */
  note?: string | null;
}

export interface CreateServicingServiceRequestRequest {
  /** @nullable */
  assignedToUserId?: string | null;
  /** @nullable */
  note?: string | null;
}

export interface ServicingServiceRequestFactPayload {
  /** @nullable */
  factType?: string | null;
  /** @nullable */
  factValue?: string | null;
  /** @nullable */
  ruleId?: string | null;
  /** @nullable */
  evidence?: string | null;
}

export interface ServicingServiceRequestEventPayload {
  serviceRequestEventId?: string;
  serviceRequestId?: string;
  teamId?: string;
  eventType?: string;
  /** @nullable */
  previousStatus?: string | null;
  /** @nullable */
  status?: string | null;
  /** @nullable */
  previousAssignedToUserId?: string | null;
  /** @nullable */
  assignedToUserId?: string | null;
  /** @nullable */
  previousDueAt?: string | null;
  /** @nullable */
  dueAt?: string | null;
  /** @nullable */
  note?: string | null;
  /** @nullable */
  createdByUserId?: string | null;
  createdAt?: string;
}

export interface ServicingServiceRequestPayload {
  serviceRequestId?: string;
  teamId?: string;
  /** @nullable */
  clientAccountId?: string | null;
  /** @nullable */
  clientName?: string | null;
  /** @nullable */
  policyId?: string | null;
  /** @nullable */
  policyNumber?: string | null;
  /** @nullable */
  certificateId?: string | null;
  /** @nullable */
  certificateHolderName?: string | null;
  /** @nullable */
  sourceInboundEmailId?: string | null;
  requestType?: string;
  status?: string;
  urgencyLevel?: string;
  /** @nullable */
  assignedToUserId?: string | null;
  subject?: string;
  /** @nullable */
  summary?: string | null;
  /** @nullable */
  suggestedAction?: string | null;
  missingFields?: string[];
  extractedFacts?: ServicingServiceRequestFactPayload[];
  /** @nullable */
  dueAt?: string | null;
  createdAt?: string;
  updatedAt?: string;
  /** @nullable */
  completedAt?: string | null;
  /** @nullable */
  escalatedAt?: string | null;
  events?: ServicingServiceRequestEventPayload[];
}

export interface CreateServicingServiceRequestResponse {
  created?: boolean;
  serviceRequest?: null | ServicingServiceRequestPayload;
}

export interface CreateSubmissionRequest {
  clientAccountId?: string;
  /** @nullable */
  opportunityId?: string | null;
  /** @nullable */
  sourcePolicyId?: string | null;
  submissionPurposeCode?: string;
  /** @nullable */
  submissionNumber?: string | null;
  /** @nullable */
  stage?: string | null;
  /** @nullable */
  transactionTypeCode?: string | null;
  /** @nullable */
  notes?: string | null;
}

export interface CreateSupportRequestResponse {
  referenceId?: string;
  message?: string;
}

export interface CreateTeamEntitlementAdjustmentRequest {
  /**
     * @maxLength 40
     * @nullable
     */
  adjustmentKind?: string | null;
  /** @nullable */
  effectiveUntilUtc?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatQuantityOverride?: number | null;
  /**
     * @maxLength 1000
     * @nullable
     */
  reason?: string | null;
}

export interface CreateTeamRequest {
  /** @maxLength 200 */
  name: string;
}

export interface CreateTeamStaffRequest {
  /** @maxLength 200 */
  displayName: string;
  /**
     * @maxLength 100
     * @nullable
     */
  firstName?: string | null;
  /**
     * @maxLength 100
     * @nullable
     */
  lastName?: string | null;
  /** @maxLength 50 */
  staffRoleCode: string;
  /**
     * @maxLength 200
     * @nullable
     */
  email?: string | null;
  /**
     * @maxLength 50
     * @nullable
     */
  phone?: string | null;
  /** @nullable */
  isActive?: boolean | null;
  /** @nullable */
  startedOn?: string | null;
}

export interface CreateUserRequest {
  email: string;
  /** @nullable */
  authSubject?: string | null;
  /** @nullable */
  firstName?: string | null;
  /** @nullable */
  lastName?: string | null;
  /** @nullable */
  phone?: string | null;
  isActive?: boolean;
}

export interface CreateVehicleRequest {
  clientAccountId?: string;
  /** @nullable */
  vin?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  year?: number | null;
  /** @nullable */
  make?: string | null;
  /** @nullable */
  model?: string | null;
  /** @nullable */
  useType?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  gvwr?: number | null;
  /** @nullable */
  garagingLocationId?: string | null;
}

export interface CrmCertificateOutputFormPayload {
  /** @nullable */
  acordFormId?: string | null;
  /** @nullable */
  acordFormEditionId?: string | null;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  formNumber?: number;
  /** @nullable */
  title?: string | null;
  usageContextCode?: string;
  /** @nullable */
  baseJurisdictionCode?: string | null;
  /** @nullable */
  editionCode?: string | null;
  /** @nullable */
  editionStatus?: string | null;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  sortOrder?: number;
  isRecommended?: boolean;
}

export interface CrmCertificateOutputRenderPayload {
  certificateId?: string;
  formSubmissionId?: string;
  /** @nullable */
  workerId?: string | null;
  /** @nullable */
  status?: string | null;
  /** @nullable */
  statusMessage?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  progressPercent?: number | null;
  reusedExistingWorker?: boolean;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  formNumber?: number;
  /** @nullable */
  title?: string | null;
  usageContextCode?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  slotsUpserted?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  slotsSkippedExisting?: number;
  outputAvailable?: boolean;
}

export interface CrmCertificateReadinessIssuePayload {
  code?: string;
  message?: string;
}

export interface CrmCertificateReadinessPayload {
  policyId?: string;
  /** @nullable */
  holderPartyId?: string | null;
  certificateTypeCode?: string;
  outputUsageContextCode?: string;
  policyExists?: boolean;
  holderExists?: boolean;
  teamResolved?: boolean;
  hasPolicyTerm?: boolean;
  hasIncludedCoverage?: boolean;
  hasCertificateFormMapping?: boolean;
  hasOutputFormMapping?: boolean;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  teamName?: string | null;
  /** @nullable */
  insuranceTypeCode?: string | null;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  includedCoverageCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  certificateFormCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  outputFormCount?: number;
  outputForms?: CrmCertificateOutputFormPayload[];
  missing?: CrmCertificateReadinessIssuePayload[];
  isReady?: boolean;
}

export interface CrmOpportunityQuoteComparisonLimitPayload {
  limitType?: string;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
     */
  limitAmount?: number | null;
  /** @nullable */
  currencyCode?: string | null;
}

export interface CrmOpportunityQuoteComparisonDeductiblePayload {
  deductibleType?: string;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
     */
  deductibleAmount?: number | null;
  /** @nullable */
  currencyCode?: string | null;
}

export interface CrmOpportunityQuoteComparisonOptionCellPayload {
  quoteOptionId?: string;
  quoteIds?: string[];
  expected?: boolean;
  required?: boolean;
  hasCoverage?: boolean;
  /** @nullable */
  isIncluded?: boolean | null;
  appliesToScopes?: string[];
  /** @nullable */
  notes?: string | null;
  limits?: CrmOpportunityQuoteComparisonLimitPayload[];
  deductibles?: CrmOpportunityQuoteComparisonDeductiblePayload[];
}

export interface CrmOpportunityQuoteComparisonQuoteCellPayload {
  quoteId?: string;
  expected?: boolean;
  required?: boolean;
  hasCoverage?: boolean;
  /** @nullable */
  isIncluded?: boolean | null;
  appliesToScopes?: string[];
  /** @nullable */
  notes?: string | null;
  limits?: CrmOpportunityQuoteComparisonLimitPayload[];
  deductibles?: CrmOpportunityQuoteComparisonDeductiblePayload[];
}

export interface CrmOpportunityQuoteComparisonCoveragePayload {
  coverageTypeCode?: string;
  description?: string;
  /** @nullable */
  lobCode?: string | null;
  options?: CrmOpportunityQuoteComparisonOptionCellPayload[];
  quotes?: CrmOpportunityQuoteComparisonQuoteCellPayload[];
}

export interface CrmOpportunityQuoteComparisonOptionItemPayload {
  quoteOptionItemId?: string;
  quoteId?: string;
  submissionId?: string;
  /** @nullable */
  submissionNumber?: string | null;
  lobCode?: string;
  /** @nullable */
  insuranceTypeCode?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
     */
  quoteAnnualPremium?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
     */
  allocatedAnnualPremium?: number | null;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  sortOrder?: number;
  /** @nullable */
  notes?: string | null;
  isGenerated?: boolean;
}

export interface CrmOpportunityQuoteComparisonOptionPayload {
  quoteOptionId?: string;
  opportunityId?: string;
  carrierPartyId?: string;
  /** @nullable */
  carrierName?: string | null;
  /** @nullable */
  optionName?: string | null;
  statusCode?: string;
  pricingBasis?: string;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
     */
  totalAnnualPremium?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
     */
  packageCreditAmount?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
     */
  packageCreditPercent?: number | null;
  /** @nullable */
  notes?: string | null;
  /** @nullable */
  subjectivitiesJson?: string | null;
  isGenerated?: boolean;
  createdAt?: string;
  /** @nullable */
  updatedAt?: string | null;
  items?: CrmOpportunityQuoteComparisonOptionItemPayload[];
}

export interface CrmOpportunityQuoteComparisonSubmissionPayload {
  submissionId?: string;
  /** @nullable */
  submissionNumber?: string | null;
  createdAt?: string;
  /** @nullable */
  updatedAt?: string | null;
}

export interface CrmOpportunityQuoteComparisonQuotePayload {
  quoteId?: string;
  submissionId?: string;
  /** @nullable */
  submissionNumber?: string | null;
  carrierPartyId?: string;
  /** @nullable */
  carrierName?: string | null;
  lobCode?: string;
  /** @nullable */
  insuranceTypeCode?: string | null;
  /** @nullable */
  quoteNumber?: string | null;
  effectiveFrom?: string;
  effectiveTo?: string;
  statusCode?: string;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
     */
  annualPremium?: number | null;
  createdAt?: string;
  /** @nullable */
  updatedAt?: string | null;
}

export interface CrmOpportunityQuoteComparisonSummaryPayload {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  submissionCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  optionCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  quoteCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  coverageCount?: number;
}

export interface CrmOpportunityQuoteComparisonPayload {
  opportunityId?: string;
  submissions?: CrmOpportunityQuoteComparisonSubmissionPayload[];
  options?: CrmOpportunityQuoteComparisonOptionPayload[];
  quotes?: CrmOpportunityQuoteComparisonQuotePayload[];
  coverages?: CrmOpportunityQuoteComparisonCoveragePayload[];
  summary?: CrmOpportunityQuoteComparisonSummaryPayload;
}

export interface CrmPolicySummaryPayload {
  clientAccountId?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  count?: number;
  /** @nullable */
  nearestRenewal?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  daysToNearest?: number | null;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  premiumCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  totalPremiumAmount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  expectedCommissionAmount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  actualCommissionAmount?: number;
  /** @nullable */
  currencyCode?: string | null;
}

export interface CrmQuoteOptionBindItemPayload {
  quoteId?: string;
  submissionId?: string;
  alreadyBound?: boolean;
  /** @nullable */
  policyId?: string | null;
  /** @nullable */
  policyTermId?: string | null;
  /** @nullable */
  policyTransactionId?: string | null;
}

export interface CrmSubmissionMissingRequiredDataKeyPayload {
  dataKey?: string;
  label?: string;
  /** @nullable */
  lobCode?: string | null;
}

/**
 * @nullable
 */
export type FormSlotUxMetadataOptionLabelOverrides = null | {[key: string]: string};

export interface FormSlotUxMetadata {
  /** @nullable */
  autocomplete?: string | null;
  /** @nullable */
  displayLabel?: string | null;
  /** @nullable */
  questionLabel?: string | null;
  /** @nullable */
  helpText?: string | null;
  /** @nullable */
  validationKind?: string | null;
  /** @nullable */
  formatKind?: string | null;
  /** @nullable */
  inputMode?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  maxLength?: number | null;
  /** @nullable */
  groupKey?: string | null;
  /** @nullable */
  groupLabel?: string | null;
  /** @nullable */
  groupRole?: string | null;
  /** @nullable */
  layoutHint?: string | null;
  /** @nullable */
  parentGroupKey?: string | null;
  /** @nullable */
  parentGroupLabel?: string | null;
  /** @nullable */
  parentGroupRole?: string | null;
  /** @nullable */
  parentLayoutHint?: string | null;
  /** @nullable */
  readonlyPresentation?: string | null;
  /** @nullable */
  booleanPresentation?: string | null;
  /** @nullable */
  optionLabelOverrides?: FormSlotUxMetadataOptionLabelOverrides;
}

export interface CrmSubmissionRequiredDataFieldPayload {
  dataKey?: string;
  displayName?: string;
  label?: string;
  /** @nullable */
  helpText?: string | null;
  valueType?: string;
  /** @nullable */
  slotType?: string | null;
  ux?: null | FormSlotUxMetadata;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  sortOrder?: number;
  /** @nullable */
  functionalGroupCode?: string | null;
  /** @nullable */
  schemaJson?: string | null;
  dataKeyRole?: string;
  /** @nullable */
  scheduleType?: string | null;
  isWritable?: boolean;
  hasValue?: boolean;
  value?: unknown;
}

export interface CrmSubmissionRequiredDataScheduleRequirementPayload {
  scheduleType?: string;
  label?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  requiredFieldCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  rowCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  completeRowCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  missingRequiredFieldCount?: number;
  isComplete?: boolean;
  /** @nullable */
  routeName?: string | null;
  fields?: CrmSubmissionRequiredDataFieldPayload[];
}

export interface CrmSubmissionApplicationReadinessIssuePayload {
  code?: string;
  message?: string;
  category?: string;
}

export interface CrmSubmissionApplicationReadinessPayload {
  submissionId?: string;
  submissionExists?: boolean;
  clientAccountExists?: boolean;
  teamResolved?: boolean;
  hasEffectiveDate?: boolean;
  hasExpirationDate?: boolean;
  hasSubmissionLobs?: boolean;
  hasInsuranceTypeCode?: boolean;
  hasApplicationFormMapping?: boolean;
  requiresJurisdictionCode?: boolean;
  hasJurisdictionCode?: boolean;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  teamName?: string | null;
  /** @nullable */
  primaryLobCode?: string | null;
  /** @nullable */
  insuranceTypeCode?: string | null;
  /** @nullable */
  jurisdictionCode?: string | null;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  submissionLobCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  applicationFormCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  requiredDataKeyCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  providedRequiredDataKeyCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  missingRequiredDataKeyCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  requiredScalarDataKeyCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  providedRequiredScalarDataKeyCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  missingRequiredScalarDataKeyCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  requiredScheduleCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  providedRequiredScheduleCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  missingRequiredScheduleCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  linkedFormSubmissionCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  requiredFormSlotCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  filledRequiredFormSlotCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  missingRequiredFormSlotCount?: number;
  hasCoverageLibraryMapping?: boolean;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  coverageLibraryTotalCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  coverageLibraryApplicationCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  coverageLibraryRequiredCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  coverageLibraryRequiredApplicationCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  dataKeyScore?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  formCompletionScore?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  coverageLibraryScore?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  score?: number;
  submissionLobCodes?: string[];
  missingRequiredDataKeys?: CrmSubmissionMissingRequiredDataKeyPayload[];
  scheduleRequirements?: CrmSubmissionRequiredDataScheduleRequirementPayload[];
  userIssues?: CrmSubmissionApplicationReadinessIssuePayload[];
  systemIssues?: CrmSubmissionApplicationReadinessIssuePayload[];
  /** @nullable */
  missing?: CrmSubmissionApplicationReadinessIssuePayload[] | null;
  isUserReady?: boolean;
  isSystemReady?: boolean;
  isReady?: boolean;
  /** @nullable */
  status?: string | null;
}

export interface CrmQuoteOptionBindReadinessPayload {
  submissionId?: string;
  readiness?: CrmSubmissionApplicationReadinessPayload;
}

export interface CrmQuoteOptionBindPayload {
  ok?: boolean;
  quoteOptionId?: string;
  opportunityId?: string;
  alreadyBound?: boolean;
  items?: CrmQuoteOptionBindItemPayload[];
  readiness?: CrmQuoteOptionBindReadinessPayload[];
}

export interface CrmQuoteOptionOperationPayload {
  quoteOptionId?: string;
  deleted?: boolean;
}

export interface CrmQuoteSelectionRequestPayload {
  quoteSelectionRequestId?: string;
  teamId?: string;
  quoteId?: string;
  submissionId?: string;
  clientAccountId?: string;
  carrierPartyId?: string;
  /** @nullable */
  carrierName?: string | null;
  /** @nullable */
  accountName?: string | null;
  /** @nullable */
  quoteNumber?: string | null;
  lobCode?: string;
  /** @nullable */
  insuranceTypeCode?: string | null;
  effectiveFrom?: string;
  effectiveTo?: string;
  quoteStatusCode?: string;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
     */
  annualPremium?: number | null;
  requiresESign?: boolean;
  eSignStatus?: string;
  recipientEmail?: string;
  /** @nullable */
  recipientName?: string | null;
  /** @nullable */
  subject?: string | null;
  /** @nullable */
  messageBody?: string | null;
  status?: string;
  /** @nullable */
  decisionType?: string | null;
  /** @nullable */
  decisionNotes?: string | null;
  /** @nullable */
  signedName?: string | null;
  expiresAt?: string;
  requestedAt?: string;
  /** @nullable */
  viewedAt?: string | null;
  /** @nullable */
  respondedAt?: string | null;
  /** @nullable */
  messageSendId?: string | null;
  /** @nullable */
  messageSendStatus?: string | null;
  /** @nullable */
  createdByUserId?: string | null;
  createdAt?: string;
  /** @nullable */
  updatedAt?: string | null;
}

export interface CrmQuoteSelectionSendPayload {
  token?: string;
  url?: string;
  quoteSelectionRequestId?: string;
  teamId?: string;
  quoteId?: string;
  submissionId?: string;
  clientAccountId?: string;
  carrierPartyId?: string;
  /** @nullable */
  carrierName?: string | null;
  /** @nullable */
  accountName?: string | null;
  /** @nullable */
  quoteNumber?: string | null;
  lobCode?: string;
  /** @nullable */
  insuranceTypeCode?: string | null;
  effectiveFrom?: string;
  effectiveTo?: string;
  quoteStatusCode?: string;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
     */
  annualPremium?: number | null;
  requiresESign?: boolean;
  eSignStatus?: string;
  recipientEmail?: string;
  /** @nullable */
  recipientName?: string | null;
  /** @nullable */
  subject?: string | null;
  /** @nullable */
  messageBody?: string | null;
  status?: string;
  /** @nullable */
  decisionType?: string | null;
  /** @nullable */
  decisionNotes?: string | null;
  /** @nullable */
  signedName?: string | null;
  expiresAt?: string;
  requestedAt?: string;
  /** @nullable */
  viewedAt?: string | null;
  /** @nullable */
  respondedAt?: string | null;
  /** @nullable */
  messageSendId?: string | null;
  /** @nullable */
  messageSendStatus?: string | null;
  /** @nullable */
  createdByUserId?: string | null;
  createdAt?: string;
  /** @nullable */
  updatedAt?: string | null;
}

export interface CrmQuoteSelectionSetupPayload {
  quoteId?: string;
  submissionId?: string;
  clientAccountId?: string;
  carrierPartyId?: string;
  /** @nullable */
  carrierName?: string | null;
  /** @nullable */
  accountName?: string | null;
  /** @nullable */
  quoteNumber?: string | null;
  lobCode?: string;
  /** @nullable */
  insuranceTypeCode?: string | null;
  effectiveFrom?: string;
  effectiveTo?: string;
  statusCode?: string;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
     */
  annualPremium?: number | null;
  requiresESign?: boolean;
  eSignStatus?: string;
  /** @nullable */
  defaultRecipientEmail?: string | null;
  /** @nullable */
  defaultRecipientName?: string | null;
  defaultSubject?: string;
  defaultBodyText?: string;
  defaultExpiresAt?: string;
  canRequestSelection?: boolean;
  blockReasons?: string[];
}

export interface CrmSubmissionAggregateChecklistPayload {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  total?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  uploaded?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  missing?: number;
  source?: string;
}

export interface CrmSubmissionAggregateReadinessPayload {
  isReady?: boolean;
  status?: string;
  level?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  score?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  issueCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  missingRequiredDataKeyCount?: number;
}

export interface CrmSubmissionPipelineItemPayload {
  columnKey?: string;
  columnLabel?: string;
  submissionId?: string;
  /** @nullable */
  submissionNumber?: string | null;
  clientAccountId?: string;
  opportunityId?: string;
  /** @nullable */
  sourcePolicyId?: string | null;
  /** @nullable */
  submissionPurposeCode?: string | null;
  /** @nullable */
  transactionStatusCode?: string | null;
  /** @nullable */
  stage?: string | null;
  createdAt?: string;
  /** @nullable */
  accountName?: string | null;
  /** @nullable */
  opportunityName?: string | null;
  /** @nullable */
  opportunityStageCode?: string | null;
  /** @nullable */
  opportunityTargetEffectiveDate?: string | null;
  /** @nullable */
  primaryLobCode?: string | null;
  /** @nullable */
  primaryInsuranceTypeCode?: string | null;
  /** @nullable */
  assignedToUserId?: string | null;
  /** @nullable */
  effectiveDate?: string | null;
  /** @nullable */
  expirationDate?: string | null;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  marketAttemptCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  marketPlannedCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  marketSubmittedCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  marketDeclinedCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  marketQuotedCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  marketBoundCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  marketResponseCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  quoteCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  boundQuoteCount?: number;
  /** @nullable */
  latestQuoteNumber?: string | null;
  /** @nullable */
  latestQuoteStatus?: string | null;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  quoteSelectionRequestCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  activeQuoteSelectionRequestCount?: number;
  /** @nullable */
  latestQuoteSelectionStatus?: string | null;
  /** @nullable */
  latestQuoteSelectionDecisionType?: string | null;
  /** @nullable */
  latestQuoteSelectionMessageSendStatus?: string | null;
  /** @nullable */
  latestQuoteSelectionRequestedAt?: string | null;
  /** @nullable */
  latestQuoteSelectionViewedAt?: string | null;
  /** @nullable */
  latestQuoteSelectionRespondedAt?: string | null;
  /** @nullable */
  insuredPartyId?: string | null;
  nextStepKey?: string;
  nextStepLabel?: string;
  nextStepDetail?: string;
  nextStepRouteName?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  marketPendingCount?: number;
  readiness?: null | CrmSubmissionAggregateReadinessPayload;
  checklist?: null | CrmSubmissionAggregateChecklistPayload;
}

export interface CrmSubmissionPipelineColumnPayload {
  key?: string;
  label?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  count?: number;
  hasMore?: boolean;
  items?: CrmSubmissionPipelineItemPayload[];
}

export interface CrmSubmissionPipelinePayload {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  scopeTotal?: number;
  /** @nullable */
  search?: string | null;
  columns?: CrmSubmissionPipelineColumnPayload[];
}

export interface TeamBillingStatusDto {
  teamId?: string;
  hasBillingRecord?: boolean;
  /** @nullable */
  planKey?: string | null;
  /** @nullable */
  planName?: string | null;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  seatQuantity?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  seatsUsed?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  seatsRemaining?: number;
  isSeatLimitReached?: boolean;
  canAddMembers?: boolean;
  subscriptionStatus?: string;
  paymentStatus?: string;
  /** @nullable */
  currentPeriodStartUtc?: string | null;
  /** @nullable */
  currentPeriodEndUtc?: string | null;
  /** @nullable */
  trialEndsAtUtc?: string | null;
  cancelAtPeriodEnd?: boolean;
  /** @nullable */
  updatedAtUtc?: string | null;
  entitlementState?: string;
  accessSource?: string;
  /** @nullable */
  adjustmentKind?: string | null;
  /** @nullable */
  adjustmentEffectiveUntilUtc?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  adjustmentSeatQuantityOverride?: number | null;
  isDemoAccount?: boolean;
  /** @nullable */
  demoAccountKind?: string | null;
  allowAppAccess?: boolean;
  allowWrites?: boolean;
  requiresPaymentAction?: boolean;
  requiresSubscription?: boolean;
}

export interface CurrentUserDto {
  id?: string;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  firstName?: string | null;
  /** @nullable */
  lastName?: string | null;
  /** @nullable */
  phone?: string | null;
  isActive?: boolean;
  /** @nullable */
  authSubject?: string | null;
  createdAt?: string;
  /** @nullable */
  lastLoginAt?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  teamRole?: string | null;
  isTeamAdmin?: boolean;
  billing?: null | TeamBillingStatusDto;
  /** @nullable */
  settings?: string | null;
}

export interface CurrentUserSettingsDto {
  settings?: string;
}

export interface DashboardBillingStatsDto {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  activeSubscriptions?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  trialingTeams?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  manualAccessTeams?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  paymentActionRequiredTeams?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  unsubscribedTeams?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  canceledTeams?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  seatLimitReachedTeams?: number;
}

export interface UserStatsDto {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  total?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  active?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  newThisMonth?: number;
}

export interface DashboardStatsDto {
  users?: UserStatsDto;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  teamsTotal?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  appFormsTotal?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  acordFormsTotal?: number;
  billing?: DashboardBillingStatsDto;
}

export interface DecideEdgeWorkRequest {
  /** @nullable */
  expectedPreviewDigest?: string | null;
  /** @nullable */
  decision?: string | null;
}

export interface DeclineSubmissionMarketRequest {
  /** @nullable */
  declineReason?: string | null;
  /** @nullable */
  notes?: string | null;
}

export interface DeliverCertificateRequest {
  /** @nullable */
  toEmail?: string | null;
  /** @nullable */
  subject?: string | null;
  /** @nullable */
  bodyText?: string | null;
  completeLinkedServiceWork?: boolean;
}

export interface DocusignConnectStartRequest {
  /** @nullable */
  returnUrl?: string | null;
}

export interface EdgeClientHeartbeatRequest {
  /** @nullable */
  capabilities?: string[] | null;
  /** @nullable */
  version?: string | null;
  /** @nullable */
  platform?: string | null;
}

export interface EdgeClientHeartbeatResponse {
  edgeClientId?: string;
  clientId?: string;
  teamId?: string;
  /** @nullable */
  displayName?: string | null;
  capabilities?: string[];
  status?: string;
  serverTimeUtc?: string;
  lastSeenAtUtc?: string;
  lastHeartbeatAtUtc?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  heartbeatIntervalSeconds?: number;
}

export interface EdgeClientSummaryResponse {
  edgeClientId?: string;
  teamId?: string;
  clientId?: string;
  /** @nullable */
  displayName?: string | null;
  capabilities?: string[];
  status?: string;
  /** @nullable */
  version?: string | null;
  /** @nullable */
  platform?: string | null;
  /** @nullable */
  enrollmentId?: string | null;
  /** @nullable */
  createdByUserId?: string | null;
  createdAtUtc?: string;
  /** @nullable */
  lastSeenAtUtc?: string | null;
  /** @nullable */
  lastHeartbeatAtUtc?: string | null;
  /** @nullable */
  revokedAtUtc?: string | null;
  /** @nullable */
  revokedByUserId?: string | null;
}

export interface EdgeEchoCheckpointResponse {
  name?: string;
  proposalId?: string;
  status?: string;
  toolName?: string;
  toolVersion?: string;
  actionSummary?: string;
  workerId?: string;
  contextJson?: string;
  preview?: TeamAgentActionPreviewResponse;
  source?: string;
  evidence?: string;
  proposedAt?: string;
  /** @nullable */
  resolvedByActorId?: string | null;
  /** @nullable */
  resolvedAt?: string | null;
  /** @nullable */
  executionId?: string | null;
  /** @nullable */
  executedAt?: string | null;
  /** @nullable */
  executionSummary?: string | null;
  /** @nullable */
  recordedResultJson?: string | null;
}

export interface EdgeEchoAgentRunResponse {
  runId?: string;
  agentName?: string;
  agentVersion?: string;
  status?: string;
  teamId?: string;
  actorId?: string;
  workerId?: string;
  workerType?: string;
  contextJson?: string;
  evidenceSource?: string;
  resultCheckpoint?: EdgeEchoCheckpointResponse;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  recordedEventCount?: number;
}

export interface EdgeEchoWorkItemStateResponse {
  workerId?: string;
  workerType?: string;
  status?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  attempts?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  maxAttempts?: number;
  /** @nullable */
  completedAtUtc?: string | null;
  /** @nullable */
  openInterventionReason?: string | null;
  /** @nullable */
  openInterventionRequestedAtUtc?: string | null;
}

export interface EdgeEchoAgentRunStateResponse {
  runId?: string;
  agentName?: string;
  agentVersion?: string;
  status?: string;
  teamId?: string;
  actorId?: string;
  startedAt?: string;
  /** @nullable */
  completedAt?: string | null;
  /** @nullable */
  outputSummary?: string | null;
  resultCheckpoint?: EdgeEchoCheckpointResponse;
  edgeWork?: null | EdgeEchoWorkItemStateResponse;
  events?: TeamAgentRunEventResponse[];
  /** @nullable */
  resolutionKind?: string | null;
  /** @nullable */
  resumeOutcome?: string | null;
}

export interface EdgeWorkApprovalResponse {
  approvalId?: string;
  workerId?: string;
  decision?: string;
  previewDigest?: string;
  outputSha256?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  outputBytes?: number;
  decidedByUserId?: string;
  decidedAtUtc?: string;
}

export interface EdgeWorkArtifactResponse {
  artifactId?: string;
  uploadId?: string;
  workerId?: string;
  /** @nullable */
  evidenceKey?: string | null;
  fileName?: string;
  contentType?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  bytes?: number;
  /** @nullable */
  sha256?: string | null;
  createdAtUtc?: string;
}

export interface EdgeWorkItemDetailResponse {
  workerId?: string;
  teamId?: string;
  workerType?: string;
  status?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  attempts?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  maxAttempts?: number;
  /** @nullable */
  outputJson?: string | null;
  /** @nullable */
  errorJson?: string | null;
  /** @nullable */
  completedAtUtc?: string | null;
  /** @nullable */
  openInterventionReason?: string | null;
  /** @nullable */
  openInterventionRequestedAtUtc?: string | null;
  artifacts?: EdgeWorkArtifactResponse[];
  approval?: null | EdgeWorkApprovalResponse;
  /** @nullable */
  cancelRequestedAtUtc?: string | null;
  /** @nullable */
  cancelRequestedByUserId?: string | null;
  /** @nullable */
  commitWorkerId?: string | null;
}

export interface EdgeWorkCancelConflictResponse {
  code?: string;
  message?: string;
  state?: null | EdgeWorkItemDetailResponse;
}

export interface EdgeWorkCommitConflictResponse {
  code?: string;
  message?: string;
  state?: null | EdgeWorkItemDetailResponse;
  /** @nullable */
  commitWorkerId?: string | null;
}

export interface EdgeWorkDecisionConflictResponse {
  code?: string;
  message?: string;
  state?: null | EdgeWorkItemDetailResponse;
}

export interface EdgeWorkEventResponse {
  workerId?: string;
  status?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  progressPct?: number;
  /** @nullable */
  statusMessage?: string | null;
  cancelRequested?: boolean;
  recordedAtUtc?: string;
}

export interface EdgeWorkInterventionResponse {
  interventionId?: string;
  workerId?: string;
  reason?: string;
  /** @nullable */
  message?: string | null;
  requestedAtUtc?: string;
  /** @nullable */
  resolvedAtUtc?: string | null;
  /** @nullable */
  resolution?: string | null;
}

export interface EdgeWorkItemResponse {
  workerId?: string;
  teamId?: string;
  workerType?: string;
  status?: string;
  createdAtUtc?: string;
}

export interface EdgeWorkItemSummaryResponse {
  workerId?: string;
  teamId?: string;
  workerType?: string;
  status?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  attempts?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  maxAttempts?: number;
  createdAtUtc?: string;
  /** @nullable */
  completedAtUtc?: string | null;
  /** @nullable */
  statusMessage?: string | null;
  /** @nullable */
  cancelRequestedAtUtc?: string | null;
  /** @nullable */
  openInterventionReason?: string | null;
  /** @nullable */
  openInterventionMessage?: string | null;
  /** @nullable */
  openInterventionRequestedAtUtc?: string | null;
  /** @nullable */
  errorReason?: string | null;
}

export interface EmailVerifyRequest {
  email?: string;
}

export interface EmailVerifyResponse {
  isValid?: boolean;
  /** @nullable */
  result?: string | null;
  /** @nullable */
  status?: string | null;
  /** @nullable */
  flags?: string[] | null;
  /** @nullable */
  suggestedCorrection?: string | null;
  /** @nullable */
  rawJson?: string | null;
  /** @nullable */
  error?: string | null;
}

export interface EnsureTeamInboundEmailRouteRequest {
  /** @nullable */
  routeType?: string | null;
  /** @nullable */
  mailboxRole?: string | null;
}

export interface EntraUserDto {
  id?: string;
  /** @nullable */
  userPrincipalName?: string | null;
  /** @nullable */
  displayName?: string | null;
  /** @nullable */
  givenName?: string | null;
  /** @nullable */
  surname?: string | null;
  /** @nullable */
  mail?: string | null;
  /** @nullable */
  jobTitle?: string | null;
  /** @nullable */
  department?: string | null;
  /** @nullable */
  officeLocation?: string | null;
  /** @nullable */
  mobilePhone?: string | null;
  /** @nullable */
  businessPhones?: string | null;
  accountEnabled?: boolean;
  /** @nullable */
  createdDateTime?: string | null;
  /** @nullable */
  lastSignInDateTime?: string | null;
  userType?: string;
  isAppAdmin?: boolean;
  isAppUser?: boolean;
}

export interface EntraUserCreationResult {
  success?: boolean;
  message?: string;
  user?: null | EntraUserDto;
  /** @nullable */
  temporaryPassword?: string | null;
  errors?: string[];
}

export interface EntraUserStatsDto {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  totalUsers?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  enabledUsers?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  disabledUsers?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  guestUsers?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  memberUsers?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  recentlyCreated?: number;
  lastSync?: string;
}

export interface EsignActivityItem {
  id?: string;
  teamId?: string;
  direction?: string;
  vendor?: string;
  envelopeId?: string;
  status?: string;
  documentKind?: string;
  recipientEmail?: string;
  /** @nullable */
  recipientName?: string | null;
  /** @nullable */
  subject?: string | null;
  clientAccountId?: string;
  submissionId?: string;
  quoteId?: string;
  carrierPartyId?: string;
  /** @nullable */
  carrierName?: string | null;
  /** @nullable */
  quoteNumber?: string | null;
  /** @nullable */
  contextLabel?: string | null;
  sentAt?: string;
  /** @nullable */
  completedAt?: string | null;
  /** @nullable */
  declinedAt?: string | null;
  /** @nullable */
  voidedAt?: string | null;
  /** @nullable */
  failedAt?: string | null;
  createdAt?: string;
  /** @nullable */
  updatedAt?: string | null;
  occurredAt?: string;
}

export interface FormSlotDataKeyBindingItem {
  slotId?: string;
  dataKey?: string;
  /** @nullable */
  transform?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  priority?: number | null;
}

export interface GenerateAppYamlRequest {
  force?: boolean;
}

export interface GenerateFormsRequest {
  /** @nullable */
  scope?: string | null;
  /** @nullable */
  publish?: boolean | null;
  /** @nullable */
  reason?: string | null;
}

export type IFormFile = Blob;

export interface InvokeRetrievalRequest {
  /** @nullable */
  documentId?: string | null;
}

export interface IssueCertificateRequest {
  regeneratePdf?: boolean;
}

export interface JsonElement {}

export interface LeadCheckOutcomeV1Response {
  checkId?: string;
  checkKey?: string;
  provider?: string;
  checkedAt?: string;
  status?: string;
  summary?: string;
  /** @nullable */
  normalizedValue?: string | null;
  evidenceIds?: string[];
}

export interface LeadCreateDraftV1Response {
  /** @nullable */
  sourceTypeCode?: string | null;
  /** @nullable */
  sourceOccurredAt?: string | null;
  /** @nullable */
  proposedPartyTypeCode?: string | null;
  /** @nullable */
  proposedName?: string | null;
  /** @nullable */
  proposedCompanyName?: string | null;
  /** @nullable */
  proposedPhone?: string | null;
  /** @nullable */
  proposedEmail?: string | null;
  /** @nullable */
  proposedAddressLine1?: string | null;
  /** @nullable */
  proposedAddressLine2?: string | null;
  /** @nullable */
  proposedCity?: string | null;
  /** @nullable */
  proposedStateCode?: string | null;
  /** @nullable */
  proposedPostalCode?: string | null;
  /** @nullable */
  proposedWebsiteUrl?: string | null;
  /** @nullable */
  rawNotes?: string | null;
  /** @nullable */
  summary?: string | null;
  /** @nullable */
  assignedToUserId?: string | null;
  /** @nullable */
  qualificationNotes?: string | null;
  /** @nullable */
  sourceMetadataJson?: string | null;
  /** @nullable */
  matchedPartyId?: string | null;
  /** @nullable */
  matchedClientAccountId?: string | null;
  confirmNoCrmMatch?: boolean;
}

export interface LeadResearchFactV1Response {
  key?: string;
  value?: string;
}

export interface LeadResearchEvidenceV1Response {
  evidenceId?: string;
  source?: string;
  provider?: string;
  sourceUrl?: string;
  retrievedAt?: string;
  authority?: string;
  status?: string;
  summary?: string;
  facts?: LeadResearchFactV1Response[];
}

export interface LeadPreparationConflictV1Response {
  conflictId?: string;
  code?: string;
  /** @nullable */
  fieldKey?: string | null;
  severity?: string;
  summary?: string;
  evidenceIds?: string[];
  checkIds?: string[];
}

export interface LeadFieldProvenanceV1Response {
  fieldKey?: string;
  /** @nullable */
  value?: string | null;
  origin?: string;
  explanation?: string;
  evidenceIds?: string[];
  checkIds?: string[];
}

export interface LeadReviewedCrmMatchV1Response {
  partyId?: string;
  clientAccountId?: string;
  displayName?: string;
  clientAccountStatus?: string;
  matchType?: string;
  /** @nullable */
  matchedValue?: string | null;
  isExact?: boolean;
}

export interface LeadReviewedCrmMatchSnapshotV1Response {
  checkedAt?: string;
  /** @nullable */
  proposedPartyTypeCode?: string | null;
  /** @nullable */
  proposedName?: string | null;
  /** @nullable */
  proposedCompanyName?: string | null;
  /** @nullable */
  proposedPhone?: string | null;
  /** @nullable */
  proposedEmail?: string | null;
  existingMatch?: null | LeadReviewedCrmMatchV1Response;
  potentialMatches?: LeadReviewedCrmMatchV1Response[];
}

export interface LeadCreateActionV1Response {
  contractVersion?: string;
  preparationSummary?: string;
  draft?: LeadCreateDraftV1Response;
  evidence?: LeadResearchEvidenceV1Response[];
  checks?: LeadCheckOutcomeV1Response[];
  conflicts?: LeadPreparationConflictV1Response[];
  fieldProvenance?: LeadFieldProvenanceV1Response[];
  reviewedCrmMatch?: LeadReviewedCrmMatchSnapshotV1Response;
}

export interface LeadPreparationActionExecutionResponse {
  executionId?: string;
  proposalId?: string;
  resultSummary?: string;
  executedAt?: string;
  /** @nullable */
  outcome?: string | null;
  /** @nullable */
  createdLeadId?: string | null;
  /** @nullable */
  resultCode?: string | null;
}

export interface LeadPreparationActionProposalResponse {
  proposalId?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  revision?: number;
  status?: string;
  toolName?: string;
  toolVersion?: string;
  summary?: string;
  source?: string;
  evidence?: string;
  proposedAt?: string;
  /** @nullable */
  supersedesProposalId?: string | null;
  /** @nullable */
  supersededByProposalId?: string | null;
  /** @nullable */
  revisedByActorId?: string | null;
  /** @nullable */
  resolvedByActorId?: string | null;
  /** @nullable */
  resolvedAt?: string | null;
}

export interface LeadPreparationBriefV1 {
  /** @nullable */
  proposedPartyTypeCode?: string | null;
  /** @nullable */
  proposedName?: string | null;
  /** @nullable */
  proposedCompanyName?: string | null;
  /** @nullable */
  proposedPhone?: string | null;
  /** @nullable */
  proposedEmail?: string | null;
  /** @nullable */
  proposedAddressLine1?: string | null;
  /** @nullable */
  proposedAddressLine2?: string | null;
  /** @nullable */
  proposedCity?: string | null;
  /** @nullable */
  proposedStateCode?: string | null;
  /** @nullable */
  proposedPostalCode?: string | null;
  /** @nullable */
  proposedWebsiteUrl?: string | null;
  /** @nullable */
  userNotes?: string | null;
}

export interface LeadPreparationCheckpointDecisionRequest {
  expectedProposalId?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  expectedRevision?: number;
  decision?: string;
}

export interface LeadPreparationCheckpointIdentityResponse {
  name?: string;
  kind?: string;
  proposalId?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  revision?: number;
}

export interface LeadPreparationEditableDraftRequest {
  /** @nullable */
  proposedPartyTypeCode?: string | null;
  /** @nullable */
  proposedName?: string | null;
  /** @nullable */
  proposedCompanyName?: string | null;
  /** @nullable */
  proposedPhone?: string | null;
  /** @nullable */
  proposedEmail?: string | null;
  /** @nullable */
  proposedAddressLine1?: string | null;
  /** @nullable */
  proposedAddressLine2?: string | null;
  /** @nullable */
  proposedCity?: string | null;
  /** @nullable */
  proposedStateCode?: string | null;
  /** @nullable */
  proposedPostalCode?: string | null;
  /** @nullable */
  proposedWebsiteUrl?: string | null;
  /** @nullable */
  rawNotes?: string | null;
  /** @nullable */
  assignedToUserId?: string | null;
  /** @nullable */
  qualificationNotes?: string | null;
  /** @nullable */
  matchedPartyId?: string | null;
  /** @nullable */
  matchedClientAccountId?: string | null;
  confirmNoCrmMatch?: boolean;
}

export interface LeadPreparationRunSummaryResponse {
  runId?: string;
  agentName?: string;
  agentVersion?: string;
  status?: string;
  teamId?: string;
  actorId?: string;
  startedAt?: string;
  /** @nullable */
  completedAt?: string | null;
  /** @nullable */
  outputSummary?: string | null;
  /** @nullable */
  errorCode?: string | null;
  checkpoint?: null | LeadPreparationCheckpointIdentityResponse;
}

export interface LeadPreparationRunStateResponse {
  run?: LeadPreparationRunSummaryResponse;
  proposal?: null | LeadPreparationActionProposalResponse;
  leadCreateAction?: null | LeadCreateActionV1Response;
  preview?: null | TeamAgentActionPreviewResponse;
  execution?: null | LeadPreparationActionExecutionResponse;
  /** @nullable */
  outcome?: string | null;
  events?: TeamAgentRunEventResponse[];
}

export interface LeadPreparationMutationConflictResponse {
  code?: string;
  message?: string;
  state?: null | LeadPreparationRunStateResponse;
}

export interface LeadPreparationProposalEditRequest {
  expectedProposalId?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  expectedRevision?: number;
  draft?: LeadPreparationEditableDraftRequest;
}

export interface LeadPreparationRunListResponse {
  runs?: LeadPreparationRunSummaryResponse[];
}

export interface LeadPreparationRunStartRequest {
  brief?: LeadPreparationBriefV1;
}

export interface LeadSummaryResponse {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  newCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  qualifiedCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  convertedCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  unassignedCount?: number;
}

export interface LinkAdditionalInterestRequest {
  additionalInterestId?: string;
  /** @nullable */
  endorsement?: string | null;
}

export interface LinkAgencyRequest {
  partyId?: string;
}

export interface MapInboundEmailSubmissionMarketRequest {
  submissionId?: string;
  submissionMarketId?: string;
  /** @nullable */
  note?: string | null;
}

export interface MatchLeadRequest {
  /** @nullable */
  matchedPartyId?: string | null;
  /** @nullable */
  matchedClientAccountId?: string | null;
}

export interface PartyDataKeyValueInput {
  dataKey?: string;
  value?: JsonElement;
}

export type PatchIntakeDraftAnswersRequestAnswers = { [key: string]: unknown };

export interface PatchIntakeDraftAnswersRequest {
  answers?: PatchIntakeDraftAnswersRequestAnswers;
  /** @nullable */
  source?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
     */
  confidence?: number | null;
}

export type PatchInviteAnswersRequestAnswers = { [key: string]: unknown };

export interface PatchInviteAnswersRequest {
  answers?: PatchInviteAnswersRequestAnswers;
  /** @nullable */
  source?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
     */
  confidence?: number | null;
}

export interface PdfFieldUpdate {
  /** @nullable */
  slotId?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  page?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
     */
  x?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
     */
  y?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
     */
  w?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
     */
  h?: number | null;
}

export interface PdfLayoutUpdateRequest {
  /** @nullable */
  fields?: PdfFieldUpdate[] | null;
}

export interface PdfWorkerDto {
  workerId?: string;
  teamId?: string;
  status?: string;
  /** @nullable */
  outputContainer?: string | null;
  /** @nullable */
  outputBlobPath?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  progressPercent?: number | null;
  persist?: boolean;
  /** @nullable */
  statusMessage?: string | null;
}

export interface PhoneLookupRequest {
  phoneNumber?: string;
  /** @nullable */
  countryCode?: string | null;
}

export interface PhoneLookupResponse {
  isValid?: boolean;
  /** @nullable */
  e164?: string | null;
  /** @nullable */
  national?: string | null;
  /** @nullable */
  countryCode?: string | null;
  /** @nullable */
  numberType?: string | null;
  /** @nullable */
  carrierName?: string | null;
  /** @nullable */
  lineType?: string | null;
  /** @nullable */
  isSmsCapable?: boolean | null;
  /** @nullable */
  error?: string | null;
}

export interface PhoneValidateRequest {
  phoneNumber?: string;
  /** @nullable */
  countryCode?: string | null;
}

export interface PhoneValidateResponse {
  isValid?: boolean;
  /** @nullable */
  e164?: string | null;
  /** @nullable */
  national?: string | null;
  /** @nullable */
  countryCode?: string | null;
  /** @nullable */
  numberType?: string | null;
  /** @nullable */
  error?: string | null;
}

export interface PipelineRow {
  clientName?: string;
  submissionNumber?: string;
  lobCode?: string;
  stageCode?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  premium?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  weightedPremium?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  expectedCommission?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  weightedCommission?: number;
  producer?: string;
}

export interface PipelineSummary {
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  totalPipelinePremium?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  totalWeightedPremium?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  totalCommission?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  totalWeightedCommission?: number;
}

export interface PlaceDetailsResponse {
  status?: string;
  /** @nullable */
  error?: string | null;
  placeId?: string;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  formattedAddress?: string | null;
  /** @nullable */
  localPhoneNumber?: string | null;
  /** @nullable */
  internationalPhoneNumber?: string | null;
  /** @nullable */
  websiteUrl?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
     */
  latitude?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
     */
  longitude?: number | null;
  /** @nullable */
  googleMapsUrl?: string | null;
}

export interface PolicyDocumentRetrievalCheckpointResponse {
  name?: string;
  proposalId?: string;
  status?: string;
  toolName?: string;
  toolVersion?: string;
  actionSummary?: string;
  workerId?: string;
  documentId?: string;
  preview?: TeamAgentActionPreviewResponse;
  source?: string;
  evidence?: string;
  proposedAt?: string;
  /** @nullable */
  resolvedByActorId?: string | null;
  /** @nullable */
  resolvedAt?: string | null;
  /** @nullable */
  executionId?: string | null;
  /** @nullable */
  executedAt?: string | null;
  /** @nullable */
  executionSummary?: string | null;
  /** @nullable */
  recordedResultJson?: string | null;
}

export interface PolicyDocumentRetrievalRunResponse {
  runId?: string;
  agentName?: string;
  agentVersion?: string;
  status?: string;
  teamId?: string;
  actorId?: string;
  workerId?: string;
  workerType?: string;
  documentId?: string;
  evidenceSource?: string;
  resultCheckpoint?: PolicyDocumentRetrievalCheckpointResponse;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  recordedEventCount?: number;
}

export interface PolicyDocumentRetrievalWorkItemStateResponse {
  workerId?: string;
  workerType?: string;
  status?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  attempts?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  maxAttempts?: number;
  /** @nullable */
  completedAtUtc?: string | null;
  /** @nullable */
  openInterventionReason?: string | null;
  /** @nullable */
  openInterventionRequestedAtUtc?: string | null;
}

export interface PolicyDocumentRetrievalRunStateResponse {
  runId?: string;
  agentName?: string;
  agentVersion?: string;
  status?: string;
  teamId?: string;
  actorId?: string;
  startedAt?: string;
  /** @nullable */
  completedAt?: string | null;
  /** @nullable */
  outputSummary?: string | null;
  resultCheckpoint?: PolicyDocumentRetrievalCheckpointResponse;
  edgeWork?: null | PolicyDocumentRetrievalWorkItemStateResponse;
  events?: TeamAgentRunEventResponse[];
  /** @nullable */
  resolutionKind?: string | null;
  /** @nullable */
  resumeOutcome?: string | null;
}

export interface PortalListItemDto {
  id?: string;
  /** @nullable */
  teamId?: string | null;
  typeCode?: string;
  /** @nullable */
  label?: string | null;
  publicKey?: string;
  isEnabled?: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface PortalRequest {
  /** @nullable */
  teamId?: string | null;
  customerId?: string;
  returnUrl?: string;
}

export interface PortalUserListItemDto {
  id?: string;
  portalId?: string;
  /** @nullable */
  partyId?: string | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  firstName?: string | null;
  /** @nullable */
  lastName?: string | null;
  isActive?: boolean;
  createdAt?: string;
  /** @nullable */
  lastLoginAt?: string | null;
}

export interface PosthogTopRoute {
  route: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  eventCount: number;
}

export interface PosthogTotals {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  activeUsers: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  totalEvents: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  pageviews: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  leadCreated: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  submissionCreated: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  genaIntakeSubmitted: number;
}

export interface PosthogUsageSummary {
  totals: PosthogTotals;
  topRoutes: PosthogTopRoute[];
}

export interface PrepareSubmissionMarketRequest {
  /** @nullable */
  packageUploadId?: string | null;
  skipReadinessValidation?: boolean;
  /** @nullable */
  notes?: string | null;
}

export interface ProblemDetails {
  /** @nullable */
  type?: string | null;
  /** @nullable */
  title?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  status?: number | null;
  /** @nullable */
  detail?: string | null;
  /** @nullable */
  instance?: string | null;
}

export interface ProcessImportRequest {
  fileId?: string;
}

export interface ProducerProductionRow {
  producer?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  inForcePremiumMonth?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  inForcePremiumYtd?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  expectedCommissionMonth?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  expectedCommissionYtd?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  pipelinePremium?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  renewalPremiumNext90Days?: number;
}

export interface ProducerProductionSummary {
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  totalInForcePremiumMonth?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  totalInForcePremiumYtd?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  totalExpectedCommissionMonth?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  totalExpectedCommissionYtd?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  totalPipelinePremium?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  totalRenewalPremiumNext90Days?: number;
}

export interface ProvisionTeamStaffRequest {
  /** @maxLength 200 */
  displayName: string;
  /**
     * @maxLength 100
     * @nullable
     */
  firstName?: string | null;
  /**
     * @maxLength 100
     * @nullable
     */
  lastName?: string | null;
  /** @maxLength 200 */
  email: string;
  /**
     * @maxLength 50
     * @nullable
     */
  phone?: string | null;
  /**
     * @maxLength 20
     * @nullable
     */
  role?: string | null;
}

export interface PublicCrmQuoteSelectionPayload {
  isValid?: boolean;
  canRespond?: boolean;
  /** @nullable */
  invalidReason?: string | null;
  quoteSelectionRequestId?: string;
  teamId?: string;
  quoteId?: string;
  submissionId?: string;
  clientAccountId?: string;
  carrierPartyId?: string;
  /** @nullable */
  carrierName?: string | null;
  /** @nullable */
  accountName?: string | null;
  /** @nullable */
  quoteNumber?: string | null;
  lobCode?: string;
  /** @nullable */
  insuranceTypeCode?: string | null;
  effectiveFrom?: string;
  effectiveTo?: string;
  quoteStatusCode?: string;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
     */
  annualPremium?: number | null;
  requiresESign?: boolean;
  eSignStatus?: string;
  recipientEmail?: string;
  /** @nullable */
  recipientName?: string | null;
  /** @nullable */
  subject?: string | null;
  /** @nullable */
  messageBody?: string | null;
  status?: string;
  /** @nullable */
  decisionType?: string | null;
  /** @nullable */
  decisionNotes?: string | null;
  /** @nullable */
  signedName?: string | null;
  expiresAt?: string;
  requestedAt?: string;
  /** @nullable */
  viewedAt?: string | null;
  /** @nullable */
  respondedAt?: string | null;
  /** @nullable */
  messageSendId?: string | null;
  /** @nullable */
  messageSendStatus?: string | null;
  /** @nullable */
  createdByUserId?: string | null;
  createdAt?: string;
  /** @nullable */
  updatedAt?: string | null;
}

export interface PublicPortalPayload {
  portalId?: string;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  teamName?: string | null;
  teamHasLogo?: boolean;
  typeCode?: string;
  /** @nullable */
  label?: string | null;
  publicKey?: string;
}

export interface QueueCertificateOutputRenderRequest {
  overwrite?: boolean;
}

export interface QuickBooksConnectStartRequest {
  /** @nullable */
  returnUrl?: string | null;
}

export interface QuickBooksManualSyncRequest {
  includeCustomers?: boolean;
  includeInvoices?: boolean;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  maxCustomers?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  maxPolicies?: number;
}

export interface ReassignPendingTeamMemberRequest {
  agencyStaffId: string;
}

export interface RegisterEdgeClientRequest {
  /** @nullable */
  enrollmentToken?: string | null;
  /** @nullable */
  displayName?: string | null;
  /** @nullable */
  capabilities?: string[] | null;
  /** @nullable */
  version?: string | null;
  /** @nullable */
  platform?: string | null;
}

export interface RegisterEdgeClientResponse {
  edgeClientId?: string;
  clientId?: string;
  clientSecret?: string;
  teamId?: string;
  /** @nullable */
  displayName?: string | null;
  capabilities?: string[];
  enrolledAtUtc?: string;
  apiBaseUrl?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  heartbeatIntervalSeconds?: number;
}

export interface RenewalForecastRow {
  clientName?: string;
  policyNumber?: string;
  lobCode?: string;
  expirationDate?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  renewalPremium?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  expectedCommission?: number;
  producer?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  daysToRenewal?: number;
}

export interface RenewalForecastSummary {
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  totalRenewalPremium?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  totalCommissionExposure?: number;
}

export interface ReplayStripeEventRequest {
  /** @nullable */
  eventId?: string | null;
  /** @nullable */
  payload?: string | null;
}

export interface ReportEdgeWorkEventRequest {
  /** @nullable */
  claimToken?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  progressPct?: number | null;
  /** @nullable */
  statusMessage?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  dataJson?: string | null;
}

export interface ReportEdgeWorkInterventionRequest {
  /** @nullable */
  claimToken?: string | null;
  /** @nullable */
  reason?: string | null;
  /** @nullable */
  message?: string | null;
}

export interface ReportPageDtoOfBookOfBusinessRowAndBookOfBusinessSummary {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  page?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  pageSize?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  total?: number;
  summary?: null | BookOfBusinessSummary;
  rows?: BookOfBusinessRow[];
}

export interface ReportPageDtoOfPipelineRowAndPipelineSummary {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  page?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  pageSize?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  total?: number;
  summary?: null | PipelineSummary;
  rows?: PipelineRow[];
}

export interface ReportPageDtoOfProducerProductionRowAndProducerProductionSummary {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  page?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  pageSize?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  total?: number;
  summary?: null | ProducerProductionSummary;
  rows?: ProducerProductionRow[];
}

export interface ReportPageDtoOfRenewalForecastRowAndRenewalForecastSummary {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  page?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  pageSize?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  total?: number;
  summary?: null | RenewalForecastSummary;
  rows?: RenewalForecastRow[];
}

export interface ResolveEdgeWorkInterventionRequest {
  /** @nullable */
  claimToken?: string | null;
  /** @nullable */
  interventionId?: string | null;
  /** @nullable */
  note?: string | null;
}

export interface RunOnboardingDripCampaignRequest {
  /** @nullable */
  teamId?: string | null;
  dryRun?: boolean;
  /** @nullable */
  dayOffsets?: number[] | null;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  take?: number;
}

export interface RunRenewalCampaignRequest {
  /** @nullable */
  teamId?: string | null;
  dryRun?: boolean;
  /** @nullable */
  dayOffsets?: number[] | null;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  take?: number;
}

export interface SaveFormSlotDataKeyBindingsRequest {
  bindings?: FormSlotDataKeyBindingItem[];
}

export interface SavePartyDataKeyValuesRequest {
  values?: PartyDataKeyValueInput[];
}

export interface ScheduleFieldItem {
  dataKey?: string;
  label?: string;
  /** @nullable */
  helpText?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  sortOrder?: number | null;
  /** @nullable */
  required?: boolean | null;
  /** @nullable */
  uiJson?: string | null;
  /** @nullable */
  isActive?: boolean | null;
}

export interface SaveScheduleFieldsRequest {
  fields?: ScheduleFieldItem[];
}

export interface SubmissionRequiredDataValueInput {
  dataKey?: string;
  value?: JsonElement;
}

export interface SaveSubmissionRequiredDataRequest {
  /** @nullable */
  values?: SubmissionRequiredDataValueInput[] | null;
}

export interface SendB2BInvitationRequest {
  email: string;
  displayName: string;
  /** @nullable */
  inviteRedirectUrl?: string | null;
  sendInvitationMessage?: boolean;
  userType?: string;
  groupIds?: string[];
  appRoles?: AppRoleAssignment[];
  /** @nullable */
  customMessage?: string | null;
}

export interface SendInvitationRequest {
  email: string;
  displayName: string;
  /** @nullable */
  invitedUserMessageInfo?: string | null;
  /** @nullable */
  inviteRedirectUrl?: string | null;
  sendInvitationMessage?: boolean;
}

export interface SendQuoteESignRequest {
  recipientEmail?: string;
  /** @nullable */
  recipientName?: string | null;
  /** @nullable */
  subject?: string | null;
  /** @nullable */
  bodyText?: string | null;
}

export interface SendQuoteSelectionRequestBody {
  recipientEmail?: string;
  /** @nullable */
  recipientName?: string | null;
  /** @nullable */
  subject?: string | null;
  /** @nullable */
  bodyText?: string | null;
  /** @nullable */
  expiresAt?: string | null;
}

export interface SendSubmissionMarketEmailRequest {
  /** @nullable */
  recipientEmail?: string | null;
  /** @nullable */
  subject?: string | null;
  /** @nullable */
  bodyText?: string | null;
  /** @nullable */
  packageUploadId?: string | null;
  /** @nullable */
  attachmentMode?: string | null;
  /** @nullable */
  ccEmails?: string[] | null;
  skipReadinessValidation?: boolean;
}

export interface SendSubmissionMarketRequest {
  /** @nullable */
  method?: string | null;
  /** @nullable */
  packageUploadId?: string | null;
  skipReadinessValidation?: boolean;
  /** @nullable */
  recipientEmail?: string | null;
  /** @nullable */
  subject?: string | null;
  /** @nullable */
  messageBody?: string | null;
  /** @nullable */
  notes?: string | null;
}

export interface ServicingInboundEmailFact {
  inboundEmailDetectedFactId?: string;
  /** @nullable */
  factType?: string | null;
  /** @nullable */
  factValue?: string | null;
  /** @nullable */
  ruleId?: string | null;
  /** @nullable */
  evidence?: string | null;
  appliedStatus?: string;
}

export interface ServicingInboundEmailItem {
  inboundEmailId?: string;
  teamId?: string;
  mappingStatus?: string;
  /** @nullable */
  mailboxRole?: string | null;
  /** @nullable */
  fromEmail?: string | null;
  /** @nullable */
  toEmail?: string | null;
  subject?: string;
  /** @nullable */
  bodyPreview?: string | null;
  /** @nullable */
  providerMessageId?: string | null;
  inboundType?: string;
  confidenceLevel?: string;
  /** @nullable */
  evidenceSummary?: string | null;
  /** @nullable */
  suggestedAction?: string | null;
  triageStatus?: string;
  urgencyLevel?: string;
  missingFields?: string[];
  triageReasons?: string[];
  detectedFacts?: ServicingInboundEmailFact[];
  /** @nullable */
  clientAccountId?: string | null;
  /** @nullable */
  clientName?: string | null;
  /** @nullable */
  submissionId?: string | null;
  /** @nullable */
  submissionMarketId?: string | null;
  /** @nullable */
  policyId?: string | null;
  /** @nullable */
  policyNumber?: string | null;
  /** @nullable */
  certificateId?: string | null;
  /** @nullable */
  certificateHolderName?: string | null;
  /** @nullable */
  serviceRequestId?: string | null;
  /** @nullable */
  intakeRunId?: string | null;
  receivedAt?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface ServicingInboundEmailSummary {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  total?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  certificateRequests?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  servicingRequests?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  pending?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  mapped?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  unmappedContext?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  needsMapping?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  missingInformation?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  readyForReview?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  readyToIssue?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  urgent?: number;
}

export interface ServicingInboundEmailListPayload {
  teamId?: string;
  status?: string;
  summary?: ServicingInboundEmailSummary;
  items?: ServicingInboundEmailItem[];
}

export interface ServicingServiceRequestSummaryPayload {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  total?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  open?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  completed?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  escalated?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  missingInformation?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  ready?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  urgent?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  overdue?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  unassigned?: number;
}

export interface ServicingServiceRequestListResponse {
  teamId?: string;
  status?: string;
  summary?: ServicingServiceRequestSummaryPayload;
  items?: ServicingServiceRequestPayload[];
}

export interface SetClientAccountOwnerRequest {
  /** @nullable */
  ownerUserId?: string | null;
}

export interface SetClientAccountStatusRequest {
  /** @nullable */
  status?: string | null;
}

export interface SetPolicyStatusRequest {
  /** @nullable */
  status?: string | null;
}

export interface SetSubmissionAssigneeRequest {
  /** @nullable */
  assignedToUserId?: string | null;
}

export interface ShelfNoteActionCheckpointResponse {
  name?: string;
  proposalId?: string;
  status?: string;
  toolName?: string;
  toolVersion?: string;
  actionSummary?: string;
  shelfId?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  expectedRevision?: number;
  proposedNote?: string;
  preview?: TeamAgentActionPreviewResponse;
  source?: string;
  evidence?: string;
  proposedAt?: string;
  /** @nullable */
  resolvedByActorId?: string | null;
  /** @nullable */
  resolvedAt?: string | null;
  /** @nullable */
  executionId?: string | null;
  /** @nullable */
  executedAt?: string | null;
  /** @nullable */
  executionSummary?: string | null;
}

export interface ShelfNoteAgentRunRequest {
  /** @nullable */
  threadId?: string | null;
}

export interface ShelfNoteAgentRunResponse {
  runId?: string;
  agentName?: string;
  agentVersion?: string;
  status?: string;
  teamId?: string;
  actorId?: string;
  shelfId?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  shelfRevision?: number;
  bookTitles?: string[];
  proposedNote?: string;
  evidenceSource?: string;
  approvalCheckpoint?: ShelfNoteActionCheckpointResponse;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  recordedEventCount?: number;
}

export interface ShelfNoteAgentRunStateResponse {
  runId?: string;
  agentName?: string;
  agentVersion?: string;
  status?: string;
  teamId?: string;
  actorId?: string;
  startedAt?: string;
  /** @nullable */
  completedAt?: string | null;
  /** @nullable */
  outputSummary?: string | null;
  approvalCheckpoint?: ShelfNoteActionCheckpointResponse;
  events?: TeamAgentRunEventResponse[];
  /** @nullable */
  resolutionKind?: string | null;
}

export interface SingleContactImportRequest {
  /** @nullable */
  source?: string | null;
  /** @nullable */
  vCard?: string | null;
  /** @nullable */
  text?: string | null;
  /** @nullable */
  firstName?: string | null;
  /** @nullable */
  lastName?: string | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  roles?: string[] | null;
}

export interface StarterSignupRequest {
  /** @nullable */
  email: string | null;
  /** @nullable */
  password: string | null;
  /** @nullable */
  agencyName: string | null;
  /** @nullable */
  teamName: string | null;
  /** @nullable */
  doingBusinessAs: string | null;
  /** @nullable */
  website: string | null;
  /** @nullable */
  honeypot: string | null;
}

export interface StartPolicyRenewalSubmissionRequest {
  /** @nullable */
  opportunityId?: string | null;
  /** @nullable */
  effectiveFrom?: string | null;
  /** @nullable */
  effectiveTo?: string | null;
  /** @nullable */
  submissionNumber?: string | null;
  /** @nullable */
  notes?: string | null;
}

export interface StripeCheckoutSessionDto {
  id?: string;
  url?: string;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  planKey?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  quantity?: number | null;
}

export interface StripePortalSessionDto {
  id?: string;
  url?: string;
}

export interface SubmissionAutoSchedulesFinalizeRequest {
  overwrite?: boolean;
  replace?: boolean;
}

export interface SubmissionScheduleDraftRequest {
  row?: JsonElement;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  sortOrder?: number | null;
  /** @nullable */
  isIncluded?: boolean | null;
}

export interface SubmissionScheduleDraftUpdateRequest {
  row?: null | JsonElement;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  sortOrder?: number | null;
  /** @nullable */
  isIncluded?: boolean | null;
}

export interface SubmitQuoteSelectionDecisionRequest {
  /** @nullable */
  decisionType?: string | null;
  /** @nullable */
  decisionNotes?: string | null;
  /** @nullable */
  signedName?: string | null;
}

export interface TagSubmissionRequest {
  tagCode?: string;
}

export interface TeamAgencyLicenseDto {
  agencyLicenseId?: string;
  agencyPartyId?: string;
  agencyName?: string;
  stateCode?: string;
  /** @nullable */
  licenseNumber?: string | null;
  /** @nullable */
  npn?: string | null;
  /** @nullable */
  linesAuthorized?: string | null;
  effectiveFrom?: string;
  /** @nullable */
  effectiveTo?: string | null;
}

export interface TeamAgencyMailingAddressDto {
  /** @nullable */
  addressId?: string | null;
  /** @nullable */
  line1?: string | null;
  /** @nullable */
  line2?: string | null;
  /** @nullable */
  city?: string | null;
  /** @nullable */
  stateProv?: string | null;
  /** @nullable */
  postalCode?: string | null;
  /** @nullable */
  country?: string | null;
}

export interface TeamAgencyProfileDto {
  partyId?: string;
  /** @nullable */
  displayName?: string | null;
  /** @nullable */
  legalName?: string | null;
  /** @nullable */
  doingBusinessAs?: string | null;
  /** @nullable */
  website?: string | null;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  fax?: string | null;
  /** @nullable */
  email?: string | null;
  mailingAddress?: null | TeamAgencyMailingAddressDto;
}

export interface TeamAgentApprovalCheckpointResponse {
  name?: string;
  proposalId?: string;
  status?: string;
  memoryKind?: string;
  memoryKey?: string;
  proposedValue?: string;
  source?: string;
  evidence?: string;
  proposedAt?: string;
  /** @nullable */
  resolvedByActorId?: string | null;
  /** @nullable */
  resolvedAt?: string | null;
}

export interface TeamAgentCheckpointDecisionRequest {
  decision?: string;
}

export interface TeamAgentErrorResponse {
  code?: string;
  message?: string;
}

export interface TeamApplyIntakeReviewDecisionRequest {
  dataKey?: string;
  decision?: string;
  /** @nullable */
  reason?: string | null;
}

export interface TeamApplyIntakeReviewRequest {
  applyToCrm?: boolean;
  applyToPackets?: boolean;
  /** @nullable */
  applyToFormSubmission?: boolean | null;
  decisions?: TeamApplyIntakeReviewDecisionRequest[];
}

export interface TeamApplyPacketPrefillRequest {
  overwrite?: boolean;
}

export interface TeamBillingSnapshotDto {
  provider?: string;
  /** @nullable */
  planKey?: string | null;
  /** @nullable */
  stripePlatformPriceId?: string | null;
  /** @nullable */
  stripeAdditionalSeatPriceId?: string | null;
  /** @nullable */
  stripeCustomerId?: string | null;
  /** @nullable */
  stripeSubscriptionId?: string | null;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  seatQuantity?: number;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /** @nullable */
  currentPeriodStartUtc?: string | null;
  /** @nullable */
  currentPeriodEndUtc?: string | null;
  /** @nullable */
  trialEndsAtUtc?: string | null;
  cancelAtPeriodEnd?: boolean;
  /** @nullable */
  canceledAtUtc?: string | null;
  /** @nullable */
  lastSyncedAtUtc?: string | null;
  /** @nullable */
  lastEventId?: string | null;
  /** @nullable */
  lastEventType?: string | null;
  createdAtUtc?: string;
  updatedAtUtc?: string;
}

export interface TeamEntitlementAdjustmentDto {
  teamEntitlementAdjustmentId?: string;
  adjustmentKind?: string;
  effectiveFromUtc?: string;
  /** @nullable */
  effectiveUntilUtc?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatQuantityOverride?: number | null;
  reason?: string;
  isActive?: boolean;
  /** @nullable */
  grantedByUserId?: string | null;
  /** @nullable */
  grantedBySubject?: string | null;
  /** @nullable */
  revokedAtUtc?: string | null;
  /** @nullable */
  revokedByUserId?: string | null;
  /** @nullable */
  revokedBySubject?: string | null;
  createdAtUtc?: string;
  updatedAtUtc?: string;
}

export interface TeamBillingEventDto {
  teamBillingEventId?: string;
  source?: string;
  provider?: string;
  eventType?: string;
  /** @nullable */
  providerEventId?: string | null;
  /** @nullable */
  planKey?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatQuantity?: number | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /** @nullable */
  currentPeriodStartUtc?: string | null;
  /** @nullable */
  currentPeriodEndUtc?: string | null;
  /** @nullable */
  trialEndsAtUtc?: string | null;
  /** @nullable */
  cancelAtPeriodEnd?: boolean | null;
  /** @nullable */
  canceledAtUtc?: string | null;
  /** @nullable */
  actorSubject?: string | null;
  occurredAtUtc?: string;
  processedAtUtc?: string;
}

export interface TeamBillingAdminDetailDto {
  teamId?: string;
  teamName?: string;
  status?: TeamBillingStatusDto;
  snapshot?: null | TeamBillingSnapshotDto;
  adjustments?: TeamEntitlementAdjustmentDto[];
  events?: TeamBillingEventDto[];
}

export interface TeamBillingCheckoutRequest {
  /** @nullable */
  priceId?: string | null;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  quantity?: number;
  /** @nullable */
  customerEmail?: string | null;
  /** @nullable */
  successUrl?: string | null;
  /** @nullable */
  cancelUrl?: string | null;
  /** @nullable */
  checkoutType?: string | null;
  /** @nullable */
  planKey?: string | null;
}

export interface TeamBillingCheckoutSessionDto {
  id?: string;
  url?: string;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  planKey?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  quantity?: number | null;
}

export interface TeamBookAnalyticsDto {
  teamId?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  totalInForcePremium?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  totalInForceExpectedCommission?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  inForcePolicyCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  renewalNext12MonthsPremium?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  renewalNext12MonthsExpectedCommission?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  renewalNext12MonthsPolicyCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  pipelineTotalEstPremium?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  pipelineTotalEstCommission?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  pipelineWeightedEstPremium?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  pipelineWeightedEstCommission?: number;
}

export interface TeamBuildSubmissionPackageRequest {
  forceRebuild?: boolean;
}

export interface TeamCarrierAppointmentDto {
  carrierAppointmentId?: string;
  producerPartyId?: string;
  producerName?: string;
  carrierPartyId?: string;
  carrierName?: string;
  stateCode?: string;
  effectiveFrom?: string;
  /** @nullable */
  effectiveTo?: string | null;
  /** @nullable */
  appointmentNumber?: string | null;
}

export interface TeamCloseIntakeRunRequest {
  /** @nullable */
  reason?: string | null;
  revokeInvite?: boolean;
}

export interface TeamContextAgentBriefResponse {
  headline?: string;
  factsUsed?: string[];
  observation?: string;
  nextQuestion?: string;
}

export interface TeamContextAgentRunRequest {
  /** @nullable */
  briefingStyle?: string | null;
}

export interface TeamContextAgentRunResponse {
  runId?: string;
  agentName?: string;
  agentVersion?: string;
  status?: string;
  teamId?: string;
  actorId?: string;
  brief?: TeamContextAgentBriefResponse;
  factsPresentedToModel?: string[];
  evidenceSource?: string;
  briefingStyle?: string;
  modelProvider?: string;
  model?: string;
  recalledApprovedMemory?: boolean;
  /** @nullable */
  memoryProposalId?: string | null;
  approvalCheckpoint?: null | TeamAgentApprovalCheckpointResponse;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  recordedEventCount?: number;
}

export interface TeamContextAgentRunStateResponse {
  runId?: string;
  agentName?: string;
  agentVersion?: string;
  status?: string;
  teamId?: string;
  actorId?: string;
  startedAt?: string;
  /** @nullable */
  completedAt?: string | null;
  /** @nullable */
  outputSummary?: string | null;
  approvalCheckpoint?: null | TeamAgentApprovalCheckpointResponse;
  events?: TeamAgentRunEventResponse[];
  /** @nullable */
  resolutionKind?: string | null;
}

export interface TeamCreateIntakeInviteRequest {
  /** @nullable */
  deliveryChannel?: string | null;
  /** @nullable */
  recipientEmail?: string | null;
  /** @nullable */
  recipientPhone?: string | null;
  /** @nullable */
  recipientName?: string | null;
  /** @nullable */
  subject?: string | null;
  /** @nullable */
  bodyText?: string | null;
  /** @nullable */
  expiresAt?: string | null;
}

export interface TeamCreateIntakeRequest {
  /** @nullable */
  contactPartyId?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  recipientEmail?: string | null;
  /** @nullable */
  recipientName?: string | null;
  /** @nullable */
  expiresAt?: string | null;
}

export interface TeamCreatePaymentLinkRequest {
  /** @nullable */
  clientAccountId?: string | null;
  /** @nullable */
  policyId?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  amountCents?: number | null;
  /** @nullable */
  currencyCode?: string | null;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  clientContext?: string | null;
  /** @nullable */
  customerEmail?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  maxUses?: number | null;
  /** @nullable */
  expiresAt?: string | null;
}

export interface TeamDashboardBookStatsDto {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  inForcePolicyCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  totalInForcePremium?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  totalInForceExpectedCommission?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  pipelineTotalEstPremium?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  pipelineTotalEstCommission?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  pipelineWeightedEstPremium?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  pipelineWeightedEstCommission?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  quickBooksLinkedPolicyCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  quickBooksOpenInvoiceCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  quickBooksOpenInvoiceBalance?: number;
}

export interface TeamDashboardStatsDto {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  clientsTotal?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  policiesTotal?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  submissionsTotal?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  intakesTotal?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  submissionsOpenTotal?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  policiesActiveTotal?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  renewalsNext30Total?: number;
}

export interface TeamDashboardMessagingStatsDto {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  emailActivityLast30DaysTotal?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  smsActivityLast30DaysTotal?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  esignActivityLast30DaysTotal?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  esignAwaitingSignatureTotal?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  failedDeliveryTotal?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  unmappedInboundTotal?: number;
}

export interface TeamDashboardSubmissionWorkStatsDto {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  marketsSubmittedTotal?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  marketsQuotedTotal?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  quotesReceivedTotal?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  quotesAwaitingSelectionTotal?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  quotesAwaitingESignTotal?: number;
}

export interface TeamDashboardHomeSummaryDto {
  generatedAtUtc?: string;
  stats?: TeamDashboardStatsDto;
  messaging?: TeamDashboardMessagingStatsDto;
  submissionWork?: TeamDashboardSubmissionWorkStatsDto;
  book?: TeamDashboardBookStatsDto;
}

export interface TeamMemberDto {
  teamId?: string;
  userId?: string;
  joinedAt?: string;
  role?: string;
  status?: string;
  isAdmin?: boolean;
  /** @nullable */
  userDisplayName?: string | null;
  /** @nullable */
  userEmail?: string | null;
  /** @nullable */
  userPrincipalName?: string | null;
  isActive?: boolean;
  hasAuthSubject?: boolean;
}

export interface TeamDetailDto {
  members?: TeamMemberDto[];
  /** @nullable */
  agencyDisplayName?: string | null;
  agencyProfile?: null | TeamAgencyProfileDto;
  id?: string;
  name?: string;
  /** @nullable */
  partyId?: string | null;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  membersCount?: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface TeamEsignSendRequest {
  toEmail?: string;
  toName?: string;
  subject?: string;
  /** @nullable */
  bodyText?: string | null;
  /** @nullable */
  html?: string | null;
}

export interface TeamEsignSettingsRequest {
  preferredVendor?: string;
}

export interface TeamGenaBookContextSourceDto {
  label?: string;
  /** @nullable */
  dataAuthority?: string | null;
  /** @nullable */
  timeBucket?: string | null;
  /** @nullable */
  sourceReadStartedAtUtc?: string | null;
  /** @nullable */
  sourceReadCompletedAtUtc?: string | null;
  /** @nullable */
  indexSubmittedAtUtc?: string | null;
  tags?: string[];
}

export interface TeamGenaBookContextItemDto {
  documentId?: string;
  taskType?: string;
  taskTypeLabel?: string;
  text?: string;
  source?: TeamGenaBookContextSourceDto;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
     */
  score?: number | null;
}

export interface TeamGenaBookContextGroupDto {
  taskType?: string;
  label?: string;
  items?: TeamGenaBookContextItemDto[];
}

export interface TeamGenaBookContextDto {
  teamId?: string;
  query?: string;
  available?: boolean;
  /** @nullable */
  unavailableReason?: string | null;
  generatedAtUtc?: string;
  groups?: TeamGenaBookContextGroupDto[];
}

export interface TeamInsuranceModelCoveragePayload {
  coverageTypeCode?: string;
  /** @nullable */
  displayName?: string | null;
  isDefault?: boolean;
  isRequired?: boolean;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  sortOrder?: number;
}

export interface TeamInsuranceModelDocumentRequirementPayload {
  requirementCode?: string;
  displayName?: string;
  /** @nullable */
  description?: string | null;
  isRequired?: boolean;
  sources?: string[];
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  sortOrder?: number;
}

export interface TeamInsuranceModelFormPayload {
  sourceType?: string;
  usageContextCode?: string;
  /** @nullable */
  usageContextDisplayName?: string | null;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  formNumber?: number;
  title?: string;
  /** @nullable */
  jurisdictionCode?: string | null;
  /** @nullable */
  editionCode?: string | null;
  /** @nullable */
  versionStatus?: string | null;
  /** @nullable */
  appFormVersionId?: string | null;
  isRecommended?: boolean;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  sortOrder?: number;
}

export interface TeamInsuranceModelLobPayload {
  lobCode?: string;
  /** @nullable */
  description?: string | null;
  isPrimary?: boolean;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  sortOrder?: number;
}

export interface TeamInsuranceModelRequiredDataPayload {
  dataKey?: string;
  /** @nullable */
  displayName?: string | null;
  /** @nullable */
  label?: string | null;
  /** @nullable */
  functionalGroupCode?: string | null;
  /** @nullable */
  functionalGroupDisplayName?: string | null;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  sortOrder?: number;
}

export interface TeamInsuranceModelInsuranceTypePayload {
  insuranceTypeCode?: string;
  displayName?: string;
  platformDisplayName?: string;
  domainCode?: string;
  lobGroup?: string;
  /** @nullable */
  defaultLobCode?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  sortOrder?: number | null;
  isEnabledByDefault?: boolean;
  hasTeamOverride?: boolean;
  lobs?: TeamInsuranceModelLobPayload[];
  coverages?: TeamInsuranceModelCoveragePayload[];
  requiredData?: TeamInsuranceModelRequiredDataPayload[];
  forms?: TeamInsuranceModelFormPayload[];
  requiredDocuments?: TeamInsuranceModelDocumentRequirementPayload[];
}

export interface TeamInsuranceModelOverviewPayload {
  teamId?: string;
  generatedAtUtc?: string;
  insuranceTypes?: TeamInsuranceModelInsuranceTypePayload[];
}

export interface TeamInsuranceTypeActivationPayload {
  insuranceTypeCode?: string;
  displayName?: string;
  platformDisplayName?: string;
  domainCode?: string;
  lobGroup?: string;
  /** @nullable */
  defaultLOBCode?: string | null;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  sortOrder?: number;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  platformSortOrder?: number | null;
  isEnabledByDefault?: boolean;
  isEnabled?: boolean;
  /** @nullable */
  isEnabledOverride?: boolean | null;
  hasActivationOverride?: boolean;
  isHidden?: boolean;
  /** @nullable */
  displayNameOverride?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  sortOrderOverride?: number | null;
  hasTeamOverride?: boolean;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  openSubmissionCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  activePolicyCount?: number;
  canDisable?: boolean;
  /** @nullable */
  disableBlockedReason?: string | null;
  /** @nullable */
  changedByUserId?: string | null;
  /** @nullable */
  updatedAt?: string | null;
}

export interface TeamInsuranceTypeActivationRequest {
  /** @nullable */
  isEnabled?: boolean | null;
}

export interface TeamLinkIntakeRunProspectRequest {
  partyId?: string;
}

export type TeamPatchPacketRunnerAnswersRequestAnswers = { [key: string]: unknown };

export interface TeamPatchPacketRunnerAnswersRequest {
  answers?: TeamPatchPacketRunnerAnswersRequestAnswers;
}

export interface TeamPaymentAccountStatusDto {
  teamId?: string;
  provider?: string;
  hasPaymentAccountRecord?: boolean;
  isConnected?: boolean;
  isReady?: boolean;
  requiresAction?: boolean;
  connectionStatus?: string;
  /** @nullable */
  stripeAccountId?: string | null;
  detailsSubmitted?: boolean;
  chargesEnabled?: boolean;
  payoutsEnabled?: boolean;
  /** @nullable */
  country?: string | null;
  /** @nullable */
  defaultCurrency?: string | null;
  requirementsCurrentlyDue?: string[];
  requirementsPastDue?: string[];
  /** @nullable */
  connectedAt?: string | null;
  /** @nullable */
  connectedByUserId?: string | null;
  /** @nullable */
  updatedAtUtc?: string | null;
}

export interface TeamPaymentOnboardingLinkRequest {
  /** @nullable */
  returnUrl?: string | null;
}

export interface TeamPipelineForecastDto {
  teamId?: string;
  asOfUtc?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  totalPremium?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  totalRevenue?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  weightedPremium?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  weightedRevenue?: number;
}

export interface TeamProducerLicenseDto {
  producerLicenseId?: string;
  producerPartyId?: string;
  producerName?: string;
  stateCode?: string;
  /** @nullable */
  licenseNumber?: string | null;
  /** @nullable */
  npn?: string | null;
  /** @nullable */
  linesAuthorized?: string | null;
  effectiveFrom?: string;
  /** @nullable */
  effectiveTo?: string | null;
}

export interface TeamRagRefreshDto {
  teamId: string;
  status: string;
  /** @nullable */
  statusMessage: string | null;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  documentCount: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  searchActionResultCount: number;
  refreshedAtUtc: string;
}

export interface TeamRenewalForecastLobDto {
  lobCode?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  policyCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  premium?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  revenue?: number;
}

export interface TeamRenewalForecastDto {
  teamId?: string;
  windowStartUtc?: string;
  windowEndUtc?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  policyCount?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  totalPremium?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  totalRevenue?: number;
  byLineOfBusiness?: TeamRenewalForecastLobDto[];
}

export interface TeamRevenueLobDto {
  lobCode?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  monthPremium?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  monthRevenue?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  ytdPremium?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  ytdRevenue?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  ytdPolicyCount?: number;
}

export interface TeamRevenueProducerDto {
  /** @nullable */
  producerUserId?: string | null;
  /** @nullable */
  producerPartyId?: string | null;
  producerName?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  monthPremium?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  monthRevenue?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  ytdPremium?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  ytdRevenue?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  ytdPolicyCount?: number;
}

export interface TeamRevokeIntakeInviteRequest {
  /** @nullable */
  reason?: string | null;
}

export interface TeamStaffDto {
  agencyStaffId?: string;
  teamId?: string;
  partyId?: string;
  staffRoleCode?: string;
  /** @nullable */
  staffRoleName?: string | null;
  /** @nullable */
  userId?: string | null;
  /** @nullable */
  userEmail?: string | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  displayName?: string | null;
  isActive?: boolean;
  /** @nullable */
  startedOn?: string | null;
  /** @nullable */
  endedOn?: string | null;
}

export interface TeamStartCrmPacketFromInsuranceModelRequest {
  /** @nullable */
  insuranceTypeCode?: string | null;
  /** @nullable */
  usageContextCode?: string | null;
  /** @nullable */
  jurisdictionCode?: string | null;
  includeOptional?: boolean;
  /** @nullable */
  packetRole?: string | null;
}

export interface TeamStartCrmPacketRequest {
  appFormVersionId?: string;
  /** @nullable */
  packetRole?: string | null;
}

export interface TeamSummaryDto {
  id?: string;
  name?: string;
  /** @nullable */
  partyId?: string | null;
  /** @nullable */
  agencyDisplayName?: string | null;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  membersCount?: number;
  createdAt?: string;
  updatedAt?: string;
}

export type TeamUpsertIntakeProposedValuesRequestValues = { [key: string]: unknown };

export interface TeamUpsertIntakeProposedValuesRequest {
  values?: TeamUpsertIntakeProposedValuesRequestValues;
  /** @nullable */
  source?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
     */
  confidence?: number | null;
}

export interface TeamUpsertPortalRequest {
  /** @nullable */
  typeCode?: string | null;
  /** @nullable */
  label?: string | null;
  /** @nullable */
  publicKey?: string | null;
  /** @nullable */
  settings?: string | null;
  /** @nullable */
  isEnabled?: boolean | null;
}

export interface TestEmailRequest {
  /** @nullable */
  teamId?: string | null;
  to?: string;
  /** @nullable */
  subject?: string | null;
  /** @nullable */
  html?: string | null;
  /** @nullable */
  text?: string | null;
  /** @nullable */
  replyTo?: string | null;
  /** @nullable */
  templateCode?: string | null;
  /** @nullable */
  templateVariantCode?: string | null;
  /** @nullable */
  clientAccountId?: string | null;
  /** @nullable */
  submissionId?: string | null;
  /** @nullable */
  submissionMarketId?: string | null;
  /** @nullable */
  policyId?: string | null;
  /** @nullable */
  intakeRunId?: string | null;
  /** @nullable */
  contextLabel?: string | null;
  marketing?: boolean;
}

export interface TestRequest {
  name?: string;
  documentUrl?: string;
  toEmail?: string;
  toName?: string;
}

export interface UpdateAcordEditionStatusRequest {
  status?: string;
}

export interface UpdateAcordFormActiveRequest {
  active?: boolean;
}

export interface UpdateAgencyLicenseRequest {
  /**
     * @maxLength 2
     * @nullable
     */
  stateCode?: string | null;
  /**
     * @maxLength 50
     * @nullable
     */
  licenseNumber?: string | null;
  /**
     * @maxLength 20
     * @nullable
     */
  npn?: string | null;
  /**
     * @maxLength 200
     * @nullable
     */
  linesAuthorized?: string | null;
  /** @nullable */
  effectiveFrom?: string | null;
  /** @nullable */
  effectiveTo?: string | null;
}

export interface UpdateAppFormActiveRequest {
  active?: boolean;
}

export interface UpdateAppFormVersionStatusRequest {
  status?: string;
}

export interface UpdateAppFormYamlRequest {
  yaml?: string;
  /** @nullable */
  changeNotes?: string | null;
}

export interface UpdateBindingGeometryField {
  /** @nullable */
  acordFieldId?: string | null;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  page?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$ */
  x?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$ */
  y?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$ */
  w?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$ */
  h?: number;
}

export interface UpdateBindingGeometryRequest {
  fields?: UpdateBindingGeometryField[];
}

export interface UpdateCarrierAppointmentRequest {
  /** @nullable */
  producerPartyId?: string | null;
  /** @nullable */
  carrierPartyId?: string | null;
  /** @nullable */
  carrierCatalogId?: string | null;
  /**
     * @maxLength 2
     * @nullable
     */
  stateCode?: string | null;
  /** @nullable */
  effectiveFrom?: string | null;
  /** @nullable */
  effectiveTo?: string | null;
  /**
     * @maxLength 50
     * @nullable
     */
  appointmentNumber?: string | null;
}

export interface UpdateCurrentUserRequest {
  /** @nullable */
  firstName?: string | null;
  /** @nullable */
  lastName?: string | null;
  /** @nullable */
  phone?: string | null;
}

export interface UpdateDataKeyActiveRequest {
  isActive?: boolean;
}

export interface UpdateDataKeyIntakeSettingsRequest {
  /** @nullable */
  label?: string | null;
  /** @nullable */
  helpText?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  sortOrder?: number | null;
  /** @nullable */
  intakeLabel?: string | null;
  /** @nullable */
  intakeHelpText?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  intakeSortOrder?: number | null;
  /** @nullable */
  askInsured?: boolean | null;
  /** @nullable */
  intakeAskInsured?: boolean | null;
  /** @nullable */
  intakeEnabled?: boolean | null;
}

export interface UpdateDataKeyRequest {
  valueType?: string;
  displayName?: string;
  /** @nullable */
  schemaJson?: string | null;
  /** @nullable */
  dataKeyRole?: string | null;
  /** @nullable */
  askInsured?: boolean | null;
  isActive?: boolean;
}

export interface UpdateEntraUserRequest {
  /** @nullable */
  displayName?: string | null;
  /** @nullable */
  givenName?: string | null;
  /** @nullable */
  surname?: string | null;
  /** @nullable */
  mail?: string | null;
  /** @nullable */
  jobTitle?: string | null;
  /** @nullable */
  department?: string | null;
  /** @nullable */
  officeLocation?: string | null;
  /** @nullable */
  mobilePhone?: string | null;
  /** @nullable */
  businessPhone?: string | null;
  /** @nullable */
  accountEnabled?: boolean | null;
  /** @nullable */
  usageLocation?: string | null;
}

export interface UpdateLeadRequest {
  /** @nullable */
  statusCode?: string | null;
  /** @nullable */
  sourceOccurredAt?: string | null;
  /** @nullable */
  proposedPartyTypeCode?: string | null;
  /** @nullable */
  proposedName?: string | null;
  /** @nullable */
  proposedCompanyName?: string | null;
  /** @nullable */
  proposedPhone?: string | null;
  /** @nullable */
  proposedEmail?: string | null;
  /** @nullable */
  proposedAddressLine1?: string | null;
  /** @nullable */
  proposedAddressLine2?: string | null;
  /** @nullable */
  proposedCity?: string | null;
  /** @nullable */
  proposedStateCode?: string | null;
  /** @nullable */
  proposedPostalCode?: string | null;
  /** @nullable */
  proposedWebsiteUrl?: string | null;
  /** @nullable */
  rawNotes?: string | null;
  /** @nullable */
  summary?: string | null;
  /** @nullable */
  assignedToUserId?: string | null;
  /** @nullable */
  qualificationNotes?: string | null;
  /** @nullable */
  sourceMetadataJson?: string | null;
}

export interface UpdatePartyRequest {
  /** @nullable */
  displayName?: string | null;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  firstName?: string | null;
  /** @nullable */
  lastName?: string | null;
  /** @nullable */
  legalName?: string | null;
  /** @nullable */
  doingBusinessAs?: string | null;
  /** @nullable */
  website?: string | null;
  /** @nullable */
  naics?: string | null;
}

export interface UpdateProducerLicenseRequest {
  /**
     * @maxLength 2
     * @nullable
     */
  stateCode?: string | null;
  /**
     * @maxLength 50
     * @nullable
     */
  licenseNumber?: string | null;
  /**
     * @maxLength 20
     * @nullable
     */
  npn?: string | null;
  /**
     * @maxLength 200
     * @nullable
     */
  linesAuthorized?: string | null;
  /** @nullable */
  effectiveFrom?: string | null;
  /** @nullable */
  effectiveTo?: string | null;
}

export interface UpdateRenewalCampaignSchedulerRequest {
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  enabled?: boolean | null;
  /** @nullable */
  cadence?: string | null;
  /** @nullable */
  timeZoneId?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  runHourLocal?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  runMinuteLocal?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  runDayOfWeek?: number | null;
  /** @nullable */
  dryRunMode?: boolean | null;
  /** @nullable */
  dayOffsets?: number[] | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  take?: number | null;
}

export interface UpdateServicingServiceRequestRequest {
  /** @nullable */
  status?: string | null;
  /** @nullable */
  assignedToUserId?: string | null;
  clearAssignee?: boolean;
  /** @nullable */
  dueAt?: string | null;
  clearDueAt?: boolean;
  /** @nullable */
  note?: string | null;
}

export interface UpdateSubmissionMarketRequest {
  /** @nullable */
  appetiteMatch?: string | null;
  /** @nullable */
  status?: string | null;
  /** @nullable */
  sentAt?: string | null;
  /** @nullable */
  responseAt?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
     */
  quotePremium?: number | null;
  /** @nullable */
  declineReason?: string | null;
  /** @nullable */
  notes?: string | null;
}

export interface UpdateSubmissionSetupRequest {
  /** @nullable */
  sourcePolicyId?: string | null;
  /** @nullable */
  lobCode?: string | null;
  /** @nullable */
  insuranceTypeCode?: string | null;
  /** @nullable */
  jurisdictionCode?: string | null;
  /** @nullable */
  effectiveDate?: string | null;
  /** @nullable */
  expirationDate?: string | null;
}

export interface UpdateTeamAgencyProfileRequest {
  /**
     * @maxLength 300
     * @nullable
     */
  displayName?: string | null;
  /**
     * @maxLength 300
     * @nullable
     */
  legalName?: string | null;
  /**
     * @maxLength 300
     * @nullable
     */
  doingBusinessAs?: string | null;
  /**
     * @maxLength 320
     * @nullable
     */
  website?: string | null;
  /**
     * @maxLength 320
     * @nullable
     */
  phone?: string | null;
  /**
     * @maxLength 320
     * @nullable
     */
  fax?: string | null;
  /**
     * @maxLength 320
     * @nullable
     */
  email?: string | null;
  mailingAddress?: null | TeamAgencyMailingAddressDto;
}

export interface UpdateTeamEmailIdentityRequest {
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  fromEmail?: string | null;
  /** @nullable */
  fromDisplayName?: string | null;
  /** @nullable */
  replyDomain?: string | null;
  /** @nullable */
  isDefault?: boolean | null;
  /** @nullable */
  isActive?: boolean | null;
}

export interface UpdateTeamRequest {
  /**
     * @maxLength 200
     * @nullable
     */
  name?: string | null;
}

export interface UpdateTeamStaffRequest {
  /**
     * @maxLength 50
     * @nullable
     */
  staffRoleCode?: string | null;
  /**
     * @maxLength 200
     * @nullable
     */
  email?: string | null;
  /**
     * @maxLength 50
     * @nullable
     */
  phone?: string | null;
  /** @nullable */
  isActive?: boolean | null;
  /** @nullable */
  startedOn?: string | null;
  /** @nullable */
  endedOn?: string | null;
}

export interface UpdateUserRequest {
  /** @nullable */
  email?: string | null;
  /** @nullable */
  firstName?: string | null;
  /** @nullable */
  lastName?: string | null;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  isActive?: boolean | null;
  /** @nullable */
  authSubject?: string | null;
}

export interface UpdateUserSettingsRequest {
  settings: string;
}

export interface UpsertAccountContactRequest {
  contactPartyId?: string;
  roleLabel?: string;
  /** @nullable */
  isPrimary?: boolean | null;
  /** @nullable */
  notes?: string | null;
}

export interface UpsertAcordFieldDataKeyBindingRequest {
  acordFieldId?: string;
  /** @nullable */
  dataKey?: string | null;
  /** @nullable */
  transform?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  priority?: number | null;
  isActive?: boolean;
}

export interface UpsertAddressRequest {
  addressTypeCode?: string;
  line1?: string;
  /** @nullable */
  line2?: string | null;
  city?: string;
  /** @nullable */
  stateProv?: string | null;
  /** @nullable */
  postalCode?: string | null;
  country?: string;
  /** @nullable */
  isPrimary?: boolean | null;
}

export interface UpsertAgentMemoryRequest {
  kind?: string;
  value?: string;
}

export interface UpsertCarrierCatalogRequest {
  /** @nullable */
  displayName?: string | null;
  /** @nullable */
  marketTypeCode?: string | null;
  /** @nullable */
  statusCode?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  naicCompanyCode?: number | null;
  /** @nullable */
  websiteUrl?: string | null;
  /** @nullable */
  domicileState?: string | null;
  /** @nullable */
  notes?: string | null;
  /** @nullable */
  submissionEmail?: string | null;
}

export interface UpsertCertificateRequest {
  policyId?: string;
  certificateTypeCode?: string;
  holderPartyId?: string;
  /** @nullable */
  issueDate?: string | null;
  /** @nullable */
  deliveryEmail?: string | null;
  /** @nullable */
  notes?: string | null;
  /** @nullable */
  pdfBlobUrl?: string | null;
}

export interface UpsertCommRequest {
  channel?: string;
  value?: string;
  /** @nullable */
  isPrimary?: boolean | null;
  /** @nullable */
  notes?: string | null;
}

export interface UpsertCoverageDeductibleRequest {
  deductibleType?: string;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
     */
  deductibleAmount?: number | null;
  /** @nullable */
  currencyCode?: string | null;
}

export interface UpsertCoverageLimitRequest {
  limitType?: string;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
     */
  limitAmount?: number | null;
  /** @nullable */
  currencyCode?: string | null;
}

export interface UpsertCoverageRequest {
  coverageTypeCode?: string;
  appliesToScope?: string;
  /** @nullable */
  appliesToId?: string | null;
  /** @nullable */
  isIncluded?: boolean | null;
  /** @nullable */
  notes?: string | null;
}

export interface UpsertEndorsementRequest {
  endorsementTypeCode?: string;
  effectiveDate?: string;
  /** @nullable */
  description?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
     */
  premiumDelta?: number | null;
  /** @nullable */
  documentUrl?: string | null;
}

export interface UpsertGlExposureRequest {
  policyId?: string;
  locationId?: string;
  glClassCode?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  basisAmount?: number;
  effectiveFrom?: string;
  /** @nullable */
  effectiveTo?: string | null;
}

export interface UpsertPolicyFormRequest {
  formNumber?: string;
  /** @nullable */
  formEdition?: string | null;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  isMandatory?: boolean | null;
}

export interface UpsertPolicyLocationRequest {
  locationId?: string;
  effectiveFrom?: string;
  /** @nullable */
  effectiveTo?: string | null;
}

export interface UpsertPolicyParticipantRequest {
  roleCode?: string;
  /** @nullable */
  userId?: string | null;
  /** @nullable */
  partyId?: string | null;
  /** @nullable */
  effectiveFrom?: string | null;
  /** @nullable */
  effectiveTo?: string | null;
  /** @nullable */
  notes?: string | null;
}

export interface UpsertPolicyPremiumRequest {
  /** @nullable */
  policyTermId?: string | null;
  lobCode?: string;
  premiumType?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$ */
  amount?: number;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
     */
  commissionRatePct?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
     */
  expectedCommissionAmount?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
     */
  actualCommissionAmount?: number | null;
  /** @nullable */
  commissionStatusCode?: string | null;
  /** @nullable */
  commissionConfirmedAt?: string | null;
  /** @nullable */
  commissionPaidAt?: string | null;
  /** @nullable */
  paymentMethodCode?: string | null;
  /** @nullable */
  currencyCode?: string | null;
  /** @nullable */
  basis?: string | null;
  /** @nullable */
  notes?: string | null;
}

export interface UpsertPolicyRenewalWorkRequest {
  /** @nullable */
  renewalStatus?: string | null;
  /** @nullable */
  renewalStrategyCode?: string | null;
  /** @nullable */
  assignedToUserId?: string | null;
  /** @nullable */
  nextActionAt?: string | null;
  /** @nullable */
  coverageReviewDone?: boolean | null;
  /** @nullable */
  lossReviewDone?: boolean | null;
  /** @nullable */
  premiumReviewDone?: boolean | null;
  /** @nullable */
  exposureReviewDone?: boolean | null;
  /** @nullable */
  missingDataIdentified?: boolean | null;
  /** @nullable */
  dataRefreshSent?: boolean | null;
  /** @nullable */
  handoffDocumentsDelivered?: boolean | null;
  /** @nullable */
  handoffCertificatesDelivered?: boolean | null;
  /** @nullable */
  handoffInvoicingNoted?: boolean | null;
}

export interface UpsertPolicyTransactionRequest {
  /** @nullable */
  policyTermId?: string | null;
  transactionTypeCode?: string;
  effectiveDate?: string;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
     */
  premiumDelta?: number | null;
  /** @nullable */
  reason?: string | null;
}

export interface UpsertPortalRequest {
  teamId?: string;
  /** @nullable */
  typeCode?: string | null;
  /** @nullable */
  label?: string | null;
  /** @nullable */
  publicKey?: string | null;
  /** @nullable */
  settings?: string | null;
  /** @nullable */
  isEnabled?: boolean | null;
}

export interface UpsertQuoteOptionItemRequest {
  quoteId?: string;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  sortOrder?: number;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
     */
  allocatedAnnualPremium?: number | null;
  /** @nullable */
  notes?: string | null;
}

export interface UpsertQuoteOptionRequest {
  /** @nullable */
  carrierPartyId?: string | null;
  /** @nullable */
  optionName?: string | null;
  /** @nullable */
  statusCode?: string | null;
  /** @nullable */
  pricingBasis?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
     */
  totalAnnualPremium?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
     */
  packageCreditAmount?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
     */
  packageCreditPercent?: number | null;
  /** @nullable */
  notes?: string | null;
  /** @nullable */
  subjectivitiesJson?: string | null;
  /** @nullable */
  items?: UpsertQuoteOptionItemRequest[] | null;
}

export interface UpsertQuoteRequest {
  /** @nullable */
  submissionMarketId?: string | null;
  carrierPartyId?: string;
  lobCode?: string;
  /** @nullable */
  insuranceTypeCode?: string | null;
  /** @nullable */
  quoteNumber?: string | null;
  effectiveFrom?: string;
  effectiveTo?: string;
  statusCode?: string;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
     */
  annualPremium?: number | null;
  /** @nullable */
  requiresESign?: boolean | null;
}

export interface UpsertRoleRequest {
  roleCode?: string;
  /** @nullable */
  effectiveFrom?: string | null;
}

export interface UpsertUmbrellaUnderlyingRequest {
  umbrellaPolicyId?: string;
  /** @nullable */
  underlyingPolicyId?: string | null;
  /** @nullable */
  carrierPartyId?: string | null;
  /** @nullable */
  lobCode?: string | null;
  /** @nullable */
  policyNumber?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
     */
  eachOccurrence?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
     */
  generalAggregate?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
     */
  autoBIEachPerson?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
     */
  autoBIEachAccident?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
     */
  propertyLimit?: number | null;
  /** @nullable */
  effectiveFrom?: string | null;
  /** @nullable */
  effectiveTo?: string | null;
}

export interface UserTeamMembershipDto {
  teamId?: string;
  teamName?: string;
  joinedAt?: string;
  role?: string;
  status?: string;
  isAdmin?: boolean;
}

export interface UserDetailDto {
  /** @nullable */
  settings?: string | null;
  id?: string;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  firstName?: string | null;
  /** @nullable */
  lastName?: string | null;
  /** @nullable */
  phone?: string | null;
  isActive?: boolean;
  createdAt?: string;
  /** @nullable */
  lastLoginAt?: string | null;
  /** @nullable */
  authSubject?: string | null;
  teams?: UserTeamMembershipDto[];
  /** @nullable */
  fullName?: string | null;
}

export interface UserDto {
  id?: string;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  firstName?: string | null;
  /** @nullable */
  lastName?: string | null;
  /** @nullable */
  phone?: string | null;
  isActive?: boolean;
  createdAt?: string;
  /** @nullable */
  lastLoginAt?: string | null;
  /** @nullable */
  authSubject?: string | null;
  teams?: UserTeamMembershipDto[];
  /** @nullable */
  fullName?: string | null;
}

export interface UserPerformanceDto {
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  performanceScore?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  intakesCreated?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  intakesCompleted?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  submissionsCreated?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  submissionsActive?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  renewalsAssigned?: number;
  /** @pattern ^-?(?:0|[1-9]\d*)$ */
  renewalsProgressed?: number;
}

export interface VinDecodeRawRow {
  /** @nullable */
  groupName?: string | null;
  /** @nullable */
  variable?: string | null;
  /** @nullable */
  value?: string | null;
  /** @nullable */
  patternId?: string | null;
  /** @nullable */
  vinSchemaId?: string | null;
  /** @nullable */
  keys?: string | null;
  /** @nullable */
  elementId?: string | null;
  /** @nullable */
  attributeId?: string | null;
  /** @nullable */
  createdOn?: string | null;
  /** @nullable */
  wmiId?: string | null;
  /** @nullable */
  code?: string | null;
  /** @nullable */
  dataType?: string | null;
  /** @nullable */
  decode?: string | null;
  /** @nullable */
  source?: string | null;
  /** @nullable */
  toBeQCd?: string | null;
}

export interface VinDecodeRawResponse {
  isValid?: boolean;
  vin?: string;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  modelYear?: number | null;
  rows?: VinDecodeRawRow[];
  /** @nullable */
  error?: string | null;
}

export interface VinDecodeRequest {
  vin?: string;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  modelYear?: number | null;
}

export interface VinDecodeResponse {
  isValid?: boolean;
  vin?: string;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  modelYear?: number | null;
  /** @nullable */
  make?: string | null;
  /** @nullable */
  model?: string | null;
  /** @nullable */
  bodyClass?: string | null;
  /** @nullable */
  engineModel?: string | null;
  /** @nullable */
  engineCylinders?: string | null;
  /** @nullable */
  fuelType?: string | null;
  /** @nullable */
  gvwr?: string | null;
  /** @nullable */
  vehicleType?: string | null;
  /** @nullable */
  plantCountry?: string | null;
  /** @nullable */
  plantCity?: string | null;
  /** @nullable */
  plantCompanyName?: string | null;
  /** @nullable */
  error?: string | null;
}

export interface VoidCertificateRequest {
  reason?: string;
}

export interface ZipCodeLookupResponse {
  isValid?: boolean;
  address?: null | AddressDto;
  /** @nullable */
  error?: string | null;
}

export interface ZipValidateResponse {
  isValid?: boolean;
  /** @nullable */
  city?: string | null;
  /** @nullable */
  state?: string | null;
  /** @nullable */
  zipCode?: string | null;
  /** @nullable */
  error?: string | null;
}

export type PostApiAddressValidate401 = {
  message?: string;
};

export type GetApiAddressZipZip401 = {
  message?: string;
};

export type GetApiAddressCityStateParams = {
zipCode?: string;
};

export type GetApiAddressCityState401 = {
  message?: string;
};

export type GetApiAddressZipcodeParams = {
Street1?: string;
Street2?: string;
City?: string;
State?: string;
Zip?: string;
};

export type GetApiAddressZipcode401 = {
  message?: string;
};

export type DeleteApiAdminAcordImportsImportRunIdParams = {
force?: boolean;
reason?: string;
};

export type DeleteApiAdminAcordImportsImportRunId401 = {
  message?: string;
};

export type DeleteApiAdminAcordImportsImportRunId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiAdminAcordEditionsEditionIdFormVersion401 = {
  message?: string;
};

export type GetApiAdminAcordEditionsEditionIdFormVersions401 = {
  message?: string;
};

export type GetApiAdminAcordEditionsEditionIdMappingkeyTokens401 = {
  message?: string;
};

export type GetApiAdminAcordEditionsEditionIdBindingsGeometry401 = {
  message?: string;
};

export type PostApiAdminAcordEditionsEditionIdBindingsGeometry401 = {
  message?: string;
};

export type PostApiAdminAcordEditionsEditionIdBindingsGeometry402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiAdminAcordEditionsEditionIdBindingsGeometryReset401 = {
  message?: string;
};

export type PostApiAdminAcordEditionsEditionIdBindingsGeometryReset402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiAdminAcordEditionsEditionIdAcroControls401 = {
  message?: string;
};

export type GetApiAdminAcordForms401 = {
  message?: string;
};

export type GetApiAdminAcordFormsSummaryParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
search?: string;
};

export type GetApiAdminAcordFormsSummary401 = {
  message?: string;
};

export type GetApiAdminAcordUsageContexts401 = {
  message?: string;
};

export type GetApiAdminAcordLibraryParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
search?: string;
sortBy?: string;
sortDirection?: string;
activeOnly?: boolean;
importedOnly?: boolean;
productCodes?: string;
lobCodes?: string;
usageContexts?: string;
};

export type GetApiAdminAcordLibrary401 = {
  message?: string;
};

export type GetApiAdminAcordEditionsParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
search?: string;
sortBy?: string;
sortDirection?: string;
activeOnly?: boolean;
activeFormsOnly?: boolean;
importedOnly?: boolean;
generatedOnly?: boolean;
dataKeyBindingsOnly?: boolean;
productCodes?: string;
};

export type GetApiAdminAcordEditions401 = {
  message?: string;
};

export type GetApiAdminAcordFormsAcordFormIdSummary401 = {
  message?: string;
};

export type PostApiAdminAcordFormsAcordFormIdActive401 = {
  message?: string;
};

export type PostApiAdminAcordFormsAcordFormIdActive402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiAdminAcordFormsAcordFormIdEditions401 = {
  message?: string;
};

export type PostApiAdminAcordEditionsEditionIdStatus401 = {
  message?: string;
};

export type PostApiAdminAcordEditionsEditionIdStatus402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiAdminAcordEditionsEditionIdFileParams = {
download?: boolean;
type?: string;
};

export type GetApiAdminAcordEditionsEditionIdFile401 = {
  message?: string;
};

export type GetApiAdminAcordEditionsEditionIdFieldsParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiAdminAcordEditionsEditionIdFields401 = {
  message?: string;
};

export type GetApiAdminAcordEditionsEditionIdFieldDatakeyBindingsParams = {
includeUnbound?: boolean;
};

export type GetApiAdminAcordEditionsEditionIdFieldDatakeyBindings401 = {
  message?: string;
};

export type PostApiAdminAcordEditionsEditionIdFieldDatakeyBindings401 = {
  message?: string;
};

export type PostApiAdminAcordEditionsEditionIdFieldDatakeyBindings402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiAdminAcordEditionsEditionIdViewer401 = {
  message?: string;
};

export type GetApiAdminAcordEditionsEditionIdImportRun401 = {
  message?: string;
};

export type PostApiAdminAcordEditionsEditionIdUploadBody = {
  file?: Blob;
};

export type PostApiAdminAcordEditionsEditionIdUpload401 = {
  message?: string;
};

export type PostApiAdminAcordEditionsEditionIdUpload402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiAdminAcordProcess401 = {
  message?: string;
};

export type PostApiAdminAcordProcess402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiAdminAcordImportRunsImportRunIdPrecheck401 = {
  message?: string;
};

export type PostApiAdminAcordImportRunsImportRunIdPrecheck402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiAdminAcordEditionsEditionIdGenerate401 = {
  message?: string;
};

export type PostApiAdminAcordEditionsEditionIdGenerate402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiAdminAcordImportRun401 = {
  message?: string;
};

export type PostApiAdminAcordImportRun402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiAdminAcordImportRunsImportRunIdEnqueue401 = {
  message?: string;
};

export type PostApiAdminAcordImportRunsImportRunIdEnqueue402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiAdminAcordImportsFileIdDetails401 = {
  message?: string;
};

export type GetApiAdminAcordImportsFileIdEditions401 = {
  message?: string;
};

export type GetApiAdminAcordImportsFileIdEventsParams = {
type?: string;
};

export type GetApiAdminAcordImportsFileIdEvents401 = {
  message?: string;
};

export type GetApiAdminAcordImportsParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
search?: string;
state?: string;
};

export type GetApiAdminAcordImports401 = {
  message?: string;
};

export type GetApiAdminAcordFormsRegenFormRegenRunIdEvents401 = {
  message?: string;
};

export type GetApiAdminAcordFormsRegenFormRegenRunId401 = {
  message?: string;
};

export type PostApiAdminAcrobatsignTest401 = {
  message?: string;
};

export type PostApiAdminAcrobatsignTest402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiAdminAppFilesParams = {
purpose?: string;
includeDeleted?: boolean;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiAdminAppFiles401 = {
  message?: string;
};

export type PostApiAdminAppFilesFromBlob401 = {
  message?: string;
};

export type PostApiAdminAppFilesFromBlob402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type DeleteApiAdminAppFilesFileId401 = {
  message?: string;
};

export type DeleteApiAdminAppFilesFileId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiAdminAppFilesFileIdRestore401 = {
  message?: string;
};

export type PostApiAdminAppFilesFileIdRestore402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type DeleteApiAdminAppFilesFileIdHard401 = {
  message?: string;
};

export type DeleteApiAdminAppFilesFileIdHard402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiAdminAppFilesFileIdContentParams = {
download?: boolean;
};

export type GetApiAdminAppFilesFileIdContent401 = {
  message?: string;
};

export type GetApiAdminCarrierCatalogParams = {
search?: string;
includeInactive?: boolean;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiAdminCarrierCatalog401 = {
  message?: string;
};

export type PostApiAdminCarrierCatalog401 = {
  message?: string;
};

export type PostApiAdminCarrierCatalog402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PutApiAdminCarrierCatalogCarrierCatalogId401 = {
  message?: string;
};

export type PutApiAdminCarrierCatalogCarrierCatalogId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiAdminDemoAccounts401 = {
  message?: string;
};

export type GetApiAdminDemoAccounts402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiAdminDemoAccounts401 = {
  message?: string;
};

export type PostApiAdminDemoAccounts402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiAdminDemoAccountsTeamIdPassword401 = {
  message?: string;
};

export type PostApiAdminDemoAccountsTeamIdPassword402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type DeleteApiAdminDemoAccountsTeamId401 = {
  message?: string;
};

export type DeleteApiAdminDemoAccountsTeamId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiAdminDocusignTest401 = {
  message?: string;
};

export type PostApiAdminDocusignTest402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiAdminEmailTemplates401 = {
  message?: string;
};

export type GetApiTeamsTeamIdEmailTemplates401 = {
  message?: string;
};

export type PostApiAdminEmailTest401 = {
  message?: string;
};

export type PostApiAdminEmailTest402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdEmailTest401 = {
  message?: string;
};

export type PostApiTeamsTeamIdEmailTest402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiAdminEmailIdentitiesParams = {
teamId?: string;
};

export type GetApiAdminEmailIdentities401 = {
  message?: string;
};

export type GetApiTeamsTeamIdEmailIdentities401 = {
  message?: string;
};

export type PutApiAdminEmailIdentitiesMailboxRole401 = {
  message?: string;
};

export type PutApiAdminEmailIdentitiesMailboxRole402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PutApiTeamsTeamIdEmailIdentitiesMailboxRole401 = {
  message?: string;
};

export type PutApiTeamsTeamIdEmailIdentitiesMailboxRole402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiAdminEmailInboundRoutesParams = {
teamId?: string;
};

export type GetApiAdminEmailInboundRoutes401 = {
  message?: string;
};

export type GetApiTeamsTeamIdEmailInboundRoutes401 = {
  message?: string;
};

export type PostApiAdminEmailInboundRoutesEnsureParams = {
teamId?: string;
};

export type PostApiAdminEmailInboundRoutesEnsure401 = {
  message?: string;
};

export type PostApiAdminEmailInboundRoutesEnsure402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdEmailInboundRoutesEnsure401 = {
  message?: string;
};

export type PostApiTeamsTeamIdEmailInboundRoutesEnsure402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiAdminEmailCampaignsRenewalsRun401 = {
  message?: string;
};

export type PostApiAdminEmailCampaignsRenewalsRun402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiAdminEmailCampaignsRenewalsSchedulerSettingsParams = {
teamId?: string;
};

export type GetApiAdminEmailCampaignsRenewalsSchedulerSettings401 = {
  message?: string;
};

export type PutApiAdminEmailCampaignsRenewalsSchedulerSettings401 = {
  message?: string;
};

export type PutApiAdminEmailCampaignsRenewalsSchedulerSettings402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdEmailCampaignsRenewalsSchedulerSettings401 = {
  message?: string;
};

export type PutApiTeamsTeamIdEmailCampaignsRenewalsSchedulerSettings401 = {
  message?: string;
};

export type PutApiTeamsTeamIdEmailCampaignsRenewalsSchedulerSettings402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiAdminEmailCampaignsRenewalsSchedulerRunsParams = {
teamId?: string;
status?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
take?: number;
};

export type GetApiAdminEmailCampaignsRenewalsSchedulerRuns401 = {
  message?: string;
};

export type GetApiTeamsTeamIdEmailCampaignsRenewalsSchedulerRunsParams = {
status?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
take?: number;
};

export type GetApiTeamsTeamIdEmailCampaignsRenewalsSchedulerRuns401 = {
  message?: string;
};

export type PostApiAdminEmailCampaignsDripRun401 = {
  message?: string;
};

export type PostApiAdminEmailCampaignsDripRun402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiAdminEmailActivityParams = {
teamId?: string;
clientAccountId?: string;
submissionId?: string;
submissionMarketId?: string;
policyId?: string;
intakeRunId?: string;
status?: string;
templateCode?: string;
mailboxRole?: string;
fromUtc?: string;
toUtc?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
take?: number;
};

export type GetApiAdminEmailActivity401 = {
  message?: string;
};

export type GetApiTeamsTeamIdEmailActivityParams = {
clientAccountId?: string;
submissionId?: string;
submissionMarketId?: string;
policyId?: string;
intakeRunId?: string;
status?: string;
templateCode?: string;
mailboxRole?: string;
fromUtc?: string;
toUtc?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
take?: number;
};

export type GetApiTeamsTeamIdEmailActivity401 = {
  message?: string;
};

export type GetApiAdminEmailActivityEventsParams = {
teamId?: string;
clientAccountId?: string;
submissionId?: string;
submissionMarketId?: string;
policyId?: string;
intakeRunId?: string;
status?: string;
templateCode?: string;
fromUtc?: string;
toUtc?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
take?: number;
};

export type GetApiAdminEmailActivityEvents401 = {
  message?: string;
};

export type GetApiTeamsTeamIdEmailActivityEventsParams = {
clientAccountId?: string;
submissionId?: string;
submissionMarketId?: string;
policyId?: string;
intakeRunId?: string;
status?: string;
templateCode?: string;
fromUtc?: string;
toUtc?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
take?: number;
};

export type GetApiTeamsTeamIdEmailActivityEvents401 = {
  message?: string;
};

export type GetApiAdminFileRecordsParams = {
scope?: string;
purpose?: string;
includeDeleted?: boolean;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiAdminFileRecords401 = {
  message?: string;
};

export type DeleteApiAdminFileRecordsScopeRecordId401 = {
  message?: string;
};

export type DeleteApiAdminFileRecordsScopeRecordId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiAdminFileRecordsScopeRecordIdRestore401 = {
  message?: string;
};

export type PostApiAdminFileRecordsScopeRecordIdRestore402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type DeleteApiAdminFileRecordsScopeRecordIdHard401 = {
  message?: string;
};

export type DeleteApiAdminFileRecordsScopeRecordIdHard402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiAdminFormFilesAttachFormVersionId401 = {
  message?: string;
};

export type PostApiAdminFormFilesAttachFormVersionId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiAdminFormFilesParams = {
teamId?: string;
formVersionId?: string;
contentType?: string;
fileName?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiAdminFormFiles401 = {
  message?: string;
};

export type GetApiAdminFormsAppParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiAdminFormsApp401 = {
  message?: string;
};

export type PostApiAdminFormsApp401 = {
  message?: string;
};

export type PostApiAdminFormsApp402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdFormsAppParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiTeamsTeamIdFormsApp401 = {
  message?: string;
};

export type GetApiAdminFormsAppSummaryParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiAdminFormsAppSummary401 = {
  message?: string;
};

export type GetApiAdminFormsAppSummaryGroupedParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiAdminFormsAppSummaryGrouped401 = {
  message?: string;
};

export type GetApiAdminFormsAppVersionsParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
search?: string;
sortBy?: string;
sortDirection?: string;
source?: string;
lobCode?: string;
};

export type GetApiAdminFormsAppVersions401 = {
  message?: string;
};

export type PostApiAdminFormsAppFormIdActive401 = {
  message?: string;
};

export type PostApiAdminFormsAppFormIdActive402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiAdminFormsAppVersionsFormVersionIdStatus401 = {
  message?: string;
};

export type PostApiAdminFormsAppVersionsFormVersionIdStatus402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiAdminFormsAppFormIdVersions401 = {
  message?: string;
};

export type PostApiAdminFormsAppFormIdVersions401 = {
  message?: string;
};

export type PostApiAdminFormsAppFormIdVersions402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdFormsAppFormIdVersions401 = {
  message?: string;
};

export type GetApiAdminFormsAppVersionsFormVersionIdSlotsParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiAdminFormsAppVersionsFormVersionIdSlots401 = {
  message?: string;
};

export type GetApiTeamsTeamIdFormsAppVersionsFormVersionIdSlotsParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiTeamsTeamIdFormsAppVersionsFormVersionIdSlots401 = {
  message?: string;
};

export type GetApiAdminFormsAppDatakeysParams = {
q?: string;
includeInactive?: boolean;
intakeEnabledOnly?: boolean;
scope?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
take?: number;
};

export type GetApiAdminFormsAppDatakeys401 = {
  message?: string;
};

export type PostApiAdminFormsAppDatakeys401 = {
  message?: string;
};

export type PostApiAdminFormsAppDatakeys402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdFormsAppDatakeysParams = {
q?: string;
includeInactive?: boolean;
intakeEnabledOnly?: boolean;
scope?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
take?: number;
};

export type GetApiTeamsTeamIdFormsAppDatakeys401 = {
  message?: string;
};

export type GetApiAdminFormsAppDatakeysSummaryParams = {
q?: string;
includeInactive?: boolean;
functionalGroupCode?: string;
lobCode?: string;
coverageTypeCode?: string;
dataKeyRole?: string;
binding?: string;
active?: string;
scope?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiAdminFormsAppDatakeysSummary401 = {
  message?: string;
};

export type GetApiTeamsTeamIdFormsAppDatakeysSummaryParams = {
q?: string;
includeInactive?: boolean;
functionalGroupCode?: string;
lobCode?: string;
coverageTypeCode?: string;
dataKeyRole?: string;
binding?: string;
active?: string;
scope?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiTeamsTeamIdFormsAppDatakeysSummary401 = {
  message?: string;
};

export type PutApiAdminFormsAppDatakeysDataKey401 = {
  message?: string;
};

export type PutApiAdminFormsAppDatakeysDataKey402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PutApiAdminFormsAppDatakeysDataKeyIntakeSettings401 = {
  message?: string;
};

export type PutApiAdminFormsAppDatakeysDataKeyIntakeSettings402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiAdminFormsAppDatakeysDataKeyActive401 = {
  message?: string;
};

export type PostApiAdminFormsAppDatakeysDataKeyActive402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiAdminFormsAppVersionsFormVersionIdDatakeyBindings401 = {
  message?: string;
};

export type PutApiAdminFormsAppVersionsFormVersionIdDatakeyBindings401 = {
  message?: string;
};

export type PutApiAdminFormsAppVersionsFormVersionIdDatakeyBindings402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdFormsAppVersionsFormVersionIdDatakeyBindings401 = {
  message?: string;
};

export type GetApiAdminFormsAppCrmBindingsParams = {
dataKey?: string;
targetEntity?: string;
includeInactive?: boolean;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
take?: number;
};

export type GetApiAdminFormsAppCrmBindings401 = {
  message?: string;
};

export type GetApiTeamsTeamIdFormsAppPartiesPartyIdDatakeyValuesParams = {
includeInactive?: boolean;
intakeEnabledOnly?: boolean;
scope?: string;
policyId?: string;
producerPartyId?: string;
};

export type GetApiTeamsTeamIdFormsAppPartiesPartyIdDatakeyValues401 = {
  message?: string;
};

export type PutApiTeamsTeamIdFormsAppPartiesPartyIdDatakeyValues401 = {
  message?: string;
};

export type PutApiTeamsTeamIdFormsAppPartiesPartyIdDatakeyValues402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdFormsAppPartiesDatakeyValuesSummaryParams = {
partyIds?: string;
includeInactive?: boolean;
intakeEnabledOnly?: boolean;
scope?: string;
};

export type GetApiTeamsTeamIdFormsAppPartiesDatakeyValuesSummary401 = {
  message?: string;
};

export type GetApiAdminFormsAppScheduleTypesParams = {
includeInactive?: boolean;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
take?: number;
};

export type GetApiAdminFormsAppScheduleTypes401 = {
  message?: string;
};

export type GetApiAdminFormsAppScheduleTypesScheduleTypeFieldsParams = {
includeInactive?: boolean;
};

export type GetApiAdminFormsAppScheduleTypesScheduleTypeFields401 = {
  message?: string;
};

export type PutApiAdminFormsAppScheduleTypesScheduleTypeFields401 = {
  message?: string;
};

export type PutApiAdminFormsAppScheduleTypesScheduleTypeFields402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PutApiAdminFormsAppVersionsFormVersionIdYaml401 = {
  message?: string;
};

export type PutApiAdminFormsAppVersionsFormVersionIdYaml402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiAdminFormsAppVersionsFormVersionIdGenerateYaml401 = {
  message?: string;
};

export type PostApiAdminFormsAppVersionsFormVersionIdGenerateYaml402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiAdminFormsAppVersionsFormVersionIdCompile401 = {
  message?: string;
};

export type PostApiAdminFormsAppVersionsFormVersionIdCompile402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiAdminFormsAppFormIdVersionsFormVersionIdActivate401 = {
  message?: string;
};

export type PostApiAdminFormsAppFormIdVersionsFormVersionIdActivate402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiAdminFormsAppVersionsFormVersionIdDeactivate401 = {
  message?: string;
};

export type PostApiAdminFormsAppVersionsFormVersionIdDeactivate402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type DeleteApiAdminFormsAppVersionsFormVersionId401 = {
  message?: string;
};

export type DeleteApiAdminFormsAppVersionsFormVersionId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PutApiAdminFormsAppVersionsFormVersionIdGeometry401 = {
  message?: string;
};

export type PutApiAdminFormsAppVersionsFormVersionIdGeometry402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiAdminFormsAppVersionsFormVersionIdDraft401 = {
  message?: string;
};

export type GetApiAdminFormsAppVersionsFormVersionIdDraft402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiAdminFormsAppVersionsFormVersionIdDraft401 = {
  message?: string;
};

export type PostApiAdminFormsAppVersionsFormVersionIdDraft402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiAdminFormsAppVersionsFormVersionIdSaveAndCompile401 = {
  message?: string;
};

export type PostApiAdminFormsAppVersionsFormVersionIdSaveAndCompile402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiAdminFormsAppVersionsFormVersionIdSaveAndCompileAcord401 = {
  message?: string;
};

export type PostApiAdminFormsAppVersionsFormVersionIdSaveAndCompileAcord402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiAdminFormsAppVersionsFormVersionIdCompileFromDraft401 = {
  message?: string;
};

export type PostApiAdminFormsAppVersionsFormVersionIdCompileFromDraft402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiAdminFormsImportParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiAdminFormsImport401 = {
  message?: string;
};

export type PostApiAdminFormsImportBody = {
  file?: Blob;
};

export type PostApiAdminFormsImport401 = {
  message?: string;
};

export type PostApiAdminFormsImport402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiAdminFormsImportWorkerId401 = {
  message?: string;
};

export type DeleteApiAdminFormsImportWorkerId401 = {
  message?: string;
};

export type DeleteApiAdminFormsImportWorkerId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiAdminFormsImportWorkerIdGenerate401 = {
  message?: string;
};

export type PostApiAdminFormsImportWorkerIdGenerate402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiAdminFormsImportWorkerIdActivate401 = {
  message?: string;
};

export type PostApiAdminFormsImportWorkerIdActivate402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiAdminPortalsParams = {
teamId?: string;
includeDeleted?: boolean;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiAdminPortals401 = {
  message?: string;
};

export type PostApiAdminPortals401 = {
  message?: string;
};

export type PostApiAdminPortals402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiAdminPortalsPaymentsParams = {
teamId?: string;
clientAccountId?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiAdminPortalsPayments401 = {
  message?: string;
};

export type PostApiAdminPortalsPayments401 = {
  message?: string;
};

export type PostApiAdminPortalsPayments402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiAdminPortalusersParams = {
portalId?: string;
includeDeleted?: boolean;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiAdminPortalusers401 = {
  message?: string;
};

export type GetApiAdminRawBlobsParams = {
container?: string;
prefix?: string;
marker?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiAdminRawBlobs401 = {
  message?: string;
};

export type DeleteApiAdminRawBlobsParams = {
name?: string;
container?: string;
};

export type DeleteApiAdminRawBlobs401 = {
  message?: string;
};

export type DeleteApiAdminRawBlobs402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiAdminRawBlobsContentParams = {
name?: string;
container?: string;
download?: boolean;
};

export type GetApiAdminRawBlobsContent401 = {
  message?: string;
};

export type PostApiAdminStripeCheckoutSession401 = {
  message?: string;
};

export type PostApiAdminStripeCheckoutSession402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiAdminStripePortalSession401 = {
  message?: string;
};

export type PostApiAdminStripePortalSession402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiAdminTeamsIdStaffProvision401 = {
  message?: string;
};

export type PostApiAdminTeamsIdStaffProvision402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiAdminTeamsIdMembersUserIdProvisionLogin401 = {
  message?: string;
};

export type PostApiAdminTeamsIdMembersUserIdProvisionLogin402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type DeleteApiAdminTeamsId401 = {
  message?: string;
};

export type DeleteApiAdminTeamsId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiAdminUploadsParams = {
teamId?: string;
purpose?: string;
includeDeleted?: boolean;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiAdminUploads401 = {
  message?: string;
};

export type PostApiAdminUploadsBody = {
  file?: Blob;
  teamId?: string;
  displayName?: string;
  description?: string;
};

export type PostApiAdminUploads401 = {
  message?: string;
};

export type PostApiAdminUploads402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiAdminUploadsUploadIdContentParams = {
download?: boolean;
};

export type GetApiAdminUploadsUploadIdContent401 = {
  message?: string;
};

export type DeleteApiAdminUploadsUploadId401 = {
  message?: string;
};

export type DeleteApiAdminUploadsUploadId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiAdminUploadsUploadIdRestore401 = {
  message?: string;
};

export type PostApiAdminUploadsUploadIdRestore402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type DeleteApiAdminUploadsUploadIdHard401 = {
  message?: string;
};

export type DeleteApiAdminUploadsUploadIdHard402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiAnalyticsSummary401 = {
  message?: string;
};

export type GetApiAuth0ConnectionsParams = {
strategy?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiAuth0Connections401 = {
  message?: string;
};

export type GetApiAuth0Connections402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiAuth0UsersParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
connection?: string;
};

export type GetApiAuth0Users401 = {
  message?: string;
};

export type GetApiAuth0Users402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiAuth0Users401 = {
  message?: string;
};

export type PostApiAuth0Users402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiAuth0UsersWithPresenceParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
target?: string;
};

export type GetApiAuth0UsersWithPresence401 = {
  message?: string;
};

export type GetApiAuth0UsersWithPresence402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiAuth0UsersUserId401 = {
  message?: string;
};

export type GetApiAuth0UsersUserId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiMonitorClarityLiveParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
numOfDays?: number;
};

export type GetApiMonitorClarityLive401 = {
  message?: string;
};

export type GetApiCrmWcClassCodes401 = {
  message?: string;
};

export type GetApiCrmGlClassifications401 = {
  message?: string;
};

export type GetApiCrmClientAccountStatusCodes401 = {
  message?: string;
};

export type GetApiCrmPolicyStatusCodes401 = {
  message?: string;
};

export type GetApiCrmCarriersParams = {
search?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiCrmCarriers401 = {
  message?: string;
};

export type GetApiCrmCarrierCatalogParams = {
search?: string;
includeInactive?: boolean;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiCrmCarrierCatalog401 = {
  message?: string;
};

export type GetApiCrmSubmissionStageCodes401 = {
  message?: string;
};

export type GetApiCrmLobCodes401 = {
  message?: string;
};

export type GetApiCrmLineOfBusinessCodes401 = {
  message?: string;
};

export type GetApiCrmInsuranceTypeCodes401 = {
  message?: string;
};

export type GetApiCrmInsuranceTypeLobs401 = {
  message?: string;
};

export type GetApiCrmInsuranceTypeAcordFormsParams = {
includeInactive?: boolean;
};

export type GetApiCrmInsuranceTypeAcordForms401 = {
  message?: string;
};

export type GetApiCrmInsuranceTypeAppFormsParams = {
includeInactive?: boolean;
};

export type GetApiCrmInsuranceTypeAppForms401 = {
  message?: string;
};

export type GetApiCrmPacketsResolveParams = {
InsuranceTypeCode?: string;
UsageContextCode?: string;
JurisdictionCode?: string;
IncludeInactive?: boolean;
};

export type GetApiCrmPacketsResolve401 = {
  message?: string;
};

export type GetApiCrmInsuranceTypeCoverages401 = {
  message?: string;
};

export type GetApiCrmCoverageUsageContextsParams = {
includeInactive?: boolean;
};

export type GetApiCrmCoverageUsageContexts401 = {
  message?: string;
};

export type GetApiCrmArtifactTypes401 = {
  message?: string;
};

export type GetApiCrmUsageContextArtifactsParams = {
includeInactive?: boolean;
};

export type GetApiCrmUsageContextArtifacts401 = {
  message?: string;
};

export type GetApiCrmUsageContextsParams = {
includeInactive?: boolean;
};

export type GetApiCrmUsageContexts401 = {
  message?: string;
};

export type GetApiCrmLifecycleContextsResolveParams = {
InsuranceTypeCode?: string;
UsageContextCode?: string;
PolicyId?: string;
JurisdictionCode?: string;
IncludeInactive?: boolean;
};

export type GetApiCrmLifecycleContextsResolve401 = {
  message?: string;
};

export type GetApiCrmDataKeyFunctionalGroups401 = {
  message?: string;
};

export type GetApiCrmInsuranceTypeDataKeyRequirementsParams = {
includeInactive?: boolean;
};

export type GetApiCrmInsuranceTypeDataKeyRequirements401 = {
  message?: string;
};

export type GetApiCrmSubmissionDocumentRequirementsParams = {
includeInactive?: boolean;
};

export type GetApiCrmSubmissionDocumentRequirements401 = {
  message?: string;
};

export type GetApiCrmInsuranceTypeDocumentRequirementsParams = {
includeInactive?: boolean;
};

export type GetApiCrmInsuranceTypeDocumentRequirements401 = {
  message?: string;
};

export type GetApiCrmLobDocumentRequirementsParams = {
includeInactive?: boolean;
};

export type GetApiCrmLobDocumentRequirements401 = {
  message?: string;
};

export type GetApiCrmNaicsCodesParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiCrmNaicsCodes401 = {
  message?: string;
};

export type GetApiCrmSicCodesParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiCrmSicCodes401 = {
  message?: string;
};

export type GetApiCrmNaicCarriersParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
search?: string;
};

export type GetApiCrmNaicCarriers401 = {
  message?: string;
};

export type GetApiCrmQuoteStatusCodes401 = {
  message?: string;
};

export type GetApiCrmCertificateTypes401 = {
  message?: string;
};

export type GetApiCrmEndorsementTypes401 = {
  message?: string;
};

export type GetApiCrmCensusCountyBusinessPatternsParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
year?: number;
stateFips?: string;
countyFips?: string;
naicsCode?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiCrmCensusCountyBusinessPatterns401 = {
  message?: string;
};

export type GetApiCrmCensusZipBusinessPatternsParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
year?: number;
zipCode?: string;
stateAbbr?: string;
naicsCode?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiCrmCensusZipBusinessPatterns401 = {
  message?: string;
};

export type GetApiCrmCensusBdsTimeseriesParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
year?: number;
naicsCode?: string;
ageLabel?: string;
geoName?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiCrmCensusBdsTimeseries401 = {
  message?: string;
};

export type GetApiCrmCensusSusbParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
year?: number;
stateFips?: string;
naicsCode?: string;
enterpriseSizeCode?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiCrmCensusSusb401 = {
  message?: string;
};

export type GetApiCrmCountryCodes401 = {
  message?: string;
};

export type GetApiCrmStateProvinceCodesParams = {
countryCode?: string;
};

export type GetApiCrmStateProvinceCodes401 = {
  message?: string;
};

export type GetApiCrmCurrencyCodes401 = {
  message?: string;
};

export type GetApiCrmCoverageLibraryParams = {
includeInactive?: boolean;
};

export type GetApiCrmCoverageLibrary401 = {
  message?: string;
};

export type GetApiCrmCoverageTypes401 = {
  message?: string;
};

export type GetApiCrmOpportunityTypeCodes401 = {
  message?: string;
};

export type GetApiCrmOpportunityStageCodes401 = {
  message?: string;
};

export type GetApiTeamsTeamIdCrmPartiesPartyIdDocuments401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmPartiesPartyIdDocumentsBody = {
  file?: IFormFile;
} & {
  FileName?: string;
  Description?: string;
  LinkType?: string;
  Notes?: string;
};

export type PostApiTeamsTeamIdCrmPartiesPartyIdDocuments401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmPartiesPartyIdDocuments402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdCrmPartiesPartyIdDocumentsAttach401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmPartiesPartyIdDocumentsAttach402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmPoliciesPolicyIdDocuments401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsBody = {
  file?: IFormFile;
} & {
  FileName?: string;
  Description?: string;
  LinkType?: string;
  Notes?: string;
};

export type PostApiTeamsTeamIdCrmPoliciesPolicyIdDocuments401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmPoliciesPolicyIdDocuments402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmSubmissionsSubmissionIdDocuments401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsBody = {
  file?: IFormFile;
} & {
  FileName?: string;
  Description?: string;
  LinkType?: string;
  Notes?: string;
};

export type PostApiTeamsTeamIdCrmSubmissionsSubmissionIdDocuments401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmSubmissionsSubmissionIdDocuments402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsAttach401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsAttach402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsAttach401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsAttach402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdCrmClientAccountsClientAccountIdPolicyDocumentImportsBody = {
  file?: IFormFile;
};

export type PostApiTeamsTeamIdCrmClientAccountsClientAccountIdPolicyDocumentImports401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmClientAccountsClientAccountIdPolicyDocumentImports402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmClientAccountsClientAccountIdPolicyDocumentImports401 = {
  message?: string;
};

export type GetApiTeamsTeamIdCrmPolicyDocumentImportsPolicyDocumentImportRunId401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmPolicyDocumentImportsPolicyDocumentImportRunIdApprove401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmPolicyDocumentImportsPolicyDocumentImportRunIdApprove402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiUsersMe401 = {
  message?: string;
};

export type PutApiUsersMe401 = {
  message?: string;
};

export type GetApiUsersMeSettings401 = {
  message?: string;
};

export type PutApiUsersMeSettings401 = {
  message?: string;
};

export type GetApiUsersMePerformance401 = {
  message?: string;
};

export type PostApiUsersMeCompleteDemo401 = {
  message?: string;
};

export type GetApiDashboardStats401 = {
  message?: string;
};

export type GetApiDirectoryUserUsersParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
top?: number;
filter?: string;
search?: string;
accountEnabled?: boolean;
};

export type GetApiDirectoryUserUsers401 = {
  message?: string;
};

export type GetApiDirectoryUserUsers402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiDirectoryUserUsers401 = {
  message?: string;
};

export type PostApiDirectoryUserUsers402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiDirectoryUserUsersUserId401 = {
  message?: string;
};

export type GetApiDirectoryUserUsersUserId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PutApiDirectoryUserUsersUserId401 = {
  message?: string;
};

export type PutApiDirectoryUserUsersUserId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type DeleteApiDirectoryUserUsersUserId401 = {
  message?: string;
};

export type DeleteApiDirectoryUserUsersUserId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiDirectoryUserInvitations401 = {
  message?: string;
};

export type PostApiDirectoryUserInvitations402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiDirectoryUserStats401 = {
  message?: string;
};

export type GetApiDirectoryUserStats402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiDirectoryUserInvitationsB2b401 = {
  message?: string;
};

export type PostApiDirectoryUserInvitationsB2b402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdEdgeEnrollments401 = {
  message?: string;
};

export type PostApiTeamsTeamIdEdgeEnrollments402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdEdgeClients401 = {
  message?: string;
};

export type PostApiTeamsTeamIdEdgeClientsEdgeClientIdRevoke401 = {
  message?: string;
};

export type PostApiTeamsTeamIdEdgeClientsEdgeClientIdRevoke402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdEdgeWorkItems401 = {
  message?: string;
};

export type PostApiTeamsTeamIdEdgeWorkItems402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdEdgeWorkItemsParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
take?: number;
};

export type GetApiTeamsTeamIdEdgeWorkItems401 = {
  message?: string;
};

export type GetApiTeamsTeamIdEdgeWorkItemsWorkerId401 = {
  message?: string;
};

export type PostApiTeamsTeamIdEdgeWorkItemsWorkerIdDecision401 = {
  message?: string;
};

export type PostApiTeamsTeamIdEdgeWorkItemsWorkerIdDecision402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdEdgeWorkItemsWorkerIdCommit401 = {
  message?: string;
};

export type PostApiTeamsTeamIdEdgeWorkItemsWorkerIdCommit402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdEdgeWorkItemsWorkerIdCancel401 = {
  message?: string;
};

export type PostApiTeamsTeamIdEdgeWorkItemsWorkerIdCancel402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiEdgeWorkWorkerIdArtifactsBody = {
  claimToken: string;
  evidenceKey: string;
  file: Blob;
};

export type GetApiTeamsTeamIdEdgeWorkItemsWorkerIdArtifacts401 = {
  message?: string;
};

export type GetApiTeamsTeamIdEdgeWorkItemsWorkerIdInterventions401 = {
  message?: string;
};

export type PostApiEmailVerify401 = {
  message?: string;
};

export type PostApiFormsFormIdVersionsFormVersionIdGenerate401 = {
  message?: string;
};

export type PostApiFormsFormIdVersionsFormVersionIdGenerate402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiFormsFormVersionIdEffective401 = {
  message?: string;
};

export type GetApiFormsFormIdVersionsVersionEffective401 = {
  message?: string;
};

export type GetApiFormsFormVersionIdViewer401 = {
  message?: string;
};

export type GetApiFormsFormVersionIdPdfContentParams = {
type?: string;
download?: boolean;
};

export type GetApiFormsFormVersionIdPdfContent401 = {
  message?: string;
};

export type PostApiFormsFormVersionIdPdfLayout401 = {
  message?: string;
};

export type PostApiFormsFormVersionIdPdfLayout402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiFormsFormVersionIdPdfLayout401 = {
  message?: string;
};

export type GetApiFormsFormVersionId401 = {
  message?: string;
};

export type GetApiFormsFormVersionIdYaml401 = {
  message?: string;
};

export type GetApiFormsFormVersionIdMeta401 = {
  message?: string;
};

export type GetApiFormsFormVersionIdPdfMappingkeyTokens401 = {
  message?: string;
};

export type GetApiFormsFormVersionIdPdfMappingkey401 = {
  message?: string;
};

export type GetApiFormsFormVersionIdPdfAcroControls401 = {
  message?: string;
};

export type GetApiHealthDb401 = {
  message?: string;
};

export type GetApiHealthGraph401 = {
  message?: string;
};

export type GetApiHealthAuth401 = {
  message?: string;
};

export type GetApiHealthAzureopenai401 = {
  message?: string;
};

export type GetApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunner401 = {
  message?: string;
};

export type PatchApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerAnswers401 = {
  message?: string;
};

export type PatchApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerAnswers402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerProposedValues401 = {
  message?: string;
};

export type GetApiIntakesInvitesTokenPdfContentParams = {
type?: string;
download?: boolean;
};

export type GetApiIntakesInvitesTokenFormsFormSubmissionIdPdfContentParams = {
type?: string;
download?: boolean;
};

export type PostApiIntakesInvitesTokenDocumentsBodyRequest = {
  /** @nullable */
  fileName?: string | null;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  linkType?: string | null;
  /** @nullable */
  notes?: string | null;
};

export type PostApiIntakesInvitesTokenDocumentsBody = {
  file?: Blob;
  request: PostApiIntakesInvitesTokenDocumentsBodyRequest;
};

export type GetApiWorkersWorkerId401 = {
  message?: string;
};

export type GetApiWorkersWorkerIdEventsParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
take?: number;
};

export type GetApiWorkersWorkerIdEvents401 = {
  message?: string;
};

export type PostApiWorkersWorkerIdCancel401 = {
  message?: string;
};

export type PostApiWorkersWorkerIdCancel402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiWorkersEventsParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
afterEventId?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
take?: number;
teamId?: string;
workerId?: string;
};

export type GetApiWorkersEvents401 = {
  message?: string;
};

export type GetApiWorkersRecentParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
take?: number;
teamId?: string;
};

export type GetApiWorkersRecent401 = {
  message?: string;
};

export type GetApiSseWorkersParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
afterEventId?: number;
teamId?: string;
workerId?: string;
};

export type GetApiSseWorkers401 = {
  message?: string;
};

export type GetApiTeamsTeamIdMessagingSmsActivityParams = {
clientAccountId?: string;
submissionId?: string;
policyId?: string;
intakeRunId?: string;
status?: string;
direction?: string;
fromUtc?: string;
toUtc?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
take?: number;
};

export type GetApiTeamsTeamIdMessagingSmsActivity401 = {
  message?: string;
};

export type GetApiTeamsTeamIdMessagingEsignActivityParams = {
clientAccountId?: string;
submissionId?: string;
quoteId?: string;
status?: string;
fromUtc?: string;
toUtc?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
take?: number;
};

export type GetApiTeamsTeamIdMessagingEsignActivity401 = {
  message?: string;
};

export type GetApiTeamsTeamIdMessagingSubmissionsSubmissionIdMarketsAttentionParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
take?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
lookbackDays?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
noResponseBusinessDays?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
infoRequestFollowUpBusinessDays?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
quoteDeadlineWithinDays?: number;
};

export type GetApiTeamsTeamIdMessagingSubmissionsSubmissionIdMarketsAttention401 = {
  message?: string;
};

export type GetApiTeamsTeamIdMessagingInboundEmailInboundEmailIdAnalysis401 = {
  message?: string;
};

export type PostApiTeamsTeamIdMessagingInboundEmailInboundEmailIdApply401 = {
  message?: string;
};

export type PostApiTeamsTeamIdMessagingInboundEmailInboundEmailIdApply402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdMessagingSubmissionsSubmissionIdMarketsSubmissionMarketIdTimelineParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
take?: number;
};

export type GetApiTeamsTeamIdMessagingSubmissionsSubmissionIdMarketsSubmissionMarketIdTimeline401 = {
  message?: string;
};

export type GetApiTeamsTeamIdMessagingSubmissionsSubmissionIdInboundEmailUnmatchedParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
take?: number;
};

export type GetApiTeamsTeamIdMessagingSubmissionsSubmissionIdInboundEmailUnmatched401 = {
  message?: string;
};

export type GetApiTeamsTeamIdMessagingServicingInboundParams = {
mailboxRole?: string;
inboundType?: string;
status?: string;
clientAccountId?: string;
policyId?: string;
certificateId?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
take?: number;
};

export type GetApiTeamsTeamIdMessagingServicingInbound401 = {
  message?: string;
};

export type PostApiTeamsTeamIdMessagingServicingInboundInboundEmailIdServiceRequest401 = {
  message?: string;
};

export type PostApiTeamsTeamIdMessagingServicingInboundInboundEmailIdServiceRequest402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdMessagingServicingServiceRequestsParams = {
status?: string;
requestType?: string;
urgencyLevel?: string;
assignedToUserId?: string;
clientAccountId?: string;
policyId?: string;
certificateId?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
take?: number;
};

export type GetApiTeamsTeamIdMessagingServicingServiceRequests401 = {
  message?: string;
};

export type GetApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestId401 = {
  message?: string;
};

export type PatchApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestId401 = {
  message?: string;
};

export type PatchApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdCertificateDraft401 = {
  message?: string;
};

export type PostApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdCertificateDraft402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdMessagingInboundEmailInboundEmailIdMapSubmissionMarket401 = {
  message?: string;
};

export type PostApiTeamsTeamIdMessagingInboundEmailInboundEmailIdMapSubmissionMarket402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiMonitorLogsParams = {
app?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
minutes?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
take?: number;
};

export type GetApiMonitorLogs401 = {
  message?: string;
};

export type PostApiPdfWorkers401 = {
  message?: string;
};

export type PostApiPdfWorkers402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiPdfWorkersWorkerId401 = {
  message?: string;
};

export type GetApiPdfWorkersWorkerIdContentParams = {
download?: boolean;
};

export type GetApiPdfWorkersWorkerIdContent401 = {
  message?: string;
};

export type GetApiPdfWorkersWorkerIdEvents401 = {
  message?: string;
};

export type PostApiPhoneValidate401 = {
  message?: string;
};

export type PostApiPhoneLookup401 = {
  message?: string;
};

export type GetApiPlacesAutocompleteParams = {
input?: string;
sessionToken?: string;
};

export type GetApiPlacesAutocomplete401 = {
  message?: string;
};

export type GetApiPlacesDetailsParams = {
placeId?: string;
sessionToken?: string;
};

export type GetApiPlacesDetails401 = {
  message?: string;
};

export type GetApiMonitorPosthogSummary401 = {
  message?: string;
};

export type GetApiPublicPortalsResolveParams = {
key?: string;
};

export type PostApiStripeWebhookReplay401 = {
  message?: string;
};

export type PostApiStripeWebhookReplay402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiSupportBody = {
  issueType?: string;
  priority?: string;
  message?: string;
  attachments?: Blob[];
};

export type PostApiSupport401 = {
  message?: string;
};

export type GetApiTeamsTeamIdIntegrationsAccountingQuickbooks401 = {
  message?: string;
};

export type PostApiTeamsTeamIdIntegrationsAccountingQuickbooksConnectStart401 = {
  message?: string;
};

export type PostApiTeamsTeamIdIntegrationsAccountingQuickbooksConnectStart402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdIntegrationsAccountingQuickbooksDisconnect401 = {
  message?: string;
};

export type PostApiTeamsTeamIdIntegrationsAccountingQuickbooksDisconnect402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdIntegrationsAccountingQuickbooksSyncRunsParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
take?: number;
};

export type GetApiTeamsTeamIdIntegrationsAccountingQuickbooksSyncRuns401 = {
  message?: string;
};

export type PostApiTeamsTeamIdIntegrationsAccountingQuickbooksSyncRun401 = {
  message?: string;
};

export type PostApiTeamsTeamIdIntegrationsAccountingQuickbooksSyncRun402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdIntegrationsAccountingQuickbooksCallbackParams = {
code?: string;
state?: string;
realmId?: string;
error?: string;
error_description?: string;
};

export type GetApiTeamsTeamIdAgentEpisodesParams = {
includeSuppressed?: boolean;
};

export type GetApiTeamsTeamIdAgentEpisodes401 = {
  message?: string;
};

export type PostApiTeamsTeamIdAgentEpisodesDeriveRunId401 = {
  message?: string;
};

export type PostApiTeamsTeamIdAgentEpisodesDeriveRunId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdAgentEpisodesEpisodeIdSuppress401 = {
  message?: string;
};

export type PostApiTeamsTeamIdAgentEpisodesEpisodeIdSuppress402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdAgentMemoriesChainParams = {
key?: string;
};

export type GetApiTeamsTeamIdAgentMemoriesChain401 = {
  message?: string;
};

export type PutApiTeamsTeamIdAgentMemoriesKey401 = {
  message?: string;
};

export type PutApiTeamsTeamIdAgentMemoriesKey402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type DeleteApiTeamsTeamIdAgentMemoriesKey401 = {
  message?: string;
};

export type DeleteApiTeamsTeamIdAgentMemoriesKey402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdAgentProcedures401 = {
  message?: string;
};

export type GetApiTeamsTeamIdAgentProceduresName401 = {
  message?: string;
};

export type PostApiTeamsTeamIdAgentProceduresNameVersions401 = {
  message?: string;
};

export type PostApiTeamsTeamIdAgentProceduresNameVersions402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdAgentProceduresNameVersionsVersionIdActivate401 = {
  message?: string;
};

export type PostApiTeamsTeamIdAgentProceduresNameVersionsVersionIdActivate402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdAgentThreads401 = {
  message?: string;
};

export type PostApiTeamsTeamIdAgentThreads402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdAgentThreads401 = {
  message?: string;
};

export type GetApiTeamsTeamIdAgentThreadsThreadId401 = {
  message?: string;
};

export type PostApiTeamsTeamIdAgentsBrowserReadRuns402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdAgentsBrowserReadRunsRunId401 = {
  message?: string;
};

export type PostApiTeamsTeamIdAgentsBrowserReadRunsRunIdCheckpointsEdgeResultResume401 = {
  message?: string;
};

export type GetApiTeamsTeamIdClients401 = {
  message?: string;
};

export type GetApiTeamsTeamIdClientsPartyId401 = {
  message?: string;
};

export type GetApiTeamsTeamIdCrmClientAccountsParams = {
search?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiTeamsTeamIdCrmClientAccounts401 = {
  message?: string;
};

export type GetApiTeamsTeamIdCrmProspectsParams = {
search?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiTeamsTeamIdCrmProspects401 = {
  message?: string;
};

export type GetApiTeamsTeamIdCrmCarriersParams = {
search?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiTeamsTeamIdCrmCarriers401 = {
  message?: string;
};

export type GetApiTeamsTeamIdCrmCarrierCatalogParams = {
search?: string;
includeInactive?: boolean;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiTeamsTeamIdCrmCarrierCatalog401 = {
  message?: string;
};

export type GetApiTeamsTeamIdCrmInsuranceTypeCodes401 = {
  message?: string;
};

export type GetApiTeamsTeamIdCrmLifecycleContextsResolveParams = {
InsuranceTypeCode?: string;
UsageContextCode?: string;
PolicyId?: string;
JurisdictionCode?: string;
IncludeInactive?: boolean;
};

export type GetApiTeamsTeamIdCrmLifecycleContextsResolve401 = {
  message?: string;
};

export type GetApiTeamsTeamIdCrmPoliciesParams = {
clientAccountId?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiTeamsTeamIdCrmPolicies401 = {
  message?: string;
};

export type GetApiTeamsTeamIdCrmPoliciesRenewalsParams = {
windowStart?: string;
windowEnd?: string;
search?: string;
renewalStatus?: string;
assignedToUserId?: string;
lobCode?: string;
timing?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiTeamsTeamIdCrmPoliciesRenewals401 = {
  message?: string;
};

export type GetApiTeamsTeamIdCrmPoliciesSummaryParams = {
clientAccountIds?: string;
};

export type GetApiTeamsTeamIdCrmPoliciesSummary401 = {
  message?: string;
};

export type GetApiTeamsTeamIdCrmSubmissionsParams = {
clientAccountId?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiTeamsTeamIdCrmSubmissions401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmSubmissions401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmSubmissions402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmSubmissionsAggregateParams = {
clientAccountId?: string;
search?: string;
stage?: string;
activeState?: string;
includeReadiness?: boolean;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiTeamsTeamIdCrmSubmissionsAggregate401 = {
  message?: string;
};

export type GetApiTeamsTeamIdCrmSubmissionsPipelineParams = {
clientAccountId?: string;
search?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
limitPerColumn?: number;
};

export type GetApiTeamsTeamIdCrmSubmissionsPipeline401 = {
  message?: string;
};

export type GetApiTeamsTeamIdCrmSubmissionsReadinessAggregateParams = {
clientAccountId?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
includeChecklist?: boolean;
};

export type GetApiTeamsTeamIdCrmSubmissionsReadinessAggregate401 = {
  message?: string;
};

export type GetApiTeamsTeamIdCrmOpportunitiesOpportunityIdQuoteComparison401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmOpportunitiesOpportunityIdQuoteOptions401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmOpportunitiesOpportunityIdQuoteOptions402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PutApiTeamsTeamIdCrmQuoteOptionsQuoteOptionId401 = {
  message?: string;
};

export type PutApiTeamsTeamIdCrmQuoteOptionsQuoteOptionId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type DeleteApiTeamsTeamIdCrmQuoteOptionsQuoteOptionId401 = {
  message?: string;
};

export type DeleteApiTeamsTeamIdCrmQuoteOptionsQuoteOptionId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdBind401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdBind402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmQuotesQuoteIdCoverages401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmQuotesQuoteIdCoverages401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmQuotesQuoteIdCoverages402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PutApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageId401 = {
  message?: string;
};

export type PutApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdLimits401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdLimits402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PutApiTeamsTeamIdCrmQuoteCoverageLimitsQuoteCoverageLimitId401 = {
  message?: string;
};

export type PutApiTeamsTeamIdCrmQuoteCoverageLimitsQuoteCoverageLimitId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdDeductibles401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdDeductibles402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PutApiTeamsTeamIdCrmQuoteCoverageDeductiblesQuoteCoverageDeductibleId401 = {
  message?: string;
};

export type PutApiTeamsTeamIdCrmQuoteCoverageDeductiblesQuoteCoverageDeductibleId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmSubmissionsSubmissionId401 = {
  message?: string;
};

export type GetApiTeamsTeamIdCrmSubmissionsSubmissionIdChangeLogParams = {
table?: string;
action?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiTeamsTeamIdCrmSubmissionsSubmissionIdChangeLog401 = {
  message?: string;
};

export type PutApiTeamsTeamIdCrmSubmissionsSubmissionIdSetup401 = {
  message?: string;
};

export type PutApiTeamsTeamIdCrmSubmissionsSubmissionIdSetup402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PutApiTeamsTeamIdCrmSubmissionsSubmissionIdAssignee401 = {
  message?: string;
};

export type PutApiTeamsTeamIdCrmSubmissionsSubmissionIdAssignee402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdCrmSubmissionsSubmissionIdClose401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmSubmissionsSubmissionIdClose402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmSubmissionsSubmissionIdSourcePolicyOptions401 = {
  message?: string;
};

export type GetApiTeamsTeamIdCrmSubmissionsSubmissionIdTags401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmSubmissionsSubmissionIdTags401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmSubmissionsSubmissionIdTags402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type DeleteApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsTagCode401 = {
  message?: string;
};

export type DeleteApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsTagCode402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmSubmissionsSubmissionIdMarkets401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmSubmissionsSubmissionIdMarkets401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmSubmissionsSubmissionIdMarkets402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PutApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketId401 = {
  message?: string;
};

export type PutApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmSubmissionsSubmissionIdQuotesParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiTeamsTeamIdCrmSubmissionsSubmissionIdQuotes401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmSubmissionsSubmissionIdQuotes401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmSubmissionsSubmissionIdQuotes402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmSubmissionsSubmissionIdQuoteWorkbenchParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiTeamsTeamIdCrmSubmissionsSubmissionIdQuoteWorkbench401 = {
  message?: string;
};

export type PutApiTeamsTeamIdCrmQuotesQuoteId401 = {
  message?: string;
};

export type PutApiTeamsTeamIdCrmQuotesQuoteId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmSubmissionsSubmissionIdQuoteSelectionRequests401 = {
  message?: string;
};

export type GetApiTeamsTeamIdCrmQuotesQuoteIdSelectionRequestSetup401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmQuotesQuoteIdSelectionRequests401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmQuotesQuoteIdSelectionRequests402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdCrmQuotesQuoteIdEsignRefresh401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmQuotesQuoteIdEsignRefresh402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdCrmQuotesQuoteIdEsignSend401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmQuotesQuoteIdEsignSend402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdCrmQuotesQuoteIdBind401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmQuotesQuoteIdBind402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendReadinessParams = {
method?: string;
};

export type GetApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendReadiness401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdPrepare401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdPrepare402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSend401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSend402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendEmail401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendEmail402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdDecline401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdDecline402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdEventsParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
take?: number;
};

export type GetApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdEvents401 = {
  message?: string;
};

export type GetApiTeamsTeamIdCrmSubmissionsSubmissionIdApplicationReadiness401 = {
  message?: string;
};

export type GetApiTeamsTeamIdCrmSubmissionsSubmissionIdRequiredData401 = {
  message?: string;
};

export type PutApiTeamsTeamIdCrmSubmissionsSubmissionIdRequiredData401 = {
  message?: string;
};

export type PutApiTeamsTeamIdCrmSubmissionsSubmissionIdRequiredData402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehicles401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehicles401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehicles402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PatchApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesDraftId401 = {
  message?: string;
};

export type PatchApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesDraftId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type DeleteApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesDraftId401 = {
  message?: string;
};

export type DeleteApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesDraftId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDrivers401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDrivers401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDrivers402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PatchApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversDraftId401 = {
  message?: string;
};

export type PatchApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversDraftId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type DeleteApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversDraftId401 = {
  message?: string;
};

export type DeleteApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversDraftId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoFinalizeSchedules401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoFinalizeSchedules402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDrafts401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDrafts401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDrafts402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PatchApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsDraftId401 = {
  message?: string;
};

export type PatchApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsDraftId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type DeleteApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsDraftId401 = {
  message?: string;
};

export type DeleteApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsDraftId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmSubmissionsSubmissionIdDetailContext401 = {
  message?: string;
};

export type GetApiTeamsTeamIdCrmPartiesParams = {
search?: string;
roleCode?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiTeamsTeamIdCrmParties401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmParties401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmParties402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmPartiesPartyId401 = {
  message?: string;
};

export type PutApiTeamsTeamIdCrmPartiesPartyId401 = {
  message?: string;
};

export type PutApiTeamsTeamIdCrmPartiesPartyId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmPartiesPartyIdRoles401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmPartiesPartyIdRoles401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmPartiesPartyIdRoles402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmPartiesPartyIdComm401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmPartiesPartyIdComm401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmPartiesPartyIdComm402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmPartiesPartyIdAddresses401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmPartiesPartyIdAddresses401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmPartiesPartyIdAddresses402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmPartiesPartyIdAccounts401 = {
  message?: string;
};

export type GetApiTeamsTeamIdCrmClientAccountsClientAccountIdContacts401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmClientAccountsClientAccountIdContacts401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmClientAccountsClientAccountIdContacts402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmClientAccountsClientAccountIdChangeLogParams = {
table?: string;
action?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiTeamsTeamIdCrmClientAccountsClientAccountIdChangeLog401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmClientAccountsClientAccountIdStatus401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmClientAccountsClientAccountIdStatus402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdCrmClientAccountsClientAccountIdOwner401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmClientAccountsClientAccountIdOwner402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdCrmContactsImportSingle401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmContactsImportSingle402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type DeleteApiTeamsTeamIdCrmPartiesPartyIdRolesRoleCode401 = {
  message?: string;
};

export type DeleteApiTeamsTeamIdCrmPartiesPartyIdRolesRoleCode402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PutApiTeamsTeamIdCrmPartiesPartyIdCommId401 = {
  message?: string;
};

export type PutApiTeamsTeamIdCrmPartiesPartyIdCommId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type DeleteApiTeamsTeamIdCrmPartiesPartyIdCommId401 = {
  message?: string;
};

export type DeleteApiTeamsTeamIdCrmPartiesPartyIdCommId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PutApiTeamsTeamIdCrmPartiesPartyIdAddressesAddressId401 = {
  message?: string;
};

export type PutApiTeamsTeamIdCrmPartiesPartyIdAddressesAddressId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type DeleteApiTeamsTeamIdCrmPartiesPartyIdAddressesAddressId401 = {
  message?: string;
};

export type DeleteApiTeamsTeamIdCrmPartiesPartyIdAddressesAddressId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsContactPartyIdRoleLabelPrimary401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsContactPartyIdRoleLabelPrimary402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type DeleteApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsContactPartyIdRoleLabel401 = {
  message?: string;
};

export type DeleteApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsContactPartyIdRoleLabel402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmPoliciesPolicyIdTermsParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiTeamsTeamIdCrmPoliciesPolicyIdTerms401 = {
  message?: string;
};

export type GetApiTeamsTeamIdCrmPoliciesPolicyIdCurrentTerm401 = {
  message?: string;
};

export type GetApiTeamsTeamIdCrmPoliciesPolicyIdChangeLogParams = {
table?: string;
action?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiTeamsTeamIdCrmPoliciesPolicyIdChangeLog401 = {
  message?: string;
};

export type GetApiTeamsTeamIdCrmPoliciesPolicyIdTransactionsParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiTeamsTeamIdCrmPoliciesPolicyIdTransactions401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmPoliciesPolicyIdTransactions401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmPoliciesPolicyIdTransactions402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmPoliciesPolicyIdParticipants401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmPoliciesPolicyIdParticipants401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmPoliciesPolicyIdParticipants402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type DeleteApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsPolicyParticipantId401 = {
  message?: string;
};

export type DeleteApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsPolicyParticipantId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmPoliciesPolicyIdCoverages401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmPoliciesPolicyIdCoverages401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmPoliciesPolicyIdCoverages402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PutApiTeamsTeamIdCrmCoveragesPolicyCoverageId401 = {
  message?: string;
};

export type PutApiTeamsTeamIdCrmCoveragesPolicyCoverageId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdCrmCoveragesPolicyCoverageIdLimits401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmCoveragesPolicyCoverageIdLimits402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PutApiTeamsTeamIdCrmLimitsPolicyCoverageLimitId401 = {
  message?: string;
};

export type PutApiTeamsTeamIdCrmLimitsPolicyCoverageLimitId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdCrmCoveragesPolicyCoverageIdDeductibles401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmCoveragesPolicyCoverageIdDeductibles402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PutApiTeamsTeamIdCrmDeductiblesPolicyCoverageDeductibleId401 = {
  message?: string;
};

export type PutApiTeamsTeamIdCrmDeductiblesPolicyCoverageDeductibleId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmPoliciesPolicyIdForms401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmPoliciesPolicyIdForms401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmPoliciesPolicyIdForms402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsParams = {
policyTermId?: string;
};

export type GetApiTeamsTeamIdCrmPoliciesPolicyIdPremiums401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmPoliciesPolicyIdPremiums401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmPoliciesPolicyIdPremiums402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PutApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsPolicyPremiumId401 = {
  message?: string;
};

export type PutApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsPolicyPremiumId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmPoliciesPolicyIdLocations401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmPoliciesPolicyIdLocations401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmPoliciesPolicyIdLocations402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmPoliciesPolicyIdEndorsementsParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiTeamsTeamIdCrmPoliciesPolicyIdEndorsements401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmPoliciesPolicyIdEndorsements401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmPoliciesPolicyIdEndorsements402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmPoliciesPolicyIdCertificatesParams = {
holderPartyId?: string;
statusCode?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiTeamsTeamIdCrmPoliciesPolicyIdCertificates401 = {
  message?: string;
};

export type GetApiTeamsTeamIdCrmPoliciesPolicyIdCertificatesReadinessParams = {
holderPartyId?: string;
certificateTypeCode?: string;
};

export type GetApiTeamsTeamIdCrmPoliciesPolicyIdCertificatesReadiness401 = {
  message?: string;
};

export type GetApiTeamsTeamIdCrmCertificatesCertificateId401 = {
  message?: string;
};

export type PutApiTeamsTeamIdCrmCertificatesCertificateId401 = {
  message?: string;
};

export type PutApiTeamsTeamIdCrmCertificatesCertificateId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmCertificatesCertificateIdDownloadParams = {
download?: boolean;
};

export type GetApiTeamsTeamIdCrmCertificatesCertificateIdDownload401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmPoliciesPolicyIdStatus401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmPoliciesPolicyIdStatus402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdCrmPoliciesPolicyIdCancel401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmPoliciesPolicyIdCancel402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdCrmPoliciesPolicyIdReinstate401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmPoliciesPolicyIdReinstate402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PutApiTeamsTeamIdCrmPolicyTermsPolicyTermIdRenewalWork401 = {
  message?: string;
};

export type PutApiTeamsTeamIdCrmPolicyTermsPolicyTermIdRenewalWork402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdCrmPoliciesPolicyIdRenewalSubmission401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmPoliciesPolicyIdRenewalSubmission402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdCrmPoliciesPolicyIdRemarketSubmission401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmPoliciesPolicyIdRemarketSubmission402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdCrmCertificates401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmCertificates402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdCrmCertificatesCertificateIdIssue401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmCertificatesCertificateIdIssue402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdCrmCertificatesCertificateIdOutputRender401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmCertificatesCertificateIdOutputRender402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmCertificatesCertificateIdOutputRender401 = {
  message?: string;
};

export type GetApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderContentParams = {
download?: boolean;
};

export type GetApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderContent401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmCertificatesCertificateIdDeliver401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmCertificatesCertificateIdDeliver402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdCrmCertificatesCertificateIdVoid401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmCertificatesCertificateIdVoid402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmGlExposuresParams = {
policyId?: string;
locationId?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiTeamsTeamIdCrmGlExposures401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmGlExposures401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmGlExposures402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmAdditionalInterestsParams = {
policyId?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiTeamsTeamIdCrmAdditionalInterests401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmAdditionalInterests401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmAdditionalInterests402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdCrmPoliciesPolicyIdAdditionalInterests401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmPoliciesPolicyIdAdditionalInterests402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type DeleteApiTeamsTeamIdCrmPoliciesPolicyIdAdditionalInterestsAdditionalInterestId401 = {
  message?: string;
};

export type DeleteApiTeamsTeamIdCrmPoliciesPolicyIdAdditionalInterestsAdditionalInterestId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmUmbrellaUnderlyingParams = {
umbrellaPolicyId?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiTeamsTeamIdCrmUmbrellaUnderlying401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmUmbrellaUnderlying401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmUmbrellaUnderlying402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmUmbrellaUnderlyingId401 = {
  message?: string;
};

export type GetApiTeamsTeamIdCrmVehiclesParams = {
clientAccountId?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiTeamsTeamIdCrmVehicles401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmVehicles401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmVehicles402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmDriversParams = {
clientAccountId?: string;
name?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiTeamsTeamIdCrmDrivers401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmDrivers401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmDrivers402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmLossesParams = {
clientAccountId?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiTeamsTeamIdCrmLosses401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmLosses401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmLosses402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmPriorCarriersParams = {
clientAccountId?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiTeamsTeamIdCrmPriorCarriers401 = {
  message?: string;
};

export type GetApiTeamsTeamIdCrmWcExperienceParams = {
clientAccountId?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiTeamsTeamIdCrmWcExperience401 = {
  message?: string;
};

export type GetApiTeamsTeamIdCrmLocationsParams = {
clientAccountId?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiTeamsTeamIdCrmLocations401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmLocations401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmLocations402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmLocationsLocationId401 = {
  message?: string;
};

export type GetApiTeamsTeamIdCrmBuildingsParams = {
locationId?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiTeamsTeamIdCrmBuildings401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmBuildings401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmBuildings402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmBuildingsBuildingId401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsStart401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsStart402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsStartFromInsuranceModel401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsStartFromInsuranceModel402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsParams = {
includeInactive?: boolean;
};

export type GetApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackets401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsApplyDatakeys401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsApplyDatakeys402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsApplySchedules401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsApplySchedules402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsFormSubmissionIdRunner401 = {
  message?: string;
};

export type PatchApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsFormSubmissionIdRunnerAnswers401 = {
  message?: string;
};

export type PatchApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsFormSubmissionIdRunnerAnswers402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdDocumentsChecklist401 = {
  message?: string;
};

export type GetApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleReadiness401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleRenderWorkers401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleRenderWorkers402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundle401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundle402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdDashboardHome401 = {
  message?: string;
};

export type PostApiTeamsTeamIdAgentsEdgeEchoRuns402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdFormsParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiTeamsTeamIdForms401 = {
  message?: string;
};

export type GetApiTeamsTeamIdFormVersionsParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiTeamsTeamIdFormVersions401 = {
  message?: string;
};

export type GetApiTeamsTeamIdFormsVersionsParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
search?: string;
sortBy?: string;
sortDirection?: string;
};

export type GetApiTeamsTeamIdFormsVersions401 = {
  message?: string;
};

export type GetApiTeamsTeamIdFormsAvailableVersionsParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
search?: string;
sortBy?: string;
sortDirection?: string;
source?: string;
lobCode?: string;
};

export type GetApiTeamsTeamIdFormsAvailableVersions401 = {
  message?: string;
};

export type GetApiTeamsTeamIdFormsSummaryParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiTeamsTeamIdFormsSummary401 = {
  message?: string;
};

export type GetApiTeamsTeamIdFormsFormIdVersionsFormVersionIdPdfParams = {
type?: string;
download?: boolean;
};

export type GetApiTeamsTeamIdFormsFormIdVersionsFormVersionIdPdf401 = {
  message?: string;
};

export type GetApiTeamsTeamIdFormsFormIdVersions401 = {
  message?: string;
};

export type GetApiTeamsTeamIdFormsFormIdVersionsFormVersionIdEffective401 = {
  message?: string;
};

export type GetApiTeamsTeamIdFormVersionsFormVersionIdEffective401 = {
  message?: string;
};

export type GetApiTeamsTeamIdFormsFormIdVersionsFormVersionIdSlotsParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiTeamsTeamIdFormsFormIdVersionsFormVersionIdSlots401 = {
  message?: string;
};

export type GetApiTeamsTeamIdFormsFormIdVersionsFormVersionIdSections401 = {
  message?: string;
};

export type GetApiTeamsTeamIdFormsFormIdVersionsFormVersionIdYaml401 = {
  message?: string;
};

export type GetApiTeamsTeamIdFormVersionsFormVersionIdMeta401 = {
  message?: string;
};

export type GetApiTeamsTeamIdGenaBookContextParams = {
query?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
limit?: number;
taskTypes?: string[];
};

export type GetApiTeamsTeamIdGenaBookContext401 = {
  message?: string;
};

export type GetApiTeamsTeamIdInsuranceModelInsuranceTypeActivations401 = {
  message?: string;
};

export type PutApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCode401 = {
  message?: string;
};

export type PutApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCode402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type DeleteApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCode401 = {
  message?: string;
};

export type DeleteApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCode402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdInsuranceModelOverview401 = {
  message?: string;
};

export type GetApiTeamsTeamIdIntegrationsEsign401 = {
  message?: string;
};

export type PutApiTeamsTeamIdIntegrationsEsign401 = {
  message?: string;
};

export type PutApiTeamsTeamIdIntegrationsEsign402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdIntegrationsEsignDocusignConnectStart401 = {
  message?: string;
};

export type PostApiTeamsTeamIdIntegrationsEsignDocusignConnectStart402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdIntegrationsEsignDocusignDisconnect401 = {
  message?: string;
};

export type PostApiTeamsTeamIdIntegrationsEsignDocusignDisconnect402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdIntegrationsEsignSend401 = {
  message?: string;
};

export type PostApiTeamsTeamIdIntegrationsEsignSend402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdIntegrationsPaymentsStripe401 = {
  message?: string;
};

export type PostApiTeamsTeamIdIntegrationsPaymentsStripeOnboardingLink401 = {
  message?: string;
};

export type PostApiTeamsTeamIdIntegrationsPaymentsStripeOnboardingLink402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdIntegrationsPaymentsStripeRefresh401 = {
  message?: string;
};

export type PostApiTeamsTeamIdIntegrationsPaymentsStripeRefresh402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdIntegrationsEsignDocusignCallbackParams = {
code?: string;
state?: string;
error?: string;
error_description?: string;
};

export type GetApiTeamsTeamIdAgentsLeadPreparationRunsParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
take?: number;
};

export type PostApiTeamsTeamIdAgentsLeadPreparationRuns402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PatchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposal402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecision402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdLeadsParams = {
statusCode?: string;
assignment?: string;
search?: string;
includeDeleted?: boolean;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiTeamsTeamIdLeads401 = {
  message?: string;
};

export type PostApiTeamsTeamIdLeads401 = {
  message?: string;
};

export type PostApiTeamsTeamIdLeads402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdLeadsSummary401 = {
  message?: string;
};

export type GetApiTeamsTeamIdLeadsLeadId401 = {
  message?: string;
};

export type PutApiTeamsTeamIdLeadsLeadId401 = {
  message?: string;
};

export type PutApiTeamsTeamIdLeadsLeadId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type DeleteApiTeamsTeamIdLeadsLeadId401 = {
  message?: string;
};

export type DeleteApiTeamsTeamIdLeadsLeadId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdLeadsImportFromCardBody = {
  file?: Blob;
};

export type PostApiTeamsTeamIdLeadsImportFromCard401 = {
  message?: string;
};

export type PostApiTeamsTeamIdLeadsImportFromCard402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdLeadsCheckMatch401 = {
  message?: string;
};

export type PostApiTeamsTeamIdLeadsLeadIdMatch401 = {
  message?: string;
};

export type PostApiTeamsTeamIdLeadsLeadIdMatch402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdLeadsLeadIdConvert401 = {
  message?: string;
};

export type PostApiTeamsTeamIdLeadsLeadIdConvert402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdLeadsLeadIdRestore401 = {
  message?: string;
};

export type PostApiTeamsTeamIdLeadsLeadIdRestore402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdAgentsPolicyDocumentRetrievalRuns402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdPortalsParams = {
includeDeleted?: boolean;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiTeamsTeamIdPortals401 = {
  message?: string;
};

export type PostApiTeamsTeamIdPortals401 = {
  message?: string;
};

export type PostApiTeamsTeamIdPortals402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdPortalsPaymentsParams = {
clientAccountId?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiTeamsTeamIdPortalsPayments401 = {
  message?: string;
};

export type PostApiTeamsTeamIdPortalsPayments401 = {
  message?: string;
};

export type PostApiTeamsTeamIdPortalsPayments402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdTeamRagRefresh401 = {
  message?: string;
};

export type PostApiTeamsTeamIdTeamRagRefresh402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdReportsBookOfBusinessParams = {
DateField?: string;
From?: string;
To?: string;
LobCode?: string;
ProducerUserId?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
Page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
PageSize?: number;
SortBy?: string;
SortDir?: string;
Format?: string;
};

export type GetApiTeamsTeamIdReportsBookOfBusiness401 = {
  message?: string;
};

export type GetApiTeamsTeamIdReportsRenewalForecastParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
DaysWindow?: number;
LobCode?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
Page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
PageSize?: number;
SortBy?: string;
SortDir?: string;
Format?: string;
};

export type GetApiTeamsTeamIdReportsRenewalForecast401 = {
  message?: string;
};

export type GetApiTeamsTeamIdReportsPipelineParams = {
StageCode?: string;
LobCode?: string;
ProducerUserId?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
Page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
PageSize?: number;
SortBy?: string;
SortDir?: string;
Format?: string;
};

export type GetApiTeamsTeamIdReportsPipeline401 = {
  message?: string;
};

export type GetApiTeamsTeamIdReportsProducerProductionParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
Month?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
Year?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
Page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
PageSize?: number;
SortBy?: string;
SortDir?: string;
Format?: string;
};

export type GetApiTeamsTeamIdReportsProducerProduction401 = {
  message?: string;
};

export type GetApiTeamsParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiTeams401 = {
  message?: string;
};

export type PostApiTeams401 = {
  message?: string;
};

export type PostApiTeams402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsIdBookAnalytics401 = {
  message?: string;
};

export type GetApiTeamsIdRevenueProducers401 = {
  message?: string;
};

export type GetApiTeamsIdRevenueLobs401 = {
  message?: string;
};

export type GetApiTeamsIdRevenueRenewalsParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
days?: number;
};

export type GetApiTeamsIdRevenueRenewals401 = {
  message?: string;
};

export type GetApiTeamsIdRevenuePipeline401 = {
  message?: string;
};

export type GetApiTeamsId401 = {
  message?: string;
};

export type PutApiTeamsId401 = {
  message?: string;
};

export type PutApiTeamsId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsIdBilling401 = {
  message?: string;
};

export type PostApiTeamsIdBillingCheckoutSession401 = {
  message?: string;
};

export type PostApiTeamsIdBillingCheckoutSession402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsIdBillingAdmin401 = {
  message?: string;
};

export type PostApiTeamsIdBillingAdjustments401 = {
  message?: string;
};

export type PostApiTeamsIdBillingAdjustments402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsIdBillingAdjustmentsAdjustmentIdRevoke401 = {
  message?: string;
};

export type PostApiTeamsIdBillingAdjustmentsAdjustmentIdRevoke402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsIdAgency401 = {
  message?: string;
};

export type PostApiTeamsIdAgency402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type DeleteApiTeamsIdAgency401 = {
  message?: string;
};

export type DeleteApiTeamsIdAgency402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsIdAgencyLink401 = {
  message?: string;
};

export type PostApiTeamsIdAgencyLink402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PutApiTeamsIdAgencyProfile401 = {
  message?: string;
};

export type PutApiTeamsIdAgencyProfile402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsAgenciesParams = {
q?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiTeamsAgencies401 = {
  message?: string;
};

export type PostApiTeamsIdMembers401 = {
  message?: string;
};

export type PostApiTeamsIdMembers402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsIdStaffAgencyStaffIdAssignSeatParams = {
role?: string;
};

export type PostApiTeamsIdStaffAgencyStaffIdAssignSeat401 = {
  message?: string;
};

export type PostApiTeamsIdStaffAgencyStaffIdAssignSeat402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsIdMembersUserIdActivate401 = {
  message?: string;
};

export type PostApiTeamsIdMembersUserIdActivate402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsIdMembersUserIdReassign401 = {
  message?: string;
};

export type PostApiTeamsIdMembersUserIdReassign402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type DeleteApiTeamsIdMembersUserId401 = {
  message?: string;
};

export type DeleteApiTeamsIdMembersUserId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsIdStaff401 = {
  message?: string;
};

export type PostApiTeamsIdStaff401 = {
  message?: string;
};

export type PostApiTeamsIdStaff402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsIdProducerLicenses401 = {
  message?: string;
};

export type PostApiTeamsIdProducerLicenses401 = {
  message?: string;
};

export type PostApiTeamsIdProducerLicenses402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PatchApiTeamsIdProducerLicensesProducerLicenseId401 = {
  message?: string;
};

export type PatchApiTeamsIdProducerLicensesProducerLicenseId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type DeleteApiTeamsIdProducerLicensesProducerLicenseId401 = {
  message?: string;
};

export type DeleteApiTeamsIdProducerLicensesProducerLicenseId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsIdAgencyLicenses401 = {
  message?: string;
};

export type PostApiTeamsIdAgencyLicenses401 = {
  message?: string;
};

export type PostApiTeamsIdAgencyLicenses402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PatchApiTeamsIdAgencyLicensesAgencyLicenseId401 = {
  message?: string;
};

export type PatchApiTeamsIdAgencyLicensesAgencyLicenseId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type DeleteApiTeamsIdAgencyLicensesAgencyLicenseId401 = {
  message?: string;
};

export type DeleteApiTeamsIdAgencyLicensesAgencyLicenseId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsIdCarrierAppointments401 = {
  message?: string;
};

export type PostApiTeamsIdCarrierAppointments401 = {
  message?: string;
};

export type PostApiTeamsIdCarrierAppointments402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PatchApiTeamsIdCarrierAppointmentsCarrierAppointmentId401 = {
  message?: string;
};

export type PatchApiTeamsIdCarrierAppointmentsCarrierAppointmentId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type DeleteApiTeamsIdCarrierAppointmentsCarrierAppointmentId401 = {
  message?: string;
};

export type DeleteApiTeamsIdCarrierAppointmentsCarrierAppointmentId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsStaffRoleCodes401 = {
  message?: string;
};

export type PatchApiTeamsIdStaffAgencyStaffId401 = {
  message?: string;
};

export type PatchApiTeamsIdStaffAgencyStaffId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsIdLogoParams = {
download?: boolean;
};

export type PostApiTeamsIdLogoBody = {
  file?: IFormFile;
};

export type PostApiTeamsIdLogo401 = {
  message?: string;
};

export type PostApiTeamsIdLogo402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type DeleteApiTeamsIdLogo401 = {
  message?: string;
};

export type DeleteApiTeamsIdLogo402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsIdLogoRemove401 = {
  message?: string;
};

export type PostApiTeamsIdLogoRemove402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsIdLogoUseUploadId401 = {
  message?: string;
};

export type PostApiTeamsIdLogoUseUploadId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdAgentsShelfNoteRuns402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecision402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdIntakesParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
take?: number;
includeAbandoned?: boolean;
};

export type GetApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdIntakes401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdIntakes401 = {
  message?: string;
};

export type PostApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdIntakes402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdSubmissionsIntakesRunsParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
take?: number;
includeAbandoned?: boolean;
};

export type GetApiTeamsTeamIdSubmissionsIntakesRuns401 = {
  message?: string;
};

export type PostApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdLinkProspect401 = {
  message?: string;
};

export type PostApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdLinkProspect402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInvite401 = {
  message?: string;
};

export type PostApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInvite402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInvites401 = {
  message?: string;
};

export type PostApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInviteRevoke401 = {
  message?: string;
};

export type PostApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInviteRevoke402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdClose401 = {
  message?: string;
};

export type PostApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdClose402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdEventsParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
take?: number;
};

export type GetApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdEvents401 = {
  message?: string;
};

export type GetApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdSlotDiff401 = {
  message?: string;
};

export type GetApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdProposedValues401 = {
  message?: string;
};

export type PutApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdProposedValues401 = {
  message?: string;
};

export type PutApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdProposedValues402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdReview401 = {
  message?: string;
};

export type PostApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdApplyReview401 = {
  message?: string;
};

export type PostApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdApplyReview402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdSubmissionsParams = {
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiTeamsTeamIdSubmissions401 = {
  message?: string;
};

export type GetApiTeamsTeamIdUploadsParams = {
purpose?: string;
includeDeleted?: boolean;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiTeamsTeamIdUploads401 = {
  message?: string;
};

export type PostApiTeamsTeamIdUploadsBody = {
  file?: Blob;
  displayName?: string;
  description?: string;
};

export type PostApiTeamsTeamIdUploads401 = {
  message?: string;
};

export type PostApiTeamsTeamIdUploads402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiTeamsTeamIdUploadsUploadIdContentParams = {
download?: boolean;
};

export type GetApiTeamsTeamIdUploadsUploadIdContent401 = {
  message?: string;
};

export type DeleteApiTeamsTeamIdUploadsUploadId401 = {
  message?: string;
};

export type DeleteApiTeamsTeamIdUploadsUploadId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiTeamsTeamIdUploadsUploadIdRestore401 = {
  message?: string;
};

export type PostApiTeamsTeamIdUploadsUploadIdRestore402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type DeleteApiTeamsTeamIdUploadsUploadIdHard401 = {
  message?: string;
};

export type DeleteApiTeamsTeamIdUploadsUploadIdHard402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiUsersParams = {
search?: string;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
page?: number;
/**
 * @pattern ^-?(?:0|[1-9]\d*)$
 */
pageSize?: number;
};

export type GetApiUsers401 = {
  message?: string;
};

export type PostApiUsers401 = {
  message?: string;
};

export type PostApiUsers402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiUsersId401 = {
  message?: string;
};

export type PutApiUsersId401 = {
  message?: string;
};

export type PutApiUsersId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type DeleteApiUsersId401 = {
  message?: string;
};

export type DeleteApiUsersId402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type PostApiUsersIdToggleStatus401 = {
  message?: string;
};

export type PostApiUsersIdToggleStatus402 = {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  teamId?: string | null;
  /** @nullable */
  subscriptionStatus?: string | null;
  /** @nullable */
  paymentStatus?: string | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatLimit?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsUsed?: number | null;
  /**
     * @nullable
     * @pattern ^-?(?:0|[1-9]\d*)$
     */
  seatsRemaining?: number | null;
  /** @nullable */
  requiresSubscription?: boolean | null;
  /** @nullable */
  requiresPaymentAction?: boolean | null;
  /** @nullable */
  manageBillingPath?: string | null;
};

export type GetApiUsersStats401 = {
  message?: string;
};

export type PutApiUsersIdSettings401 = {
  message?: string;
};

export type PostApiVinDecodeHybrid401 = {
  message?: string;
};

export type PostApiVinDecode401 = {
  message?: string;
};

export type PostApiVinDecodeApi401 = {
  message?: string;
};

export type PostApiVinDecodeRaw401 = {
  message?: string;
};

export type postApiAddressValidateResponse200TextPlain = {
  data: AddressValidateResponse
  status: 200
}

export type postApiAddressValidateResponse200ApplicationJson = {
  data: AddressValidateResponse
  status: 200
}

export type postApiAddressValidateResponse200TextJson = {
  data: AddressValidateResponse
  status: 200
}

export type postApiAddressValidateResponse401 = {
  data: PostApiAddressValidate401
  status: 401
}

export type postApiAddressValidateResponseSuccess = (postApiAddressValidateResponse200TextPlain | postApiAddressValidateResponse200ApplicationJson | postApiAddressValidateResponse200TextJson) & {
  headers: Headers;
};
export type postApiAddressValidateResponseError = (postApiAddressValidateResponse401) & {
  headers: Headers;
};

export type postApiAddressValidateResponse = (postApiAddressValidateResponseSuccess | postApiAddressValidateResponseError)

export const getPostApiAddressValidateUrl = () => {




  return `/api/address/validate`
}

export const postApiAddressValidate = async (addressValidateRequest: AddressValidateRequest, options?: RequestInit): Promise<postApiAddressValidateResponse> => {

  return fetcher<postApiAddressValidateResponse>(getPostApiAddressValidateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      addressValidateRequest,)
  }
);}



export type getApiAddressZipZipResponse200TextPlain = {
  data: ZipValidateResponse
  status: 200
}

export type getApiAddressZipZipResponse200ApplicationJson = {
  data: ZipValidateResponse
  status: 200
}

export type getApiAddressZipZipResponse200TextJson = {
  data: ZipValidateResponse
  status: 200
}

export type getApiAddressZipZipResponse401 = {
  data: GetApiAddressZipZip401
  status: 401
}

export type getApiAddressZipZipResponseSuccess = (getApiAddressZipZipResponse200TextPlain | getApiAddressZipZipResponse200ApplicationJson | getApiAddressZipZipResponse200TextJson) & {
  headers: Headers;
};
export type getApiAddressZipZipResponseError = (getApiAddressZipZipResponse401) & {
  headers: Headers;
};

export type getApiAddressZipZipResponse = (getApiAddressZipZipResponseSuccess | getApiAddressZipZipResponseError)

export const getGetApiAddressZipZipUrl = (zip: string,) => {




  return `/api/address/zip/${zip}`
}

export const getApiAddressZipZip = async (zip: string, options?: RequestInit): Promise<getApiAddressZipZipResponse> => {

  return fetcher<getApiAddressZipZipResponse>(getGetApiAddressZipZipUrl(zip),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiAddressCityStateResponse200TextPlain = {
  data: CityStateLookupResponse
  status: 200
}

export type getApiAddressCityStateResponse200ApplicationJson = {
  data: CityStateLookupResponse
  status: 200
}

export type getApiAddressCityStateResponse200TextJson = {
  data: CityStateLookupResponse
  status: 200
}

export type getApiAddressCityStateResponse401 = {
  data: GetApiAddressCityState401
  status: 401
}

export type getApiAddressCityStateResponseSuccess = (getApiAddressCityStateResponse200TextPlain | getApiAddressCityStateResponse200ApplicationJson | getApiAddressCityStateResponse200TextJson) & {
  headers: Headers;
};
export type getApiAddressCityStateResponseError = (getApiAddressCityStateResponse401) & {
  headers: Headers;
};

export type getApiAddressCityStateResponse = (getApiAddressCityStateResponseSuccess | getApiAddressCityStateResponseError)

export const getGetApiAddressCityStateUrl = (params?: GetApiAddressCityStateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/address/city-state?${stringifiedParams}` : `/api/address/city-state`
}

export const getApiAddressCityState = async (params?: GetApiAddressCityStateParams, options?: RequestInit): Promise<getApiAddressCityStateResponse> => {

  return fetcher<getApiAddressCityStateResponse>(getGetApiAddressCityStateUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiAddressZipcodeResponse200TextPlain = {
  data: ZipCodeLookupResponse
  status: 200
}

export type getApiAddressZipcodeResponse200ApplicationJson = {
  data: ZipCodeLookupResponse
  status: 200
}

export type getApiAddressZipcodeResponse200TextJson = {
  data: ZipCodeLookupResponse
  status: 200
}

export type getApiAddressZipcodeResponse401 = {
  data: GetApiAddressZipcode401
  status: 401
}

export type getApiAddressZipcodeResponseSuccess = (getApiAddressZipcodeResponse200TextPlain | getApiAddressZipcodeResponse200ApplicationJson | getApiAddressZipcodeResponse200TextJson) & {
  headers: Headers;
};
export type getApiAddressZipcodeResponseError = (getApiAddressZipcodeResponse401) & {
  headers: Headers;
};

export type getApiAddressZipcodeResponse = (getApiAddressZipcodeResponseSuccess | getApiAddressZipcodeResponseError)

export const getGetApiAddressZipcodeUrl = (params?: GetApiAddressZipcodeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/address/zipcode?${stringifiedParams}` : `/api/address/zipcode`
}

export const getApiAddressZipcode = async (params?: GetApiAddressZipcodeParams, options?: RequestInit): Promise<getApiAddressZipcodeResponse> => {

  return fetcher<getApiAddressZipcodeResponse>(getGetApiAddressZipcodeUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type deleteApiAdminAcordImportsImportRunIdResponse200 = {
  data: void
  status: 200
}

export type deleteApiAdminAcordImportsImportRunIdResponse401 = {
  data: DeleteApiAdminAcordImportsImportRunId401
  status: 401
}

export type deleteApiAdminAcordImportsImportRunIdResponse402 = {
  data: DeleteApiAdminAcordImportsImportRunId402
  status: 402
}

export type deleteApiAdminAcordImportsImportRunIdResponseSuccess = (deleteApiAdminAcordImportsImportRunIdResponse200) & {
  headers: Headers;
};
export type deleteApiAdminAcordImportsImportRunIdResponseError = (deleteApiAdminAcordImportsImportRunIdResponse401 | deleteApiAdminAcordImportsImportRunIdResponse402) & {
  headers: Headers;
};

export type deleteApiAdminAcordImportsImportRunIdResponse = (deleteApiAdminAcordImportsImportRunIdResponseSuccess | deleteApiAdminAcordImportsImportRunIdResponseError)

export const getDeleteApiAdminAcordImportsImportRunIdUrl = (importRunId: string,
    params?: DeleteApiAdminAcordImportsImportRunIdParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/acord/imports/${importRunId}?${stringifiedParams}` : `/api/admin/acord/imports/${importRunId}`
}

export const deleteApiAdminAcordImportsImportRunId = async (importRunId: string,
    params?: DeleteApiAdminAcordImportsImportRunIdParams, options?: RequestInit): Promise<deleteApiAdminAcordImportsImportRunIdResponse> => {

  return fetcher<deleteApiAdminAcordImportsImportRunIdResponse>(getDeleteApiAdminAcordImportsImportRunIdUrl(importRunId,params),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type getApiAdminAcordEditionsEditionIdFormVersionResponse200 = {
  data: void
  status: 200
}

export type getApiAdminAcordEditionsEditionIdFormVersionResponse401 = {
  data: GetApiAdminAcordEditionsEditionIdFormVersion401
  status: 401
}

export type getApiAdminAcordEditionsEditionIdFormVersionResponseSuccess = (getApiAdminAcordEditionsEditionIdFormVersionResponse200) & {
  headers: Headers;
};
export type getApiAdminAcordEditionsEditionIdFormVersionResponseError = (getApiAdminAcordEditionsEditionIdFormVersionResponse401) & {
  headers: Headers;
};

export type getApiAdminAcordEditionsEditionIdFormVersionResponse = (getApiAdminAcordEditionsEditionIdFormVersionResponseSuccess | getApiAdminAcordEditionsEditionIdFormVersionResponseError)

export const getGetApiAdminAcordEditionsEditionIdFormVersionUrl = (editionId: string,) => {




  return `/api/admin/acord/editions/${editionId}/form-version`
}

export const getApiAdminAcordEditionsEditionIdFormVersion = async (editionId: string, options?: RequestInit): Promise<getApiAdminAcordEditionsEditionIdFormVersionResponse> => {

  return fetcher<getApiAdminAcordEditionsEditionIdFormVersionResponse>(getGetApiAdminAcordEditionsEditionIdFormVersionUrl(editionId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiAdminAcordEditionsEditionIdFormVersionsResponse200 = {
  data: void
  status: 200
}

export type getApiAdminAcordEditionsEditionIdFormVersionsResponse401 = {
  data: GetApiAdminAcordEditionsEditionIdFormVersions401
  status: 401
}

export type getApiAdminAcordEditionsEditionIdFormVersionsResponseSuccess = (getApiAdminAcordEditionsEditionIdFormVersionsResponse200) & {
  headers: Headers;
};
export type getApiAdminAcordEditionsEditionIdFormVersionsResponseError = (getApiAdminAcordEditionsEditionIdFormVersionsResponse401) & {
  headers: Headers;
};

export type getApiAdminAcordEditionsEditionIdFormVersionsResponse = (getApiAdminAcordEditionsEditionIdFormVersionsResponseSuccess | getApiAdminAcordEditionsEditionIdFormVersionsResponseError)

export const getGetApiAdminAcordEditionsEditionIdFormVersionsUrl = (editionId: string,) => {




  return `/api/admin/acord/editions/${editionId}/form-versions`
}

export const getApiAdminAcordEditionsEditionIdFormVersions = async (editionId: string, options?: RequestInit): Promise<getApiAdminAcordEditionsEditionIdFormVersionsResponse> => {

  return fetcher<getApiAdminAcordEditionsEditionIdFormVersionsResponse>(getGetApiAdminAcordEditionsEditionIdFormVersionsUrl(editionId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiAdminAcordEditionsEditionIdMappingkeyTokensResponse200 = {
  data: void
  status: 200
}

export type getApiAdminAcordEditionsEditionIdMappingkeyTokensResponse401 = {
  data: GetApiAdminAcordEditionsEditionIdMappingkeyTokens401
  status: 401
}

export type getApiAdminAcordEditionsEditionIdMappingkeyTokensResponseSuccess = (getApiAdminAcordEditionsEditionIdMappingkeyTokensResponse200) & {
  headers: Headers;
};
export type getApiAdminAcordEditionsEditionIdMappingkeyTokensResponseError = (getApiAdminAcordEditionsEditionIdMappingkeyTokensResponse401) & {
  headers: Headers;
};

export type getApiAdminAcordEditionsEditionIdMappingkeyTokensResponse = (getApiAdminAcordEditionsEditionIdMappingkeyTokensResponseSuccess | getApiAdminAcordEditionsEditionIdMappingkeyTokensResponseError)

export const getGetApiAdminAcordEditionsEditionIdMappingkeyTokensUrl = (editionId: string,) => {




  return `/api/admin/acord/editions/${editionId}/mappingkey-tokens`
}

export const getApiAdminAcordEditionsEditionIdMappingkeyTokens = async (editionId: string, options?: RequestInit): Promise<getApiAdminAcordEditionsEditionIdMappingkeyTokensResponse> => {

  return fetcher<getApiAdminAcordEditionsEditionIdMappingkeyTokensResponse>(getGetApiAdminAcordEditionsEditionIdMappingkeyTokensUrl(editionId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiAdminAcordEditionsEditionIdBindingsGeometryResponse200 = {
  data: void
  status: 200
}

export type getApiAdminAcordEditionsEditionIdBindingsGeometryResponse401 = {
  data: GetApiAdminAcordEditionsEditionIdBindingsGeometry401
  status: 401
}

export type getApiAdminAcordEditionsEditionIdBindingsGeometryResponseSuccess = (getApiAdminAcordEditionsEditionIdBindingsGeometryResponse200) & {
  headers: Headers;
};
export type getApiAdminAcordEditionsEditionIdBindingsGeometryResponseError = (getApiAdminAcordEditionsEditionIdBindingsGeometryResponse401) & {
  headers: Headers;
};

export type getApiAdminAcordEditionsEditionIdBindingsGeometryResponse = (getApiAdminAcordEditionsEditionIdBindingsGeometryResponseSuccess | getApiAdminAcordEditionsEditionIdBindingsGeometryResponseError)

export const getGetApiAdminAcordEditionsEditionIdBindingsGeometryUrl = (editionId: string,) => {




  return `/api/admin/acord/editions/${editionId}/bindings-geometry`
}

export const getApiAdminAcordEditionsEditionIdBindingsGeometry = async (editionId: string, options?: RequestInit): Promise<getApiAdminAcordEditionsEditionIdBindingsGeometryResponse> => {

  return fetcher<getApiAdminAcordEditionsEditionIdBindingsGeometryResponse>(getGetApiAdminAcordEditionsEditionIdBindingsGeometryUrl(editionId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiAdminAcordEditionsEditionIdBindingsGeometryResponse200 = {
  data: void
  status: 200
}

export type postApiAdminAcordEditionsEditionIdBindingsGeometryResponse401 = {
  data: PostApiAdminAcordEditionsEditionIdBindingsGeometry401
  status: 401
}

export type postApiAdminAcordEditionsEditionIdBindingsGeometryResponse402 = {
  data: PostApiAdminAcordEditionsEditionIdBindingsGeometry402
  status: 402
}

export type postApiAdminAcordEditionsEditionIdBindingsGeometryResponseSuccess = (postApiAdminAcordEditionsEditionIdBindingsGeometryResponse200) & {
  headers: Headers;
};
export type postApiAdminAcordEditionsEditionIdBindingsGeometryResponseError = (postApiAdminAcordEditionsEditionIdBindingsGeometryResponse401 | postApiAdminAcordEditionsEditionIdBindingsGeometryResponse402) & {
  headers: Headers;
};

export type postApiAdminAcordEditionsEditionIdBindingsGeometryResponse = (postApiAdminAcordEditionsEditionIdBindingsGeometryResponseSuccess | postApiAdminAcordEditionsEditionIdBindingsGeometryResponseError)

export const getPostApiAdminAcordEditionsEditionIdBindingsGeometryUrl = (editionId: string,) => {




  return `/api/admin/acord/editions/${editionId}/bindings-geometry`
}

export const postApiAdminAcordEditionsEditionIdBindingsGeometry = async (editionId: string,
    updateBindingGeometryRequest: UpdateBindingGeometryRequest, options?: RequestInit): Promise<postApiAdminAcordEditionsEditionIdBindingsGeometryResponse> => {

  return fetcher<postApiAdminAcordEditionsEditionIdBindingsGeometryResponse>(getPostApiAdminAcordEditionsEditionIdBindingsGeometryUrl(editionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateBindingGeometryRequest,)
  }
);}



export type postApiAdminAcordEditionsEditionIdBindingsGeometryResetResponse200 = {
  data: void
  status: 200
}

export type postApiAdminAcordEditionsEditionIdBindingsGeometryResetResponse401 = {
  data: PostApiAdminAcordEditionsEditionIdBindingsGeometryReset401
  status: 401
}

export type postApiAdminAcordEditionsEditionIdBindingsGeometryResetResponse402 = {
  data: PostApiAdminAcordEditionsEditionIdBindingsGeometryReset402
  status: 402
}

export type postApiAdminAcordEditionsEditionIdBindingsGeometryResetResponseSuccess = (postApiAdminAcordEditionsEditionIdBindingsGeometryResetResponse200) & {
  headers: Headers;
};
export type postApiAdminAcordEditionsEditionIdBindingsGeometryResetResponseError = (postApiAdminAcordEditionsEditionIdBindingsGeometryResetResponse401 | postApiAdminAcordEditionsEditionIdBindingsGeometryResetResponse402) & {
  headers: Headers;
};

export type postApiAdminAcordEditionsEditionIdBindingsGeometryResetResponse = (postApiAdminAcordEditionsEditionIdBindingsGeometryResetResponseSuccess | postApiAdminAcordEditionsEditionIdBindingsGeometryResetResponseError)

export const getPostApiAdminAcordEditionsEditionIdBindingsGeometryResetUrl = (editionId: string,) => {




  return `/api/admin/acord/editions/${editionId}/bindings-geometry/reset`
}

export const postApiAdminAcordEditionsEditionIdBindingsGeometryReset = async (editionId: string, options?: RequestInit): Promise<postApiAdminAcordEditionsEditionIdBindingsGeometryResetResponse> => {

  return fetcher<postApiAdminAcordEditionsEditionIdBindingsGeometryResetResponse>(getPostApiAdminAcordEditionsEditionIdBindingsGeometryResetUrl(editionId),
  {
    ...options,
    method: 'POST'


  }
);}



export type getApiAdminAcordEditionsEditionIdAcroControlsResponse200 = {
  data: void
  status: 200
}

export type getApiAdminAcordEditionsEditionIdAcroControlsResponse401 = {
  data: GetApiAdminAcordEditionsEditionIdAcroControls401
  status: 401
}

export type getApiAdminAcordEditionsEditionIdAcroControlsResponseSuccess = (getApiAdminAcordEditionsEditionIdAcroControlsResponse200) & {
  headers: Headers;
};
export type getApiAdminAcordEditionsEditionIdAcroControlsResponseError = (getApiAdminAcordEditionsEditionIdAcroControlsResponse401) & {
  headers: Headers;
};

export type getApiAdminAcordEditionsEditionIdAcroControlsResponse = (getApiAdminAcordEditionsEditionIdAcroControlsResponseSuccess | getApiAdminAcordEditionsEditionIdAcroControlsResponseError)

export const getGetApiAdminAcordEditionsEditionIdAcroControlsUrl = (editionId: string,) => {




  return `/api/admin/acord/editions/${editionId}/acro-controls`
}

export const getApiAdminAcordEditionsEditionIdAcroControls = async (editionId: string, options?: RequestInit): Promise<getApiAdminAcordEditionsEditionIdAcroControlsResponse> => {

  return fetcher<getApiAdminAcordEditionsEditionIdAcroControlsResponse>(getGetApiAdminAcordEditionsEditionIdAcroControlsUrl(editionId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiAdminAcordFormsResponse200 = {
  data: void
  status: 200
}

export type getApiAdminAcordFormsResponse401 = {
  data: GetApiAdminAcordForms401
  status: 401
}

export type getApiAdminAcordFormsResponseSuccess = (getApiAdminAcordFormsResponse200) & {
  headers: Headers;
};
export type getApiAdminAcordFormsResponseError = (getApiAdminAcordFormsResponse401) & {
  headers: Headers;
};

export type getApiAdminAcordFormsResponse = (getApiAdminAcordFormsResponseSuccess | getApiAdminAcordFormsResponseError)

export const getGetApiAdminAcordFormsUrl = () => {




  return `/api/admin/acord/forms`
}

export const getApiAdminAcordForms = async ( options?: RequestInit): Promise<getApiAdminAcordFormsResponse> => {

  return fetcher<getApiAdminAcordFormsResponse>(getGetApiAdminAcordFormsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiAdminAcordFormsSummaryResponse200 = {
  data: void
  status: 200
}

export type getApiAdminAcordFormsSummaryResponse401 = {
  data: GetApiAdminAcordFormsSummary401
  status: 401
}

export type getApiAdminAcordFormsSummaryResponseSuccess = (getApiAdminAcordFormsSummaryResponse200) & {
  headers: Headers;
};
export type getApiAdminAcordFormsSummaryResponseError = (getApiAdminAcordFormsSummaryResponse401) & {
  headers: Headers;
};

export type getApiAdminAcordFormsSummaryResponse = (getApiAdminAcordFormsSummaryResponseSuccess | getApiAdminAcordFormsSummaryResponseError)

export const getGetApiAdminAcordFormsSummaryUrl = (params?: GetApiAdminAcordFormsSummaryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/acord/forms/summary?${stringifiedParams}` : `/api/admin/acord/forms/summary`
}

export const getApiAdminAcordFormsSummary = async (params?: GetApiAdminAcordFormsSummaryParams, options?: RequestInit): Promise<getApiAdminAcordFormsSummaryResponse> => {

  return fetcher<getApiAdminAcordFormsSummaryResponse>(getGetApiAdminAcordFormsSummaryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiAdminAcordUsageContextsResponse200 = {
  data: void
  status: 200
}

export type getApiAdminAcordUsageContextsResponse401 = {
  data: GetApiAdminAcordUsageContexts401
  status: 401
}

export type getApiAdminAcordUsageContextsResponseSuccess = (getApiAdminAcordUsageContextsResponse200) & {
  headers: Headers;
};
export type getApiAdminAcordUsageContextsResponseError = (getApiAdminAcordUsageContextsResponse401) & {
  headers: Headers;
};

export type getApiAdminAcordUsageContextsResponse = (getApiAdminAcordUsageContextsResponseSuccess | getApiAdminAcordUsageContextsResponseError)

export const getGetApiAdminAcordUsageContextsUrl = () => {




  return `/api/admin/acord/usage-contexts`
}

export const getApiAdminAcordUsageContexts = async ( options?: RequestInit): Promise<getApiAdminAcordUsageContextsResponse> => {

  return fetcher<getApiAdminAcordUsageContextsResponse>(getGetApiAdminAcordUsageContextsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiAdminAcordLibraryResponse200 = {
  data: void
  status: 200
}

export type getApiAdminAcordLibraryResponse401 = {
  data: GetApiAdminAcordLibrary401
  status: 401
}

export type getApiAdminAcordLibraryResponseSuccess = (getApiAdminAcordLibraryResponse200) & {
  headers: Headers;
};
export type getApiAdminAcordLibraryResponseError = (getApiAdminAcordLibraryResponse401) & {
  headers: Headers;
};

export type getApiAdminAcordLibraryResponse = (getApiAdminAcordLibraryResponseSuccess | getApiAdminAcordLibraryResponseError)

export const getGetApiAdminAcordLibraryUrl = (params?: GetApiAdminAcordLibraryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/acord/library?${stringifiedParams}` : `/api/admin/acord/library`
}

export const getApiAdminAcordLibrary = async (params?: GetApiAdminAcordLibraryParams, options?: RequestInit): Promise<getApiAdminAcordLibraryResponse> => {

  return fetcher<getApiAdminAcordLibraryResponse>(getGetApiAdminAcordLibraryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiAdminAcordEditionsResponse200 = {
  data: void
  status: 200
}

export type getApiAdminAcordEditionsResponse401 = {
  data: GetApiAdminAcordEditions401
  status: 401
}

export type getApiAdminAcordEditionsResponseSuccess = (getApiAdminAcordEditionsResponse200) & {
  headers: Headers;
};
export type getApiAdminAcordEditionsResponseError = (getApiAdminAcordEditionsResponse401) & {
  headers: Headers;
};

export type getApiAdminAcordEditionsResponse = (getApiAdminAcordEditionsResponseSuccess | getApiAdminAcordEditionsResponseError)

export const getGetApiAdminAcordEditionsUrl = (params?: GetApiAdminAcordEditionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/acord/editions?${stringifiedParams}` : `/api/admin/acord/editions`
}

export const getApiAdminAcordEditions = async (params?: GetApiAdminAcordEditionsParams, options?: RequestInit): Promise<getApiAdminAcordEditionsResponse> => {

  return fetcher<getApiAdminAcordEditionsResponse>(getGetApiAdminAcordEditionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiAdminAcordFormsAcordFormIdSummaryResponse200 = {
  data: void
  status: 200
}

export type getApiAdminAcordFormsAcordFormIdSummaryResponse401 = {
  data: GetApiAdminAcordFormsAcordFormIdSummary401
  status: 401
}

export type getApiAdminAcordFormsAcordFormIdSummaryResponseSuccess = (getApiAdminAcordFormsAcordFormIdSummaryResponse200) & {
  headers: Headers;
};
export type getApiAdminAcordFormsAcordFormIdSummaryResponseError = (getApiAdminAcordFormsAcordFormIdSummaryResponse401) & {
  headers: Headers;
};

export type getApiAdminAcordFormsAcordFormIdSummaryResponse = (getApiAdminAcordFormsAcordFormIdSummaryResponseSuccess | getApiAdminAcordFormsAcordFormIdSummaryResponseError)

export const getGetApiAdminAcordFormsAcordFormIdSummaryUrl = (acordFormId: string,) => {




  return `/api/admin/acord/forms/${acordFormId}/summary`
}

export const getApiAdminAcordFormsAcordFormIdSummary = async (acordFormId: string, options?: RequestInit): Promise<getApiAdminAcordFormsAcordFormIdSummaryResponse> => {

  return fetcher<getApiAdminAcordFormsAcordFormIdSummaryResponse>(getGetApiAdminAcordFormsAcordFormIdSummaryUrl(acordFormId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiAdminAcordFormsAcordFormIdActiveResponse200 = {
  data: void
  status: 200
}

export type postApiAdminAcordFormsAcordFormIdActiveResponse401 = {
  data: PostApiAdminAcordFormsAcordFormIdActive401
  status: 401
}

export type postApiAdminAcordFormsAcordFormIdActiveResponse402 = {
  data: PostApiAdminAcordFormsAcordFormIdActive402
  status: 402
}

export type postApiAdminAcordFormsAcordFormIdActiveResponseSuccess = (postApiAdminAcordFormsAcordFormIdActiveResponse200) & {
  headers: Headers;
};
export type postApiAdminAcordFormsAcordFormIdActiveResponseError = (postApiAdminAcordFormsAcordFormIdActiveResponse401 | postApiAdminAcordFormsAcordFormIdActiveResponse402) & {
  headers: Headers;
};

export type postApiAdminAcordFormsAcordFormIdActiveResponse = (postApiAdminAcordFormsAcordFormIdActiveResponseSuccess | postApiAdminAcordFormsAcordFormIdActiveResponseError)

export const getPostApiAdminAcordFormsAcordFormIdActiveUrl = (acordFormId: string,) => {




  return `/api/admin/acord/forms/${acordFormId}/active`
}

export const postApiAdminAcordFormsAcordFormIdActive = async (acordFormId: string,
    updateAcordFormActiveRequest: UpdateAcordFormActiveRequest, options?: RequestInit): Promise<postApiAdminAcordFormsAcordFormIdActiveResponse> => {

  return fetcher<postApiAdminAcordFormsAcordFormIdActiveResponse>(getPostApiAdminAcordFormsAcordFormIdActiveUrl(acordFormId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateAcordFormActiveRequest,)
  }
);}



export type getApiAdminAcordFormsAcordFormIdEditionsResponse200 = {
  data: void
  status: 200
}

export type getApiAdminAcordFormsAcordFormIdEditionsResponse401 = {
  data: GetApiAdminAcordFormsAcordFormIdEditions401
  status: 401
}

export type getApiAdminAcordFormsAcordFormIdEditionsResponseSuccess = (getApiAdminAcordFormsAcordFormIdEditionsResponse200) & {
  headers: Headers;
};
export type getApiAdminAcordFormsAcordFormIdEditionsResponseError = (getApiAdminAcordFormsAcordFormIdEditionsResponse401) & {
  headers: Headers;
};

export type getApiAdminAcordFormsAcordFormIdEditionsResponse = (getApiAdminAcordFormsAcordFormIdEditionsResponseSuccess | getApiAdminAcordFormsAcordFormIdEditionsResponseError)

export const getGetApiAdminAcordFormsAcordFormIdEditionsUrl = (acordFormId: string,) => {




  return `/api/admin/acord/forms/${acordFormId}/editions`
}

export const getApiAdminAcordFormsAcordFormIdEditions = async (acordFormId: string, options?: RequestInit): Promise<getApiAdminAcordFormsAcordFormIdEditionsResponse> => {

  return fetcher<getApiAdminAcordFormsAcordFormIdEditionsResponse>(getGetApiAdminAcordFormsAcordFormIdEditionsUrl(acordFormId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiAdminAcordEditionsEditionIdStatusResponse200 = {
  data: void
  status: 200
}

export type postApiAdminAcordEditionsEditionIdStatusResponse401 = {
  data: PostApiAdminAcordEditionsEditionIdStatus401
  status: 401
}

export type postApiAdminAcordEditionsEditionIdStatusResponse402 = {
  data: PostApiAdminAcordEditionsEditionIdStatus402
  status: 402
}

export type postApiAdminAcordEditionsEditionIdStatusResponseSuccess = (postApiAdminAcordEditionsEditionIdStatusResponse200) & {
  headers: Headers;
};
export type postApiAdminAcordEditionsEditionIdStatusResponseError = (postApiAdminAcordEditionsEditionIdStatusResponse401 | postApiAdminAcordEditionsEditionIdStatusResponse402) & {
  headers: Headers;
};

export type postApiAdminAcordEditionsEditionIdStatusResponse = (postApiAdminAcordEditionsEditionIdStatusResponseSuccess | postApiAdminAcordEditionsEditionIdStatusResponseError)

export const getPostApiAdminAcordEditionsEditionIdStatusUrl = (editionId: string,) => {




  return `/api/admin/acord/editions/${editionId}/status`
}

export const postApiAdminAcordEditionsEditionIdStatus = async (editionId: string,
    updateAcordEditionStatusRequest: UpdateAcordEditionStatusRequest, options?: RequestInit): Promise<postApiAdminAcordEditionsEditionIdStatusResponse> => {

  return fetcher<postApiAdminAcordEditionsEditionIdStatusResponse>(getPostApiAdminAcordEditionsEditionIdStatusUrl(editionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateAcordEditionStatusRequest,)
  }
);}



export type getApiAdminAcordEditionsEditionIdFileResponse200 = {
  data: void
  status: 200
}

export type getApiAdminAcordEditionsEditionIdFileResponse401 = {
  data: GetApiAdminAcordEditionsEditionIdFile401
  status: 401
}

export type getApiAdminAcordEditionsEditionIdFileResponseSuccess = (getApiAdminAcordEditionsEditionIdFileResponse200) & {
  headers: Headers;
};
export type getApiAdminAcordEditionsEditionIdFileResponseError = (getApiAdminAcordEditionsEditionIdFileResponse401) & {
  headers: Headers;
};

export type getApiAdminAcordEditionsEditionIdFileResponse = (getApiAdminAcordEditionsEditionIdFileResponseSuccess | getApiAdminAcordEditionsEditionIdFileResponseError)

export const getGetApiAdminAcordEditionsEditionIdFileUrl = (editionId: string,
    params?: GetApiAdminAcordEditionsEditionIdFileParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/acord/editions/${editionId}/file?${stringifiedParams}` : `/api/admin/acord/editions/${editionId}/file`
}

export const getApiAdminAcordEditionsEditionIdFile = async (editionId: string,
    params?: GetApiAdminAcordEditionsEditionIdFileParams, options?: RequestInit): Promise<getApiAdminAcordEditionsEditionIdFileResponse> => {

  return fetcher<getApiAdminAcordEditionsEditionIdFileResponse>(getGetApiAdminAcordEditionsEditionIdFileUrl(editionId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiAdminAcordEditionsEditionIdFieldsResponse200 = {
  data: void
  status: 200
}

export type getApiAdminAcordEditionsEditionIdFieldsResponse401 = {
  data: GetApiAdminAcordEditionsEditionIdFields401
  status: 401
}

export type getApiAdminAcordEditionsEditionIdFieldsResponseSuccess = (getApiAdminAcordEditionsEditionIdFieldsResponse200) & {
  headers: Headers;
};
export type getApiAdminAcordEditionsEditionIdFieldsResponseError = (getApiAdminAcordEditionsEditionIdFieldsResponse401) & {
  headers: Headers;
};

export type getApiAdminAcordEditionsEditionIdFieldsResponse = (getApiAdminAcordEditionsEditionIdFieldsResponseSuccess | getApiAdminAcordEditionsEditionIdFieldsResponseError)

export const getGetApiAdminAcordEditionsEditionIdFieldsUrl = (editionId: string,
    params?: GetApiAdminAcordEditionsEditionIdFieldsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/acord/editions/${editionId}/fields?${stringifiedParams}` : `/api/admin/acord/editions/${editionId}/fields`
}

export const getApiAdminAcordEditionsEditionIdFields = async (editionId: string,
    params?: GetApiAdminAcordEditionsEditionIdFieldsParams, options?: RequestInit): Promise<getApiAdminAcordEditionsEditionIdFieldsResponse> => {

  return fetcher<getApiAdminAcordEditionsEditionIdFieldsResponse>(getGetApiAdminAcordEditionsEditionIdFieldsUrl(editionId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiAdminAcordEditionsEditionIdFieldDatakeyBindingsResponse200 = {
  data: void
  status: 200
}

export type getApiAdminAcordEditionsEditionIdFieldDatakeyBindingsResponse401 = {
  data: GetApiAdminAcordEditionsEditionIdFieldDatakeyBindings401
  status: 401
}

export type getApiAdminAcordEditionsEditionIdFieldDatakeyBindingsResponseSuccess = (getApiAdminAcordEditionsEditionIdFieldDatakeyBindingsResponse200) & {
  headers: Headers;
};
export type getApiAdminAcordEditionsEditionIdFieldDatakeyBindingsResponseError = (getApiAdminAcordEditionsEditionIdFieldDatakeyBindingsResponse401) & {
  headers: Headers;
};

export type getApiAdminAcordEditionsEditionIdFieldDatakeyBindingsResponse = (getApiAdminAcordEditionsEditionIdFieldDatakeyBindingsResponseSuccess | getApiAdminAcordEditionsEditionIdFieldDatakeyBindingsResponseError)

export const getGetApiAdminAcordEditionsEditionIdFieldDatakeyBindingsUrl = (editionId: string,
    params?: GetApiAdminAcordEditionsEditionIdFieldDatakeyBindingsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/acord/editions/${editionId}/field-datakey-bindings?${stringifiedParams}` : `/api/admin/acord/editions/${editionId}/field-datakey-bindings`
}

export const getApiAdminAcordEditionsEditionIdFieldDatakeyBindings = async (editionId: string,
    params?: GetApiAdminAcordEditionsEditionIdFieldDatakeyBindingsParams, options?: RequestInit): Promise<getApiAdminAcordEditionsEditionIdFieldDatakeyBindingsResponse> => {

  return fetcher<getApiAdminAcordEditionsEditionIdFieldDatakeyBindingsResponse>(getGetApiAdminAcordEditionsEditionIdFieldDatakeyBindingsUrl(editionId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiAdminAcordEditionsEditionIdFieldDatakeyBindingsResponse200 = {
  data: void
  status: 200
}

export type postApiAdminAcordEditionsEditionIdFieldDatakeyBindingsResponse401 = {
  data: PostApiAdminAcordEditionsEditionIdFieldDatakeyBindings401
  status: 401
}

export type postApiAdminAcordEditionsEditionIdFieldDatakeyBindingsResponse402 = {
  data: PostApiAdminAcordEditionsEditionIdFieldDatakeyBindings402
  status: 402
}

export type postApiAdminAcordEditionsEditionIdFieldDatakeyBindingsResponseSuccess = (postApiAdminAcordEditionsEditionIdFieldDatakeyBindingsResponse200) & {
  headers: Headers;
};
export type postApiAdminAcordEditionsEditionIdFieldDatakeyBindingsResponseError = (postApiAdminAcordEditionsEditionIdFieldDatakeyBindingsResponse401 | postApiAdminAcordEditionsEditionIdFieldDatakeyBindingsResponse402) & {
  headers: Headers;
};

export type postApiAdminAcordEditionsEditionIdFieldDatakeyBindingsResponse = (postApiAdminAcordEditionsEditionIdFieldDatakeyBindingsResponseSuccess | postApiAdminAcordEditionsEditionIdFieldDatakeyBindingsResponseError)

export const getPostApiAdminAcordEditionsEditionIdFieldDatakeyBindingsUrl = (editionId: string,) => {




  return `/api/admin/acord/editions/${editionId}/field-datakey-bindings`
}

export const postApiAdminAcordEditionsEditionIdFieldDatakeyBindings = async (editionId: string,
    upsertAcordFieldDataKeyBindingRequest: UpsertAcordFieldDataKeyBindingRequest, options?: RequestInit): Promise<postApiAdminAcordEditionsEditionIdFieldDatakeyBindingsResponse> => {

  return fetcher<postApiAdminAcordEditionsEditionIdFieldDatakeyBindingsResponse>(getPostApiAdminAcordEditionsEditionIdFieldDatakeyBindingsUrl(editionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upsertAcordFieldDataKeyBindingRequest,)
  }
);}



export type getApiAdminAcordEditionsEditionIdViewerResponse200 = {
  data: void
  status: 200
}

export type getApiAdminAcordEditionsEditionIdViewerResponse401 = {
  data: GetApiAdminAcordEditionsEditionIdViewer401
  status: 401
}

export type getApiAdminAcordEditionsEditionIdViewerResponseSuccess = (getApiAdminAcordEditionsEditionIdViewerResponse200) & {
  headers: Headers;
};
export type getApiAdminAcordEditionsEditionIdViewerResponseError = (getApiAdminAcordEditionsEditionIdViewerResponse401) & {
  headers: Headers;
};

export type getApiAdminAcordEditionsEditionIdViewerResponse = (getApiAdminAcordEditionsEditionIdViewerResponseSuccess | getApiAdminAcordEditionsEditionIdViewerResponseError)

export const getGetApiAdminAcordEditionsEditionIdViewerUrl = (editionId: string,) => {




  return `/api/admin/acord/editions/${editionId}/viewer`
}

export const getApiAdminAcordEditionsEditionIdViewer = async (editionId: string, options?: RequestInit): Promise<getApiAdminAcordEditionsEditionIdViewerResponse> => {

  return fetcher<getApiAdminAcordEditionsEditionIdViewerResponse>(getGetApiAdminAcordEditionsEditionIdViewerUrl(editionId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiAdminAcordEditionsEditionIdImportRunResponse200 = {
  data: void
  status: 200
}

export type getApiAdminAcordEditionsEditionIdImportRunResponse401 = {
  data: GetApiAdminAcordEditionsEditionIdImportRun401
  status: 401
}

export type getApiAdminAcordEditionsEditionIdImportRunResponseSuccess = (getApiAdminAcordEditionsEditionIdImportRunResponse200) & {
  headers: Headers;
};
export type getApiAdminAcordEditionsEditionIdImportRunResponseError = (getApiAdminAcordEditionsEditionIdImportRunResponse401) & {
  headers: Headers;
};

export type getApiAdminAcordEditionsEditionIdImportRunResponse = (getApiAdminAcordEditionsEditionIdImportRunResponseSuccess | getApiAdminAcordEditionsEditionIdImportRunResponseError)

export const getGetApiAdminAcordEditionsEditionIdImportRunUrl = (editionId: string,) => {




  return `/api/admin/acord/editions/${editionId}/import-run`
}

export const getApiAdminAcordEditionsEditionIdImportRun = async (editionId: string, options?: RequestInit): Promise<getApiAdminAcordEditionsEditionIdImportRunResponse> => {

  return fetcher<getApiAdminAcordEditionsEditionIdImportRunResponse>(getGetApiAdminAcordEditionsEditionIdImportRunUrl(editionId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiAdminAcordEditionsEditionIdUploadResponse200 = {
  data: void
  status: 200
}

export type postApiAdminAcordEditionsEditionIdUploadResponse401 = {
  data: PostApiAdminAcordEditionsEditionIdUpload401
  status: 401
}

export type postApiAdminAcordEditionsEditionIdUploadResponse402 = {
  data: PostApiAdminAcordEditionsEditionIdUpload402
  status: 402
}

export type postApiAdminAcordEditionsEditionIdUploadResponseSuccess = (postApiAdminAcordEditionsEditionIdUploadResponse200) & {
  headers: Headers;
};
export type postApiAdminAcordEditionsEditionIdUploadResponseError = (postApiAdminAcordEditionsEditionIdUploadResponse401 | postApiAdminAcordEditionsEditionIdUploadResponse402) & {
  headers: Headers;
};

export type postApiAdminAcordEditionsEditionIdUploadResponse = (postApiAdminAcordEditionsEditionIdUploadResponseSuccess | postApiAdminAcordEditionsEditionIdUploadResponseError)

export const getPostApiAdminAcordEditionsEditionIdUploadUrl = (editionId: string,) => {




  return `/api/admin/acord/editions/${editionId}/upload`
}

export const postApiAdminAcordEditionsEditionIdUpload = async (editionId: string,
    postApiAdminAcordEditionsEditionIdUploadBody: PostApiAdminAcordEditionsEditionIdUploadBody, options?: RequestInit): Promise<postApiAdminAcordEditionsEditionIdUploadResponse> => {
    const formData = new FormData();
if(postApiAdminAcordEditionsEditionIdUploadBody.file !== undefined) {
 formData.append(`file`, postApiAdminAcordEditionsEditionIdUploadBody.file);
 }

  return fetcher<postApiAdminAcordEditionsEditionIdUploadResponse>(getPostApiAdminAcordEditionsEditionIdUploadUrl(editionId),
  {
    ...options,
    method: 'POST'
    ,
    body:
      formData,
  }
);}



export type postApiAdminAcordProcessResponse200 = {
  data: void
  status: 200
}

export type postApiAdminAcordProcessResponse401 = {
  data: PostApiAdminAcordProcess401
  status: 401
}

export type postApiAdminAcordProcessResponse402 = {
  data: PostApiAdminAcordProcess402
  status: 402
}

export type postApiAdminAcordProcessResponseSuccess = (postApiAdminAcordProcessResponse200) & {
  headers: Headers;
};
export type postApiAdminAcordProcessResponseError = (postApiAdminAcordProcessResponse401 | postApiAdminAcordProcessResponse402) & {
  headers: Headers;
};

export type postApiAdminAcordProcessResponse = (postApiAdminAcordProcessResponseSuccess | postApiAdminAcordProcessResponseError)

export const getPostApiAdminAcordProcessUrl = () => {




  return `/api/admin/acord/process`
}

export const postApiAdminAcordProcess = async (processImportRequest: ProcessImportRequest, options?: RequestInit): Promise<postApiAdminAcordProcessResponse> => {

  return fetcher<postApiAdminAcordProcessResponse>(getPostApiAdminAcordProcessUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      processImportRequest,)
  }
);}



export type postApiAdminAcordImportRunsImportRunIdPrecheckResponse200 = {
  data: void
  status: 200
}

export type postApiAdminAcordImportRunsImportRunIdPrecheckResponse401 = {
  data: PostApiAdminAcordImportRunsImportRunIdPrecheck401
  status: 401
}

export type postApiAdminAcordImportRunsImportRunIdPrecheckResponse402 = {
  data: PostApiAdminAcordImportRunsImportRunIdPrecheck402
  status: 402
}

export type postApiAdminAcordImportRunsImportRunIdPrecheckResponseSuccess = (postApiAdminAcordImportRunsImportRunIdPrecheckResponse200) & {
  headers: Headers;
};
export type postApiAdminAcordImportRunsImportRunIdPrecheckResponseError = (postApiAdminAcordImportRunsImportRunIdPrecheckResponse401 | postApiAdminAcordImportRunsImportRunIdPrecheckResponse402) & {
  headers: Headers;
};

export type postApiAdminAcordImportRunsImportRunIdPrecheckResponse = (postApiAdminAcordImportRunsImportRunIdPrecheckResponseSuccess | postApiAdminAcordImportRunsImportRunIdPrecheckResponseError)

export const getPostApiAdminAcordImportRunsImportRunIdPrecheckUrl = (importRunId: string,) => {




  return `/api/admin/acord/import-runs/${importRunId}/precheck`
}

export const postApiAdminAcordImportRunsImportRunIdPrecheck = async (importRunId: string, options?: RequestInit): Promise<postApiAdminAcordImportRunsImportRunIdPrecheckResponse> => {

  return fetcher<postApiAdminAcordImportRunsImportRunIdPrecheckResponse>(getPostApiAdminAcordImportRunsImportRunIdPrecheckUrl(importRunId),
  {
    ...options,
    method: 'POST'


  }
);}



export type postApiAdminAcordEditionsEditionIdGenerateResponse200 = {
  data: void
  status: 200
}

export type postApiAdminAcordEditionsEditionIdGenerateResponse401 = {
  data: PostApiAdminAcordEditionsEditionIdGenerate401
  status: 401
}

export type postApiAdminAcordEditionsEditionIdGenerateResponse402 = {
  data: PostApiAdminAcordEditionsEditionIdGenerate402
  status: 402
}

export type postApiAdminAcordEditionsEditionIdGenerateResponseSuccess = (postApiAdminAcordEditionsEditionIdGenerateResponse200) & {
  headers: Headers;
};
export type postApiAdminAcordEditionsEditionIdGenerateResponseError = (postApiAdminAcordEditionsEditionIdGenerateResponse401 | postApiAdminAcordEditionsEditionIdGenerateResponse402) & {
  headers: Headers;
};

export type postApiAdminAcordEditionsEditionIdGenerateResponse = (postApiAdminAcordEditionsEditionIdGenerateResponseSuccess | postApiAdminAcordEditionsEditionIdGenerateResponseError)

export const getPostApiAdminAcordEditionsEditionIdGenerateUrl = (editionId: string,) => {




  return `/api/admin/acord/editions/${editionId}/generate`
}

export const postApiAdminAcordEditionsEditionIdGenerate = async (editionId: string,
    nullGenerateFormsRequest: null | GenerateFormsRequest, options?: RequestInit): Promise<postApiAdminAcordEditionsEditionIdGenerateResponse> => {

  return fetcher<postApiAdminAcordEditionsEditionIdGenerateResponse>(getPostApiAdminAcordEditionsEditionIdGenerateUrl(editionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullGenerateFormsRequest,)
  }
);}



export type postApiAdminAcordImportRunResponse200 = {
  data: void
  status: 200
}

export type postApiAdminAcordImportRunResponse401 = {
  data: PostApiAdminAcordImportRun401
  status: 401
}

export type postApiAdminAcordImportRunResponse402 = {
  data: PostApiAdminAcordImportRun402
  status: 402
}

export type postApiAdminAcordImportRunResponseSuccess = (postApiAdminAcordImportRunResponse200) & {
  headers: Headers;
};
export type postApiAdminAcordImportRunResponseError = (postApiAdminAcordImportRunResponse401 | postApiAdminAcordImportRunResponse402) & {
  headers: Headers;
};

export type postApiAdminAcordImportRunResponse = (postApiAdminAcordImportRunResponseSuccess | postApiAdminAcordImportRunResponseError)

export const getPostApiAdminAcordImportRunUrl = () => {




  return `/api/admin/acord/import-run`
}

export const postApiAdminAcordImportRun = async ( options?: RequestInit): Promise<postApiAdminAcordImportRunResponse> => {

  return fetcher<postApiAdminAcordImportRunResponse>(getPostApiAdminAcordImportRunUrl(),
  {
    ...options,
    method: 'POST'


  }
);}



export type postApiAdminAcordImportRunsImportRunIdEnqueueResponse200 = {
  data: void
  status: 200
}

export type postApiAdminAcordImportRunsImportRunIdEnqueueResponse401 = {
  data: PostApiAdminAcordImportRunsImportRunIdEnqueue401
  status: 401
}

export type postApiAdminAcordImportRunsImportRunIdEnqueueResponse402 = {
  data: PostApiAdminAcordImportRunsImportRunIdEnqueue402
  status: 402
}

export type postApiAdminAcordImportRunsImportRunIdEnqueueResponseSuccess = (postApiAdminAcordImportRunsImportRunIdEnqueueResponse200) & {
  headers: Headers;
};
export type postApiAdminAcordImportRunsImportRunIdEnqueueResponseError = (postApiAdminAcordImportRunsImportRunIdEnqueueResponse401 | postApiAdminAcordImportRunsImportRunIdEnqueueResponse402) & {
  headers: Headers;
};

export type postApiAdminAcordImportRunsImportRunIdEnqueueResponse = (postApiAdminAcordImportRunsImportRunIdEnqueueResponseSuccess | postApiAdminAcordImportRunsImportRunIdEnqueueResponseError)

export const getPostApiAdminAcordImportRunsImportRunIdEnqueueUrl = (importRunId: string,) => {




  return `/api/admin/acord/import-runs/${importRunId}/enqueue`
}

export const postApiAdminAcordImportRunsImportRunIdEnqueue = async (importRunId: string, options?: RequestInit): Promise<postApiAdminAcordImportRunsImportRunIdEnqueueResponse> => {

  return fetcher<postApiAdminAcordImportRunsImportRunIdEnqueueResponse>(getPostApiAdminAcordImportRunsImportRunIdEnqueueUrl(importRunId),
  {
    ...options,
    method: 'POST'


  }
);}



export type getApiAdminAcordImportsFileIdDetailsResponse200 = {
  data: void
  status: 200
}

export type getApiAdminAcordImportsFileIdDetailsResponse401 = {
  data: GetApiAdminAcordImportsFileIdDetails401
  status: 401
}

export type getApiAdminAcordImportsFileIdDetailsResponseSuccess = (getApiAdminAcordImportsFileIdDetailsResponse200) & {
  headers: Headers;
};
export type getApiAdminAcordImportsFileIdDetailsResponseError = (getApiAdminAcordImportsFileIdDetailsResponse401) & {
  headers: Headers;
};

export type getApiAdminAcordImportsFileIdDetailsResponse = (getApiAdminAcordImportsFileIdDetailsResponseSuccess | getApiAdminAcordImportsFileIdDetailsResponseError)

export const getGetApiAdminAcordImportsFileIdDetailsUrl = (fileId: string,) => {




  return `/api/admin/acord/imports/${fileId}/details`
}

export const getApiAdminAcordImportsFileIdDetails = async (fileId: string, options?: RequestInit): Promise<getApiAdminAcordImportsFileIdDetailsResponse> => {

  return fetcher<getApiAdminAcordImportsFileIdDetailsResponse>(getGetApiAdminAcordImportsFileIdDetailsUrl(fileId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiAdminAcordImportsFileIdEditionsResponse200 = {
  data: void
  status: 200
}

export type getApiAdminAcordImportsFileIdEditionsResponse401 = {
  data: GetApiAdminAcordImportsFileIdEditions401
  status: 401
}

export type getApiAdminAcordImportsFileIdEditionsResponseSuccess = (getApiAdminAcordImportsFileIdEditionsResponse200) & {
  headers: Headers;
};
export type getApiAdminAcordImportsFileIdEditionsResponseError = (getApiAdminAcordImportsFileIdEditionsResponse401) & {
  headers: Headers;
};

export type getApiAdminAcordImportsFileIdEditionsResponse = (getApiAdminAcordImportsFileIdEditionsResponseSuccess | getApiAdminAcordImportsFileIdEditionsResponseError)

export const getGetApiAdminAcordImportsFileIdEditionsUrl = (fileId: string,) => {




  return `/api/admin/acord/imports/${fileId}/editions`
}

export const getApiAdminAcordImportsFileIdEditions = async (fileId: string, options?: RequestInit): Promise<getApiAdminAcordImportsFileIdEditionsResponse> => {

  return fetcher<getApiAdminAcordImportsFileIdEditionsResponse>(getGetApiAdminAcordImportsFileIdEditionsUrl(fileId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiAdminAcordImportsFileIdEventsResponse200 = {
  data: void
  status: 200
}

export type getApiAdminAcordImportsFileIdEventsResponse401 = {
  data: GetApiAdminAcordImportsFileIdEvents401
  status: 401
}

export type getApiAdminAcordImportsFileIdEventsResponseSuccess = (getApiAdminAcordImportsFileIdEventsResponse200) & {
  headers: Headers;
};
export type getApiAdminAcordImportsFileIdEventsResponseError = (getApiAdminAcordImportsFileIdEventsResponse401) & {
  headers: Headers;
};

export type getApiAdminAcordImportsFileIdEventsResponse = (getApiAdminAcordImportsFileIdEventsResponseSuccess | getApiAdminAcordImportsFileIdEventsResponseError)

export const getGetApiAdminAcordImportsFileIdEventsUrl = (fileId: string,
    params?: GetApiAdminAcordImportsFileIdEventsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/acord/imports/${fileId}/events?${stringifiedParams}` : `/api/admin/acord/imports/${fileId}/events`
}

export const getApiAdminAcordImportsFileIdEvents = async (fileId: string,
    params?: GetApiAdminAcordImportsFileIdEventsParams, options?: RequestInit): Promise<getApiAdminAcordImportsFileIdEventsResponse> => {

  return fetcher<getApiAdminAcordImportsFileIdEventsResponse>(getGetApiAdminAcordImportsFileIdEventsUrl(fileId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiAdminAcordImportsResponse200 = {
  data: void
  status: 200
}

export type getApiAdminAcordImportsResponse401 = {
  data: GetApiAdminAcordImports401
  status: 401
}

export type getApiAdminAcordImportsResponseSuccess = (getApiAdminAcordImportsResponse200) & {
  headers: Headers;
};
export type getApiAdminAcordImportsResponseError = (getApiAdminAcordImportsResponse401) & {
  headers: Headers;
};

export type getApiAdminAcordImportsResponse = (getApiAdminAcordImportsResponseSuccess | getApiAdminAcordImportsResponseError)

export const getGetApiAdminAcordImportsUrl = (params?: GetApiAdminAcordImportsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/acord/imports?${stringifiedParams}` : `/api/admin/acord/imports`
}

export const getApiAdminAcordImports = async (params?: GetApiAdminAcordImportsParams, options?: RequestInit): Promise<getApiAdminAcordImportsResponse> => {

  return fetcher<getApiAdminAcordImportsResponse>(getGetApiAdminAcordImportsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiAdminAcordFormsRegenFormRegenRunIdEventsResponse200 = {
  data: void
  status: 200
}

export type getApiAdminAcordFormsRegenFormRegenRunIdEventsResponse401 = {
  data: GetApiAdminAcordFormsRegenFormRegenRunIdEvents401
  status: 401
}

export type getApiAdminAcordFormsRegenFormRegenRunIdEventsResponseSuccess = (getApiAdminAcordFormsRegenFormRegenRunIdEventsResponse200) & {
  headers: Headers;
};
export type getApiAdminAcordFormsRegenFormRegenRunIdEventsResponseError = (getApiAdminAcordFormsRegenFormRegenRunIdEventsResponse401) & {
  headers: Headers;
};

export type getApiAdminAcordFormsRegenFormRegenRunIdEventsResponse = (getApiAdminAcordFormsRegenFormRegenRunIdEventsResponseSuccess | getApiAdminAcordFormsRegenFormRegenRunIdEventsResponseError)

export const getGetApiAdminAcordFormsRegenFormRegenRunIdEventsUrl = (formRegenRunId: string,) => {




  return `/api/admin/acord/forms/regen/${formRegenRunId}/events`
}

export const getApiAdminAcordFormsRegenFormRegenRunIdEvents = async (formRegenRunId: string, options?: RequestInit): Promise<getApiAdminAcordFormsRegenFormRegenRunIdEventsResponse> => {

  return fetcher<getApiAdminAcordFormsRegenFormRegenRunIdEventsResponse>(getGetApiAdminAcordFormsRegenFormRegenRunIdEventsUrl(formRegenRunId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiAdminAcordFormsRegenFormRegenRunIdResponse200 = {
  data: void
  status: 200
}

export type getApiAdminAcordFormsRegenFormRegenRunIdResponse401 = {
  data: GetApiAdminAcordFormsRegenFormRegenRunId401
  status: 401
}

export type getApiAdminAcordFormsRegenFormRegenRunIdResponseSuccess = (getApiAdminAcordFormsRegenFormRegenRunIdResponse200) & {
  headers: Headers;
};
export type getApiAdminAcordFormsRegenFormRegenRunIdResponseError = (getApiAdminAcordFormsRegenFormRegenRunIdResponse401) & {
  headers: Headers;
};

export type getApiAdminAcordFormsRegenFormRegenRunIdResponse = (getApiAdminAcordFormsRegenFormRegenRunIdResponseSuccess | getApiAdminAcordFormsRegenFormRegenRunIdResponseError)

export const getGetApiAdminAcordFormsRegenFormRegenRunIdUrl = (formRegenRunId: string,) => {




  return `/api/admin/acord/forms/regen/${formRegenRunId}`
}

export const getApiAdminAcordFormsRegenFormRegenRunId = async (formRegenRunId: string, options?: RequestInit): Promise<getApiAdminAcordFormsRegenFormRegenRunIdResponse> => {

  return fetcher<getApiAdminAcordFormsRegenFormRegenRunIdResponse>(getGetApiAdminAcordFormsRegenFormRegenRunIdUrl(formRegenRunId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiAdminAcrobatsignTestResponse200 = {
  data: void
  status: 200
}

export type postApiAdminAcrobatsignTestResponse401 = {
  data: PostApiAdminAcrobatsignTest401
  status: 401
}

export type postApiAdminAcrobatsignTestResponse402 = {
  data: PostApiAdminAcrobatsignTest402
  status: 402
}

export type postApiAdminAcrobatsignTestResponseSuccess = (postApiAdminAcrobatsignTestResponse200) & {
  headers: Headers;
};
export type postApiAdminAcrobatsignTestResponseError = (postApiAdminAcrobatsignTestResponse401 | postApiAdminAcrobatsignTestResponse402) & {
  headers: Headers;
};

export type postApiAdminAcrobatsignTestResponse = (postApiAdminAcrobatsignTestResponseSuccess | postApiAdminAcrobatsignTestResponseError)

export const getPostApiAdminAcrobatsignTestUrl = () => {




  return `/api/admin/acrobatsign/test`
}

export const postApiAdminAcrobatsignTest = async (testRequest: TestRequest, options?: RequestInit): Promise<postApiAdminAcrobatsignTestResponse> => {

  return fetcher<postApiAdminAcrobatsignTestResponse>(getPostApiAdminAcrobatsignTestUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      testRequest,)
  }
);}



export type getApiAdminAppFilesResponse200 = {
  data: void
  status: 200
}

export type getApiAdminAppFilesResponse401 = {
  data: GetApiAdminAppFiles401
  status: 401
}

export type getApiAdminAppFilesResponseSuccess = (getApiAdminAppFilesResponse200) & {
  headers: Headers;
};
export type getApiAdminAppFilesResponseError = (getApiAdminAppFilesResponse401) & {
  headers: Headers;
};

export type getApiAdminAppFilesResponse = (getApiAdminAppFilesResponseSuccess | getApiAdminAppFilesResponseError)

export const getGetApiAdminAppFilesUrl = (params?: GetApiAdminAppFilesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/app-files?${stringifiedParams}` : `/api/admin/app-files`
}

export const getApiAdminAppFiles = async (params?: GetApiAdminAppFilesParams, options?: RequestInit): Promise<getApiAdminAppFilesResponse> => {

  return fetcher<getApiAdminAppFilesResponse>(getGetApiAdminAppFilesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiAdminAppFilesFromBlobResponse200 = {
  data: void
  status: 200
}

export type postApiAdminAppFilesFromBlobResponse401 = {
  data: PostApiAdminAppFilesFromBlob401
  status: 401
}

export type postApiAdminAppFilesFromBlobResponse402 = {
  data: PostApiAdminAppFilesFromBlob402
  status: 402
}

export type postApiAdminAppFilesFromBlobResponseSuccess = (postApiAdminAppFilesFromBlobResponse200) & {
  headers: Headers;
};
export type postApiAdminAppFilesFromBlobResponseError = (postApiAdminAppFilesFromBlobResponse401 | postApiAdminAppFilesFromBlobResponse402) & {
  headers: Headers;
};

export type postApiAdminAppFilesFromBlobResponse = (postApiAdminAppFilesFromBlobResponseSuccess | postApiAdminAppFilesFromBlobResponseError)

export const getPostApiAdminAppFilesFromBlobUrl = () => {




  return `/api/admin/app-files/from-blob`
}

export const postApiAdminAppFilesFromBlob = async (createFromBlobRequest: CreateFromBlobRequest, options?: RequestInit): Promise<postApiAdminAppFilesFromBlobResponse> => {

  return fetcher<postApiAdminAppFilesFromBlobResponse>(getPostApiAdminAppFilesFromBlobUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createFromBlobRequest,)
  }
);}



export type deleteApiAdminAppFilesFileIdResponse200 = {
  data: void
  status: 200
}

export type deleteApiAdminAppFilesFileIdResponse401 = {
  data: DeleteApiAdminAppFilesFileId401
  status: 401
}

export type deleteApiAdminAppFilesFileIdResponse402 = {
  data: DeleteApiAdminAppFilesFileId402
  status: 402
}

export type deleteApiAdminAppFilesFileIdResponseSuccess = (deleteApiAdminAppFilesFileIdResponse200) & {
  headers: Headers;
};
export type deleteApiAdminAppFilesFileIdResponseError = (deleteApiAdminAppFilesFileIdResponse401 | deleteApiAdminAppFilesFileIdResponse402) & {
  headers: Headers;
};

export type deleteApiAdminAppFilesFileIdResponse = (deleteApiAdminAppFilesFileIdResponseSuccess | deleteApiAdminAppFilesFileIdResponseError)

export const getDeleteApiAdminAppFilesFileIdUrl = (fileId: string,) => {




  return `/api/admin/app-files/${fileId}`
}

export const deleteApiAdminAppFilesFileId = async (fileId: string, options?: RequestInit): Promise<deleteApiAdminAppFilesFileIdResponse> => {

  return fetcher<deleteApiAdminAppFilesFileIdResponse>(getDeleteApiAdminAppFilesFileIdUrl(fileId),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type postApiAdminAppFilesFileIdRestoreResponse200 = {
  data: void
  status: 200
}

export type postApiAdminAppFilesFileIdRestoreResponse401 = {
  data: PostApiAdminAppFilesFileIdRestore401
  status: 401
}

export type postApiAdminAppFilesFileIdRestoreResponse402 = {
  data: PostApiAdminAppFilesFileIdRestore402
  status: 402
}

export type postApiAdminAppFilesFileIdRestoreResponseSuccess = (postApiAdminAppFilesFileIdRestoreResponse200) & {
  headers: Headers;
};
export type postApiAdminAppFilesFileIdRestoreResponseError = (postApiAdminAppFilesFileIdRestoreResponse401 | postApiAdminAppFilesFileIdRestoreResponse402) & {
  headers: Headers;
};

export type postApiAdminAppFilesFileIdRestoreResponse = (postApiAdminAppFilesFileIdRestoreResponseSuccess | postApiAdminAppFilesFileIdRestoreResponseError)

export const getPostApiAdminAppFilesFileIdRestoreUrl = (fileId: string,) => {




  return `/api/admin/app-files/${fileId}/restore`
}

export const postApiAdminAppFilesFileIdRestore = async (fileId: string, options?: RequestInit): Promise<postApiAdminAppFilesFileIdRestoreResponse> => {

  return fetcher<postApiAdminAppFilesFileIdRestoreResponse>(getPostApiAdminAppFilesFileIdRestoreUrl(fileId),
  {
    ...options,
    method: 'POST'


  }
);}



export type deleteApiAdminAppFilesFileIdHardResponse200 = {
  data: void
  status: 200
}

export type deleteApiAdminAppFilesFileIdHardResponse401 = {
  data: DeleteApiAdminAppFilesFileIdHard401
  status: 401
}

export type deleteApiAdminAppFilesFileIdHardResponse402 = {
  data: DeleteApiAdminAppFilesFileIdHard402
  status: 402
}

export type deleteApiAdminAppFilesFileIdHardResponseSuccess = (deleteApiAdminAppFilesFileIdHardResponse200) & {
  headers: Headers;
};
export type deleteApiAdminAppFilesFileIdHardResponseError = (deleteApiAdminAppFilesFileIdHardResponse401 | deleteApiAdminAppFilesFileIdHardResponse402) & {
  headers: Headers;
};

export type deleteApiAdminAppFilesFileIdHardResponse = (deleteApiAdminAppFilesFileIdHardResponseSuccess | deleteApiAdminAppFilesFileIdHardResponseError)

export const getDeleteApiAdminAppFilesFileIdHardUrl = (fileId: string,) => {




  return `/api/admin/app-files/${fileId}/hard`
}

export const deleteApiAdminAppFilesFileIdHard = async (fileId: string, options?: RequestInit): Promise<deleteApiAdminAppFilesFileIdHardResponse> => {

  return fetcher<deleteApiAdminAppFilesFileIdHardResponse>(getDeleteApiAdminAppFilesFileIdHardUrl(fileId),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type getApiAdminAppFilesFileIdContentResponse200 = {
  data: void
  status: 200
}

export type getApiAdminAppFilesFileIdContentResponse401 = {
  data: GetApiAdminAppFilesFileIdContent401
  status: 401
}

export type getApiAdminAppFilesFileIdContentResponseSuccess = (getApiAdminAppFilesFileIdContentResponse200) & {
  headers: Headers;
};
export type getApiAdminAppFilesFileIdContentResponseError = (getApiAdminAppFilesFileIdContentResponse401) & {
  headers: Headers;
};

export type getApiAdminAppFilesFileIdContentResponse = (getApiAdminAppFilesFileIdContentResponseSuccess | getApiAdminAppFilesFileIdContentResponseError)

export const getGetApiAdminAppFilesFileIdContentUrl = (fileId: string,
    params?: GetApiAdminAppFilesFileIdContentParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/app-files/${fileId}/content?${stringifiedParams}` : `/api/admin/app-files/${fileId}/content`
}

export const getApiAdminAppFilesFileIdContent = async (fileId: string,
    params?: GetApiAdminAppFilesFileIdContentParams, options?: RequestInit): Promise<getApiAdminAppFilesFileIdContentResponse> => {

  return fetcher<getApiAdminAppFilesFileIdContentResponse>(getGetApiAdminAppFilesFileIdContentUrl(fileId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiAdminCarrierCatalogResponse200 = {
  data: void
  status: 200
}

export type getApiAdminCarrierCatalogResponse401 = {
  data: GetApiAdminCarrierCatalog401
  status: 401
}

export type getApiAdminCarrierCatalogResponseSuccess = (getApiAdminCarrierCatalogResponse200) & {
  headers: Headers;
};
export type getApiAdminCarrierCatalogResponseError = (getApiAdminCarrierCatalogResponse401) & {
  headers: Headers;
};

export type getApiAdminCarrierCatalogResponse = (getApiAdminCarrierCatalogResponseSuccess | getApiAdminCarrierCatalogResponseError)

export const getGetApiAdminCarrierCatalogUrl = (params?: GetApiAdminCarrierCatalogParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/carrier-catalog?${stringifiedParams}` : `/api/admin/carrier-catalog`
}

export const getApiAdminCarrierCatalog = async (params?: GetApiAdminCarrierCatalogParams, options?: RequestInit): Promise<getApiAdminCarrierCatalogResponse> => {

  return fetcher<getApiAdminCarrierCatalogResponse>(getGetApiAdminCarrierCatalogUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiAdminCarrierCatalogResponse200TextPlain = {
  data: AdminCarrierCatalogPayload
  status: 200
}

export type postApiAdminCarrierCatalogResponse200ApplicationJson = {
  data: AdminCarrierCatalogPayload
  status: 200
}

export type postApiAdminCarrierCatalogResponse200TextJson = {
  data: AdminCarrierCatalogPayload
  status: 200
}

export type postApiAdminCarrierCatalogResponse401 = {
  data: PostApiAdminCarrierCatalog401
  status: 401
}

export type postApiAdminCarrierCatalogResponse402 = {
  data: PostApiAdminCarrierCatalog402
  status: 402
}

export type postApiAdminCarrierCatalogResponseSuccess = (postApiAdminCarrierCatalogResponse200TextPlain | postApiAdminCarrierCatalogResponse200ApplicationJson | postApiAdminCarrierCatalogResponse200TextJson) & {
  headers: Headers;
};
export type postApiAdminCarrierCatalogResponseError = (postApiAdminCarrierCatalogResponse401 | postApiAdminCarrierCatalogResponse402) & {
  headers: Headers;
};

export type postApiAdminCarrierCatalogResponse = (postApiAdminCarrierCatalogResponseSuccess | postApiAdminCarrierCatalogResponseError)

export const getPostApiAdminCarrierCatalogUrl = () => {




  return `/api/admin/carrier-catalog`
}

export const postApiAdminCarrierCatalog = async (nullUpsertCarrierCatalogRequest: null | UpsertCarrierCatalogRequest, options?: RequestInit): Promise<postApiAdminCarrierCatalogResponse> => {

  return fetcher<postApiAdminCarrierCatalogResponse>(getPostApiAdminCarrierCatalogUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullUpsertCarrierCatalogRequest,)
  }
);}



export type putApiAdminCarrierCatalogCarrierCatalogIdResponse200TextPlain = {
  data: AdminCarrierCatalogPayload
  status: 200
}

export type putApiAdminCarrierCatalogCarrierCatalogIdResponse200ApplicationJson = {
  data: AdminCarrierCatalogPayload
  status: 200
}

export type putApiAdminCarrierCatalogCarrierCatalogIdResponse200TextJson = {
  data: AdminCarrierCatalogPayload
  status: 200
}

export type putApiAdminCarrierCatalogCarrierCatalogIdResponse401 = {
  data: PutApiAdminCarrierCatalogCarrierCatalogId401
  status: 401
}

export type putApiAdminCarrierCatalogCarrierCatalogIdResponse402 = {
  data: PutApiAdminCarrierCatalogCarrierCatalogId402
  status: 402
}

export type putApiAdminCarrierCatalogCarrierCatalogIdResponseSuccess = (putApiAdminCarrierCatalogCarrierCatalogIdResponse200TextPlain | putApiAdminCarrierCatalogCarrierCatalogIdResponse200ApplicationJson | putApiAdminCarrierCatalogCarrierCatalogIdResponse200TextJson) & {
  headers: Headers;
};
export type putApiAdminCarrierCatalogCarrierCatalogIdResponseError = (putApiAdminCarrierCatalogCarrierCatalogIdResponse401 | putApiAdminCarrierCatalogCarrierCatalogIdResponse402) & {
  headers: Headers;
};

export type putApiAdminCarrierCatalogCarrierCatalogIdResponse = (putApiAdminCarrierCatalogCarrierCatalogIdResponseSuccess | putApiAdminCarrierCatalogCarrierCatalogIdResponseError)

export const getPutApiAdminCarrierCatalogCarrierCatalogIdUrl = (carrierCatalogId: string,) => {




  return `/api/admin/carrier-catalog/${carrierCatalogId}`
}

export const putApiAdminCarrierCatalogCarrierCatalogId = async (carrierCatalogId: string,
    nullUpsertCarrierCatalogRequest: null | UpsertCarrierCatalogRequest, options?: RequestInit): Promise<putApiAdminCarrierCatalogCarrierCatalogIdResponse> => {

  return fetcher<putApiAdminCarrierCatalogCarrierCatalogIdResponse>(getPutApiAdminCarrierCatalogCarrierCatalogIdUrl(carrierCatalogId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullUpsertCarrierCatalogRequest,)
  }
);}



export type getApiAdminDemoAccountsResponse200TextPlain = {
  data: AdminDemoAccountListItemDto[]
  status: 200
}

export type getApiAdminDemoAccountsResponse200ApplicationJson = {
  data: AdminDemoAccountListItemDto[]
  status: 200
}

export type getApiAdminDemoAccountsResponse200TextJson = {
  data: AdminDemoAccountListItemDto[]
  status: 200
}

export type getApiAdminDemoAccountsResponse401 = {
  data: GetApiAdminDemoAccounts401
  status: 401
}

export type getApiAdminDemoAccountsResponse402 = {
  data: GetApiAdminDemoAccounts402
  status: 402
}

export type getApiAdminDemoAccountsResponseSuccess = (getApiAdminDemoAccountsResponse200TextPlain | getApiAdminDemoAccountsResponse200ApplicationJson | getApiAdminDemoAccountsResponse200TextJson) & {
  headers: Headers;
};
export type getApiAdminDemoAccountsResponseError = (getApiAdminDemoAccountsResponse401 | getApiAdminDemoAccountsResponse402) & {
  headers: Headers;
};

export type getApiAdminDemoAccountsResponse = (getApiAdminDemoAccountsResponseSuccess | getApiAdminDemoAccountsResponseError)

export const getGetApiAdminDemoAccountsUrl = () => {




  return `/api/admin/demo-accounts`
}

export const getApiAdminDemoAccounts = async ( options?: RequestInit): Promise<getApiAdminDemoAccountsResponse> => {

  return fetcher<getApiAdminDemoAccountsResponse>(getGetApiAdminDemoAccountsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiAdminDemoAccountsResponse200TextPlain = {
  data: AdminDemoAccountDto
  status: 200
}

export type postApiAdminDemoAccountsResponse200ApplicationJson = {
  data: AdminDemoAccountDto
  status: 200
}

export type postApiAdminDemoAccountsResponse200TextJson = {
  data: AdminDemoAccountDto
  status: 200
}

export type postApiAdminDemoAccountsResponse401 = {
  data: PostApiAdminDemoAccounts401
  status: 401
}

export type postApiAdminDemoAccountsResponse402 = {
  data: PostApiAdminDemoAccounts402
  status: 402
}

export type postApiAdminDemoAccountsResponseSuccess = (postApiAdminDemoAccountsResponse200TextPlain | postApiAdminDemoAccountsResponse200ApplicationJson | postApiAdminDemoAccountsResponse200TextJson) & {
  headers: Headers;
};
export type postApiAdminDemoAccountsResponseError = (postApiAdminDemoAccountsResponse401 | postApiAdminDemoAccountsResponse402) & {
  headers: Headers;
};

export type postApiAdminDemoAccountsResponse = (postApiAdminDemoAccountsResponseSuccess | postApiAdminDemoAccountsResponseError)

export const getPostApiAdminDemoAccountsUrl = () => {




  return `/api/admin/demo-accounts`
}

export const postApiAdminDemoAccounts = async (nullCreateAdminDemoAccountRequestDto: null | CreateAdminDemoAccountRequestDto, options?: RequestInit): Promise<postApiAdminDemoAccountsResponse> => {

  return fetcher<postApiAdminDemoAccountsResponse>(getPostApiAdminDemoAccountsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullCreateAdminDemoAccountRequestDto,)
  }
);}



export type postApiAdminDemoAccountsTeamIdPasswordResponse200TextPlain = {
  data: AdminDemoAccountDto
  status: 200
}

export type postApiAdminDemoAccountsTeamIdPasswordResponse200ApplicationJson = {
  data: AdminDemoAccountDto
  status: 200
}

export type postApiAdminDemoAccountsTeamIdPasswordResponse200TextJson = {
  data: AdminDemoAccountDto
  status: 200
}

export type postApiAdminDemoAccountsTeamIdPasswordResponse401 = {
  data: PostApiAdminDemoAccountsTeamIdPassword401
  status: 401
}

export type postApiAdminDemoAccountsTeamIdPasswordResponse402 = {
  data: PostApiAdminDemoAccountsTeamIdPassword402
  status: 402
}

export type postApiAdminDemoAccountsTeamIdPasswordResponseSuccess = (postApiAdminDemoAccountsTeamIdPasswordResponse200TextPlain | postApiAdminDemoAccountsTeamIdPasswordResponse200ApplicationJson | postApiAdminDemoAccountsTeamIdPasswordResponse200TextJson) & {
  headers: Headers;
};
export type postApiAdminDemoAccountsTeamIdPasswordResponseError = (postApiAdminDemoAccountsTeamIdPasswordResponse401 | postApiAdminDemoAccountsTeamIdPasswordResponse402) & {
  headers: Headers;
};

export type postApiAdminDemoAccountsTeamIdPasswordResponse = (postApiAdminDemoAccountsTeamIdPasswordResponseSuccess | postApiAdminDemoAccountsTeamIdPasswordResponseError)

export const getPostApiAdminDemoAccountsTeamIdPasswordUrl = (teamId: string,) => {




  return `/api/admin/demo-accounts/${teamId}/password`
}

export const postApiAdminDemoAccountsTeamIdPassword = async (teamId: string, options?: RequestInit): Promise<postApiAdminDemoAccountsTeamIdPasswordResponse> => {

  return fetcher<postApiAdminDemoAccountsTeamIdPasswordResponse>(getPostApiAdminDemoAccountsTeamIdPasswordUrl(teamId),
  {
    ...options,
    method: 'POST'


  }
);}



export type deleteApiAdminDemoAccountsTeamIdResponse200TextPlain = {
  data: AdminDemoAccountDto
  status: 200
}

export type deleteApiAdminDemoAccountsTeamIdResponse200ApplicationJson = {
  data: AdminDemoAccountDto
  status: 200
}

export type deleteApiAdminDemoAccountsTeamIdResponse200TextJson = {
  data: AdminDemoAccountDto
  status: 200
}

export type deleteApiAdminDemoAccountsTeamIdResponse401 = {
  data: DeleteApiAdminDemoAccountsTeamId401
  status: 401
}

export type deleteApiAdminDemoAccountsTeamIdResponse402 = {
  data: DeleteApiAdminDemoAccountsTeamId402
  status: 402
}

export type deleteApiAdminDemoAccountsTeamIdResponseSuccess = (deleteApiAdminDemoAccountsTeamIdResponse200TextPlain | deleteApiAdminDemoAccountsTeamIdResponse200ApplicationJson | deleteApiAdminDemoAccountsTeamIdResponse200TextJson) & {
  headers: Headers;
};
export type deleteApiAdminDemoAccountsTeamIdResponseError = (deleteApiAdminDemoAccountsTeamIdResponse401 | deleteApiAdminDemoAccountsTeamIdResponse402) & {
  headers: Headers;
};

export type deleteApiAdminDemoAccountsTeamIdResponse = (deleteApiAdminDemoAccountsTeamIdResponseSuccess | deleteApiAdminDemoAccountsTeamIdResponseError)

export const getDeleteApiAdminDemoAccountsTeamIdUrl = (teamId: string,) => {




  return `/api/admin/demo-accounts/${teamId}`
}

export const deleteApiAdminDemoAccountsTeamId = async (teamId: string, options?: RequestInit): Promise<deleteApiAdminDemoAccountsTeamIdResponse> => {

  return fetcher<deleteApiAdminDemoAccountsTeamIdResponse>(getDeleteApiAdminDemoAccountsTeamIdUrl(teamId),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type postApiAdminDocusignTestResponse200 = {
  data: void
  status: 200
}

export type postApiAdminDocusignTestResponse401 = {
  data: PostApiAdminDocusignTest401
  status: 401
}

export type postApiAdminDocusignTestResponse402 = {
  data: PostApiAdminDocusignTest402
  status: 402
}

export type postApiAdminDocusignTestResponseSuccess = (postApiAdminDocusignTestResponse200) & {
  headers: Headers;
};
export type postApiAdminDocusignTestResponseError = (postApiAdminDocusignTestResponse401 | postApiAdminDocusignTestResponse402) & {
  headers: Headers;
};

export type postApiAdminDocusignTestResponse = (postApiAdminDocusignTestResponseSuccess | postApiAdminDocusignTestResponseError)

export const getPostApiAdminDocusignTestUrl = () => {




  return `/api/admin/docusign/test`
}

export const postApiAdminDocusignTest = async (testRequest: TestRequest, options?: RequestInit): Promise<postApiAdminDocusignTestResponse> => {

  return fetcher<postApiAdminDocusignTestResponse>(getPostApiAdminDocusignTestUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      testRequest,)
  }
);}



export type getApiAdminEmailTemplatesResponse200 = {
  data: void
  status: 200
}

export type getApiAdminEmailTemplatesResponse401 = {
  data: GetApiAdminEmailTemplates401
  status: 401
}

export type getApiAdminEmailTemplatesResponseSuccess = (getApiAdminEmailTemplatesResponse200) & {
  headers: Headers;
};
export type getApiAdminEmailTemplatesResponseError = (getApiAdminEmailTemplatesResponse401) & {
  headers: Headers;
};

export type getApiAdminEmailTemplatesResponse = (getApiAdminEmailTemplatesResponseSuccess | getApiAdminEmailTemplatesResponseError)

export const getGetApiAdminEmailTemplatesUrl = () => {




  return `/api/admin/email/templates`
}

export const getApiAdminEmailTemplates = async ( options?: RequestInit): Promise<getApiAdminEmailTemplatesResponse> => {

  return fetcher<getApiAdminEmailTemplatesResponse>(getGetApiAdminEmailTemplatesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdEmailTemplatesResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdEmailTemplatesResponse401 = {
  data: GetApiTeamsTeamIdEmailTemplates401
  status: 401
}

export type getApiTeamsTeamIdEmailTemplatesResponseSuccess = (getApiTeamsTeamIdEmailTemplatesResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdEmailTemplatesResponseError = (getApiTeamsTeamIdEmailTemplatesResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdEmailTemplatesResponse = (getApiTeamsTeamIdEmailTemplatesResponseSuccess | getApiTeamsTeamIdEmailTemplatesResponseError)

export const getGetApiTeamsTeamIdEmailTemplatesUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/email/templates`
}

export const getApiTeamsTeamIdEmailTemplates = async (teamId: string, options?: RequestInit): Promise<getApiTeamsTeamIdEmailTemplatesResponse> => {

  return fetcher<getApiTeamsTeamIdEmailTemplatesResponse>(getGetApiTeamsTeamIdEmailTemplatesUrl(teamId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiAdminEmailTestResponse200 = {
  data: void
  status: 200
}

export type postApiAdminEmailTestResponse401 = {
  data: PostApiAdminEmailTest401
  status: 401
}

export type postApiAdminEmailTestResponse402 = {
  data: PostApiAdminEmailTest402
  status: 402
}

export type postApiAdminEmailTestResponseSuccess = (postApiAdminEmailTestResponse200) & {
  headers: Headers;
};
export type postApiAdminEmailTestResponseError = (postApiAdminEmailTestResponse401 | postApiAdminEmailTestResponse402) & {
  headers: Headers;
};

export type postApiAdminEmailTestResponse = (postApiAdminEmailTestResponseSuccess | postApiAdminEmailTestResponseError)

export const getPostApiAdminEmailTestUrl = () => {




  return `/api/admin/email/test`
}

export const postApiAdminEmailTest = async (testEmailRequest: TestEmailRequest, options?: RequestInit): Promise<postApiAdminEmailTestResponse> => {

  return fetcher<postApiAdminEmailTestResponse>(getPostApiAdminEmailTestUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      testEmailRequest,)
  }
);}



export type postApiTeamsTeamIdEmailTestResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdEmailTestResponse401 = {
  data: PostApiTeamsTeamIdEmailTest401
  status: 401
}

export type postApiTeamsTeamIdEmailTestResponse402 = {
  data: PostApiTeamsTeamIdEmailTest402
  status: 402
}

export type postApiTeamsTeamIdEmailTestResponseSuccess = (postApiTeamsTeamIdEmailTestResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdEmailTestResponseError = (postApiTeamsTeamIdEmailTestResponse401 | postApiTeamsTeamIdEmailTestResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdEmailTestResponse = (postApiTeamsTeamIdEmailTestResponseSuccess | postApiTeamsTeamIdEmailTestResponseError)

export const getPostApiTeamsTeamIdEmailTestUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/email/test`
}

export const postApiTeamsTeamIdEmailTest = async (teamId: string,
    testEmailRequest: TestEmailRequest, options?: RequestInit): Promise<postApiTeamsTeamIdEmailTestResponse> => {

  return fetcher<postApiTeamsTeamIdEmailTestResponse>(getPostApiTeamsTeamIdEmailTestUrl(teamId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      testEmailRequest,)
  }
);}



export type getApiAdminEmailIdentitiesResponse200 = {
  data: void
  status: 200
}

export type getApiAdminEmailIdentitiesResponse401 = {
  data: GetApiAdminEmailIdentities401
  status: 401
}

export type getApiAdminEmailIdentitiesResponseSuccess = (getApiAdminEmailIdentitiesResponse200) & {
  headers: Headers;
};
export type getApiAdminEmailIdentitiesResponseError = (getApiAdminEmailIdentitiesResponse401) & {
  headers: Headers;
};

export type getApiAdminEmailIdentitiesResponse = (getApiAdminEmailIdentitiesResponseSuccess | getApiAdminEmailIdentitiesResponseError)

export const getGetApiAdminEmailIdentitiesUrl = (params?: GetApiAdminEmailIdentitiesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/email/identities?${stringifiedParams}` : `/api/admin/email/identities`
}

export const getApiAdminEmailIdentities = async (params?: GetApiAdminEmailIdentitiesParams, options?: RequestInit): Promise<getApiAdminEmailIdentitiesResponse> => {

  return fetcher<getApiAdminEmailIdentitiesResponse>(getGetApiAdminEmailIdentitiesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdEmailIdentitiesResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdEmailIdentitiesResponse401 = {
  data: GetApiTeamsTeamIdEmailIdentities401
  status: 401
}

export type getApiTeamsTeamIdEmailIdentitiesResponseSuccess = (getApiTeamsTeamIdEmailIdentitiesResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdEmailIdentitiesResponseError = (getApiTeamsTeamIdEmailIdentitiesResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdEmailIdentitiesResponse = (getApiTeamsTeamIdEmailIdentitiesResponseSuccess | getApiTeamsTeamIdEmailIdentitiesResponseError)

export const getGetApiTeamsTeamIdEmailIdentitiesUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/email/identities`
}

export const getApiTeamsTeamIdEmailIdentities = async (teamId: string, options?: RequestInit): Promise<getApiTeamsTeamIdEmailIdentitiesResponse> => {

  return fetcher<getApiTeamsTeamIdEmailIdentitiesResponse>(getGetApiTeamsTeamIdEmailIdentitiesUrl(teamId),
  {
    ...options,
    method: 'GET'


  }
);}



export type putApiAdminEmailIdentitiesMailboxRoleResponse200 = {
  data: void
  status: 200
}

export type putApiAdminEmailIdentitiesMailboxRoleResponse401 = {
  data: PutApiAdminEmailIdentitiesMailboxRole401
  status: 401
}

export type putApiAdminEmailIdentitiesMailboxRoleResponse402 = {
  data: PutApiAdminEmailIdentitiesMailboxRole402
  status: 402
}

export type putApiAdminEmailIdentitiesMailboxRoleResponseSuccess = (putApiAdminEmailIdentitiesMailboxRoleResponse200) & {
  headers: Headers;
};
export type putApiAdminEmailIdentitiesMailboxRoleResponseError = (putApiAdminEmailIdentitiesMailboxRoleResponse401 | putApiAdminEmailIdentitiesMailboxRoleResponse402) & {
  headers: Headers;
};

export type putApiAdminEmailIdentitiesMailboxRoleResponse = (putApiAdminEmailIdentitiesMailboxRoleResponseSuccess | putApiAdminEmailIdentitiesMailboxRoleResponseError)

export const getPutApiAdminEmailIdentitiesMailboxRoleUrl = (mailboxRole: string,) => {




  return `/api/admin/email/identities/${mailboxRole}`
}

export const putApiAdminEmailIdentitiesMailboxRole = async (mailboxRole: string,
    nullUpdateTeamEmailIdentityRequest: null | UpdateTeamEmailIdentityRequest, options?: RequestInit): Promise<putApiAdminEmailIdentitiesMailboxRoleResponse> => {

  return fetcher<putApiAdminEmailIdentitiesMailboxRoleResponse>(getPutApiAdminEmailIdentitiesMailboxRoleUrl(mailboxRole),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullUpdateTeamEmailIdentityRequest,)
  }
);}



export type putApiTeamsTeamIdEmailIdentitiesMailboxRoleResponse200 = {
  data: void
  status: 200
}

export type putApiTeamsTeamIdEmailIdentitiesMailboxRoleResponse401 = {
  data: PutApiTeamsTeamIdEmailIdentitiesMailboxRole401
  status: 401
}

export type putApiTeamsTeamIdEmailIdentitiesMailboxRoleResponse402 = {
  data: PutApiTeamsTeamIdEmailIdentitiesMailboxRole402
  status: 402
}

export type putApiTeamsTeamIdEmailIdentitiesMailboxRoleResponseSuccess = (putApiTeamsTeamIdEmailIdentitiesMailboxRoleResponse200) & {
  headers: Headers;
};
export type putApiTeamsTeamIdEmailIdentitiesMailboxRoleResponseError = (putApiTeamsTeamIdEmailIdentitiesMailboxRoleResponse401 | putApiTeamsTeamIdEmailIdentitiesMailboxRoleResponse402) & {
  headers: Headers;
};

export type putApiTeamsTeamIdEmailIdentitiesMailboxRoleResponse = (putApiTeamsTeamIdEmailIdentitiesMailboxRoleResponseSuccess | putApiTeamsTeamIdEmailIdentitiesMailboxRoleResponseError)

export const getPutApiTeamsTeamIdEmailIdentitiesMailboxRoleUrl = (teamId: string,
    mailboxRole: string,) => {




  return `/api/teams/${teamId}/email/identities/${mailboxRole}`
}

export const putApiTeamsTeamIdEmailIdentitiesMailboxRole = async (teamId: string,
    mailboxRole: string,
    nullUpdateTeamEmailIdentityRequest: null | UpdateTeamEmailIdentityRequest, options?: RequestInit): Promise<putApiTeamsTeamIdEmailIdentitiesMailboxRoleResponse> => {

  return fetcher<putApiTeamsTeamIdEmailIdentitiesMailboxRoleResponse>(getPutApiTeamsTeamIdEmailIdentitiesMailboxRoleUrl(teamId,mailboxRole),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullUpdateTeamEmailIdentityRequest,)
  }
);}



export type getApiAdminEmailInboundRoutesResponse200 = {
  data: void
  status: 200
}

export type getApiAdminEmailInboundRoutesResponse401 = {
  data: GetApiAdminEmailInboundRoutes401
  status: 401
}

export type getApiAdminEmailInboundRoutesResponseSuccess = (getApiAdminEmailInboundRoutesResponse200) & {
  headers: Headers;
};
export type getApiAdminEmailInboundRoutesResponseError = (getApiAdminEmailInboundRoutesResponse401) & {
  headers: Headers;
};

export type getApiAdminEmailInboundRoutesResponse = (getApiAdminEmailInboundRoutesResponseSuccess | getApiAdminEmailInboundRoutesResponseError)

export const getGetApiAdminEmailInboundRoutesUrl = (params?: GetApiAdminEmailInboundRoutesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/email/inbound-routes?${stringifiedParams}` : `/api/admin/email/inbound-routes`
}

export const getApiAdminEmailInboundRoutes = async (params?: GetApiAdminEmailInboundRoutesParams, options?: RequestInit): Promise<getApiAdminEmailInboundRoutesResponse> => {

  return fetcher<getApiAdminEmailInboundRoutesResponse>(getGetApiAdminEmailInboundRoutesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdEmailInboundRoutesResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdEmailInboundRoutesResponse401 = {
  data: GetApiTeamsTeamIdEmailInboundRoutes401
  status: 401
}

export type getApiTeamsTeamIdEmailInboundRoutesResponseSuccess = (getApiTeamsTeamIdEmailInboundRoutesResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdEmailInboundRoutesResponseError = (getApiTeamsTeamIdEmailInboundRoutesResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdEmailInboundRoutesResponse = (getApiTeamsTeamIdEmailInboundRoutesResponseSuccess | getApiTeamsTeamIdEmailInboundRoutesResponseError)

export const getGetApiTeamsTeamIdEmailInboundRoutesUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/email/inbound-routes`
}

export const getApiTeamsTeamIdEmailInboundRoutes = async (teamId: string, options?: RequestInit): Promise<getApiTeamsTeamIdEmailInboundRoutesResponse> => {

  return fetcher<getApiTeamsTeamIdEmailInboundRoutesResponse>(getGetApiTeamsTeamIdEmailInboundRoutesUrl(teamId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiAdminEmailInboundRoutesEnsureResponse200 = {
  data: void
  status: 200
}

export type postApiAdminEmailInboundRoutesEnsureResponse401 = {
  data: PostApiAdminEmailInboundRoutesEnsure401
  status: 401
}

export type postApiAdminEmailInboundRoutesEnsureResponse402 = {
  data: PostApiAdminEmailInboundRoutesEnsure402
  status: 402
}

export type postApiAdminEmailInboundRoutesEnsureResponseSuccess = (postApiAdminEmailInboundRoutesEnsureResponse200) & {
  headers: Headers;
};
export type postApiAdminEmailInboundRoutesEnsureResponseError = (postApiAdminEmailInboundRoutesEnsureResponse401 | postApiAdminEmailInboundRoutesEnsureResponse402) & {
  headers: Headers;
};

export type postApiAdminEmailInboundRoutesEnsureResponse = (postApiAdminEmailInboundRoutesEnsureResponseSuccess | postApiAdminEmailInboundRoutesEnsureResponseError)

export const getPostApiAdminEmailInboundRoutesEnsureUrl = (params?: PostApiAdminEmailInboundRoutesEnsureParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/email/inbound-routes/ensure?${stringifiedParams}` : `/api/admin/email/inbound-routes/ensure`
}

export const postApiAdminEmailInboundRoutesEnsure = async (nullEnsureTeamInboundEmailRouteRequest: null | EnsureTeamInboundEmailRouteRequest,
    params?: PostApiAdminEmailInboundRoutesEnsureParams, options?: RequestInit): Promise<postApiAdminEmailInboundRoutesEnsureResponse> => {

  return fetcher<postApiAdminEmailInboundRoutesEnsureResponse>(getPostApiAdminEmailInboundRoutesEnsureUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullEnsureTeamInboundEmailRouteRequest,)
  }
);}



export type postApiTeamsTeamIdEmailInboundRoutesEnsureResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdEmailInboundRoutesEnsureResponse401 = {
  data: PostApiTeamsTeamIdEmailInboundRoutesEnsure401
  status: 401
}

export type postApiTeamsTeamIdEmailInboundRoutesEnsureResponse402 = {
  data: PostApiTeamsTeamIdEmailInboundRoutesEnsure402
  status: 402
}

export type postApiTeamsTeamIdEmailInboundRoutesEnsureResponseSuccess = (postApiTeamsTeamIdEmailInboundRoutesEnsureResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdEmailInboundRoutesEnsureResponseError = (postApiTeamsTeamIdEmailInboundRoutesEnsureResponse401 | postApiTeamsTeamIdEmailInboundRoutesEnsureResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdEmailInboundRoutesEnsureResponse = (postApiTeamsTeamIdEmailInboundRoutesEnsureResponseSuccess | postApiTeamsTeamIdEmailInboundRoutesEnsureResponseError)

export const getPostApiTeamsTeamIdEmailInboundRoutesEnsureUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/email/inbound-routes/ensure`
}

export const postApiTeamsTeamIdEmailInboundRoutesEnsure = async (teamId: string,
    nullEnsureTeamInboundEmailRouteRequest: null | EnsureTeamInboundEmailRouteRequest, options?: RequestInit): Promise<postApiTeamsTeamIdEmailInboundRoutesEnsureResponse> => {

  return fetcher<postApiTeamsTeamIdEmailInboundRoutesEnsureResponse>(getPostApiTeamsTeamIdEmailInboundRoutesEnsureUrl(teamId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullEnsureTeamInboundEmailRouteRequest,)
  }
);}



export type postApiAdminEmailCampaignsRenewalsRunResponse200 = {
  data: void
  status: 200
}

export type postApiAdminEmailCampaignsRenewalsRunResponse401 = {
  data: PostApiAdminEmailCampaignsRenewalsRun401
  status: 401
}

export type postApiAdminEmailCampaignsRenewalsRunResponse402 = {
  data: PostApiAdminEmailCampaignsRenewalsRun402
  status: 402
}

export type postApiAdminEmailCampaignsRenewalsRunResponseSuccess = (postApiAdminEmailCampaignsRenewalsRunResponse200) & {
  headers: Headers;
};
export type postApiAdminEmailCampaignsRenewalsRunResponseError = (postApiAdminEmailCampaignsRenewalsRunResponse401 | postApiAdminEmailCampaignsRenewalsRunResponse402) & {
  headers: Headers;
};

export type postApiAdminEmailCampaignsRenewalsRunResponse = (postApiAdminEmailCampaignsRenewalsRunResponseSuccess | postApiAdminEmailCampaignsRenewalsRunResponseError)

export const getPostApiAdminEmailCampaignsRenewalsRunUrl = () => {




  return `/api/admin/email/campaigns/renewals/run`
}

export const postApiAdminEmailCampaignsRenewalsRun = async (nullRunRenewalCampaignRequest: null | RunRenewalCampaignRequest, options?: RequestInit): Promise<postApiAdminEmailCampaignsRenewalsRunResponse> => {

  return fetcher<postApiAdminEmailCampaignsRenewalsRunResponse>(getPostApiAdminEmailCampaignsRenewalsRunUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullRunRenewalCampaignRequest,)
  }
);}



export type getApiAdminEmailCampaignsRenewalsSchedulerSettingsResponse200 = {
  data: void
  status: 200
}

export type getApiAdminEmailCampaignsRenewalsSchedulerSettingsResponse401 = {
  data: GetApiAdminEmailCampaignsRenewalsSchedulerSettings401
  status: 401
}

export type getApiAdminEmailCampaignsRenewalsSchedulerSettingsResponseSuccess = (getApiAdminEmailCampaignsRenewalsSchedulerSettingsResponse200) & {
  headers: Headers;
};
export type getApiAdminEmailCampaignsRenewalsSchedulerSettingsResponseError = (getApiAdminEmailCampaignsRenewalsSchedulerSettingsResponse401) & {
  headers: Headers;
};

export type getApiAdminEmailCampaignsRenewalsSchedulerSettingsResponse = (getApiAdminEmailCampaignsRenewalsSchedulerSettingsResponseSuccess | getApiAdminEmailCampaignsRenewalsSchedulerSettingsResponseError)

export const getGetApiAdminEmailCampaignsRenewalsSchedulerSettingsUrl = (params?: GetApiAdminEmailCampaignsRenewalsSchedulerSettingsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/email/campaigns/renewals/scheduler/settings?${stringifiedParams}` : `/api/admin/email/campaigns/renewals/scheduler/settings`
}

export const getApiAdminEmailCampaignsRenewalsSchedulerSettings = async (params?: GetApiAdminEmailCampaignsRenewalsSchedulerSettingsParams, options?: RequestInit): Promise<getApiAdminEmailCampaignsRenewalsSchedulerSettingsResponse> => {

  return fetcher<getApiAdminEmailCampaignsRenewalsSchedulerSettingsResponse>(getGetApiAdminEmailCampaignsRenewalsSchedulerSettingsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type putApiAdminEmailCampaignsRenewalsSchedulerSettingsResponse200 = {
  data: void
  status: 200
}

export type putApiAdminEmailCampaignsRenewalsSchedulerSettingsResponse401 = {
  data: PutApiAdminEmailCampaignsRenewalsSchedulerSettings401
  status: 401
}

export type putApiAdminEmailCampaignsRenewalsSchedulerSettingsResponse402 = {
  data: PutApiAdminEmailCampaignsRenewalsSchedulerSettings402
  status: 402
}

export type putApiAdminEmailCampaignsRenewalsSchedulerSettingsResponseSuccess = (putApiAdminEmailCampaignsRenewalsSchedulerSettingsResponse200) & {
  headers: Headers;
};
export type putApiAdminEmailCampaignsRenewalsSchedulerSettingsResponseError = (putApiAdminEmailCampaignsRenewalsSchedulerSettingsResponse401 | putApiAdminEmailCampaignsRenewalsSchedulerSettingsResponse402) & {
  headers: Headers;
};

export type putApiAdminEmailCampaignsRenewalsSchedulerSettingsResponse = (putApiAdminEmailCampaignsRenewalsSchedulerSettingsResponseSuccess | putApiAdminEmailCampaignsRenewalsSchedulerSettingsResponseError)

export const getPutApiAdminEmailCampaignsRenewalsSchedulerSettingsUrl = () => {




  return `/api/admin/email/campaigns/renewals/scheduler/settings`
}

export const putApiAdminEmailCampaignsRenewalsSchedulerSettings = async (nullUpdateRenewalCampaignSchedulerRequest: null | UpdateRenewalCampaignSchedulerRequest, options?: RequestInit): Promise<putApiAdminEmailCampaignsRenewalsSchedulerSettingsResponse> => {

  return fetcher<putApiAdminEmailCampaignsRenewalsSchedulerSettingsResponse>(getPutApiAdminEmailCampaignsRenewalsSchedulerSettingsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullUpdateRenewalCampaignSchedulerRequest,)
  }
);}



export type getApiTeamsTeamIdEmailCampaignsRenewalsSchedulerSettingsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdEmailCampaignsRenewalsSchedulerSettingsResponse401 = {
  data: GetApiTeamsTeamIdEmailCampaignsRenewalsSchedulerSettings401
  status: 401
}

export type getApiTeamsTeamIdEmailCampaignsRenewalsSchedulerSettingsResponseSuccess = (getApiTeamsTeamIdEmailCampaignsRenewalsSchedulerSettingsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdEmailCampaignsRenewalsSchedulerSettingsResponseError = (getApiTeamsTeamIdEmailCampaignsRenewalsSchedulerSettingsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdEmailCampaignsRenewalsSchedulerSettingsResponse = (getApiTeamsTeamIdEmailCampaignsRenewalsSchedulerSettingsResponseSuccess | getApiTeamsTeamIdEmailCampaignsRenewalsSchedulerSettingsResponseError)

export const getGetApiTeamsTeamIdEmailCampaignsRenewalsSchedulerSettingsUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/email/campaigns/renewals/scheduler/settings`
}

export const getApiTeamsTeamIdEmailCampaignsRenewalsSchedulerSettings = async (teamId: string, options?: RequestInit): Promise<getApiTeamsTeamIdEmailCampaignsRenewalsSchedulerSettingsResponse> => {

  return fetcher<getApiTeamsTeamIdEmailCampaignsRenewalsSchedulerSettingsResponse>(getGetApiTeamsTeamIdEmailCampaignsRenewalsSchedulerSettingsUrl(teamId),
  {
    ...options,
    method: 'GET'


  }
);}



export type putApiTeamsTeamIdEmailCampaignsRenewalsSchedulerSettingsResponse200 = {
  data: void
  status: 200
}

export type putApiTeamsTeamIdEmailCampaignsRenewalsSchedulerSettingsResponse401 = {
  data: PutApiTeamsTeamIdEmailCampaignsRenewalsSchedulerSettings401
  status: 401
}

export type putApiTeamsTeamIdEmailCampaignsRenewalsSchedulerSettingsResponse402 = {
  data: PutApiTeamsTeamIdEmailCampaignsRenewalsSchedulerSettings402
  status: 402
}

export type putApiTeamsTeamIdEmailCampaignsRenewalsSchedulerSettingsResponseSuccess = (putApiTeamsTeamIdEmailCampaignsRenewalsSchedulerSettingsResponse200) & {
  headers: Headers;
};
export type putApiTeamsTeamIdEmailCampaignsRenewalsSchedulerSettingsResponseError = (putApiTeamsTeamIdEmailCampaignsRenewalsSchedulerSettingsResponse401 | putApiTeamsTeamIdEmailCampaignsRenewalsSchedulerSettingsResponse402) & {
  headers: Headers;
};

export type putApiTeamsTeamIdEmailCampaignsRenewalsSchedulerSettingsResponse = (putApiTeamsTeamIdEmailCampaignsRenewalsSchedulerSettingsResponseSuccess | putApiTeamsTeamIdEmailCampaignsRenewalsSchedulerSettingsResponseError)

export const getPutApiTeamsTeamIdEmailCampaignsRenewalsSchedulerSettingsUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/email/campaigns/renewals/scheduler/settings`
}

export const putApiTeamsTeamIdEmailCampaignsRenewalsSchedulerSettings = async (teamId: string,
    nullUpdateRenewalCampaignSchedulerRequest: null | UpdateRenewalCampaignSchedulerRequest, options?: RequestInit): Promise<putApiTeamsTeamIdEmailCampaignsRenewalsSchedulerSettingsResponse> => {

  return fetcher<putApiTeamsTeamIdEmailCampaignsRenewalsSchedulerSettingsResponse>(getPutApiTeamsTeamIdEmailCampaignsRenewalsSchedulerSettingsUrl(teamId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullUpdateRenewalCampaignSchedulerRequest,)
  }
);}



export type getApiAdminEmailCampaignsRenewalsSchedulerRunsResponse200 = {
  data: void
  status: 200
}

export type getApiAdminEmailCampaignsRenewalsSchedulerRunsResponse401 = {
  data: GetApiAdminEmailCampaignsRenewalsSchedulerRuns401
  status: 401
}

export type getApiAdminEmailCampaignsRenewalsSchedulerRunsResponseSuccess = (getApiAdminEmailCampaignsRenewalsSchedulerRunsResponse200) & {
  headers: Headers;
};
export type getApiAdminEmailCampaignsRenewalsSchedulerRunsResponseError = (getApiAdminEmailCampaignsRenewalsSchedulerRunsResponse401) & {
  headers: Headers;
};

export type getApiAdminEmailCampaignsRenewalsSchedulerRunsResponse = (getApiAdminEmailCampaignsRenewalsSchedulerRunsResponseSuccess | getApiAdminEmailCampaignsRenewalsSchedulerRunsResponseError)

export const getGetApiAdminEmailCampaignsRenewalsSchedulerRunsUrl = (params?: GetApiAdminEmailCampaignsRenewalsSchedulerRunsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/email/campaigns/renewals/scheduler/runs?${stringifiedParams}` : `/api/admin/email/campaigns/renewals/scheduler/runs`
}

export const getApiAdminEmailCampaignsRenewalsSchedulerRuns = async (params?: GetApiAdminEmailCampaignsRenewalsSchedulerRunsParams, options?: RequestInit): Promise<getApiAdminEmailCampaignsRenewalsSchedulerRunsResponse> => {

  return fetcher<getApiAdminEmailCampaignsRenewalsSchedulerRunsResponse>(getGetApiAdminEmailCampaignsRenewalsSchedulerRunsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdEmailCampaignsRenewalsSchedulerRunsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdEmailCampaignsRenewalsSchedulerRunsResponse401 = {
  data: GetApiTeamsTeamIdEmailCampaignsRenewalsSchedulerRuns401
  status: 401
}

export type getApiTeamsTeamIdEmailCampaignsRenewalsSchedulerRunsResponseSuccess = (getApiTeamsTeamIdEmailCampaignsRenewalsSchedulerRunsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdEmailCampaignsRenewalsSchedulerRunsResponseError = (getApiTeamsTeamIdEmailCampaignsRenewalsSchedulerRunsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdEmailCampaignsRenewalsSchedulerRunsResponse = (getApiTeamsTeamIdEmailCampaignsRenewalsSchedulerRunsResponseSuccess | getApiTeamsTeamIdEmailCampaignsRenewalsSchedulerRunsResponseError)

export const getGetApiTeamsTeamIdEmailCampaignsRenewalsSchedulerRunsUrl = (teamId: string,
    params?: GetApiTeamsTeamIdEmailCampaignsRenewalsSchedulerRunsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/email/campaigns/renewals/scheduler/runs?${stringifiedParams}` : `/api/teams/${teamId}/email/campaigns/renewals/scheduler/runs`
}

export const getApiTeamsTeamIdEmailCampaignsRenewalsSchedulerRuns = async (teamId: string,
    params?: GetApiTeamsTeamIdEmailCampaignsRenewalsSchedulerRunsParams, options?: RequestInit): Promise<getApiTeamsTeamIdEmailCampaignsRenewalsSchedulerRunsResponse> => {

  return fetcher<getApiTeamsTeamIdEmailCampaignsRenewalsSchedulerRunsResponse>(getGetApiTeamsTeamIdEmailCampaignsRenewalsSchedulerRunsUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiAdminEmailCampaignsDripRunResponse200 = {
  data: void
  status: 200
}

export type postApiAdminEmailCampaignsDripRunResponse401 = {
  data: PostApiAdminEmailCampaignsDripRun401
  status: 401
}

export type postApiAdminEmailCampaignsDripRunResponse402 = {
  data: PostApiAdminEmailCampaignsDripRun402
  status: 402
}

export type postApiAdminEmailCampaignsDripRunResponseSuccess = (postApiAdminEmailCampaignsDripRunResponse200) & {
  headers: Headers;
};
export type postApiAdminEmailCampaignsDripRunResponseError = (postApiAdminEmailCampaignsDripRunResponse401 | postApiAdminEmailCampaignsDripRunResponse402) & {
  headers: Headers;
};

export type postApiAdminEmailCampaignsDripRunResponse = (postApiAdminEmailCampaignsDripRunResponseSuccess | postApiAdminEmailCampaignsDripRunResponseError)

export const getPostApiAdminEmailCampaignsDripRunUrl = () => {




  return `/api/admin/email/campaigns/drip/run`
}

export const postApiAdminEmailCampaignsDripRun = async (nullRunOnboardingDripCampaignRequest: null | RunOnboardingDripCampaignRequest, options?: RequestInit): Promise<postApiAdminEmailCampaignsDripRunResponse> => {

  return fetcher<postApiAdminEmailCampaignsDripRunResponse>(getPostApiAdminEmailCampaignsDripRunUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullRunOnboardingDripCampaignRequest,)
  }
);}



export type getApiAdminEmailActivityResponse200 = {
  data: void
  status: 200
}

export type getApiAdminEmailActivityResponse401 = {
  data: GetApiAdminEmailActivity401
  status: 401
}

export type getApiAdminEmailActivityResponseSuccess = (getApiAdminEmailActivityResponse200) & {
  headers: Headers;
};
export type getApiAdminEmailActivityResponseError = (getApiAdminEmailActivityResponse401) & {
  headers: Headers;
};

export type getApiAdminEmailActivityResponse = (getApiAdminEmailActivityResponseSuccess | getApiAdminEmailActivityResponseError)

export const getGetApiAdminEmailActivityUrl = (params?: GetApiAdminEmailActivityParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/email/activity?${stringifiedParams}` : `/api/admin/email/activity`
}

export const getApiAdminEmailActivity = async (params?: GetApiAdminEmailActivityParams, options?: RequestInit): Promise<getApiAdminEmailActivityResponse> => {

  return fetcher<getApiAdminEmailActivityResponse>(getGetApiAdminEmailActivityUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdEmailActivityResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdEmailActivityResponse401 = {
  data: GetApiTeamsTeamIdEmailActivity401
  status: 401
}

export type getApiTeamsTeamIdEmailActivityResponseSuccess = (getApiTeamsTeamIdEmailActivityResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdEmailActivityResponseError = (getApiTeamsTeamIdEmailActivityResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdEmailActivityResponse = (getApiTeamsTeamIdEmailActivityResponseSuccess | getApiTeamsTeamIdEmailActivityResponseError)

export const getGetApiTeamsTeamIdEmailActivityUrl = (teamId: string,
    params?: GetApiTeamsTeamIdEmailActivityParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/email/activity?${stringifiedParams}` : `/api/teams/${teamId}/email/activity`
}

export const getApiTeamsTeamIdEmailActivity = async (teamId: string,
    params?: GetApiTeamsTeamIdEmailActivityParams, options?: RequestInit): Promise<getApiTeamsTeamIdEmailActivityResponse> => {

  return fetcher<getApiTeamsTeamIdEmailActivityResponse>(getGetApiTeamsTeamIdEmailActivityUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiAdminEmailActivityEventsResponse200 = {
  data: void
  status: 200
}

export type getApiAdminEmailActivityEventsResponse401 = {
  data: GetApiAdminEmailActivityEvents401
  status: 401
}

export type getApiAdminEmailActivityEventsResponseSuccess = (getApiAdminEmailActivityEventsResponse200) & {
  headers: Headers;
};
export type getApiAdminEmailActivityEventsResponseError = (getApiAdminEmailActivityEventsResponse401) & {
  headers: Headers;
};

export type getApiAdminEmailActivityEventsResponse = (getApiAdminEmailActivityEventsResponseSuccess | getApiAdminEmailActivityEventsResponseError)

export const getGetApiAdminEmailActivityEventsUrl = (params?: GetApiAdminEmailActivityEventsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/email/activity/events?${stringifiedParams}` : `/api/admin/email/activity/events`
}

export const getApiAdminEmailActivityEvents = async (params?: GetApiAdminEmailActivityEventsParams, options?: RequestInit): Promise<getApiAdminEmailActivityEventsResponse> => {

  return fetcher<getApiAdminEmailActivityEventsResponse>(getGetApiAdminEmailActivityEventsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdEmailActivityEventsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdEmailActivityEventsResponse401 = {
  data: GetApiTeamsTeamIdEmailActivityEvents401
  status: 401
}

export type getApiTeamsTeamIdEmailActivityEventsResponseSuccess = (getApiTeamsTeamIdEmailActivityEventsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdEmailActivityEventsResponseError = (getApiTeamsTeamIdEmailActivityEventsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdEmailActivityEventsResponse = (getApiTeamsTeamIdEmailActivityEventsResponseSuccess | getApiTeamsTeamIdEmailActivityEventsResponseError)

export const getGetApiTeamsTeamIdEmailActivityEventsUrl = (teamId: string,
    params?: GetApiTeamsTeamIdEmailActivityEventsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/email/activity/events?${stringifiedParams}` : `/api/teams/${teamId}/email/activity/events`
}

export const getApiTeamsTeamIdEmailActivityEvents = async (teamId: string,
    params?: GetApiTeamsTeamIdEmailActivityEventsParams, options?: RequestInit): Promise<getApiTeamsTeamIdEmailActivityEventsResponse> => {

  return fetcher<getApiTeamsTeamIdEmailActivityEventsResponse>(getGetApiTeamsTeamIdEmailActivityEventsUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiAdminFileRecordsResponse200 = {
  data: void
  status: 200
}

export type getApiAdminFileRecordsResponse401 = {
  data: GetApiAdminFileRecords401
  status: 401
}

export type getApiAdminFileRecordsResponseSuccess = (getApiAdminFileRecordsResponse200) & {
  headers: Headers;
};
export type getApiAdminFileRecordsResponseError = (getApiAdminFileRecordsResponse401) & {
  headers: Headers;
};

export type getApiAdminFileRecordsResponse = (getApiAdminFileRecordsResponseSuccess | getApiAdminFileRecordsResponseError)

export const getGetApiAdminFileRecordsUrl = (params?: GetApiAdminFileRecordsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/file-records?${stringifiedParams}` : `/api/admin/file-records`
}

export const getApiAdminFileRecords = async (params?: GetApiAdminFileRecordsParams, options?: RequestInit): Promise<getApiAdminFileRecordsResponse> => {

  return fetcher<getApiAdminFileRecordsResponse>(getGetApiAdminFileRecordsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type deleteApiAdminFileRecordsScopeRecordIdResponse200 = {
  data: void
  status: 200
}

export type deleteApiAdminFileRecordsScopeRecordIdResponse401 = {
  data: DeleteApiAdminFileRecordsScopeRecordId401
  status: 401
}

export type deleteApiAdminFileRecordsScopeRecordIdResponse402 = {
  data: DeleteApiAdminFileRecordsScopeRecordId402
  status: 402
}

export type deleteApiAdminFileRecordsScopeRecordIdResponseSuccess = (deleteApiAdminFileRecordsScopeRecordIdResponse200) & {
  headers: Headers;
};
export type deleteApiAdminFileRecordsScopeRecordIdResponseError = (deleteApiAdminFileRecordsScopeRecordIdResponse401 | deleteApiAdminFileRecordsScopeRecordIdResponse402) & {
  headers: Headers;
};

export type deleteApiAdminFileRecordsScopeRecordIdResponse = (deleteApiAdminFileRecordsScopeRecordIdResponseSuccess | deleteApiAdminFileRecordsScopeRecordIdResponseError)

export const getDeleteApiAdminFileRecordsScopeRecordIdUrl = (scope: string,
    recordId: string,) => {




  return `/api/admin/file-records/${scope}/${recordId}`
}

export const deleteApiAdminFileRecordsScopeRecordId = async (scope: string,
    recordId: string, options?: RequestInit): Promise<deleteApiAdminFileRecordsScopeRecordIdResponse> => {

  return fetcher<deleteApiAdminFileRecordsScopeRecordIdResponse>(getDeleteApiAdminFileRecordsScopeRecordIdUrl(scope,recordId),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type postApiAdminFileRecordsScopeRecordIdRestoreResponse200 = {
  data: void
  status: 200
}

export type postApiAdminFileRecordsScopeRecordIdRestoreResponse401 = {
  data: PostApiAdminFileRecordsScopeRecordIdRestore401
  status: 401
}

export type postApiAdminFileRecordsScopeRecordIdRestoreResponse402 = {
  data: PostApiAdminFileRecordsScopeRecordIdRestore402
  status: 402
}

export type postApiAdminFileRecordsScopeRecordIdRestoreResponseSuccess = (postApiAdminFileRecordsScopeRecordIdRestoreResponse200) & {
  headers: Headers;
};
export type postApiAdminFileRecordsScopeRecordIdRestoreResponseError = (postApiAdminFileRecordsScopeRecordIdRestoreResponse401 | postApiAdminFileRecordsScopeRecordIdRestoreResponse402) & {
  headers: Headers;
};

export type postApiAdminFileRecordsScopeRecordIdRestoreResponse = (postApiAdminFileRecordsScopeRecordIdRestoreResponseSuccess | postApiAdminFileRecordsScopeRecordIdRestoreResponseError)

export const getPostApiAdminFileRecordsScopeRecordIdRestoreUrl = (scope: string,
    recordId: string,) => {




  return `/api/admin/file-records/${scope}/${recordId}/restore`
}

export const postApiAdminFileRecordsScopeRecordIdRestore = async (scope: string,
    recordId: string, options?: RequestInit): Promise<postApiAdminFileRecordsScopeRecordIdRestoreResponse> => {

  return fetcher<postApiAdminFileRecordsScopeRecordIdRestoreResponse>(getPostApiAdminFileRecordsScopeRecordIdRestoreUrl(scope,recordId),
  {
    ...options,
    method: 'POST'


  }
);}



export type deleteApiAdminFileRecordsScopeRecordIdHardResponse200 = {
  data: void
  status: 200
}

export type deleteApiAdminFileRecordsScopeRecordIdHardResponse401 = {
  data: DeleteApiAdminFileRecordsScopeRecordIdHard401
  status: 401
}

export type deleteApiAdminFileRecordsScopeRecordIdHardResponse402 = {
  data: DeleteApiAdminFileRecordsScopeRecordIdHard402
  status: 402
}

export type deleteApiAdminFileRecordsScopeRecordIdHardResponseSuccess = (deleteApiAdminFileRecordsScopeRecordIdHardResponse200) & {
  headers: Headers;
};
export type deleteApiAdminFileRecordsScopeRecordIdHardResponseError = (deleteApiAdminFileRecordsScopeRecordIdHardResponse401 | deleteApiAdminFileRecordsScopeRecordIdHardResponse402) & {
  headers: Headers;
};

export type deleteApiAdminFileRecordsScopeRecordIdHardResponse = (deleteApiAdminFileRecordsScopeRecordIdHardResponseSuccess | deleteApiAdminFileRecordsScopeRecordIdHardResponseError)

export const getDeleteApiAdminFileRecordsScopeRecordIdHardUrl = (scope: string,
    recordId: string,) => {




  return `/api/admin/file-records/${scope}/${recordId}/hard`
}

export const deleteApiAdminFileRecordsScopeRecordIdHard = async (scope: string,
    recordId: string, options?: RequestInit): Promise<deleteApiAdminFileRecordsScopeRecordIdHardResponse> => {

  return fetcher<deleteApiAdminFileRecordsScopeRecordIdHardResponse>(getDeleteApiAdminFileRecordsScopeRecordIdHardUrl(scope,recordId),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type postApiAdminFormFilesAttachFormVersionIdResponse200TextPlain = {
  data: AdminFormFileAttachmentDto
  status: 200
}

export type postApiAdminFormFilesAttachFormVersionIdResponse200ApplicationJson = {
  data: AdminFormFileAttachmentDto
  status: 200
}

export type postApiAdminFormFilesAttachFormVersionIdResponse200TextJson = {
  data: AdminFormFileAttachmentDto
  status: 200
}

export type postApiAdminFormFilesAttachFormVersionIdResponse401 = {
  data: PostApiAdminFormFilesAttachFormVersionId401
  status: 401
}

export type postApiAdminFormFilesAttachFormVersionIdResponse402 = {
  data: PostApiAdminFormFilesAttachFormVersionId402
  status: 402
}

export type postApiAdminFormFilesAttachFormVersionIdResponseSuccess = (postApiAdminFormFilesAttachFormVersionIdResponse200TextPlain | postApiAdminFormFilesAttachFormVersionIdResponse200ApplicationJson | postApiAdminFormFilesAttachFormVersionIdResponse200TextJson) & {
  headers: Headers;
};
export type postApiAdminFormFilesAttachFormVersionIdResponseError = (postApiAdminFormFilesAttachFormVersionIdResponse401 | postApiAdminFormFilesAttachFormVersionIdResponse402) & {
  headers: Headers;
};

export type postApiAdminFormFilesAttachFormVersionIdResponse = (postApiAdminFormFilesAttachFormVersionIdResponseSuccess | postApiAdminFormFilesAttachFormVersionIdResponseError)

export const getPostApiAdminFormFilesAttachFormVersionIdUrl = (formVersionId: string,) => {




  return `/api/admin/form-files/attach/${formVersionId}`
}

export const postApiAdminFormFilesAttachFormVersionId = async (formVersionId: string,
    attachFromUploadRequest: AttachFromUploadRequest, options?: RequestInit): Promise<postApiAdminFormFilesAttachFormVersionIdResponse> => {

  return fetcher<postApiAdminFormFilesAttachFormVersionIdResponse>(getPostApiAdminFormFilesAttachFormVersionIdUrl(formVersionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      attachFromUploadRequest,)
  }
);}



export type getApiAdminFormFilesResponse200TextPlain = {
  data: AdminFormFileListItemDto[]
  status: 200
}

export type getApiAdminFormFilesResponse200ApplicationJson = {
  data: AdminFormFileListItemDto[]
  status: 200
}

export type getApiAdminFormFilesResponse200TextJson = {
  data: AdminFormFileListItemDto[]
  status: 200
}

export type getApiAdminFormFilesResponse401 = {
  data: GetApiAdminFormFiles401
  status: 401
}

export type getApiAdminFormFilesResponseSuccess = (getApiAdminFormFilesResponse200TextPlain | getApiAdminFormFilesResponse200ApplicationJson | getApiAdminFormFilesResponse200TextJson) & {
  headers: Headers;
};
export type getApiAdminFormFilesResponseError = (getApiAdminFormFilesResponse401) & {
  headers: Headers;
};

export type getApiAdminFormFilesResponse = (getApiAdminFormFilesResponseSuccess | getApiAdminFormFilesResponseError)

export const getGetApiAdminFormFilesUrl = (params?: GetApiAdminFormFilesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/form-files?${stringifiedParams}` : `/api/admin/form-files`
}

export const getApiAdminFormFiles = async (params?: GetApiAdminFormFilesParams, options?: RequestInit): Promise<getApiAdminFormFilesResponse> => {

  return fetcher<getApiAdminFormFilesResponse>(getGetApiAdminFormFilesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiAdminFormsAppResponse200 = {
  data: void
  status: 200
}

export type getApiAdminFormsAppResponse401 = {
  data: GetApiAdminFormsApp401
  status: 401
}

export type getApiAdminFormsAppResponseSuccess = (getApiAdminFormsAppResponse200) & {
  headers: Headers;
};
export type getApiAdminFormsAppResponseError = (getApiAdminFormsAppResponse401) & {
  headers: Headers;
};

export type getApiAdminFormsAppResponse = (getApiAdminFormsAppResponseSuccess | getApiAdminFormsAppResponseError)

export const getGetApiAdminFormsAppUrl = (params?: GetApiAdminFormsAppParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/forms/app?${stringifiedParams}` : `/api/admin/forms/app`
}

export const getApiAdminFormsApp = async (params?: GetApiAdminFormsAppParams, options?: RequestInit): Promise<getApiAdminFormsAppResponse> => {

  return fetcher<getApiAdminFormsAppResponse>(getGetApiAdminFormsAppUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiAdminFormsAppResponse200 = {
  data: void
  status: 200
}

export type postApiAdminFormsAppResponse401 = {
  data: PostApiAdminFormsApp401
  status: 401
}

export type postApiAdminFormsAppResponse402 = {
  data: PostApiAdminFormsApp402
  status: 402
}

export type postApiAdminFormsAppResponseSuccess = (postApiAdminFormsAppResponse200) & {
  headers: Headers;
};
export type postApiAdminFormsAppResponseError = (postApiAdminFormsAppResponse401 | postApiAdminFormsAppResponse402) & {
  headers: Headers;
};

export type postApiAdminFormsAppResponse = (postApiAdminFormsAppResponseSuccess | postApiAdminFormsAppResponseError)

export const getPostApiAdminFormsAppUrl = () => {




  return `/api/admin/forms/app`
}

export const postApiAdminFormsApp = async (createAppFormRequest: CreateAppFormRequest, options?: RequestInit): Promise<postApiAdminFormsAppResponse> => {

  return fetcher<postApiAdminFormsAppResponse>(getPostApiAdminFormsAppUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createAppFormRequest,)
  }
);}



export type getApiTeamsTeamIdFormsAppResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdFormsAppResponse401 = {
  data: GetApiTeamsTeamIdFormsApp401
  status: 401
}

export type getApiTeamsTeamIdFormsAppResponseSuccess = (getApiTeamsTeamIdFormsAppResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdFormsAppResponseError = (getApiTeamsTeamIdFormsAppResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdFormsAppResponse = (getApiTeamsTeamIdFormsAppResponseSuccess | getApiTeamsTeamIdFormsAppResponseError)

export const getGetApiTeamsTeamIdFormsAppUrl = (teamId: string,
    params?: GetApiTeamsTeamIdFormsAppParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/forms/app?${stringifiedParams}` : `/api/teams/${teamId}/forms/app`
}

export const getApiTeamsTeamIdFormsApp = async (teamId: string,
    params?: GetApiTeamsTeamIdFormsAppParams, options?: RequestInit): Promise<getApiTeamsTeamIdFormsAppResponse> => {

  return fetcher<getApiTeamsTeamIdFormsAppResponse>(getGetApiTeamsTeamIdFormsAppUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiAdminFormsAppSummaryResponse200 = {
  data: void
  status: 200
}

export type getApiAdminFormsAppSummaryResponse401 = {
  data: GetApiAdminFormsAppSummary401
  status: 401
}

export type getApiAdminFormsAppSummaryResponseSuccess = (getApiAdminFormsAppSummaryResponse200) & {
  headers: Headers;
};
export type getApiAdminFormsAppSummaryResponseError = (getApiAdminFormsAppSummaryResponse401) & {
  headers: Headers;
};

export type getApiAdminFormsAppSummaryResponse = (getApiAdminFormsAppSummaryResponseSuccess | getApiAdminFormsAppSummaryResponseError)

export const getGetApiAdminFormsAppSummaryUrl = (params?: GetApiAdminFormsAppSummaryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/forms/app/summary?${stringifiedParams}` : `/api/admin/forms/app/summary`
}

export const getApiAdminFormsAppSummary = async (params?: GetApiAdminFormsAppSummaryParams, options?: RequestInit): Promise<getApiAdminFormsAppSummaryResponse> => {

  return fetcher<getApiAdminFormsAppSummaryResponse>(getGetApiAdminFormsAppSummaryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiAdminFormsAppSummaryGroupedResponse200 = {
  data: void
  status: 200
}

export type getApiAdminFormsAppSummaryGroupedResponse401 = {
  data: GetApiAdminFormsAppSummaryGrouped401
  status: 401
}

export type getApiAdminFormsAppSummaryGroupedResponseSuccess = (getApiAdminFormsAppSummaryGroupedResponse200) & {
  headers: Headers;
};
export type getApiAdminFormsAppSummaryGroupedResponseError = (getApiAdminFormsAppSummaryGroupedResponse401) & {
  headers: Headers;
};

export type getApiAdminFormsAppSummaryGroupedResponse = (getApiAdminFormsAppSummaryGroupedResponseSuccess | getApiAdminFormsAppSummaryGroupedResponseError)

export const getGetApiAdminFormsAppSummaryGroupedUrl = (params?: GetApiAdminFormsAppSummaryGroupedParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/forms/app/summary-grouped?${stringifiedParams}` : `/api/admin/forms/app/summary-grouped`
}

export const getApiAdminFormsAppSummaryGrouped = async (params?: GetApiAdminFormsAppSummaryGroupedParams, options?: RequestInit): Promise<getApiAdminFormsAppSummaryGroupedResponse> => {

  return fetcher<getApiAdminFormsAppSummaryGroupedResponse>(getGetApiAdminFormsAppSummaryGroupedUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiAdminFormsAppVersionsResponse200 = {
  data: void
  status: 200
}

export type getApiAdminFormsAppVersionsResponse401 = {
  data: GetApiAdminFormsAppVersions401
  status: 401
}

export type getApiAdminFormsAppVersionsResponseSuccess = (getApiAdminFormsAppVersionsResponse200) & {
  headers: Headers;
};
export type getApiAdminFormsAppVersionsResponseError = (getApiAdminFormsAppVersionsResponse401) & {
  headers: Headers;
};

export type getApiAdminFormsAppVersionsResponse = (getApiAdminFormsAppVersionsResponseSuccess | getApiAdminFormsAppVersionsResponseError)

export const getGetApiAdminFormsAppVersionsUrl = (params?: GetApiAdminFormsAppVersionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/forms/app/versions?${stringifiedParams}` : `/api/admin/forms/app/versions`
}

export const getApiAdminFormsAppVersions = async (params?: GetApiAdminFormsAppVersionsParams, options?: RequestInit): Promise<getApiAdminFormsAppVersionsResponse> => {

  return fetcher<getApiAdminFormsAppVersionsResponse>(getGetApiAdminFormsAppVersionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiAdminFormsAppFormIdActiveResponse200 = {
  data: void
  status: 200
}

export type postApiAdminFormsAppFormIdActiveResponse401 = {
  data: PostApiAdminFormsAppFormIdActive401
  status: 401
}

export type postApiAdminFormsAppFormIdActiveResponse402 = {
  data: PostApiAdminFormsAppFormIdActive402
  status: 402
}

export type postApiAdminFormsAppFormIdActiveResponseSuccess = (postApiAdminFormsAppFormIdActiveResponse200) & {
  headers: Headers;
};
export type postApiAdminFormsAppFormIdActiveResponseError = (postApiAdminFormsAppFormIdActiveResponse401 | postApiAdminFormsAppFormIdActiveResponse402) & {
  headers: Headers;
};

export type postApiAdminFormsAppFormIdActiveResponse = (postApiAdminFormsAppFormIdActiveResponseSuccess | postApiAdminFormsAppFormIdActiveResponseError)

export const getPostApiAdminFormsAppFormIdActiveUrl = (formId: string,) => {




  return `/api/admin/forms/app/${formId}/active`
}

export const postApiAdminFormsAppFormIdActive = async (formId: string,
    updateAppFormActiveRequest: UpdateAppFormActiveRequest, options?: RequestInit): Promise<postApiAdminFormsAppFormIdActiveResponse> => {

  return fetcher<postApiAdminFormsAppFormIdActiveResponse>(getPostApiAdminFormsAppFormIdActiveUrl(formId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateAppFormActiveRequest,)
  }
);}



export type postApiAdminFormsAppVersionsFormVersionIdStatusResponse200 = {
  data: void
  status: 200
}

export type postApiAdminFormsAppVersionsFormVersionIdStatusResponse401 = {
  data: PostApiAdminFormsAppVersionsFormVersionIdStatus401
  status: 401
}

export type postApiAdminFormsAppVersionsFormVersionIdStatusResponse402 = {
  data: PostApiAdminFormsAppVersionsFormVersionIdStatus402
  status: 402
}

export type postApiAdminFormsAppVersionsFormVersionIdStatusResponseSuccess = (postApiAdminFormsAppVersionsFormVersionIdStatusResponse200) & {
  headers: Headers;
};
export type postApiAdminFormsAppVersionsFormVersionIdStatusResponseError = (postApiAdminFormsAppVersionsFormVersionIdStatusResponse401 | postApiAdminFormsAppVersionsFormVersionIdStatusResponse402) & {
  headers: Headers;
};

export type postApiAdminFormsAppVersionsFormVersionIdStatusResponse = (postApiAdminFormsAppVersionsFormVersionIdStatusResponseSuccess | postApiAdminFormsAppVersionsFormVersionIdStatusResponseError)

export const getPostApiAdminFormsAppVersionsFormVersionIdStatusUrl = (formVersionId: string,) => {




  return `/api/admin/forms/app/versions/${formVersionId}/status`
}

export const postApiAdminFormsAppVersionsFormVersionIdStatus = async (formVersionId: string,
    updateAppFormVersionStatusRequest: UpdateAppFormVersionStatusRequest, options?: RequestInit): Promise<postApiAdminFormsAppVersionsFormVersionIdStatusResponse> => {

  return fetcher<postApiAdminFormsAppVersionsFormVersionIdStatusResponse>(getPostApiAdminFormsAppVersionsFormVersionIdStatusUrl(formVersionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateAppFormVersionStatusRequest,)
  }
);}



export type getApiAdminFormsAppFormIdVersionsResponse200 = {
  data: void
  status: 200
}

export type getApiAdminFormsAppFormIdVersionsResponse401 = {
  data: GetApiAdminFormsAppFormIdVersions401
  status: 401
}

export type getApiAdminFormsAppFormIdVersionsResponseSuccess = (getApiAdminFormsAppFormIdVersionsResponse200) & {
  headers: Headers;
};
export type getApiAdminFormsAppFormIdVersionsResponseError = (getApiAdminFormsAppFormIdVersionsResponse401) & {
  headers: Headers;
};

export type getApiAdminFormsAppFormIdVersionsResponse = (getApiAdminFormsAppFormIdVersionsResponseSuccess | getApiAdminFormsAppFormIdVersionsResponseError)

export const getGetApiAdminFormsAppFormIdVersionsUrl = (formId: string,) => {




  return `/api/admin/forms/app/${formId}/versions`
}

export const getApiAdminFormsAppFormIdVersions = async (formId: string, options?: RequestInit): Promise<getApiAdminFormsAppFormIdVersionsResponse> => {

  return fetcher<getApiAdminFormsAppFormIdVersionsResponse>(getGetApiAdminFormsAppFormIdVersionsUrl(formId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiAdminFormsAppFormIdVersionsResponse200 = {
  data: void
  status: 200
}

export type postApiAdminFormsAppFormIdVersionsResponse401 = {
  data: PostApiAdminFormsAppFormIdVersions401
  status: 401
}

export type postApiAdminFormsAppFormIdVersionsResponse402 = {
  data: PostApiAdminFormsAppFormIdVersions402
  status: 402
}

export type postApiAdminFormsAppFormIdVersionsResponseSuccess = (postApiAdminFormsAppFormIdVersionsResponse200) & {
  headers: Headers;
};
export type postApiAdminFormsAppFormIdVersionsResponseError = (postApiAdminFormsAppFormIdVersionsResponse401 | postApiAdminFormsAppFormIdVersionsResponse402) & {
  headers: Headers;
};

export type postApiAdminFormsAppFormIdVersionsResponse = (postApiAdminFormsAppFormIdVersionsResponseSuccess | postApiAdminFormsAppFormIdVersionsResponseError)

export const getPostApiAdminFormsAppFormIdVersionsUrl = (formId: string,) => {




  return `/api/admin/forms/app/${formId}/versions`
}

export const postApiAdminFormsAppFormIdVersions = async (formId: string,
    createAppFormVersionRequest: CreateAppFormVersionRequest, options?: RequestInit): Promise<postApiAdminFormsAppFormIdVersionsResponse> => {

  return fetcher<postApiAdminFormsAppFormIdVersionsResponse>(getPostApiAdminFormsAppFormIdVersionsUrl(formId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createAppFormVersionRequest,)
  }
);}



export type getApiTeamsTeamIdFormsAppFormIdVersionsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdFormsAppFormIdVersionsResponse401 = {
  data: GetApiTeamsTeamIdFormsAppFormIdVersions401
  status: 401
}

export type getApiTeamsTeamIdFormsAppFormIdVersionsResponseSuccess = (getApiTeamsTeamIdFormsAppFormIdVersionsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdFormsAppFormIdVersionsResponseError = (getApiTeamsTeamIdFormsAppFormIdVersionsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdFormsAppFormIdVersionsResponse = (getApiTeamsTeamIdFormsAppFormIdVersionsResponseSuccess | getApiTeamsTeamIdFormsAppFormIdVersionsResponseError)

export const getGetApiTeamsTeamIdFormsAppFormIdVersionsUrl = (teamId: string,
    formId: string,) => {




  return `/api/teams/${teamId}/forms/app/${formId}/versions`
}

export const getApiTeamsTeamIdFormsAppFormIdVersions = async (teamId: string,
    formId: string, options?: RequestInit): Promise<getApiTeamsTeamIdFormsAppFormIdVersionsResponse> => {

  return fetcher<getApiTeamsTeamIdFormsAppFormIdVersionsResponse>(getGetApiTeamsTeamIdFormsAppFormIdVersionsUrl(teamId,formId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiAdminFormsAppVersionsFormVersionIdSlotsResponse200 = {
  data: void
  status: 200
}

export type getApiAdminFormsAppVersionsFormVersionIdSlotsResponse401 = {
  data: GetApiAdminFormsAppVersionsFormVersionIdSlots401
  status: 401
}

export type getApiAdminFormsAppVersionsFormVersionIdSlotsResponseSuccess = (getApiAdminFormsAppVersionsFormVersionIdSlotsResponse200) & {
  headers: Headers;
};
export type getApiAdminFormsAppVersionsFormVersionIdSlotsResponseError = (getApiAdminFormsAppVersionsFormVersionIdSlotsResponse401) & {
  headers: Headers;
};

export type getApiAdminFormsAppVersionsFormVersionIdSlotsResponse = (getApiAdminFormsAppVersionsFormVersionIdSlotsResponseSuccess | getApiAdminFormsAppVersionsFormVersionIdSlotsResponseError)

export const getGetApiAdminFormsAppVersionsFormVersionIdSlotsUrl = (formVersionId: string,
    params?: GetApiAdminFormsAppVersionsFormVersionIdSlotsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/forms/app/versions/${formVersionId}/slots?${stringifiedParams}` : `/api/admin/forms/app/versions/${formVersionId}/slots`
}

export const getApiAdminFormsAppVersionsFormVersionIdSlots = async (formVersionId: string,
    params?: GetApiAdminFormsAppVersionsFormVersionIdSlotsParams, options?: RequestInit): Promise<getApiAdminFormsAppVersionsFormVersionIdSlotsResponse> => {

  return fetcher<getApiAdminFormsAppVersionsFormVersionIdSlotsResponse>(getGetApiAdminFormsAppVersionsFormVersionIdSlotsUrl(formVersionId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdFormsAppVersionsFormVersionIdSlotsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdFormsAppVersionsFormVersionIdSlotsResponse401 = {
  data: GetApiTeamsTeamIdFormsAppVersionsFormVersionIdSlots401
  status: 401
}

export type getApiTeamsTeamIdFormsAppVersionsFormVersionIdSlotsResponseSuccess = (getApiTeamsTeamIdFormsAppVersionsFormVersionIdSlotsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdFormsAppVersionsFormVersionIdSlotsResponseError = (getApiTeamsTeamIdFormsAppVersionsFormVersionIdSlotsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdFormsAppVersionsFormVersionIdSlotsResponse = (getApiTeamsTeamIdFormsAppVersionsFormVersionIdSlotsResponseSuccess | getApiTeamsTeamIdFormsAppVersionsFormVersionIdSlotsResponseError)

export const getGetApiTeamsTeamIdFormsAppVersionsFormVersionIdSlotsUrl = (teamId: string,
    formVersionId: string,
    params?: GetApiTeamsTeamIdFormsAppVersionsFormVersionIdSlotsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/forms/app/versions/${formVersionId}/slots?${stringifiedParams}` : `/api/teams/${teamId}/forms/app/versions/${formVersionId}/slots`
}

export const getApiTeamsTeamIdFormsAppVersionsFormVersionIdSlots = async (teamId: string,
    formVersionId: string,
    params?: GetApiTeamsTeamIdFormsAppVersionsFormVersionIdSlotsParams, options?: RequestInit): Promise<getApiTeamsTeamIdFormsAppVersionsFormVersionIdSlotsResponse> => {

  return fetcher<getApiTeamsTeamIdFormsAppVersionsFormVersionIdSlotsResponse>(getGetApiTeamsTeamIdFormsAppVersionsFormVersionIdSlotsUrl(teamId,formVersionId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiAdminFormsAppDatakeysResponse200 = {
  data: void
  status: 200
}

export type getApiAdminFormsAppDatakeysResponse401 = {
  data: GetApiAdminFormsAppDatakeys401
  status: 401
}

export type getApiAdminFormsAppDatakeysResponseSuccess = (getApiAdminFormsAppDatakeysResponse200) & {
  headers: Headers;
};
export type getApiAdminFormsAppDatakeysResponseError = (getApiAdminFormsAppDatakeysResponse401) & {
  headers: Headers;
};

export type getApiAdminFormsAppDatakeysResponse = (getApiAdminFormsAppDatakeysResponseSuccess | getApiAdminFormsAppDatakeysResponseError)

export const getGetApiAdminFormsAppDatakeysUrl = (params?: GetApiAdminFormsAppDatakeysParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/forms/app/datakeys?${stringifiedParams}` : `/api/admin/forms/app/datakeys`
}

export const getApiAdminFormsAppDatakeys = async (params?: GetApiAdminFormsAppDatakeysParams, options?: RequestInit): Promise<getApiAdminFormsAppDatakeysResponse> => {

  return fetcher<getApiAdminFormsAppDatakeysResponse>(getGetApiAdminFormsAppDatakeysUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiAdminFormsAppDatakeysResponse200 = {
  data: void
  status: 200
}

export type postApiAdminFormsAppDatakeysResponse401 = {
  data: PostApiAdminFormsAppDatakeys401
  status: 401
}

export type postApiAdminFormsAppDatakeysResponse402 = {
  data: PostApiAdminFormsAppDatakeys402
  status: 402
}

export type postApiAdminFormsAppDatakeysResponseSuccess = (postApiAdminFormsAppDatakeysResponse200) & {
  headers: Headers;
};
export type postApiAdminFormsAppDatakeysResponseError = (postApiAdminFormsAppDatakeysResponse401 | postApiAdminFormsAppDatakeysResponse402) & {
  headers: Headers;
};

export type postApiAdminFormsAppDatakeysResponse = (postApiAdminFormsAppDatakeysResponseSuccess | postApiAdminFormsAppDatakeysResponseError)

export const getPostApiAdminFormsAppDatakeysUrl = () => {




  return `/api/admin/forms/app/datakeys`
}

export const postApiAdminFormsAppDatakeys = async (createDataKeyRequest: CreateDataKeyRequest, options?: RequestInit): Promise<postApiAdminFormsAppDatakeysResponse> => {

  return fetcher<postApiAdminFormsAppDatakeysResponse>(getPostApiAdminFormsAppDatakeysUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createDataKeyRequest,)
  }
);}



export type getApiTeamsTeamIdFormsAppDatakeysResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdFormsAppDatakeysResponse401 = {
  data: GetApiTeamsTeamIdFormsAppDatakeys401
  status: 401
}

export type getApiTeamsTeamIdFormsAppDatakeysResponseSuccess = (getApiTeamsTeamIdFormsAppDatakeysResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdFormsAppDatakeysResponseError = (getApiTeamsTeamIdFormsAppDatakeysResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdFormsAppDatakeysResponse = (getApiTeamsTeamIdFormsAppDatakeysResponseSuccess | getApiTeamsTeamIdFormsAppDatakeysResponseError)

export const getGetApiTeamsTeamIdFormsAppDatakeysUrl = (teamId: string,
    params?: GetApiTeamsTeamIdFormsAppDatakeysParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/forms/app/datakeys?${stringifiedParams}` : `/api/teams/${teamId}/forms/app/datakeys`
}

export const getApiTeamsTeamIdFormsAppDatakeys = async (teamId: string,
    params?: GetApiTeamsTeamIdFormsAppDatakeysParams, options?: RequestInit): Promise<getApiTeamsTeamIdFormsAppDatakeysResponse> => {

  return fetcher<getApiTeamsTeamIdFormsAppDatakeysResponse>(getGetApiTeamsTeamIdFormsAppDatakeysUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiAdminFormsAppDatakeysSummaryResponse200 = {
  data: void
  status: 200
}

export type getApiAdminFormsAppDatakeysSummaryResponse401 = {
  data: GetApiAdminFormsAppDatakeysSummary401
  status: 401
}

export type getApiAdminFormsAppDatakeysSummaryResponseSuccess = (getApiAdminFormsAppDatakeysSummaryResponse200) & {
  headers: Headers;
};
export type getApiAdminFormsAppDatakeysSummaryResponseError = (getApiAdminFormsAppDatakeysSummaryResponse401) & {
  headers: Headers;
};

export type getApiAdminFormsAppDatakeysSummaryResponse = (getApiAdminFormsAppDatakeysSummaryResponseSuccess | getApiAdminFormsAppDatakeysSummaryResponseError)

export const getGetApiAdminFormsAppDatakeysSummaryUrl = (params?: GetApiAdminFormsAppDatakeysSummaryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/forms/app/datakeys/summary?${stringifiedParams}` : `/api/admin/forms/app/datakeys/summary`
}

export const getApiAdminFormsAppDatakeysSummary = async (params?: GetApiAdminFormsAppDatakeysSummaryParams, options?: RequestInit): Promise<getApiAdminFormsAppDatakeysSummaryResponse> => {

  return fetcher<getApiAdminFormsAppDatakeysSummaryResponse>(getGetApiAdminFormsAppDatakeysSummaryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdFormsAppDatakeysSummaryResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdFormsAppDatakeysSummaryResponse401 = {
  data: GetApiTeamsTeamIdFormsAppDatakeysSummary401
  status: 401
}

export type getApiTeamsTeamIdFormsAppDatakeysSummaryResponseSuccess = (getApiTeamsTeamIdFormsAppDatakeysSummaryResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdFormsAppDatakeysSummaryResponseError = (getApiTeamsTeamIdFormsAppDatakeysSummaryResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdFormsAppDatakeysSummaryResponse = (getApiTeamsTeamIdFormsAppDatakeysSummaryResponseSuccess | getApiTeamsTeamIdFormsAppDatakeysSummaryResponseError)

export const getGetApiTeamsTeamIdFormsAppDatakeysSummaryUrl = (teamId: string,
    params?: GetApiTeamsTeamIdFormsAppDatakeysSummaryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/forms/app/datakeys/summary?${stringifiedParams}` : `/api/teams/${teamId}/forms/app/datakeys/summary`
}

export const getApiTeamsTeamIdFormsAppDatakeysSummary = async (teamId: string,
    params?: GetApiTeamsTeamIdFormsAppDatakeysSummaryParams, options?: RequestInit): Promise<getApiTeamsTeamIdFormsAppDatakeysSummaryResponse> => {

  return fetcher<getApiTeamsTeamIdFormsAppDatakeysSummaryResponse>(getGetApiTeamsTeamIdFormsAppDatakeysSummaryUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type putApiAdminFormsAppDatakeysDataKeyResponse200 = {
  data: void
  status: 200
}

export type putApiAdminFormsAppDatakeysDataKeyResponse401 = {
  data: PutApiAdminFormsAppDatakeysDataKey401
  status: 401
}

export type putApiAdminFormsAppDatakeysDataKeyResponse402 = {
  data: PutApiAdminFormsAppDatakeysDataKey402
  status: 402
}

export type putApiAdminFormsAppDatakeysDataKeyResponseSuccess = (putApiAdminFormsAppDatakeysDataKeyResponse200) & {
  headers: Headers;
};
export type putApiAdminFormsAppDatakeysDataKeyResponseError = (putApiAdminFormsAppDatakeysDataKeyResponse401 | putApiAdminFormsAppDatakeysDataKeyResponse402) & {
  headers: Headers;
};

export type putApiAdminFormsAppDatakeysDataKeyResponse = (putApiAdminFormsAppDatakeysDataKeyResponseSuccess | putApiAdminFormsAppDatakeysDataKeyResponseError)

export const getPutApiAdminFormsAppDatakeysDataKeyUrl = (dataKey: string,) => {




  return `/api/admin/forms/app/datakeys/${dataKey}`
}

export const putApiAdminFormsAppDatakeysDataKey = async (dataKey: string,
    updateDataKeyRequest: UpdateDataKeyRequest, options?: RequestInit): Promise<putApiAdminFormsAppDatakeysDataKeyResponse> => {

  return fetcher<putApiAdminFormsAppDatakeysDataKeyResponse>(getPutApiAdminFormsAppDatakeysDataKeyUrl(dataKey),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateDataKeyRequest,)
  }
);}



export type putApiAdminFormsAppDatakeysDataKeyIntakeSettingsResponse200 = {
  data: void
  status: 200
}

export type putApiAdminFormsAppDatakeysDataKeyIntakeSettingsResponse401 = {
  data: PutApiAdminFormsAppDatakeysDataKeyIntakeSettings401
  status: 401
}

export type putApiAdminFormsAppDatakeysDataKeyIntakeSettingsResponse402 = {
  data: PutApiAdminFormsAppDatakeysDataKeyIntakeSettings402
  status: 402
}

export type putApiAdminFormsAppDatakeysDataKeyIntakeSettingsResponseSuccess = (putApiAdminFormsAppDatakeysDataKeyIntakeSettingsResponse200) & {
  headers: Headers;
};
export type putApiAdminFormsAppDatakeysDataKeyIntakeSettingsResponseError = (putApiAdminFormsAppDatakeysDataKeyIntakeSettingsResponse401 | putApiAdminFormsAppDatakeysDataKeyIntakeSettingsResponse402) & {
  headers: Headers;
};

export type putApiAdminFormsAppDatakeysDataKeyIntakeSettingsResponse = (putApiAdminFormsAppDatakeysDataKeyIntakeSettingsResponseSuccess | putApiAdminFormsAppDatakeysDataKeyIntakeSettingsResponseError)

export const getPutApiAdminFormsAppDatakeysDataKeyIntakeSettingsUrl = (dataKey: string,) => {




  return `/api/admin/forms/app/datakeys/${dataKey}/intake-settings`
}

export const putApiAdminFormsAppDatakeysDataKeyIntakeSettings = async (dataKey: string,
    updateDataKeyIntakeSettingsRequest: UpdateDataKeyIntakeSettingsRequest, options?: RequestInit): Promise<putApiAdminFormsAppDatakeysDataKeyIntakeSettingsResponse> => {

  return fetcher<putApiAdminFormsAppDatakeysDataKeyIntakeSettingsResponse>(getPutApiAdminFormsAppDatakeysDataKeyIntakeSettingsUrl(dataKey),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateDataKeyIntakeSettingsRequest,)
  }
);}



export type postApiAdminFormsAppDatakeysDataKeyActiveResponse200 = {
  data: void
  status: 200
}

export type postApiAdminFormsAppDatakeysDataKeyActiveResponse401 = {
  data: PostApiAdminFormsAppDatakeysDataKeyActive401
  status: 401
}

export type postApiAdminFormsAppDatakeysDataKeyActiveResponse402 = {
  data: PostApiAdminFormsAppDatakeysDataKeyActive402
  status: 402
}

export type postApiAdminFormsAppDatakeysDataKeyActiveResponseSuccess = (postApiAdminFormsAppDatakeysDataKeyActiveResponse200) & {
  headers: Headers;
};
export type postApiAdminFormsAppDatakeysDataKeyActiveResponseError = (postApiAdminFormsAppDatakeysDataKeyActiveResponse401 | postApiAdminFormsAppDatakeysDataKeyActiveResponse402) & {
  headers: Headers;
};

export type postApiAdminFormsAppDatakeysDataKeyActiveResponse = (postApiAdminFormsAppDatakeysDataKeyActiveResponseSuccess | postApiAdminFormsAppDatakeysDataKeyActiveResponseError)

export const getPostApiAdminFormsAppDatakeysDataKeyActiveUrl = (dataKey: string,) => {




  return `/api/admin/forms/app/datakeys/${dataKey}/active`
}

export const postApiAdminFormsAppDatakeysDataKeyActive = async (dataKey: string,
    updateDataKeyActiveRequest: UpdateDataKeyActiveRequest, options?: RequestInit): Promise<postApiAdminFormsAppDatakeysDataKeyActiveResponse> => {

  return fetcher<postApiAdminFormsAppDatakeysDataKeyActiveResponse>(getPostApiAdminFormsAppDatakeysDataKeyActiveUrl(dataKey),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateDataKeyActiveRequest,)
  }
);}



export type getApiAdminFormsAppVersionsFormVersionIdDatakeyBindingsResponse200 = {
  data: void
  status: 200
}

export type getApiAdminFormsAppVersionsFormVersionIdDatakeyBindingsResponse401 = {
  data: GetApiAdminFormsAppVersionsFormVersionIdDatakeyBindings401
  status: 401
}

export type getApiAdminFormsAppVersionsFormVersionIdDatakeyBindingsResponseSuccess = (getApiAdminFormsAppVersionsFormVersionIdDatakeyBindingsResponse200) & {
  headers: Headers;
};
export type getApiAdminFormsAppVersionsFormVersionIdDatakeyBindingsResponseError = (getApiAdminFormsAppVersionsFormVersionIdDatakeyBindingsResponse401) & {
  headers: Headers;
};

export type getApiAdminFormsAppVersionsFormVersionIdDatakeyBindingsResponse = (getApiAdminFormsAppVersionsFormVersionIdDatakeyBindingsResponseSuccess | getApiAdminFormsAppVersionsFormVersionIdDatakeyBindingsResponseError)

export const getGetApiAdminFormsAppVersionsFormVersionIdDatakeyBindingsUrl = (formVersionId: string,) => {




  return `/api/admin/forms/app/versions/${formVersionId}/datakey-bindings`
}

export const getApiAdminFormsAppVersionsFormVersionIdDatakeyBindings = async (formVersionId: string, options?: RequestInit): Promise<getApiAdminFormsAppVersionsFormVersionIdDatakeyBindingsResponse> => {

  return fetcher<getApiAdminFormsAppVersionsFormVersionIdDatakeyBindingsResponse>(getGetApiAdminFormsAppVersionsFormVersionIdDatakeyBindingsUrl(formVersionId),
  {
    ...options,
    method: 'GET'


  }
);}



export type putApiAdminFormsAppVersionsFormVersionIdDatakeyBindingsResponse200 = {
  data: void
  status: 200
}

export type putApiAdminFormsAppVersionsFormVersionIdDatakeyBindingsResponse401 = {
  data: PutApiAdminFormsAppVersionsFormVersionIdDatakeyBindings401
  status: 401
}

export type putApiAdminFormsAppVersionsFormVersionIdDatakeyBindingsResponse402 = {
  data: PutApiAdminFormsAppVersionsFormVersionIdDatakeyBindings402
  status: 402
}

export type putApiAdminFormsAppVersionsFormVersionIdDatakeyBindingsResponseSuccess = (putApiAdminFormsAppVersionsFormVersionIdDatakeyBindingsResponse200) & {
  headers: Headers;
};
export type putApiAdminFormsAppVersionsFormVersionIdDatakeyBindingsResponseError = (putApiAdminFormsAppVersionsFormVersionIdDatakeyBindingsResponse401 | putApiAdminFormsAppVersionsFormVersionIdDatakeyBindingsResponse402) & {
  headers: Headers;
};

export type putApiAdminFormsAppVersionsFormVersionIdDatakeyBindingsResponse = (putApiAdminFormsAppVersionsFormVersionIdDatakeyBindingsResponseSuccess | putApiAdminFormsAppVersionsFormVersionIdDatakeyBindingsResponseError)

export const getPutApiAdminFormsAppVersionsFormVersionIdDatakeyBindingsUrl = (formVersionId: string,) => {




  return `/api/admin/forms/app/versions/${formVersionId}/datakey-bindings`
}

export const putApiAdminFormsAppVersionsFormVersionIdDatakeyBindings = async (formVersionId: string,
    saveFormSlotDataKeyBindingsRequest: SaveFormSlotDataKeyBindingsRequest, options?: RequestInit): Promise<putApiAdminFormsAppVersionsFormVersionIdDatakeyBindingsResponse> => {

  return fetcher<putApiAdminFormsAppVersionsFormVersionIdDatakeyBindingsResponse>(getPutApiAdminFormsAppVersionsFormVersionIdDatakeyBindingsUrl(formVersionId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      saveFormSlotDataKeyBindingsRequest,)
  }
);}



export type getApiTeamsTeamIdFormsAppVersionsFormVersionIdDatakeyBindingsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdFormsAppVersionsFormVersionIdDatakeyBindingsResponse401 = {
  data: GetApiTeamsTeamIdFormsAppVersionsFormVersionIdDatakeyBindings401
  status: 401
}

export type getApiTeamsTeamIdFormsAppVersionsFormVersionIdDatakeyBindingsResponseSuccess = (getApiTeamsTeamIdFormsAppVersionsFormVersionIdDatakeyBindingsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdFormsAppVersionsFormVersionIdDatakeyBindingsResponseError = (getApiTeamsTeamIdFormsAppVersionsFormVersionIdDatakeyBindingsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdFormsAppVersionsFormVersionIdDatakeyBindingsResponse = (getApiTeamsTeamIdFormsAppVersionsFormVersionIdDatakeyBindingsResponseSuccess | getApiTeamsTeamIdFormsAppVersionsFormVersionIdDatakeyBindingsResponseError)

export const getGetApiTeamsTeamIdFormsAppVersionsFormVersionIdDatakeyBindingsUrl = (teamId: string,
    formVersionId: string,) => {




  return `/api/teams/${teamId}/forms/app/versions/${formVersionId}/datakey-bindings`
}

export const getApiTeamsTeamIdFormsAppVersionsFormVersionIdDatakeyBindings = async (teamId: string,
    formVersionId: string, options?: RequestInit): Promise<getApiTeamsTeamIdFormsAppVersionsFormVersionIdDatakeyBindingsResponse> => {

  return fetcher<getApiTeamsTeamIdFormsAppVersionsFormVersionIdDatakeyBindingsResponse>(getGetApiTeamsTeamIdFormsAppVersionsFormVersionIdDatakeyBindingsUrl(teamId,formVersionId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiAdminFormsAppCrmBindingsResponse200 = {
  data: void
  status: 200
}

export type getApiAdminFormsAppCrmBindingsResponse401 = {
  data: GetApiAdminFormsAppCrmBindings401
  status: 401
}

export type getApiAdminFormsAppCrmBindingsResponseSuccess = (getApiAdminFormsAppCrmBindingsResponse200) & {
  headers: Headers;
};
export type getApiAdminFormsAppCrmBindingsResponseError = (getApiAdminFormsAppCrmBindingsResponse401) & {
  headers: Headers;
};

export type getApiAdminFormsAppCrmBindingsResponse = (getApiAdminFormsAppCrmBindingsResponseSuccess | getApiAdminFormsAppCrmBindingsResponseError)

export const getGetApiAdminFormsAppCrmBindingsUrl = (params?: GetApiAdminFormsAppCrmBindingsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/forms/app/crm-bindings?${stringifiedParams}` : `/api/admin/forms/app/crm-bindings`
}

export const getApiAdminFormsAppCrmBindings = async (params?: GetApiAdminFormsAppCrmBindingsParams, options?: RequestInit): Promise<getApiAdminFormsAppCrmBindingsResponse> => {

  return fetcher<getApiAdminFormsAppCrmBindingsResponse>(getGetApiAdminFormsAppCrmBindingsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdFormsAppPartiesPartyIdDatakeyValuesResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdFormsAppPartiesPartyIdDatakeyValuesResponse401 = {
  data: GetApiTeamsTeamIdFormsAppPartiesPartyIdDatakeyValues401
  status: 401
}

export type getApiTeamsTeamIdFormsAppPartiesPartyIdDatakeyValuesResponseSuccess = (getApiTeamsTeamIdFormsAppPartiesPartyIdDatakeyValuesResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdFormsAppPartiesPartyIdDatakeyValuesResponseError = (getApiTeamsTeamIdFormsAppPartiesPartyIdDatakeyValuesResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdFormsAppPartiesPartyIdDatakeyValuesResponse = (getApiTeamsTeamIdFormsAppPartiesPartyIdDatakeyValuesResponseSuccess | getApiTeamsTeamIdFormsAppPartiesPartyIdDatakeyValuesResponseError)

export const getGetApiTeamsTeamIdFormsAppPartiesPartyIdDatakeyValuesUrl = (teamId: string,
    partyId: string,
    params?: GetApiTeamsTeamIdFormsAppPartiesPartyIdDatakeyValuesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/forms/app/parties/${partyId}/datakey-values?${stringifiedParams}` : `/api/teams/${teamId}/forms/app/parties/${partyId}/datakey-values`
}

export const getApiTeamsTeamIdFormsAppPartiesPartyIdDatakeyValues = async (teamId: string,
    partyId: string,
    params?: GetApiTeamsTeamIdFormsAppPartiesPartyIdDatakeyValuesParams, options?: RequestInit): Promise<getApiTeamsTeamIdFormsAppPartiesPartyIdDatakeyValuesResponse> => {

  return fetcher<getApiTeamsTeamIdFormsAppPartiesPartyIdDatakeyValuesResponse>(getGetApiTeamsTeamIdFormsAppPartiesPartyIdDatakeyValuesUrl(teamId,partyId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type putApiTeamsTeamIdFormsAppPartiesPartyIdDatakeyValuesResponse200 = {
  data: void
  status: 200
}

export type putApiTeamsTeamIdFormsAppPartiesPartyIdDatakeyValuesResponse401 = {
  data: PutApiTeamsTeamIdFormsAppPartiesPartyIdDatakeyValues401
  status: 401
}

export type putApiTeamsTeamIdFormsAppPartiesPartyIdDatakeyValuesResponse402 = {
  data: PutApiTeamsTeamIdFormsAppPartiesPartyIdDatakeyValues402
  status: 402
}

export type putApiTeamsTeamIdFormsAppPartiesPartyIdDatakeyValuesResponseSuccess = (putApiTeamsTeamIdFormsAppPartiesPartyIdDatakeyValuesResponse200) & {
  headers: Headers;
};
export type putApiTeamsTeamIdFormsAppPartiesPartyIdDatakeyValuesResponseError = (putApiTeamsTeamIdFormsAppPartiesPartyIdDatakeyValuesResponse401 | putApiTeamsTeamIdFormsAppPartiesPartyIdDatakeyValuesResponse402) & {
  headers: Headers;
};

export type putApiTeamsTeamIdFormsAppPartiesPartyIdDatakeyValuesResponse = (putApiTeamsTeamIdFormsAppPartiesPartyIdDatakeyValuesResponseSuccess | putApiTeamsTeamIdFormsAppPartiesPartyIdDatakeyValuesResponseError)

export const getPutApiTeamsTeamIdFormsAppPartiesPartyIdDatakeyValuesUrl = (teamId: string,
    partyId: string,) => {




  return `/api/teams/${teamId}/forms/app/parties/${partyId}/datakey-values`
}

export const putApiTeamsTeamIdFormsAppPartiesPartyIdDatakeyValues = async (teamId: string,
    partyId: string,
    savePartyDataKeyValuesRequest: SavePartyDataKeyValuesRequest, options?: RequestInit): Promise<putApiTeamsTeamIdFormsAppPartiesPartyIdDatakeyValuesResponse> => {

  return fetcher<putApiTeamsTeamIdFormsAppPartiesPartyIdDatakeyValuesResponse>(getPutApiTeamsTeamIdFormsAppPartiesPartyIdDatakeyValuesUrl(teamId,partyId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      savePartyDataKeyValuesRequest,)
  }
);}



export type getApiTeamsTeamIdFormsAppPartiesDatakeyValuesSummaryResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdFormsAppPartiesDatakeyValuesSummaryResponse401 = {
  data: GetApiTeamsTeamIdFormsAppPartiesDatakeyValuesSummary401
  status: 401
}

export type getApiTeamsTeamIdFormsAppPartiesDatakeyValuesSummaryResponseSuccess = (getApiTeamsTeamIdFormsAppPartiesDatakeyValuesSummaryResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdFormsAppPartiesDatakeyValuesSummaryResponseError = (getApiTeamsTeamIdFormsAppPartiesDatakeyValuesSummaryResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdFormsAppPartiesDatakeyValuesSummaryResponse = (getApiTeamsTeamIdFormsAppPartiesDatakeyValuesSummaryResponseSuccess | getApiTeamsTeamIdFormsAppPartiesDatakeyValuesSummaryResponseError)

export const getGetApiTeamsTeamIdFormsAppPartiesDatakeyValuesSummaryUrl = (teamId: string,
    params?: GetApiTeamsTeamIdFormsAppPartiesDatakeyValuesSummaryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/forms/app/parties/datakey-values/summary?${stringifiedParams}` : `/api/teams/${teamId}/forms/app/parties/datakey-values/summary`
}

export const getApiTeamsTeamIdFormsAppPartiesDatakeyValuesSummary = async (teamId: string,
    params?: GetApiTeamsTeamIdFormsAppPartiesDatakeyValuesSummaryParams, options?: RequestInit): Promise<getApiTeamsTeamIdFormsAppPartiesDatakeyValuesSummaryResponse> => {

  return fetcher<getApiTeamsTeamIdFormsAppPartiesDatakeyValuesSummaryResponse>(getGetApiTeamsTeamIdFormsAppPartiesDatakeyValuesSummaryUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiAdminFormsAppScheduleTypesResponse200 = {
  data: void
  status: 200
}

export type getApiAdminFormsAppScheduleTypesResponse401 = {
  data: GetApiAdminFormsAppScheduleTypes401
  status: 401
}

export type getApiAdminFormsAppScheduleTypesResponseSuccess = (getApiAdminFormsAppScheduleTypesResponse200) & {
  headers: Headers;
};
export type getApiAdminFormsAppScheduleTypesResponseError = (getApiAdminFormsAppScheduleTypesResponse401) & {
  headers: Headers;
};

export type getApiAdminFormsAppScheduleTypesResponse = (getApiAdminFormsAppScheduleTypesResponseSuccess | getApiAdminFormsAppScheduleTypesResponseError)

export const getGetApiAdminFormsAppScheduleTypesUrl = (params?: GetApiAdminFormsAppScheduleTypesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/forms/app/schedule-types?${stringifiedParams}` : `/api/admin/forms/app/schedule-types`
}

export const getApiAdminFormsAppScheduleTypes = async (params?: GetApiAdminFormsAppScheduleTypesParams, options?: RequestInit): Promise<getApiAdminFormsAppScheduleTypesResponse> => {

  return fetcher<getApiAdminFormsAppScheduleTypesResponse>(getGetApiAdminFormsAppScheduleTypesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiAdminFormsAppScheduleTypesScheduleTypeFieldsResponse200 = {
  data: void
  status: 200
}

export type getApiAdminFormsAppScheduleTypesScheduleTypeFieldsResponse401 = {
  data: GetApiAdminFormsAppScheduleTypesScheduleTypeFields401
  status: 401
}

export type getApiAdminFormsAppScheduleTypesScheduleTypeFieldsResponseSuccess = (getApiAdminFormsAppScheduleTypesScheduleTypeFieldsResponse200) & {
  headers: Headers;
};
export type getApiAdminFormsAppScheduleTypesScheduleTypeFieldsResponseError = (getApiAdminFormsAppScheduleTypesScheduleTypeFieldsResponse401) & {
  headers: Headers;
};

export type getApiAdminFormsAppScheduleTypesScheduleTypeFieldsResponse = (getApiAdminFormsAppScheduleTypesScheduleTypeFieldsResponseSuccess | getApiAdminFormsAppScheduleTypesScheduleTypeFieldsResponseError)

export const getGetApiAdminFormsAppScheduleTypesScheduleTypeFieldsUrl = (scheduleType: string,
    params?: GetApiAdminFormsAppScheduleTypesScheduleTypeFieldsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/forms/app/schedule-types/${scheduleType}/fields?${stringifiedParams}` : `/api/admin/forms/app/schedule-types/${scheduleType}/fields`
}

export const getApiAdminFormsAppScheduleTypesScheduleTypeFields = async (scheduleType: string,
    params?: GetApiAdminFormsAppScheduleTypesScheduleTypeFieldsParams, options?: RequestInit): Promise<getApiAdminFormsAppScheduleTypesScheduleTypeFieldsResponse> => {

  return fetcher<getApiAdminFormsAppScheduleTypesScheduleTypeFieldsResponse>(getGetApiAdminFormsAppScheduleTypesScheduleTypeFieldsUrl(scheduleType,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type putApiAdminFormsAppScheduleTypesScheduleTypeFieldsResponse200 = {
  data: void
  status: 200
}

export type putApiAdminFormsAppScheduleTypesScheduleTypeFieldsResponse401 = {
  data: PutApiAdminFormsAppScheduleTypesScheduleTypeFields401
  status: 401
}

export type putApiAdminFormsAppScheduleTypesScheduleTypeFieldsResponse402 = {
  data: PutApiAdminFormsAppScheduleTypesScheduleTypeFields402
  status: 402
}

export type putApiAdminFormsAppScheduleTypesScheduleTypeFieldsResponseSuccess = (putApiAdminFormsAppScheduleTypesScheduleTypeFieldsResponse200) & {
  headers: Headers;
};
export type putApiAdminFormsAppScheduleTypesScheduleTypeFieldsResponseError = (putApiAdminFormsAppScheduleTypesScheduleTypeFieldsResponse401 | putApiAdminFormsAppScheduleTypesScheduleTypeFieldsResponse402) & {
  headers: Headers;
};

export type putApiAdminFormsAppScheduleTypesScheduleTypeFieldsResponse = (putApiAdminFormsAppScheduleTypesScheduleTypeFieldsResponseSuccess | putApiAdminFormsAppScheduleTypesScheduleTypeFieldsResponseError)

export const getPutApiAdminFormsAppScheduleTypesScheduleTypeFieldsUrl = (scheduleType: string,) => {




  return `/api/admin/forms/app/schedule-types/${scheduleType}/fields`
}

export const putApiAdminFormsAppScheduleTypesScheduleTypeFields = async (scheduleType: string,
    saveScheduleFieldsRequest: SaveScheduleFieldsRequest, options?: RequestInit): Promise<putApiAdminFormsAppScheduleTypesScheduleTypeFieldsResponse> => {

  return fetcher<putApiAdminFormsAppScheduleTypesScheduleTypeFieldsResponse>(getPutApiAdminFormsAppScheduleTypesScheduleTypeFieldsUrl(scheduleType),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      saveScheduleFieldsRequest,)
  }
);}



export type putApiAdminFormsAppVersionsFormVersionIdYamlResponse200 = {
  data: void
  status: 200
}

export type putApiAdminFormsAppVersionsFormVersionIdYamlResponse401 = {
  data: PutApiAdminFormsAppVersionsFormVersionIdYaml401
  status: 401
}

export type putApiAdminFormsAppVersionsFormVersionIdYamlResponse402 = {
  data: PutApiAdminFormsAppVersionsFormVersionIdYaml402
  status: 402
}

export type putApiAdminFormsAppVersionsFormVersionIdYamlResponseSuccess = (putApiAdminFormsAppVersionsFormVersionIdYamlResponse200) & {
  headers: Headers;
};
export type putApiAdminFormsAppVersionsFormVersionIdYamlResponseError = (putApiAdminFormsAppVersionsFormVersionIdYamlResponse401 | putApiAdminFormsAppVersionsFormVersionIdYamlResponse402) & {
  headers: Headers;
};

export type putApiAdminFormsAppVersionsFormVersionIdYamlResponse = (putApiAdminFormsAppVersionsFormVersionIdYamlResponseSuccess | putApiAdminFormsAppVersionsFormVersionIdYamlResponseError)

export const getPutApiAdminFormsAppVersionsFormVersionIdYamlUrl = (formVersionId: string,) => {




  return `/api/admin/forms/app/versions/${formVersionId}/yaml`
}

export const putApiAdminFormsAppVersionsFormVersionIdYaml = async (formVersionId: string,
    updateAppFormYamlRequest: UpdateAppFormYamlRequest, options?: RequestInit): Promise<putApiAdminFormsAppVersionsFormVersionIdYamlResponse> => {

  return fetcher<putApiAdminFormsAppVersionsFormVersionIdYamlResponse>(getPutApiAdminFormsAppVersionsFormVersionIdYamlUrl(formVersionId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateAppFormYamlRequest,)
  }
);}



export type postApiAdminFormsAppVersionsFormVersionIdGenerateYamlResponse200 = {
  data: void
  status: 200
}

export type postApiAdminFormsAppVersionsFormVersionIdGenerateYamlResponse401 = {
  data: PostApiAdminFormsAppVersionsFormVersionIdGenerateYaml401
  status: 401
}

export type postApiAdminFormsAppVersionsFormVersionIdGenerateYamlResponse402 = {
  data: PostApiAdminFormsAppVersionsFormVersionIdGenerateYaml402
  status: 402
}

export type postApiAdminFormsAppVersionsFormVersionIdGenerateYamlResponseSuccess = (postApiAdminFormsAppVersionsFormVersionIdGenerateYamlResponse200) & {
  headers: Headers;
};
export type postApiAdminFormsAppVersionsFormVersionIdGenerateYamlResponseError = (postApiAdminFormsAppVersionsFormVersionIdGenerateYamlResponse401 | postApiAdminFormsAppVersionsFormVersionIdGenerateYamlResponse402) & {
  headers: Headers;
};

export type postApiAdminFormsAppVersionsFormVersionIdGenerateYamlResponse = (postApiAdminFormsAppVersionsFormVersionIdGenerateYamlResponseSuccess | postApiAdminFormsAppVersionsFormVersionIdGenerateYamlResponseError)

export const getPostApiAdminFormsAppVersionsFormVersionIdGenerateYamlUrl = (formVersionId: string,) => {




  return `/api/admin/forms/app/versions/${formVersionId}/generate-yaml`
}

export const postApiAdminFormsAppVersionsFormVersionIdGenerateYaml = async (formVersionId: string,
    nullGenerateAppYamlRequest: null | GenerateAppYamlRequest, options?: RequestInit): Promise<postApiAdminFormsAppVersionsFormVersionIdGenerateYamlResponse> => {

  return fetcher<postApiAdminFormsAppVersionsFormVersionIdGenerateYamlResponse>(getPostApiAdminFormsAppVersionsFormVersionIdGenerateYamlUrl(formVersionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullGenerateAppYamlRequest,)
  }
);}



export type postApiAdminFormsAppVersionsFormVersionIdCompileResponse200 = {
  data: void
  status: 200
}

export type postApiAdminFormsAppVersionsFormVersionIdCompileResponse401 = {
  data: PostApiAdminFormsAppVersionsFormVersionIdCompile401
  status: 401
}

export type postApiAdminFormsAppVersionsFormVersionIdCompileResponse402 = {
  data: PostApiAdminFormsAppVersionsFormVersionIdCompile402
  status: 402
}

export type postApiAdminFormsAppVersionsFormVersionIdCompileResponseSuccess = (postApiAdminFormsAppVersionsFormVersionIdCompileResponse200) & {
  headers: Headers;
};
export type postApiAdminFormsAppVersionsFormVersionIdCompileResponseError = (postApiAdminFormsAppVersionsFormVersionIdCompileResponse401 | postApiAdminFormsAppVersionsFormVersionIdCompileResponse402) & {
  headers: Headers;
};

export type postApiAdminFormsAppVersionsFormVersionIdCompileResponse = (postApiAdminFormsAppVersionsFormVersionIdCompileResponseSuccess | postApiAdminFormsAppVersionsFormVersionIdCompileResponseError)

export const getPostApiAdminFormsAppVersionsFormVersionIdCompileUrl = (formVersionId: string,) => {




  return `/api/admin/forms/app/versions/${formVersionId}/compile`
}

export const postApiAdminFormsAppVersionsFormVersionIdCompile = async (formVersionId: string,
    nullCompileAppFormRequest: null | CompileAppFormRequest, options?: RequestInit): Promise<postApiAdminFormsAppVersionsFormVersionIdCompileResponse> => {

  return fetcher<postApiAdminFormsAppVersionsFormVersionIdCompileResponse>(getPostApiAdminFormsAppVersionsFormVersionIdCompileUrl(formVersionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullCompileAppFormRequest,)
  }
);}



export type postApiAdminFormsAppFormIdVersionsFormVersionIdActivateResponse200 = {
  data: void
  status: 200
}

export type postApiAdminFormsAppFormIdVersionsFormVersionIdActivateResponse401 = {
  data: PostApiAdminFormsAppFormIdVersionsFormVersionIdActivate401
  status: 401
}

export type postApiAdminFormsAppFormIdVersionsFormVersionIdActivateResponse402 = {
  data: PostApiAdminFormsAppFormIdVersionsFormVersionIdActivate402
  status: 402
}

export type postApiAdminFormsAppFormIdVersionsFormVersionIdActivateResponseSuccess = (postApiAdminFormsAppFormIdVersionsFormVersionIdActivateResponse200) & {
  headers: Headers;
};
export type postApiAdminFormsAppFormIdVersionsFormVersionIdActivateResponseError = (postApiAdminFormsAppFormIdVersionsFormVersionIdActivateResponse401 | postApiAdminFormsAppFormIdVersionsFormVersionIdActivateResponse402) & {
  headers: Headers;
};

export type postApiAdminFormsAppFormIdVersionsFormVersionIdActivateResponse = (postApiAdminFormsAppFormIdVersionsFormVersionIdActivateResponseSuccess | postApiAdminFormsAppFormIdVersionsFormVersionIdActivateResponseError)

export const getPostApiAdminFormsAppFormIdVersionsFormVersionIdActivateUrl = (formId: string,
    formVersionId: string,) => {




  return `/api/admin/forms/app/${formId}/versions/${formVersionId}/activate`
}

export const postApiAdminFormsAppFormIdVersionsFormVersionIdActivate = async (formId: string,
    formVersionId: string, options?: RequestInit): Promise<postApiAdminFormsAppFormIdVersionsFormVersionIdActivateResponse> => {

  return fetcher<postApiAdminFormsAppFormIdVersionsFormVersionIdActivateResponse>(getPostApiAdminFormsAppFormIdVersionsFormVersionIdActivateUrl(formId,formVersionId),
  {
    ...options,
    method: 'POST'


  }
);}



export type postApiAdminFormsAppVersionsFormVersionIdDeactivateResponse200 = {
  data: void
  status: 200
}

export type postApiAdminFormsAppVersionsFormVersionIdDeactivateResponse401 = {
  data: PostApiAdminFormsAppVersionsFormVersionIdDeactivate401
  status: 401
}

export type postApiAdminFormsAppVersionsFormVersionIdDeactivateResponse402 = {
  data: PostApiAdminFormsAppVersionsFormVersionIdDeactivate402
  status: 402
}

export type postApiAdminFormsAppVersionsFormVersionIdDeactivateResponseSuccess = (postApiAdminFormsAppVersionsFormVersionIdDeactivateResponse200) & {
  headers: Headers;
};
export type postApiAdminFormsAppVersionsFormVersionIdDeactivateResponseError = (postApiAdminFormsAppVersionsFormVersionIdDeactivateResponse401 | postApiAdminFormsAppVersionsFormVersionIdDeactivateResponse402) & {
  headers: Headers;
};

export type postApiAdminFormsAppVersionsFormVersionIdDeactivateResponse = (postApiAdminFormsAppVersionsFormVersionIdDeactivateResponseSuccess | postApiAdminFormsAppVersionsFormVersionIdDeactivateResponseError)

export const getPostApiAdminFormsAppVersionsFormVersionIdDeactivateUrl = (formVersionId: string,) => {




  return `/api/admin/forms/app/versions/${formVersionId}/deactivate`
}

export const postApiAdminFormsAppVersionsFormVersionIdDeactivate = async (formVersionId: string, options?: RequestInit): Promise<postApiAdminFormsAppVersionsFormVersionIdDeactivateResponse> => {

  return fetcher<postApiAdminFormsAppVersionsFormVersionIdDeactivateResponse>(getPostApiAdminFormsAppVersionsFormVersionIdDeactivateUrl(formVersionId),
  {
    ...options,
    method: 'POST'


  }
);}



export type deleteApiAdminFormsAppVersionsFormVersionIdResponse200 = {
  data: void
  status: 200
}

export type deleteApiAdminFormsAppVersionsFormVersionIdResponse401 = {
  data: DeleteApiAdminFormsAppVersionsFormVersionId401
  status: 401
}

export type deleteApiAdminFormsAppVersionsFormVersionIdResponse402 = {
  data: DeleteApiAdminFormsAppVersionsFormVersionId402
  status: 402
}

export type deleteApiAdminFormsAppVersionsFormVersionIdResponseSuccess = (deleteApiAdminFormsAppVersionsFormVersionIdResponse200) & {
  headers: Headers;
};
export type deleteApiAdminFormsAppVersionsFormVersionIdResponseError = (deleteApiAdminFormsAppVersionsFormVersionIdResponse401 | deleteApiAdminFormsAppVersionsFormVersionIdResponse402) & {
  headers: Headers;
};

export type deleteApiAdminFormsAppVersionsFormVersionIdResponse = (deleteApiAdminFormsAppVersionsFormVersionIdResponseSuccess | deleteApiAdminFormsAppVersionsFormVersionIdResponseError)

export const getDeleteApiAdminFormsAppVersionsFormVersionIdUrl = (formVersionId: string,) => {




  return `/api/admin/forms/app/versions/${formVersionId}`
}

export const deleteApiAdminFormsAppVersionsFormVersionId = async (formVersionId: string, options?: RequestInit): Promise<deleteApiAdminFormsAppVersionsFormVersionIdResponse> => {

  return fetcher<deleteApiAdminFormsAppVersionsFormVersionIdResponse>(getDeleteApiAdminFormsAppVersionsFormVersionIdUrl(formVersionId),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type putApiAdminFormsAppVersionsFormVersionIdGeometryResponse200 = {
  data: void
  status: 200
}

export type putApiAdminFormsAppVersionsFormVersionIdGeometryResponse401 = {
  data: PutApiAdminFormsAppVersionsFormVersionIdGeometry401
  status: 401
}

export type putApiAdminFormsAppVersionsFormVersionIdGeometryResponse402 = {
  data: PutApiAdminFormsAppVersionsFormVersionIdGeometry402
  status: 402
}

export type putApiAdminFormsAppVersionsFormVersionIdGeometryResponseSuccess = (putApiAdminFormsAppVersionsFormVersionIdGeometryResponse200) & {
  headers: Headers;
};
export type putApiAdminFormsAppVersionsFormVersionIdGeometryResponseError = (putApiAdminFormsAppVersionsFormVersionIdGeometryResponse401 | putApiAdminFormsAppVersionsFormVersionIdGeometryResponse402) & {
  headers: Headers;
};

export type putApiAdminFormsAppVersionsFormVersionIdGeometryResponse = (putApiAdminFormsAppVersionsFormVersionIdGeometryResponseSuccess | putApiAdminFormsAppVersionsFormVersionIdGeometryResponseError)

export const getPutApiAdminFormsAppVersionsFormVersionIdGeometryUrl = (formVersionId: string,) => {




  return `/api/admin/forms/app/versions/${formVersionId}/geometry`
}

export const putApiAdminFormsAppVersionsFormVersionIdGeometry = async (formVersionId: string,
    appUpdateGeometryRequest: AppUpdateGeometryRequest, options?: RequestInit): Promise<putApiAdminFormsAppVersionsFormVersionIdGeometryResponse> => {

  return fetcher<putApiAdminFormsAppVersionsFormVersionIdGeometryResponse>(getPutApiAdminFormsAppVersionsFormVersionIdGeometryUrl(formVersionId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      appUpdateGeometryRequest,)
  }
);}



export type getApiAdminFormsAppVersionsFormVersionIdDraftResponse200 = {
  data: void
  status: 200
}

export type getApiAdminFormsAppVersionsFormVersionIdDraftResponse401 = {
  data: GetApiAdminFormsAppVersionsFormVersionIdDraft401
  status: 401
}

export type getApiAdminFormsAppVersionsFormVersionIdDraftResponse402 = {
  data: GetApiAdminFormsAppVersionsFormVersionIdDraft402
  status: 402
}

export type getApiAdminFormsAppVersionsFormVersionIdDraftResponseSuccess = (getApiAdminFormsAppVersionsFormVersionIdDraftResponse200) & {
  headers: Headers;
};
export type getApiAdminFormsAppVersionsFormVersionIdDraftResponseError = (getApiAdminFormsAppVersionsFormVersionIdDraftResponse401 | getApiAdminFormsAppVersionsFormVersionIdDraftResponse402) & {
  headers: Headers;
};

export type getApiAdminFormsAppVersionsFormVersionIdDraftResponse = (getApiAdminFormsAppVersionsFormVersionIdDraftResponseSuccess | getApiAdminFormsAppVersionsFormVersionIdDraftResponseError)

export const getGetApiAdminFormsAppVersionsFormVersionIdDraftUrl = (formVersionId: string,) => {




  return `/api/admin/forms/app/versions/${formVersionId}/draft`
}

export const getApiAdminFormsAppVersionsFormVersionIdDraft = async (formVersionId: string, options?: RequestInit): Promise<getApiAdminFormsAppVersionsFormVersionIdDraftResponse> => {

  return fetcher<getApiAdminFormsAppVersionsFormVersionIdDraftResponse>(getGetApiAdminFormsAppVersionsFormVersionIdDraftUrl(formVersionId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiAdminFormsAppVersionsFormVersionIdDraftResponse200 = {
  data: void
  status: 200
}

export type postApiAdminFormsAppVersionsFormVersionIdDraftResponse401 = {
  data: PostApiAdminFormsAppVersionsFormVersionIdDraft401
  status: 401
}

export type postApiAdminFormsAppVersionsFormVersionIdDraftResponse402 = {
  data: PostApiAdminFormsAppVersionsFormVersionIdDraft402
  status: 402
}

export type postApiAdminFormsAppVersionsFormVersionIdDraftResponseSuccess = (postApiAdminFormsAppVersionsFormVersionIdDraftResponse200) & {
  headers: Headers;
};
export type postApiAdminFormsAppVersionsFormVersionIdDraftResponseError = (postApiAdminFormsAppVersionsFormVersionIdDraftResponse401 | postApiAdminFormsAppVersionsFormVersionIdDraftResponse402) & {
  headers: Headers;
};

export type postApiAdminFormsAppVersionsFormVersionIdDraftResponse = (postApiAdminFormsAppVersionsFormVersionIdDraftResponseSuccess | postApiAdminFormsAppVersionsFormVersionIdDraftResponseError)

export const getPostApiAdminFormsAppVersionsFormVersionIdDraftUrl = (formVersionId: string,) => {




  return `/api/admin/forms/app/versions/${formVersionId}/draft`
}

export const postApiAdminFormsAppVersionsFormVersionIdDraft = async (formVersionId: string,
    appFormDraftDto: AppFormDraftDto, options?: RequestInit): Promise<postApiAdminFormsAppVersionsFormVersionIdDraftResponse> => {

  return fetcher<postApiAdminFormsAppVersionsFormVersionIdDraftResponse>(getPostApiAdminFormsAppVersionsFormVersionIdDraftUrl(formVersionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      appFormDraftDto,)
  }
);}



export type postApiAdminFormsAppVersionsFormVersionIdSaveAndCompileResponse200 = {
  data: void
  status: 200
}

export type postApiAdminFormsAppVersionsFormVersionIdSaveAndCompileResponse401 = {
  data: PostApiAdminFormsAppVersionsFormVersionIdSaveAndCompile401
  status: 401
}

export type postApiAdminFormsAppVersionsFormVersionIdSaveAndCompileResponse402 = {
  data: PostApiAdminFormsAppVersionsFormVersionIdSaveAndCompile402
  status: 402
}

export type postApiAdminFormsAppVersionsFormVersionIdSaveAndCompileResponseSuccess = (postApiAdminFormsAppVersionsFormVersionIdSaveAndCompileResponse200) & {
  headers: Headers;
};
export type postApiAdminFormsAppVersionsFormVersionIdSaveAndCompileResponseError = (postApiAdminFormsAppVersionsFormVersionIdSaveAndCompileResponse401 | postApiAdminFormsAppVersionsFormVersionIdSaveAndCompileResponse402) & {
  headers: Headers;
};

export type postApiAdminFormsAppVersionsFormVersionIdSaveAndCompileResponse = (postApiAdminFormsAppVersionsFormVersionIdSaveAndCompileResponseSuccess | postApiAdminFormsAppVersionsFormVersionIdSaveAndCompileResponseError)

export const getPostApiAdminFormsAppVersionsFormVersionIdSaveAndCompileUrl = (formVersionId: string,) => {




  return `/api/admin/forms/app/versions/${formVersionId}/save-and-compile`
}

export const postApiAdminFormsAppVersionsFormVersionIdSaveAndCompile = async (formVersionId: string,
    appFormDraftDto: AppFormDraftDto, options?: RequestInit): Promise<postApiAdminFormsAppVersionsFormVersionIdSaveAndCompileResponse> => {

  return fetcher<postApiAdminFormsAppVersionsFormVersionIdSaveAndCompileResponse>(getPostApiAdminFormsAppVersionsFormVersionIdSaveAndCompileUrl(formVersionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      appFormDraftDto,)
  }
);}



export type postApiAdminFormsAppVersionsFormVersionIdSaveAndCompileAcordResponse200 = {
  data: void
  status: 200
}

export type postApiAdminFormsAppVersionsFormVersionIdSaveAndCompileAcordResponse401 = {
  data: PostApiAdminFormsAppVersionsFormVersionIdSaveAndCompileAcord401
  status: 401
}

export type postApiAdminFormsAppVersionsFormVersionIdSaveAndCompileAcordResponse402 = {
  data: PostApiAdminFormsAppVersionsFormVersionIdSaveAndCompileAcord402
  status: 402
}

export type postApiAdminFormsAppVersionsFormVersionIdSaveAndCompileAcordResponseSuccess = (postApiAdminFormsAppVersionsFormVersionIdSaveAndCompileAcordResponse200) & {
  headers: Headers;
};
export type postApiAdminFormsAppVersionsFormVersionIdSaveAndCompileAcordResponseError = (postApiAdminFormsAppVersionsFormVersionIdSaveAndCompileAcordResponse401 | postApiAdminFormsAppVersionsFormVersionIdSaveAndCompileAcordResponse402) & {
  headers: Headers;
};

export type postApiAdminFormsAppVersionsFormVersionIdSaveAndCompileAcordResponse = (postApiAdminFormsAppVersionsFormVersionIdSaveAndCompileAcordResponseSuccess | postApiAdminFormsAppVersionsFormVersionIdSaveAndCompileAcordResponseError)

export const getPostApiAdminFormsAppVersionsFormVersionIdSaveAndCompileAcordUrl = (formVersionId: string,) => {




  return `/api/admin/forms/app/versions/${formVersionId}/save-and-compile-acord`
}

export const postApiAdminFormsAppVersionsFormVersionIdSaveAndCompileAcord = async (formVersionId: string,
    appFormDraftDto: AppFormDraftDto, options?: RequestInit): Promise<postApiAdminFormsAppVersionsFormVersionIdSaveAndCompileAcordResponse> => {

  return fetcher<postApiAdminFormsAppVersionsFormVersionIdSaveAndCompileAcordResponse>(getPostApiAdminFormsAppVersionsFormVersionIdSaveAndCompileAcordUrl(formVersionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      appFormDraftDto,)
  }
);}



export type postApiAdminFormsAppVersionsFormVersionIdCompileFromDraftResponse200 = {
  data: void
  status: 200
}

export type postApiAdminFormsAppVersionsFormVersionIdCompileFromDraftResponse401 = {
  data: PostApiAdminFormsAppVersionsFormVersionIdCompileFromDraft401
  status: 401
}

export type postApiAdminFormsAppVersionsFormVersionIdCompileFromDraftResponse402 = {
  data: PostApiAdminFormsAppVersionsFormVersionIdCompileFromDraft402
  status: 402
}

export type postApiAdminFormsAppVersionsFormVersionIdCompileFromDraftResponseSuccess = (postApiAdminFormsAppVersionsFormVersionIdCompileFromDraftResponse200) & {
  headers: Headers;
};
export type postApiAdminFormsAppVersionsFormVersionIdCompileFromDraftResponseError = (postApiAdminFormsAppVersionsFormVersionIdCompileFromDraftResponse401 | postApiAdminFormsAppVersionsFormVersionIdCompileFromDraftResponse402) & {
  headers: Headers;
};

export type postApiAdminFormsAppVersionsFormVersionIdCompileFromDraftResponse = (postApiAdminFormsAppVersionsFormVersionIdCompileFromDraftResponseSuccess | postApiAdminFormsAppVersionsFormVersionIdCompileFromDraftResponseError)

export const getPostApiAdminFormsAppVersionsFormVersionIdCompileFromDraftUrl = (formVersionId: string,) => {




  return `/api/admin/forms/app/versions/${formVersionId}/compile-from-draft`
}

export const postApiAdminFormsAppVersionsFormVersionIdCompileFromDraft = async (formVersionId: string, options?: RequestInit): Promise<postApiAdminFormsAppVersionsFormVersionIdCompileFromDraftResponse> => {

  return fetcher<postApiAdminFormsAppVersionsFormVersionIdCompileFromDraftResponse>(getPostApiAdminFormsAppVersionsFormVersionIdCompileFromDraftUrl(formVersionId),
  {
    ...options,
    method: 'POST'


  }
);}



export type getApiAdminFormsImportResponse200 = {
  data: void
  status: 200
}

export type getApiAdminFormsImportResponse401 = {
  data: GetApiAdminFormsImport401
  status: 401
}

export type getApiAdminFormsImportResponseSuccess = (getApiAdminFormsImportResponse200) & {
  headers: Headers;
};
export type getApiAdminFormsImportResponseError = (getApiAdminFormsImportResponse401) & {
  headers: Headers;
};

export type getApiAdminFormsImportResponse = (getApiAdminFormsImportResponseSuccess | getApiAdminFormsImportResponseError)

export const getGetApiAdminFormsImportUrl = (params?: GetApiAdminFormsImportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/forms/import?${stringifiedParams}` : `/api/admin/forms/import`
}

export const getApiAdminFormsImport = async (params?: GetApiAdminFormsImportParams, options?: RequestInit): Promise<getApiAdminFormsImportResponse> => {

  return fetcher<getApiAdminFormsImportResponse>(getGetApiAdminFormsImportUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiAdminFormsImportResponse200 = {
  data: void
  status: 200
}

export type postApiAdminFormsImportResponse401 = {
  data: PostApiAdminFormsImport401
  status: 401
}

export type postApiAdminFormsImportResponse402 = {
  data: PostApiAdminFormsImport402
  status: 402
}

export type postApiAdminFormsImportResponseSuccess = (postApiAdminFormsImportResponse200) & {
  headers: Headers;
};
export type postApiAdminFormsImportResponseError = (postApiAdminFormsImportResponse401 | postApiAdminFormsImportResponse402) & {
  headers: Headers;
};

export type postApiAdminFormsImportResponse = (postApiAdminFormsImportResponseSuccess | postApiAdminFormsImportResponseError)

export const getPostApiAdminFormsImportUrl = () => {




  return `/api/admin/forms/import`
}

export const postApiAdminFormsImport = async (postApiAdminFormsImportBody: PostApiAdminFormsImportBody, options?: RequestInit): Promise<postApiAdminFormsImportResponse> => {
    const formData = new FormData();
if(postApiAdminFormsImportBody.file !== undefined) {
 formData.append(`file`, postApiAdminFormsImportBody.file);
 }

  return fetcher<postApiAdminFormsImportResponse>(getPostApiAdminFormsImportUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body:
      formData,
  }
);}



export type getApiAdminFormsImportWorkerIdResponse200 = {
  data: void
  status: 200
}

export type getApiAdminFormsImportWorkerIdResponse401 = {
  data: GetApiAdminFormsImportWorkerId401
  status: 401
}

export type getApiAdminFormsImportWorkerIdResponseSuccess = (getApiAdminFormsImportWorkerIdResponse200) & {
  headers: Headers;
};
export type getApiAdminFormsImportWorkerIdResponseError = (getApiAdminFormsImportWorkerIdResponse401) & {
  headers: Headers;
};

export type getApiAdminFormsImportWorkerIdResponse = (getApiAdminFormsImportWorkerIdResponseSuccess | getApiAdminFormsImportWorkerIdResponseError)

export const getGetApiAdminFormsImportWorkerIdUrl = (workerId: string,) => {




  return `/api/admin/forms/import/${workerId}`
}

export const getApiAdminFormsImportWorkerId = async (workerId: string, options?: RequestInit): Promise<getApiAdminFormsImportWorkerIdResponse> => {

  return fetcher<getApiAdminFormsImportWorkerIdResponse>(getGetApiAdminFormsImportWorkerIdUrl(workerId),
  {
    ...options,
    method: 'GET'


  }
);}



export type deleteApiAdminFormsImportWorkerIdResponse200 = {
  data: void
  status: 200
}

export type deleteApiAdminFormsImportWorkerIdResponse401 = {
  data: DeleteApiAdminFormsImportWorkerId401
  status: 401
}

export type deleteApiAdminFormsImportWorkerIdResponse402 = {
  data: DeleteApiAdminFormsImportWorkerId402
  status: 402
}

export type deleteApiAdminFormsImportWorkerIdResponseSuccess = (deleteApiAdminFormsImportWorkerIdResponse200) & {
  headers: Headers;
};
export type deleteApiAdminFormsImportWorkerIdResponseError = (deleteApiAdminFormsImportWorkerIdResponse401 | deleteApiAdminFormsImportWorkerIdResponse402) & {
  headers: Headers;
};

export type deleteApiAdminFormsImportWorkerIdResponse = (deleteApiAdminFormsImportWorkerIdResponseSuccess | deleteApiAdminFormsImportWorkerIdResponseError)

export const getDeleteApiAdminFormsImportWorkerIdUrl = (workerId: string,) => {




  return `/api/admin/forms/import/${workerId}`
}

export const deleteApiAdminFormsImportWorkerId = async (workerId: string, options?: RequestInit): Promise<deleteApiAdminFormsImportWorkerIdResponse> => {

  return fetcher<deleteApiAdminFormsImportWorkerIdResponse>(getDeleteApiAdminFormsImportWorkerIdUrl(workerId),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type postApiAdminFormsImportWorkerIdGenerateResponse200 = {
  data: void
  status: 200
}

export type postApiAdminFormsImportWorkerIdGenerateResponse401 = {
  data: PostApiAdminFormsImportWorkerIdGenerate401
  status: 401
}

export type postApiAdminFormsImportWorkerIdGenerateResponse402 = {
  data: PostApiAdminFormsImportWorkerIdGenerate402
  status: 402
}

export type postApiAdminFormsImportWorkerIdGenerateResponseSuccess = (postApiAdminFormsImportWorkerIdGenerateResponse200) & {
  headers: Headers;
};
export type postApiAdminFormsImportWorkerIdGenerateResponseError = (postApiAdminFormsImportWorkerIdGenerateResponse401 | postApiAdminFormsImportWorkerIdGenerateResponse402) & {
  headers: Headers;
};

export type postApiAdminFormsImportWorkerIdGenerateResponse = (postApiAdminFormsImportWorkerIdGenerateResponseSuccess | postApiAdminFormsImportWorkerIdGenerateResponseError)

export const getPostApiAdminFormsImportWorkerIdGenerateUrl = (workerId: string,) => {




  return `/api/admin/forms/import/${workerId}/generate`
}

export const postApiAdminFormsImportWorkerIdGenerate = async (workerId: string, options?: RequestInit): Promise<postApiAdminFormsImportWorkerIdGenerateResponse> => {

  return fetcher<postApiAdminFormsImportWorkerIdGenerateResponse>(getPostApiAdminFormsImportWorkerIdGenerateUrl(workerId),
  {
    ...options,
    method: 'POST'


  }
);}



export type postApiAdminFormsImportWorkerIdActivateResponse200 = {
  data: void
  status: 200
}

export type postApiAdminFormsImportWorkerIdActivateResponse401 = {
  data: PostApiAdminFormsImportWorkerIdActivate401
  status: 401
}

export type postApiAdminFormsImportWorkerIdActivateResponse402 = {
  data: PostApiAdminFormsImportWorkerIdActivate402
  status: 402
}

export type postApiAdminFormsImportWorkerIdActivateResponseSuccess = (postApiAdminFormsImportWorkerIdActivateResponse200) & {
  headers: Headers;
};
export type postApiAdminFormsImportWorkerIdActivateResponseError = (postApiAdminFormsImportWorkerIdActivateResponse401 | postApiAdminFormsImportWorkerIdActivateResponse402) & {
  headers: Headers;
};

export type postApiAdminFormsImportWorkerIdActivateResponse = (postApiAdminFormsImportWorkerIdActivateResponseSuccess | postApiAdminFormsImportWorkerIdActivateResponseError)

export const getPostApiAdminFormsImportWorkerIdActivateUrl = (workerId: string,) => {




  return `/api/admin/forms/import/${workerId}/activate`
}

export const postApiAdminFormsImportWorkerIdActivate = async (workerId: string, options?: RequestInit): Promise<postApiAdminFormsImportWorkerIdActivateResponse> => {

  return fetcher<postApiAdminFormsImportWorkerIdActivateResponse>(getPostApiAdminFormsImportWorkerIdActivateUrl(workerId),
  {
    ...options,
    method: 'POST'


  }
);}



export type getApiAdminPortalsResponse200 = {
  data: void
  status: 200
}

export type getApiAdminPortalsResponse401 = {
  data: GetApiAdminPortals401
  status: 401
}

export type getApiAdminPortalsResponseSuccess = (getApiAdminPortalsResponse200) & {
  headers: Headers;
};
export type getApiAdminPortalsResponseError = (getApiAdminPortalsResponse401) & {
  headers: Headers;
};

export type getApiAdminPortalsResponse = (getApiAdminPortalsResponseSuccess | getApiAdminPortalsResponseError)

export const getGetApiAdminPortalsUrl = (params?: GetApiAdminPortalsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/portals?${stringifiedParams}` : `/api/admin/portals`
}

export const getApiAdminPortals = async (params?: GetApiAdminPortalsParams, options?: RequestInit): Promise<getApiAdminPortalsResponse> => {

  return fetcher<getApiAdminPortalsResponse>(getGetApiAdminPortalsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiAdminPortalsResponse200TextPlain = {
  data: PortalListItemDto
  status: 200
}

export type postApiAdminPortalsResponse200ApplicationJson = {
  data: PortalListItemDto
  status: 200
}

export type postApiAdminPortalsResponse200TextJson = {
  data: PortalListItemDto
  status: 200
}

export type postApiAdminPortalsResponse401 = {
  data: PostApiAdminPortals401
  status: 401
}

export type postApiAdminPortalsResponse402 = {
  data: PostApiAdminPortals402
  status: 402
}

export type postApiAdminPortalsResponseSuccess = (postApiAdminPortalsResponse200TextPlain | postApiAdminPortalsResponse200ApplicationJson | postApiAdminPortalsResponse200TextJson) & {
  headers: Headers;
};
export type postApiAdminPortalsResponseError = (postApiAdminPortalsResponse401 | postApiAdminPortalsResponse402) & {
  headers: Headers;
};

export type postApiAdminPortalsResponse = (postApiAdminPortalsResponseSuccess | postApiAdminPortalsResponseError)

export const getPostApiAdminPortalsUrl = () => {




  return `/api/admin/portals`
}

export const postApiAdminPortals = async (upsertPortalRequest: UpsertPortalRequest, options?: RequestInit): Promise<postApiAdminPortalsResponse> => {

  return fetcher<postApiAdminPortalsResponse>(getPostApiAdminPortalsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upsertPortalRequest,)
  }
);}



export type getApiAdminPortalsPaymentsResponse200 = {
  data: void
  status: 200
}

export type getApiAdminPortalsPaymentsResponse401 = {
  data: GetApiAdminPortalsPayments401
  status: 401
}

export type getApiAdminPortalsPaymentsResponseSuccess = (getApiAdminPortalsPaymentsResponse200) & {
  headers: Headers;
};
export type getApiAdminPortalsPaymentsResponseError = (getApiAdminPortalsPaymentsResponse401) & {
  headers: Headers;
};

export type getApiAdminPortalsPaymentsResponse = (getApiAdminPortalsPaymentsResponseSuccess | getApiAdminPortalsPaymentsResponseError)

export const getGetApiAdminPortalsPaymentsUrl = (params?: GetApiAdminPortalsPaymentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/portals/payments?${stringifiedParams}` : `/api/admin/portals/payments`
}

export const getApiAdminPortalsPayments = async (params?: GetApiAdminPortalsPaymentsParams, options?: RequestInit): Promise<getApiAdminPortalsPaymentsResponse> => {

  return fetcher<getApiAdminPortalsPaymentsResponse>(getGetApiAdminPortalsPaymentsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiAdminPortalsPaymentsResponse200 = {
  data: void
  status: 200
}

export type postApiAdminPortalsPaymentsResponse401 = {
  data: PostApiAdminPortalsPayments401
  status: 401
}

export type postApiAdminPortalsPaymentsResponse402 = {
  data: PostApiAdminPortalsPayments402
  status: 402
}

export type postApiAdminPortalsPaymentsResponseSuccess = (postApiAdminPortalsPaymentsResponse200) & {
  headers: Headers;
};
export type postApiAdminPortalsPaymentsResponseError = (postApiAdminPortalsPaymentsResponse401 | postApiAdminPortalsPaymentsResponse402) & {
  headers: Headers;
};

export type postApiAdminPortalsPaymentsResponse = (postApiAdminPortalsPaymentsResponseSuccess | postApiAdminPortalsPaymentsResponseError)

export const getPostApiAdminPortalsPaymentsUrl = () => {




  return `/api/admin/portals/payments`
}

export const postApiAdminPortalsPayments = async (createPaymentLinkRequest: CreatePaymentLinkRequest, options?: RequestInit): Promise<postApiAdminPortalsPaymentsResponse> => {

  return fetcher<postApiAdminPortalsPaymentsResponse>(getPostApiAdminPortalsPaymentsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createPaymentLinkRequest,)
  }
);}



export type getApiAdminPortalusersResponse200TextPlain = {
  data: PortalUserListItemDto[]
  status: 200
}

export type getApiAdminPortalusersResponse200ApplicationJson = {
  data: PortalUserListItemDto[]
  status: 200
}

export type getApiAdminPortalusersResponse200TextJson = {
  data: PortalUserListItemDto[]
  status: 200
}

export type getApiAdminPortalusersResponse401 = {
  data: GetApiAdminPortalusers401
  status: 401
}

export type getApiAdminPortalusersResponseSuccess = (getApiAdminPortalusersResponse200TextPlain | getApiAdminPortalusersResponse200ApplicationJson | getApiAdminPortalusersResponse200TextJson) & {
  headers: Headers;
};
export type getApiAdminPortalusersResponseError = (getApiAdminPortalusersResponse401) & {
  headers: Headers;
};

export type getApiAdminPortalusersResponse = (getApiAdminPortalusersResponseSuccess | getApiAdminPortalusersResponseError)

export const getGetApiAdminPortalusersUrl = (params?: GetApiAdminPortalusersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/portalusers?${stringifiedParams}` : `/api/admin/portalusers`
}

export const getApiAdminPortalusers = async (params?: GetApiAdminPortalusersParams, options?: RequestInit): Promise<getApiAdminPortalusersResponse> => {

  return fetcher<getApiAdminPortalusersResponse>(getGetApiAdminPortalusersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiAdminRawBlobsResponse200 = {
  data: void
  status: 200
}

export type getApiAdminRawBlobsResponse401 = {
  data: GetApiAdminRawBlobs401
  status: 401
}

export type getApiAdminRawBlobsResponseSuccess = (getApiAdminRawBlobsResponse200) & {
  headers: Headers;
};
export type getApiAdminRawBlobsResponseError = (getApiAdminRawBlobsResponse401) & {
  headers: Headers;
};

export type getApiAdminRawBlobsResponse = (getApiAdminRawBlobsResponseSuccess | getApiAdminRawBlobsResponseError)

export const getGetApiAdminRawBlobsUrl = (params?: GetApiAdminRawBlobsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/raw-blobs?${stringifiedParams}` : `/api/admin/raw-blobs`
}

export const getApiAdminRawBlobs = async (params?: GetApiAdminRawBlobsParams, options?: RequestInit): Promise<getApiAdminRawBlobsResponse> => {

  return fetcher<getApiAdminRawBlobsResponse>(getGetApiAdminRawBlobsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type deleteApiAdminRawBlobsResponse200 = {
  data: void
  status: 200
}

export type deleteApiAdminRawBlobsResponse401 = {
  data: DeleteApiAdminRawBlobs401
  status: 401
}

export type deleteApiAdminRawBlobsResponse402 = {
  data: DeleteApiAdminRawBlobs402
  status: 402
}

export type deleteApiAdminRawBlobsResponseSuccess = (deleteApiAdminRawBlobsResponse200) & {
  headers: Headers;
};
export type deleteApiAdminRawBlobsResponseError = (deleteApiAdminRawBlobsResponse401 | deleteApiAdminRawBlobsResponse402) & {
  headers: Headers;
};

export type deleteApiAdminRawBlobsResponse = (deleteApiAdminRawBlobsResponseSuccess | deleteApiAdminRawBlobsResponseError)

export const getDeleteApiAdminRawBlobsUrl = (params?: DeleteApiAdminRawBlobsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/raw-blobs?${stringifiedParams}` : `/api/admin/raw-blobs`
}

export const deleteApiAdminRawBlobs = async (params?: DeleteApiAdminRawBlobsParams, options?: RequestInit): Promise<deleteApiAdminRawBlobsResponse> => {

  return fetcher<deleteApiAdminRawBlobsResponse>(getDeleteApiAdminRawBlobsUrl(params),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type getApiAdminRawBlobsContentResponse200 = {
  data: void
  status: 200
}

export type getApiAdminRawBlobsContentResponse401 = {
  data: GetApiAdminRawBlobsContent401
  status: 401
}

export type getApiAdminRawBlobsContentResponseSuccess = (getApiAdminRawBlobsContentResponse200) & {
  headers: Headers;
};
export type getApiAdminRawBlobsContentResponseError = (getApiAdminRawBlobsContentResponse401) & {
  headers: Headers;
};

export type getApiAdminRawBlobsContentResponse = (getApiAdminRawBlobsContentResponseSuccess | getApiAdminRawBlobsContentResponseError)

export const getGetApiAdminRawBlobsContentUrl = (params?: GetApiAdminRawBlobsContentParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/raw-blobs/content?${stringifiedParams}` : `/api/admin/raw-blobs/content`
}

export const getApiAdminRawBlobsContent = async (params?: GetApiAdminRawBlobsContentParams, options?: RequestInit): Promise<getApiAdminRawBlobsContentResponse> => {

  return fetcher<getApiAdminRawBlobsContentResponse>(getGetApiAdminRawBlobsContentUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiAdminStripeCheckoutSessionResponse200TextPlain = {
  data: StripeCheckoutSessionDto
  status: 200
}

export type postApiAdminStripeCheckoutSessionResponse200ApplicationJson = {
  data: StripeCheckoutSessionDto
  status: 200
}

export type postApiAdminStripeCheckoutSessionResponse200TextJson = {
  data: StripeCheckoutSessionDto
  status: 200
}

export type postApiAdminStripeCheckoutSessionResponse401 = {
  data: PostApiAdminStripeCheckoutSession401
  status: 401
}

export type postApiAdminStripeCheckoutSessionResponse402 = {
  data: PostApiAdminStripeCheckoutSession402
  status: 402
}

export type postApiAdminStripeCheckoutSessionResponseSuccess = (postApiAdminStripeCheckoutSessionResponse200TextPlain | postApiAdminStripeCheckoutSessionResponse200ApplicationJson | postApiAdminStripeCheckoutSessionResponse200TextJson) & {
  headers: Headers;
};
export type postApiAdminStripeCheckoutSessionResponseError = (postApiAdminStripeCheckoutSessionResponse401 | postApiAdminStripeCheckoutSessionResponse402) & {
  headers: Headers;
};

export type postApiAdminStripeCheckoutSessionResponse = (postApiAdminStripeCheckoutSessionResponseSuccess | postApiAdminStripeCheckoutSessionResponseError)

export const getPostApiAdminStripeCheckoutSessionUrl = () => {




  return `/api/admin/stripe/checkout-session`
}

export const postApiAdminStripeCheckoutSession = async (checkoutRequest: CheckoutRequest, options?: RequestInit): Promise<postApiAdminStripeCheckoutSessionResponse> => {

  return fetcher<postApiAdminStripeCheckoutSessionResponse>(getPostApiAdminStripeCheckoutSessionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      checkoutRequest,)
  }
);}



export type postApiAdminStripePortalSessionResponse200TextPlain = {
  data: StripePortalSessionDto
  status: 200
}

export type postApiAdminStripePortalSessionResponse200ApplicationJson = {
  data: StripePortalSessionDto
  status: 200
}

export type postApiAdminStripePortalSessionResponse200TextJson = {
  data: StripePortalSessionDto
  status: 200
}

export type postApiAdminStripePortalSessionResponse401 = {
  data: PostApiAdminStripePortalSession401
  status: 401
}

export type postApiAdminStripePortalSessionResponse402 = {
  data: PostApiAdminStripePortalSession402
  status: 402
}

export type postApiAdminStripePortalSessionResponseSuccess = (postApiAdminStripePortalSessionResponse200TextPlain | postApiAdminStripePortalSessionResponse200ApplicationJson | postApiAdminStripePortalSessionResponse200TextJson) & {
  headers: Headers;
};
export type postApiAdminStripePortalSessionResponseError = (postApiAdminStripePortalSessionResponse401 | postApiAdminStripePortalSessionResponse402) & {
  headers: Headers;
};

export type postApiAdminStripePortalSessionResponse = (postApiAdminStripePortalSessionResponseSuccess | postApiAdminStripePortalSessionResponseError)

export const getPostApiAdminStripePortalSessionUrl = () => {




  return `/api/admin/stripe/portal-session`
}

export const postApiAdminStripePortalSession = async (portalRequest: PortalRequest, options?: RequestInit): Promise<postApiAdminStripePortalSessionResponse> => {

  return fetcher<postApiAdminStripePortalSessionResponse>(getPostApiAdminStripePortalSessionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      portalRequest,)
  }
);}



export type postApiAdminTeamsIdStaffProvisionResponse200TextPlain = {
  data: TeamDetailDto
  status: 200
}

export type postApiAdminTeamsIdStaffProvisionResponse200ApplicationJson = {
  data: TeamDetailDto
  status: 200
}

export type postApiAdminTeamsIdStaffProvisionResponse200TextJson = {
  data: TeamDetailDto
  status: 200
}

export type postApiAdminTeamsIdStaffProvisionResponse400TextPlain = {
  data: ProblemDetails
  status: 400
}

export type postApiAdminTeamsIdStaffProvisionResponse400ApplicationJson = {
  data: ProblemDetails
  status: 400
}

export type postApiAdminTeamsIdStaffProvisionResponse400TextJson = {
  data: ProblemDetails
  status: 400
}

export type postApiAdminTeamsIdStaffProvisionResponse401 = {
  data: PostApiAdminTeamsIdStaffProvision401
  status: 401
}

export type postApiAdminTeamsIdStaffProvisionResponse402 = {
  data: PostApiAdminTeamsIdStaffProvision402
  status: 402
}

export type postApiAdminTeamsIdStaffProvisionResponse403TextPlain = {
  data: ProblemDetails
  status: 403
}

export type postApiAdminTeamsIdStaffProvisionResponse403ApplicationJson = {
  data: ProblemDetails
  status: 403
}

export type postApiAdminTeamsIdStaffProvisionResponse403TextJson = {
  data: ProblemDetails
  status: 403
}

export type postApiAdminTeamsIdStaffProvisionResponse404TextPlain = {
  data: ProblemDetails
  status: 404
}

export type postApiAdminTeamsIdStaffProvisionResponse404ApplicationJson = {
  data: ProblemDetails
  status: 404
}

export type postApiAdminTeamsIdStaffProvisionResponse404TextJson = {
  data: ProblemDetails
  status: 404
}

export type postApiAdminTeamsIdStaffProvisionResponse409TextPlain = {
  data: ProblemDetails
  status: 409
}

export type postApiAdminTeamsIdStaffProvisionResponse409ApplicationJson = {
  data: ProblemDetails
  status: 409
}

export type postApiAdminTeamsIdStaffProvisionResponse409TextJson = {
  data: ProblemDetails
  status: 409
}

export type postApiAdminTeamsIdStaffProvisionResponse500 = {
  data: void
  status: 500
}

export type postApiAdminTeamsIdStaffProvisionResponseSuccess = (postApiAdminTeamsIdStaffProvisionResponse200TextPlain | postApiAdminTeamsIdStaffProvisionResponse200ApplicationJson | postApiAdminTeamsIdStaffProvisionResponse200TextJson) & {
  headers: Headers;
};
export type postApiAdminTeamsIdStaffProvisionResponseError = (postApiAdminTeamsIdStaffProvisionResponse400TextPlain | postApiAdminTeamsIdStaffProvisionResponse400ApplicationJson | postApiAdminTeamsIdStaffProvisionResponse400TextJson | postApiAdminTeamsIdStaffProvisionResponse401 | postApiAdminTeamsIdStaffProvisionResponse402 | postApiAdminTeamsIdStaffProvisionResponse403TextPlain | postApiAdminTeamsIdStaffProvisionResponse403ApplicationJson | postApiAdminTeamsIdStaffProvisionResponse403TextJson | postApiAdminTeamsIdStaffProvisionResponse404TextPlain | postApiAdminTeamsIdStaffProvisionResponse404ApplicationJson | postApiAdminTeamsIdStaffProvisionResponse404TextJson | postApiAdminTeamsIdStaffProvisionResponse409TextPlain | postApiAdminTeamsIdStaffProvisionResponse409ApplicationJson | postApiAdminTeamsIdStaffProvisionResponse409TextJson | postApiAdminTeamsIdStaffProvisionResponse500) & {
  headers: Headers;
};

export type postApiAdminTeamsIdStaffProvisionResponse = (postApiAdminTeamsIdStaffProvisionResponseSuccess | postApiAdminTeamsIdStaffProvisionResponseError)

export const getPostApiAdminTeamsIdStaffProvisionUrl = (id: string,) => {




  return `/api/admin/teams/${id}/staff/provision`
}

export const postApiAdminTeamsIdStaffProvision = async (id: string,
    provisionTeamStaffRequest: ProvisionTeamStaffRequest, options?: RequestInit): Promise<postApiAdminTeamsIdStaffProvisionResponse> => {

  return fetcher<postApiAdminTeamsIdStaffProvisionResponse>(getPostApiAdminTeamsIdStaffProvisionUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      provisionTeamStaffRequest,)
  }
);}



export type postApiAdminTeamsIdMembersUserIdProvisionLoginResponse200TextPlain = {
  data: TeamDetailDto
  status: 200
}

export type postApiAdminTeamsIdMembersUserIdProvisionLoginResponse200ApplicationJson = {
  data: TeamDetailDto
  status: 200
}

export type postApiAdminTeamsIdMembersUserIdProvisionLoginResponse200TextJson = {
  data: TeamDetailDto
  status: 200
}

export type postApiAdminTeamsIdMembersUserIdProvisionLoginResponse400TextPlain = {
  data: ProblemDetails
  status: 400
}

export type postApiAdminTeamsIdMembersUserIdProvisionLoginResponse400ApplicationJson = {
  data: ProblemDetails
  status: 400
}

export type postApiAdminTeamsIdMembersUserIdProvisionLoginResponse400TextJson = {
  data: ProblemDetails
  status: 400
}

export type postApiAdminTeamsIdMembersUserIdProvisionLoginResponse401 = {
  data: PostApiAdminTeamsIdMembersUserIdProvisionLogin401
  status: 401
}

export type postApiAdminTeamsIdMembersUserIdProvisionLoginResponse402 = {
  data: PostApiAdminTeamsIdMembersUserIdProvisionLogin402
  status: 402
}

export type postApiAdminTeamsIdMembersUserIdProvisionLoginResponse403TextPlain = {
  data: ProblemDetails
  status: 403
}

export type postApiAdminTeamsIdMembersUserIdProvisionLoginResponse403ApplicationJson = {
  data: ProblemDetails
  status: 403
}

export type postApiAdminTeamsIdMembersUserIdProvisionLoginResponse403TextJson = {
  data: ProblemDetails
  status: 403
}

export type postApiAdminTeamsIdMembersUserIdProvisionLoginResponse404TextPlain = {
  data: ProblemDetails
  status: 404
}

export type postApiAdminTeamsIdMembersUserIdProvisionLoginResponse404ApplicationJson = {
  data: ProblemDetails
  status: 404
}

export type postApiAdminTeamsIdMembersUserIdProvisionLoginResponse404TextJson = {
  data: ProblemDetails
  status: 404
}

export type postApiAdminTeamsIdMembersUserIdProvisionLoginResponse409TextPlain = {
  data: ProblemDetails
  status: 409
}

export type postApiAdminTeamsIdMembersUserIdProvisionLoginResponse409ApplicationJson = {
  data: ProblemDetails
  status: 409
}

export type postApiAdminTeamsIdMembersUserIdProvisionLoginResponse409TextJson = {
  data: ProblemDetails
  status: 409
}

export type postApiAdminTeamsIdMembersUserIdProvisionLoginResponse500 = {
  data: void
  status: 500
}

export type postApiAdminTeamsIdMembersUserIdProvisionLoginResponseSuccess = (postApiAdminTeamsIdMembersUserIdProvisionLoginResponse200TextPlain | postApiAdminTeamsIdMembersUserIdProvisionLoginResponse200ApplicationJson | postApiAdminTeamsIdMembersUserIdProvisionLoginResponse200TextJson) & {
  headers: Headers;
};
export type postApiAdminTeamsIdMembersUserIdProvisionLoginResponseError = (postApiAdminTeamsIdMembersUserIdProvisionLoginResponse400TextPlain | postApiAdminTeamsIdMembersUserIdProvisionLoginResponse400ApplicationJson | postApiAdminTeamsIdMembersUserIdProvisionLoginResponse400TextJson | postApiAdminTeamsIdMembersUserIdProvisionLoginResponse401 | postApiAdminTeamsIdMembersUserIdProvisionLoginResponse402 | postApiAdminTeamsIdMembersUserIdProvisionLoginResponse403TextPlain | postApiAdminTeamsIdMembersUserIdProvisionLoginResponse403ApplicationJson | postApiAdminTeamsIdMembersUserIdProvisionLoginResponse403TextJson | postApiAdminTeamsIdMembersUserIdProvisionLoginResponse404TextPlain | postApiAdminTeamsIdMembersUserIdProvisionLoginResponse404ApplicationJson | postApiAdminTeamsIdMembersUserIdProvisionLoginResponse404TextJson | postApiAdminTeamsIdMembersUserIdProvisionLoginResponse409TextPlain | postApiAdminTeamsIdMembersUserIdProvisionLoginResponse409ApplicationJson | postApiAdminTeamsIdMembersUserIdProvisionLoginResponse409TextJson | postApiAdminTeamsIdMembersUserIdProvisionLoginResponse500) & {
  headers: Headers;
};

export type postApiAdminTeamsIdMembersUserIdProvisionLoginResponse = (postApiAdminTeamsIdMembersUserIdProvisionLoginResponseSuccess | postApiAdminTeamsIdMembersUserIdProvisionLoginResponseError)

export const getPostApiAdminTeamsIdMembersUserIdProvisionLoginUrl = (id: string,
    userId: string,) => {




  return `/api/admin/teams/${id}/members/${userId}/provision-login`
}

export const postApiAdminTeamsIdMembersUserIdProvisionLogin = async (id: string,
    userId: string, options?: RequestInit): Promise<postApiAdminTeamsIdMembersUserIdProvisionLoginResponse> => {

  return fetcher<postApiAdminTeamsIdMembersUserIdProvisionLoginResponse>(getPostApiAdminTeamsIdMembersUserIdProvisionLoginUrl(id,userId),
  {
    ...options,
    method: 'POST'


  }
);}



export type deleteApiAdminTeamsIdResponse204 = {
  data: void
  status: 204
}

export type deleteApiAdminTeamsIdResponse400TextPlain = {
  data: ProblemDetails
  status: 400
}

export type deleteApiAdminTeamsIdResponse400ApplicationJson = {
  data: ProblemDetails
  status: 400
}

export type deleteApiAdminTeamsIdResponse400TextJson = {
  data: ProblemDetails
  status: 400
}

export type deleteApiAdminTeamsIdResponse401 = {
  data: DeleteApiAdminTeamsId401
  status: 401
}

export type deleteApiAdminTeamsIdResponse402 = {
  data: DeleteApiAdminTeamsId402
  status: 402
}

export type deleteApiAdminTeamsIdResponse403TextPlain = {
  data: ProblemDetails
  status: 403
}

export type deleteApiAdminTeamsIdResponse403ApplicationJson = {
  data: ProblemDetails
  status: 403
}

export type deleteApiAdminTeamsIdResponse403TextJson = {
  data: ProblemDetails
  status: 403
}

export type deleteApiAdminTeamsIdResponse404TextPlain = {
  data: ProblemDetails
  status: 404
}

export type deleteApiAdminTeamsIdResponse404ApplicationJson = {
  data: ProblemDetails
  status: 404
}

export type deleteApiAdminTeamsIdResponse404TextJson = {
  data: ProblemDetails
  status: 404
}

export type deleteApiAdminTeamsIdResponse409TextPlain = {
  data: ProblemDetails
  status: 409
}

export type deleteApiAdminTeamsIdResponse409ApplicationJson = {
  data: ProblemDetails
  status: 409
}

export type deleteApiAdminTeamsIdResponse409TextJson = {
  data: ProblemDetails
  status: 409
}

export type deleteApiAdminTeamsIdResponse500 = {
  data: void
  status: 500
}

export type deleteApiAdminTeamsIdResponseSuccess = (deleteApiAdminTeamsIdResponse204) & {
  headers: Headers;
};
export type deleteApiAdminTeamsIdResponseError = (deleteApiAdminTeamsIdResponse400TextPlain | deleteApiAdminTeamsIdResponse400ApplicationJson | deleteApiAdminTeamsIdResponse400TextJson | deleteApiAdminTeamsIdResponse401 | deleteApiAdminTeamsIdResponse402 | deleteApiAdminTeamsIdResponse403TextPlain | deleteApiAdminTeamsIdResponse403ApplicationJson | deleteApiAdminTeamsIdResponse403TextJson | deleteApiAdminTeamsIdResponse404TextPlain | deleteApiAdminTeamsIdResponse404ApplicationJson | deleteApiAdminTeamsIdResponse404TextJson | deleteApiAdminTeamsIdResponse409TextPlain | deleteApiAdminTeamsIdResponse409ApplicationJson | deleteApiAdminTeamsIdResponse409TextJson | deleteApiAdminTeamsIdResponse500) & {
  headers: Headers;
};

export type deleteApiAdminTeamsIdResponse = (deleteApiAdminTeamsIdResponseSuccess | deleteApiAdminTeamsIdResponseError)

export const getDeleteApiAdminTeamsIdUrl = (id: string,) => {




  return `/api/admin/teams/${id}`
}

export const deleteApiAdminTeamsId = async (id: string, options?: RequestInit): Promise<deleteApiAdminTeamsIdResponse> => {

  return fetcher<deleteApiAdminTeamsIdResponse>(getDeleteApiAdminTeamsIdUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type getApiAdminUploadsResponse200 = {
  data: void
  status: 200
}

export type getApiAdminUploadsResponse401 = {
  data: GetApiAdminUploads401
  status: 401
}

export type getApiAdminUploadsResponseSuccess = (getApiAdminUploadsResponse200) & {
  headers: Headers;
};
export type getApiAdminUploadsResponseError = (getApiAdminUploadsResponse401) & {
  headers: Headers;
};

export type getApiAdminUploadsResponse = (getApiAdminUploadsResponseSuccess | getApiAdminUploadsResponseError)

export const getGetApiAdminUploadsUrl = (params?: GetApiAdminUploadsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/uploads?${stringifiedParams}` : `/api/admin/uploads`
}

export const getApiAdminUploads = async (params?: GetApiAdminUploadsParams, options?: RequestInit): Promise<getApiAdminUploadsResponse> => {

  return fetcher<getApiAdminUploadsResponse>(getGetApiAdminUploadsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiAdminUploadsResponse200 = {
  data: void
  status: 200
}

export type postApiAdminUploadsResponse401 = {
  data: PostApiAdminUploads401
  status: 401
}

export type postApiAdminUploadsResponse402 = {
  data: PostApiAdminUploads402
  status: 402
}

export type postApiAdminUploadsResponseSuccess = (postApiAdminUploadsResponse200) & {
  headers: Headers;
};
export type postApiAdminUploadsResponseError = (postApiAdminUploadsResponse401 | postApiAdminUploadsResponse402) & {
  headers: Headers;
};

export type postApiAdminUploadsResponse = (postApiAdminUploadsResponseSuccess | postApiAdminUploadsResponseError)

export const getPostApiAdminUploadsUrl = () => {




  return `/api/admin/uploads`
}

export const postApiAdminUploads = async (postApiAdminUploadsBody: PostApiAdminUploadsBody, options?: RequestInit): Promise<postApiAdminUploadsResponse> => {
    const formData = new FormData();
if(postApiAdminUploadsBody.file !== undefined) {
 formData.append(`file`, postApiAdminUploadsBody.file);
 }
if(postApiAdminUploadsBody.teamId !== undefined) {
 formData.append(`teamId`, postApiAdminUploadsBody.teamId);
 }
if(postApiAdminUploadsBody.displayName !== undefined) {
 formData.append(`displayName`, postApiAdminUploadsBody.displayName);
 }
if(postApiAdminUploadsBody.description !== undefined) {
 formData.append(`description`, postApiAdminUploadsBody.description);
 }

  return fetcher<postApiAdminUploadsResponse>(getPostApiAdminUploadsUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body:
      formData,
  }
);}



export type getApiAdminUploadsUploadIdContentResponse200 = {
  data: void
  status: 200
}

export type getApiAdminUploadsUploadIdContentResponse401 = {
  data: GetApiAdminUploadsUploadIdContent401
  status: 401
}

export type getApiAdminUploadsUploadIdContentResponseSuccess = (getApiAdminUploadsUploadIdContentResponse200) & {
  headers: Headers;
};
export type getApiAdminUploadsUploadIdContentResponseError = (getApiAdminUploadsUploadIdContentResponse401) & {
  headers: Headers;
};

export type getApiAdminUploadsUploadIdContentResponse = (getApiAdminUploadsUploadIdContentResponseSuccess | getApiAdminUploadsUploadIdContentResponseError)

export const getGetApiAdminUploadsUploadIdContentUrl = (uploadId: string,
    params?: GetApiAdminUploadsUploadIdContentParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/uploads/${uploadId}/content?${stringifiedParams}` : `/api/admin/uploads/${uploadId}/content`
}

export const getApiAdminUploadsUploadIdContent = async (uploadId: string,
    params?: GetApiAdminUploadsUploadIdContentParams, options?: RequestInit): Promise<getApiAdminUploadsUploadIdContentResponse> => {

  return fetcher<getApiAdminUploadsUploadIdContentResponse>(getGetApiAdminUploadsUploadIdContentUrl(uploadId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type deleteApiAdminUploadsUploadIdResponse200 = {
  data: void
  status: 200
}

export type deleteApiAdminUploadsUploadIdResponse401 = {
  data: DeleteApiAdminUploadsUploadId401
  status: 401
}

export type deleteApiAdminUploadsUploadIdResponse402 = {
  data: DeleteApiAdminUploadsUploadId402
  status: 402
}

export type deleteApiAdminUploadsUploadIdResponseSuccess = (deleteApiAdminUploadsUploadIdResponse200) & {
  headers: Headers;
};
export type deleteApiAdminUploadsUploadIdResponseError = (deleteApiAdminUploadsUploadIdResponse401 | deleteApiAdminUploadsUploadIdResponse402) & {
  headers: Headers;
};

export type deleteApiAdminUploadsUploadIdResponse = (deleteApiAdminUploadsUploadIdResponseSuccess | deleteApiAdminUploadsUploadIdResponseError)

export const getDeleteApiAdminUploadsUploadIdUrl = (uploadId: string,) => {




  return `/api/admin/uploads/${uploadId}`
}

export const deleteApiAdminUploadsUploadId = async (uploadId: string, options?: RequestInit): Promise<deleteApiAdminUploadsUploadIdResponse> => {

  return fetcher<deleteApiAdminUploadsUploadIdResponse>(getDeleteApiAdminUploadsUploadIdUrl(uploadId),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type postApiAdminUploadsUploadIdRestoreResponse200 = {
  data: void
  status: 200
}

export type postApiAdminUploadsUploadIdRestoreResponse401 = {
  data: PostApiAdminUploadsUploadIdRestore401
  status: 401
}

export type postApiAdminUploadsUploadIdRestoreResponse402 = {
  data: PostApiAdminUploadsUploadIdRestore402
  status: 402
}

export type postApiAdminUploadsUploadIdRestoreResponseSuccess = (postApiAdminUploadsUploadIdRestoreResponse200) & {
  headers: Headers;
};
export type postApiAdminUploadsUploadIdRestoreResponseError = (postApiAdminUploadsUploadIdRestoreResponse401 | postApiAdminUploadsUploadIdRestoreResponse402) & {
  headers: Headers;
};

export type postApiAdminUploadsUploadIdRestoreResponse = (postApiAdminUploadsUploadIdRestoreResponseSuccess | postApiAdminUploadsUploadIdRestoreResponseError)

export const getPostApiAdminUploadsUploadIdRestoreUrl = (uploadId: string,) => {




  return `/api/admin/uploads/${uploadId}/restore`
}

export const postApiAdminUploadsUploadIdRestore = async (uploadId: string, options?: RequestInit): Promise<postApiAdminUploadsUploadIdRestoreResponse> => {

  return fetcher<postApiAdminUploadsUploadIdRestoreResponse>(getPostApiAdminUploadsUploadIdRestoreUrl(uploadId),
  {
    ...options,
    method: 'POST'


  }
);}



export type deleteApiAdminUploadsUploadIdHardResponse200 = {
  data: void
  status: 200
}

export type deleteApiAdminUploadsUploadIdHardResponse401 = {
  data: DeleteApiAdminUploadsUploadIdHard401
  status: 401
}

export type deleteApiAdminUploadsUploadIdHardResponse402 = {
  data: DeleteApiAdminUploadsUploadIdHard402
  status: 402
}

export type deleteApiAdminUploadsUploadIdHardResponseSuccess = (deleteApiAdminUploadsUploadIdHardResponse200) & {
  headers: Headers;
};
export type deleteApiAdminUploadsUploadIdHardResponseError = (deleteApiAdminUploadsUploadIdHardResponse401 | deleteApiAdminUploadsUploadIdHardResponse402) & {
  headers: Headers;
};

export type deleteApiAdminUploadsUploadIdHardResponse = (deleteApiAdminUploadsUploadIdHardResponseSuccess | deleteApiAdminUploadsUploadIdHardResponseError)

export const getDeleteApiAdminUploadsUploadIdHardUrl = (uploadId: string,) => {




  return `/api/admin/uploads/${uploadId}/hard`
}

export const deleteApiAdminUploadsUploadIdHard = async (uploadId: string, options?: RequestInit): Promise<deleteApiAdminUploadsUploadIdHardResponse> => {

  return fetcher<deleteApiAdminUploadsUploadIdHardResponse>(getDeleteApiAdminUploadsUploadIdHardUrl(uploadId),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type getApiAnalyticsSummaryResponse200 = {
  data: void
  status: 200
}

export type getApiAnalyticsSummaryResponse401 = {
  data: GetApiAnalyticsSummary401
  status: 401
}

export type getApiAnalyticsSummaryResponseSuccess = (getApiAnalyticsSummaryResponse200) & {
  headers: Headers;
};
export type getApiAnalyticsSummaryResponseError = (getApiAnalyticsSummaryResponse401) & {
  headers: Headers;
};

export type getApiAnalyticsSummaryResponse = (getApiAnalyticsSummaryResponseSuccess | getApiAnalyticsSummaryResponseError)

export const getGetApiAnalyticsSummaryUrl = () => {




  return `/api/analytics/summary`
}

export const getApiAnalyticsSummary = async ( options?: RequestInit): Promise<getApiAnalyticsSummaryResponse> => {

  return fetcher<getApiAnalyticsSummaryResponse>(getGetApiAnalyticsSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiAuth0ConnectionsResponse200TextPlain = {
  data: Auth0ConnectionDto[]
  status: 200
}

export type getApiAuth0ConnectionsResponse200ApplicationJson = {
  data: Auth0ConnectionDto[]
  status: 200
}

export type getApiAuth0ConnectionsResponse200TextJson = {
  data: Auth0ConnectionDto[]
  status: 200
}

export type getApiAuth0ConnectionsResponse401 = {
  data: GetApiAuth0Connections401
  status: 401
}

export type getApiAuth0ConnectionsResponse402 = {
  data: GetApiAuth0Connections402
  status: 402
}

export type getApiAuth0ConnectionsResponseSuccess = (getApiAuth0ConnectionsResponse200TextPlain | getApiAuth0ConnectionsResponse200ApplicationJson | getApiAuth0ConnectionsResponse200TextJson) & {
  headers: Headers;
};
export type getApiAuth0ConnectionsResponseError = (getApiAuth0ConnectionsResponse401 | getApiAuth0ConnectionsResponse402) & {
  headers: Headers;
};

export type getApiAuth0ConnectionsResponse = (getApiAuth0ConnectionsResponseSuccess | getApiAuth0ConnectionsResponseError)

export const getGetApiAuth0ConnectionsUrl = (params?: GetApiAuth0ConnectionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Auth0Connections?${stringifiedParams}` : `/api/Auth0Connections`
}

export const getApiAuth0Connections = async (params?: GetApiAuth0ConnectionsParams, options?: RequestInit): Promise<getApiAuth0ConnectionsResponse> => {

  return fetcher<getApiAuth0ConnectionsResponse>(getGetApiAuth0ConnectionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiAuth0UsersResponse200TextPlain = {
  data: Auth0UserDto[]
  status: 200
}

export type getApiAuth0UsersResponse200ApplicationJson = {
  data: Auth0UserDto[]
  status: 200
}

export type getApiAuth0UsersResponse200TextJson = {
  data: Auth0UserDto[]
  status: 200
}

export type getApiAuth0UsersResponse401 = {
  data: GetApiAuth0Users401
  status: 401
}

export type getApiAuth0UsersResponse402 = {
  data: GetApiAuth0Users402
  status: 402
}

export type getApiAuth0UsersResponseSuccess = (getApiAuth0UsersResponse200TextPlain | getApiAuth0UsersResponse200ApplicationJson | getApiAuth0UsersResponse200TextJson) & {
  headers: Headers;
};
export type getApiAuth0UsersResponseError = (getApiAuth0UsersResponse401 | getApiAuth0UsersResponse402) & {
  headers: Headers;
};

export type getApiAuth0UsersResponse = (getApiAuth0UsersResponseSuccess | getApiAuth0UsersResponseError)

export const getGetApiAuth0UsersUrl = (params?: GetApiAuth0UsersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Auth0Users?${stringifiedParams}` : `/api/Auth0Users`
}

export const getApiAuth0Users = async (params?: GetApiAuth0UsersParams, options?: RequestInit): Promise<getApiAuth0UsersResponse> => {

  return fetcher<getApiAuth0UsersResponse>(getGetApiAuth0UsersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiAuth0UsersResponse200TextPlain = {
  data: Auth0UserDto
  status: 200
}

export type postApiAuth0UsersResponse200ApplicationJson = {
  data: Auth0UserDto
  status: 200
}

export type postApiAuth0UsersResponse200TextJson = {
  data: Auth0UserDto
  status: 200
}

export type postApiAuth0UsersResponse401 = {
  data: PostApiAuth0Users401
  status: 401
}

export type postApiAuth0UsersResponse402 = {
  data: PostApiAuth0Users402
  status: 402
}

export type postApiAuth0UsersResponseSuccess = (postApiAuth0UsersResponse200TextPlain | postApiAuth0UsersResponse200ApplicationJson | postApiAuth0UsersResponse200TextJson) & {
  headers: Headers;
};
export type postApiAuth0UsersResponseError = (postApiAuth0UsersResponse401 | postApiAuth0UsersResponse402) & {
  headers: Headers;
};

export type postApiAuth0UsersResponse = (postApiAuth0UsersResponseSuccess | postApiAuth0UsersResponseError)

export const getPostApiAuth0UsersUrl = () => {




  return `/api/Auth0Users`
}

export const postApiAuth0Users = async (auth0CreateUserRequest: Auth0CreateUserRequest, options?: RequestInit): Promise<postApiAuth0UsersResponse> => {

  return fetcher<postApiAuth0UsersResponse>(getPostApiAuth0UsersUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      auth0CreateUserRequest,)
  }
);}



export type getApiAuth0UsersWithPresenceResponse200TextPlain = {
  data: Auth0UserWithPresenceDto[]
  status: 200
}

export type getApiAuth0UsersWithPresenceResponse200ApplicationJson = {
  data: Auth0UserWithPresenceDto[]
  status: 200
}

export type getApiAuth0UsersWithPresenceResponse200TextJson = {
  data: Auth0UserWithPresenceDto[]
  status: 200
}

export type getApiAuth0UsersWithPresenceResponse401 = {
  data: GetApiAuth0UsersWithPresence401
  status: 401
}

export type getApiAuth0UsersWithPresenceResponse402 = {
  data: GetApiAuth0UsersWithPresence402
  status: 402
}

export type getApiAuth0UsersWithPresenceResponseSuccess = (getApiAuth0UsersWithPresenceResponse200TextPlain | getApiAuth0UsersWithPresenceResponse200ApplicationJson | getApiAuth0UsersWithPresenceResponse200TextJson) & {
  headers: Headers;
};
export type getApiAuth0UsersWithPresenceResponseError = (getApiAuth0UsersWithPresenceResponse401 | getApiAuth0UsersWithPresenceResponse402) & {
  headers: Headers;
};

export type getApiAuth0UsersWithPresenceResponse = (getApiAuth0UsersWithPresenceResponseSuccess | getApiAuth0UsersWithPresenceResponseError)

export const getGetApiAuth0UsersWithPresenceUrl = (params?: GetApiAuth0UsersWithPresenceParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Auth0Users/with-presence?${stringifiedParams}` : `/api/Auth0Users/with-presence`
}

export const getApiAuth0UsersWithPresence = async (params?: GetApiAuth0UsersWithPresenceParams, options?: RequestInit): Promise<getApiAuth0UsersWithPresenceResponse> => {

  return fetcher<getApiAuth0UsersWithPresenceResponse>(getGetApiAuth0UsersWithPresenceUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiAuth0UsersUserIdResponse200TextPlain = {
  data: Auth0UserDto
  status: 200
}

export type getApiAuth0UsersUserIdResponse200ApplicationJson = {
  data: Auth0UserDto
  status: 200
}

export type getApiAuth0UsersUserIdResponse200TextJson = {
  data: Auth0UserDto
  status: 200
}

export type getApiAuth0UsersUserIdResponse401 = {
  data: GetApiAuth0UsersUserId401
  status: 401
}

export type getApiAuth0UsersUserIdResponse402 = {
  data: GetApiAuth0UsersUserId402
  status: 402
}

export type getApiAuth0UsersUserIdResponseSuccess = (getApiAuth0UsersUserIdResponse200TextPlain | getApiAuth0UsersUserIdResponse200ApplicationJson | getApiAuth0UsersUserIdResponse200TextJson) & {
  headers: Headers;
};
export type getApiAuth0UsersUserIdResponseError = (getApiAuth0UsersUserIdResponse401 | getApiAuth0UsersUserIdResponse402) & {
  headers: Headers;
};

export type getApiAuth0UsersUserIdResponse = (getApiAuth0UsersUserIdResponseSuccess | getApiAuth0UsersUserIdResponseError)

export const getGetApiAuth0UsersUserIdUrl = (userId: string,) => {




  return `/api/Auth0Users/${userId}`
}

export const getApiAuth0UsersUserId = async (userId: string, options?: RequestInit): Promise<getApiAuth0UsersUserIdResponse> => {

  return fetcher<getApiAuth0UsersUserIdResponse>(getGetApiAuth0UsersUserIdUrl(userId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiMonitorClarityLiveResponse200 = {
  data: void
  status: 200
}

export type getApiMonitorClarityLiveResponse401 = {
  data: GetApiMonitorClarityLive401
  status: 401
}

export type getApiMonitorClarityLiveResponseSuccess = (getApiMonitorClarityLiveResponse200) & {
  headers: Headers;
};
export type getApiMonitorClarityLiveResponseError = (getApiMonitorClarityLiveResponse401) & {
  headers: Headers;
};

export type getApiMonitorClarityLiveResponse = (getApiMonitorClarityLiveResponseSuccess | getApiMonitorClarityLiveResponseError)

export const getGetApiMonitorClarityLiveUrl = (params?: GetApiMonitorClarityLiveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/monitor/clarity/live?${stringifiedParams}` : `/api/monitor/clarity/live`
}

export const getApiMonitorClarityLive = async (params?: GetApiMonitorClarityLiveParams, options?: RequestInit): Promise<getApiMonitorClarityLiveResponse> => {

  return fetcher<getApiMonitorClarityLiveResponse>(getGetApiMonitorClarityLiveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiCrmWcClassCodesResponse200 = {
  data: void
  status: 200
}

export type getApiCrmWcClassCodesResponse401 = {
  data: GetApiCrmWcClassCodes401
  status: 401
}

export type getApiCrmWcClassCodesResponseSuccess = (getApiCrmWcClassCodesResponse200) & {
  headers: Headers;
};
export type getApiCrmWcClassCodesResponseError = (getApiCrmWcClassCodesResponse401) & {
  headers: Headers;
};

export type getApiCrmWcClassCodesResponse = (getApiCrmWcClassCodesResponseSuccess | getApiCrmWcClassCodesResponseError)

export const getGetApiCrmWcClassCodesUrl = () => {




  return `/api/crm/wc-class-codes`
}

export const getApiCrmWcClassCodes = async ( options?: RequestInit): Promise<getApiCrmWcClassCodesResponse> => {

  return fetcher<getApiCrmWcClassCodesResponse>(getGetApiCrmWcClassCodesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiCrmGlClassificationsResponse200 = {
  data: void
  status: 200
}

export type getApiCrmGlClassificationsResponse401 = {
  data: GetApiCrmGlClassifications401
  status: 401
}

export type getApiCrmGlClassificationsResponseSuccess = (getApiCrmGlClassificationsResponse200) & {
  headers: Headers;
};
export type getApiCrmGlClassificationsResponseError = (getApiCrmGlClassificationsResponse401) & {
  headers: Headers;
};

export type getApiCrmGlClassificationsResponse = (getApiCrmGlClassificationsResponseSuccess | getApiCrmGlClassificationsResponseError)

export const getGetApiCrmGlClassificationsUrl = () => {




  return `/api/crm/gl-classifications`
}

export const getApiCrmGlClassifications = async ( options?: RequestInit): Promise<getApiCrmGlClassificationsResponse> => {

  return fetcher<getApiCrmGlClassificationsResponse>(getGetApiCrmGlClassificationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiCrmClientAccountStatusCodesResponse200 = {
  data: void
  status: 200
}

export type getApiCrmClientAccountStatusCodesResponse401 = {
  data: GetApiCrmClientAccountStatusCodes401
  status: 401
}

export type getApiCrmClientAccountStatusCodesResponseSuccess = (getApiCrmClientAccountStatusCodesResponse200) & {
  headers: Headers;
};
export type getApiCrmClientAccountStatusCodesResponseError = (getApiCrmClientAccountStatusCodesResponse401) & {
  headers: Headers;
};

export type getApiCrmClientAccountStatusCodesResponse = (getApiCrmClientAccountStatusCodesResponseSuccess | getApiCrmClientAccountStatusCodesResponseError)

export const getGetApiCrmClientAccountStatusCodesUrl = () => {




  return `/api/crm/client-account-status-codes`
}

export const getApiCrmClientAccountStatusCodes = async ( options?: RequestInit): Promise<getApiCrmClientAccountStatusCodesResponse> => {

  return fetcher<getApiCrmClientAccountStatusCodesResponse>(getGetApiCrmClientAccountStatusCodesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiCrmPolicyStatusCodesResponse200 = {
  data: void
  status: 200
}

export type getApiCrmPolicyStatusCodesResponse401 = {
  data: GetApiCrmPolicyStatusCodes401
  status: 401
}

export type getApiCrmPolicyStatusCodesResponseSuccess = (getApiCrmPolicyStatusCodesResponse200) & {
  headers: Headers;
};
export type getApiCrmPolicyStatusCodesResponseError = (getApiCrmPolicyStatusCodesResponse401) & {
  headers: Headers;
};

export type getApiCrmPolicyStatusCodesResponse = (getApiCrmPolicyStatusCodesResponseSuccess | getApiCrmPolicyStatusCodesResponseError)

export const getGetApiCrmPolicyStatusCodesUrl = () => {




  return `/api/crm/policy-status-codes`
}

export const getApiCrmPolicyStatusCodes = async ( options?: RequestInit): Promise<getApiCrmPolicyStatusCodesResponse> => {

  return fetcher<getApiCrmPolicyStatusCodesResponse>(getGetApiCrmPolicyStatusCodesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiCrmCarriersResponse200 = {
  data: void
  status: 200
}

export type getApiCrmCarriersResponse401 = {
  data: GetApiCrmCarriers401
  status: 401
}

export type getApiCrmCarriersResponseSuccess = (getApiCrmCarriersResponse200) & {
  headers: Headers;
};
export type getApiCrmCarriersResponseError = (getApiCrmCarriersResponse401) & {
  headers: Headers;
};

export type getApiCrmCarriersResponse = (getApiCrmCarriersResponseSuccess | getApiCrmCarriersResponseError)

export const getGetApiCrmCarriersUrl = (params?: GetApiCrmCarriersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/crm/carriers?${stringifiedParams}` : `/api/crm/carriers`
}

export const getApiCrmCarriers = async (params?: GetApiCrmCarriersParams, options?: RequestInit): Promise<getApiCrmCarriersResponse> => {

  return fetcher<getApiCrmCarriersResponse>(getGetApiCrmCarriersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiCrmCarrierCatalogResponse200 = {
  data: void
  status: 200
}

export type getApiCrmCarrierCatalogResponse401 = {
  data: GetApiCrmCarrierCatalog401
  status: 401
}

export type getApiCrmCarrierCatalogResponseSuccess = (getApiCrmCarrierCatalogResponse200) & {
  headers: Headers;
};
export type getApiCrmCarrierCatalogResponseError = (getApiCrmCarrierCatalogResponse401) & {
  headers: Headers;
};

export type getApiCrmCarrierCatalogResponse = (getApiCrmCarrierCatalogResponseSuccess | getApiCrmCarrierCatalogResponseError)

export const getGetApiCrmCarrierCatalogUrl = (params?: GetApiCrmCarrierCatalogParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/crm/carrier-catalog?${stringifiedParams}` : `/api/crm/carrier-catalog`
}

export const getApiCrmCarrierCatalog = async (params?: GetApiCrmCarrierCatalogParams, options?: RequestInit): Promise<getApiCrmCarrierCatalogResponse> => {

  return fetcher<getApiCrmCarrierCatalogResponse>(getGetApiCrmCarrierCatalogUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiCrmSubmissionStageCodesResponse200 = {
  data: void
  status: 200
}

export type getApiCrmSubmissionStageCodesResponse401 = {
  data: GetApiCrmSubmissionStageCodes401
  status: 401
}

export type getApiCrmSubmissionStageCodesResponseSuccess = (getApiCrmSubmissionStageCodesResponse200) & {
  headers: Headers;
};
export type getApiCrmSubmissionStageCodesResponseError = (getApiCrmSubmissionStageCodesResponse401) & {
  headers: Headers;
};

export type getApiCrmSubmissionStageCodesResponse = (getApiCrmSubmissionStageCodesResponseSuccess | getApiCrmSubmissionStageCodesResponseError)

export const getGetApiCrmSubmissionStageCodesUrl = () => {




  return `/api/crm/submission-stage-codes`
}

export const getApiCrmSubmissionStageCodes = async ( options?: RequestInit): Promise<getApiCrmSubmissionStageCodesResponse> => {

  return fetcher<getApiCrmSubmissionStageCodesResponse>(getGetApiCrmSubmissionStageCodesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiCrmLobCodesResponse200 = {
  data: void
  status: 200
}

export type getApiCrmLobCodesResponse401 = {
  data: GetApiCrmLobCodes401
  status: 401
}

export type getApiCrmLobCodesResponseSuccess = (getApiCrmLobCodesResponse200) & {
  headers: Headers;
};
export type getApiCrmLobCodesResponseError = (getApiCrmLobCodesResponse401) & {
  headers: Headers;
};

export type getApiCrmLobCodesResponse = (getApiCrmLobCodesResponseSuccess | getApiCrmLobCodesResponseError)

export const getGetApiCrmLobCodesUrl = () => {




  return `/api/crm/lob-codes`
}

export const getApiCrmLobCodes = async ( options?: RequestInit): Promise<getApiCrmLobCodesResponse> => {

  return fetcher<getApiCrmLobCodesResponse>(getGetApiCrmLobCodesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiCrmLineOfBusinessCodesResponse200 = {
  data: void
  status: 200
}

export type getApiCrmLineOfBusinessCodesResponse401 = {
  data: GetApiCrmLineOfBusinessCodes401
  status: 401
}

export type getApiCrmLineOfBusinessCodesResponseSuccess = (getApiCrmLineOfBusinessCodesResponse200) & {
  headers: Headers;
};
export type getApiCrmLineOfBusinessCodesResponseError = (getApiCrmLineOfBusinessCodesResponse401) & {
  headers: Headers;
};

export type getApiCrmLineOfBusinessCodesResponse = (getApiCrmLineOfBusinessCodesResponseSuccess | getApiCrmLineOfBusinessCodesResponseError)

export const getGetApiCrmLineOfBusinessCodesUrl = () => {




  return `/api/crm/line-of-business-codes`
}

export const getApiCrmLineOfBusinessCodes = async ( options?: RequestInit): Promise<getApiCrmLineOfBusinessCodesResponse> => {

  return fetcher<getApiCrmLineOfBusinessCodesResponse>(getGetApiCrmLineOfBusinessCodesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiCrmInsuranceTypeCodesResponse200 = {
  data: void
  status: 200
}

export type getApiCrmInsuranceTypeCodesResponse401 = {
  data: GetApiCrmInsuranceTypeCodes401
  status: 401
}

export type getApiCrmInsuranceTypeCodesResponseSuccess = (getApiCrmInsuranceTypeCodesResponse200) & {
  headers: Headers;
};
export type getApiCrmInsuranceTypeCodesResponseError = (getApiCrmInsuranceTypeCodesResponse401) & {
  headers: Headers;
};

export type getApiCrmInsuranceTypeCodesResponse = (getApiCrmInsuranceTypeCodesResponseSuccess | getApiCrmInsuranceTypeCodesResponseError)

export const getGetApiCrmInsuranceTypeCodesUrl = () => {




  return `/api/crm/insurance-type-codes`
}

export const getApiCrmInsuranceTypeCodes = async ( options?: RequestInit): Promise<getApiCrmInsuranceTypeCodesResponse> => {

  return fetcher<getApiCrmInsuranceTypeCodesResponse>(getGetApiCrmInsuranceTypeCodesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiCrmInsuranceTypeLobsResponse200 = {
  data: void
  status: 200
}

export type getApiCrmInsuranceTypeLobsResponse401 = {
  data: GetApiCrmInsuranceTypeLobs401
  status: 401
}

export type getApiCrmInsuranceTypeLobsResponseSuccess = (getApiCrmInsuranceTypeLobsResponse200) & {
  headers: Headers;
};
export type getApiCrmInsuranceTypeLobsResponseError = (getApiCrmInsuranceTypeLobsResponse401) & {
  headers: Headers;
};

export type getApiCrmInsuranceTypeLobsResponse = (getApiCrmInsuranceTypeLobsResponseSuccess | getApiCrmInsuranceTypeLobsResponseError)

export const getGetApiCrmInsuranceTypeLobsUrl = () => {




  return `/api/crm/insurance-type-lobs`
}

export const getApiCrmInsuranceTypeLobs = async ( options?: RequestInit): Promise<getApiCrmInsuranceTypeLobsResponse> => {

  return fetcher<getApiCrmInsuranceTypeLobsResponse>(getGetApiCrmInsuranceTypeLobsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiCrmInsuranceTypeAcordFormsResponse200 = {
  data: void
  status: 200
}

export type getApiCrmInsuranceTypeAcordFormsResponse401 = {
  data: GetApiCrmInsuranceTypeAcordForms401
  status: 401
}

export type getApiCrmInsuranceTypeAcordFormsResponseSuccess = (getApiCrmInsuranceTypeAcordFormsResponse200) & {
  headers: Headers;
};
export type getApiCrmInsuranceTypeAcordFormsResponseError = (getApiCrmInsuranceTypeAcordFormsResponse401) & {
  headers: Headers;
};

export type getApiCrmInsuranceTypeAcordFormsResponse = (getApiCrmInsuranceTypeAcordFormsResponseSuccess | getApiCrmInsuranceTypeAcordFormsResponseError)

export const getGetApiCrmInsuranceTypeAcordFormsUrl = (params?: GetApiCrmInsuranceTypeAcordFormsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/crm/insurance-type-acord-forms?${stringifiedParams}` : `/api/crm/insurance-type-acord-forms`
}

export const getApiCrmInsuranceTypeAcordForms = async (params?: GetApiCrmInsuranceTypeAcordFormsParams, options?: RequestInit): Promise<getApiCrmInsuranceTypeAcordFormsResponse> => {

  return fetcher<getApiCrmInsuranceTypeAcordFormsResponse>(getGetApiCrmInsuranceTypeAcordFormsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiCrmInsuranceTypeAppFormsResponse200 = {
  data: void
  status: 200
}

export type getApiCrmInsuranceTypeAppFormsResponse401 = {
  data: GetApiCrmInsuranceTypeAppForms401
  status: 401
}

export type getApiCrmInsuranceTypeAppFormsResponseSuccess = (getApiCrmInsuranceTypeAppFormsResponse200) & {
  headers: Headers;
};
export type getApiCrmInsuranceTypeAppFormsResponseError = (getApiCrmInsuranceTypeAppFormsResponse401) & {
  headers: Headers;
};

export type getApiCrmInsuranceTypeAppFormsResponse = (getApiCrmInsuranceTypeAppFormsResponseSuccess | getApiCrmInsuranceTypeAppFormsResponseError)

export const getGetApiCrmInsuranceTypeAppFormsUrl = (params?: GetApiCrmInsuranceTypeAppFormsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/crm/insurance-type-app-forms?${stringifiedParams}` : `/api/crm/insurance-type-app-forms`
}

export const getApiCrmInsuranceTypeAppForms = async (params?: GetApiCrmInsuranceTypeAppFormsParams, options?: RequestInit): Promise<getApiCrmInsuranceTypeAppFormsResponse> => {

  return fetcher<getApiCrmInsuranceTypeAppFormsResponse>(getGetApiCrmInsuranceTypeAppFormsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiCrmPacketsResolveResponse200 = {
  data: void
  status: 200
}

export type getApiCrmPacketsResolveResponse401 = {
  data: GetApiCrmPacketsResolve401
  status: 401
}

export type getApiCrmPacketsResolveResponseSuccess = (getApiCrmPacketsResolveResponse200) & {
  headers: Headers;
};
export type getApiCrmPacketsResolveResponseError = (getApiCrmPacketsResolveResponse401) & {
  headers: Headers;
};

export type getApiCrmPacketsResolveResponse = (getApiCrmPacketsResolveResponseSuccess | getApiCrmPacketsResolveResponseError)

export const getGetApiCrmPacketsResolveUrl = (params?: GetApiCrmPacketsResolveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/crm/packets/resolve?${stringifiedParams}` : `/api/crm/packets/resolve`
}

export const getApiCrmPacketsResolve = async (params?: GetApiCrmPacketsResolveParams, options?: RequestInit): Promise<getApiCrmPacketsResolveResponse> => {

  return fetcher<getApiCrmPacketsResolveResponse>(getGetApiCrmPacketsResolveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiCrmInsuranceTypeCoveragesResponse200 = {
  data: void
  status: 200
}

export type getApiCrmInsuranceTypeCoveragesResponse401 = {
  data: GetApiCrmInsuranceTypeCoverages401
  status: 401
}

export type getApiCrmInsuranceTypeCoveragesResponseSuccess = (getApiCrmInsuranceTypeCoveragesResponse200) & {
  headers: Headers;
};
export type getApiCrmInsuranceTypeCoveragesResponseError = (getApiCrmInsuranceTypeCoveragesResponse401) & {
  headers: Headers;
};

export type getApiCrmInsuranceTypeCoveragesResponse = (getApiCrmInsuranceTypeCoveragesResponseSuccess | getApiCrmInsuranceTypeCoveragesResponseError)

export const getGetApiCrmInsuranceTypeCoveragesUrl = () => {




  return `/api/crm/insurance-type-coverages`
}

export const getApiCrmInsuranceTypeCoverages = async ( options?: RequestInit): Promise<getApiCrmInsuranceTypeCoveragesResponse> => {

  return fetcher<getApiCrmInsuranceTypeCoveragesResponse>(getGetApiCrmInsuranceTypeCoveragesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiCrmCoverageUsageContextsResponse200 = {
  data: void
  status: 200
}

export type getApiCrmCoverageUsageContextsResponse401 = {
  data: GetApiCrmCoverageUsageContexts401
  status: 401
}

export type getApiCrmCoverageUsageContextsResponseSuccess = (getApiCrmCoverageUsageContextsResponse200) & {
  headers: Headers;
};
export type getApiCrmCoverageUsageContextsResponseError = (getApiCrmCoverageUsageContextsResponse401) & {
  headers: Headers;
};

export type getApiCrmCoverageUsageContextsResponse = (getApiCrmCoverageUsageContextsResponseSuccess | getApiCrmCoverageUsageContextsResponseError)

export const getGetApiCrmCoverageUsageContextsUrl = (params?: GetApiCrmCoverageUsageContextsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/crm/coverage-usage-contexts?${stringifiedParams}` : `/api/crm/coverage-usage-contexts`
}

export const getApiCrmCoverageUsageContexts = async (params?: GetApiCrmCoverageUsageContextsParams, options?: RequestInit): Promise<getApiCrmCoverageUsageContextsResponse> => {

  return fetcher<getApiCrmCoverageUsageContextsResponse>(getGetApiCrmCoverageUsageContextsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiCrmArtifactTypesResponse200 = {
  data: void
  status: 200
}

export type getApiCrmArtifactTypesResponse401 = {
  data: GetApiCrmArtifactTypes401
  status: 401
}

export type getApiCrmArtifactTypesResponseSuccess = (getApiCrmArtifactTypesResponse200) & {
  headers: Headers;
};
export type getApiCrmArtifactTypesResponseError = (getApiCrmArtifactTypesResponse401) & {
  headers: Headers;
};

export type getApiCrmArtifactTypesResponse = (getApiCrmArtifactTypesResponseSuccess | getApiCrmArtifactTypesResponseError)

export const getGetApiCrmArtifactTypesUrl = () => {




  return `/api/crm/artifact-types`
}

export const getApiCrmArtifactTypes = async ( options?: RequestInit): Promise<getApiCrmArtifactTypesResponse> => {

  return fetcher<getApiCrmArtifactTypesResponse>(getGetApiCrmArtifactTypesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiCrmUsageContextArtifactsResponse200 = {
  data: void
  status: 200
}

export type getApiCrmUsageContextArtifactsResponse401 = {
  data: GetApiCrmUsageContextArtifacts401
  status: 401
}

export type getApiCrmUsageContextArtifactsResponseSuccess = (getApiCrmUsageContextArtifactsResponse200) & {
  headers: Headers;
};
export type getApiCrmUsageContextArtifactsResponseError = (getApiCrmUsageContextArtifactsResponse401) & {
  headers: Headers;
};

export type getApiCrmUsageContextArtifactsResponse = (getApiCrmUsageContextArtifactsResponseSuccess | getApiCrmUsageContextArtifactsResponseError)

export const getGetApiCrmUsageContextArtifactsUrl = (params?: GetApiCrmUsageContextArtifactsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/crm/usage-context-artifacts?${stringifiedParams}` : `/api/crm/usage-context-artifacts`
}

export const getApiCrmUsageContextArtifacts = async (params?: GetApiCrmUsageContextArtifactsParams, options?: RequestInit): Promise<getApiCrmUsageContextArtifactsResponse> => {

  return fetcher<getApiCrmUsageContextArtifactsResponse>(getGetApiCrmUsageContextArtifactsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiCrmUsageContextsResponse200 = {
  data: void
  status: 200
}

export type getApiCrmUsageContextsResponse401 = {
  data: GetApiCrmUsageContexts401
  status: 401
}

export type getApiCrmUsageContextsResponseSuccess = (getApiCrmUsageContextsResponse200) & {
  headers: Headers;
};
export type getApiCrmUsageContextsResponseError = (getApiCrmUsageContextsResponse401) & {
  headers: Headers;
};

export type getApiCrmUsageContextsResponse = (getApiCrmUsageContextsResponseSuccess | getApiCrmUsageContextsResponseError)

export const getGetApiCrmUsageContextsUrl = (params?: GetApiCrmUsageContextsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/crm/usage-contexts?${stringifiedParams}` : `/api/crm/usage-contexts`
}

export const getApiCrmUsageContexts = async (params?: GetApiCrmUsageContextsParams, options?: RequestInit): Promise<getApiCrmUsageContextsResponse> => {

  return fetcher<getApiCrmUsageContextsResponse>(getGetApiCrmUsageContextsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiCrmLifecycleContextsResolveResponse200 = {
  data: void
  status: 200
}

export type getApiCrmLifecycleContextsResolveResponse401 = {
  data: GetApiCrmLifecycleContextsResolve401
  status: 401
}

export type getApiCrmLifecycleContextsResolveResponseSuccess = (getApiCrmLifecycleContextsResolveResponse200) & {
  headers: Headers;
};
export type getApiCrmLifecycleContextsResolveResponseError = (getApiCrmLifecycleContextsResolveResponse401) & {
  headers: Headers;
};

export type getApiCrmLifecycleContextsResolveResponse = (getApiCrmLifecycleContextsResolveResponseSuccess | getApiCrmLifecycleContextsResolveResponseError)

export const getGetApiCrmLifecycleContextsResolveUrl = (params?: GetApiCrmLifecycleContextsResolveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/crm/lifecycle-contexts/resolve?${stringifiedParams}` : `/api/crm/lifecycle-contexts/resolve`
}

export const getApiCrmLifecycleContextsResolve = async (params?: GetApiCrmLifecycleContextsResolveParams, options?: RequestInit): Promise<getApiCrmLifecycleContextsResolveResponse> => {

  return fetcher<getApiCrmLifecycleContextsResolveResponse>(getGetApiCrmLifecycleContextsResolveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiCrmDataKeyFunctionalGroupsResponse200 = {
  data: void
  status: 200
}

export type getApiCrmDataKeyFunctionalGroupsResponse401 = {
  data: GetApiCrmDataKeyFunctionalGroups401
  status: 401
}

export type getApiCrmDataKeyFunctionalGroupsResponseSuccess = (getApiCrmDataKeyFunctionalGroupsResponse200) & {
  headers: Headers;
};
export type getApiCrmDataKeyFunctionalGroupsResponseError = (getApiCrmDataKeyFunctionalGroupsResponse401) & {
  headers: Headers;
};

export type getApiCrmDataKeyFunctionalGroupsResponse = (getApiCrmDataKeyFunctionalGroupsResponseSuccess | getApiCrmDataKeyFunctionalGroupsResponseError)

export const getGetApiCrmDataKeyFunctionalGroupsUrl = () => {




  return `/api/crm/data-key-functional-groups`
}

export const getApiCrmDataKeyFunctionalGroups = async ( options?: RequestInit): Promise<getApiCrmDataKeyFunctionalGroupsResponse> => {

  return fetcher<getApiCrmDataKeyFunctionalGroupsResponse>(getGetApiCrmDataKeyFunctionalGroupsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiCrmInsuranceTypeDataKeyRequirementsResponse200 = {
  data: void
  status: 200
}

export type getApiCrmInsuranceTypeDataKeyRequirementsResponse401 = {
  data: GetApiCrmInsuranceTypeDataKeyRequirements401
  status: 401
}

export type getApiCrmInsuranceTypeDataKeyRequirementsResponseSuccess = (getApiCrmInsuranceTypeDataKeyRequirementsResponse200) & {
  headers: Headers;
};
export type getApiCrmInsuranceTypeDataKeyRequirementsResponseError = (getApiCrmInsuranceTypeDataKeyRequirementsResponse401) & {
  headers: Headers;
};

export type getApiCrmInsuranceTypeDataKeyRequirementsResponse = (getApiCrmInsuranceTypeDataKeyRequirementsResponseSuccess | getApiCrmInsuranceTypeDataKeyRequirementsResponseError)

export const getGetApiCrmInsuranceTypeDataKeyRequirementsUrl = (params?: GetApiCrmInsuranceTypeDataKeyRequirementsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/crm/insurance-type-data-key-requirements?${stringifiedParams}` : `/api/crm/insurance-type-data-key-requirements`
}

export const getApiCrmInsuranceTypeDataKeyRequirements = async (params?: GetApiCrmInsuranceTypeDataKeyRequirementsParams, options?: RequestInit): Promise<getApiCrmInsuranceTypeDataKeyRequirementsResponse> => {

  return fetcher<getApiCrmInsuranceTypeDataKeyRequirementsResponse>(getGetApiCrmInsuranceTypeDataKeyRequirementsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiCrmSubmissionDocumentRequirementsResponse200 = {
  data: void
  status: 200
}

export type getApiCrmSubmissionDocumentRequirementsResponse401 = {
  data: GetApiCrmSubmissionDocumentRequirements401
  status: 401
}

export type getApiCrmSubmissionDocumentRequirementsResponseSuccess = (getApiCrmSubmissionDocumentRequirementsResponse200) & {
  headers: Headers;
};
export type getApiCrmSubmissionDocumentRequirementsResponseError = (getApiCrmSubmissionDocumentRequirementsResponse401) & {
  headers: Headers;
};

export type getApiCrmSubmissionDocumentRequirementsResponse = (getApiCrmSubmissionDocumentRequirementsResponseSuccess | getApiCrmSubmissionDocumentRequirementsResponseError)

export const getGetApiCrmSubmissionDocumentRequirementsUrl = (params?: GetApiCrmSubmissionDocumentRequirementsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/crm/submission-document-requirements?${stringifiedParams}` : `/api/crm/submission-document-requirements`
}

export const getApiCrmSubmissionDocumentRequirements = async (params?: GetApiCrmSubmissionDocumentRequirementsParams, options?: RequestInit): Promise<getApiCrmSubmissionDocumentRequirementsResponse> => {

  return fetcher<getApiCrmSubmissionDocumentRequirementsResponse>(getGetApiCrmSubmissionDocumentRequirementsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiCrmInsuranceTypeDocumentRequirementsResponse200 = {
  data: void
  status: 200
}

export type getApiCrmInsuranceTypeDocumentRequirementsResponse401 = {
  data: GetApiCrmInsuranceTypeDocumentRequirements401
  status: 401
}

export type getApiCrmInsuranceTypeDocumentRequirementsResponseSuccess = (getApiCrmInsuranceTypeDocumentRequirementsResponse200) & {
  headers: Headers;
};
export type getApiCrmInsuranceTypeDocumentRequirementsResponseError = (getApiCrmInsuranceTypeDocumentRequirementsResponse401) & {
  headers: Headers;
};

export type getApiCrmInsuranceTypeDocumentRequirementsResponse = (getApiCrmInsuranceTypeDocumentRequirementsResponseSuccess | getApiCrmInsuranceTypeDocumentRequirementsResponseError)

export const getGetApiCrmInsuranceTypeDocumentRequirementsUrl = (params?: GetApiCrmInsuranceTypeDocumentRequirementsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/crm/insurance-type-document-requirements?${stringifiedParams}` : `/api/crm/insurance-type-document-requirements`
}

export const getApiCrmInsuranceTypeDocumentRequirements = async (params?: GetApiCrmInsuranceTypeDocumentRequirementsParams, options?: RequestInit): Promise<getApiCrmInsuranceTypeDocumentRequirementsResponse> => {

  return fetcher<getApiCrmInsuranceTypeDocumentRequirementsResponse>(getGetApiCrmInsuranceTypeDocumentRequirementsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiCrmLobDocumentRequirementsResponse200 = {
  data: void
  status: 200
}

export type getApiCrmLobDocumentRequirementsResponse401 = {
  data: GetApiCrmLobDocumentRequirements401
  status: 401
}

export type getApiCrmLobDocumentRequirementsResponseSuccess = (getApiCrmLobDocumentRequirementsResponse200) & {
  headers: Headers;
};
export type getApiCrmLobDocumentRequirementsResponseError = (getApiCrmLobDocumentRequirementsResponse401) & {
  headers: Headers;
};

export type getApiCrmLobDocumentRequirementsResponse = (getApiCrmLobDocumentRequirementsResponseSuccess | getApiCrmLobDocumentRequirementsResponseError)

export const getGetApiCrmLobDocumentRequirementsUrl = (params?: GetApiCrmLobDocumentRequirementsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/crm/lob-document-requirements?${stringifiedParams}` : `/api/crm/lob-document-requirements`
}

export const getApiCrmLobDocumentRequirements = async (params?: GetApiCrmLobDocumentRequirementsParams, options?: RequestInit): Promise<getApiCrmLobDocumentRequirementsResponse> => {

  return fetcher<getApiCrmLobDocumentRequirementsResponse>(getGetApiCrmLobDocumentRequirementsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiCrmNaicsCodesResponse200 = {
  data: void
  status: 200
}

export type getApiCrmNaicsCodesResponse401 = {
  data: GetApiCrmNaicsCodes401
  status: 401
}

export type getApiCrmNaicsCodesResponseSuccess = (getApiCrmNaicsCodesResponse200) & {
  headers: Headers;
};
export type getApiCrmNaicsCodesResponseError = (getApiCrmNaicsCodesResponse401) & {
  headers: Headers;
};

export type getApiCrmNaicsCodesResponse = (getApiCrmNaicsCodesResponseSuccess | getApiCrmNaicsCodesResponseError)

export const getGetApiCrmNaicsCodesUrl = (params?: GetApiCrmNaicsCodesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/crm/naics-codes?${stringifiedParams}` : `/api/crm/naics-codes`
}

export const getApiCrmNaicsCodes = async (params?: GetApiCrmNaicsCodesParams, options?: RequestInit): Promise<getApiCrmNaicsCodesResponse> => {

  return fetcher<getApiCrmNaicsCodesResponse>(getGetApiCrmNaicsCodesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiCrmSicCodesResponse200 = {
  data: void
  status: 200
}

export type getApiCrmSicCodesResponse401 = {
  data: GetApiCrmSicCodes401
  status: 401
}

export type getApiCrmSicCodesResponseSuccess = (getApiCrmSicCodesResponse200) & {
  headers: Headers;
};
export type getApiCrmSicCodesResponseError = (getApiCrmSicCodesResponse401) & {
  headers: Headers;
};

export type getApiCrmSicCodesResponse = (getApiCrmSicCodesResponseSuccess | getApiCrmSicCodesResponseError)

export const getGetApiCrmSicCodesUrl = (params?: GetApiCrmSicCodesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/crm/sic-codes?${stringifiedParams}` : `/api/crm/sic-codes`
}

export const getApiCrmSicCodes = async (params?: GetApiCrmSicCodesParams, options?: RequestInit): Promise<getApiCrmSicCodesResponse> => {

  return fetcher<getApiCrmSicCodesResponse>(getGetApiCrmSicCodesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiCrmNaicCarriersResponse200 = {
  data: void
  status: 200
}

export type getApiCrmNaicCarriersResponse401 = {
  data: GetApiCrmNaicCarriers401
  status: 401
}

export type getApiCrmNaicCarriersResponseSuccess = (getApiCrmNaicCarriersResponse200) & {
  headers: Headers;
};
export type getApiCrmNaicCarriersResponseError = (getApiCrmNaicCarriersResponse401) & {
  headers: Headers;
};

export type getApiCrmNaicCarriersResponse = (getApiCrmNaicCarriersResponseSuccess | getApiCrmNaicCarriersResponseError)

export const getGetApiCrmNaicCarriersUrl = (params?: GetApiCrmNaicCarriersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/crm/naic-carriers?${stringifiedParams}` : `/api/crm/naic-carriers`
}

export const getApiCrmNaicCarriers = async (params?: GetApiCrmNaicCarriersParams, options?: RequestInit): Promise<getApiCrmNaicCarriersResponse> => {

  return fetcher<getApiCrmNaicCarriersResponse>(getGetApiCrmNaicCarriersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiCrmQuoteStatusCodesResponse200 = {
  data: void
  status: 200
}

export type getApiCrmQuoteStatusCodesResponse401 = {
  data: GetApiCrmQuoteStatusCodes401
  status: 401
}

export type getApiCrmQuoteStatusCodesResponseSuccess = (getApiCrmQuoteStatusCodesResponse200) & {
  headers: Headers;
};
export type getApiCrmQuoteStatusCodesResponseError = (getApiCrmQuoteStatusCodesResponse401) & {
  headers: Headers;
};

export type getApiCrmQuoteStatusCodesResponse = (getApiCrmQuoteStatusCodesResponseSuccess | getApiCrmQuoteStatusCodesResponseError)

export const getGetApiCrmQuoteStatusCodesUrl = () => {




  return `/api/crm/quote-status-codes`
}

export const getApiCrmQuoteStatusCodes = async ( options?: RequestInit): Promise<getApiCrmQuoteStatusCodesResponse> => {

  return fetcher<getApiCrmQuoteStatusCodesResponse>(getGetApiCrmQuoteStatusCodesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiCrmCertificateTypesResponse200 = {
  data: void
  status: 200
}

export type getApiCrmCertificateTypesResponse401 = {
  data: GetApiCrmCertificateTypes401
  status: 401
}

export type getApiCrmCertificateTypesResponseSuccess = (getApiCrmCertificateTypesResponse200) & {
  headers: Headers;
};
export type getApiCrmCertificateTypesResponseError = (getApiCrmCertificateTypesResponse401) & {
  headers: Headers;
};

export type getApiCrmCertificateTypesResponse = (getApiCrmCertificateTypesResponseSuccess | getApiCrmCertificateTypesResponseError)

export const getGetApiCrmCertificateTypesUrl = () => {




  return `/api/crm/certificate-types`
}

export const getApiCrmCertificateTypes = async ( options?: RequestInit): Promise<getApiCrmCertificateTypesResponse> => {

  return fetcher<getApiCrmCertificateTypesResponse>(getGetApiCrmCertificateTypesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiCrmEndorsementTypesResponse200 = {
  data: void
  status: 200
}

export type getApiCrmEndorsementTypesResponse401 = {
  data: GetApiCrmEndorsementTypes401
  status: 401
}

export type getApiCrmEndorsementTypesResponseSuccess = (getApiCrmEndorsementTypesResponse200) & {
  headers: Headers;
};
export type getApiCrmEndorsementTypesResponseError = (getApiCrmEndorsementTypesResponse401) & {
  headers: Headers;
};

export type getApiCrmEndorsementTypesResponse = (getApiCrmEndorsementTypesResponseSuccess | getApiCrmEndorsementTypesResponseError)

export const getGetApiCrmEndorsementTypesUrl = () => {




  return `/api/crm/endorsement-types`
}

export const getApiCrmEndorsementTypes = async ( options?: RequestInit): Promise<getApiCrmEndorsementTypesResponse> => {

  return fetcher<getApiCrmEndorsementTypesResponse>(getGetApiCrmEndorsementTypesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiCrmCensusCountyBusinessPatternsResponse200 = {
  data: void
  status: 200
}

export type getApiCrmCensusCountyBusinessPatternsResponse401 = {
  data: GetApiCrmCensusCountyBusinessPatterns401
  status: 401
}

export type getApiCrmCensusCountyBusinessPatternsResponseSuccess = (getApiCrmCensusCountyBusinessPatternsResponse200) & {
  headers: Headers;
};
export type getApiCrmCensusCountyBusinessPatternsResponseError = (getApiCrmCensusCountyBusinessPatternsResponse401) & {
  headers: Headers;
};

export type getApiCrmCensusCountyBusinessPatternsResponse = (getApiCrmCensusCountyBusinessPatternsResponseSuccess | getApiCrmCensusCountyBusinessPatternsResponseError)

export const getGetApiCrmCensusCountyBusinessPatternsUrl = (params?: GetApiCrmCensusCountyBusinessPatternsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/crm/census/county-business-patterns?${stringifiedParams}` : `/api/crm/census/county-business-patterns`
}

export const getApiCrmCensusCountyBusinessPatterns = async (params?: GetApiCrmCensusCountyBusinessPatternsParams, options?: RequestInit): Promise<getApiCrmCensusCountyBusinessPatternsResponse> => {

  return fetcher<getApiCrmCensusCountyBusinessPatternsResponse>(getGetApiCrmCensusCountyBusinessPatternsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiCrmCensusZipBusinessPatternsResponse200 = {
  data: void
  status: 200
}

export type getApiCrmCensusZipBusinessPatternsResponse401 = {
  data: GetApiCrmCensusZipBusinessPatterns401
  status: 401
}

export type getApiCrmCensusZipBusinessPatternsResponseSuccess = (getApiCrmCensusZipBusinessPatternsResponse200) & {
  headers: Headers;
};
export type getApiCrmCensusZipBusinessPatternsResponseError = (getApiCrmCensusZipBusinessPatternsResponse401) & {
  headers: Headers;
};

export type getApiCrmCensusZipBusinessPatternsResponse = (getApiCrmCensusZipBusinessPatternsResponseSuccess | getApiCrmCensusZipBusinessPatternsResponseError)

export const getGetApiCrmCensusZipBusinessPatternsUrl = (params?: GetApiCrmCensusZipBusinessPatternsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/crm/census/zip-business-patterns?${stringifiedParams}` : `/api/crm/census/zip-business-patterns`
}

export const getApiCrmCensusZipBusinessPatterns = async (params?: GetApiCrmCensusZipBusinessPatternsParams, options?: RequestInit): Promise<getApiCrmCensusZipBusinessPatternsResponse> => {

  return fetcher<getApiCrmCensusZipBusinessPatternsResponse>(getGetApiCrmCensusZipBusinessPatternsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiCrmCensusBdsTimeseriesResponse200 = {
  data: void
  status: 200
}

export type getApiCrmCensusBdsTimeseriesResponse401 = {
  data: GetApiCrmCensusBdsTimeseries401
  status: 401
}

export type getApiCrmCensusBdsTimeseriesResponseSuccess = (getApiCrmCensusBdsTimeseriesResponse200) & {
  headers: Headers;
};
export type getApiCrmCensusBdsTimeseriesResponseError = (getApiCrmCensusBdsTimeseriesResponse401) & {
  headers: Headers;
};

export type getApiCrmCensusBdsTimeseriesResponse = (getApiCrmCensusBdsTimeseriesResponseSuccess | getApiCrmCensusBdsTimeseriesResponseError)

export const getGetApiCrmCensusBdsTimeseriesUrl = (params?: GetApiCrmCensusBdsTimeseriesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/crm/census/bds-timeseries?${stringifiedParams}` : `/api/crm/census/bds-timeseries`
}

export const getApiCrmCensusBdsTimeseries = async (params?: GetApiCrmCensusBdsTimeseriesParams, options?: RequestInit): Promise<getApiCrmCensusBdsTimeseriesResponse> => {

  return fetcher<getApiCrmCensusBdsTimeseriesResponse>(getGetApiCrmCensusBdsTimeseriesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiCrmCensusSusbResponse200 = {
  data: void
  status: 200
}

export type getApiCrmCensusSusbResponse401 = {
  data: GetApiCrmCensusSusb401
  status: 401
}

export type getApiCrmCensusSusbResponseSuccess = (getApiCrmCensusSusbResponse200) & {
  headers: Headers;
};
export type getApiCrmCensusSusbResponseError = (getApiCrmCensusSusbResponse401) & {
  headers: Headers;
};

export type getApiCrmCensusSusbResponse = (getApiCrmCensusSusbResponseSuccess | getApiCrmCensusSusbResponseError)

export const getGetApiCrmCensusSusbUrl = (params?: GetApiCrmCensusSusbParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/crm/census/susb?${stringifiedParams}` : `/api/crm/census/susb`
}

export const getApiCrmCensusSusb = async (params?: GetApiCrmCensusSusbParams, options?: RequestInit): Promise<getApiCrmCensusSusbResponse> => {

  return fetcher<getApiCrmCensusSusbResponse>(getGetApiCrmCensusSusbUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiCrmCountryCodesResponse200 = {
  data: void
  status: 200
}

export type getApiCrmCountryCodesResponse401 = {
  data: GetApiCrmCountryCodes401
  status: 401
}

export type getApiCrmCountryCodesResponseSuccess = (getApiCrmCountryCodesResponse200) & {
  headers: Headers;
};
export type getApiCrmCountryCodesResponseError = (getApiCrmCountryCodesResponse401) & {
  headers: Headers;
};

export type getApiCrmCountryCodesResponse = (getApiCrmCountryCodesResponseSuccess | getApiCrmCountryCodesResponseError)

export const getGetApiCrmCountryCodesUrl = () => {




  return `/api/crm/country-codes`
}

export const getApiCrmCountryCodes = async ( options?: RequestInit): Promise<getApiCrmCountryCodesResponse> => {

  return fetcher<getApiCrmCountryCodesResponse>(getGetApiCrmCountryCodesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiCrmStateProvinceCodesResponse200 = {
  data: void
  status: 200
}

export type getApiCrmStateProvinceCodesResponse401 = {
  data: GetApiCrmStateProvinceCodes401
  status: 401
}

export type getApiCrmStateProvinceCodesResponseSuccess = (getApiCrmStateProvinceCodesResponse200) & {
  headers: Headers;
};
export type getApiCrmStateProvinceCodesResponseError = (getApiCrmStateProvinceCodesResponse401) & {
  headers: Headers;
};

export type getApiCrmStateProvinceCodesResponse = (getApiCrmStateProvinceCodesResponseSuccess | getApiCrmStateProvinceCodesResponseError)

export const getGetApiCrmStateProvinceCodesUrl = (params?: GetApiCrmStateProvinceCodesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/crm/state-province-codes?${stringifiedParams}` : `/api/crm/state-province-codes`
}

export const getApiCrmStateProvinceCodes = async (params?: GetApiCrmStateProvinceCodesParams, options?: RequestInit): Promise<getApiCrmStateProvinceCodesResponse> => {

  return fetcher<getApiCrmStateProvinceCodesResponse>(getGetApiCrmStateProvinceCodesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiCrmCurrencyCodesResponse200 = {
  data: void
  status: 200
}

export type getApiCrmCurrencyCodesResponse401 = {
  data: GetApiCrmCurrencyCodes401
  status: 401
}

export type getApiCrmCurrencyCodesResponseSuccess = (getApiCrmCurrencyCodesResponse200) & {
  headers: Headers;
};
export type getApiCrmCurrencyCodesResponseError = (getApiCrmCurrencyCodesResponse401) & {
  headers: Headers;
};

export type getApiCrmCurrencyCodesResponse = (getApiCrmCurrencyCodesResponseSuccess | getApiCrmCurrencyCodesResponseError)

export const getGetApiCrmCurrencyCodesUrl = () => {




  return `/api/crm/currency-codes`
}

export const getApiCrmCurrencyCodes = async ( options?: RequestInit): Promise<getApiCrmCurrencyCodesResponse> => {

  return fetcher<getApiCrmCurrencyCodesResponse>(getGetApiCrmCurrencyCodesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiCrmCoverageLibraryResponse200 = {
  data: void
  status: 200
}

export type getApiCrmCoverageLibraryResponse401 = {
  data: GetApiCrmCoverageLibrary401
  status: 401
}

export type getApiCrmCoverageLibraryResponseSuccess = (getApiCrmCoverageLibraryResponse200) & {
  headers: Headers;
};
export type getApiCrmCoverageLibraryResponseError = (getApiCrmCoverageLibraryResponse401) & {
  headers: Headers;
};

export type getApiCrmCoverageLibraryResponse = (getApiCrmCoverageLibraryResponseSuccess | getApiCrmCoverageLibraryResponseError)

export const getGetApiCrmCoverageLibraryUrl = (params?: GetApiCrmCoverageLibraryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/crm/coverage-library?${stringifiedParams}` : `/api/crm/coverage-library`
}

export const getApiCrmCoverageLibrary = async (params?: GetApiCrmCoverageLibraryParams, options?: RequestInit): Promise<getApiCrmCoverageLibraryResponse> => {

  return fetcher<getApiCrmCoverageLibraryResponse>(getGetApiCrmCoverageLibraryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiCrmCoverageTypesResponse200 = {
  data: void
  status: 200
}

export type getApiCrmCoverageTypesResponse401 = {
  data: GetApiCrmCoverageTypes401
  status: 401
}

export type getApiCrmCoverageTypesResponseSuccess = (getApiCrmCoverageTypesResponse200) & {
  headers: Headers;
};
export type getApiCrmCoverageTypesResponseError = (getApiCrmCoverageTypesResponse401) & {
  headers: Headers;
};

export type getApiCrmCoverageTypesResponse = (getApiCrmCoverageTypesResponseSuccess | getApiCrmCoverageTypesResponseError)

export const getGetApiCrmCoverageTypesUrl = () => {




  return `/api/crm/coverage-types`
}

export const getApiCrmCoverageTypes = async ( options?: RequestInit): Promise<getApiCrmCoverageTypesResponse> => {

  return fetcher<getApiCrmCoverageTypesResponse>(getGetApiCrmCoverageTypesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiCrmOpportunityTypeCodesResponse200 = {
  data: void
  status: 200
}

export type getApiCrmOpportunityTypeCodesResponse401 = {
  data: GetApiCrmOpportunityTypeCodes401
  status: 401
}

export type getApiCrmOpportunityTypeCodesResponseSuccess = (getApiCrmOpportunityTypeCodesResponse200) & {
  headers: Headers;
};
export type getApiCrmOpportunityTypeCodesResponseError = (getApiCrmOpportunityTypeCodesResponse401) & {
  headers: Headers;
};

export type getApiCrmOpportunityTypeCodesResponse = (getApiCrmOpportunityTypeCodesResponseSuccess | getApiCrmOpportunityTypeCodesResponseError)

export const getGetApiCrmOpportunityTypeCodesUrl = () => {




  return `/api/crm/opportunity-type-codes`
}

export const getApiCrmOpportunityTypeCodes = async ( options?: RequestInit): Promise<getApiCrmOpportunityTypeCodesResponse> => {

  return fetcher<getApiCrmOpportunityTypeCodesResponse>(getGetApiCrmOpportunityTypeCodesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiCrmOpportunityStageCodesResponse200 = {
  data: void
  status: 200
}

export type getApiCrmOpportunityStageCodesResponse401 = {
  data: GetApiCrmOpportunityStageCodes401
  status: 401
}

export type getApiCrmOpportunityStageCodesResponseSuccess = (getApiCrmOpportunityStageCodesResponse200) & {
  headers: Headers;
};
export type getApiCrmOpportunityStageCodesResponseError = (getApiCrmOpportunityStageCodesResponse401) & {
  headers: Headers;
};

export type getApiCrmOpportunityStageCodesResponse = (getApiCrmOpportunityStageCodesResponseSuccess | getApiCrmOpportunityStageCodesResponseError)

export const getGetApiCrmOpportunityStageCodesUrl = () => {




  return `/api/crm/opportunity-stage-codes`
}

export const getApiCrmOpportunityStageCodes = async ( options?: RequestInit): Promise<getApiCrmOpportunityStageCodesResponse> => {

  return fetcher<getApiCrmOpportunityStageCodesResponse>(getGetApiCrmOpportunityStageCodesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdCrmPartiesPartyIdDocumentsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmPartiesPartyIdDocumentsResponse401 = {
  data: GetApiTeamsTeamIdCrmPartiesPartyIdDocuments401
  status: 401
}

export type getApiTeamsTeamIdCrmPartiesPartyIdDocumentsResponseSuccess = (getApiTeamsTeamIdCrmPartiesPartyIdDocumentsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmPartiesPartyIdDocumentsResponseError = (getApiTeamsTeamIdCrmPartiesPartyIdDocumentsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmPartiesPartyIdDocumentsResponse = (getApiTeamsTeamIdCrmPartiesPartyIdDocumentsResponseSuccess | getApiTeamsTeamIdCrmPartiesPartyIdDocumentsResponseError)

export const getGetApiTeamsTeamIdCrmPartiesPartyIdDocumentsUrl = (teamId: string,
    partyId: string,) => {




  return `/api/teams/${teamId}/crm/parties/${partyId}/documents`
}

export const getApiTeamsTeamIdCrmPartiesPartyIdDocuments = async (teamId: string,
    partyId: string, options?: RequestInit): Promise<getApiTeamsTeamIdCrmPartiesPartyIdDocumentsResponse> => {

  return fetcher<getApiTeamsTeamIdCrmPartiesPartyIdDocumentsResponse>(getGetApiTeamsTeamIdCrmPartiesPartyIdDocumentsUrl(teamId,partyId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdCrmPartiesPartyIdDocumentsResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmPartiesPartyIdDocumentsResponse401 = {
  data: PostApiTeamsTeamIdCrmPartiesPartyIdDocuments401
  status: 401
}

export type postApiTeamsTeamIdCrmPartiesPartyIdDocumentsResponse402 = {
  data: PostApiTeamsTeamIdCrmPartiesPartyIdDocuments402
  status: 402
}

export type postApiTeamsTeamIdCrmPartiesPartyIdDocumentsResponseSuccess = (postApiTeamsTeamIdCrmPartiesPartyIdDocumentsResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmPartiesPartyIdDocumentsResponseError = (postApiTeamsTeamIdCrmPartiesPartyIdDocumentsResponse401 | postApiTeamsTeamIdCrmPartiesPartyIdDocumentsResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmPartiesPartyIdDocumentsResponse = (postApiTeamsTeamIdCrmPartiesPartyIdDocumentsResponseSuccess | postApiTeamsTeamIdCrmPartiesPartyIdDocumentsResponseError)

export const getPostApiTeamsTeamIdCrmPartiesPartyIdDocumentsUrl = (teamId: string,
    partyId: string,) => {




  return `/api/teams/${teamId}/crm/parties/${partyId}/documents`
}

export const postApiTeamsTeamIdCrmPartiesPartyIdDocuments = async (teamId: string,
    partyId: string,
    postApiTeamsTeamIdCrmPartiesPartyIdDocumentsBody: PostApiTeamsTeamIdCrmPartiesPartyIdDocumentsBody, options?: RequestInit): Promise<postApiTeamsTeamIdCrmPartiesPartyIdDocumentsResponse> => {
    const formData = new FormData();
if(postApiTeamsTeamIdCrmPartiesPartyIdDocumentsBody.file !== undefined) {
 formData.append(`file`, postApiTeamsTeamIdCrmPartiesPartyIdDocumentsBody.file);
 }

if(postApiTeamsTeamIdCrmPartiesPartyIdDocumentsBody.FileName !== undefined) {
 formData.append(`FileName`, postApiTeamsTeamIdCrmPartiesPartyIdDocumentsBody.FileName);
 }
if(postApiTeamsTeamIdCrmPartiesPartyIdDocumentsBody.Description !== undefined) {
 formData.append(`Description`, postApiTeamsTeamIdCrmPartiesPartyIdDocumentsBody.Description);
 }
if(postApiTeamsTeamIdCrmPartiesPartyIdDocumentsBody.LinkType !== undefined) {
 formData.append(`LinkType`, postApiTeamsTeamIdCrmPartiesPartyIdDocumentsBody.LinkType);
 }
if(postApiTeamsTeamIdCrmPartiesPartyIdDocumentsBody.Notes !== undefined) {
 formData.append(`Notes`, postApiTeamsTeamIdCrmPartiesPartyIdDocumentsBody.Notes);
 }

  return fetcher<postApiTeamsTeamIdCrmPartiesPartyIdDocumentsResponse>(getPostApiTeamsTeamIdCrmPartiesPartyIdDocumentsUrl(teamId,partyId),
  {
    ...options,
    method: 'POST'
    ,
    body:
      formData,
  }
);}



export type postApiTeamsTeamIdCrmPartiesPartyIdDocumentsAttachResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmPartiesPartyIdDocumentsAttachResponse401 = {
  data: PostApiTeamsTeamIdCrmPartiesPartyIdDocumentsAttach401
  status: 401
}

export type postApiTeamsTeamIdCrmPartiesPartyIdDocumentsAttachResponse402 = {
  data: PostApiTeamsTeamIdCrmPartiesPartyIdDocumentsAttach402
  status: 402
}

export type postApiTeamsTeamIdCrmPartiesPartyIdDocumentsAttachResponseSuccess = (postApiTeamsTeamIdCrmPartiesPartyIdDocumentsAttachResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmPartiesPartyIdDocumentsAttachResponseError = (postApiTeamsTeamIdCrmPartiesPartyIdDocumentsAttachResponse401 | postApiTeamsTeamIdCrmPartiesPartyIdDocumentsAttachResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmPartiesPartyIdDocumentsAttachResponse = (postApiTeamsTeamIdCrmPartiesPartyIdDocumentsAttachResponseSuccess | postApiTeamsTeamIdCrmPartiesPartyIdDocumentsAttachResponseError)

export const getPostApiTeamsTeamIdCrmPartiesPartyIdDocumentsAttachUrl = (teamId: string,
    partyId: string,) => {




  return `/api/teams/${teamId}/crm/parties/${partyId}/documents/attach`
}

export const postApiTeamsTeamIdCrmPartiesPartyIdDocumentsAttach = async (teamId: string,
    partyId: string,
    nullAttachCrmDocumentRequest: null | AttachCrmDocumentRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmPartiesPartyIdDocumentsAttachResponse> => {

  return fetcher<postApiTeamsTeamIdCrmPartiesPartyIdDocumentsAttachResponse>(getPostApiTeamsTeamIdCrmPartiesPartyIdDocumentsAttachUrl(teamId,partyId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullAttachCrmDocumentRequest,)
  }
);}



export type getApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsResponse401 = {
  data: GetApiTeamsTeamIdCrmPoliciesPolicyIdDocuments401
  status: 401
}

export type getApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsResponseSuccess = (getApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsResponseError = (getApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsResponse = (getApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsResponseSuccess | getApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsResponseError)

export const getGetApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsUrl = (teamId: string,
    policyId: string,) => {




  return `/api/teams/${teamId}/crm/policies/${policyId}/documents`
}

export const getApiTeamsTeamIdCrmPoliciesPolicyIdDocuments = async (teamId: string,
    policyId: string, options?: RequestInit): Promise<getApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsResponse> => {

  return fetcher<getApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsResponse>(getGetApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsUrl(teamId,policyId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsResponse401 = {
  data: PostApiTeamsTeamIdCrmPoliciesPolicyIdDocuments401
  status: 401
}

export type postApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsResponse402 = {
  data: PostApiTeamsTeamIdCrmPoliciesPolicyIdDocuments402
  status: 402
}

export type postApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsResponseSuccess = (postApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsResponseError = (postApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsResponse401 | postApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsResponse = (postApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsResponseSuccess | postApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsResponseError)

export const getPostApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsUrl = (teamId: string,
    policyId: string,) => {




  return `/api/teams/${teamId}/crm/policies/${policyId}/documents`
}

export const postApiTeamsTeamIdCrmPoliciesPolicyIdDocuments = async (teamId: string,
    policyId: string,
    postApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsBody: PostApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsBody, options?: RequestInit): Promise<postApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsResponse> => {
    const formData = new FormData();
if(postApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsBody.file !== undefined) {
 formData.append(`file`, postApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsBody.file);
 }

if(postApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsBody.FileName !== undefined) {
 formData.append(`FileName`, postApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsBody.FileName);
 }
if(postApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsBody.Description !== undefined) {
 formData.append(`Description`, postApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsBody.Description);
 }
if(postApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsBody.LinkType !== undefined) {
 formData.append(`LinkType`, postApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsBody.LinkType);
 }
if(postApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsBody.Notes !== undefined) {
 formData.append(`Notes`, postApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsBody.Notes);
 }

  return fetcher<postApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsResponse>(getPostApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsUrl(teamId,policyId),
  {
    ...options,
    method: 'POST'
    ,
    body:
      formData,
  }
);}



export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsResponse401 = {
  data: GetApiTeamsTeamIdCrmSubmissionsSubmissionIdDocuments401
  status: 401
}

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsResponseSuccess = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsResponseError = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsResponse = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsResponseSuccess | getApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsResponseError)

export const getGetApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsUrl = (teamId: string,
    submissionId: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${submissionId}/documents`
}

export const getApiTeamsTeamIdCrmSubmissionsSubmissionIdDocuments = async (teamId: string,
    submissionId: string, options?: RequestInit): Promise<getApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsResponse> => {

  return fetcher<getApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsResponse>(getGetApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsUrl(teamId,submissionId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsResponse401 = {
  data: PostApiTeamsTeamIdCrmSubmissionsSubmissionIdDocuments401
  status: 401
}

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsResponse402 = {
  data: PostApiTeamsTeamIdCrmSubmissionsSubmissionIdDocuments402
  status: 402
}

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsResponseSuccess = (postApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsResponseError = (postApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsResponse401 | postApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsResponse = (postApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsResponseSuccess | postApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsResponseError)

export const getPostApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsUrl = (teamId: string,
    submissionId: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${submissionId}/documents`
}

export const postApiTeamsTeamIdCrmSubmissionsSubmissionIdDocuments = async (teamId: string,
    submissionId: string,
    postApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsBody: PostApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsBody, options?: RequestInit): Promise<postApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsResponse> => {
    const formData = new FormData();
if(postApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsBody.file !== undefined) {
 formData.append(`file`, postApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsBody.file);
 }

if(postApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsBody.FileName !== undefined) {
 formData.append(`FileName`, postApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsBody.FileName);
 }
if(postApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsBody.Description !== undefined) {
 formData.append(`Description`, postApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsBody.Description);
 }
if(postApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsBody.LinkType !== undefined) {
 formData.append(`LinkType`, postApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsBody.LinkType);
 }
if(postApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsBody.Notes !== undefined) {
 formData.append(`Notes`, postApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsBody.Notes);
 }

  return fetcher<postApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsResponse>(getPostApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsUrl(teamId,submissionId),
  {
    ...options,
    method: 'POST'
    ,
    body:
      formData,
  }
);}



export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsAttachResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsAttachResponse401 = {
  data: PostApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsAttach401
  status: 401
}

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsAttachResponse402 = {
  data: PostApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsAttach402
  status: 402
}

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsAttachResponseSuccess = (postApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsAttachResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsAttachResponseError = (postApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsAttachResponse401 | postApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsAttachResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsAttachResponse = (postApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsAttachResponseSuccess | postApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsAttachResponseError)

export const getPostApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsAttachUrl = (teamId: string,
    submissionId: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${submissionId}/documents/attach`
}

export const postApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsAttach = async (teamId: string,
    submissionId: string,
    nullAttachCrmDocumentRequest: null | AttachCrmDocumentRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsAttachResponse> => {

  return fetcher<postApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsAttachResponse>(getPostApiTeamsTeamIdCrmSubmissionsSubmissionIdDocumentsAttachUrl(teamId,submissionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullAttachCrmDocumentRequest,)
  }
);}



export type postApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsAttachResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsAttachResponse401 = {
  data: PostApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsAttach401
  status: 401
}

export type postApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsAttachResponse402 = {
  data: PostApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsAttach402
  status: 402
}

export type postApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsAttachResponseSuccess = (postApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsAttachResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsAttachResponseError = (postApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsAttachResponse401 | postApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsAttachResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsAttachResponse = (postApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsAttachResponseSuccess | postApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsAttachResponseError)

export const getPostApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsAttachUrl = (teamId: string,
    policyId: string,) => {




  return `/api/teams/${teamId}/crm/policies/${policyId}/documents/attach`
}

export const postApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsAttach = async (teamId: string,
    policyId: string,
    nullAttachCrmDocumentRequest: null | AttachCrmDocumentRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsAttachResponse> => {

  return fetcher<postApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsAttachResponse>(getPostApiTeamsTeamIdCrmPoliciesPolicyIdDocumentsAttachUrl(teamId,policyId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullAttachCrmDocumentRequest,)
  }
);}



export type postApiTeamsTeamIdCrmClientAccountsClientAccountIdPolicyDocumentImportsResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmClientAccountsClientAccountIdPolicyDocumentImportsResponse401 = {
  data: PostApiTeamsTeamIdCrmClientAccountsClientAccountIdPolicyDocumentImports401
  status: 401
}

export type postApiTeamsTeamIdCrmClientAccountsClientAccountIdPolicyDocumentImportsResponse402 = {
  data: PostApiTeamsTeamIdCrmClientAccountsClientAccountIdPolicyDocumentImports402
  status: 402
}

export type postApiTeamsTeamIdCrmClientAccountsClientAccountIdPolicyDocumentImportsResponseSuccess = (postApiTeamsTeamIdCrmClientAccountsClientAccountIdPolicyDocumentImportsResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmClientAccountsClientAccountIdPolicyDocumentImportsResponseError = (postApiTeamsTeamIdCrmClientAccountsClientAccountIdPolicyDocumentImportsResponse401 | postApiTeamsTeamIdCrmClientAccountsClientAccountIdPolicyDocumentImportsResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmClientAccountsClientAccountIdPolicyDocumentImportsResponse = (postApiTeamsTeamIdCrmClientAccountsClientAccountIdPolicyDocumentImportsResponseSuccess | postApiTeamsTeamIdCrmClientAccountsClientAccountIdPolicyDocumentImportsResponseError)

export const getPostApiTeamsTeamIdCrmClientAccountsClientAccountIdPolicyDocumentImportsUrl = (teamId: string,
    clientAccountId: string,) => {




  return `/api/teams/${teamId}/crm/client-accounts/${clientAccountId}/policy-document-imports`
}

export const postApiTeamsTeamIdCrmClientAccountsClientAccountIdPolicyDocumentImports = async (teamId: string,
    clientAccountId: string,
    postApiTeamsTeamIdCrmClientAccountsClientAccountIdPolicyDocumentImportsBody: PostApiTeamsTeamIdCrmClientAccountsClientAccountIdPolicyDocumentImportsBody, options?: RequestInit): Promise<postApiTeamsTeamIdCrmClientAccountsClientAccountIdPolicyDocumentImportsResponse> => {
    const formData = new FormData();
if(postApiTeamsTeamIdCrmClientAccountsClientAccountIdPolicyDocumentImportsBody.file !== undefined) {
 formData.append(`file`, postApiTeamsTeamIdCrmClientAccountsClientAccountIdPolicyDocumentImportsBody.file);
 }

  return fetcher<postApiTeamsTeamIdCrmClientAccountsClientAccountIdPolicyDocumentImportsResponse>(getPostApiTeamsTeamIdCrmClientAccountsClientAccountIdPolicyDocumentImportsUrl(teamId,clientAccountId),
  {
    ...options,
    method: 'POST'
    ,
    body:
      formData,
  }
);}



export type getApiTeamsTeamIdCrmClientAccountsClientAccountIdPolicyDocumentImportsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmClientAccountsClientAccountIdPolicyDocumentImportsResponse401 = {
  data: GetApiTeamsTeamIdCrmClientAccountsClientAccountIdPolicyDocumentImports401
  status: 401
}

export type getApiTeamsTeamIdCrmClientAccountsClientAccountIdPolicyDocumentImportsResponseSuccess = (getApiTeamsTeamIdCrmClientAccountsClientAccountIdPolicyDocumentImportsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmClientAccountsClientAccountIdPolicyDocumentImportsResponseError = (getApiTeamsTeamIdCrmClientAccountsClientAccountIdPolicyDocumentImportsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmClientAccountsClientAccountIdPolicyDocumentImportsResponse = (getApiTeamsTeamIdCrmClientAccountsClientAccountIdPolicyDocumentImportsResponseSuccess | getApiTeamsTeamIdCrmClientAccountsClientAccountIdPolicyDocumentImportsResponseError)

export const getGetApiTeamsTeamIdCrmClientAccountsClientAccountIdPolicyDocumentImportsUrl = (teamId: string,
    clientAccountId: string,) => {




  return `/api/teams/${teamId}/crm/client-accounts/${clientAccountId}/policy-document-imports`
}

export const getApiTeamsTeamIdCrmClientAccountsClientAccountIdPolicyDocumentImports = async (teamId: string,
    clientAccountId: string, options?: RequestInit): Promise<getApiTeamsTeamIdCrmClientAccountsClientAccountIdPolicyDocumentImportsResponse> => {

  return fetcher<getApiTeamsTeamIdCrmClientAccountsClientAccountIdPolicyDocumentImportsResponse>(getGetApiTeamsTeamIdCrmClientAccountsClientAccountIdPolicyDocumentImportsUrl(teamId,clientAccountId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdCrmPolicyDocumentImportsPolicyDocumentImportRunIdResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmPolicyDocumentImportsPolicyDocumentImportRunIdResponse401 = {
  data: GetApiTeamsTeamIdCrmPolicyDocumentImportsPolicyDocumentImportRunId401
  status: 401
}

export type getApiTeamsTeamIdCrmPolicyDocumentImportsPolicyDocumentImportRunIdResponseSuccess = (getApiTeamsTeamIdCrmPolicyDocumentImportsPolicyDocumentImportRunIdResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmPolicyDocumentImportsPolicyDocumentImportRunIdResponseError = (getApiTeamsTeamIdCrmPolicyDocumentImportsPolicyDocumentImportRunIdResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmPolicyDocumentImportsPolicyDocumentImportRunIdResponse = (getApiTeamsTeamIdCrmPolicyDocumentImportsPolicyDocumentImportRunIdResponseSuccess | getApiTeamsTeamIdCrmPolicyDocumentImportsPolicyDocumentImportRunIdResponseError)

export const getGetApiTeamsTeamIdCrmPolicyDocumentImportsPolicyDocumentImportRunIdUrl = (teamId: string,
    policyDocumentImportRunId: string,) => {




  return `/api/teams/${teamId}/crm/policy-document-imports/${policyDocumentImportRunId}`
}

export const getApiTeamsTeamIdCrmPolicyDocumentImportsPolicyDocumentImportRunId = async (teamId: string,
    policyDocumentImportRunId: string, options?: RequestInit): Promise<getApiTeamsTeamIdCrmPolicyDocumentImportsPolicyDocumentImportRunIdResponse> => {

  return fetcher<getApiTeamsTeamIdCrmPolicyDocumentImportsPolicyDocumentImportRunIdResponse>(getGetApiTeamsTeamIdCrmPolicyDocumentImportsPolicyDocumentImportRunIdUrl(teamId,policyDocumentImportRunId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdCrmPolicyDocumentImportsPolicyDocumentImportRunIdApproveResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmPolicyDocumentImportsPolicyDocumentImportRunIdApproveResponse401 = {
  data: PostApiTeamsTeamIdCrmPolicyDocumentImportsPolicyDocumentImportRunIdApprove401
  status: 401
}

export type postApiTeamsTeamIdCrmPolicyDocumentImportsPolicyDocumentImportRunIdApproveResponse402 = {
  data: PostApiTeamsTeamIdCrmPolicyDocumentImportsPolicyDocumentImportRunIdApprove402
  status: 402
}

export type postApiTeamsTeamIdCrmPolicyDocumentImportsPolicyDocumentImportRunIdApproveResponseSuccess = (postApiTeamsTeamIdCrmPolicyDocumentImportsPolicyDocumentImportRunIdApproveResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmPolicyDocumentImportsPolicyDocumentImportRunIdApproveResponseError = (postApiTeamsTeamIdCrmPolicyDocumentImportsPolicyDocumentImportRunIdApproveResponse401 | postApiTeamsTeamIdCrmPolicyDocumentImportsPolicyDocumentImportRunIdApproveResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmPolicyDocumentImportsPolicyDocumentImportRunIdApproveResponse = (postApiTeamsTeamIdCrmPolicyDocumentImportsPolicyDocumentImportRunIdApproveResponseSuccess | postApiTeamsTeamIdCrmPolicyDocumentImportsPolicyDocumentImportRunIdApproveResponseError)

export const getPostApiTeamsTeamIdCrmPolicyDocumentImportsPolicyDocumentImportRunIdApproveUrl = (teamId: string,
    policyDocumentImportRunId: string,) => {




  return `/api/teams/${teamId}/crm/policy-document-imports/${policyDocumentImportRunId}/approve`
}

export const postApiTeamsTeamIdCrmPolicyDocumentImportsPolicyDocumentImportRunIdApprove = async (teamId: string,
    policyDocumentImportRunId: string,
    nullApprovePolicyDocumentImportRequest: null | ApprovePolicyDocumentImportRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmPolicyDocumentImportsPolicyDocumentImportRunIdApproveResponse> => {

  return fetcher<postApiTeamsTeamIdCrmPolicyDocumentImportsPolicyDocumentImportRunIdApproveResponse>(getPostApiTeamsTeamIdCrmPolicyDocumentImportsPolicyDocumentImportRunIdApproveUrl(teamId,policyDocumentImportRunId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullApprovePolicyDocumentImportRequest,)
  }
);}



export type getApiUsersMeResponse200TextPlain = {
  data: CurrentUserDto
  status: 200
}

export type getApiUsersMeResponse200ApplicationJson = {
  data: CurrentUserDto
  status: 200
}

export type getApiUsersMeResponse200TextJson = {
  data: CurrentUserDto
  status: 200
}

export type getApiUsersMeResponse401 = {
  data: GetApiUsersMe401
  status: 401
}

export type getApiUsersMeResponseSuccess = (getApiUsersMeResponse200TextPlain | getApiUsersMeResponse200ApplicationJson | getApiUsersMeResponse200TextJson) & {
  headers: Headers;
};
export type getApiUsersMeResponseError = (getApiUsersMeResponse401) & {
  headers: Headers;
};

export type getApiUsersMeResponse = (getApiUsersMeResponseSuccess | getApiUsersMeResponseError)

export const getGetApiUsersMeUrl = () => {




  return `/api/users/me`
}

export const getApiUsersMe = async ( options?: RequestInit): Promise<getApiUsersMeResponse> => {

  return fetcher<getApiUsersMeResponse>(getGetApiUsersMeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type putApiUsersMeResponse200TextPlain = {
  data: CurrentUserDto
  status: 200
}

export type putApiUsersMeResponse200ApplicationJson = {
  data: CurrentUserDto
  status: 200
}

export type putApiUsersMeResponse200TextJson = {
  data: CurrentUserDto
  status: 200
}

export type putApiUsersMeResponse401 = {
  data: PutApiUsersMe401
  status: 401
}

export type putApiUsersMeResponseSuccess = (putApiUsersMeResponse200TextPlain | putApiUsersMeResponse200ApplicationJson | putApiUsersMeResponse200TextJson) & {
  headers: Headers;
};
export type putApiUsersMeResponseError = (putApiUsersMeResponse401) & {
  headers: Headers;
};

export type putApiUsersMeResponse = (putApiUsersMeResponseSuccess | putApiUsersMeResponseError)

export const getPutApiUsersMeUrl = () => {




  return `/api/users/me`
}

export const putApiUsersMe = async (updateCurrentUserRequest: UpdateCurrentUserRequest, options?: RequestInit): Promise<putApiUsersMeResponse> => {

  return fetcher<putApiUsersMeResponse>(getPutApiUsersMeUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateCurrentUserRequest,)
  }
);}



export type getApiUsersMeSettingsResponse200TextPlain = {
  data: CurrentUserSettingsDto
  status: 200
}

export type getApiUsersMeSettingsResponse200ApplicationJson = {
  data: CurrentUserSettingsDto
  status: 200
}

export type getApiUsersMeSettingsResponse200TextJson = {
  data: CurrentUserSettingsDto
  status: 200
}

export type getApiUsersMeSettingsResponse401 = {
  data: GetApiUsersMeSettings401
  status: 401
}

export type getApiUsersMeSettingsResponseSuccess = (getApiUsersMeSettingsResponse200TextPlain | getApiUsersMeSettingsResponse200ApplicationJson | getApiUsersMeSettingsResponse200TextJson) & {
  headers: Headers;
};
export type getApiUsersMeSettingsResponseError = (getApiUsersMeSettingsResponse401) & {
  headers: Headers;
};

export type getApiUsersMeSettingsResponse = (getApiUsersMeSettingsResponseSuccess | getApiUsersMeSettingsResponseError)

export const getGetApiUsersMeSettingsUrl = () => {




  return `/api/users/me/settings`
}

export const getApiUsersMeSettings = async ( options?: RequestInit): Promise<getApiUsersMeSettingsResponse> => {

  return fetcher<getApiUsersMeSettingsResponse>(getGetApiUsersMeSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type putApiUsersMeSettingsResponse200TextPlain = {
  data: CurrentUserSettingsDto
  status: 200
}

export type putApiUsersMeSettingsResponse200ApplicationJson = {
  data: CurrentUserSettingsDto
  status: 200
}

export type putApiUsersMeSettingsResponse200TextJson = {
  data: CurrentUserSettingsDto
  status: 200
}

export type putApiUsersMeSettingsResponse401 = {
  data: PutApiUsersMeSettings401
  status: 401
}

export type putApiUsersMeSettingsResponseSuccess = (putApiUsersMeSettingsResponse200TextPlain | putApiUsersMeSettingsResponse200ApplicationJson | putApiUsersMeSettingsResponse200TextJson) & {
  headers: Headers;
};
export type putApiUsersMeSettingsResponseError = (putApiUsersMeSettingsResponse401) & {
  headers: Headers;
};

export type putApiUsersMeSettingsResponse = (putApiUsersMeSettingsResponseSuccess | putApiUsersMeSettingsResponseError)

export const getPutApiUsersMeSettingsUrl = () => {




  return `/api/users/me/settings`
}

export const putApiUsersMeSettings = async (updateUserSettingsRequest: UpdateUserSettingsRequest, options?: RequestInit): Promise<putApiUsersMeSettingsResponse> => {

  return fetcher<putApiUsersMeSettingsResponse>(getPutApiUsersMeSettingsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateUserSettingsRequest,)
  }
);}



export type getApiUsersMePerformanceResponse200TextPlain = {
  data: UserPerformanceDto
  status: 200
}

export type getApiUsersMePerformanceResponse200ApplicationJson = {
  data: UserPerformanceDto
  status: 200
}

export type getApiUsersMePerformanceResponse200TextJson = {
  data: UserPerformanceDto
  status: 200
}

export type getApiUsersMePerformanceResponse401 = {
  data: GetApiUsersMePerformance401
  status: 401
}

export type getApiUsersMePerformanceResponseSuccess = (getApiUsersMePerformanceResponse200TextPlain | getApiUsersMePerformanceResponse200ApplicationJson | getApiUsersMePerformanceResponse200TextJson) & {
  headers: Headers;
};
export type getApiUsersMePerformanceResponseError = (getApiUsersMePerformanceResponse401) & {
  headers: Headers;
};

export type getApiUsersMePerformanceResponse = (getApiUsersMePerformanceResponseSuccess | getApiUsersMePerformanceResponseError)

export const getGetApiUsersMePerformanceUrl = () => {




  return `/api/users/me/performance`
}

export const getApiUsersMePerformance = async ( options?: RequestInit): Promise<getApiUsersMePerformanceResponse> => {

  return fetcher<getApiUsersMePerformanceResponse>(getGetApiUsersMePerformanceUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiUsersMeCompleteDemoResponse200TextPlain = {
  data: CompleteDemoDto
  status: 200
}

export type postApiUsersMeCompleteDemoResponse200ApplicationJson = {
  data: CompleteDemoDto
  status: 200
}

export type postApiUsersMeCompleteDemoResponse200TextJson = {
  data: CompleteDemoDto
  status: 200
}

export type postApiUsersMeCompleteDemoResponse401 = {
  data: PostApiUsersMeCompleteDemo401
  status: 401
}

export type postApiUsersMeCompleteDemoResponseSuccess = (postApiUsersMeCompleteDemoResponse200TextPlain | postApiUsersMeCompleteDemoResponse200ApplicationJson | postApiUsersMeCompleteDemoResponse200TextJson) & {
  headers: Headers;
};
export type postApiUsersMeCompleteDemoResponseError = (postApiUsersMeCompleteDemoResponse401) & {
  headers: Headers;
};

export type postApiUsersMeCompleteDemoResponse = (postApiUsersMeCompleteDemoResponseSuccess | postApiUsersMeCompleteDemoResponseError)

export const getPostApiUsersMeCompleteDemoUrl = () => {




  return `/api/users/me/complete-demo`
}

export const postApiUsersMeCompleteDemo = async ( options?: RequestInit): Promise<postApiUsersMeCompleteDemoResponse> => {

  return fetcher<postApiUsersMeCompleteDemoResponse>(getPostApiUsersMeCompleteDemoUrl(),
  {
    ...options,
    method: 'POST'


  }
);}



export type getApiDashboardStatsResponse200TextPlain = {
  data: DashboardStatsDto
  status: 200
}

export type getApiDashboardStatsResponse200ApplicationJson = {
  data: DashboardStatsDto
  status: 200
}

export type getApiDashboardStatsResponse200TextJson = {
  data: DashboardStatsDto
  status: 200
}

export type getApiDashboardStatsResponse401 = {
  data: GetApiDashboardStats401
  status: 401
}

export type getApiDashboardStatsResponseSuccess = (getApiDashboardStatsResponse200TextPlain | getApiDashboardStatsResponse200ApplicationJson | getApiDashboardStatsResponse200TextJson) & {
  headers: Headers;
};
export type getApiDashboardStatsResponseError = (getApiDashboardStatsResponse401) & {
  headers: Headers;
};

export type getApiDashboardStatsResponse = (getApiDashboardStatsResponseSuccess | getApiDashboardStatsResponseError)

export const getGetApiDashboardStatsUrl = () => {




  return `/api/dashboard/stats`
}

export const getApiDashboardStats = async ( options?: RequestInit): Promise<getApiDashboardStatsResponse> => {

  return fetcher<getApiDashboardStatsResponse>(getGetApiDashboardStatsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiDirectoryUserUsersResponse200TextPlain = {
  data: EntraUserDto[]
  status: 200
}

export type getApiDirectoryUserUsersResponse200ApplicationJson = {
  data: EntraUserDto[]
  status: 200
}

export type getApiDirectoryUserUsersResponse200TextJson = {
  data: EntraUserDto[]
  status: 200
}

export type getApiDirectoryUserUsersResponse401 = {
  data: GetApiDirectoryUserUsers401
  status: 401
}

export type getApiDirectoryUserUsersResponse402 = {
  data: GetApiDirectoryUserUsers402
  status: 402
}

export type getApiDirectoryUserUsersResponseSuccess = (getApiDirectoryUserUsersResponse200TextPlain | getApiDirectoryUserUsersResponse200ApplicationJson | getApiDirectoryUserUsersResponse200TextJson) & {
  headers: Headers;
};
export type getApiDirectoryUserUsersResponseError = (getApiDirectoryUserUsersResponse401 | getApiDirectoryUserUsersResponse402) & {
  headers: Headers;
};

export type getApiDirectoryUserUsersResponse = (getApiDirectoryUserUsersResponseSuccess | getApiDirectoryUserUsersResponseError)

export const getGetApiDirectoryUserUsersUrl = (params?: GetApiDirectoryUserUsersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/DirectoryUser/users?${stringifiedParams}` : `/api/DirectoryUser/users`
}

export const getApiDirectoryUserUsers = async (params?: GetApiDirectoryUserUsersParams, options?: RequestInit): Promise<getApiDirectoryUserUsersResponse> => {

  return fetcher<getApiDirectoryUserUsersResponse>(getGetApiDirectoryUserUsersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiDirectoryUserUsersResponse200TextPlain = {
  data: EntraUserCreationResult
  status: 200
}

export type postApiDirectoryUserUsersResponse200ApplicationJson = {
  data: EntraUserCreationResult
  status: 200
}

export type postApiDirectoryUserUsersResponse200TextJson = {
  data: EntraUserCreationResult
  status: 200
}

export type postApiDirectoryUserUsersResponse401 = {
  data: PostApiDirectoryUserUsers401
  status: 401
}

export type postApiDirectoryUserUsersResponse402 = {
  data: PostApiDirectoryUserUsers402
  status: 402
}

export type postApiDirectoryUserUsersResponseSuccess = (postApiDirectoryUserUsersResponse200TextPlain | postApiDirectoryUserUsersResponse200ApplicationJson | postApiDirectoryUserUsersResponse200TextJson) & {
  headers: Headers;
};
export type postApiDirectoryUserUsersResponseError = (postApiDirectoryUserUsersResponse401 | postApiDirectoryUserUsersResponse402) & {
  headers: Headers;
};

export type postApiDirectoryUserUsersResponse = (postApiDirectoryUserUsersResponseSuccess | postApiDirectoryUserUsersResponseError)

export const getPostApiDirectoryUserUsersUrl = () => {




  return `/api/DirectoryUser/users`
}

export const postApiDirectoryUserUsers = async (createEntraUserRequest: CreateEntraUserRequest, options?: RequestInit): Promise<postApiDirectoryUserUsersResponse> => {

  return fetcher<postApiDirectoryUserUsersResponse>(getPostApiDirectoryUserUsersUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createEntraUserRequest,)
  }
);}



export type getApiDirectoryUserUsersUserIdResponse200TextPlain = {
  data: EntraUserDto
  status: 200
}

export type getApiDirectoryUserUsersUserIdResponse200ApplicationJson = {
  data: EntraUserDto
  status: 200
}

export type getApiDirectoryUserUsersUserIdResponse200TextJson = {
  data: EntraUserDto
  status: 200
}

export type getApiDirectoryUserUsersUserIdResponse401 = {
  data: GetApiDirectoryUserUsersUserId401
  status: 401
}

export type getApiDirectoryUserUsersUserIdResponse402 = {
  data: GetApiDirectoryUserUsersUserId402
  status: 402
}

export type getApiDirectoryUserUsersUserIdResponseSuccess = (getApiDirectoryUserUsersUserIdResponse200TextPlain | getApiDirectoryUserUsersUserIdResponse200ApplicationJson | getApiDirectoryUserUsersUserIdResponse200TextJson) & {
  headers: Headers;
};
export type getApiDirectoryUserUsersUserIdResponseError = (getApiDirectoryUserUsersUserIdResponse401 | getApiDirectoryUserUsersUserIdResponse402) & {
  headers: Headers;
};

export type getApiDirectoryUserUsersUserIdResponse = (getApiDirectoryUserUsersUserIdResponseSuccess | getApiDirectoryUserUsersUserIdResponseError)

export const getGetApiDirectoryUserUsersUserIdUrl = (userId: string,) => {




  return `/api/DirectoryUser/users/${userId}`
}

export const getApiDirectoryUserUsersUserId = async (userId: string, options?: RequestInit): Promise<getApiDirectoryUserUsersUserIdResponse> => {

  return fetcher<getApiDirectoryUserUsersUserIdResponse>(getGetApiDirectoryUserUsersUserIdUrl(userId),
  {
    ...options,
    method: 'GET'


  }
);}



export type putApiDirectoryUserUsersUserIdResponse200TextPlain = {
  data: EntraUserDto
  status: 200
}

export type putApiDirectoryUserUsersUserIdResponse200ApplicationJson = {
  data: EntraUserDto
  status: 200
}

export type putApiDirectoryUserUsersUserIdResponse200TextJson = {
  data: EntraUserDto
  status: 200
}

export type putApiDirectoryUserUsersUserIdResponse401 = {
  data: PutApiDirectoryUserUsersUserId401
  status: 401
}

export type putApiDirectoryUserUsersUserIdResponse402 = {
  data: PutApiDirectoryUserUsersUserId402
  status: 402
}

export type putApiDirectoryUserUsersUserIdResponseSuccess = (putApiDirectoryUserUsersUserIdResponse200TextPlain | putApiDirectoryUserUsersUserIdResponse200ApplicationJson | putApiDirectoryUserUsersUserIdResponse200TextJson) & {
  headers: Headers;
};
export type putApiDirectoryUserUsersUserIdResponseError = (putApiDirectoryUserUsersUserIdResponse401 | putApiDirectoryUserUsersUserIdResponse402) & {
  headers: Headers;
};

export type putApiDirectoryUserUsersUserIdResponse = (putApiDirectoryUserUsersUserIdResponseSuccess | putApiDirectoryUserUsersUserIdResponseError)

export const getPutApiDirectoryUserUsersUserIdUrl = (userId: string,) => {




  return `/api/DirectoryUser/users/${userId}`
}

export const putApiDirectoryUserUsersUserId = async (userId: string,
    updateEntraUserRequest: UpdateEntraUserRequest, options?: RequestInit): Promise<putApiDirectoryUserUsersUserIdResponse> => {

  return fetcher<putApiDirectoryUserUsersUserIdResponse>(getPutApiDirectoryUserUsersUserIdUrl(userId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateEntraUserRequest,)
  }
);}



export type deleteApiDirectoryUserUsersUserIdResponse200 = {
  data: void
  status: 200
}

export type deleteApiDirectoryUserUsersUserIdResponse401 = {
  data: DeleteApiDirectoryUserUsersUserId401
  status: 401
}

export type deleteApiDirectoryUserUsersUserIdResponse402 = {
  data: DeleteApiDirectoryUserUsersUserId402
  status: 402
}

export type deleteApiDirectoryUserUsersUserIdResponseSuccess = (deleteApiDirectoryUserUsersUserIdResponse200) & {
  headers: Headers;
};
export type deleteApiDirectoryUserUsersUserIdResponseError = (deleteApiDirectoryUserUsersUserIdResponse401 | deleteApiDirectoryUserUsersUserIdResponse402) & {
  headers: Headers;
};

export type deleteApiDirectoryUserUsersUserIdResponse = (deleteApiDirectoryUserUsersUserIdResponseSuccess | deleteApiDirectoryUserUsersUserIdResponseError)

export const getDeleteApiDirectoryUserUsersUserIdUrl = (userId: string,) => {




  return `/api/DirectoryUser/users/${userId}`
}

export const deleteApiDirectoryUserUsersUserId = async (userId: string, options?: RequestInit): Promise<deleteApiDirectoryUserUsersUserIdResponse> => {

  return fetcher<deleteApiDirectoryUserUsersUserIdResponse>(getDeleteApiDirectoryUserUsersUserIdUrl(userId),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type postApiDirectoryUserInvitationsResponse200 = {
  data: void
  status: 200
}

export type postApiDirectoryUserInvitationsResponse401 = {
  data: PostApiDirectoryUserInvitations401
  status: 401
}

export type postApiDirectoryUserInvitationsResponse402 = {
  data: PostApiDirectoryUserInvitations402
  status: 402
}

export type postApiDirectoryUserInvitationsResponseSuccess = (postApiDirectoryUserInvitationsResponse200) & {
  headers: Headers;
};
export type postApiDirectoryUserInvitationsResponseError = (postApiDirectoryUserInvitationsResponse401 | postApiDirectoryUserInvitationsResponse402) & {
  headers: Headers;
};

export type postApiDirectoryUserInvitationsResponse = (postApiDirectoryUserInvitationsResponseSuccess | postApiDirectoryUserInvitationsResponseError)

export const getPostApiDirectoryUserInvitationsUrl = () => {




  return `/api/DirectoryUser/invitations`
}

export const postApiDirectoryUserInvitations = async (sendInvitationRequest: SendInvitationRequest, options?: RequestInit): Promise<postApiDirectoryUserInvitationsResponse> => {

  return fetcher<postApiDirectoryUserInvitationsResponse>(getPostApiDirectoryUserInvitationsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sendInvitationRequest,)
  }
);}



export type getApiDirectoryUserStatsResponse200TextPlain = {
  data: EntraUserStatsDto
  status: 200
}

export type getApiDirectoryUserStatsResponse200ApplicationJson = {
  data: EntraUserStatsDto
  status: 200
}

export type getApiDirectoryUserStatsResponse200TextJson = {
  data: EntraUserStatsDto
  status: 200
}

export type getApiDirectoryUserStatsResponse401 = {
  data: GetApiDirectoryUserStats401
  status: 401
}

export type getApiDirectoryUserStatsResponse402 = {
  data: GetApiDirectoryUserStats402
  status: 402
}

export type getApiDirectoryUserStatsResponseSuccess = (getApiDirectoryUserStatsResponse200TextPlain | getApiDirectoryUserStatsResponse200ApplicationJson | getApiDirectoryUserStatsResponse200TextJson) & {
  headers: Headers;
};
export type getApiDirectoryUserStatsResponseError = (getApiDirectoryUserStatsResponse401 | getApiDirectoryUserStatsResponse402) & {
  headers: Headers;
};

export type getApiDirectoryUserStatsResponse = (getApiDirectoryUserStatsResponseSuccess | getApiDirectoryUserStatsResponseError)

export const getGetApiDirectoryUserStatsUrl = () => {




  return `/api/DirectoryUser/stats`
}

export const getApiDirectoryUserStats = async ( options?: RequestInit): Promise<getApiDirectoryUserStatsResponse> => {

  return fetcher<getApiDirectoryUserStatsResponse>(getGetApiDirectoryUserStatsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiDirectoryUserInvitationsB2bResponse200TextPlain = {
  data: B2BInvitationResult
  status: 200
}

export type postApiDirectoryUserInvitationsB2bResponse200ApplicationJson = {
  data: B2BInvitationResult
  status: 200
}

export type postApiDirectoryUserInvitationsB2bResponse200TextJson = {
  data: B2BInvitationResult
  status: 200
}

export type postApiDirectoryUserInvitationsB2bResponse401 = {
  data: PostApiDirectoryUserInvitationsB2b401
  status: 401
}

export type postApiDirectoryUserInvitationsB2bResponse402 = {
  data: PostApiDirectoryUserInvitationsB2b402
  status: 402
}

export type postApiDirectoryUserInvitationsB2bResponseSuccess = (postApiDirectoryUserInvitationsB2bResponse200TextPlain | postApiDirectoryUserInvitationsB2bResponse200ApplicationJson | postApiDirectoryUserInvitationsB2bResponse200TextJson) & {
  headers: Headers;
};
export type postApiDirectoryUserInvitationsB2bResponseError = (postApiDirectoryUserInvitationsB2bResponse401 | postApiDirectoryUserInvitationsB2bResponse402) & {
  headers: Headers;
};

export type postApiDirectoryUserInvitationsB2bResponse = (postApiDirectoryUserInvitationsB2bResponseSuccess | postApiDirectoryUserInvitationsB2bResponseError)

export const getPostApiDirectoryUserInvitationsB2bUrl = () => {




  return `/api/DirectoryUser/invitations/b2b`
}

export const postApiDirectoryUserInvitationsB2b = async (sendB2BInvitationRequest: SendB2BInvitationRequest, options?: RequestInit): Promise<postApiDirectoryUserInvitationsB2bResponse> => {

  return fetcher<postApiDirectoryUserInvitationsB2bResponse>(getPostApiDirectoryUserInvitationsB2bUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sendB2BInvitationRequest,)
  }
);}



export type postApiTeamsTeamIdEdgeEnrollmentsResponse200TextPlain = {
  data: CreateEdgeClientEnrollmentResponse
  status: 200
}

export type postApiTeamsTeamIdEdgeEnrollmentsResponse200ApplicationJson = {
  data: CreateEdgeClientEnrollmentResponse
  status: 200
}

export type postApiTeamsTeamIdEdgeEnrollmentsResponse200TextJson = {
  data: CreateEdgeClientEnrollmentResponse
  status: 200
}

export type postApiTeamsTeamIdEdgeEnrollmentsResponse400TextPlain = {
  data: ProblemDetails
  status: 400
}

export type postApiTeamsTeamIdEdgeEnrollmentsResponse400ApplicationJson = {
  data: ProblemDetails
  status: 400
}

export type postApiTeamsTeamIdEdgeEnrollmentsResponse400TextJson = {
  data: ProblemDetails
  status: 400
}

export type postApiTeamsTeamIdEdgeEnrollmentsResponse401 = {
  data: PostApiTeamsTeamIdEdgeEnrollments401
  status: 401
}

export type postApiTeamsTeamIdEdgeEnrollmentsResponse402 = {
  data: PostApiTeamsTeamIdEdgeEnrollments402
  status: 402
}

export type postApiTeamsTeamIdEdgeEnrollmentsResponse403TextPlain = {
  data: ProblemDetails
  status: 403
}

export type postApiTeamsTeamIdEdgeEnrollmentsResponse403ApplicationJson = {
  data: ProblemDetails
  status: 403
}

export type postApiTeamsTeamIdEdgeEnrollmentsResponse403TextJson = {
  data: ProblemDetails
  status: 403
}

export type postApiTeamsTeamIdEdgeEnrollmentsResponse404TextPlain = {
  data: ProblemDetails
  status: 404
}

export type postApiTeamsTeamIdEdgeEnrollmentsResponse404ApplicationJson = {
  data: ProblemDetails
  status: 404
}

export type postApiTeamsTeamIdEdgeEnrollmentsResponse404TextJson = {
  data: ProblemDetails
  status: 404
}

export type postApiTeamsTeamIdEdgeEnrollmentsResponse500 = {
  data: void
  status: 500
}

export type postApiTeamsTeamIdEdgeEnrollmentsResponseSuccess = (postApiTeamsTeamIdEdgeEnrollmentsResponse200TextPlain | postApiTeamsTeamIdEdgeEnrollmentsResponse200ApplicationJson | postApiTeamsTeamIdEdgeEnrollmentsResponse200TextJson) & {
  headers: Headers;
};
export type postApiTeamsTeamIdEdgeEnrollmentsResponseError = (postApiTeamsTeamIdEdgeEnrollmentsResponse400TextPlain | postApiTeamsTeamIdEdgeEnrollmentsResponse400ApplicationJson | postApiTeamsTeamIdEdgeEnrollmentsResponse400TextJson | postApiTeamsTeamIdEdgeEnrollmentsResponse401 | postApiTeamsTeamIdEdgeEnrollmentsResponse402 | postApiTeamsTeamIdEdgeEnrollmentsResponse403TextPlain | postApiTeamsTeamIdEdgeEnrollmentsResponse403ApplicationJson | postApiTeamsTeamIdEdgeEnrollmentsResponse403TextJson | postApiTeamsTeamIdEdgeEnrollmentsResponse404TextPlain | postApiTeamsTeamIdEdgeEnrollmentsResponse404ApplicationJson | postApiTeamsTeamIdEdgeEnrollmentsResponse404TextJson | postApiTeamsTeamIdEdgeEnrollmentsResponse500) & {
  headers: Headers;
};

export type postApiTeamsTeamIdEdgeEnrollmentsResponse = (postApiTeamsTeamIdEdgeEnrollmentsResponseSuccess | postApiTeamsTeamIdEdgeEnrollmentsResponseError)

export const getPostApiTeamsTeamIdEdgeEnrollmentsUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/edge/enrollments`
}

export const postApiTeamsTeamIdEdgeEnrollments = async (teamId: string,
    createEdgeClientEnrollmentRequest: CreateEdgeClientEnrollmentRequest, options?: RequestInit): Promise<postApiTeamsTeamIdEdgeEnrollmentsResponse> => {

  return fetcher<postApiTeamsTeamIdEdgeEnrollmentsResponse>(getPostApiTeamsTeamIdEdgeEnrollmentsUrl(teamId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createEdgeClientEnrollmentRequest,)
  }
);}



export type getApiTeamsTeamIdEdgeClientsResponse200TextPlain = {
  data: EdgeClientSummaryResponse[]
  status: 200
}

export type getApiTeamsTeamIdEdgeClientsResponse200ApplicationJson = {
  data: EdgeClientSummaryResponse[]
  status: 200
}

export type getApiTeamsTeamIdEdgeClientsResponse200TextJson = {
  data: EdgeClientSummaryResponse[]
  status: 200
}

export type getApiTeamsTeamIdEdgeClientsResponse400TextPlain = {
  data: ProblemDetails
  status: 400
}

export type getApiTeamsTeamIdEdgeClientsResponse400ApplicationJson = {
  data: ProblemDetails
  status: 400
}

export type getApiTeamsTeamIdEdgeClientsResponse400TextJson = {
  data: ProblemDetails
  status: 400
}

export type getApiTeamsTeamIdEdgeClientsResponse401 = {
  data: GetApiTeamsTeamIdEdgeClients401
  status: 401
}

export type getApiTeamsTeamIdEdgeClientsResponse403TextPlain = {
  data: ProblemDetails
  status: 403
}

export type getApiTeamsTeamIdEdgeClientsResponse403ApplicationJson = {
  data: ProblemDetails
  status: 403
}

export type getApiTeamsTeamIdEdgeClientsResponse403TextJson = {
  data: ProblemDetails
  status: 403
}

export type getApiTeamsTeamIdEdgeClientsResponse500 = {
  data: void
  status: 500
}

export type getApiTeamsTeamIdEdgeClientsResponseSuccess = (getApiTeamsTeamIdEdgeClientsResponse200TextPlain | getApiTeamsTeamIdEdgeClientsResponse200ApplicationJson | getApiTeamsTeamIdEdgeClientsResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsTeamIdEdgeClientsResponseError = (getApiTeamsTeamIdEdgeClientsResponse400TextPlain | getApiTeamsTeamIdEdgeClientsResponse400ApplicationJson | getApiTeamsTeamIdEdgeClientsResponse400TextJson | getApiTeamsTeamIdEdgeClientsResponse401 | getApiTeamsTeamIdEdgeClientsResponse403TextPlain | getApiTeamsTeamIdEdgeClientsResponse403ApplicationJson | getApiTeamsTeamIdEdgeClientsResponse403TextJson | getApiTeamsTeamIdEdgeClientsResponse500) & {
  headers: Headers;
};

export type getApiTeamsTeamIdEdgeClientsResponse = (getApiTeamsTeamIdEdgeClientsResponseSuccess | getApiTeamsTeamIdEdgeClientsResponseError)

export const getGetApiTeamsTeamIdEdgeClientsUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/edge/clients`
}

export const getApiTeamsTeamIdEdgeClients = async (teamId: string, options?: RequestInit): Promise<getApiTeamsTeamIdEdgeClientsResponse> => {

  return fetcher<getApiTeamsTeamIdEdgeClientsResponse>(getGetApiTeamsTeamIdEdgeClientsUrl(teamId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdEdgeClientsEdgeClientIdRevokeResponse200TextPlain = {
  data: EdgeClientSummaryResponse
  status: 200
}

export type postApiTeamsTeamIdEdgeClientsEdgeClientIdRevokeResponse200ApplicationJson = {
  data: EdgeClientSummaryResponse
  status: 200
}

export type postApiTeamsTeamIdEdgeClientsEdgeClientIdRevokeResponse200TextJson = {
  data: EdgeClientSummaryResponse
  status: 200
}

export type postApiTeamsTeamIdEdgeClientsEdgeClientIdRevokeResponse400TextPlain = {
  data: ProblemDetails
  status: 400
}

export type postApiTeamsTeamIdEdgeClientsEdgeClientIdRevokeResponse400ApplicationJson = {
  data: ProblemDetails
  status: 400
}

export type postApiTeamsTeamIdEdgeClientsEdgeClientIdRevokeResponse400TextJson = {
  data: ProblemDetails
  status: 400
}

export type postApiTeamsTeamIdEdgeClientsEdgeClientIdRevokeResponse401 = {
  data: PostApiTeamsTeamIdEdgeClientsEdgeClientIdRevoke401
  status: 401
}

export type postApiTeamsTeamIdEdgeClientsEdgeClientIdRevokeResponse402 = {
  data: PostApiTeamsTeamIdEdgeClientsEdgeClientIdRevoke402
  status: 402
}

export type postApiTeamsTeamIdEdgeClientsEdgeClientIdRevokeResponse403TextPlain = {
  data: ProblemDetails
  status: 403
}

export type postApiTeamsTeamIdEdgeClientsEdgeClientIdRevokeResponse403ApplicationJson = {
  data: ProblemDetails
  status: 403
}

export type postApiTeamsTeamIdEdgeClientsEdgeClientIdRevokeResponse403TextJson = {
  data: ProblemDetails
  status: 403
}

export type postApiTeamsTeamIdEdgeClientsEdgeClientIdRevokeResponse404TextPlain = {
  data: ProblemDetails
  status: 404
}

export type postApiTeamsTeamIdEdgeClientsEdgeClientIdRevokeResponse404ApplicationJson = {
  data: ProblemDetails
  status: 404
}

export type postApiTeamsTeamIdEdgeClientsEdgeClientIdRevokeResponse404TextJson = {
  data: ProblemDetails
  status: 404
}

export type postApiTeamsTeamIdEdgeClientsEdgeClientIdRevokeResponse500 = {
  data: void
  status: 500
}

export type postApiTeamsTeamIdEdgeClientsEdgeClientIdRevokeResponseSuccess = (postApiTeamsTeamIdEdgeClientsEdgeClientIdRevokeResponse200TextPlain | postApiTeamsTeamIdEdgeClientsEdgeClientIdRevokeResponse200ApplicationJson | postApiTeamsTeamIdEdgeClientsEdgeClientIdRevokeResponse200TextJson) & {
  headers: Headers;
};
export type postApiTeamsTeamIdEdgeClientsEdgeClientIdRevokeResponseError = (postApiTeamsTeamIdEdgeClientsEdgeClientIdRevokeResponse400TextPlain | postApiTeamsTeamIdEdgeClientsEdgeClientIdRevokeResponse400ApplicationJson | postApiTeamsTeamIdEdgeClientsEdgeClientIdRevokeResponse400TextJson | postApiTeamsTeamIdEdgeClientsEdgeClientIdRevokeResponse401 | postApiTeamsTeamIdEdgeClientsEdgeClientIdRevokeResponse402 | postApiTeamsTeamIdEdgeClientsEdgeClientIdRevokeResponse403TextPlain | postApiTeamsTeamIdEdgeClientsEdgeClientIdRevokeResponse403ApplicationJson | postApiTeamsTeamIdEdgeClientsEdgeClientIdRevokeResponse403TextJson | postApiTeamsTeamIdEdgeClientsEdgeClientIdRevokeResponse404TextPlain | postApiTeamsTeamIdEdgeClientsEdgeClientIdRevokeResponse404ApplicationJson | postApiTeamsTeamIdEdgeClientsEdgeClientIdRevokeResponse404TextJson | postApiTeamsTeamIdEdgeClientsEdgeClientIdRevokeResponse500) & {
  headers: Headers;
};

export type postApiTeamsTeamIdEdgeClientsEdgeClientIdRevokeResponse = (postApiTeamsTeamIdEdgeClientsEdgeClientIdRevokeResponseSuccess | postApiTeamsTeamIdEdgeClientsEdgeClientIdRevokeResponseError)

export const getPostApiTeamsTeamIdEdgeClientsEdgeClientIdRevokeUrl = (teamId: string,
    edgeClientId: string,) => {




  return `/api/teams/${teamId}/edge/clients/${edgeClientId}/revoke`
}

export const postApiTeamsTeamIdEdgeClientsEdgeClientIdRevoke = async (teamId: string,
    edgeClientId: string, options?: RequestInit): Promise<postApiTeamsTeamIdEdgeClientsEdgeClientIdRevokeResponse> => {

  return fetcher<postApiTeamsTeamIdEdgeClientsEdgeClientIdRevokeResponse>(getPostApiTeamsTeamIdEdgeClientsEdgeClientIdRevokeUrl(teamId,edgeClientId),
  {
    ...options,
    method: 'POST'


  }
);}



export type postApiEdgeEnrollResponse200TextPlain = {
  data: RegisterEdgeClientResponse
  status: 200
}

export type postApiEdgeEnrollResponse200ApplicationJson = {
  data: RegisterEdgeClientResponse
  status: 200
}

export type postApiEdgeEnrollResponse200TextJson = {
  data: RegisterEdgeClientResponse
  status: 200
}

export type postApiEdgeEnrollResponse400TextPlain = {
  data: ProblemDetails
  status: 400
}

export type postApiEdgeEnrollResponse400ApplicationJson = {
  data: ProblemDetails
  status: 400
}

export type postApiEdgeEnrollResponse400TextJson = {
  data: ProblemDetails
  status: 400
}

export type postApiEdgeEnrollResponse401TextPlain = {
  data: ProblemDetails
  status: 401
}

export type postApiEdgeEnrollResponse401ApplicationJson = {
  data: ProblemDetails
  status: 401
}

export type postApiEdgeEnrollResponse401TextJson = {
  data: ProblemDetails
  status: 401
}

export type postApiEdgeEnrollResponse500 = {
  data: void
  status: 500
}

export type postApiEdgeEnrollResponseSuccess = (postApiEdgeEnrollResponse200TextPlain | postApiEdgeEnrollResponse200ApplicationJson | postApiEdgeEnrollResponse200TextJson) & {
  headers: Headers;
};
export type postApiEdgeEnrollResponseError = (postApiEdgeEnrollResponse400TextPlain | postApiEdgeEnrollResponse400ApplicationJson | postApiEdgeEnrollResponse400TextJson | postApiEdgeEnrollResponse401TextPlain | postApiEdgeEnrollResponse401ApplicationJson | postApiEdgeEnrollResponse401TextJson | postApiEdgeEnrollResponse500) & {
  headers: Headers;
};

export type postApiEdgeEnrollResponse = (postApiEdgeEnrollResponseSuccess | postApiEdgeEnrollResponseError)

export const getPostApiEdgeEnrollUrl = () => {




  return `/api/edge/enroll`
}

export const postApiEdgeEnroll = async (registerEdgeClientRequest: RegisterEdgeClientRequest, options?: RequestInit): Promise<postApiEdgeEnrollResponse> => {

  return fetcher<postApiEdgeEnrollResponse>(getPostApiEdgeEnrollUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      registerEdgeClientRequest,)
  }
);}



export type postApiEdgeHeartbeatResponse200TextPlain = {
  data: EdgeClientHeartbeatResponse
  status: 200
}

export type postApiEdgeHeartbeatResponse200ApplicationJson = {
  data: EdgeClientHeartbeatResponse
  status: 200
}

export type postApiEdgeHeartbeatResponse200TextJson = {
  data: EdgeClientHeartbeatResponse
  status: 200
}

export type postApiEdgeHeartbeatResponse400TextPlain = {
  data: ProblemDetails
  status: 400
}

export type postApiEdgeHeartbeatResponse400ApplicationJson = {
  data: ProblemDetails
  status: 400
}

export type postApiEdgeHeartbeatResponse400TextJson = {
  data: ProblemDetails
  status: 400
}

export type postApiEdgeHeartbeatResponse401TextPlain = {
  data: ProblemDetails
  status: 401
}

export type postApiEdgeHeartbeatResponse401ApplicationJson = {
  data: ProblemDetails
  status: 401
}

export type postApiEdgeHeartbeatResponse401TextJson = {
  data: ProblemDetails
  status: 401
}

export type postApiEdgeHeartbeatResponse500 = {
  data: void
  status: 500
}

export type postApiEdgeHeartbeatResponseSuccess = (postApiEdgeHeartbeatResponse200TextPlain | postApiEdgeHeartbeatResponse200ApplicationJson | postApiEdgeHeartbeatResponse200TextJson) & {
  headers: Headers;
};
export type postApiEdgeHeartbeatResponseError = (postApiEdgeHeartbeatResponse400TextPlain | postApiEdgeHeartbeatResponse400ApplicationJson | postApiEdgeHeartbeatResponse400TextJson | postApiEdgeHeartbeatResponse401TextPlain | postApiEdgeHeartbeatResponse401ApplicationJson | postApiEdgeHeartbeatResponse401TextJson | postApiEdgeHeartbeatResponse500) & {
  headers: Headers;
};

export type postApiEdgeHeartbeatResponse = (postApiEdgeHeartbeatResponseSuccess | postApiEdgeHeartbeatResponseError)

export const getPostApiEdgeHeartbeatUrl = () => {




  return `/api/edge/heartbeat`
}

export const postApiEdgeHeartbeat = async (edgeClientHeartbeatRequest: EdgeClientHeartbeatRequest, options?: RequestInit): Promise<postApiEdgeHeartbeatResponse> => {

  return fetcher<postApiEdgeHeartbeatResponse>(getPostApiEdgeHeartbeatUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      edgeClientHeartbeatRequest,)
  }
);}



export type postApiTeamsTeamIdEdgeWorkItemsResponse200TextPlain = {
  data: EdgeWorkItemResponse
  status: 200
}

export type postApiTeamsTeamIdEdgeWorkItemsResponse200ApplicationJson = {
  data: EdgeWorkItemResponse
  status: 200
}

export type postApiTeamsTeamIdEdgeWorkItemsResponse200TextJson = {
  data: EdgeWorkItemResponse
  status: 200
}

export type postApiTeamsTeamIdEdgeWorkItemsResponse400TextPlain = {
  data: ProblemDetails
  status: 400
}

export type postApiTeamsTeamIdEdgeWorkItemsResponse400ApplicationJson = {
  data: ProblemDetails
  status: 400
}

export type postApiTeamsTeamIdEdgeWorkItemsResponse400TextJson = {
  data: ProblemDetails
  status: 400
}

export type postApiTeamsTeamIdEdgeWorkItemsResponse401 = {
  data: PostApiTeamsTeamIdEdgeWorkItems401
  status: 401
}

export type postApiTeamsTeamIdEdgeWorkItemsResponse402 = {
  data: PostApiTeamsTeamIdEdgeWorkItems402
  status: 402
}

export type postApiTeamsTeamIdEdgeWorkItemsResponse403TextPlain = {
  data: ProblemDetails
  status: 403
}

export type postApiTeamsTeamIdEdgeWorkItemsResponse403ApplicationJson = {
  data: ProblemDetails
  status: 403
}

export type postApiTeamsTeamIdEdgeWorkItemsResponse403TextJson = {
  data: ProblemDetails
  status: 403
}

export type postApiTeamsTeamIdEdgeWorkItemsResponse404TextPlain = {
  data: ProblemDetails
  status: 404
}

export type postApiTeamsTeamIdEdgeWorkItemsResponse404ApplicationJson = {
  data: ProblemDetails
  status: 404
}

export type postApiTeamsTeamIdEdgeWorkItemsResponse404TextJson = {
  data: ProblemDetails
  status: 404
}

export type postApiTeamsTeamIdEdgeWorkItemsResponse409TextPlain = {
  data: ProblemDetails
  status: 409
}

export type postApiTeamsTeamIdEdgeWorkItemsResponse409ApplicationJson = {
  data: ProblemDetails
  status: 409
}

export type postApiTeamsTeamIdEdgeWorkItemsResponse409TextJson = {
  data: ProblemDetails
  status: 409
}

export type postApiTeamsTeamIdEdgeWorkItemsResponse500 = {
  data: void
  status: 500
}

export type postApiTeamsTeamIdEdgeWorkItemsResponseSuccess = (postApiTeamsTeamIdEdgeWorkItemsResponse200TextPlain | postApiTeamsTeamIdEdgeWorkItemsResponse200ApplicationJson | postApiTeamsTeamIdEdgeWorkItemsResponse200TextJson) & {
  headers: Headers;
};
export type postApiTeamsTeamIdEdgeWorkItemsResponseError = (postApiTeamsTeamIdEdgeWorkItemsResponse400TextPlain | postApiTeamsTeamIdEdgeWorkItemsResponse400ApplicationJson | postApiTeamsTeamIdEdgeWorkItemsResponse400TextJson | postApiTeamsTeamIdEdgeWorkItemsResponse401 | postApiTeamsTeamIdEdgeWorkItemsResponse402 | postApiTeamsTeamIdEdgeWorkItemsResponse403TextPlain | postApiTeamsTeamIdEdgeWorkItemsResponse403ApplicationJson | postApiTeamsTeamIdEdgeWorkItemsResponse403TextJson | postApiTeamsTeamIdEdgeWorkItemsResponse404TextPlain | postApiTeamsTeamIdEdgeWorkItemsResponse404ApplicationJson | postApiTeamsTeamIdEdgeWorkItemsResponse404TextJson | postApiTeamsTeamIdEdgeWorkItemsResponse409TextPlain | postApiTeamsTeamIdEdgeWorkItemsResponse409ApplicationJson | postApiTeamsTeamIdEdgeWorkItemsResponse409TextJson | postApiTeamsTeamIdEdgeWorkItemsResponse500) & {
  headers: Headers;
};

export type postApiTeamsTeamIdEdgeWorkItemsResponse = (postApiTeamsTeamIdEdgeWorkItemsResponseSuccess | postApiTeamsTeamIdEdgeWorkItemsResponseError)

export const getPostApiTeamsTeamIdEdgeWorkItemsUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/edge/work-items`
}

export const postApiTeamsTeamIdEdgeWorkItems = async (teamId: string,
    createEdgeWorkItemRequest: CreateEdgeWorkItemRequest, options?: RequestInit): Promise<postApiTeamsTeamIdEdgeWorkItemsResponse> => {

  return fetcher<postApiTeamsTeamIdEdgeWorkItemsResponse>(getPostApiTeamsTeamIdEdgeWorkItemsUrl(teamId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createEdgeWorkItemRequest,)
  }
);}



export type getApiTeamsTeamIdEdgeWorkItemsResponse200TextPlain = {
  data: EdgeWorkItemSummaryResponse[]
  status: 200
}

export type getApiTeamsTeamIdEdgeWorkItemsResponse200ApplicationJson = {
  data: EdgeWorkItemSummaryResponse[]
  status: 200
}

export type getApiTeamsTeamIdEdgeWorkItemsResponse200TextJson = {
  data: EdgeWorkItemSummaryResponse[]
  status: 200
}

export type getApiTeamsTeamIdEdgeWorkItemsResponse400TextPlain = {
  data: ProblemDetails
  status: 400
}

export type getApiTeamsTeamIdEdgeWorkItemsResponse400ApplicationJson = {
  data: ProblemDetails
  status: 400
}

export type getApiTeamsTeamIdEdgeWorkItemsResponse400TextJson = {
  data: ProblemDetails
  status: 400
}

export type getApiTeamsTeamIdEdgeWorkItemsResponse401 = {
  data: GetApiTeamsTeamIdEdgeWorkItems401
  status: 401
}

export type getApiTeamsTeamIdEdgeWorkItemsResponse403TextPlain = {
  data: ProblemDetails
  status: 403
}

export type getApiTeamsTeamIdEdgeWorkItemsResponse403ApplicationJson = {
  data: ProblemDetails
  status: 403
}

export type getApiTeamsTeamIdEdgeWorkItemsResponse403TextJson = {
  data: ProblemDetails
  status: 403
}

export type getApiTeamsTeamIdEdgeWorkItemsResponse500 = {
  data: void
  status: 500
}

export type getApiTeamsTeamIdEdgeWorkItemsResponseSuccess = (getApiTeamsTeamIdEdgeWorkItemsResponse200TextPlain | getApiTeamsTeamIdEdgeWorkItemsResponse200ApplicationJson | getApiTeamsTeamIdEdgeWorkItemsResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsTeamIdEdgeWorkItemsResponseError = (getApiTeamsTeamIdEdgeWorkItemsResponse400TextPlain | getApiTeamsTeamIdEdgeWorkItemsResponse400ApplicationJson | getApiTeamsTeamIdEdgeWorkItemsResponse400TextJson | getApiTeamsTeamIdEdgeWorkItemsResponse401 | getApiTeamsTeamIdEdgeWorkItemsResponse403TextPlain | getApiTeamsTeamIdEdgeWorkItemsResponse403ApplicationJson | getApiTeamsTeamIdEdgeWorkItemsResponse403TextJson | getApiTeamsTeamIdEdgeWorkItemsResponse500) & {
  headers: Headers;
};

export type getApiTeamsTeamIdEdgeWorkItemsResponse = (getApiTeamsTeamIdEdgeWorkItemsResponseSuccess | getApiTeamsTeamIdEdgeWorkItemsResponseError)

export const getGetApiTeamsTeamIdEdgeWorkItemsUrl = (teamId: string,
    params?: GetApiTeamsTeamIdEdgeWorkItemsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/edge/work-items?${stringifiedParams}` : `/api/teams/${teamId}/edge/work-items`
}

export const getApiTeamsTeamIdEdgeWorkItems = async (teamId: string,
    params?: GetApiTeamsTeamIdEdgeWorkItemsParams, options?: RequestInit): Promise<getApiTeamsTeamIdEdgeWorkItemsResponse> => {

  return fetcher<getApiTeamsTeamIdEdgeWorkItemsResponse>(getGetApiTeamsTeamIdEdgeWorkItemsUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdResponse200TextPlain = {
  data: EdgeWorkItemDetailResponse
  status: 200
}

export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdResponse200ApplicationJson = {
  data: EdgeWorkItemDetailResponse
  status: 200
}

export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdResponse200TextJson = {
  data: EdgeWorkItemDetailResponse
  status: 200
}

export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdResponse400TextPlain = {
  data: ProblemDetails
  status: 400
}

export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdResponse400ApplicationJson = {
  data: ProblemDetails
  status: 400
}

export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdResponse400TextJson = {
  data: ProblemDetails
  status: 400
}

export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdResponse401 = {
  data: GetApiTeamsTeamIdEdgeWorkItemsWorkerId401
  status: 401
}

export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdResponse403TextPlain = {
  data: ProblemDetails
  status: 403
}

export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdResponse403ApplicationJson = {
  data: ProblemDetails
  status: 403
}

export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdResponse403TextJson = {
  data: ProblemDetails
  status: 403
}

export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdResponse404TextPlain = {
  data: ProblemDetails
  status: 404
}

export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdResponse404ApplicationJson = {
  data: ProblemDetails
  status: 404
}

export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdResponse404TextJson = {
  data: ProblemDetails
  status: 404
}

export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdResponse500 = {
  data: void
  status: 500
}

export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdResponseSuccess = (getApiTeamsTeamIdEdgeWorkItemsWorkerIdResponse200TextPlain | getApiTeamsTeamIdEdgeWorkItemsWorkerIdResponse200ApplicationJson | getApiTeamsTeamIdEdgeWorkItemsWorkerIdResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdResponseError = (getApiTeamsTeamIdEdgeWorkItemsWorkerIdResponse400TextPlain | getApiTeamsTeamIdEdgeWorkItemsWorkerIdResponse400ApplicationJson | getApiTeamsTeamIdEdgeWorkItemsWorkerIdResponse400TextJson | getApiTeamsTeamIdEdgeWorkItemsWorkerIdResponse401 | getApiTeamsTeamIdEdgeWorkItemsWorkerIdResponse403TextPlain | getApiTeamsTeamIdEdgeWorkItemsWorkerIdResponse403ApplicationJson | getApiTeamsTeamIdEdgeWorkItemsWorkerIdResponse403TextJson | getApiTeamsTeamIdEdgeWorkItemsWorkerIdResponse404TextPlain | getApiTeamsTeamIdEdgeWorkItemsWorkerIdResponse404ApplicationJson | getApiTeamsTeamIdEdgeWorkItemsWorkerIdResponse404TextJson | getApiTeamsTeamIdEdgeWorkItemsWorkerIdResponse500) & {
  headers: Headers;
};

export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdResponse = (getApiTeamsTeamIdEdgeWorkItemsWorkerIdResponseSuccess | getApiTeamsTeamIdEdgeWorkItemsWorkerIdResponseError)

export const getGetApiTeamsTeamIdEdgeWorkItemsWorkerIdUrl = (teamId: string,
    workerId: string,) => {




  return `/api/teams/${teamId}/edge/work-items/${workerId}`
}

export const getApiTeamsTeamIdEdgeWorkItemsWorkerId = async (teamId: string,
    workerId: string, options?: RequestInit): Promise<getApiTeamsTeamIdEdgeWorkItemsWorkerIdResponse> => {

  return fetcher<getApiTeamsTeamIdEdgeWorkItemsWorkerIdResponse>(getGetApiTeamsTeamIdEdgeWorkItemsWorkerIdUrl(teamId,workerId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdDecisionResponse200TextPlain = {
  data: EdgeWorkItemDetailResponse
  status: 200
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdDecisionResponse200ApplicationJson = {
  data: EdgeWorkItemDetailResponse
  status: 200
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdDecisionResponse200TextJson = {
  data: EdgeWorkItemDetailResponse
  status: 200
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdDecisionResponse400TextPlain = {
  data: ProblemDetails
  status: 400
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdDecisionResponse400ApplicationJson = {
  data: ProblemDetails
  status: 400
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdDecisionResponse400TextJson = {
  data: ProblemDetails
  status: 400
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdDecisionResponse401 = {
  data: PostApiTeamsTeamIdEdgeWorkItemsWorkerIdDecision401
  status: 401
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdDecisionResponse402 = {
  data: PostApiTeamsTeamIdEdgeWorkItemsWorkerIdDecision402
  status: 402
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdDecisionResponse403TextPlain = {
  data: ProblemDetails
  status: 403
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdDecisionResponse403ApplicationJson = {
  data: ProblemDetails
  status: 403
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdDecisionResponse403TextJson = {
  data: ProblemDetails
  status: 403
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdDecisionResponse404TextPlain = {
  data: ProblemDetails
  status: 404
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdDecisionResponse404ApplicationJson = {
  data: ProblemDetails
  status: 404
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdDecisionResponse404TextJson = {
  data: ProblemDetails
  status: 404
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdDecisionResponse409TextPlain = {
  data: EdgeWorkDecisionConflictResponse
  status: 409
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdDecisionResponse409ApplicationJson = {
  data: EdgeWorkDecisionConflictResponse
  status: 409
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdDecisionResponse409TextJson = {
  data: EdgeWorkDecisionConflictResponse
  status: 409
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdDecisionResponse500 = {
  data: void
  status: 500
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdDecisionResponseSuccess = (postApiTeamsTeamIdEdgeWorkItemsWorkerIdDecisionResponse200TextPlain | postApiTeamsTeamIdEdgeWorkItemsWorkerIdDecisionResponse200ApplicationJson | postApiTeamsTeamIdEdgeWorkItemsWorkerIdDecisionResponse200TextJson) & {
  headers: Headers;
};
export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdDecisionResponseError = (postApiTeamsTeamIdEdgeWorkItemsWorkerIdDecisionResponse400TextPlain | postApiTeamsTeamIdEdgeWorkItemsWorkerIdDecisionResponse400ApplicationJson | postApiTeamsTeamIdEdgeWorkItemsWorkerIdDecisionResponse400TextJson | postApiTeamsTeamIdEdgeWorkItemsWorkerIdDecisionResponse401 | postApiTeamsTeamIdEdgeWorkItemsWorkerIdDecisionResponse402 | postApiTeamsTeamIdEdgeWorkItemsWorkerIdDecisionResponse403TextPlain | postApiTeamsTeamIdEdgeWorkItemsWorkerIdDecisionResponse403ApplicationJson | postApiTeamsTeamIdEdgeWorkItemsWorkerIdDecisionResponse403TextJson | postApiTeamsTeamIdEdgeWorkItemsWorkerIdDecisionResponse404TextPlain | postApiTeamsTeamIdEdgeWorkItemsWorkerIdDecisionResponse404ApplicationJson | postApiTeamsTeamIdEdgeWorkItemsWorkerIdDecisionResponse404TextJson | postApiTeamsTeamIdEdgeWorkItemsWorkerIdDecisionResponse409TextPlain | postApiTeamsTeamIdEdgeWorkItemsWorkerIdDecisionResponse409ApplicationJson | postApiTeamsTeamIdEdgeWorkItemsWorkerIdDecisionResponse409TextJson | postApiTeamsTeamIdEdgeWorkItemsWorkerIdDecisionResponse500) & {
  headers: Headers;
};

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdDecisionResponse = (postApiTeamsTeamIdEdgeWorkItemsWorkerIdDecisionResponseSuccess | postApiTeamsTeamIdEdgeWorkItemsWorkerIdDecisionResponseError)

export const getPostApiTeamsTeamIdEdgeWorkItemsWorkerIdDecisionUrl = (teamId: string,
    workerId: string,) => {




  return `/api/teams/${teamId}/edge/work-items/${workerId}/decision`
}

export const postApiTeamsTeamIdEdgeWorkItemsWorkerIdDecision = async (teamId: string,
    workerId: string,
    decideEdgeWorkRequest: DecideEdgeWorkRequest, options?: RequestInit): Promise<postApiTeamsTeamIdEdgeWorkItemsWorkerIdDecisionResponse> => {

  return fetcher<postApiTeamsTeamIdEdgeWorkItemsWorkerIdDecisionResponse>(getPostApiTeamsTeamIdEdgeWorkItemsWorkerIdDecisionUrl(teamId,workerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      decideEdgeWorkRequest,)
  }
);}



export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdCommitResponse200TextPlain = {
  data: EdgeWorkItemDetailResponse
  status: 200
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdCommitResponse200ApplicationJson = {
  data: EdgeWorkItemDetailResponse
  status: 200
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdCommitResponse200TextJson = {
  data: EdgeWorkItemDetailResponse
  status: 200
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdCommitResponse400TextPlain = {
  data: ProblemDetails
  status: 400
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdCommitResponse400ApplicationJson = {
  data: ProblemDetails
  status: 400
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdCommitResponse400TextJson = {
  data: ProblemDetails
  status: 400
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdCommitResponse401 = {
  data: PostApiTeamsTeamIdEdgeWorkItemsWorkerIdCommit401
  status: 401
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdCommitResponse402 = {
  data: PostApiTeamsTeamIdEdgeWorkItemsWorkerIdCommit402
  status: 402
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdCommitResponse403TextPlain = {
  data: ProblemDetails
  status: 403
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdCommitResponse403ApplicationJson = {
  data: ProblemDetails
  status: 403
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdCommitResponse403TextJson = {
  data: ProblemDetails
  status: 403
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdCommitResponse404TextPlain = {
  data: ProblemDetails
  status: 404
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdCommitResponse404ApplicationJson = {
  data: ProblemDetails
  status: 404
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdCommitResponse404TextJson = {
  data: ProblemDetails
  status: 404
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdCommitResponse409TextPlain = {
  data: EdgeWorkCommitConflictResponse
  status: 409
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdCommitResponse409ApplicationJson = {
  data: EdgeWorkCommitConflictResponse
  status: 409
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdCommitResponse409TextJson = {
  data: EdgeWorkCommitConflictResponse
  status: 409
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdCommitResponse500 = {
  data: void
  status: 500
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdCommitResponseSuccess = (postApiTeamsTeamIdEdgeWorkItemsWorkerIdCommitResponse200TextPlain | postApiTeamsTeamIdEdgeWorkItemsWorkerIdCommitResponse200ApplicationJson | postApiTeamsTeamIdEdgeWorkItemsWorkerIdCommitResponse200TextJson) & {
  headers: Headers;
};
export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdCommitResponseError = (postApiTeamsTeamIdEdgeWorkItemsWorkerIdCommitResponse400TextPlain | postApiTeamsTeamIdEdgeWorkItemsWorkerIdCommitResponse400ApplicationJson | postApiTeamsTeamIdEdgeWorkItemsWorkerIdCommitResponse400TextJson | postApiTeamsTeamIdEdgeWorkItemsWorkerIdCommitResponse401 | postApiTeamsTeamIdEdgeWorkItemsWorkerIdCommitResponse402 | postApiTeamsTeamIdEdgeWorkItemsWorkerIdCommitResponse403TextPlain | postApiTeamsTeamIdEdgeWorkItemsWorkerIdCommitResponse403ApplicationJson | postApiTeamsTeamIdEdgeWorkItemsWorkerIdCommitResponse403TextJson | postApiTeamsTeamIdEdgeWorkItemsWorkerIdCommitResponse404TextPlain | postApiTeamsTeamIdEdgeWorkItemsWorkerIdCommitResponse404ApplicationJson | postApiTeamsTeamIdEdgeWorkItemsWorkerIdCommitResponse404TextJson | postApiTeamsTeamIdEdgeWorkItemsWorkerIdCommitResponse409TextPlain | postApiTeamsTeamIdEdgeWorkItemsWorkerIdCommitResponse409ApplicationJson | postApiTeamsTeamIdEdgeWorkItemsWorkerIdCommitResponse409TextJson | postApiTeamsTeamIdEdgeWorkItemsWorkerIdCommitResponse500) & {
  headers: Headers;
};

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdCommitResponse = (postApiTeamsTeamIdEdgeWorkItemsWorkerIdCommitResponseSuccess | postApiTeamsTeamIdEdgeWorkItemsWorkerIdCommitResponseError)

export const getPostApiTeamsTeamIdEdgeWorkItemsWorkerIdCommitUrl = (teamId: string,
    workerId: string,) => {




  return `/api/teams/${teamId}/edge/work-items/${workerId}/commit`
}

export const postApiTeamsTeamIdEdgeWorkItemsWorkerIdCommit = async (teamId: string,
    workerId: string, options?: RequestInit): Promise<postApiTeamsTeamIdEdgeWorkItemsWorkerIdCommitResponse> => {

  return fetcher<postApiTeamsTeamIdEdgeWorkItemsWorkerIdCommitResponse>(getPostApiTeamsTeamIdEdgeWorkItemsWorkerIdCommitUrl(teamId,workerId),
  {
    ...options,
    method: 'POST'


  }
);}



export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponse200TextPlain = {
  data: EdgeWorkItemDetailResponse
  status: 200
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponse200ApplicationJson = {
  data: EdgeWorkItemDetailResponse
  status: 200
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponse200TextJson = {
  data: EdgeWorkItemDetailResponse
  status: 200
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponse202TextPlain = {
  data: EdgeWorkItemDetailResponse
  status: 202
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponse202ApplicationJson = {
  data: EdgeWorkItemDetailResponse
  status: 202
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponse202TextJson = {
  data: EdgeWorkItemDetailResponse
  status: 202
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponse400TextPlain = {
  data: ProblemDetails
  status: 400
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponse400ApplicationJson = {
  data: ProblemDetails
  status: 400
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponse400TextJson = {
  data: ProblemDetails
  status: 400
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponse401 = {
  data: PostApiTeamsTeamIdEdgeWorkItemsWorkerIdCancel401
  status: 401
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponse402 = {
  data: PostApiTeamsTeamIdEdgeWorkItemsWorkerIdCancel402
  status: 402
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponse403TextPlain = {
  data: ProblemDetails
  status: 403
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponse403ApplicationJson = {
  data: ProblemDetails
  status: 403
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponse403TextJson = {
  data: ProblemDetails
  status: 403
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponse404TextPlain = {
  data: ProblemDetails
  status: 404
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponse404ApplicationJson = {
  data: ProblemDetails
  status: 404
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponse404TextJson = {
  data: ProblemDetails
  status: 404
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponse409TextPlain = {
  data: EdgeWorkCancelConflictResponse
  status: 409
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponse409ApplicationJson = {
  data: EdgeWorkCancelConflictResponse
  status: 409
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponse409TextJson = {
  data: EdgeWorkCancelConflictResponse
  status: 409
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponse500 = {
  data: void
  status: 500
}

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponseSuccess = (postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponse200TextPlain | postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponse200ApplicationJson | postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponse200TextJson | postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponse202TextPlain | postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponse202ApplicationJson | postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponse202TextJson) & {
  headers: Headers;
};
export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponseError = (postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponse400TextPlain | postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponse400ApplicationJson | postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponse400TextJson | postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponse401 | postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponse402 | postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponse403TextPlain | postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponse403ApplicationJson | postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponse403TextJson | postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponse404TextPlain | postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponse404ApplicationJson | postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponse404TextJson | postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponse409TextPlain | postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponse409ApplicationJson | postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponse409TextJson | postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponse500) & {
  headers: Headers;
};

export type postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponse = (postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponseSuccess | postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponseError)

export const getPostApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelUrl = (teamId: string,
    workerId: string,) => {




  return `/api/teams/${teamId}/edge/work-items/${workerId}/cancel`
}

export const postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancel = async (teamId: string,
    workerId: string, options?: RequestInit): Promise<postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponse> => {

  return fetcher<postApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelResponse>(getPostApiTeamsTeamIdEdgeWorkItemsWorkerIdCancelUrl(teamId,workerId),
  {
    ...options,
    method: 'POST'


  }
);}



export type postApiEdgeWorkClaimResponse200TextPlain = {
  data: ClaimEdgeWorkResponse
  status: 200
}

export type postApiEdgeWorkClaimResponse200ApplicationJson = {
  data: ClaimEdgeWorkResponse
  status: 200
}

export type postApiEdgeWorkClaimResponse200TextJson = {
  data: ClaimEdgeWorkResponse
  status: 200
}

export type postApiEdgeWorkClaimResponse401TextPlain = {
  data: ProblemDetails
  status: 401
}

export type postApiEdgeWorkClaimResponse401ApplicationJson = {
  data: ProblemDetails
  status: 401
}

export type postApiEdgeWorkClaimResponse401TextJson = {
  data: ProblemDetails
  status: 401
}

export type postApiEdgeWorkClaimResponse500 = {
  data: void
  status: 500
}

export type postApiEdgeWorkClaimResponseSuccess = (postApiEdgeWorkClaimResponse200TextPlain | postApiEdgeWorkClaimResponse200ApplicationJson | postApiEdgeWorkClaimResponse200TextJson) & {
  headers: Headers;
};
export type postApiEdgeWorkClaimResponseError = (postApiEdgeWorkClaimResponse401TextPlain | postApiEdgeWorkClaimResponse401ApplicationJson | postApiEdgeWorkClaimResponse401TextJson | postApiEdgeWorkClaimResponse500) & {
  headers: Headers;
};

export type postApiEdgeWorkClaimResponse = (postApiEdgeWorkClaimResponseSuccess | postApiEdgeWorkClaimResponseError)

export const getPostApiEdgeWorkClaimUrl = () => {




  return `/api/edge/work/claim`
}

export const postApiEdgeWorkClaim = async (nullClaimEdgeWorkRequest: null | ClaimEdgeWorkRequest, options?: RequestInit): Promise<postApiEdgeWorkClaimResponse> => {

  return fetcher<postApiEdgeWorkClaimResponse>(getPostApiEdgeWorkClaimUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullClaimEdgeWorkRequest,)
  }
);}



export type postApiEdgeWorkWorkerIdEventsResponse200TextPlain = {
  data: EdgeWorkEventResponse
  status: 200
}

export type postApiEdgeWorkWorkerIdEventsResponse200ApplicationJson = {
  data: EdgeWorkEventResponse
  status: 200
}

export type postApiEdgeWorkWorkerIdEventsResponse200TextJson = {
  data: EdgeWorkEventResponse
  status: 200
}

export type postApiEdgeWorkWorkerIdEventsResponse400TextPlain = {
  data: ProblemDetails
  status: 400
}

export type postApiEdgeWorkWorkerIdEventsResponse400ApplicationJson = {
  data: ProblemDetails
  status: 400
}

export type postApiEdgeWorkWorkerIdEventsResponse400TextJson = {
  data: ProblemDetails
  status: 400
}

export type postApiEdgeWorkWorkerIdEventsResponse401TextPlain = {
  data: ProblemDetails
  status: 401
}

export type postApiEdgeWorkWorkerIdEventsResponse401ApplicationJson = {
  data: ProblemDetails
  status: 401
}

export type postApiEdgeWorkWorkerIdEventsResponse401TextJson = {
  data: ProblemDetails
  status: 401
}

export type postApiEdgeWorkWorkerIdEventsResponse404TextPlain = {
  data: ProblemDetails
  status: 404
}

export type postApiEdgeWorkWorkerIdEventsResponse404ApplicationJson = {
  data: ProblemDetails
  status: 404
}

export type postApiEdgeWorkWorkerIdEventsResponse404TextJson = {
  data: ProblemDetails
  status: 404
}

export type postApiEdgeWorkWorkerIdEventsResponse500 = {
  data: void
  status: 500
}

export type postApiEdgeWorkWorkerIdEventsResponseSuccess = (postApiEdgeWorkWorkerIdEventsResponse200TextPlain | postApiEdgeWorkWorkerIdEventsResponse200ApplicationJson | postApiEdgeWorkWorkerIdEventsResponse200TextJson) & {
  headers: Headers;
};
export type postApiEdgeWorkWorkerIdEventsResponseError = (postApiEdgeWorkWorkerIdEventsResponse400TextPlain | postApiEdgeWorkWorkerIdEventsResponse400ApplicationJson | postApiEdgeWorkWorkerIdEventsResponse400TextJson | postApiEdgeWorkWorkerIdEventsResponse401TextPlain | postApiEdgeWorkWorkerIdEventsResponse401ApplicationJson | postApiEdgeWorkWorkerIdEventsResponse401TextJson | postApiEdgeWorkWorkerIdEventsResponse404TextPlain | postApiEdgeWorkWorkerIdEventsResponse404ApplicationJson | postApiEdgeWorkWorkerIdEventsResponse404TextJson | postApiEdgeWorkWorkerIdEventsResponse500) & {
  headers: Headers;
};

export type postApiEdgeWorkWorkerIdEventsResponse = (postApiEdgeWorkWorkerIdEventsResponseSuccess | postApiEdgeWorkWorkerIdEventsResponseError)

export const getPostApiEdgeWorkWorkerIdEventsUrl = (workerId: string,) => {




  return `/api/edge/work/${workerId}/events`
}

export const postApiEdgeWorkWorkerIdEvents = async (workerId: string,
    reportEdgeWorkEventRequest: ReportEdgeWorkEventRequest, options?: RequestInit): Promise<postApiEdgeWorkWorkerIdEventsResponse> => {

  return fetcher<postApiEdgeWorkWorkerIdEventsResponse>(getPostApiEdgeWorkWorkerIdEventsUrl(workerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      reportEdgeWorkEventRequest,)
  }
);}



export type postApiEdgeWorkWorkerIdCompleteResponse200TextPlain = {
  data: CompleteEdgeWorkResponse
  status: 200
}

export type postApiEdgeWorkWorkerIdCompleteResponse200ApplicationJson = {
  data: CompleteEdgeWorkResponse
  status: 200
}

export type postApiEdgeWorkWorkerIdCompleteResponse200TextJson = {
  data: CompleteEdgeWorkResponse
  status: 200
}

export type postApiEdgeWorkWorkerIdCompleteResponse400TextPlain = {
  data: ProblemDetails
  status: 400
}

export type postApiEdgeWorkWorkerIdCompleteResponse400ApplicationJson = {
  data: ProblemDetails
  status: 400
}

export type postApiEdgeWorkWorkerIdCompleteResponse400TextJson = {
  data: ProblemDetails
  status: 400
}

export type postApiEdgeWorkWorkerIdCompleteResponse401TextPlain = {
  data: ProblemDetails
  status: 401
}

export type postApiEdgeWorkWorkerIdCompleteResponse401ApplicationJson = {
  data: ProblemDetails
  status: 401
}

export type postApiEdgeWorkWorkerIdCompleteResponse401TextJson = {
  data: ProblemDetails
  status: 401
}

export type postApiEdgeWorkWorkerIdCompleteResponse404TextPlain = {
  data: ProblemDetails
  status: 404
}

export type postApiEdgeWorkWorkerIdCompleteResponse404ApplicationJson = {
  data: ProblemDetails
  status: 404
}

export type postApiEdgeWorkWorkerIdCompleteResponse404TextJson = {
  data: ProblemDetails
  status: 404
}

export type postApiEdgeWorkWorkerIdCompleteResponse409TextPlain = {
  data: ProblemDetails
  status: 409
}

export type postApiEdgeWorkWorkerIdCompleteResponse409ApplicationJson = {
  data: ProblemDetails
  status: 409
}

export type postApiEdgeWorkWorkerIdCompleteResponse409TextJson = {
  data: ProblemDetails
  status: 409
}

export type postApiEdgeWorkWorkerIdCompleteResponse500 = {
  data: void
  status: 500
}

export type postApiEdgeWorkWorkerIdCompleteResponseSuccess = (postApiEdgeWorkWorkerIdCompleteResponse200TextPlain | postApiEdgeWorkWorkerIdCompleteResponse200ApplicationJson | postApiEdgeWorkWorkerIdCompleteResponse200TextJson) & {
  headers: Headers;
};
export type postApiEdgeWorkWorkerIdCompleteResponseError = (postApiEdgeWorkWorkerIdCompleteResponse400TextPlain | postApiEdgeWorkWorkerIdCompleteResponse400ApplicationJson | postApiEdgeWorkWorkerIdCompleteResponse400TextJson | postApiEdgeWorkWorkerIdCompleteResponse401TextPlain | postApiEdgeWorkWorkerIdCompleteResponse401ApplicationJson | postApiEdgeWorkWorkerIdCompleteResponse401TextJson | postApiEdgeWorkWorkerIdCompleteResponse404TextPlain | postApiEdgeWorkWorkerIdCompleteResponse404ApplicationJson | postApiEdgeWorkWorkerIdCompleteResponse404TextJson | postApiEdgeWorkWorkerIdCompleteResponse409TextPlain | postApiEdgeWorkWorkerIdCompleteResponse409ApplicationJson | postApiEdgeWorkWorkerIdCompleteResponse409TextJson | postApiEdgeWorkWorkerIdCompleteResponse500) & {
  headers: Headers;
};

export type postApiEdgeWorkWorkerIdCompleteResponse = (postApiEdgeWorkWorkerIdCompleteResponseSuccess | postApiEdgeWorkWorkerIdCompleteResponseError)

export const getPostApiEdgeWorkWorkerIdCompleteUrl = (workerId: string,) => {




  return `/api/edge/work/${workerId}/complete`
}

export const postApiEdgeWorkWorkerIdComplete = async (workerId: string,
    completeEdgeWorkRequest: CompleteEdgeWorkRequest, options?: RequestInit): Promise<postApiEdgeWorkWorkerIdCompleteResponse> => {

  return fetcher<postApiEdgeWorkWorkerIdCompleteResponse>(getPostApiEdgeWorkWorkerIdCompleteUrl(workerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      completeEdgeWorkRequest,)
  }
);}



export type postApiEdgeWorkWorkerIdArtifactsResponse200TextPlain = {
  data: EdgeWorkArtifactResponse
  status: 200
}

export type postApiEdgeWorkWorkerIdArtifactsResponse200ApplicationJson = {
  data: EdgeWorkArtifactResponse
  status: 200
}

export type postApiEdgeWorkWorkerIdArtifactsResponse200TextJson = {
  data: EdgeWorkArtifactResponse
  status: 200
}

export type postApiEdgeWorkWorkerIdArtifactsResponse400TextPlain = {
  data: ProblemDetails
  status: 400
}

export type postApiEdgeWorkWorkerIdArtifactsResponse400ApplicationJson = {
  data: ProblemDetails
  status: 400
}

export type postApiEdgeWorkWorkerIdArtifactsResponse400TextJson = {
  data: ProblemDetails
  status: 400
}

export type postApiEdgeWorkWorkerIdArtifactsResponse401TextPlain = {
  data: ProblemDetails
  status: 401
}

export type postApiEdgeWorkWorkerIdArtifactsResponse401ApplicationJson = {
  data: ProblemDetails
  status: 401
}

export type postApiEdgeWorkWorkerIdArtifactsResponse401TextJson = {
  data: ProblemDetails
  status: 401
}

export type postApiEdgeWorkWorkerIdArtifactsResponse404TextPlain = {
  data: ProblemDetails
  status: 404
}

export type postApiEdgeWorkWorkerIdArtifactsResponse404ApplicationJson = {
  data: ProblemDetails
  status: 404
}

export type postApiEdgeWorkWorkerIdArtifactsResponse404TextJson = {
  data: ProblemDetails
  status: 404
}

export type postApiEdgeWorkWorkerIdArtifactsResponse409TextPlain = {
  data: ProblemDetails
  status: 409
}

export type postApiEdgeWorkWorkerIdArtifactsResponse409ApplicationJson = {
  data: ProblemDetails
  status: 409
}

export type postApiEdgeWorkWorkerIdArtifactsResponse409TextJson = {
  data: ProblemDetails
  status: 409
}

export type postApiEdgeWorkWorkerIdArtifactsResponse500 = {
  data: void
  status: 500
}

export type postApiEdgeWorkWorkerIdArtifactsResponseSuccess = (postApiEdgeWorkWorkerIdArtifactsResponse200TextPlain | postApiEdgeWorkWorkerIdArtifactsResponse200ApplicationJson | postApiEdgeWorkWorkerIdArtifactsResponse200TextJson) & {
  headers: Headers;
};
export type postApiEdgeWorkWorkerIdArtifactsResponseError = (postApiEdgeWorkWorkerIdArtifactsResponse400TextPlain | postApiEdgeWorkWorkerIdArtifactsResponse400ApplicationJson | postApiEdgeWorkWorkerIdArtifactsResponse400TextJson | postApiEdgeWorkWorkerIdArtifactsResponse401TextPlain | postApiEdgeWorkWorkerIdArtifactsResponse401ApplicationJson | postApiEdgeWorkWorkerIdArtifactsResponse401TextJson | postApiEdgeWorkWorkerIdArtifactsResponse404TextPlain | postApiEdgeWorkWorkerIdArtifactsResponse404ApplicationJson | postApiEdgeWorkWorkerIdArtifactsResponse404TextJson | postApiEdgeWorkWorkerIdArtifactsResponse409TextPlain | postApiEdgeWorkWorkerIdArtifactsResponse409ApplicationJson | postApiEdgeWorkWorkerIdArtifactsResponse409TextJson | postApiEdgeWorkWorkerIdArtifactsResponse500) & {
  headers: Headers;
};

export type postApiEdgeWorkWorkerIdArtifactsResponse = (postApiEdgeWorkWorkerIdArtifactsResponseSuccess | postApiEdgeWorkWorkerIdArtifactsResponseError)

export const getPostApiEdgeWorkWorkerIdArtifactsUrl = (workerId: string,) => {




  return `/api/edge/work/${workerId}/artifacts`
}

export const postApiEdgeWorkWorkerIdArtifacts = async (workerId: string,
    postApiEdgeWorkWorkerIdArtifactsBody: PostApiEdgeWorkWorkerIdArtifactsBody, options?: RequestInit): Promise<postApiEdgeWorkWorkerIdArtifactsResponse> => {
    const formData = new FormData();
formData.append(`claimToken`, postApiEdgeWorkWorkerIdArtifactsBody.claimToken);
formData.append(`evidenceKey`, postApiEdgeWorkWorkerIdArtifactsBody.evidenceKey);
formData.append(`file`, postApiEdgeWorkWorkerIdArtifactsBody.file);

  return fetcher<postApiEdgeWorkWorkerIdArtifactsResponse>(getPostApiEdgeWorkWorkerIdArtifactsUrl(workerId),
  {
    ...options,
    method: 'POST'
    ,
    body:
      formData,
  }
);}



export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdArtifactsResponse200TextPlain = {
  data: EdgeWorkArtifactResponse[]
  status: 200
}

export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdArtifactsResponse200ApplicationJson = {
  data: EdgeWorkArtifactResponse[]
  status: 200
}

export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdArtifactsResponse200TextJson = {
  data: EdgeWorkArtifactResponse[]
  status: 200
}

export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdArtifactsResponse400TextPlain = {
  data: ProblemDetails
  status: 400
}

export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdArtifactsResponse400ApplicationJson = {
  data: ProblemDetails
  status: 400
}

export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdArtifactsResponse400TextJson = {
  data: ProblemDetails
  status: 400
}

export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdArtifactsResponse401 = {
  data: GetApiTeamsTeamIdEdgeWorkItemsWorkerIdArtifacts401
  status: 401
}

export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdArtifactsResponse403TextPlain = {
  data: ProblemDetails
  status: 403
}

export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdArtifactsResponse403ApplicationJson = {
  data: ProblemDetails
  status: 403
}

export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdArtifactsResponse403TextJson = {
  data: ProblemDetails
  status: 403
}

export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdArtifactsResponse404TextPlain = {
  data: ProblemDetails
  status: 404
}

export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdArtifactsResponse404ApplicationJson = {
  data: ProblemDetails
  status: 404
}

export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdArtifactsResponse404TextJson = {
  data: ProblemDetails
  status: 404
}

export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdArtifactsResponse500 = {
  data: void
  status: 500
}

export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdArtifactsResponseSuccess = (getApiTeamsTeamIdEdgeWorkItemsWorkerIdArtifactsResponse200TextPlain | getApiTeamsTeamIdEdgeWorkItemsWorkerIdArtifactsResponse200ApplicationJson | getApiTeamsTeamIdEdgeWorkItemsWorkerIdArtifactsResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdArtifactsResponseError = (getApiTeamsTeamIdEdgeWorkItemsWorkerIdArtifactsResponse400TextPlain | getApiTeamsTeamIdEdgeWorkItemsWorkerIdArtifactsResponse400ApplicationJson | getApiTeamsTeamIdEdgeWorkItemsWorkerIdArtifactsResponse400TextJson | getApiTeamsTeamIdEdgeWorkItemsWorkerIdArtifactsResponse401 | getApiTeamsTeamIdEdgeWorkItemsWorkerIdArtifactsResponse403TextPlain | getApiTeamsTeamIdEdgeWorkItemsWorkerIdArtifactsResponse403ApplicationJson | getApiTeamsTeamIdEdgeWorkItemsWorkerIdArtifactsResponse403TextJson | getApiTeamsTeamIdEdgeWorkItemsWorkerIdArtifactsResponse404TextPlain | getApiTeamsTeamIdEdgeWorkItemsWorkerIdArtifactsResponse404ApplicationJson | getApiTeamsTeamIdEdgeWorkItemsWorkerIdArtifactsResponse404TextJson | getApiTeamsTeamIdEdgeWorkItemsWorkerIdArtifactsResponse500) & {
  headers: Headers;
};

export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdArtifactsResponse = (getApiTeamsTeamIdEdgeWorkItemsWorkerIdArtifactsResponseSuccess | getApiTeamsTeamIdEdgeWorkItemsWorkerIdArtifactsResponseError)

export const getGetApiTeamsTeamIdEdgeWorkItemsWorkerIdArtifactsUrl = (teamId: string,
    workerId: string,) => {




  return `/api/teams/${teamId}/edge/work-items/${workerId}/artifacts`
}

export const getApiTeamsTeamIdEdgeWorkItemsWorkerIdArtifacts = async (teamId: string,
    workerId: string, options?: RequestInit): Promise<getApiTeamsTeamIdEdgeWorkItemsWorkerIdArtifactsResponse> => {

  return fetcher<getApiTeamsTeamIdEdgeWorkItemsWorkerIdArtifactsResponse>(getGetApiTeamsTeamIdEdgeWorkItemsWorkerIdArtifactsUrl(teamId,workerId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiEdgeWorkWorkerIdInterventionResponse200TextPlain = {
  data: EdgeWorkInterventionResponse
  status: 200
}

export type postApiEdgeWorkWorkerIdInterventionResponse200ApplicationJson = {
  data: EdgeWorkInterventionResponse
  status: 200
}

export type postApiEdgeWorkWorkerIdInterventionResponse200TextJson = {
  data: EdgeWorkInterventionResponse
  status: 200
}

export type postApiEdgeWorkWorkerIdInterventionResponse400TextPlain = {
  data: ProblemDetails
  status: 400
}

export type postApiEdgeWorkWorkerIdInterventionResponse400ApplicationJson = {
  data: ProblemDetails
  status: 400
}

export type postApiEdgeWorkWorkerIdInterventionResponse400TextJson = {
  data: ProblemDetails
  status: 400
}

export type postApiEdgeWorkWorkerIdInterventionResponse401TextPlain = {
  data: ProblemDetails
  status: 401
}

export type postApiEdgeWorkWorkerIdInterventionResponse401ApplicationJson = {
  data: ProblemDetails
  status: 401
}

export type postApiEdgeWorkWorkerIdInterventionResponse401TextJson = {
  data: ProblemDetails
  status: 401
}

export type postApiEdgeWorkWorkerIdInterventionResponse404TextPlain = {
  data: ProblemDetails
  status: 404
}

export type postApiEdgeWorkWorkerIdInterventionResponse404ApplicationJson = {
  data: ProblemDetails
  status: 404
}

export type postApiEdgeWorkWorkerIdInterventionResponse404TextJson = {
  data: ProblemDetails
  status: 404
}

export type postApiEdgeWorkWorkerIdInterventionResponse409TextPlain = {
  data: ProblemDetails
  status: 409
}

export type postApiEdgeWorkWorkerIdInterventionResponse409ApplicationJson = {
  data: ProblemDetails
  status: 409
}

export type postApiEdgeWorkWorkerIdInterventionResponse409TextJson = {
  data: ProblemDetails
  status: 409
}

export type postApiEdgeWorkWorkerIdInterventionResponse500 = {
  data: void
  status: 500
}

export type postApiEdgeWorkWorkerIdInterventionResponseSuccess = (postApiEdgeWorkWorkerIdInterventionResponse200TextPlain | postApiEdgeWorkWorkerIdInterventionResponse200ApplicationJson | postApiEdgeWorkWorkerIdInterventionResponse200TextJson) & {
  headers: Headers;
};
export type postApiEdgeWorkWorkerIdInterventionResponseError = (postApiEdgeWorkWorkerIdInterventionResponse400TextPlain | postApiEdgeWorkWorkerIdInterventionResponse400ApplicationJson | postApiEdgeWorkWorkerIdInterventionResponse400TextJson | postApiEdgeWorkWorkerIdInterventionResponse401TextPlain | postApiEdgeWorkWorkerIdInterventionResponse401ApplicationJson | postApiEdgeWorkWorkerIdInterventionResponse401TextJson | postApiEdgeWorkWorkerIdInterventionResponse404TextPlain | postApiEdgeWorkWorkerIdInterventionResponse404ApplicationJson | postApiEdgeWorkWorkerIdInterventionResponse404TextJson | postApiEdgeWorkWorkerIdInterventionResponse409TextPlain | postApiEdgeWorkWorkerIdInterventionResponse409ApplicationJson | postApiEdgeWorkWorkerIdInterventionResponse409TextJson | postApiEdgeWorkWorkerIdInterventionResponse500) & {
  headers: Headers;
};

export type postApiEdgeWorkWorkerIdInterventionResponse = (postApiEdgeWorkWorkerIdInterventionResponseSuccess | postApiEdgeWorkWorkerIdInterventionResponseError)

export const getPostApiEdgeWorkWorkerIdInterventionUrl = (workerId: string,) => {




  return `/api/edge/work/${workerId}/intervention`
}

export const postApiEdgeWorkWorkerIdIntervention = async (workerId: string,
    reportEdgeWorkInterventionRequest: ReportEdgeWorkInterventionRequest, options?: RequestInit): Promise<postApiEdgeWorkWorkerIdInterventionResponse> => {

  return fetcher<postApiEdgeWorkWorkerIdInterventionResponse>(getPostApiEdgeWorkWorkerIdInterventionUrl(workerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      reportEdgeWorkInterventionRequest,)
  }
);}



export type postApiEdgeWorkWorkerIdInterventionResolveResponse200TextPlain = {
  data: EdgeWorkInterventionResponse
  status: 200
}

export type postApiEdgeWorkWorkerIdInterventionResolveResponse200ApplicationJson = {
  data: EdgeWorkInterventionResponse
  status: 200
}

export type postApiEdgeWorkWorkerIdInterventionResolveResponse200TextJson = {
  data: EdgeWorkInterventionResponse
  status: 200
}

export type postApiEdgeWorkWorkerIdInterventionResolveResponse400TextPlain = {
  data: ProblemDetails
  status: 400
}

export type postApiEdgeWorkWorkerIdInterventionResolveResponse400ApplicationJson = {
  data: ProblemDetails
  status: 400
}

export type postApiEdgeWorkWorkerIdInterventionResolveResponse400TextJson = {
  data: ProblemDetails
  status: 400
}

export type postApiEdgeWorkWorkerIdInterventionResolveResponse401TextPlain = {
  data: ProblemDetails
  status: 401
}

export type postApiEdgeWorkWorkerIdInterventionResolveResponse401ApplicationJson = {
  data: ProblemDetails
  status: 401
}

export type postApiEdgeWorkWorkerIdInterventionResolveResponse401TextJson = {
  data: ProblemDetails
  status: 401
}

export type postApiEdgeWorkWorkerIdInterventionResolveResponse404TextPlain = {
  data: ProblemDetails
  status: 404
}

export type postApiEdgeWorkWorkerIdInterventionResolveResponse404ApplicationJson = {
  data: ProblemDetails
  status: 404
}

export type postApiEdgeWorkWorkerIdInterventionResolveResponse404TextJson = {
  data: ProblemDetails
  status: 404
}

export type postApiEdgeWorkWorkerIdInterventionResolveResponse409TextPlain = {
  data: ProblemDetails
  status: 409
}

export type postApiEdgeWorkWorkerIdInterventionResolveResponse409ApplicationJson = {
  data: ProblemDetails
  status: 409
}

export type postApiEdgeWorkWorkerIdInterventionResolveResponse409TextJson = {
  data: ProblemDetails
  status: 409
}

export type postApiEdgeWorkWorkerIdInterventionResolveResponse500 = {
  data: void
  status: 500
}

export type postApiEdgeWorkWorkerIdInterventionResolveResponseSuccess = (postApiEdgeWorkWorkerIdInterventionResolveResponse200TextPlain | postApiEdgeWorkWorkerIdInterventionResolveResponse200ApplicationJson | postApiEdgeWorkWorkerIdInterventionResolveResponse200TextJson) & {
  headers: Headers;
};
export type postApiEdgeWorkWorkerIdInterventionResolveResponseError = (postApiEdgeWorkWorkerIdInterventionResolveResponse400TextPlain | postApiEdgeWorkWorkerIdInterventionResolveResponse400ApplicationJson | postApiEdgeWorkWorkerIdInterventionResolveResponse400TextJson | postApiEdgeWorkWorkerIdInterventionResolveResponse401TextPlain | postApiEdgeWorkWorkerIdInterventionResolveResponse401ApplicationJson | postApiEdgeWorkWorkerIdInterventionResolveResponse401TextJson | postApiEdgeWorkWorkerIdInterventionResolveResponse404TextPlain | postApiEdgeWorkWorkerIdInterventionResolveResponse404ApplicationJson | postApiEdgeWorkWorkerIdInterventionResolveResponse404TextJson | postApiEdgeWorkWorkerIdInterventionResolveResponse409TextPlain | postApiEdgeWorkWorkerIdInterventionResolveResponse409ApplicationJson | postApiEdgeWorkWorkerIdInterventionResolveResponse409TextJson | postApiEdgeWorkWorkerIdInterventionResolveResponse500) & {
  headers: Headers;
};

export type postApiEdgeWorkWorkerIdInterventionResolveResponse = (postApiEdgeWorkWorkerIdInterventionResolveResponseSuccess | postApiEdgeWorkWorkerIdInterventionResolveResponseError)

export const getPostApiEdgeWorkWorkerIdInterventionResolveUrl = (workerId: string,) => {




  return `/api/edge/work/${workerId}/intervention/resolve`
}

export const postApiEdgeWorkWorkerIdInterventionResolve = async (workerId: string,
    resolveEdgeWorkInterventionRequest: ResolveEdgeWorkInterventionRequest, options?: RequestInit): Promise<postApiEdgeWorkWorkerIdInterventionResolveResponse> => {

  return fetcher<postApiEdgeWorkWorkerIdInterventionResolveResponse>(getPostApiEdgeWorkWorkerIdInterventionResolveUrl(workerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      resolveEdgeWorkInterventionRequest,)
  }
);}



export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdInterventionsResponse200TextPlain = {
  data: EdgeWorkInterventionResponse[]
  status: 200
}

export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdInterventionsResponse200ApplicationJson = {
  data: EdgeWorkInterventionResponse[]
  status: 200
}

export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdInterventionsResponse200TextJson = {
  data: EdgeWorkInterventionResponse[]
  status: 200
}

export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdInterventionsResponse400TextPlain = {
  data: ProblemDetails
  status: 400
}

export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdInterventionsResponse400ApplicationJson = {
  data: ProblemDetails
  status: 400
}

export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdInterventionsResponse400TextJson = {
  data: ProblemDetails
  status: 400
}

export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdInterventionsResponse401 = {
  data: GetApiTeamsTeamIdEdgeWorkItemsWorkerIdInterventions401
  status: 401
}

export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdInterventionsResponse403TextPlain = {
  data: ProblemDetails
  status: 403
}

export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdInterventionsResponse403ApplicationJson = {
  data: ProblemDetails
  status: 403
}

export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdInterventionsResponse403TextJson = {
  data: ProblemDetails
  status: 403
}

export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdInterventionsResponse404TextPlain = {
  data: ProblemDetails
  status: 404
}

export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdInterventionsResponse404ApplicationJson = {
  data: ProblemDetails
  status: 404
}

export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdInterventionsResponse404TextJson = {
  data: ProblemDetails
  status: 404
}

export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdInterventionsResponse500 = {
  data: void
  status: 500
}

export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdInterventionsResponseSuccess = (getApiTeamsTeamIdEdgeWorkItemsWorkerIdInterventionsResponse200TextPlain | getApiTeamsTeamIdEdgeWorkItemsWorkerIdInterventionsResponse200ApplicationJson | getApiTeamsTeamIdEdgeWorkItemsWorkerIdInterventionsResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdInterventionsResponseError = (getApiTeamsTeamIdEdgeWorkItemsWorkerIdInterventionsResponse400TextPlain | getApiTeamsTeamIdEdgeWorkItemsWorkerIdInterventionsResponse400ApplicationJson | getApiTeamsTeamIdEdgeWorkItemsWorkerIdInterventionsResponse400TextJson | getApiTeamsTeamIdEdgeWorkItemsWorkerIdInterventionsResponse401 | getApiTeamsTeamIdEdgeWorkItemsWorkerIdInterventionsResponse403TextPlain | getApiTeamsTeamIdEdgeWorkItemsWorkerIdInterventionsResponse403ApplicationJson | getApiTeamsTeamIdEdgeWorkItemsWorkerIdInterventionsResponse403TextJson | getApiTeamsTeamIdEdgeWorkItemsWorkerIdInterventionsResponse404TextPlain | getApiTeamsTeamIdEdgeWorkItemsWorkerIdInterventionsResponse404ApplicationJson | getApiTeamsTeamIdEdgeWorkItemsWorkerIdInterventionsResponse404TextJson | getApiTeamsTeamIdEdgeWorkItemsWorkerIdInterventionsResponse500) & {
  headers: Headers;
};

export type getApiTeamsTeamIdEdgeWorkItemsWorkerIdInterventionsResponse = (getApiTeamsTeamIdEdgeWorkItemsWorkerIdInterventionsResponseSuccess | getApiTeamsTeamIdEdgeWorkItemsWorkerIdInterventionsResponseError)

export const getGetApiTeamsTeamIdEdgeWorkItemsWorkerIdInterventionsUrl = (teamId: string,
    workerId: string,) => {




  return `/api/teams/${teamId}/edge/work-items/${workerId}/interventions`
}

export const getApiTeamsTeamIdEdgeWorkItemsWorkerIdInterventions = async (teamId: string,
    workerId: string, options?: RequestInit): Promise<getApiTeamsTeamIdEdgeWorkItemsWorkerIdInterventionsResponse> => {

  return fetcher<getApiTeamsTeamIdEdgeWorkItemsWorkerIdInterventionsResponse>(getGetApiTeamsTeamIdEdgeWorkItemsWorkerIdInterventionsUrl(teamId,workerId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiEmailVerifyResponse200TextPlain = {
  data: EmailVerifyResponse
  status: 200
}

export type postApiEmailVerifyResponse200ApplicationJson = {
  data: EmailVerifyResponse
  status: 200
}

export type postApiEmailVerifyResponse200TextJson = {
  data: EmailVerifyResponse
  status: 200
}

export type postApiEmailVerifyResponse401 = {
  data: PostApiEmailVerify401
  status: 401
}

export type postApiEmailVerifyResponseSuccess = (postApiEmailVerifyResponse200TextPlain | postApiEmailVerifyResponse200ApplicationJson | postApiEmailVerifyResponse200TextJson) & {
  headers: Headers;
};
export type postApiEmailVerifyResponseError = (postApiEmailVerifyResponse401) & {
  headers: Headers;
};

export type postApiEmailVerifyResponse = (postApiEmailVerifyResponseSuccess | postApiEmailVerifyResponseError)

export const getPostApiEmailVerifyUrl = () => {




  return `/api/email/verify`
}

export const postApiEmailVerify = async (emailVerifyRequest: EmailVerifyRequest, options?: RequestInit): Promise<postApiEmailVerifyResponse> => {

  return fetcher<postApiEmailVerifyResponse>(getPostApiEmailVerifyUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      emailVerifyRequest,)
  }
);}



export type postApiFormsFormIdVersionsFormVersionIdGenerateResponse200 = {
  data: void
  status: 200
}

export type postApiFormsFormIdVersionsFormVersionIdGenerateResponse401 = {
  data: PostApiFormsFormIdVersionsFormVersionIdGenerate401
  status: 401
}

export type postApiFormsFormIdVersionsFormVersionIdGenerateResponse402 = {
  data: PostApiFormsFormIdVersionsFormVersionIdGenerate402
  status: 402
}

export type postApiFormsFormIdVersionsFormVersionIdGenerateResponseSuccess = (postApiFormsFormIdVersionsFormVersionIdGenerateResponse200) & {
  headers: Headers;
};
export type postApiFormsFormIdVersionsFormVersionIdGenerateResponseError = (postApiFormsFormIdVersionsFormVersionIdGenerateResponse401 | postApiFormsFormIdVersionsFormVersionIdGenerateResponse402) & {
  headers: Headers;
};

export type postApiFormsFormIdVersionsFormVersionIdGenerateResponse = (postApiFormsFormIdVersionsFormVersionIdGenerateResponseSuccess | postApiFormsFormIdVersionsFormVersionIdGenerateResponseError)

export const getPostApiFormsFormIdVersionsFormVersionIdGenerateUrl = (formId: string,
    formVersionId: string,) => {




  return `/api/Forms/${formId}/versions/${formVersionId}/generate`
}

export const postApiFormsFormIdVersionsFormVersionIdGenerate = async (formId: string,
    formVersionId: string, options?: RequestInit): Promise<postApiFormsFormIdVersionsFormVersionIdGenerateResponse> => {

  return fetcher<postApiFormsFormIdVersionsFormVersionIdGenerateResponse>(getPostApiFormsFormIdVersionsFormVersionIdGenerateUrl(formId,formVersionId),
  {
    ...options,
    method: 'POST'


  }
);}



export type getApiFormsFormVersionIdEffectiveResponse200 = {
  data: void
  status: 200
}

export type getApiFormsFormVersionIdEffectiveResponse401 = {
  data: GetApiFormsFormVersionIdEffective401
  status: 401
}

export type getApiFormsFormVersionIdEffectiveResponseSuccess = (getApiFormsFormVersionIdEffectiveResponse200) & {
  headers: Headers;
};
export type getApiFormsFormVersionIdEffectiveResponseError = (getApiFormsFormVersionIdEffectiveResponse401) & {
  headers: Headers;
};

export type getApiFormsFormVersionIdEffectiveResponse = (getApiFormsFormVersionIdEffectiveResponseSuccess | getApiFormsFormVersionIdEffectiveResponseError)

export const getGetApiFormsFormVersionIdEffectiveUrl = (formVersionId: string,) => {




  return `/api/Forms/${formVersionId}/effective`
}

export const getApiFormsFormVersionIdEffective = async (formVersionId: string, options?: RequestInit): Promise<getApiFormsFormVersionIdEffectiveResponse> => {

  return fetcher<getApiFormsFormVersionIdEffectiveResponse>(getGetApiFormsFormVersionIdEffectiveUrl(formVersionId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiFormsFormIdVersionsVersionEffectiveResponse200 = {
  data: void
  status: 200
}

export type getApiFormsFormIdVersionsVersionEffectiveResponse401 = {
  data: GetApiFormsFormIdVersionsVersionEffective401
  status: 401
}

export type getApiFormsFormIdVersionsVersionEffectiveResponseSuccess = (getApiFormsFormIdVersionsVersionEffectiveResponse200) & {
  headers: Headers;
};
export type getApiFormsFormIdVersionsVersionEffectiveResponseError = (getApiFormsFormIdVersionsVersionEffectiveResponse401) & {
  headers: Headers;
};

export type getApiFormsFormIdVersionsVersionEffectiveResponse = (getApiFormsFormIdVersionsVersionEffectiveResponseSuccess | getApiFormsFormIdVersionsVersionEffectiveResponseError)

export const getGetApiFormsFormIdVersionsVersionEffectiveUrl = (formId: string,
    version: number,) => {




  return `/api/Forms/${formId}/versions/${version}/effective`
}

export const getApiFormsFormIdVersionsVersionEffective = async (formId: string,
    version: number, options?: RequestInit): Promise<getApiFormsFormIdVersionsVersionEffectiveResponse> => {

  return fetcher<getApiFormsFormIdVersionsVersionEffectiveResponse>(getGetApiFormsFormIdVersionsVersionEffectiveUrl(formId,version),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiFormsFormVersionIdViewerResponse200 = {
  data: void
  status: 200
}

export type getApiFormsFormVersionIdViewerResponse401 = {
  data: GetApiFormsFormVersionIdViewer401
  status: 401
}

export type getApiFormsFormVersionIdViewerResponseSuccess = (getApiFormsFormVersionIdViewerResponse200) & {
  headers: Headers;
};
export type getApiFormsFormVersionIdViewerResponseError = (getApiFormsFormVersionIdViewerResponse401) & {
  headers: Headers;
};

export type getApiFormsFormVersionIdViewerResponse = (getApiFormsFormVersionIdViewerResponseSuccess | getApiFormsFormVersionIdViewerResponseError)

export const getGetApiFormsFormVersionIdViewerUrl = (formVersionId: string,) => {




  return `/api/Forms/${formVersionId}/viewer`
}

export const getApiFormsFormVersionIdViewer = async (formVersionId: string, options?: RequestInit): Promise<getApiFormsFormVersionIdViewerResponse> => {

  return fetcher<getApiFormsFormVersionIdViewerResponse>(getGetApiFormsFormVersionIdViewerUrl(formVersionId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiFormsFormVersionIdPdfContentResponse200 = {
  data: void
  status: 200
}

export type getApiFormsFormVersionIdPdfContentResponse401 = {
  data: GetApiFormsFormVersionIdPdfContent401
  status: 401
}

export type getApiFormsFormVersionIdPdfContentResponseSuccess = (getApiFormsFormVersionIdPdfContentResponse200) & {
  headers: Headers;
};
export type getApiFormsFormVersionIdPdfContentResponseError = (getApiFormsFormVersionIdPdfContentResponse401) & {
  headers: Headers;
};

export type getApiFormsFormVersionIdPdfContentResponse = (getApiFormsFormVersionIdPdfContentResponseSuccess | getApiFormsFormVersionIdPdfContentResponseError)

export const getGetApiFormsFormVersionIdPdfContentUrl = (formVersionId: string,
    params?: GetApiFormsFormVersionIdPdfContentParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Forms/${formVersionId}/pdf/content?${stringifiedParams}` : `/api/Forms/${formVersionId}/pdf/content`
}

export const getApiFormsFormVersionIdPdfContent = async (formVersionId: string,
    params?: GetApiFormsFormVersionIdPdfContentParams, options?: RequestInit): Promise<getApiFormsFormVersionIdPdfContentResponse> => {

  return fetcher<getApiFormsFormVersionIdPdfContentResponse>(getGetApiFormsFormVersionIdPdfContentUrl(formVersionId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiFormsFormVersionIdPdfLayoutResponse200 = {
  data: void
  status: 200
}

export type postApiFormsFormVersionIdPdfLayoutResponse401 = {
  data: PostApiFormsFormVersionIdPdfLayout401
  status: 401
}

export type postApiFormsFormVersionIdPdfLayoutResponse402 = {
  data: PostApiFormsFormVersionIdPdfLayout402
  status: 402
}

export type postApiFormsFormVersionIdPdfLayoutResponseSuccess = (postApiFormsFormVersionIdPdfLayoutResponse200) & {
  headers: Headers;
};
export type postApiFormsFormVersionIdPdfLayoutResponseError = (postApiFormsFormVersionIdPdfLayoutResponse401 | postApiFormsFormVersionIdPdfLayoutResponse402) & {
  headers: Headers;
};

export type postApiFormsFormVersionIdPdfLayoutResponse = (postApiFormsFormVersionIdPdfLayoutResponseSuccess | postApiFormsFormVersionIdPdfLayoutResponseError)

export const getPostApiFormsFormVersionIdPdfLayoutUrl = (formVersionId: string,) => {




  return `/api/Forms/${formVersionId}/pdf/layout`
}

export const postApiFormsFormVersionIdPdfLayout = async (formVersionId: string,
    pdfLayoutUpdateRequest: PdfLayoutUpdateRequest, options?: RequestInit): Promise<postApiFormsFormVersionIdPdfLayoutResponse> => {

  return fetcher<postApiFormsFormVersionIdPdfLayoutResponse>(getPostApiFormsFormVersionIdPdfLayoutUrl(formVersionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      pdfLayoutUpdateRequest,)
  }
);}



export type getApiFormsFormVersionIdPdfLayoutResponse200 = {
  data: void
  status: 200
}

export type getApiFormsFormVersionIdPdfLayoutResponse401 = {
  data: GetApiFormsFormVersionIdPdfLayout401
  status: 401
}

export type getApiFormsFormVersionIdPdfLayoutResponseSuccess = (getApiFormsFormVersionIdPdfLayoutResponse200) & {
  headers: Headers;
};
export type getApiFormsFormVersionIdPdfLayoutResponseError = (getApiFormsFormVersionIdPdfLayoutResponse401) & {
  headers: Headers;
};

export type getApiFormsFormVersionIdPdfLayoutResponse = (getApiFormsFormVersionIdPdfLayoutResponseSuccess | getApiFormsFormVersionIdPdfLayoutResponseError)

export const getGetApiFormsFormVersionIdPdfLayoutUrl = (formVersionId: string,) => {




  return `/api/Forms/${formVersionId}/pdf/layout`
}

export const getApiFormsFormVersionIdPdfLayout = async (formVersionId: string, options?: RequestInit): Promise<getApiFormsFormVersionIdPdfLayoutResponse> => {

  return fetcher<getApiFormsFormVersionIdPdfLayoutResponse>(getGetApiFormsFormVersionIdPdfLayoutUrl(formVersionId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiFormsFormVersionIdResponse200 = {
  data: void
  status: 200
}

export type getApiFormsFormVersionIdResponse401 = {
  data: GetApiFormsFormVersionId401
  status: 401
}

export type getApiFormsFormVersionIdResponseSuccess = (getApiFormsFormVersionIdResponse200) & {
  headers: Headers;
};
export type getApiFormsFormVersionIdResponseError = (getApiFormsFormVersionIdResponse401) & {
  headers: Headers;
};

export type getApiFormsFormVersionIdResponse = (getApiFormsFormVersionIdResponseSuccess | getApiFormsFormVersionIdResponseError)

export const getGetApiFormsFormVersionIdUrl = (formVersionId: string,) => {




  return `/api/Forms/${formVersionId}`
}

export const getApiFormsFormVersionId = async (formVersionId: string, options?: RequestInit): Promise<getApiFormsFormVersionIdResponse> => {

  return fetcher<getApiFormsFormVersionIdResponse>(getGetApiFormsFormVersionIdUrl(formVersionId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiFormsFormVersionIdYamlResponse200 = {
  data: void
  status: 200
}

export type getApiFormsFormVersionIdYamlResponse401 = {
  data: GetApiFormsFormVersionIdYaml401
  status: 401
}

export type getApiFormsFormVersionIdYamlResponseSuccess = (getApiFormsFormVersionIdYamlResponse200) & {
  headers: Headers;
};
export type getApiFormsFormVersionIdYamlResponseError = (getApiFormsFormVersionIdYamlResponse401) & {
  headers: Headers;
};

export type getApiFormsFormVersionIdYamlResponse = (getApiFormsFormVersionIdYamlResponseSuccess | getApiFormsFormVersionIdYamlResponseError)

export const getGetApiFormsFormVersionIdYamlUrl = (formVersionId: string,) => {




  return `/api/Forms/${formVersionId}/yaml`
}

export const getApiFormsFormVersionIdYaml = async (formVersionId: string, options?: RequestInit): Promise<getApiFormsFormVersionIdYamlResponse> => {

  return fetcher<getApiFormsFormVersionIdYamlResponse>(getGetApiFormsFormVersionIdYamlUrl(formVersionId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiFormsFormVersionIdMetaResponse200 = {
  data: void
  status: 200
}

export type getApiFormsFormVersionIdMetaResponse401 = {
  data: GetApiFormsFormVersionIdMeta401
  status: 401
}

export type getApiFormsFormVersionIdMetaResponseSuccess = (getApiFormsFormVersionIdMetaResponse200) & {
  headers: Headers;
};
export type getApiFormsFormVersionIdMetaResponseError = (getApiFormsFormVersionIdMetaResponse401) & {
  headers: Headers;
};

export type getApiFormsFormVersionIdMetaResponse = (getApiFormsFormVersionIdMetaResponseSuccess | getApiFormsFormVersionIdMetaResponseError)

export const getGetApiFormsFormVersionIdMetaUrl = (formVersionId: string,) => {




  return `/api/Forms/${formVersionId}/meta`
}

export const getApiFormsFormVersionIdMeta = async (formVersionId: string, options?: RequestInit): Promise<getApiFormsFormVersionIdMetaResponse> => {

  return fetcher<getApiFormsFormVersionIdMetaResponse>(getGetApiFormsFormVersionIdMetaUrl(formVersionId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiFormsFormVersionIdPdfMappingkeyTokensResponse200 = {
  data: void
  status: 200
}

export type getApiFormsFormVersionIdPdfMappingkeyTokensResponse401 = {
  data: GetApiFormsFormVersionIdPdfMappingkeyTokens401
  status: 401
}

export type getApiFormsFormVersionIdPdfMappingkeyTokensResponseSuccess = (getApiFormsFormVersionIdPdfMappingkeyTokensResponse200) & {
  headers: Headers;
};
export type getApiFormsFormVersionIdPdfMappingkeyTokensResponseError = (getApiFormsFormVersionIdPdfMappingkeyTokensResponse401) & {
  headers: Headers;
};

export type getApiFormsFormVersionIdPdfMappingkeyTokensResponse = (getApiFormsFormVersionIdPdfMappingkeyTokensResponseSuccess | getApiFormsFormVersionIdPdfMappingkeyTokensResponseError)

export const getGetApiFormsFormVersionIdPdfMappingkeyTokensUrl = (formVersionId: string,) => {




  return `/api/Forms/${formVersionId}/pdf/mappingkey-tokens`
}

export const getApiFormsFormVersionIdPdfMappingkeyTokens = async (formVersionId: string, options?: RequestInit): Promise<getApiFormsFormVersionIdPdfMappingkeyTokensResponse> => {

  return fetcher<getApiFormsFormVersionIdPdfMappingkeyTokensResponse>(getGetApiFormsFormVersionIdPdfMappingkeyTokensUrl(formVersionId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiFormsFormVersionIdPdfMappingkeyResponse200 = {
  data: void
  status: 200
}

export type getApiFormsFormVersionIdPdfMappingkeyResponse401 = {
  data: GetApiFormsFormVersionIdPdfMappingkey401
  status: 401
}

export type getApiFormsFormVersionIdPdfMappingkeyResponseSuccess = (getApiFormsFormVersionIdPdfMappingkeyResponse200) & {
  headers: Headers;
};
export type getApiFormsFormVersionIdPdfMappingkeyResponseError = (getApiFormsFormVersionIdPdfMappingkeyResponse401) & {
  headers: Headers;
};

export type getApiFormsFormVersionIdPdfMappingkeyResponse = (getApiFormsFormVersionIdPdfMappingkeyResponseSuccess | getApiFormsFormVersionIdPdfMappingkeyResponseError)

export const getGetApiFormsFormVersionIdPdfMappingkeyUrl = (formVersionId: string,) => {




  return `/api/Forms/${formVersionId}/pdf/mappingkey`
}

export const getApiFormsFormVersionIdPdfMappingkey = async (formVersionId: string, options?: RequestInit): Promise<getApiFormsFormVersionIdPdfMappingkeyResponse> => {

  return fetcher<getApiFormsFormVersionIdPdfMappingkeyResponse>(getGetApiFormsFormVersionIdPdfMappingkeyUrl(formVersionId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiFormsFormVersionIdPdfAcroControlsResponse200 = {
  data: void
  status: 200
}

export type getApiFormsFormVersionIdPdfAcroControlsResponse401 = {
  data: GetApiFormsFormVersionIdPdfAcroControls401
  status: 401
}

export type getApiFormsFormVersionIdPdfAcroControlsResponseSuccess = (getApiFormsFormVersionIdPdfAcroControlsResponse200) & {
  headers: Headers;
};
export type getApiFormsFormVersionIdPdfAcroControlsResponseError = (getApiFormsFormVersionIdPdfAcroControlsResponse401) & {
  headers: Headers;
};

export type getApiFormsFormVersionIdPdfAcroControlsResponse = (getApiFormsFormVersionIdPdfAcroControlsResponseSuccess | getApiFormsFormVersionIdPdfAcroControlsResponseError)

export const getGetApiFormsFormVersionIdPdfAcroControlsUrl = (formVersionId: string,) => {




  return `/api/Forms/${formVersionId}/pdf/acro-controls`
}

export const getApiFormsFormVersionIdPdfAcroControls = async (formVersionId: string, options?: RequestInit): Promise<getApiFormsFormVersionIdPdfAcroControlsResponse> => {

  return fetcher<getApiFormsFormVersionIdPdfAcroControlsResponse>(getGetApiFormsFormVersionIdPdfAcroControlsUrl(formVersionId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiHealthResponse200 = {
  data: void
  status: 200
}

export type getApiHealthResponseSuccess = (getApiHealthResponse200) & {
  headers: Headers;
};
;

export type getApiHealthResponse = (getApiHealthResponseSuccess)

export const getGetApiHealthUrl = () => {




  return `/api/Health`
}

export const getApiHealth = async ( options?: RequestInit): Promise<getApiHealthResponse> => {

  return fetcher<getApiHealthResponse>(getGetApiHealthUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiHealthPingResponse200 = {
  data: void
  status: 200
}

export type getApiHealthPingResponseSuccess = (getApiHealthPingResponse200) & {
  headers: Headers;
};
;

export type getApiHealthPingResponse = (getApiHealthPingResponseSuccess)

export const getGetApiHealthPingUrl = () => {




  return `/api/Health/ping`
}

export const getApiHealthPing = async ( options?: RequestInit): Promise<getApiHealthPingResponse> => {

  return fetcher<getApiHealthPingResponse>(getGetApiHealthPingUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiHealthDbResponse200 = {
  data: void
  status: 200
}

export type getApiHealthDbResponse401 = {
  data: GetApiHealthDb401
  status: 401
}

export type getApiHealthDbResponseSuccess = (getApiHealthDbResponse200) & {
  headers: Headers;
};
export type getApiHealthDbResponseError = (getApiHealthDbResponse401) & {
  headers: Headers;
};

export type getApiHealthDbResponse = (getApiHealthDbResponseSuccess | getApiHealthDbResponseError)

export const getGetApiHealthDbUrl = () => {




  return `/api/Health/db`
}

export const getApiHealthDb = async ( options?: RequestInit): Promise<getApiHealthDbResponse> => {

  return fetcher<getApiHealthDbResponse>(getGetApiHealthDbUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiHealthGraphResponse200 = {
  data: void
  status: 200
}

export type getApiHealthGraphResponse401 = {
  data: GetApiHealthGraph401
  status: 401
}

export type getApiHealthGraphResponseSuccess = (getApiHealthGraphResponse200) & {
  headers: Headers;
};
export type getApiHealthGraphResponseError = (getApiHealthGraphResponse401) & {
  headers: Headers;
};

export type getApiHealthGraphResponse = (getApiHealthGraphResponseSuccess | getApiHealthGraphResponseError)

export const getGetApiHealthGraphUrl = () => {




  return `/api/Health/graph`
}

export const getApiHealthGraph = async ( options?: RequestInit): Promise<getApiHealthGraphResponse> => {

  return fetcher<getApiHealthGraphResponse>(getGetApiHealthGraphUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiHealthAuthResponse200 = {
  data: void
  status: 200
}

export type getApiHealthAuthResponse401 = {
  data: GetApiHealthAuth401
  status: 401
}

export type getApiHealthAuthResponseSuccess = (getApiHealthAuthResponse200) & {
  headers: Headers;
};
export type getApiHealthAuthResponseError = (getApiHealthAuthResponse401) & {
  headers: Headers;
};

export type getApiHealthAuthResponse = (getApiHealthAuthResponseSuccess | getApiHealthAuthResponseError)

export const getGetApiHealthAuthUrl = () => {




  return `/api/Health/auth`
}

export const getApiHealthAuth = async ( options?: RequestInit): Promise<getApiHealthAuthResponse> => {

  return fetcher<getApiHealthAuthResponse>(getGetApiHealthAuthUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiHealthAzureopenaiResponse200 = {
  data: void
  status: 200
}

export type getApiHealthAzureopenaiResponse401 = {
  data: GetApiHealthAzureopenai401
  status: 401
}

export type getApiHealthAzureopenaiResponseSuccess = (getApiHealthAzureopenaiResponse200) & {
  headers: Headers;
};
export type getApiHealthAzureopenaiResponseError = (getApiHealthAzureopenaiResponse401) & {
  headers: Headers;
};

export type getApiHealthAzureopenaiResponse = (getApiHealthAzureopenaiResponseSuccess | getApiHealthAzureopenaiResponseError)

export const getGetApiHealthAzureopenaiUrl = () => {




  return `/api/Health/azureopenai`
}

export const getApiHealthAzureopenai = async ( options?: RequestInit): Promise<getApiHealthAzureopenaiResponse> => {

  return fetcher<getApiHealthAzureopenaiResponse>(getGetApiHealthAzureopenaiUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiIntakesSchedulesScheduleTypeSchemaResponse200 = {
  data: void
  status: 200
}

export type getApiIntakesSchedulesScheduleTypeSchemaResponseSuccess = (getApiIntakesSchedulesScheduleTypeSchemaResponse200) & {
  headers: Headers;
};
;

export type getApiIntakesSchedulesScheduleTypeSchemaResponse = (getApiIntakesSchedulesScheduleTypeSchemaResponseSuccess)

export const getGetApiIntakesSchedulesScheduleTypeSchemaUrl = (scheduleType: string,) => {




  return `/api/Intakes/schedules/${scheduleType}/schema`
}

export const getApiIntakesSchedulesScheduleTypeSchema = async (scheduleType: string, options?: RequestInit): Promise<getApiIntakesSchedulesScheduleTypeSchemaResponse> => {

  return fetcher<getApiIntakesSchedulesScheduleTypeSchemaResponse>(getGetApiIntakesSchedulesScheduleTypeSchemaUrl(scheduleType),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerResponse401 = {
  data: GetApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunner401
  status: 401
}

export type getApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerResponseSuccess = (getApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerResponseError = (getApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerResponse = (getApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerResponseSuccess | getApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerResponseError)

export const getGetApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerUrl = (teamId: string,
    intakeId: string,) => {




  return `/api/teams/${teamId}/submissions/intakes/definitions/${intakeId}/runner`
}

export const getApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunner = async (teamId: string,
    intakeId: string, options?: RequestInit): Promise<getApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerResponse> => {

  return fetcher<getApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerResponse>(getGetApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerUrl(teamId,intakeId),
  {
    ...options,
    method: 'GET'


  }
);}



export type patchApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerAnswersResponse200 = {
  data: void
  status: 200
}

export type patchApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerAnswersResponse401 = {
  data: PatchApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerAnswers401
  status: 401
}

export type patchApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerAnswersResponse402 = {
  data: PatchApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerAnswers402
  status: 402
}

export type patchApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerAnswersResponseSuccess = (patchApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerAnswersResponse200) & {
  headers: Headers;
};
export type patchApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerAnswersResponseError = (patchApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerAnswersResponse401 | patchApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerAnswersResponse402) & {
  headers: Headers;
};

export type patchApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerAnswersResponse = (patchApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerAnswersResponseSuccess | patchApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerAnswersResponseError)

export const getPatchApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerAnswersUrl = (teamId: string,
    intakeId: string,) => {




  return `/api/teams/${teamId}/submissions/intakes/definitions/${intakeId}/runner/answers`
}

export const patchApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerAnswers = async (teamId: string,
    intakeId: string,
    patchIntakeDraftAnswersRequest: PatchIntakeDraftAnswersRequest, options?: RequestInit): Promise<patchApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerAnswersResponse> => {

  return fetcher<patchApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerAnswersResponse>(getPatchApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerAnswersUrl(teamId,intakeId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchIntakeDraftAnswersRequest,)
  }
);}



export type getApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerProposedValuesResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerProposedValuesResponse401 = {
  data: GetApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerProposedValues401
  status: 401
}

export type getApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerProposedValuesResponseSuccess = (getApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerProposedValuesResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerProposedValuesResponseError = (getApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerProposedValuesResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerProposedValuesResponse = (getApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerProposedValuesResponseSuccess | getApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerProposedValuesResponseError)

export const getGetApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerProposedValuesUrl = (teamId: string,
    intakeId: string,) => {




  return `/api/teams/${teamId}/submissions/intakes/definitions/${intakeId}/runner/proposed-values`
}

export const getApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerProposedValues = async (teamId: string,
    intakeId: string, options?: RequestInit): Promise<getApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerProposedValuesResponse> => {

  return fetcher<getApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerProposedValuesResponse>(getGetApiTeamsTeamIdSubmissionsIntakesDefinitionsIntakeIdRunnerProposedValuesUrl(teamId,intakeId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiIntakesInvitesTokenResponse200 = {
  data: void
  status: 200
}

export type getApiIntakesInvitesTokenResponseSuccess = (getApiIntakesInvitesTokenResponse200) & {
  headers: Headers;
};
;

export type getApiIntakesInvitesTokenResponse = (getApiIntakesInvitesTokenResponseSuccess)

export const getGetApiIntakesInvitesTokenUrl = (token: string,) => {




  return `/api/Intakes/invites/${token}`
}

export const getApiIntakesInvitesToken = async (token: string, options?: RequestInit): Promise<getApiIntakesInvitesTokenResponse> => {

  return fetcher<getApiIntakesInvitesTokenResponse>(getGetApiIntakesInvitesTokenUrl(token),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiIntakesInvitesTokenEffectiveResponse200 = {
  data: void
  status: 200
}

export type getApiIntakesInvitesTokenEffectiveResponseSuccess = (getApiIntakesInvitesTokenEffectiveResponse200) & {
  headers: Headers;
};
;

export type getApiIntakesInvitesTokenEffectiveResponse = (getApiIntakesInvitesTokenEffectiveResponseSuccess)

export const getGetApiIntakesInvitesTokenEffectiveUrl = (token: string,) => {




  return `/api/Intakes/invites/${token}/effective`
}

export const getApiIntakesInvitesTokenEffective = async (token: string, options?: RequestInit): Promise<getApiIntakesInvitesTokenEffectiveResponse> => {

  return fetcher<getApiIntakesInvitesTokenEffectiveResponse>(getGetApiIntakesInvitesTokenEffectiveUrl(token),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiIntakesInvitesTokenPdfContentResponse200 = {
  data: void
  status: 200
}

export type getApiIntakesInvitesTokenPdfContentResponseSuccess = (getApiIntakesInvitesTokenPdfContentResponse200) & {
  headers: Headers;
};
;

export type getApiIntakesInvitesTokenPdfContentResponse = (getApiIntakesInvitesTokenPdfContentResponseSuccess)

export const getGetApiIntakesInvitesTokenPdfContentUrl = (token: string,
    params?: GetApiIntakesInvitesTokenPdfContentParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Intakes/invites/${token}/pdf/content?${stringifiedParams}` : `/api/Intakes/invites/${token}/pdf/content`
}

export const getApiIntakesInvitesTokenPdfContent = async (token: string,
    params?: GetApiIntakesInvitesTokenPdfContentParams, options?: RequestInit): Promise<getApiIntakesInvitesTokenPdfContentResponse> => {

  return fetcher<getApiIntakesInvitesTokenPdfContentResponse>(getGetApiIntakesInvitesTokenPdfContentUrl(token,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiIntakesInvitesTokenAnswersResponse200 = {
  data: void
  status: 200
}

export type getApiIntakesInvitesTokenAnswersResponseSuccess = (getApiIntakesInvitesTokenAnswersResponse200) & {
  headers: Headers;
};
;

export type getApiIntakesInvitesTokenAnswersResponse = (getApiIntakesInvitesTokenAnswersResponseSuccess)

export const getGetApiIntakesInvitesTokenAnswersUrl = (token: string,) => {




  return `/api/Intakes/invites/${token}/answers`
}

export const getApiIntakesInvitesTokenAnswers = async (token: string, options?: RequestInit): Promise<getApiIntakesInvitesTokenAnswersResponse> => {

  return fetcher<getApiIntakesInvitesTokenAnswersResponse>(getGetApiIntakesInvitesTokenAnswersUrl(token),
  {
    ...options,
    method: 'GET'


  }
);}



export type patchApiIntakesInvitesTokenAnswersResponse200 = {
  data: void
  status: 200
}

export type patchApiIntakesInvitesTokenAnswersResponseSuccess = (patchApiIntakesInvitesTokenAnswersResponse200) & {
  headers: Headers;
};
;

export type patchApiIntakesInvitesTokenAnswersResponse = (patchApiIntakesInvitesTokenAnswersResponseSuccess)

export const getPatchApiIntakesInvitesTokenAnswersUrl = (token: string,) => {




  return `/api/Intakes/invites/${token}/answers`
}

export const patchApiIntakesInvitesTokenAnswers = async (token: string,
    patchInviteAnswersRequest: PatchInviteAnswersRequest, options?: RequestInit): Promise<patchApiIntakesInvitesTokenAnswersResponse> => {

  return fetcher<patchApiIntakesInvitesTokenAnswersResponse>(getPatchApiIntakesInvitesTokenAnswersUrl(token),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchInviteAnswersRequest,)
  }
);}



export type postApiIntakesInvitesTokenSubmitResponse200 = {
  data: void
  status: 200
}

export type postApiIntakesInvitesTokenSubmitResponseSuccess = (postApiIntakesInvitesTokenSubmitResponse200) & {
  headers: Headers;
};
;

export type postApiIntakesInvitesTokenSubmitResponse = (postApiIntakesInvitesTokenSubmitResponseSuccess)

export const getPostApiIntakesInvitesTokenSubmitUrl = (token: string,) => {




  return `/api/Intakes/invites/${token}/submit`
}

export const postApiIntakesInvitesTokenSubmit = async (token: string, options?: RequestInit): Promise<postApiIntakesInvitesTokenSubmitResponse> => {

  return fetcher<postApiIntakesInvitesTokenSubmitResponse>(getPostApiIntakesInvitesTokenSubmitUrl(token),
  {
    ...options,
    method: 'POST'


  }
);}



export type getApiIntakesInvitesTokenProposedValuesResponse200 = {
  data: void
  status: 200
}

export type getApiIntakesInvitesTokenProposedValuesResponseSuccess = (getApiIntakesInvitesTokenProposedValuesResponse200) & {
  headers: Headers;
};
;

export type getApiIntakesInvitesTokenProposedValuesResponse = (getApiIntakesInvitesTokenProposedValuesResponseSuccess)

export const getGetApiIntakesInvitesTokenProposedValuesUrl = (token: string,) => {




  return `/api/Intakes/invites/${token}/proposed-values`
}

export const getApiIntakesInvitesTokenProposedValues = async (token: string, options?: RequestInit): Promise<getApiIntakesInvitesTokenProposedValuesResponse> => {

  return fetcher<getApiIntakesInvitesTokenProposedValuesResponse>(getGetApiIntakesInvitesTokenProposedValuesUrl(token),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiIntakesInvitesTokenFormsFormSubmissionIdEffectiveResponse200 = {
  data: void
  status: 200
}

export type getApiIntakesInvitesTokenFormsFormSubmissionIdEffectiveResponseSuccess = (getApiIntakesInvitesTokenFormsFormSubmissionIdEffectiveResponse200) & {
  headers: Headers;
};
;

export type getApiIntakesInvitesTokenFormsFormSubmissionIdEffectiveResponse = (getApiIntakesInvitesTokenFormsFormSubmissionIdEffectiveResponseSuccess)

export const getGetApiIntakesInvitesTokenFormsFormSubmissionIdEffectiveUrl = (token: string,
    formSubmissionId: string,) => {




  return `/api/Intakes/invites/${token}/forms/${formSubmissionId}/effective`
}

export const getApiIntakesInvitesTokenFormsFormSubmissionIdEffective = async (token: string,
    formSubmissionId: string, options?: RequestInit): Promise<getApiIntakesInvitesTokenFormsFormSubmissionIdEffectiveResponse> => {

  return fetcher<getApiIntakesInvitesTokenFormsFormSubmissionIdEffectiveResponse>(getGetApiIntakesInvitesTokenFormsFormSubmissionIdEffectiveUrl(token,formSubmissionId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiIntakesInvitesTokenFormsFormSubmissionIdAnswersResponse200 = {
  data: void
  status: 200
}

export type getApiIntakesInvitesTokenFormsFormSubmissionIdAnswersResponseSuccess = (getApiIntakesInvitesTokenFormsFormSubmissionIdAnswersResponse200) & {
  headers: Headers;
};
;

export type getApiIntakesInvitesTokenFormsFormSubmissionIdAnswersResponse = (getApiIntakesInvitesTokenFormsFormSubmissionIdAnswersResponseSuccess)

export const getGetApiIntakesInvitesTokenFormsFormSubmissionIdAnswersUrl = (token: string,
    formSubmissionId: string,) => {




  return `/api/Intakes/invites/${token}/forms/${formSubmissionId}/answers`
}

export const getApiIntakesInvitesTokenFormsFormSubmissionIdAnswers = async (token: string,
    formSubmissionId: string, options?: RequestInit): Promise<getApiIntakesInvitesTokenFormsFormSubmissionIdAnswersResponse> => {

  return fetcher<getApiIntakesInvitesTokenFormsFormSubmissionIdAnswersResponse>(getGetApiIntakesInvitesTokenFormsFormSubmissionIdAnswersUrl(token,formSubmissionId),
  {
    ...options,
    method: 'GET'


  }
);}



export type patchApiIntakesInvitesTokenFormsFormSubmissionIdAnswersResponse200 = {
  data: void
  status: 200
}

export type patchApiIntakesInvitesTokenFormsFormSubmissionIdAnswersResponseSuccess = (patchApiIntakesInvitesTokenFormsFormSubmissionIdAnswersResponse200) & {
  headers: Headers;
};
;

export type patchApiIntakesInvitesTokenFormsFormSubmissionIdAnswersResponse = (patchApiIntakesInvitesTokenFormsFormSubmissionIdAnswersResponseSuccess)

export const getPatchApiIntakesInvitesTokenFormsFormSubmissionIdAnswersUrl = (token: string,
    formSubmissionId: string,) => {




  return `/api/Intakes/invites/${token}/forms/${formSubmissionId}/answers`
}

export const patchApiIntakesInvitesTokenFormsFormSubmissionIdAnswers = async (token: string,
    formSubmissionId: string,
    patchInviteAnswersRequest: PatchInviteAnswersRequest, options?: RequestInit): Promise<patchApiIntakesInvitesTokenFormsFormSubmissionIdAnswersResponse> => {

  return fetcher<patchApiIntakesInvitesTokenFormsFormSubmissionIdAnswersResponse>(getPatchApiIntakesInvitesTokenFormsFormSubmissionIdAnswersUrl(token,formSubmissionId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchInviteAnswersRequest,)
  }
);}



export type getApiIntakesInvitesTokenFormsFormSubmissionIdPdfContentResponse200 = {
  data: void
  status: 200
}

export type getApiIntakesInvitesTokenFormsFormSubmissionIdPdfContentResponseSuccess = (getApiIntakesInvitesTokenFormsFormSubmissionIdPdfContentResponse200) & {
  headers: Headers;
};
;

export type getApiIntakesInvitesTokenFormsFormSubmissionIdPdfContentResponse = (getApiIntakesInvitesTokenFormsFormSubmissionIdPdfContentResponseSuccess)

export const getGetApiIntakesInvitesTokenFormsFormSubmissionIdPdfContentUrl = (token: string,
    formSubmissionId: string,
    params?: GetApiIntakesInvitesTokenFormsFormSubmissionIdPdfContentParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Intakes/invites/${token}/forms/${formSubmissionId}/pdf/content?${stringifiedParams}` : `/api/Intakes/invites/${token}/forms/${formSubmissionId}/pdf/content`
}

export const getApiIntakesInvitesTokenFormsFormSubmissionIdPdfContent = async (token: string,
    formSubmissionId: string,
    params?: GetApiIntakesInvitesTokenFormsFormSubmissionIdPdfContentParams, options?: RequestInit): Promise<getApiIntakesInvitesTokenFormsFormSubmissionIdPdfContentResponse> => {

  return fetcher<getApiIntakesInvitesTokenFormsFormSubmissionIdPdfContentResponse>(getGetApiIntakesInvitesTokenFormsFormSubmissionIdPdfContentUrl(token,formSubmissionId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiIntakesInvitesTokenDocumentsResponse200 = {
  data: void
  status: 200
}

export type getApiIntakesInvitesTokenDocumentsResponseSuccess = (getApiIntakesInvitesTokenDocumentsResponse200) & {
  headers: Headers;
};
;

export type getApiIntakesInvitesTokenDocumentsResponse = (getApiIntakesInvitesTokenDocumentsResponseSuccess)

export const getGetApiIntakesInvitesTokenDocumentsUrl = (token: string,) => {




  return `/api/Intakes/invites/${token}/documents`
}

export const getApiIntakesInvitesTokenDocuments = async (token: string, options?: RequestInit): Promise<getApiIntakesInvitesTokenDocumentsResponse> => {

  return fetcher<getApiIntakesInvitesTokenDocumentsResponse>(getGetApiIntakesInvitesTokenDocumentsUrl(token),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiIntakesInvitesTokenDocumentsResponse200 = {
  data: void
  status: 200
}

export type postApiIntakesInvitesTokenDocumentsResponseSuccess = (postApiIntakesInvitesTokenDocumentsResponse200) & {
  headers: Headers;
};
;

export type postApiIntakesInvitesTokenDocumentsResponse = (postApiIntakesInvitesTokenDocumentsResponseSuccess)

export const getPostApiIntakesInvitesTokenDocumentsUrl = (token: string,) => {




  return `/api/Intakes/invites/${token}/documents`
}

export const postApiIntakesInvitesTokenDocuments = async (token: string,
    postApiIntakesInvitesTokenDocumentsBody: PostApiIntakesInvitesTokenDocumentsBody, options?: RequestInit): Promise<postApiIntakesInvitesTokenDocumentsResponse> => {
    const formData = new FormData();
if(postApiIntakesInvitesTokenDocumentsBody.file !== undefined) {
 formData.append(`file`, postApiIntakesInvitesTokenDocumentsBody.file);
 }
formData.append(`request`, JSON.stringify(postApiIntakesInvitesTokenDocumentsBody.request));

  return fetcher<postApiIntakesInvitesTokenDocumentsResponse>(getPostApiIntakesInvitesTokenDocumentsUrl(token),
  {
    ...options,
    method: 'POST'
    ,
    body:
      formData,
  }
);}



export type getApiWorkersWorkerIdResponse200 = {
  data: void
  status: 200
}

export type getApiWorkersWorkerIdResponse401 = {
  data: GetApiWorkersWorkerId401
  status: 401
}

export type getApiWorkersWorkerIdResponseSuccess = (getApiWorkersWorkerIdResponse200) & {
  headers: Headers;
};
export type getApiWorkersWorkerIdResponseError = (getApiWorkersWorkerIdResponse401) & {
  headers: Headers;
};

export type getApiWorkersWorkerIdResponse = (getApiWorkersWorkerIdResponseSuccess | getApiWorkersWorkerIdResponseError)

export const getGetApiWorkersWorkerIdUrl = (workerId: string,) => {




  return `/api/workers/${workerId}`
}

export const getApiWorkersWorkerId = async (workerId: string, options?: RequestInit): Promise<getApiWorkersWorkerIdResponse> => {

  return fetcher<getApiWorkersWorkerIdResponse>(getGetApiWorkersWorkerIdUrl(workerId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiWorkersWorkerIdEventsResponse200 = {
  data: void
  status: 200
}

export type getApiWorkersWorkerIdEventsResponse401 = {
  data: GetApiWorkersWorkerIdEvents401
  status: 401
}

export type getApiWorkersWorkerIdEventsResponseSuccess = (getApiWorkersWorkerIdEventsResponse200) & {
  headers: Headers;
};
export type getApiWorkersWorkerIdEventsResponseError = (getApiWorkersWorkerIdEventsResponse401) & {
  headers: Headers;
};

export type getApiWorkersWorkerIdEventsResponse = (getApiWorkersWorkerIdEventsResponseSuccess | getApiWorkersWorkerIdEventsResponseError)

export const getGetApiWorkersWorkerIdEventsUrl = (workerId: string,
    params?: GetApiWorkersWorkerIdEventsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/workers/${workerId}/events?${stringifiedParams}` : `/api/workers/${workerId}/events`
}

export const getApiWorkersWorkerIdEvents = async (workerId: string,
    params?: GetApiWorkersWorkerIdEventsParams, options?: RequestInit): Promise<getApiWorkersWorkerIdEventsResponse> => {

  return fetcher<getApiWorkersWorkerIdEventsResponse>(getGetApiWorkersWorkerIdEventsUrl(workerId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiWorkersWorkerIdCancelResponse200 = {
  data: void
  status: 200
}

export type postApiWorkersWorkerIdCancelResponse401 = {
  data: PostApiWorkersWorkerIdCancel401
  status: 401
}

export type postApiWorkersWorkerIdCancelResponse402 = {
  data: PostApiWorkersWorkerIdCancel402
  status: 402
}

export type postApiWorkersWorkerIdCancelResponseSuccess = (postApiWorkersWorkerIdCancelResponse200) & {
  headers: Headers;
};
export type postApiWorkersWorkerIdCancelResponseError = (postApiWorkersWorkerIdCancelResponse401 | postApiWorkersWorkerIdCancelResponse402) & {
  headers: Headers;
};

export type postApiWorkersWorkerIdCancelResponse = (postApiWorkersWorkerIdCancelResponseSuccess | postApiWorkersWorkerIdCancelResponseError)

export const getPostApiWorkersWorkerIdCancelUrl = (workerId: string,) => {




  return `/api/workers/${workerId}/cancel`
}

export const postApiWorkersWorkerIdCancel = async (workerId: string, options?: RequestInit): Promise<postApiWorkersWorkerIdCancelResponse> => {

  return fetcher<postApiWorkersWorkerIdCancelResponse>(getPostApiWorkersWorkerIdCancelUrl(workerId),
  {
    ...options,
    method: 'POST'


  }
);}



export type getApiWorkersEventsResponse200 = {
  data: void
  status: 200
}

export type getApiWorkersEventsResponse401 = {
  data: GetApiWorkersEvents401
  status: 401
}

export type getApiWorkersEventsResponseSuccess = (getApiWorkersEventsResponse200) & {
  headers: Headers;
};
export type getApiWorkersEventsResponseError = (getApiWorkersEventsResponse401) & {
  headers: Headers;
};

export type getApiWorkersEventsResponse = (getApiWorkersEventsResponseSuccess | getApiWorkersEventsResponseError)

export const getGetApiWorkersEventsUrl = (params?: GetApiWorkersEventsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/workers/events?${stringifiedParams}` : `/api/workers/events`
}

export const getApiWorkersEvents = async (params?: GetApiWorkersEventsParams, options?: RequestInit): Promise<getApiWorkersEventsResponse> => {

  return fetcher<getApiWorkersEventsResponse>(getGetApiWorkersEventsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiWorkersRecentResponse200 = {
  data: void
  status: 200
}

export type getApiWorkersRecentResponse401 = {
  data: GetApiWorkersRecent401
  status: 401
}

export type getApiWorkersRecentResponseSuccess = (getApiWorkersRecentResponse200) & {
  headers: Headers;
};
export type getApiWorkersRecentResponseError = (getApiWorkersRecentResponse401) & {
  headers: Headers;
};

export type getApiWorkersRecentResponse = (getApiWorkersRecentResponseSuccess | getApiWorkersRecentResponseError)

export const getGetApiWorkersRecentUrl = (params?: GetApiWorkersRecentParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/workers/recent?${stringifiedParams}` : `/api/workers/recent`
}

export const getApiWorkersRecent = async (params?: GetApiWorkersRecentParams, options?: RequestInit): Promise<getApiWorkersRecentResponse> => {

  return fetcher<getApiWorkersRecentResponse>(getGetApiWorkersRecentUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiSseWorkersResponse200 = {
  data: void
  status: 200
}

export type getApiSseWorkersResponse401 = {
  data: GetApiSseWorkers401
  status: 401
}

export type getApiSseWorkersResponseSuccess = (getApiSseWorkersResponse200) & {
  headers: Headers;
};
export type getApiSseWorkersResponseError = (getApiSseWorkersResponse401) & {
  headers: Headers;
};

export type getApiSseWorkersResponse = (getApiSseWorkersResponseSuccess | getApiSseWorkersResponseError)

export const getGetApiSseWorkersUrl = (params?: GetApiSseWorkersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/sse/workers?${stringifiedParams}` : `/api/sse/workers`
}

export const getApiSseWorkers = async (params?: GetApiSseWorkersParams, options?: RequestInit): Promise<getApiSseWorkersResponse> => {

  return fetcher<getApiSseWorkersResponse>(getGetApiSseWorkersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdMessagingSmsActivityResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdMessagingSmsActivityResponse401 = {
  data: GetApiTeamsTeamIdMessagingSmsActivity401
  status: 401
}

export type getApiTeamsTeamIdMessagingSmsActivityResponseSuccess = (getApiTeamsTeamIdMessagingSmsActivityResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdMessagingSmsActivityResponseError = (getApiTeamsTeamIdMessagingSmsActivityResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdMessagingSmsActivityResponse = (getApiTeamsTeamIdMessagingSmsActivityResponseSuccess | getApiTeamsTeamIdMessagingSmsActivityResponseError)

export const getGetApiTeamsTeamIdMessagingSmsActivityUrl = (teamId: string,
    params?: GetApiTeamsTeamIdMessagingSmsActivityParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/messaging/sms/activity?${stringifiedParams}` : `/api/teams/${teamId}/messaging/sms/activity`
}

export const getApiTeamsTeamIdMessagingSmsActivity = async (teamId: string,
    params?: GetApiTeamsTeamIdMessagingSmsActivityParams, options?: RequestInit): Promise<getApiTeamsTeamIdMessagingSmsActivityResponse> => {

  return fetcher<getApiTeamsTeamIdMessagingSmsActivityResponse>(getGetApiTeamsTeamIdMessagingSmsActivityUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdMessagingEsignActivityResponse200TextPlain = {
  data: EsignActivityItem[]
  status: 200
}

export type getApiTeamsTeamIdMessagingEsignActivityResponse200ApplicationJson = {
  data: EsignActivityItem[]
  status: 200
}

export type getApiTeamsTeamIdMessagingEsignActivityResponse200TextJson = {
  data: EsignActivityItem[]
  status: 200
}

export type getApiTeamsTeamIdMessagingEsignActivityResponse401 = {
  data: GetApiTeamsTeamIdMessagingEsignActivity401
  status: 401
}

export type getApiTeamsTeamIdMessagingEsignActivityResponseSuccess = (getApiTeamsTeamIdMessagingEsignActivityResponse200TextPlain | getApiTeamsTeamIdMessagingEsignActivityResponse200ApplicationJson | getApiTeamsTeamIdMessagingEsignActivityResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsTeamIdMessagingEsignActivityResponseError = (getApiTeamsTeamIdMessagingEsignActivityResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdMessagingEsignActivityResponse = (getApiTeamsTeamIdMessagingEsignActivityResponseSuccess | getApiTeamsTeamIdMessagingEsignActivityResponseError)

export const getGetApiTeamsTeamIdMessagingEsignActivityUrl = (teamId: string,
    params?: GetApiTeamsTeamIdMessagingEsignActivityParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/messaging/esign/activity?${stringifiedParams}` : `/api/teams/${teamId}/messaging/esign/activity`
}

export const getApiTeamsTeamIdMessagingEsignActivity = async (teamId: string,
    params?: GetApiTeamsTeamIdMessagingEsignActivityParams, options?: RequestInit): Promise<getApiTeamsTeamIdMessagingEsignActivityResponse> => {

  return fetcher<getApiTeamsTeamIdMessagingEsignActivityResponse>(getGetApiTeamsTeamIdMessagingEsignActivityUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdMessagingSubmissionsSubmissionIdMarketsAttentionResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdMessagingSubmissionsSubmissionIdMarketsAttentionResponse401 = {
  data: GetApiTeamsTeamIdMessagingSubmissionsSubmissionIdMarketsAttention401
  status: 401
}

export type getApiTeamsTeamIdMessagingSubmissionsSubmissionIdMarketsAttentionResponseSuccess = (getApiTeamsTeamIdMessagingSubmissionsSubmissionIdMarketsAttentionResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdMessagingSubmissionsSubmissionIdMarketsAttentionResponseError = (getApiTeamsTeamIdMessagingSubmissionsSubmissionIdMarketsAttentionResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdMessagingSubmissionsSubmissionIdMarketsAttentionResponse = (getApiTeamsTeamIdMessagingSubmissionsSubmissionIdMarketsAttentionResponseSuccess | getApiTeamsTeamIdMessagingSubmissionsSubmissionIdMarketsAttentionResponseError)

export const getGetApiTeamsTeamIdMessagingSubmissionsSubmissionIdMarketsAttentionUrl = (teamId: string,
    submissionId: string,
    params?: GetApiTeamsTeamIdMessagingSubmissionsSubmissionIdMarketsAttentionParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/messaging/submissions/${submissionId}/markets/attention?${stringifiedParams}` : `/api/teams/${teamId}/messaging/submissions/${submissionId}/markets/attention`
}

export const getApiTeamsTeamIdMessagingSubmissionsSubmissionIdMarketsAttention = async (teamId: string,
    submissionId: string,
    params?: GetApiTeamsTeamIdMessagingSubmissionsSubmissionIdMarketsAttentionParams, options?: RequestInit): Promise<getApiTeamsTeamIdMessagingSubmissionsSubmissionIdMarketsAttentionResponse> => {

  return fetcher<getApiTeamsTeamIdMessagingSubmissionsSubmissionIdMarketsAttentionResponse>(getGetApiTeamsTeamIdMessagingSubmissionsSubmissionIdMarketsAttentionUrl(teamId,submissionId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdMessagingInboundEmailInboundEmailIdAnalysisResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdMessagingInboundEmailInboundEmailIdAnalysisResponse401 = {
  data: GetApiTeamsTeamIdMessagingInboundEmailInboundEmailIdAnalysis401
  status: 401
}

export type getApiTeamsTeamIdMessagingInboundEmailInboundEmailIdAnalysisResponseSuccess = (getApiTeamsTeamIdMessagingInboundEmailInboundEmailIdAnalysisResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdMessagingInboundEmailInboundEmailIdAnalysisResponseError = (getApiTeamsTeamIdMessagingInboundEmailInboundEmailIdAnalysisResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdMessagingInboundEmailInboundEmailIdAnalysisResponse = (getApiTeamsTeamIdMessagingInboundEmailInboundEmailIdAnalysisResponseSuccess | getApiTeamsTeamIdMessagingInboundEmailInboundEmailIdAnalysisResponseError)

export const getGetApiTeamsTeamIdMessagingInboundEmailInboundEmailIdAnalysisUrl = (teamId: string,
    inboundEmailId: string,) => {




  return `/api/teams/${teamId}/messaging/inbound/email/${inboundEmailId}/analysis`
}

export const getApiTeamsTeamIdMessagingInboundEmailInboundEmailIdAnalysis = async (teamId: string,
    inboundEmailId: string, options?: RequestInit): Promise<getApiTeamsTeamIdMessagingInboundEmailInboundEmailIdAnalysisResponse> => {

  return fetcher<getApiTeamsTeamIdMessagingInboundEmailInboundEmailIdAnalysisResponse>(getGetApiTeamsTeamIdMessagingInboundEmailInboundEmailIdAnalysisUrl(teamId,inboundEmailId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdMessagingInboundEmailInboundEmailIdApplyResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdMessagingInboundEmailInboundEmailIdApplyResponse401 = {
  data: PostApiTeamsTeamIdMessagingInboundEmailInboundEmailIdApply401
  status: 401
}

export type postApiTeamsTeamIdMessagingInboundEmailInboundEmailIdApplyResponse402 = {
  data: PostApiTeamsTeamIdMessagingInboundEmailInboundEmailIdApply402
  status: 402
}

export type postApiTeamsTeamIdMessagingInboundEmailInboundEmailIdApplyResponseSuccess = (postApiTeamsTeamIdMessagingInboundEmailInboundEmailIdApplyResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdMessagingInboundEmailInboundEmailIdApplyResponseError = (postApiTeamsTeamIdMessagingInboundEmailInboundEmailIdApplyResponse401 | postApiTeamsTeamIdMessagingInboundEmailInboundEmailIdApplyResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdMessagingInboundEmailInboundEmailIdApplyResponse = (postApiTeamsTeamIdMessagingInboundEmailInboundEmailIdApplyResponseSuccess | postApiTeamsTeamIdMessagingInboundEmailInboundEmailIdApplyResponseError)

export const getPostApiTeamsTeamIdMessagingInboundEmailInboundEmailIdApplyUrl = (teamId: string,
    inboundEmailId: string,) => {




  return `/api/teams/${teamId}/messaging/inbound/email/${inboundEmailId}/apply`
}

export const postApiTeamsTeamIdMessagingInboundEmailInboundEmailIdApply = async (teamId: string,
    inboundEmailId: string,
    nullApplyInboundEmailActionRequest: null | ApplyInboundEmailActionRequest, options?: RequestInit): Promise<postApiTeamsTeamIdMessagingInboundEmailInboundEmailIdApplyResponse> => {

  return fetcher<postApiTeamsTeamIdMessagingInboundEmailInboundEmailIdApplyResponse>(getPostApiTeamsTeamIdMessagingInboundEmailInboundEmailIdApplyUrl(teamId,inboundEmailId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullApplyInboundEmailActionRequest,)
  }
);}



export type getApiTeamsTeamIdMessagingSubmissionsSubmissionIdMarketsSubmissionMarketIdTimelineResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdMessagingSubmissionsSubmissionIdMarketsSubmissionMarketIdTimelineResponse401 = {
  data: GetApiTeamsTeamIdMessagingSubmissionsSubmissionIdMarketsSubmissionMarketIdTimeline401
  status: 401
}

export type getApiTeamsTeamIdMessagingSubmissionsSubmissionIdMarketsSubmissionMarketIdTimelineResponseSuccess = (getApiTeamsTeamIdMessagingSubmissionsSubmissionIdMarketsSubmissionMarketIdTimelineResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdMessagingSubmissionsSubmissionIdMarketsSubmissionMarketIdTimelineResponseError = (getApiTeamsTeamIdMessagingSubmissionsSubmissionIdMarketsSubmissionMarketIdTimelineResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdMessagingSubmissionsSubmissionIdMarketsSubmissionMarketIdTimelineResponse = (getApiTeamsTeamIdMessagingSubmissionsSubmissionIdMarketsSubmissionMarketIdTimelineResponseSuccess | getApiTeamsTeamIdMessagingSubmissionsSubmissionIdMarketsSubmissionMarketIdTimelineResponseError)

export const getGetApiTeamsTeamIdMessagingSubmissionsSubmissionIdMarketsSubmissionMarketIdTimelineUrl = (teamId: string,
    submissionId: string,
    submissionMarketId: string,
    params?: GetApiTeamsTeamIdMessagingSubmissionsSubmissionIdMarketsSubmissionMarketIdTimelineParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/messaging/submissions/${submissionId}/markets/${submissionMarketId}/timeline?${stringifiedParams}` : `/api/teams/${teamId}/messaging/submissions/${submissionId}/markets/${submissionMarketId}/timeline`
}

export const getApiTeamsTeamIdMessagingSubmissionsSubmissionIdMarketsSubmissionMarketIdTimeline = async (teamId: string,
    submissionId: string,
    submissionMarketId: string,
    params?: GetApiTeamsTeamIdMessagingSubmissionsSubmissionIdMarketsSubmissionMarketIdTimelineParams, options?: RequestInit): Promise<getApiTeamsTeamIdMessagingSubmissionsSubmissionIdMarketsSubmissionMarketIdTimelineResponse> => {

  return fetcher<getApiTeamsTeamIdMessagingSubmissionsSubmissionIdMarketsSubmissionMarketIdTimelineResponse>(getGetApiTeamsTeamIdMessagingSubmissionsSubmissionIdMarketsSubmissionMarketIdTimelineUrl(teamId,submissionId,submissionMarketId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdMessagingSubmissionsSubmissionIdInboundEmailUnmatchedResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdMessagingSubmissionsSubmissionIdInboundEmailUnmatchedResponse401 = {
  data: GetApiTeamsTeamIdMessagingSubmissionsSubmissionIdInboundEmailUnmatched401
  status: 401
}

export type getApiTeamsTeamIdMessagingSubmissionsSubmissionIdInboundEmailUnmatchedResponseSuccess = (getApiTeamsTeamIdMessagingSubmissionsSubmissionIdInboundEmailUnmatchedResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdMessagingSubmissionsSubmissionIdInboundEmailUnmatchedResponseError = (getApiTeamsTeamIdMessagingSubmissionsSubmissionIdInboundEmailUnmatchedResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdMessagingSubmissionsSubmissionIdInboundEmailUnmatchedResponse = (getApiTeamsTeamIdMessagingSubmissionsSubmissionIdInboundEmailUnmatchedResponseSuccess | getApiTeamsTeamIdMessagingSubmissionsSubmissionIdInboundEmailUnmatchedResponseError)

export const getGetApiTeamsTeamIdMessagingSubmissionsSubmissionIdInboundEmailUnmatchedUrl = (teamId: string,
    submissionId: string,
    params?: GetApiTeamsTeamIdMessagingSubmissionsSubmissionIdInboundEmailUnmatchedParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/messaging/submissions/${submissionId}/inbound/email/unmatched?${stringifiedParams}` : `/api/teams/${teamId}/messaging/submissions/${submissionId}/inbound/email/unmatched`
}

export const getApiTeamsTeamIdMessagingSubmissionsSubmissionIdInboundEmailUnmatched = async (teamId: string,
    submissionId: string,
    params?: GetApiTeamsTeamIdMessagingSubmissionsSubmissionIdInboundEmailUnmatchedParams, options?: RequestInit): Promise<getApiTeamsTeamIdMessagingSubmissionsSubmissionIdInboundEmailUnmatchedResponse> => {

  return fetcher<getApiTeamsTeamIdMessagingSubmissionsSubmissionIdInboundEmailUnmatchedResponse>(getGetApiTeamsTeamIdMessagingSubmissionsSubmissionIdInboundEmailUnmatchedUrl(teamId,submissionId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdMessagingServicingInboundResponse200TextPlain = {
  data: ServicingInboundEmailListPayload
  status: 200
}

export type getApiTeamsTeamIdMessagingServicingInboundResponse200ApplicationJson = {
  data: ServicingInboundEmailListPayload
  status: 200
}

export type getApiTeamsTeamIdMessagingServicingInboundResponse200TextJson = {
  data: ServicingInboundEmailListPayload
  status: 200
}

export type getApiTeamsTeamIdMessagingServicingInboundResponse401 = {
  data: GetApiTeamsTeamIdMessagingServicingInbound401
  status: 401
}

export type getApiTeamsTeamIdMessagingServicingInboundResponseSuccess = (getApiTeamsTeamIdMessagingServicingInboundResponse200TextPlain | getApiTeamsTeamIdMessagingServicingInboundResponse200ApplicationJson | getApiTeamsTeamIdMessagingServicingInboundResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsTeamIdMessagingServicingInboundResponseError = (getApiTeamsTeamIdMessagingServicingInboundResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdMessagingServicingInboundResponse = (getApiTeamsTeamIdMessagingServicingInboundResponseSuccess | getApiTeamsTeamIdMessagingServicingInboundResponseError)

export const getGetApiTeamsTeamIdMessagingServicingInboundUrl = (teamId: string,
    params?: GetApiTeamsTeamIdMessagingServicingInboundParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/messaging/servicing/inbound?${stringifiedParams}` : `/api/teams/${teamId}/messaging/servicing/inbound`
}

export const getApiTeamsTeamIdMessagingServicingInbound = async (teamId: string,
    params?: GetApiTeamsTeamIdMessagingServicingInboundParams, options?: RequestInit): Promise<getApiTeamsTeamIdMessagingServicingInboundResponse> => {

  return fetcher<getApiTeamsTeamIdMessagingServicingInboundResponse>(getGetApiTeamsTeamIdMessagingServicingInboundUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdMessagingServicingInboundInboundEmailIdServiceRequestResponse200TextPlain = {
  data: CreateServicingServiceRequestResponse
  status: 200
}

export type postApiTeamsTeamIdMessagingServicingInboundInboundEmailIdServiceRequestResponse200ApplicationJson = {
  data: CreateServicingServiceRequestResponse
  status: 200
}

export type postApiTeamsTeamIdMessagingServicingInboundInboundEmailIdServiceRequestResponse200TextJson = {
  data: CreateServicingServiceRequestResponse
  status: 200
}

export type postApiTeamsTeamIdMessagingServicingInboundInboundEmailIdServiceRequestResponse401 = {
  data: PostApiTeamsTeamIdMessagingServicingInboundInboundEmailIdServiceRequest401
  status: 401
}

export type postApiTeamsTeamIdMessagingServicingInboundInboundEmailIdServiceRequestResponse402 = {
  data: PostApiTeamsTeamIdMessagingServicingInboundInboundEmailIdServiceRequest402
  status: 402
}

export type postApiTeamsTeamIdMessagingServicingInboundInboundEmailIdServiceRequestResponseSuccess = (postApiTeamsTeamIdMessagingServicingInboundInboundEmailIdServiceRequestResponse200TextPlain | postApiTeamsTeamIdMessagingServicingInboundInboundEmailIdServiceRequestResponse200ApplicationJson | postApiTeamsTeamIdMessagingServicingInboundInboundEmailIdServiceRequestResponse200TextJson) & {
  headers: Headers;
};
export type postApiTeamsTeamIdMessagingServicingInboundInboundEmailIdServiceRequestResponseError = (postApiTeamsTeamIdMessagingServicingInboundInboundEmailIdServiceRequestResponse401 | postApiTeamsTeamIdMessagingServicingInboundInboundEmailIdServiceRequestResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdMessagingServicingInboundInboundEmailIdServiceRequestResponse = (postApiTeamsTeamIdMessagingServicingInboundInboundEmailIdServiceRequestResponseSuccess | postApiTeamsTeamIdMessagingServicingInboundInboundEmailIdServiceRequestResponseError)

export const getPostApiTeamsTeamIdMessagingServicingInboundInboundEmailIdServiceRequestUrl = (teamId: string,
    inboundEmailId: string,) => {




  return `/api/teams/${teamId}/messaging/servicing/inbound/${inboundEmailId}/service-request`
}

export const postApiTeamsTeamIdMessagingServicingInboundInboundEmailIdServiceRequest = async (teamId: string,
    inboundEmailId: string,
    nullCreateServicingServiceRequestRequest: null | CreateServicingServiceRequestRequest, options?: RequestInit): Promise<postApiTeamsTeamIdMessagingServicingInboundInboundEmailIdServiceRequestResponse> => {

  return fetcher<postApiTeamsTeamIdMessagingServicingInboundInboundEmailIdServiceRequestResponse>(getPostApiTeamsTeamIdMessagingServicingInboundInboundEmailIdServiceRequestUrl(teamId,inboundEmailId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullCreateServicingServiceRequestRequest,)
  }
);}



export type getApiTeamsTeamIdMessagingServicingServiceRequestsResponse200TextPlain = {
  data: ServicingServiceRequestListResponse
  status: 200
}

export type getApiTeamsTeamIdMessagingServicingServiceRequestsResponse200ApplicationJson = {
  data: ServicingServiceRequestListResponse
  status: 200
}

export type getApiTeamsTeamIdMessagingServicingServiceRequestsResponse200TextJson = {
  data: ServicingServiceRequestListResponse
  status: 200
}

export type getApiTeamsTeamIdMessagingServicingServiceRequestsResponse401 = {
  data: GetApiTeamsTeamIdMessagingServicingServiceRequests401
  status: 401
}

export type getApiTeamsTeamIdMessagingServicingServiceRequestsResponseSuccess = (getApiTeamsTeamIdMessagingServicingServiceRequestsResponse200TextPlain | getApiTeamsTeamIdMessagingServicingServiceRequestsResponse200ApplicationJson | getApiTeamsTeamIdMessagingServicingServiceRequestsResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsTeamIdMessagingServicingServiceRequestsResponseError = (getApiTeamsTeamIdMessagingServicingServiceRequestsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdMessagingServicingServiceRequestsResponse = (getApiTeamsTeamIdMessagingServicingServiceRequestsResponseSuccess | getApiTeamsTeamIdMessagingServicingServiceRequestsResponseError)

export const getGetApiTeamsTeamIdMessagingServicingServiceRequestsUrl = (teamId: string,
    params?: GetApiTeamsTeamIdMessagingServicingServiceRequestsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/messaging/servicing/service-requests?${stringifiedParams}` : `/api/teams/${teamId}/messaging/servicing/service-requests`
}

export const getApiTeamsTeamIdMessagingServicingServiceRequests = async (teamId: string,
    params?: GetApiTeamsTeamIdMessagingServicingServiceRequestsParams, options?: RequestInit): Promise<getApiTeamsTeamIdMessagingServicingServiceRequestsResponse> => {

  return fetcher<getApiTeamsTeamIdMessagingServicingServiceRequestsResponse>(getGetApiTeamsTeamIdMessagingServicingServiceRequestsUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdResponse200TextPlain = {
  data: CreateServicingServiceRequestResponse
  status: 200
}

export type getApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdResponse200ApplicationJson = {
  data: CreateServicingServiceRequestResponse
  status: 200
}

export type getApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdResponse200TextJson = {
  data: CreateServicingServiceRequestResponse
  status: 200
}

export type getApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdResponse401 = {
  data: GetApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestId401
  status: 401
}

export type getApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdResponseSuccess = (getApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdResponse200TextPlain | getApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdResponse200ApplicationJson | getApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdResponseError = (getApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdResponse = (getApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdResponseSuccess | getApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdResponseError)

export const getGetApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdUrl = (teamId: string,
    serviceRequestId: string,) => {




  return `/api/teams/${teamId}/messaging/servicing/service-requests/${serviceRequestId}`
}

export const getApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestId = async (teamId: string,
    serviceRequestId: string, options?: RequestInit): Promise<getApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdResponse> => {

  return fetcher<getApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdResponse>(getGetApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdUrl(teamId,serviceRequestId),
  {
    ...options,
    method: 'GET'


  }
);}



export type patchApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdResponse200TextPlain = {
  data: CreateServicingServiceRequestResponse
  status: 200
}

export type patchApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdResponse200ApplicationJson = {
  data: CreateServicingServiceRequestResponse
  status: 200
}

export type patchApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdResponse200TextJson = {
  data: CreateServicingServiceRequestResponse
  status: 200
}

export type patchApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdResponse401 = {
  data: PatchApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestId401
  status: 401
}

export type patchApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdResponse402 = {
  data: PatchApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestId402
  status: 402
}

export type patchApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdResponseSuccess = (patchApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdResponse200TextPlain | patchApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdResponse200ApplicationJson | patchApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdResponse200TextJson) & {
  headers: Headers;
};
export type patchApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdResponseError = (patchApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdResponse401 | patchApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdResponse402) & {
  headers: Headers;
};

export type patchApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdResponse = (patchApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdResponseSuccess | patchApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdResponseError)

export const getPatchApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdUrl = (teamId: string,
    serviceRequestId: string,) => {




  return `/api/teams/${teamId}/messaging/servicing/service-requests/${serviceRequestId}`
}

export const patchApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestId = async (teamId: string,
    serviceRequestId: string,
    nullUpdateServicingServiceRequestRequest: null | UpdateServicingServiceRequestRequest, options?: RequestInit): Promise<patchApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdResponse> => {

  return fetcher<patchApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdResponse>(getPatchApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdUrl(teamId,serviceRequestId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullUpdateServicingServiceRequestRequest,)
  }
);}



export type postApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdCertificateDraftResponse200TextPlain = {
  data: CreateServicingServiceRequestResponse
  status: 200
}

export type postApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdCertificateDraftResponse200ApplicationJson = {
  data: CreateServicingServiceRequestResponse
  status: 200
}

export type postApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdCertificateDraftResponse200TextJson = {
  data: CreateServicingServiceRequestResponse
  status: 200
}

export type postApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdCertificateDraftResponse401 = {
  data: PostApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdCertificateDraft401
  status: 401
}

export type postApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdCertificateDraftResponse402 = {
  data: PostApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdCertificateDraft402
  status: 402
}

export type postApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdCertificateDraftResponseSuccess = (postApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdCertificateDraftResponse200TextPlain | postApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdCertificateDraftResponse200ApplicationJson | postApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdCertificateDraftResponse200TextJson) & {
  headers: Headers;
};
export type postApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdCertificateDraftResponseError = (postApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdCertificateDraftResponse401 | postApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdCertificateDraftResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdCertificateDraftResponse = (postApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdCertificateDraftResponseSuccess | postApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdCertificateDraftResponseError)

export const getPostApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdCertificateDraftUrl = (teamId: string,
    serviceRequestId: string,) => {




  return `/api/teams/${teamId}/messaging/servicing/service-requests/${serviceRequestId}/certificate-draft`
}

export const postApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdCertificateDraft = async (teamId: string,
    serviceRequestId: string,
    nullCreateServicingCertificateDraftRequest: null | CreateServicingCertificateDraftRequest, options?: RequestInit): Promise<postApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdCertificateDraftResponse> => {

  return fetcher<postApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdCertificateDraftResponse>(getPostApiTeamsTeamIdMessagingServicingServiceRequestsServiceRequestIdCertificateDraftUrl(teamId,serviceRequestId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullCreateServicingCertificateDraftRequest,)
  }
);}



export type postApiTeamsTeamIdMessagingInboundEmailInboundEmailIdMapSubmissionMarketResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdMessagingInboundEmailInboundEmailIdMapSubmissionMarketResponse401 = {
  data: PostApiTeamsTeamIdMessagingInboundEmailInboundEmailIdMapSubmissionMarket401
  status: 401
}

export type postApiTeamsTeamIdMessagingInboundEmailInboundEmailIdMapSubmissionMarketResponse402 = {
  data: PostApiTeamsTeamIdMessagingInboundEmailInboundEmailIdMapSubmissionMarket402
  status: 402
}

export type postApiTeamsTeamIdMessagingInboundEmailInboundEmailIdMapSubmissionMarketResponseSuccess = (postApiTeamsTeamIdMessagingInboundEmailInboundEmailIdMapSubmissionMarketResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdMessagingInboundEmailInboundEmailIdMapSubmissionMarketResponseError = (postApiTeamsTeamIdMessagingInboundEmailInboundEmailIdMapSubmissionMarketResponse401 | postApiTeamsTeamIdMessagingInboundEmailInboundEmailIdMapSubmissionMarketResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdMessagingInboundEmailInboundEmailIdMapSubmissionMarketResponse = (postApiTeamsTeamIdMessagingInboundEmailInboundEmailIdMapSubmissionMarketResponseSuccess | postApiTeamsTeamIdMessagingInboundEmailInboundEmailIdMapSubmissionMarketResponseError)

export const getPostApiTeamsTeamIdMessagingInboundEmailInboundEmailIdMapSubmissionMarketUrl = (teamId: string,
    inboundEmailId: string,) => {




  return `/api/teams/${teamId}/messaging/inbound/email/${inboundEmailId}/map-submission-market`
}

export const postApiTeamsTeamIdMessagingInboundEmailInboundEmailIdMapSubmissionMarket = async (teamId: string,
    inboundEmailId: string,
    nullMapInboundEmailSubmissionMarketRequest: null | MapInboundEmailSubmissionMarketRequest, options?: RequestInit): Promise<postApiTeamsTeamIdMessagingInboundEmailInboundEmailIdMapSubmissionMarketResponse> => {

  return fetcher<postApiTeamsTeamIdMessagingInboundEmailInboundEmailIdMapSubmissionMarketResponse>(getPostApiTeamsTeamIdMessagingInboundEmailInboundEmailIdMapSubmissionMarketUrl(teamId,inboundEmailId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullMapInboundEmailSubmissionMarketRequest,)
  }
);}



export type getApiMonitorLogsResponse200 = {
  data: void
  status: 200
}

export type getApiMonitorLogsResponse401 = {
  data: GetApiMonitorLogs401
  status: 401
}

export type getApiMonitorLogsResponseSuccess = (getApiMonitorLogsResponse200) & {
  headers: Headers;
};
export type getApiMonitorLogsResponseError = (getApiMonitorLogsResponse401) & {
  headers: Headers;
};

export type getApiMonitorLogsResponse = (getApiMonitorLogsResponseSuccess | getApiMonitorLogsResponseError)

export const getGetApiMonitorLogsUrl = (params?: GetApiMonitorLogsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/monitor/logs?${stringifiedParams}` : `/api/monitor/logs`
}

export const getApiMonitorLogs = async (params?: GetApiMonitorLogsParams, options?: RequestInit): Promise<getApiMonitorLogsResponse> => {

  return fetcher<getApiMonitorLogsResponse>(getGetApiMonitorLogsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiPdfWorkersResponse200TextPlain = {
  data: PdfWorkerDto
  status: 200
}

export type postApiPdfWorkersResponse200ApplicationJson = {
  data: PdfWorkerDto
  status: 200
}

export type postApiPdfWorkersResponse200TextJson = {
  data: PdfWorkerDto
  status: 200
}

export type postApiPdfWorkersResponse202TextPlain = {
  data: PdfWorkerDto
  status: 202
}

export type postApiPdfWorkersResponse202ApplicationJson = {
  data: PdfWorkerDto
  status: 202
}

export type postApiPdfWorkersResponse202TextJson = {
  data: PdfWorkerDto
  status: 202
}

export type postApiPdfWorkersResponse401 = {
  data: PostApiPdfWorkers401
  status: 401
}

export type postApiPdfWorkersResponse402 = {
  data: PostApiPdfWorkers402
  status: 402
}

export type postApiPdfWorkersResponseSuccess = (postApiPdfWorkersResponse200TextPlain | postApiPdfWorkersResponse200ApplicationJson | postApiPdfWorkersResponse200TextJson | postApiPdfWorkersResponse202TextPlain | postApiPdfWorkersResponse202ApplicationJson | postApiPdfWorkersResponse202TextJson) & {
  headers: Headers;
};
export type postApiPdfWorkersResponseError = (postApiPdfWorkersResponse401 | postApiPdfWorkersResponse402) & {
  headers: Headers;
};

export type postApiPdfWorkersResponse = (postApiPdfWorkersResponseSuccess | postApiPdfWorkersResponseError)

export const getPostApiPdfWorkersUrl = () => {




  return `/api/pdf/workers`
}

export const postApiPdfWorkers = async (createPdfWorkerRequest: CreatePdfWorkerRequest, options?: RequestInit): Promise<postApiPdfWorkersResponse> => {

  return fetcher<postApiPdfWorkersResponse>(getPostApiPdfWorkersUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createPdfWorkerRequest,)
  }
);}



export type getApiPdfWorkersWorkerIdResponse200TextPlain = {
  data: PdfWorkerDto
  status: 200
}

export type getApiPdfWorkersWorkerIdResponse200ApplicationJson = {
  data: PdfWorkerDto
  status: 200
}

export type getApiPdfWorkersWorkerIdResponse200TextJson = {
  data: PdfWorkerDto
  status: 200
}

export type getApiPdfWorkersWorkerIdResponse401 = {
  data: GetApiPdfWorkersWorkerId401
  status: 401
}

export type getApiPdfWorkersWorkerIdResponseSuccess = (getApiPdfWorkersWorkerIdResponse200TextPlain | getApiPdfWorkersWorkerIdResponse200ApplicationJson | getApiPdfWorkersWorkerIdResponse200TextJson) & {
  headers: Headers;
};
export type getApiPdfWorkersWorkerIdResponseError = (getApiPdfWorkersWorkerIdResponse401) & {
  headers: Headers;
};

export type getApiPdfWorkersWorkerIdResponse = (getApiPdfWorkersWorkerIdResponseSuccess | getApiPdfWorkersWorkerIdResponseError)

export const getGetApiPdfWorkersWorkerIdUrl = (workerId: string,) => {




  return `/api/pdf/workers/${workerId}`
}

export const getApiPdfWorkersWorkerId = async (workerId: string, options?: RequestInit): Promise<getApiPdfWorkersWorkerIdResponse> => {

  return fetcher<getApiPdfWorkersWorkerIdResponse>(getGetApiPdfWorkersWorkerIdUrl(workerId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiPdfWorkersWorkerIdContentResponse200 = {
  data: void
  status: 200
}

export type getApiPdfWorkersWorkerIdContentResponse401 = {
  data: GetApiPdfWorkersWorkerIdContent401
  status: 401
}

export type getApiPdfWorkersWorkerIdContentResponseSuccess = (getApiPdfWorkersWorkerIdContentResponse200) & {
  headers: Headers;
};
export type getApiPdfWorkersWorkerIdContentResponseError = (getApiPdfWorkersWorkerIdContentResponse401) & {
  headers: Headers;
};

export type getApiPdfWorkersWorkerIdContentResponse = (getApiPdfWorkersWorkerIdContentResponseSuccess | getApiPdfWorkersWorkerIdContentResponseError)

export const getGetApiPdfWorkersWorkerIdContentUrl = (workerId: string,
    params?: GetApiPdfWorkersWorkerIdContentParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/pdf/workers/${workerId}/content?${stringifiedParams}` : `/api/pdf/workers/${workerId}/content`
}

export const getApiPdfWorkersWorkerIdContent = async (workerId: string,
    params?: GetApiPdfWorkersWorkerIdContentParams, options?: RequestInit): Promise<getApiPdfWorkersWorkerIdContentResponse> => {

  return fetcher<getApiPdfWorkersWorkerIdContentResponse>(getGetApiPdfWorkersWorkerIdContentUrl(workerId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiPdfWorkersWorkerIdEventsResponse200 = {
  data: void
  status: 200
}

export type getApiPdfWorkersWorkerIdEventsResponse401 = {
  data: GetApiPdfWorkersWorkerIdEvents401
  status: 401
}

export type getApiPdfWorkersWorkerIdEventsResponseSuccess = (getApiPdfWorkersWorkerIdEventsResponse200) & {
  headers: Headers;
};
export type getApiPdfWorkersWorkerIdEventsResponseError = (getApiPdfWorkersWorkerIdEventsResponse401) & {
  headers: Headers;
};

export type getApiPdfWorkersWorkerIdEventsResponse = (getApiPdfWorkersWorkerIdEventsResponseSuccess | getApiPdfWorkersWorkerIdEventsResponseError)

export const getGetApiPdfWorkersWorkerIdEventsUrl = (workerId: string,) => {




  return `/api/pdf/workers/${workerId}/events`
}

export const getApiPdfWorkersWorkerIdEvents = async (workerId: string, options?: RequestInit): Promise<getApiPdfWorkersWorkerIdEventsResponse> => {

  return fetcher<getApiPdfWorkersWorkerIdEventsResponse>(getGetApiPdfWorkersWorkerIdEventsUrl(workerId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiPhoneValidateResponse200TextPlain = {
  data: PhoneValidateResponse
  status: 200
}

export type postApiPhoneValidateResponse200ApplicationJson = {
  data: PhoneValidateResponse
  status: 200
}

export type postApiPhoneValidateResponse200TextJson = {
  data: PhoneValidateResponse
  status: 200
}

export type postApiPhoneValidateResponse401 = {
  data: PostApiPhoneValidate401
  status: 401
}

export type postApiPhoneValidateResponseSuccess = (postApiPhoneValidateResponse200TextPlain | postApiPhoneValidateResponse200ApplicationJson | postApiPhoneValidateResponse200TextJson) & {
  headers: Headers;
};
export type postApiPhoneValidateResponseError = (postApiPhoneValidateResponse401) & {
  headers: Headers;
};

export type postApiPhoneValidateResponse = (postApiPhoneValidateResponseSuccess | postApiPhoneValidateResponseError)

export const getPostApiPhoneValidateUrl = () => {




  return `/api/phone/validate`
}

export const postApiPhoneValidate = async (phoneValidateRequest: PhoneValidateRequest, options?: RequestInit): Promise<postApiPhoneValidateResponse> => {

  return fetcher<postApiPhoneValidateResponse>(getPostApiPhoneValidateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      phoneValidateRequest,)
  }
);}



export type postApiPhoneLookupResponse200TextPlain = {
  data: PhoneLookupResponse
  status: 200
}

export type postApiPhoneLookupResponse200ApplicationJson = {
  data: PhoneLookupResponse
  status: 200
}

export type postApiPhoneLookupResponse200TextJson = {
  data: PhoneLookupResponse
  status: 200
}

export type postApiPhoneLookupResponse401 = {
  data: PostApiPhoneLookup401
  status: 401
}

export type postApiPhoneLookupResponseSuccess = (postApiPhoneLookupResponse200TextPlain | postApiPhoneLookupResponse200ApplicationJson | postApiPhoneLookupResponse200TextJson) & {
  headers: Headers;
};
export type postApiPhoneLookupResponseError = (postApiPhoneLookupResponse401) & {
  headers: Headers;
};

export type postApiPhoneLookupResponse = (postApiPhoneLookupResponseSuccess | postApiPhoneLookupResponseError)

export const getPostApiPhoneLookupUrl = () => {




  return `/api/phone/lookup`
}

export const postApiPhoneLookup = async (phoneLookupRequest: PhoneLookupRequest, options?: RequestInit): Promise<postApiPhoneLookupResponse> => {

  return fetcher<postApiPhoneLookupResponse>(getPostApiPhoneLookupUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      phoneLookupRequest,)
  }
);}



export type getApiPlacesAutocompleteResponse200TextPlain = {
  data: AutocompleteResponse
  status: 200
}

export type getApiPlacesAutocompleteResponse200ApplicationJson = {
  data: AutocompleteResponse
  status: 200
}

export type getApiPlacesAutocompleteResponse200TextJson = {
  data: AutocompleteResponse
  status: 200
}

export type getApiPlacesAutocompleteResponse401 = {
  data: GetApiPlacesAutocomplete401
  status: 401
}

export type getApiPlacesAutocompleteResponseSuccess = (getApiPlacesAutocompleteResponse200TextPlain | getApiPlacesAutocompleteResponse200ApplicationJson | getApiPlacesAutocompleteResponse200TextJson) & {
  headers: Headers;
};
export type getApiPlacesAutocompleteResponseError = (getApiPlacesAutocompleteResponse401) & {
  headers: Headers;
};

export type getApiPlacesAutocompleteResponse = (getApiPlacesAutocompleteResponseSuccess | getApiPlacesAutocompleteResponseError)

export const getGetApiPlacesAutocompleteUrl = (params?: GetApiPlacesAutocompleteParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/places/autocomplete?${stringifiedParams}` : `/api/places/autocomplete`
}

export const getApiPlacesAutocomplete = async (params?: GetApiPlacesAutocompleteParams, options?: RequestInit): Promise<getApiPlacesAutocompleteResponse> => {

  return fetcher<getApiPlacesAutocompleteResponse>(getGetApiPlacesAutocompleteUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiPlacesDetailsResponse200TextPlain = {
  data: PlaceDetailsResponse
  status: 200
}

export type getApiPlacesDetailsResponse200ApplicationJson = {
  data: PlaceDetailsResponse
  status: 200
}

export type getApiPlacesDetailsResponse200TextJson = {
  data: PlaceDetailsResponse
  status: 200
}

export type getApiPlacesDetailsResponse401 = {
  data: GetApiPlacesDetails401
  status: 401
}

export type getApiPlacesDetailsResponseSuccess = (getApiPlacesDetailsResponse200TextPlain | getApiPlacesDetailsResponse200ApplicationJson | getApiPlacesDetailsResponse200TextJson) & {
  headers: Headers;
};
export type getApiPlacesDetailsResponseError = (getApiPlacesDetailsResponse401) & {
  headers: Headers;
};

export type getApiPlacesDetailsResponse = (getApiPlacesDetailsResponseSuccess | getApiPlacesDetailsResponseError)

export const getGetApiPlacesDetailsUrl = (params?: GetApiPlacesDetailsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/places/details?${stringifiedParams}` : `/api/places/details`
}

export const getApiPlacesDetails = async (params?: GetApiPlacesDetailsParams, options?: RequestInit): Promise<getApiPlacesDetailsResponse> => {

  return fetcher<getApiPlacesDetailsResponse>(getGetApiPlacesDetailsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiMonitorPosthogSummaryResponse200TextPlain = {
  data: PosthogUsageSummary
  status: 200
}

export type getApiMonitorPosthogSummaryResponse200ApplicationJson = {
  data: PosthogUsageSummary
  status: 200
}

export type getApiMonitorPosthogSummaryResponse200TextJson = {
  data: PosthogUsageSummary
  status: 200
}

export type getApiMonitorPosthogSummaryResponse401 = {
  data: GetApiMonitorPosthogSummary401
  status: 401
}

export type getApiMonitorPosthogSummaryResponse502 = {
  data: void
  status: 502
}

export type getApiMonitorPosthogSummaryResponse503 = {
  data: void
  status: 503
}

export type getApiMonitorPosthogSummaryResponseSuccess = (getApiMonitorPosthogSummaryResponse200TextPlain | getApiMonitorPosthogSummaryResponse200ApplicationJson | getApiMonitorPosthogSummaryResponse200TextJson) & {
  headers: Headers;
};
export type getApiMonitorPosthogSummaryResponseError = (getApiMonitorPosthogSummaryResponse401 | getApiMonitorPosthogSummaryResponse502 | getApiMonitorPosthogSummaryResponse503) & {
  headers: Headers;
};

export type getApiMonitorPosthogSummaryResponse = (getApiMonitorPosthogSummaryResponseSuccess | getApiMonitorPosthogSummaryResponseError)

export const getGetApiMonitorPosthogSummaryUrl = () => {




  return `/api/monitor/posthog/summary`
}

export const getApiMonitorPosthogSummary = async ( options?: RequestInit): Promise<getApiMonitorPosthogSummaryResponse> => {

  return fetcher<getApiMonitorPosthogSummaryResponse>(getGetApiMonitorPosthogSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiPublicSignupResponse200 = {
  data: void
  status: 200
}

export type postApiPublicSignupResponseSuccess = (postApiPublicSignupResponse200) & {
  headers: Headers;
};
;

export type postApiPublicSignupResponse = (postApiPublicSignupResponseSuccess)

export const getPostApiPublicSignupUrl = () => {




  return `/api/public/signup`
}

export const postApiPublicSignup = async (starterSignupRequest: StarterSignupRequest, options?: RequestInit): Promise<postApiPublicSignupResponse> => {

  return fetcher<postApiPublicSignupResponse>(getPostApiPublicSignupUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      starterSignupRequest,)
  }
);}



export type getApiPublicPortalsResolveResponse200TextPlain = {
  data: PublicPortalPayload
  status: 200
}

export type getApiPublicPortalsResolveResponse200ApplicationJson = {
  data: PublicPortalPayload
  status: 200
}

export type getApiPublicPortalsResolveResponse200TextJson = {
  data: PublicPortalPayload
  status: 200
}

export type getApiPublicPortalsResolveResponseSuccess = (getApiPublicPortalsResolveResponse200TextPlain | getApiPublicPortalsResolveResponse200ApplicationJson | getApiPublicPortalsResolveResponse200TextJson) & {
  headers: Headers;
};
;

export type getApiPublicPortalsResolveResponse = (getApiPublicPortalsResolveResponseSuccess)

export const getGetApiPublicPortalsResolveUrl = (params?: GetApiPublicPortalsResolveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/public/portals/resolve?${stringifiedParams}` : `/api/public/portals/resolve`
}

export const getApiPublicPortalsResolve = async (params?: GetApiPublicPortalsResolveParams, options?: RequestInit): Promise<getApiPublicPortalsResolveResponse> => {

  return fetcher<getApiPublicPortalsResolveResponse>(getGetApiPublicPortalsResolveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiPublicLinksTokenResolveResponse200 = {
  data: void
  status: 200
}

export type postApiPublicLinksTokenResolveResponseSuccess = (postApiPublicLinksTokenResolveResponse200) & {
  headers: Headers;
};
;

export type postApiPublicLinksTokenResolveResponse = (postApiPublicLinksTokenResolveResponseSuccess)

export const getPostApiPublicLinksTokenResolveUrl = (token: string,) => {




  return `/api/public/links/${token}/resolve`
}

export const postApiPublicLinksTokenResolve = async (token: string, options?: RequestInit): Promise<postApiPublicLinksTokenResolveResponse> => {

  return fetcher<postApiPublicLinksTokenResolveResponse>(getPostApiPublicLinksTokenResolveUrl(token),
  {
    ...options,
    method: 'POST'


  }
);}



export type getApiPublicQuoteSelectionsTokenResponse200TextPlain = {
  data: PublicCrmQuoteSelectionPayload
  status: 200
}

export type getApiPublicQuoteSelectionsTokenResponse200ApplicationJson = {
  data: PublicCrmQuoteSelectionPayload
  status: 200
}

export type getApiPublicQuoteSelectionsTokenResponse200TextJson = {
  data: PublicCrmQuoteSelectionPayload
  status: 200
}

export type getApiPublicQuoteSelectionsTokenResponseSuccess = (getApiPublicQuoteSelectionsTokenResponse200TextPlain | getApiPublicQuoteSelectionsTokenResponse200ApplicationJson | getApiPublicQuoteSelectionsTokenResponse200TextJson) & {
  headers: Headers;
};
;

export type getApiPublicQuoteSelectionsTokenResponse = (getApiPublicQuoteSelectionsTokenResponseSuccess)

export const getGetApiPublicQuoteSelectionsTokenUrl = (token: string,) => {




  return `/api/public/quote-selections/${token}`
}

export const getApiPublicQuoteSelectionsToken = async (token: string, options?: RequestInit): Promise<getApiPublicQuoteSelectionsTokenResponse> => {

  return fetcher<getApiPublicQuoteSelectionsTokenResponse>(getGetApiPublicQuoteSelectionsTokenUrl(token),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiPublicQuoteSelectionsTokenDecisionResponse200TextPlain = {
  data: PublicCrmQuoteSelectionPayload
  status: 200
}

export type postApiPublicQuoteSelectionsTokenDecisionResponse200ApplicationJson = {
  data: PublicCrmQuoteSelectionPayload
  status: 200
}

export type postApiPublicQuoteSelectionsTokenDecisionResponse200TextJson = {
  data: PublicCrmQuoteSelectionPayload
  status: 200
}

export type postApiPublicQuoteSelectionsTokenDecisionResponseSuccess = (postApiPublicQuoteSelectionsTokenDecisionResponse200TextPlain | postApiPublicQuoteSelectionsTokenDecisionResponse200ApplicationJson | postApiPublicQuoteSelectionsTokenDecisionResponse200TextJson) & {
  headers: Headers;
};
;

export type postApiPublicQuoteSelectionsTokenDecisionResponse = (postApiPublicQuoteSelectionsTokenDecisionResponseSuccess)

export const getPostApiPublicQuoteSelectionsTokenDecisionUrl = (token: string,) => {




  return `/api/public/quote-selections/${token}/decision`
}

export const postApiPublicQuoteSelectionsTokenDecision = async (token: string,
    submitQuoteSelectionDecisionRequest: SubmitQuoteSelectionDecisionRequest, options?: RequestInit): Promise<postApiPublicQuoteSelectionsTokenDecisionResponse> => {

  return fetcher<postApiPublicQuoteSelectionsTokenDecisionResponse>(getPostApiPublicQuoteSelectionsTokenDecisionUrl(token),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      submitQuoteSelectionDecisionRequest,)
  }
);}



export type postApiPublicPaymentsTokenCheckoutSessionResponse200 = {
  data: void
  status: 200
}

export type postApiPublicPaymentsTokenCheckoutSessionResponseSuccess = (postApiPublicPaymentsTokenCheckoutSessionResponse200) & {
  headers: Headers;
};
;

export type postApiPublicPaymentsTokenCheckoutSessionResponse = (postApiPublicPaymentsTokenCheckoutSessionResponseSuccess)

export const getPostApiPublicPaymentsTokenCheckoutSessionUrl = (token: string,) => {




  return `/api/public/payments/${token}/checkout-session`
}

export const postApiPublicPaymentsTokenCheckoutSession = async (token: string,
    nullCreatePaymentLinkCheckoutSessionRequest: null | CreatePaymentLinkCheckoutSessionRequest, options?: RequestInit): Promise<postApiPublicPaymentsTokenCheckoutSessionResponse> => {

  return fetcher<postApiPublicPaymentsTokenCheckoutSessionResponse>(getPostApiPublicPaymentsTokenCheckoutSessionUrl(token),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullCreatePaymentLinkCheckoutSessionRequest,)
  }
);}



export type getApiPublicPaymentsTokenResponse200 = {
  data: void
  status: 200
}

export type getApiPublicPaymentsTokenResponseSuccess = (getApiPublicPaymentsTokenResponse200) & {
  headers: Headers;
};
;

export type getApiPublicPaymentsTokenResponse = (getApiPublicPaymentsTokenResponseSuccess)

export const getGetApiPublicPaymentsTokenUrl = (token: string,) => {




  return `/api/public/payments/${token}`
}

export const getApiPublicPaymentsToken = async (token: string, options?: RequestInit): Promise<getApiPublicPaymentsTokenResponse> => {

  return fetcher<getApiPublicPaymentsTokenResponse>(getGetApiPublicPaymentsTokenUrl(token),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiStripeWebhookReplayResponse200 = {
  data: void
  status: 200
}

export type postApiStripeWebhookReplayResponse401 = {
  data: PostApiStripeWebhookReplay401
  status: 401
}

export type postApiStripeWebhookReplayResponse402 = {
  data: PostApiStripeWebhookReplay402
  status: 402
}

export type postApiStripeWebhookReplayResponseSuccess = (postApiStripeWebhookReplayResponse200) & {
  headers: Headers;
};
export type postApiStripeWebhookReplayResponseError = (postApiStripeWebhookReplayResponse401 | postApiStripeWebhookReplayResponse402) & {
  headers: Headers;
};

export type postApiStripeWebhookReplayResponse = (postApiStripeWebhookReplayResponseSuccess | postApiStripeWebhookReplayResponseError)

export const getPostApiStripeWebhookReplayUrl = () => {




  return `/api/stripe/webhook/replay`
}

export const postApiStripeWebhookReplay = async (replayStripeEventRequest: ReplayStripeEventRequest, options?: RequestInit): Promise<postApiStripeWebhookReplayResponse> => {

  return fetcher<postApiStripeWebhookReplayResponse>(getPostApiStripeWebhookReplayUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      replayStripeEventRequest,)
  }
);}



export type postApiSupportResponse200TextPlain = {
  data: CreateSupportRequestResponse
  status: 200
}

export type postApiSupportResponse200ApplicationJson = {
  data: CreateSupportRequestResponse
  status: 200
}

export type postApiSupportResponse200TextJson = {
  data: CreateSupportRequestResponse
  status: 200
}

export type postApiSupportResponse401 = {
  data: PostApiSupport401
  status: 401
}

export type postApiSupportResponseSuccess = (postApiSupportResponse200TextPlain | postApiSupportResponse200ApplicationJson | postApiSupportResponse200TextJson) & {
  headers: Headers;
};
export type postApiSupportResponseError = (postApiSupportResponse401) & {
  headers: Headers;
};

export type postApiSupportResponse = (postApiSupportResponseSuccess | postApiSupportResponseError)

export const getPostApiSupportUrl = () => {




  return `/api/support`
}

export const postApiSupport = async (postApiSupportBody: PostApiSupportBody, options?: RequestInit): Promise<postApiSupportResponse> => {
    const formData = new FormData();
if(postApiSupportBody.issueType !== undefined) {
 formData.append(`issueType`, postApiSupportBody.issueType);
 }
if(postApiSupportBody.priority !== undefined) {
 formData.append(`priority`, postApiSupportBody.priority);
 }
if(postApiSupportBody.message !== undefined) {
 formData.append(`message`, postApiSupportBody.message);
 }
if(postApiSupportBody.attachments !== undefined) {
 postApiSupportBody.attachments.forEach(value => formData.append(`attachments`, value));
 }

  return fetcher<postApiSupportResponse>(getPostApiSupportUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body:
      formData,
  }
);}



export type getApiTeamsTeamIdIntegrationsAccountingQuickbooksResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdIntegrationsAccountingQuickbooksResponse401 = {
  data: GetApiTeamsTeamIdIntegrationsAccountingQuickbooks401
  status: 401
}

export type getApiTeamsTeamIdIntegrationsAccountingQuickbooksResponseSuccess = (getApiTeamsTeamIdIntegrationsAccountingQuickbooksResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdIntegrationsAccountingQuickbooksResponseError = (getApiTeamsTeamIdIntegrationsAccountingQuickbooksResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdIntegrationsAccountingQuickbooksResponse = (getApiTeamsTeamIdIntegrationsAccountingQuickbooksResponseSuccess | getApiTeamsTeamIdIntegrationsAccountingQuickbooksResponseError)

export const getGetApiTeamsTeamIdIntegrationsAccountingQuickbooksUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/integrations/accounting/quickbooks`
}

export const getApiTeamsTeamIdIntegrationsAccountingQuickbooks = async (teamId: string, options?: RequestInit): Promise<getApiTeamsTeamIdIntegrationsAccountingQuickbooksResponse> => {

  return fetcher<getApiTeamsTeamIdIntegrationsAccountingQuickbooksResponse>(getGetApiTeamsTeamIdIntegrationsAccountingQuickbooksUrl(teamId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdIntegrationsAccountingQuickbooksConnectStartResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdIntegrationsAccountingQuickbooksConnectStartResponse401 = {
  data: PostApiTeamsTeamIdIntegrationsAccountingQuickbooksConnectStart401
  status: 401
}

export type postApiTeamsTeamIdIntegrationsAccountingQuickbooksConnectStartResponse402 = {
  data: PostApiTeamsTeamIdIntegrationsAccountingQuickbooksConnectStart402
  status: 402
}

export type postApiTeamsTeamIdIntegrationsAccountingQuickbooksConnectStartResponseSuccess = (postApiTeamsTeamIdIntegrationsAccountingQuickbooksConnectStartResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdIntegrationsAccountingQuickbooksConnectStartResponseError = (postApiTeamsTeamIdIntegrationsAccountingQuickbooksConnectStartResponse401 | postApiTeamsTeamIdIntegrationsAccountingQuickbooksConnectStartResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdIntegrationsAccountingQuickbooksConnectStartResponse = (postApiTeamsTeamIdIntegrationsAccountingQuickbooksConnectStartResponseSuccess | postApiTeamsTeamIdIntegrationsAccountingQuickbooksConnectStartResponseError)

export const getPostApiTeamsTeamIdIntegrationsAccountingQuickbooksConnectStartUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/integrations/accounting/quickbooks/connect/start`
}

export const postApiTeamsTeamIdIntegrationsAccountingQuickbooksConnectStart = async (teamId: string,
    nullQuickBooksConnectStartRequest: null | QuickBooksConnectStartRequest, options?: RequestInit): Promise<postApiTeamsTeamIdIntegrationsAccountingQuickbooksConnectStartResponse> => {

  return fetcher<postApiTeamsTeamIdIntegrationsAccountingQuickbooksConnectStartResponse>(getPostApiTeamsTeamIdIntegrationsAccountingQuickbooksConnectStartUrl(teamId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullQuickBooksConnectStartRequest,)
  }
);}



export type postApiTeamsTeamIdIntegrationsAccountingQuickbooksDisconnectResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdIntegrationsAccountingQuickbooksDisconnectResponse401 = {
  data: PostApiTeamsTeamIdIntegrationsAccountingQuickbooksDisconnect401
  status: 401
}

export type postApiTeamsTeamIdIntegrationsAccountingQuickbooksDisconnectResponse402 = {
  data: PostApiTeamsTeamIdIntegrationsAccountingQuickbooksDisconnect402
  status: 402
}

export type postApiTeamsTeamIdIntegrationsAccountingQuickbooksDisconnectResponseSuccess = (postApiTeamsTeamIdIntegrationsAccountingQuickbooksDisconnectResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdIntegrationsAccountingQuickbooksDisconnectResponseError = (postApiTeamsTeamIdIntegrationsAccountingQuickbooksDisconnectResponse401 | postApiTeamsTeamIdIntegrationsAccountingQuickbooksDisconnectResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdIntegrationsAccountingQuickbooksDisconnectResponse = (postApiTeamsTeamIdIntegrationsAccountingQuickbooksDisconnectResponseSuccess | postApiTeamsTeamIdIntegrationsAccountingQuickbooksDisconnectResponseError)

export const getPostApiTeamsTeamIdIntegrationsAccountingQuickbooksDisconnectUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/integrations/accounting/quickbooks/disconnect`
}

export const postApiTeamsTeamIdIntegrationsAccountingQuickbooksDisconnect = async (teamId: string, options?: RequestInit): Promise<postApiTeamsTeamIdIntegrationsAccountingQuickbooksDisconnectResponse> => {

  return fetcher<postApiTeamsTeamIdIntegrationsAccountingQuickbooksDisconnectResponse>(getPostApiTeamsTeamIdIntegrationsAccountingQuickbooksDisconnectUrl(teamId),
  {
    ...options,
    method: 'POST'


  }
);}



export type getApiTeamsTeamIdIntegrationsAccountingQuickbooksSyncRunsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdIntegrationsAccountingQuickbooksSyncRunsResponse401 = {
  data: GetApiTeamsTeamIdIntegrationsAccountingQuickbooksSyncRuns401
  status: 401
}

export type getApiTeamsTeamIdIntegrationsAccountingQuickbooksSyncRunsResponseSuccess = (getApiTeamsTeamIdIntegrationsAccountingQuickbooksSyncRunsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdIntegrationsAccountingQuickbooksSyncRunsResponseError = (getApiTeamsTeamIdIntegrationsAccountingQuickbooksSyncRunsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdIntegrationsAccountingQuickbooksSyncRunsResponse = (getApiTeamsTeamIdIntegrationsAccountingQuickbooksSyncRunsResponseSuccess | getApiTeamsTeamIdIntegrationsAccountingQuickbooksSyncRunsResponseError)

export const getGetApiTeamsTeamIdIntegrationsAccountingQuickbooksSyncRunsUrl = (teamId: string,
    params?: GetApiTeamsTeamIdIntegrationsAccountingQuickbooksSyncRunsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/integrations/accounting/quickbooks/sync/runs?${stringifiedParams}` : `/api/teams/${teamId}/integrations/accounting/quickbooks/sync/runs`
}

export const getApiTeamsTeamIdIntegrationsAccountingQuickbooksSyncRuns = async (teamId: string,
    params?: GetApiTeamsTeamIdIntegrationsAccountingQuickbooksSyncRunsParams, options?: RequestInit): Promise<getApiTeamsTeamIdIntegrationsAccountingQuickbooksSyncRunsResponse> => {

  return fetcher<getApiTeamsTeamIdIntegrationsAccountingQuickbooksSyncRunsResponse>(getGetApiTeamsTeamIdIntegrationsAccountingQuickbooksSyncRunsUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdIntegrationsAccountingQuickbooksSyncRunResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdIntegrationsAccountingQuickbooksSyncRunResponse401 = {
  data: PostApiTeamsTeamIdIntegrationsAccountingQuickbooksSyncRun401
  status: 401
}

export type postApiTeamsTeamIdIntegrationsAccountingQuickbooksSyncRunResponse402 = {
  data: PostApiTeamsTeamIdIntegrationsAccountingQuickbooksSyncRun402
  status: 402
}

export type postApiTeamsTeamIdIntegrationsAccountingQuickbooksSyncRunResponseSuccess = (postApiTeamsTeamIdIntegrationsAccountingQuickbooksSyncRunResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdIntegrationsAccountingQuickbooksSyncRunResponseError = (postApiTeamsTeamIdIntegrationsAccountingQuickbooksSyncRunResponse401 | postApiTeamsTeamIdIntegrationsAccountingQuickbooksSyncRunResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdIntegrationsAccountingQuickbooksSyncRunResponse = (postApiTeamsTeamIdIntegrationsAccountingQuickbooksSyncRunResponseSuccess | postApiTeamsTeamIdIntegrationsAccountingQuickbooksSyncRunResponseError)

export const getPostApiTeamsTeamIdIntegrationsAccountingQuickbooksSyncRunUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/integrations/accounting/quickbooks/sync/run`
}

export const postApiTeamsTeamIdIntegrationsAccountingQuickbooksSyncRun = async (teamId: string,
    nullQuickBooksManualSyncRequest: null | QuickBooksManualSyncRequest, options?: RequestInit): Promise<postApiTeamsTeamIdIntegrationsAccountingQuickbooksSyncRunResponse> => {

  return fetcher<postApiTeamsTeamIdIntegrationsAccountingQuickbooksSyncRunResponse>(getPostApiTeamsTeamIdIntegrationsAccountingQuickbooksSyncRunUrl(teamId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullQuickBooksManualSyncRequest,)
  }
);}



export type getApiTeamsTeamIdIntegrationsAccountingQuickbooksCallbackResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdIntegrationsAccountingQuickbooksCallbackResponseSuccess = (getApiTeamsTeamIdIntegrationsAccountingQuickbooksCallbackResponse200) & {
  headers: Headers;
};
;

export type getApiTeamsTeamIdIntegrationsAccountingQuickbooksCallbackResponse = (getApiTeamsTeamIdIntegrationsAccountingQuickbooksCallbackResponseSuccess)

export const getGetApiTeamsTeamIdIntegrationsAccountingQuickbooksCallbackUrl = (teamId: string,
    params?: GetApiTeamsTeamIdIntegrationsAccountingQuickbooksCallbackParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/integrations/accounting/quickbooks/callback?${stringifiedParams}` : `/api/teams/${teamId}/integrations/accounting/quickbooks/callback`
}

export const getApiTeamsTeamIdIntegrationsAccountingQuickbooksCallback = async (teamId: string,
    params?: GetApiTeamsTeamIdIntegrationsAccountingQuickbooksCallbackParams, options?: RequestInit): Promise<getApiTeamsTeamIdIntegrationsAccountingQuickbooksCallbackResponse> => {

  return fetcher<getApiTeamsTeamIdIntegrationsAccountingQuickbooksCallbackResponse>(getGetApiTeamsTeamIdIntegrationsAccountingQuickbooksCallbackUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdAgentEpisodesResponse200TextPlain = {
  data: AgentEpisodeListResponse
  status: 200
}

export type getApiTeamsTeamIdAgentEpisodesResponse200ApplicationJson = {
  data: AgentEpisodeListResponse
  status: 200
}

export type getApiTeamsTeamIdAgentEpisodesResponse200TextJson = {
  data: AgentEpisodeListResponse
  status: 200
}

export type getApiTeamsTeamIdAgentEpisodesResponse401 = {
  data: GetApiTeamsTeamIdAgentEpisodes401
  status: 401
}

export type getApiTeamsTeamIdAgentEpisodesResponse403TextPlain = {
  data: TeamAgentErrorResponse
  status: 403
}

export type getApiTeamsTeamIdAgentEpisodesResponse403ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type getApiTeamsTeamIdAgentEpisodesResponse403TextJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type getApiTeamsTeamIdAgentEpisodesResponseSuccess = (getApiTeamsTeamIdAgentEpisodesResponse200TextPlain | getApiTeamsTeamIdAgentEpisodesResponse200ApplicationJson | getApiTeamsTeamIdAgentEpisodesResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsTeamIdAgentEpisodesResponseError = (getApiTeamsTeamIdAgentEpisodesResponse401 | getApiTeamsTeamIdAgentEpisodesResponse403TextPlain | getApiTeamsTeamIdAgentEpisodesResponse403ApplicationJson | getApiTeamsTeamIdAgentEpisodesResponse403TextJson) & {
  headers: Headers;
};

export type getApiTeamsTeamIdAgentEpisodesResponse = (getApiTeamsTeamIdAgentEpisodesResponseSuccess | getApiTeamsTeamIdAgentEpisodesResponseError)

export const getGetApiTeamsTeamIdAgentEpisodesUrl = (teamId: string,
    params?: GetApiTeamsTeamIdAgentEpisodesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/agent-episodes?${stringifiedParams}` : `/api/teams/${teamId}/agent-episodes`
}

export const getApiTeamsTeamIdAgentEpisodes = async (teamId: string,
    params?: GetApiTeamsTeamIdAgentEpisodesParams, options?: RequestInit): Promise<getApiTeamsTeamIdAgentEpisodesResponse> => {

  return fetcher<getApiTeamsTeamIdAgentEpisodesResponse>(getGetApiTeamsTeamIdAgentEpisodesUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdAgentEpisodesDeriveRunIdResponse200TextPlain = {
  data: AgentEpisodeDerivationResponse
  status: 200
}

export type postApiTeamsTeamIdAgentEpisodesDeriveRunIdResponse200ApplicationJson = {
  data: AgentEpisodeDerivationResponse
  status: 200
}

export type postApiTeamsTeamIdAgentEpisodesDeriveRunIdResponse200TextJson = {
  data: AgentEpisodeDerivationResponse
  status: 200
}

export type postApiTeamsTeamIdAgentEpisodesDeriveRunIdResponse401 = {
  data: PostApiTeamsTeamIdAgentEpisodesDeriveRunId401
  status: 401
}

export type postApiTeamsTeamIdAgentEpisodesDeriveRunIdResponse402 = {
  data: PostApiTeamsTeamIdAgentEpisodesDeriveRunId402
  status: 402
}

export type postApiTeamsTeamIdAgentEpisodesDeriveRunIdResponse404TextPlain = {
  data: TeamAgentErrorResponse
  status: 404
}

export type postApiTeamsTeamIdAgentEpisodesDeriveRunIdResponse404ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 404
}

export type postApiTeamsTeamIdAgentEpisodesDeriveRunIdResponse404TextJson = {
  data: TeamAgentErrorResponse
  status: 404
}

export type postApiTeamsTeamIdAgentEpisodesDeriveRunIdResponseSuccess = (postApiTeamsTeamIdAgentEpisodesDeriveRunIdResponse200TextPlain | postApiTeamsTeamIdAgentEpisodesDeriveRunIdResponse200ApplicationJson | postApiTeamsTeamIdAgentEpisodesDeriveRunIdResponse200TextJson) & {
  headers: Headers;
};
export type postApiTeamsTeamIdAgentEpisodesDeriveRunIdResponseError = (postApiTeamsTeamIdAgentEpisodesDeriveRunIdResponse401 | postApiTeamsTeamIdAgentEpisodesDeriveRunIdResponse402 | postApiTeamsTeamIdAgentEpisodesDeriveRunIdResponse404TextPlain | postApiTeamsTeamIdAgentEpisodesDeriveRunIdResponse404ApplicationJson | postApiTeamsTeamIdAgentEpisodesDeriveRunIdResponse404TextJson) & {
  headers: Headers;
};

export type postApiTeamsTeamIdAgentEpisodesDeriveRunIdResponse = (postApiTeamsTeamIdAgentEpisodesDeriveRunIdResponseSuccess | postApiTeamsTeamIdAgentEpisodesDeriveRunIdResponseError)

export const getPostApiTeamsTeamIdAgentEpisodesDeriveRunIdUrl = (teamId: string,
    runId: string,) => {




  return `/api/teams/${teamId}/agent-episodes/derive/${runId}`
}

export const postApiTeamsTeamIdAgentEpisodesDeriveRunId = async (teamId: string,
    runId: string, options?: RequestInit): Promise<postApiTeamsTeamIdAgentEpisodesDeriveRunIdResponse> => {

  return fetcher<postApiTeamsTeamIdAgentEpisodesDeriveRunIdResponse>(getPostApiTeamsTeamIdAgentEpisodesDeriveRunIdUrl(teamId,runId),
  {
    ...options,
    method: 'POST'


  }
);}



export type postApiTeamsTeamIdAgentEpisodesEpisodeIdSuppressResponse200TextPlain = {
  data: AgentEpisodeSuppressionResponse
  status: 200
}

export type postApiTeamsTeamIdAgentEpisodesEpisodeIdSuppressResponse200ApplicationJson = {
  data: AgentEpisodeSuppressionResponse
  status: 200
}

export type postApiTeamsTeamIdAgentEpisodesEpisodeIdSuppressResponse200TextJson = {
  data: AgentEpisodeSuppressionResponse
  status: 200
}

export type postApiTeamsTeamIdAgentEpisodesEpisodeIdSuppressResponse401 = {
  data: PostApiTeamsTeamIdAgentEpisodesEpisodeIdSuppress401
  status: 401
}

export type postApiTeamsTeamIdAgentEpisodesEpisodeIdSuppressResponse402 = {
  data: PostApiTeamsTeamIdAgentEpisodesEpisodeIdSuppress402
  status: 402
}

export type postApiTeamsTeamIdAgentEpisodesEpisodeIdSuppressResponse404TextPlain = {
  data: TeamAgentErrorResponse
  status: 404
}

export type postApiTeamsTeamIdAgentEpisodesEpisodeIdSuppressResponse404ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 404
}

export type postApiTeamsTeamIdAgentEpisodesEpisodeIdSuppressResponse404TextJson = {
  data: TeamAgentErrorResponse
  status: 404
}

export type postApiTeamsTeamIdAgentEpisodesEpisodeIdSuppressResponseSuccess = (postApiTeamsTeamIdAgentEpisodesEpisodeIdSuppressResponse200TextPlain | postApiTeamsTeamIdAgentEpisodesEpisodeIdSuppressResponse200ApplicationJson | postApiTeamsTeamIdAgentEpisodesEpisodeIdSuppressResponse200TextJson) & {
  headers: Headers;
};
export type postApiTeamsTeamIdAgentEpisodesEpisodeIdSuppressResponseError = (postApiTeamsTeamIdAgentEpisodesEpisodeIdSuppressResponse401 | postApiTeamsTeamIdAgentEpisodesEpisodeIdSuppressResponse402 | postApiTeamsTeamIdAgentEpisodesEpisodeIdSuppressResponse404TextPlain | postApiTeamsTeamIdAgentEpisodesEpisodeIdSuppressResponse404ApplicationJson | postApiTeamsTeamIdAgentEpisodesEpisodeIdSuppressResponse404TextJson) & {
  headers: Headers;
};

export type postApiTeamsTeamIdAgentEpisodesEpisodeIdSuppressResponse = (postApiTeamsTeamIdAgentEpisodesEpisodeIdSuppressResponseSuccess | postApiTeamsTeamIdAgentEpisodesEpisodeIdSuppressResponseError)

export const getPostApiTeamsTeamIdAgentEpisodesEpisodeIdSuppressUrl = (teamId: string,
    episodeId: string,) => {




  return `/api/teams/${teamId}/agent-episodes/${episodeId}/suppress`
}

export const postApiTeamsTeamIdAgentEpisodesEpisodeIdSuppress = async (teamId: string,
    episodeId: string, options?: RequestInit): Promise<postApiTeamsTeamIdAgentEpisodesEpisodeIdSuppressResponse> => {

  return fetcher<postApiTeamsTeamIdAgentEpisodesEpisodeIdSuppressResponse>(getPostApiTeamsTeamIdAgentEpisodesEpisodeIdSuppressUrl(teamId,episodeId),
  {
    ...options,
    method: 'POST'


  }
);}



export type getApiTeamsTeamIdAgentMemoriesResponse200TextPlain = {
  data: AgentMemoryListResponse
  status: 200
}

export type getApiTeamsTeamIdAgentMemoriesResponse200ApplicationJson = {
  data: AgentMemoryListResponse
  status: 200
}

export type getApiTeamsTeamIdAgentMemoriesResponse200TextJson = {
  data: AgentMemoryListResponse
  status: 200
}

export type getApiTeamsTeamIdAgentMemoriesResponse401TextPlain = {
  data: TeamAgentErrorResponse
  status: 401
}

export type getApiTeamsTeamIdAgentMemoriesResponse401ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 401
}

export type getApiTeamsTeamIdAgentMemoriesResponse401TextJson = {
  data: TeamAgentErrorResponse
  status: 401
}

export type getApiTeamsTeamIdAgentMemoriesResponse403TextPlain = {
  data: TeamAgentErrorResponse
  status: 403
}

export type getApiTeamsTeamIdAgentMemoriesResponse403ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type getApiTeamsTeamIdAgentMemoriesResponse403TextJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type getApiTeamsTeamIdAgentMemoriesResponseSuccess = (getApiTeamsTeamIdAgentMemoriesResponse200TextPlain | getApiTeamsTeamIdAgentMemoriesResponse200ApplicationJson | getApiTeamsTeamIdAgentMemoriesResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsTeamIdAgentMemoriesResponseError = (getApiTeamsTeamIdAgentMemoriesResponse401TextPlain | getApiTeamsTeamIdAgentMemoriesResponse401ApplicationJson | getApiTeamsTeamIdAgentMemoriesResponse401TextJson | getApiTeamsTeamIdAgentMemoriesResponse403TextPlain | getApiTeamsTeamIdAgentMemoriesResponse403ApplicationJson | getApiTeamsTeamIdAgentMemoriesResponse403TextJson) & {
  headers: Headers;
};

export type getApiTeamsTeamIdAgentMemoriesResponse = (getApiTeamsTeamIdAgentMemoriesResponseSuccess | getApiTeamsTeamIdAgentMemoriesResponseError)

export const getGetApiTeamsTeamIdAgentMemoriesUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/agent-memories`
}

export const getApiTeamsTeamIdAgentMemories = async (teamId: string, options?: RequestInit): Promise<getApiTeamsTeamIdAgentMemoriesResponse> => {

  return fetcher<getApiTeamsTeamIdAgentMemoriesResponse>(getGetApiTeamsTeamIdAgentMemoriesUrl(teamId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdAgentMemoriesChainResponse200TextPlain = {
  data: AgentMemoryListResponse
  status: 200
}

export type getApiTeamsTeamIdAgentMemoriesChainResponse200ApplicationJson = {
  data: AgentMemoryListResponse
  status: 200
}

export type getApiTeamsTeamIdAgentMemoriesChainResponse200TextJson = {
  data: AgentMemoryListResponse
  status: 200
}

export type getApiTeamsTeamIdAgentMemoriesChainResponse401 = {
  data: GetApiTeamsTeamIdAgentMemoriesChain401
  status: 401
}

export type getApiTeamsTeamIdAgentMemoriesChainResponse404TextPlain = {
  data: TeamAgentErrorResponse
  status: 404
}

export type getApiTeamsTeamIdAgentMemoriesChainResponse404ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 404
}

export type getApiTeamsTeamIdAgentMemoriesChainResponse404TextJson = {
  data: TeamAgentErrorResponse
  status: 404
}

export type getApiTeamsTeamIdAgentMemoriesChainResponseSuccess = (getApiTeamsTeamIdAgentMemoriesChainResponse200TextPlain | getApiTeamsTeamIdAgentMemoriesChainResponse200ApplicationJson | getApiTeamsTeamIdAgentMemoriesChainResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsTeamIdAgentMemoriesChainResponseError = (getApiTeamsTeamIdAgentMemoriesChainResponse401 | getApiTeamsTeamIdAgentMemoriesChainResponse404TextPlain | getApiTeamsTeamIdAgentMemoriesChainResponse404ApplicationJson | getApiTeamsTeamIdAgentMemoriesChainResponse404TextJson) & {
  headers: Headers;
};

export type getApiTeamsTeamIdAgentMemoriesChainResponse = (getApiTeamsTeamIdAgentMemoriesChainResponseSuccess | getApiTeamsTeamIdAgentMemoriesChainResponseError)

export const getGetApiTeamsTeamIdAgentMemoriesChainUrl = (teamId: string,
    params?: GetApiTeamsTeamIdAgentMemoriesChainParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/agent-memories/chain?${stringifiedParams}` : `/api/teams/${teamId}/agent-memories/chain`
}

export const getApiTeamsTeamIdAgentMemoriesChain = async (teamId: string,
    params?: GetApiTeamsTeamIdAgentMemoriesChainParams, options?: RequestInit): Promise<getApiTeamsTeamIdAgentMemoriesChainResponse> => {

  return fetcher<getApiTeamsTeamIdAgentMemoriesChainResponse>(getGetApiTeamsTeamIdAgentMemoriesChainUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type putApiTeamsTeamIdAgentMemoriesKeyResponse200TextPlain = {
  data: AgentMemoryEntryResponse
  status: 200
}

export type putApiTeamsTeamIdAgentMemoriesKeyResponse200ApplicationJson = {
  data: AgentMemoryEntryResponse
  status: 200
}

export type putApiTeamsTeamIdAgentMemoriesKeyResponse200TextJson = {
  data: AgentMemoryEntryResponse
  status: 200
}

export type putApiTeamsTeamIdAgentMemoriesKeyResponse400TextPlain = {
  data: TeamAgentErrorResponse
  status: 400
}

export type putApiTeamsTeamIdAgentMemoriesKeyResponse400ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 400
}

export type putApiTeamsTeamIdAgentMemoriesKeyResponse400TextJson = {
  data: TeamAgentErrorResponse
  status: 400
}

export type putApiTeamsTeamIdAgentMemoriesKeyResponse401 = {
  data: PutApiTeamsTeamIdAgentMemoriesKey401
  status: 401
}

export type putApiTeamsTeamIdAgentMemoriesKeyResponse402 = {
  data: PutApiTeamsTeamIdAgentMemoriesKey402
  status: 402
}

export type putApiTeamsTeamIdAgentMemoriesKeyResponseSuccess = (putApiTeamsTeamIdAgentMemoriesKeyResponse200TextPlain | putApiTeamsTeamIdAgentMemoriesKeyResponse200ApplicationJson | putApiTeamsTeamIdAgentMemoriesKeyResponse200TextJson) & {
  headers: Headers;
};
export type putApiTeamsTeamIdAgentMemoriesKeyResponseError = (putApiTeamsTeamIdAgentMemoriesKeyResponse400TextPlain | putApiTeamsTeamIdAgentMemoriesKeyResponse400ApplicationJson | putApiTeamsTeamIdAgentMemoriesKeyResponse400TextJson | putApiTeamsTeamIdAgentMemoriesKeyResponse401 | putApiTeamsTeamIdAgentMemoriesKeyResponse402) & {
  headers: Headers;
};

export type putApiTeamsTeamIdAgentMemoriesKeyResponse = (putApiTeamsTeamIdAgentMemoriesKeyResponseSuccess | putApiTeamsTeamIdAgentMemoriesKeyResponseError)

export const getPutApiTeamsTeamIdAgentMemoriesKeyUrl = (teamId: string,
    key: string,) => {




  return `/api/teams/${teamId}/agent-memories/${key}`
}

export const putApiTeamsTeamIdAgentMemoriesKey = async (teamId: string,
    key: string,
    upsertAgentMemoryRequest: UpsertAgentMemoryRequest, options?: RequestInit): Promise<putApiTeamsTeamIdAgentMemoriesKeyResponse> => {

  return fetcher<putApiTeamsTeamIdAgentMemoriesKeyResponse>(getPutApiTeamsTeamIdAgentMemoriesKeyUrl(teamId,key),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upsertAgentMemoryRequest,)
  }
);}



export type deleteApiTeamsTeamIdAgentMemoriesKeyResponse200TextPlain = {
  data: AgentMemoryDeleteResponse
  status: 200
}

export type deleteApiTeamsTeamIdAgentMemoriesKeyResponse200ApplicationJson = {
  data: AgentMemoryDeleteResponse
  status: 200
}

export type deleteApiTeamsTeamIdAgentMemoriesKeyResponse200TextJson = {
  data: AgentMemoryDeleteResponse
  status: 200
}

export type deleteApiTeamsTeamIdAgentMemoriesKeyResponse401 = {
  data: DeleteApiTeamsTeamIdAgentMemoriesKey401
  status: 401
}

export type deleteApiTeamsTeamIdAgentMemoriesKeyResponse402 = {
  data: DeleteApiTeamsTeamIdAgentMemoriesKey402
  status: 402
}

export type deleteApiTeamsTeamIdAgentMemoriesKeyResponse404TextPlain = {
  data: TeamAgentErrorResponse
  status: 404
}

export type deleteApiTeamsTeamIdAgentMemoriesKeyResponse404ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 404
}

export type deleteApiTeamsTeamIdAgentMemoriesKeyResponse404TextJson = {
  data: TeamAgentErrorResponse
  status: 404
}

export type deleteApiTeamsTeamIdAgentMemoriesKeyResponseSuccess = (deleteApiTeamsTeamIdAgentMemoriesKeyResponse200TextPlain | deleteApiTeamsTeamIdAgentMemoriesKeyResponse200ApplicationJson | deleteApiTeamsTeamIdAgentMemoriesKeyResponse200TextJson) & {
  headers: Headers;
};
export type deleteApiTeamsTeamIdAgentMemoriesKeyResponseError = (deleteApiTeamsTeamIdAgentMemoriesKeyResponse401 | deleteApiTeamsTeamIdAgentMemoriesKeyResponse402 | deleteApiTeamsTeamIdAgentMemoriesKeyResponse404TextPlain | deleteApiTeamsTeamIdAgentMemoriesKeyResponse404ApplicationJson | deleteApiTeamsTeamIdAgentMemoriesKeyResponse404TextJson) & {
  headers: Headers;
};

export type deleteApiTeamsTeamIdAgentMemoriesKeyResponse = (deleteApiTeamsTeamIdAgentMemoriesKeyResponseSuccess | deleteApiTeamsTeamIdAgentMemoriesKeyResponseError)

export const getDeleteApiTeamsTeamIdAgentMemoriesKeyUrl = (teamId: string,
    key: string,) => {




  return `/api/teams/${teamId}/agent-memories/${key}`
}

export const deleteApiTeamsTeamIdAgentMemoriesKey = async (teamId: string,
    key: string, options?: RequestInit): Promise<deleteApiTeamsTeamIdAgentMemoriesKeyResponse> => {

  return fetcher<deleteApiTeamsTeamIdAgentMemoriesKeyResponse>(getDeleteApiTeamsTeamIdAgentMemoriesKeyUrl(teamId,key),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type getApiTeamsTeamIdAgentProceduresResponse200TextPlain = {
  data: AgentProcedureListResponse
  status: 200
}

export type getApiTeamsTeamIdAgentProceduresResponse200ApplicationJson = {
  data: AgentProcedureListResponse
  status: 200
}

export type getApiTeamsTeamIdAgentProceduresResponse200TextJson = {
  data: AgentProcedureListResponse
  status: 200
}

export type getApiTeamsTeamIdAgentProceduresResponse401 = {
  data: GetApiTeamsTeamIdAgentProcedures401
  status: 401
}

export type getApiTeamsTeamIdAgentProceduresResponse403TextPlain = {
  data: TeamAgentErrorResponse
  status: 403
}

export type getApiTeamsTeamIdAgentProceduresResponse403ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type getApiTeamsTeamIdAgentProceduresResponse403TextJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type getApiTeamsTeamIdAgentProceduresResponseSuccess = (getApiTeamsTeamIdAgentProceduresResponse200TextPlain | getApiTeamsTeamIdAgentProceduresResponse200ApplicationJson | getApiTeamsTeamIdAgentProceduresResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsTeamIdAgentProceduresResponseError = (getApiTeamsTeamIdAgentProceduresResponse401 | getApiTeamsTeamIdAgentProceduresResponse403TextPlain | getApiTeamsTeamIdAgentProceduresResponse403ApplicationJson | getApiTeamsTeamIdAgentProceduresResponse403TextJson) & {
  headers: Headers;
};

export type getApiTeamsTeamIdAgentProceduresResponse = (getApiTeamsTeamIdAgentProceduresResponseSuccess | getApiTeamsTeamIdAgentProceduresResponseError)

export const getGetApiTeamsTeamIdAgentProceduresUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/agent-procedures`
}

export const getApiTeamsTeamIdAgentProcedures = async (teamId: string, options?: RequestInit): Promise<getApiTeamsTeamIdAgentProceduresResponse> => {

  return fetcher<getApiTeamsTeamIdAgentProceduresResponse>(getGetApiTeamsTeamIdAgentProceduresUrl(teamId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdAgentProceduresNameResponse200TextPlain = {
  data: AgentProcedureDetailResponse
  status: 200
}

export type getApiTeamsTeamIdAgentProceduresNameResponse200ApplicationJson = {
  data: AgentProcedureDetailResponse
  status: 200
}

export type getApiTeamsTeamIdAgentProceduresNameResponse200TextJson = {
  data: AgentProcedureDetailResponse
  status: 200
}

export type getApiTeamsTeamIdAgentProceduresNameResponse401 = {
  data: GetApiTeamsTeamIdAgentProceduresName401
  status: 401
}

export type getApiTeamsTeamIdAgentProceduresNameResponse404TextPlain = {
  data: TeamAgentErrorResponse
  status: 404
}

export type getApiTeamsTeamIdAgentProceduresNameResponse404ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 404
}

export type getApiTeamsTeamIdAgentProceduresNameResponse404TextJson = {
  data: TeamAgentErrorResponse
  status: 404
}

export type getApiTeamsTeamIdAgentProceduresNameResponseSuccess = (getApiTeamsTeamIdAgentProceduresNameResponse200TextPlain | getApiTeamsTeamIdAgentProceduresNameResponse200ApplicationJson | getApiTeamsTeamIdAgentProceduresNameResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsTeamIdAgentProceduresNameResponseError = (getApiTeamsTeamIdAgentProceduresNameResponse401 | getApiTeamsTeamIdAgentProceduresNameResponse404TextPlain | getApiTeamsTeamIdAgentProceduresNameResponse404ApplicationJson | getApiTeamsTeamIdAgentProceduresNameResponse404TextJson) & {
  headers: Headers;
};

export type getApiTeamsTeamIdAgentProceduresNameResponse = (getApiTeamsTeamIdAgentProceduresNameResponseSuccess | getApiTeamsTeamIdAgentProceduresNameResponseError)

export const getGetApiTeamsTeamIdAgentProceduresNameUrl = (teamId: string,
    name: string,) => {




  return `/api/teams/${teamId}/agent-procedures/${name}`
}

export const getApiTeamsTeamIdAgentProceduresName = async (teamId: string,
    name: string, options?: RequestInit): Promise<getApiTeamsTeamIdAgentProceduresNameResponse> => {

  return fetcher<getApiTeamsTeamIdAgentProceduresNameResponse>(getGetApiTeamsTeamIdAgentProceduresNameUrl(teamId,name),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdAgentProceduresNameVersionsResponse200TextPlain = {
  data: AgentProcedureVersionResponse
  status: 200
}

export type postApiTeamsTeamIdAgentProceduresNameVersionsResponse200ApplicationJson = {
  data: AgentProcedureVersionResponse
  status: 200
}

export type postApiTeamsTeamIdAgentProceduresNameVersionsResponse200TextJson = {
  data: AgentProcedureVersionResponse
  status: 200
}

export type postApiTeamsTeamIdAgentProceduresNameVersionsResponse400TextPlain = {
  data: TeamAgentErrorResponse
  status: 400
}

export type postApiTeamsTeamIdAgentProceduresNameVersionsResponse400ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 400
}

export type postApiTeamsTeamIdAgentProceduresNameVersionsResponse400TextJson = {
  data: TeamAgentErrorResponse
  status: 400
}

export type postApiTeamsTeamIdAgentProceduresNameVersionsResponse401 = {
  data: PostApiTeamsTeamIdAgentProceduresNameVersions401
  status: 401
}

export type postApiTeamsTeamIdAgentProceduresNameVersionsResponse402 = {
  data: PostApiTeamsTeamIdAgentProceduresNameVersions402
  status: 402
}

export type postApiTeamsTeamIdAgentProceduresNameVersionsResponseSuccess = (postApiTeamsTeamIdAgentProceduresNameVersionsResponse200TextPlain | postApiTeamsTeamIdAgentProceduresNameVersionsResponse200ApplicationJson | postApiTeamsTeamIdAgentProceduresNameVersionsResponse200TextJson) & {
  headers: Headers;
};
export type postApiTeamsTeamIdAgentProceduresNameVersionsResponseError = (postApiTeamsTeamIdAgentProceduresNameVersionsResponse400TextPlain | postApiTeamsTeamIdAgentProceduresNameVersionsResponse400ApplicationJson | postApiTeamsTeamIdAgentProceduresNameVersionsResponse400TextJson | postApiTeamsTeamIdAgentProceduresNameVersionsResponse401 | postApiTeamsTeamIdAgentProceduresNameVersionsResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdAgentProceduresNameVersionsResponse = (postApiTeamsTeamIdAgentProceduresNameVersionsResponseSuccess | postApiTeamsTeamIdAgentProceduresNameVersionsResponseError)

export const getPostApiTeamsTeamIdAgentProceduresNameVersionsUrl = (teamId: string,
    name: string,) => {




  return `/api/teams/${teamId}/agent-procedures/${name}/versions`
}

export const postApiTeamsTeamIdAgentProceduresNameVersions = async (teamId: string,
    name: string,
    createAgentProcedureVersionRequest: CreateAgentProcedureVersionRequest, options?: RequestInit): Promise<postApiTeamsTeamIdAgentProceduresNameVersionsResponse> => {

  return fetcher<postApiTeamsTeamIdAgentProceduresNameVersionsResponse>(getPostApiTeamsTeamIdAgentProceduresNameVersionsUrl(teamId,name),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createAgentProcedureVersionRequest,)
  }
);}



export type postApiTeamsTeamIdAgentProceduresNameVersionsVersionIdActivateResponse200TextPlain = {
  data: AgentProcedureActivationResponse
  status: 200
}

export type postApiTeamsTeamIdAgentProceduresNameVersionsVersionIdActivateResponse200ApplicationJson = {
  data: AgentProcedureActivationResponse
  status: 200
}

export type postApiTeamsTeamIdAgentProceduresNameVersionsVersionIdActivateResponse200TextJson = {
  data: AgentProcedureActivationResponse
  status: 200
}

export type postApiTeamsTeamIdAgentProceduresNameVersionsVersionIdActivateResponse401 = {
  data: PostApiTeamsTeamIdAgentProceduresNameVersionsVersionIdActivate401
  status: 401
}

export type postApiTeamsTeamIdAgentProceduresNameVersionsVersionIdActivateResponse402 = {
  data: PostApiTeamsTeamIdAgentProceduresNameVersionsVersionIdActivate402
  status: 402
}

export type postApiTeamsTeamIdAgentProceduresNameVersionsVersionIdActivateResponse404TextPlain = {
  data: TeamAgentErrorResponse
  status: 404
}

export type postApiTeamsTeamIdAgentProceduresNameVersionsVersionIdActivateResponse404ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 404
}

export type postApiTeamsTeamIdAgentProceduresNameVersionsVersionIdActivateResponse404TextJson = {
  data: TeamAgentErrorResponse
  status: 404
}

export type postApiTeamsTeamIdAgentProceduresNameVersionsVersionIdActivateResponse409TextPlain = {
  data: TeamAgentErrorResponse
  status: 409
}

export type postApiTeamsTeamIdAgentProceduresNameVersionsVersionIdActivateResponse409ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 409
}

export type postApiTeamsTeamIdAgentProceduresNameVersionsVersionIdActivateResponse409TextJson = {
  data: TeamAgentErrorResponse
  status: 409
}

export type postApiTeamsTeamIdAgentProceduresNameVersionsVersionIdActivateResponseSuccess = (postApiTeamsTeamIdAgentProceduresNameVersionsVersionIdActivateResponse200TextPlain | postApiTeamsTeamIdAgentProceduresNameVersionsVersionIdActivateResponse200ApplicationJson | postApiTeamsTeamIdAgentProceduresNameVersionsVersionIdActivateResponse200TextJson) & {
  headers: Headers;
};
export type postApiTeamsTeamIdAgentProceduresNameVersionsVersionIdActivateResponseError = (postApiTeamsTeamIdAgentProceduresNameVersionsVersionIdActivateResponse401 | postApiTeamsTeamIdAgentProceduresNameVersionsVersionIdActivateResponse402 | postApiTeamsTeamIdAgentProceduresNameVersionsVersionIdActivateResponse404TextPlain | postApiTeamsTeamIdAgentProceduresNameVersionsVersionIdActivateResponse404ApplicationJson | postApiTeamsTeamIdAgentProceduresNameVersionsVersionIdActivateResponse404TextJson | postApiTeamsTeamIdAgentProceduresNameVersionsVersionIdActivateResponse409TextPlain | postApiTeamsTeamIdAgentProceduresNameVersionsVersionIdActivateResponse409ApplicationJson | postApiTeamsTeamIdAgentProceduresNameVersionsVersionIdActivateResponse409TextJson) & {
  headers: Headers;
};

export type postApiTeamsTeamIdAgentProceduresNameVersionsVersionIdActivateResponse = (postApiTeamsTeamIdAgentProceduresNameVersionsVersionIdActivateResponseSuccess | postApiTeamsTeamIdAgentProceduresNameVersionsVersionIdActivateResponseError)

export const getPostApiTeamsTeamIdAgentProceduresNameVersionsVersionIdActivateUrl = (teamId: string,
    name: string,
    versionId: string,) => {




  return `/api/teams/${teamId}/agent-procedures/${name}/versions/${versionId}/activate`
}

export const postApiTeamsTeamIdAgentProceduresNameVersionsVersionIdActivate = async (teamId: string,
    name: string,
    versionId: string,
    activateAgentProcedureVersionRequest: ActivateAgentProcedureVersionRequest, options?: RequestInit): Promise<postApiTeamsTeamIdAgentProceduresNameVersionsVersionIdActivateResponse> => {

  return fetcher<postApiTeamsTeamIdAgentProceduresNameVersionsVersionIdActivateResponse>(getPostApiTeamsTeamIdAgentProceduresNameVersionsVersionIdActivateUrl(teamId,name,versionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      activateAgentProcedureVersionRequest,)
  }
);}



export type postApiTeamsTeamIdAgentsTeamContextRunsResponse200TextPlain = {
  data: TeamContextAgentRunResponse
  status: 200
}

export type postApiTeamsTeamIdAgentsTeamContextRunsResponse200ApplicationJson = {
  data: TeamContextAgentRunResponse
  status: 200
}

export type postApiTeamsTeamIdAgentsTeamContextRunsResponse200TextJson = {
  data: TeamContextAgentRunResponse
  status: 200
}

export type postApiTeamsTeamIdAgentsTeamContextRunsResponse400TextPlain = {
  data: TeamAgentErrorResponse
  status: 400
}

export type postApiTeamsTeamIdAgentsTeamContextRunsResponse400ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 400
}

export type postApiTeamsTeamIdAgentsTeamContextRunsResponse400TextJson = {
  data: TeamAgentErrorResponse
  status: 400
}

export type postApiTeamsTeamIdAgentsTeamContextRunsResponse401TextPlain = {
  data: TeamAgentErrorResponse
  status: 401
}

export type postApiTeamsTeamIdAgentsTeamContextRunsResponse401ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 401
}

export type postApiTeamsTeamIdAgentsTeamContextRunsResponse401TextJson = {
  data: TeamAgentErrorResponse
  status: 401
}

export type postApiTeamsTeamIdAgentsTeamContextRunsResponse403TextPlain = {
  data: TeamAgentErrorResponse
  status: 403
}

export type postApiTeamsTeamIdAgentsTeamContextRunsResponse403ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type postApiTeamsTeamIdAgentsTeamContextRunsResponse403TextJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type postApiTeamsTeamIdAgentsTeamContextRunsResponseSuccess = (postApiTeamsTeamIdAgentsTeamContextRunsResponse200TextPlain | postApiTeamsTeamIdAgentsTeamContextRunsResponse200ApplicationJson | postApiTeamsTeamIdAgentsTeamContextRunsResponse200TextJson) & {
  headers: Headers;
};
export type postApiTeamsTeamIdAgentsTeamContextRunsResponseError = (postApiTeamsTeamIdAgentsTeamContextRunsResponse400TextPlain | postApiTeamsTeamIdAgentsTeamContextRunsResponse400ApplicationJson | postApiTeamsTeamIdAgentsTeamContextRunsResponse400TextJson | postApiTeamsTeamIdAgentsTeamContextRunsResponse401TextPlain | postApiTeamsTeamIdAgentsTeamContextRunsResponse401ApplicationJson | postApiTeamsTeamIdAgentsTeamContextRunsResponse401TextJson | postApiTeamsTeamIdAgentsTeamContextRunsResponse403TextPlain | postApiTeamsTeamIdAgentsTeamContextRunsResponse403ApplicationJson | postApiTeamsTeamIdAgentsTeamContextRunsResponse403TextJson) & {
  headers: Headers;
};

export type postApiTeamsTeamIdAgentsTeamContextRunsResponse = (postApiTeamsTeamIdAgentsTeamContextRunsResponseSuccess | postApiTeamsTeamIdAgentsTeamContextRunsResponseError)

export const getPostApiTeamsTeamIdAgentsTeamContextRunsUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/agents/team-context/runs`
}

export const postApiTeamsTeamIdAgentsTeamContextRuns = async (teamId: string,
    teamContextAgentRunRequest: TeamContextAgentRunRequest, options?: RequestInit): Promise<postApiTeamsTeamIdAgentsTeamContextRunsResponse> => {

  return fetcher<postApiTeamsTeamIdAgentsTeamContextRunsResponse>(getPostApiTeamsTeamIdAgentsTeamContextRunsUrl(teamId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      teamContextAgentRunRequest,)
  }
);}



export type getApiTeamsTeamIdAgentsTeamContextRunsRunIdResponse200TextPlain = {
  data: TeamContextAgentRunStateResponse
  status: 200
}

export type getApiTeamsTeamIdAgentsTeamContextRunsRunIdResponse200ApplicationJson = {
  data: TeamContextAgentRunStateResponse
  status: 200
}

export type getApiTeamsTeamIdAgentsTeamContextRunsRunIdResponse200TextJson = {
  data: TeamContextAgentRunStateResponse
  status: 200
}

export type getApiTeamsTeamIdAgentsTeamContextRunsRunIdResponse400TextPlain = {
  data: TeamAgentErrorResponse
  status: 400
}

export type getApiTeamsTeamIdAgentsTeamContextRunsRunIdResponse400ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 400
}

export type getApiTeamsTeamIdAgentsTeamContextRunsRunIdResponse400TextJson = {
  data: TeamAgentErrorResponse
  status: 400
}

export type getApiTeamsTeamIdAgentsTeamContextRunsRunIdResponse401TextPlain = {
  data: TeamAgentErrorResponse
  status: 401
}

export type getApiTeamsTeamIdAgentsTeamContextRunsRunIdResponse401ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 401
}

export type getApiTeamsTeamIdAgentsTeamContextRunsRunIdResponse401TextJson = {
  data: TeamAgentErrorResponse
  status: 401
}

export type getApiTeamsTeamIdAgentsTeamContextRunsRunIdResponse403TextPlain = {
  data: TeamAgentErrorResponse
  status: 403
}

export type getApiTeamsTeamIdAgentsTeamContextRunsRunIdResponse403ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type getApiTeamsTeamIdAgentsTeamContextRunsRunIdResponse403TextJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type getApiTeamsTeamIdAgentsTeamContextRunsRunIdResponse404TextPlain = {
  data: TeamAgentErrorResponse
  status: 404
}

export type getApiTeamsTeamIdAgentsTeamContextRunsRunIdResponse404ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 404
}

export type getApiTeamsTeamIdAgentsTeamContextRunsRunIdResponse404TextJson = {
  data: TeamAgentErrorResponse
  status: 404
}

export type getApiTeamsTeamIdAgentsTeamContextRunsRunIdResponseSuccess = (getApiTeamsTeamIdAgentsTeamContextRunsRunIdResponse200TextPlain | getApiTeamsTeamIdAgentsTeamContextRunsRunIdResponse200ApplicationJson | getApiTeamsTeamIdAgentsTeamContextRunsRunIdResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsTeamIdAgentsTeamContextRunsRunIdResponseError = (getApiTeamsTeamIdAgentsTeamContextRunsRunIdResponse400TextPlain | getApiTeamsTeamIdAgentsTeamContextRunsRunIdResponse400ApplicationJson | getApiTeamsTeamIdAgentsTeamContextRunsRunIdResponse400TextJson | getApiTeamsTeamIdAgentsTeamContextRunsRunIdResponse401TextPlain | getApiTeamsTeamIdAgentsTeamContextRunsRunIdResponse401ApplicationJson | getApiTeamsTeamIdAgentsTeamContextRunsRunIdResponse401TextJson | getApiTeamsTeamIdAgentsTeamContextRunsRunIdResponse403TextPlain | getApiTeamsTeamIdAgentsTeamContextRunsRunIdResponse403ApplicationJson | getApiTeamsTeamIdAgentsTeamContextRunsRunIdResponse403TextJson | getApiTeamsTeamIdAgentsTeamContextRunsRunIdResponse404TextPlain | getApiTeamsTeamIdAgentsTeamContextRunsRunIdResponse404ApplicationJson | getApiTeamsTeamIdAgentsTeamContextRunsRunIdResponse404TextJson) & {
  headers: Headers;
};

export type getApiTeamsTeamIdAgentsTeamContextRunsRunIdResponse = (getApiTeamsTeamIdAgentsTeamContextRunsRunIdResponseSuccess | getApiTeamsTeamIdAgentsTeamContextRunsRunIdResponseError)

export const getGetApiTeamsTeamIdAgentsTeamContextRunsRunIdUrl = (teamId: string,
    runId: string,) => {




  return `/api/teams/${teamId}/agents/team-context/runs/${runId}`
}

export const getApiTeamsTeamIdAgentsTeamContextRunsRunId = async (teamId: string,
    runId: string, options?: RequestInit): Promise<getApiTeamsTeamIdAgentsTeamContextRunsRunIdResponse> => {

  return fetcher<getApiTeamsTeamIdAgentsTeamContextRunsRunIdResponse>(getGetApiTeamsTeamIdAgentsTeamContextRunsRunIdUrl(teamId,runId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecisionResponse200TextPlain = {
  data: TeamContextAgentRunStateResponse
  status: 200
}

export type postApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecisionResponse200ApplicationJson = {
  data: TeamContextAgentRunStateResponse
  status: 200
}

export type postApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecisionResponse200TextJson = {
  data: TeamContextAgentRunStateResponse
  status: 200
}

export type postApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecisionResponse400TextPlain = {
  data: TeamAgentErrorResponse
  status: 400
}

export type postApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecisionResponse400ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 400
}

export type postApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecisionResponse400TextJson = {
  data: TeamAgentErrorResponse
  status: 400
}

export type postApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecisionResponse401TextPlain = {
  data: TeamAgentErrorResponse
  status: 401
}

export type postApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecisionResponse401ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 401
}

export type postApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecisionResponse401TextJson = {
  data: TeamAgentErrorResponse
  status: 401
}

export type postApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecisionResponse403TextPlain = {
  data: TeamAgentErrorResponse
  status: 403
}

export type postApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecisionResponse403ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type postApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecisionResponse403TextJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type postApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecisionResponse404TextPlain = {
  data: TeamAgentErrorResponse
  status: 404
}

export type postApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecisionResponse404ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 404
}

export type postApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecisionResponse404TextJson = {
  data: TeamAgentErrorResponse
  status: 404
}

export type postApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecisionResponse409TextPlain = {
  data: TeamAgentErrorResponse
  status: 409
}

export type postApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecisionResponse409ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 409
}

export type postApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecisionResponse409TextJson = {
  data: TeamAgentErrorResponse
  status: 409
}

export type postApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecisionResponseSuccess = (postApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecisionResponse200TextPlain | postApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecisionResponse200ApplicationJson | postApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecisionResponse200TextJson) & {
  headers: Headers;
};
export type postApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecisionResponseError = (postApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecisionResponse400TextPlain | postApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecisionResponse400ApplicationJson | postApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecisionResponse400TextJson | postApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecisionResponse401TextPlain | postApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecisionResponse401ApplicationJson | postApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecisionResponse401TextJson | postApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecisionResponse403TextPlain | postApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecisionResponse403ApplicationJson | postApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecisionResponse403TextJson | postApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecisionResponse404TextPlain | postApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecisionResponse404ApplicationJson | postApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecisionResponse404TextJson | postApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecisionResponse409TextPlain | postApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecisionResponse409ApplicationJson | postApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecisionResponse409TextJson) & {
  headers: Headers;
};

export type postApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecisionResponse = (postApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecisionResponseSuccess | postApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecisionResponseError)

export const getPostApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecisionUrl = (teamId: string,
    runId: string,) => {




  return `/api/teams/${teamId}/agents/team-context/runs/${runId}/checkpoints/memory-approval/decision`
}

export const postApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecision = async (teamId: string,
    runId: string,
    teamAgentCheckpointDecisionRequest: TeamAgentCheckpointDecisionRequest, options?: RequestInit): Promise<postApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecisionResponse> => {

  return fetcher<postApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecisionResponse>(getPostApiTeamsTeamIdAgentsTeamContextRunsRunIdCheckpointsMemoryApprovalDecisionUrl(teamId,runId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      teamAgentCheckpointDecisionRequest,)
  }
);}



export type postApiTeamsTeamIdAgentThreadsResponse200TextPlain = {
  data: AgentThreadResponse
  status: 200
}

export type postApiTeamsTeamIdAgentThreadsResponse200ApplicationJson = {
  data: AgentThreadResponse
  status: 200
}

export type postApiTeamsTeamIdAgentThreadsResponse200TextJson = {
  data: AgentThreadResponse
  status: 200
}

export type postApiTeamsTeamIdAgentThreadsResponse400TextPlain = {
  data: TeamAgentErrorResponse
  status: 400
}

export type postApiTeamsTeamIdAgentThreadsResponse400ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 400
}

export type postApiTeamsTeamIdAgentThreadsResponse400TextJson = {
  data: TeamAgentErrorResponse
  status: 400
}

export type postApiTeamsTeamIdAgentThreadsResponse401 = {
  data: PostApiTeamsTeamIdAgentThreads401
  status: 401
}

export type postApiTeamsTeamIdAgentThreadsResponse402 = {
  data: PostApiTeamsTeamIdAgentThreads402
  status: 402
}

export type postApiTeamsTeamIdAgentThreadsResponseSuccess = (postApiTeamsTeamIdAgentThreadsResponse200TextPlain | postApiTeamsTeamIdAgentThreadsResponse200ApplicationJson | postApiTeamsTeamIdAgentThreadsResponse200TextJson) & {
  headers: Headers;
};
export type postApiTeamsTeamIdAgentThreadsResponseError = (postApiTeamsTeamIdAgentThreadsResponse400TextPlain | postApiTeamsTeamIdAgentThreadsResponse400ApplicationJson | postApiTeamsTeamIdAgentThreadsResponse400TextJson | postApiTeamsTeamIdAgentThreadsResponse401 | postApiTeamsTeamIdAgentThreadsResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdAgentThreadsResponse = (postApiTeamsTeamIdAgentThreadsResponseSuccess | postApiTeamsTeamIdAgentThreadsResponseError)

export const getPostApiTeamsTeamIdAgentThreadsUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/agent-threads`
}

export const postApiTeamsTeamIdAgentThreads = async (teamId: string,
    createAgentThreadRequest: CreateAgentThreadRequest, options?: RequestInit): Promise<postApiTeamsTeamIdAgentThreadsResponse> => {

  return fetcher<postApiTeamsTeamIdAgentThreadsResponse>(getPostApiTeamsTeamIdAgentThreadsUrl(teamId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createAgentThreadRequest,)
  }
);}



export type getApiTeamsTeamIdAgentThreadsResponse200TextPlain = {
  data: AgentThreadListResponse
  status: 200
}

export type getApiTeamsTeamIdAgentThreadsResponse200ApplicationJson = {
  data: AgentThreadListResponse
  status: 200
}

export type getApiTeamsTeamIdAgentThreadsResponse200TextJson = {
  data: AgentThreadListResponse
  status: 200
}

export type getApiTeamsTeamIdAgentThreadsResponse401 = {
  data: GetApiTeamsTeamIdAgentThreads401
  status: 401
}

export type getApiTeamsTeamIdAgentThreadsResponse403TextPlain = {
  data: TeamAgentErrorResponse
  status: 403
}

export type getApiTeamsTeamIdAgentThreadsResponse403ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type getApiTeamsTeamIdAgentThreadsResponse403TextJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type getApiTeamsTeamIdAgentThreadsResponseSuccess = (getApiTeamsTeamIdAgentThreadsResponse200TextPlain | getApiTeamsTeamIdAgentThreadsResponse200ApplicationJson | getApiTeamsTeamIdAgentThreadsResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsTeamIdAgentThreadsResponseError = (getApiTeamsTeamIdAgentThreadsResponse401 | getApiTeamsTeamIdAgentThreadsResponse403TextPlain | getApiTeamsTeamIdAgentThreadsResponse403ApplicationJson | getApiTeamsTeamIdAgentThreadsResponse403TextJson) & {
  headers: Headers;
};

export type getApiTeamsTeamIdAgentThreadsResponse = (getApiTeamsTeamIdAgentThreadsResponseSuccess | getApiTeamsTeamIdAgentThreadsResponseError)

export const getGetApiTeamsTeamIdAgentThreadsUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/agent-threads`
}

export const getApiTeamsTeamIdAgentThreads = async (teamId: string, options?: RequestInit): Promise<getApiTeamsTeamIdAgentThreadsResponse> => {

  return fetcher<getApiTeamsTeamIdAgentThreadsResponse>(getGetApiTeamsTeamIdAgentThreadsUrl(teamId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdAgentThreadsThreadIdResponse200TextPlain = {
  data: AgentThreadDetailResponse
  status: 200
}

export type getApiTeamsTeamIdAgentThreadsThreadIdResponse200ApplicationJson = {
  data: AgentThreadDetailResponse
  status: 200
}

export type getApiTeamsTeamIdAgentThreadsThreadIdResponse200TextJson = {
  data: AgentThreadDetailResponse
  status: 200
}

export type getApiTeamsTeamIdAgentThreadsThreadIdResponse401 = {
  data: GetApiTeamsTeamIdAgentThreadsThreadId401
  status: 401
}

export type getApiTeamsTeamIdAgentThreadsThreadIdResponse404TextPlain = {
  data: TeamAgentErrorResponse
  status: 404
}

export type getApiTeamsTeamIdAgentThreadsThreadIdResponse404ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 404
}

export type getApiTeamsTeamIdAgentThreadsThreadIdResponse404TextJson = {
  data: TeamAgentErrorResponse
  status: 404
}

export type getApiTeamsTeamIdAgentThreadsThreadIdResponseSuccess = (getApiTeamsTeamIdAgentThreadsThreadIdResponse200TextPlain | getApiTeamsTeamIdAgentThreadsThreadIdResponse200ApplicationJson | getApiTeamsTeamIdAgentThreadsThreadIdResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsTeamIdAgentThreadsThreadIdResponseError = (getApiTeamsTeamIdAgentThreadsThreadIdResponse401 | getApiTeamsTeamIdAgentThreadsThreadIdResponse404TextPlain | getApiTeamsTeamIdAgentThreadsThreadIdResponse404ApplicationJson | getApiTeamsTeamIdAgentThreadsThreadIdResponse404TextJson) & {
  headers: Headers;
};

export type getApiTeamsTeamIdAgentThreadsThreadIdResponse = (getApiTeamsTeamIdAgentThreadsThreadIdResponseSuccess | getApiTeamsTeamIdAgentThreadsThreadIdResponseError)

export const getGetApiTeamsTeamIdAgentThreadsThreadIdUrl = (teamId: string,
    threadId: string,) => {




  return `/api/teams/${teamId}/agent-threads/${threadId}`
}

export const getApiTeamsTeamIdAgentThreadsThreadId = async (teamId: string,
    threadId: string, options?: RequestInit): Promise<getApiTeamsTeamIdAgentThreadsThreadIdResponse> => {

  return fetcher<getApiTeamsTeamIdAgentThreadsThreadIdResponse>(getGetApiTeamsTeamIdAgentThreadsThreadIdUrl(teamId,threadId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdAgentsBookReviewRunsResponse200TextPlain = {
  data: BookReviewAgentRunResponse
  status: 200
}

export type postApiTeamsTeamIdAgentsBookReviewRunsResponse200ApplicationJson = {
  data: BookReviewAgentRunResponse
  status: 200
}

export type postApiTeamsTeamIdAgentsBookReviewRunsResponse200TextJson = {
  data: BookReviewAgentRunResponse
  status: 200
}

export type postApiTeamsTeamIdAgentsBookReviewRunsResponse400TextPlain = {
  data: TeamAgentErrorResponse
  status: 400
}

export type postApiTeamsTeamIdAgentsBookReviewRunsResponse400ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 400
}

export type postApiTeamsTeamIdAgentsBookReviewRunsResponse400TextJson = {
  data: TeamAgentErrorResponse
  status: 400
}

export type postApiTeamsTeamIdAgentsBookReviewRunsResponse401TextPlain = {
  data: TeamAgentErrorResponse
  status: 401
}

export type postApiTeamsTeamIdAgentsBookReviewRunsResponse401ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 401
}

export type postApiTeamsTeamIdAgentsBookReviewRunsResponse401TextJson = {
  data: TeamAgentErrorResponse
  status: 401
}

export type postApiTeamsTeamIdAgentsBookReviewRunsResponse403TextPlain = {
  data: TeamAgentErrorResponse
  status: 403
}

export type postApiTeamsTeamIdAgentsBookReviewRunsResponse403ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type postApiTeamsTeamIdAgentsBookReviewRunsResponse403TextJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type postApiTeamsTeamIdAgentsBookReviewRunsResponse404TextPlain = {
  data: TeamAgentErrorResponse
  status: 404
}

export type postApiTeamsTeamIdAgentsBookReviewRunsResponse404ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 404
}

export type postApiTeamsTeamIdAgentsBookReviewRunsResponse404TextJson = {
  data: TeamAgentErrorResponse
  status: 404
}

export type postApiTeamsTeamIdAgentsBookReviewRunsResponseSuccess = (postApiTeamsTeamIdAgentsBookReviewRunsResponse200TextPlain | postApiTeamsTeamIdAgentsBookReviewRunsResponse200ApplicationJson | postApiTeamsTeamIdAgentsBookReviewRunsResponse200TextJson) & {
  headers: Headers;
};
export type postApiTeamsTeamIdAgentsBookReviewRunsResponseError = (postApiTeamsTeamIdAgentsBookReviewRunsResponse400TextPlain | postApiTeamsTeamIdAgentsBookReviewRunsResponse400ApplicationJson | postApiTeamsTeamIdAgentsBookReviewRunsResponse400TextJson | postApiTeamsTeamIdAgentsBookReviewRunsResponse401TextPlain | postApiTeamsTeamIdAgentsBookReviewRunsResponse401ApplicationJson | postApiTeamsTeamIdAgentsBookReviewRunsResponse401TextJson | postApiTeamsTeamIdAgentsBookReviewRunsResponse403TextPlain | postApiTeamsTeamIdAgentsBookReviewRunsResponse403ApplicationJson | postApiTeamsTeamIdAgentsBookReviewRunsResponse403TextJson | postApiTeamsTeamIdAgentsBookReviewRunsResponse404TextPlain | postApiTeamsTeamIdAgentsBookReviewRunsResponse404ApplicationJson | postApiTeamsTeamIdAgentsBookReviewRunsResponse404TextJson) & {
  headers: Headers;
};

export type postApiTeamsTeamIdAgentsBookReviewRunsResponse = (postApiTeamsTeamIdAgentsBookReviewRunsResponseSuccess | postApiTeamsTeamIdAgentsBookReviewRunsResponseError)

export const getPostApiTeamsTeamIdAgentsBookReviewRunsUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/agents/book-review/runs`
}

export const postApiTeamsTeamIdAgentsBookReviewRuns = async (teamId: string, options?: RequestInit): Promise<postApiTeamsTeamIdAgentsBookReviewRunsResponse> => {

  return fetcher<postApiTeamsTeamIdAgentsBookReviewRunsResponse>(getPostApiTeamsTeamIdAgentsBookReviewRunsUrl(teamId),
  {
    ...options,
    method: 'POST'


  }
);}



export type postApiTeamsTeamIdAgentsBrowserReadRunsResponse200TextPlain = {
  data: BrowserReadRunResponse
  status: 200
}

export type postApiTeamsTeamIdAgentsBrowserReadRunsResponse200ApplicationJson = {
  data: BrowserReadRunResponse
  status: 200
}

export type postApiTeamsTeamIdAgentsBrowserReadRunsResponse200TextJson = {
  data: BrowserReadRunResponse
  status: 200
}

export type postApiTeamsTeamIdAgentsBrowserReadRunsResponse400TextPlain = {
  data: TeamAgentErrorResponse
  status: 400
}

export type postApiTeamsTeamIdAgentsBrowserReadRunsResponse400ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 400
}

export type postApiTeamsTeamIdAgentsBrowserReadRunsResponse400TextJson = {
  data: TeamAgentErrorResponse
  status: 400
}

export type postApiTeamsTeamIdAgentsBrowserReadRunsResponse401TextPlain = {
  data: TeamAgentErrorResponse
  status: 401
}

export type postApiTeamsTeamIdAgentsBrowserReadRunsResponse401ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 401
}

export type postApiTeamsTeamIdAgentsBrowserReadRunsResponse401TextJson = {
  data: TeamAgentErrorResponse
  status: 401
}

export type postApiTeamsTeamIdAgentsBrowserReadRunsResponse402 = {
  data: PostApiTeamsTeamIdAgentsBrowserReadRuns402
  status: 402
}

export type postApiTeamsTeamIdAgentsBrowserReadRunsResponse403TextPlain = {
  data: TeamAgentErrorResponse
  status: 403
}

export type postApiTeamsTeamIdAgentsBrowserReadRunsResponse403ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type postApiTeamsTeamIdAgentsBrowserReadRunsResponse403TextJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type postApiTeamsTeamIdAgentsBrowserReadRunsResponseSuccess = (postApiTeamsTeamIdAgentsBrowserReadRunsResponse200TextPlain | postApiTeamsTeamIdAgentsBrowserReadRunsResponse200ApplicationJson | postApiTeamsTeamIdAgentsBrowserReadRunsResponse200TextJson) & {
  headers: Headers;
};
export type postApiTeamsTeamIdAgentsBrowserReadRunsResponseError = (postApiTeamsTeamIdAgentsBrowserReadRunsResponse400TextPlain | postApiTeamsTeamIdAgentsBrowserReadRunsResponse400ApplicationJson | postApiTeamsTeamIdAgentsBrowserReadRunsResponse400TextJson | postApiTeamsTeamIdAgentsBrowserReadRunsResponse401TextPlain | postApiTeamsTeamIdAgentsBrowserReadRunsResponse401ApplicationJson | postApiTeamsTeamIdAgentsBrowserReadRunsResponse401TextJson | postApiTeamsTeamIdAgentsBrowserReadRunsResponse402 | postApiTeamsTeamIdAgentsBrowserReadRunsResponse403TextPlain | postApiTeamsTeamIdAgentsBrowserReadRunsResponse403ApplicationJson | postApiTeamsTeamIdAgentsBrowserReadRunsResponse403TextJson) & {
  headers: Headers;
};

export type postApiTeamsTeamIdAgentsBrowserReadRunsResponse = (postApiTeamsTeamIdAgentsBrowserReadRunsResponseSuccess | postApiTeamsTeamIdAgentsBrowserReadRunsResponseError)

export const getPostApiTeamsTeamIdAgentsBrowserReadRunsUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/agents/browser-read/runs`
}

export const postApiTeamsTeamIdAgentsBrowserReadRuns = async (teamId: string, options?: RequestInit): Promise<postApiTeamsTeamIdAgentsBrowserReadRunsResponse> => {

  return fetcher<postApiTeamsTeamIdAgentsBrowserReadRunsResponse>(getPostApiTeamsTeamIdAgentsBrowserReadRunsUrl(teamId),
  {
    ...options,
    method: 'POST'


  }
);}



export type getApiTeamsTeamIdAgentsBrowserReadRunsRunIdResponse200TextPlain = {
  data: BrowserReadRunStateResponse
  status: 200
}

export type getApiTeamsTeamIdAgentsBrowserReadRunsRunIdResponse200ApplicationJson = {
  data: BrowserReadRunStateResponse
  status: 200
}

export type getApiTeamsTeamIdAgentsBrowserReadRunsRunIdResponse200TextJson = {
  data: BrowserReadRunStateResponse
  status: 200
}

export type getApiTeamsTeamIdAgentsBrowserReadRunsRunIdResponse401 = {
  data: GetApiTeamsTeamIdAgentsBrowserReadRunsRunId401
  status: 401
}

export type getApiTeamsTeamIdAgentsBrowserReadRunsRunIdResponse404TextPlain = {
  data: TeamAgentErrorResponse
  status: 404
}

export type getApiTeamsTeamIdAgentsBrowserReadRunsRunIdResponse404ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 404
}

export type getApiTeamsTeamIdAgentsBrowserReadRunsRunIdResponse404TextJson = {
  data: TeamAgentErrorResponse
  status: 404
}

export type getApiTeamsTeamIdAgentsBrowserReadRunsRunIdResponseSuccess = (getApiTeamsTeamIdAgentsBrowserReadRunsRunIdResponse200TextPlain | getApiTeamsTeamIdAgentsBrowserReadRunsRunIdResponse200ApplicationJson | getApiTeamsTeamIdAgentsBrowserReadRunsRunIdResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsTeamIdAgentsBrowserReadRunsRunIdResponseError = (getApiTeamsTeamIdAgentsBrowserReadRunsRunIdResponse401 | getApiTeamsTeamIdAgentsBrowserReadRunsRunIdResponse404TextPlain | getApiTeamsTeamIdAgentsBrowserReadRunsRunIdResponse404ApplicationJson | getApiTeamsTeamIdAgentsBrowserReadRunsRunIdResponse404TextJson) & {
  headers: Headers;
};

export type getApiTeamsTeamIdAgentsBrowserReadRunsRunIdResponse = (getApiTeamsTeamIdAgentsBrowserReadRunsRunIdResponseSuccess | getApiTeamsTeamIdAgentsBrowserReadRunsRunIdResponseError)

export const getGetApiTeamsTeamIdAgentsBrowserReadRunsRunIdUrl = (teamId: string,
    runId: string,) => {




  return `/api/teams/${teamId}/agents/browser-read/runs/${runId}`
}

export const getApiTeamsTeamIdAgentsBrowserReadRunsRunId = async (teamId: string,
    runId: string, options?: RequestInit): Promise<getApiTeamsTeamIdAgentsBrowserReadRunsRunIdResponse> => {

  return fetcher<getApiTeamsTeamIdAgentsBrowserReadRunsRunIdResponse>(getGetApiTeamsTeamIdAgentsBrowserReadRunsRunIdUrl(teamId,runId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdAgentsBrowserReadRunsRunIdCheckpointsEdgeResultResumeResponse200TextPlain = {
  data: BrowserReadRunStateResponse
  status: 200
}

export type postApiTeamsTeamIdAgentsBrowserReadRunsRunIdCheckpointsEdgeResultResumeResponse200ApplicationJson = {
  data: BrowserReadRunStateResponse
  status: 200
}

export type postApiTeamsTeamIdAgentsBrowserReadRunsRunIdCheckpointsEdgeResultResumeResponse200TextJson = {
  data: BrowserReadRunStateResponse
  status: 200
}

export type postApiTeamsTeamIdAgentsBrowserReadRunsRunIdCheckpointsEdgeResultResumeResponse401 = {
  data: PostApiTeamsTeamIdAgentsBrowserReadRunsRunIdCheckpointsEdgeResultResume401
  status: 401
}

export type postApiTeamsTeamIdAgentsBrowserReadRunsRunIdCheckpointsEdgeResultResumeResponse404TextPlain = {
  data: TeamAgentErrorResponse
  status: 404
}

export type postApiTeamsTeamIdAgentsBrowserReadRunsRunIdCheckpointsEdgeResultResumeResponse404ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 404
}

export type postApiTeamsTeamIdAgentsBrowserReadRunsRunIdCheckpointsEdgeResultResumeResponse404TextJson = {
  data: TeamAgentErrorResponse
  status: 404
}

export type postApiTeamsTeamIdAgentsBrowserReadRunsRunIdCheckpointsEdgeResultResumeResponse409TextPlain = {
  data: TeamAgentErrorResponse
  status: 409
}

export type postApiTeamsTeamIdAgentsBrowserReadRunsRunIdCheckpointsEdgeResultResumeResponse409ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 409
}

export type postApiTeamsTeamIdAgentsBrowserReadRunsRunIdCheckpointsEdgeResultResumeResponse409TextJson = {
  data: TeamAgentErrorResponse
  status: 409
}

export type postApiTeamsTeamIdAgentsBrowserReadRunsRunIdCheckpointsEdgeResultResumeResponseSuccess = (postApiTeamsTeamIdAgentsBrowserReadRunsRunIdCheckpointsEdgeResultResumeResponse200TextPlain | postApiTeamsTeamIdAgentsBrowserReadRunsRunIdCheckpointsEdgeResultResumeResponse200ApplicationJson | postApiTeamsTeamIdAgentsBrowserReadRunsRunIdCheckpointsEdgeResultResumeResponse200TextJson) & {
  headers: Headers;
};
export type postApiTeamsTeamIdAgentsBrowserReadRunsRunIdCheckpointsEdgeResultResumeResponseError = (postApiTeamsTeamIdAgentsBrowserReadRunsRunIdCheckpointsEdgeResultResumeResponse401 | postApiTeamsTeamIdAgentsBrowserReadRunsRunIdCheckpointsEdgeResultResumeResponse404TextPlain | postApiTeamsTeamIdAgentsBrowserReadRunsRunIdCheckpointsEdgeResultResumeResponse404ApplicationJson | postApiTeamsTeamIdAgentsBrowserReadRunsRunIdCheckpointsEdgeResultResumeResponse404TextJson | postApiTeamsTeamIdAgentsBrowserReadRunsRunIdCheckpointsEdgeResultResumeResponse409TextPlain | postApiTeamsTeamIdAgentsBrowserReadRunsRunIdCheckpointsEdgeResultResumeResponse409ApplicationJson | postApiTeamsTeamIdAgentsBrowserReadRunsRunIdCheckpointsEdgeResultResumeResponse409TextJson) & {
  headers: Headers;
};

export type postApiTeamsTeamIdAgentsBrowserReadRunsRunIdCheckpointsEdgeResultResumeResponse = (postApiTeamsTeamIdAgentsBrowserReadRunsRunIdCheckpointsEdgeResultResumeResponseSuccess | postApiTeamsTeamIdAgentsBrowserReadRunsRunIdCheckpointsEdgeResultResumeResponseError)

export const getPostApiTeamsTeamIdAgentsBrowserReadRunsRunIdCheckpointsEdgeResultResumeUrl = (teamId: string,
    runId: string,) => {




  return `/api/teams/${teamId}/agents/browser-read/runs/${runId}/checkpoints/edge-result/resume`
}

export const postApiTeamsTeamIdAgentsBrowserReadRunsRunIdCheckpointsEdgeResultResume = async (teamId: string,
    runId: string, options?: RequestInit): Promise<postApiTeamsTeamIdAgentsBrowserReadRunsRunIdCheckpointsEdgeResultResumeResponse> => {

  return fetcher<postApiTeamsTeamIdAgentsBrowserReadRunsRunIdCheckpointsEdgeResultResumeResponse>(getPostApiTeamsTeamIdAgentsBrowserReadRunsRunIdCheckpointsEdgeResultResumeUrl(teamId,runId),
  {
    ...options,
    method: 'POST'


  }
);}



export type getApiTeamsTeamIdClientsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdClientsResponse401 = {
  data: GetApiTeamsTeamIdClients401
  status: 401
}

export type getApiTeamsTeamIdClientsResponseSuccess = (getApiTeamsTeamIdClientsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdClientsResponseError = (getApiTeamsTeamIdClientsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdClientsResponse = (getApiTeamsTeamIdClientsResponseSuccess | getApiTeamsTeamIdClientsResponseError)

export const getGetApiTeamsTeamIdClientsUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/clients`
}

export const getApiTeamsTeamIdClients = async (teamId: string, options?: RequestInit): Promise<getApiTeamsTeamIdClientsResponse> => {

  return fetcher<getApiTeamsTeamIdClientsResponse>(getGetApiTeamsTeamIdClientsUrl(teamId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdClientsPartyIdResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdClientsPartyIdResponse401 = {
  data: GetApiTeamsTeamIdClientsPartyId401
  status: 401
}

export type getApiTeamsTeamIdClientsPartyIdResponseSuccess = (getApiTeamsTeamIdClientsPartyIdResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdClientsPartyIdResponseError = (getApiTeamsTeamIdClientsPartyIdResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdClientsPartyIdResponse = (getApiTeamsTeamIdClientsPartyIdResponseSuccess | getApiTeamsTeamIdClientsPartyIdResponseError)

export const getGetApiTeamsTeamIdClientsPartyIdUrl = (teamId: string,
    partyId: string,) => {




  return `/api/teams/${teamId}/clients/${partyId}`
}

export const getApiTeamsTeamIdClientsPartyId = async (teamId: string,
    partyId: string, options?: RequestInit): Promise<getApiTeamsTeamIdClientsPartyIdResponse> => {

  return fetcher<getApiTeamsTeamIdClientsPartyIdResponse>(getGetApiTeamsTeamIdClientsPartyIdUrl(teamId,partyId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdCrmClientAccountsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmClientAccountsResponse401 = {
  data: GetApiTeamsTeamIdCrmClientAccounts401
  status: 401
}

export type getApiTeamsTeamIdCrmClientAccountsResponseSuccess = (getApiTeamsTeamIdCrmClientAccountsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmClientAccountsResponseError = (getApiTeamsTeamIdCrmClientAccountsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmClientAccountsResponse = (getApiTeamsTeamIdCrmClientAccountsResponseSuccess | getApiTeamsTeamIdCrmClientAccountsResponseError)

export const getGetApiTeamsTeamIdCrmClientAccountsUrl = (teamId: string,
    params?: GetApiTeamsTeamIdCrmClientAccountsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/crm/client-accounts?${stringifiedParams}` : `/api/teams/${teamId}/crm/client-accounts`
}

export const getApiTeamsTeamIdCrmClientAccounts = async (teamId: string,
    params?: GetApiTeamsTeamIdCrmClientAccountsParams, options?: RequestInit): Promise<getApiTeamsTeamIdCrmClientAccountsResponse> => {

  return fetcher<getApiTeamsTeamIdCrmClientAccountsResponse>(getGetApiTeamsTeamIdCrmClientAccountsUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdCrmProspectsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmProspectsResponse401 = {
  data: GetApiTeamsTeamIdCrmProspects401
  status: 401
}

export type getApiTeamsTeamIdCrmProspectsResponseSuccess = (getApiTeamsTeamIdCrmProspectsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmProspectsResponseError = (getApiTeamsTeamIdCrmProspectsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmProspectsResponse = (getApiTeamsTeamIdCrmProspectsResponseSuccess | getApiTeamsTeamIdCrmProspectsResponseError)

export const getGetApiTeamsTeamIdCrmProspectsUrl = (teamId: string,
    params?: GetApiTeamsTeamIdCrmProspectsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/crm/prospects?${stringifiedParams}` : `/api/teams/${teamId}/crm/prospects`
}

export const getApiTeamsTeamIdCrmProspects = async (teamId: string,
    params?: GetApiTeamsTeamIdCrmProspectsParams, options?: RequestInit): Promise<getApiTeamsTeamIdCrmProspectsResponse> => {

  return fetcher<getApiTeamsTeamIdCrmProspectsResponse>(getGetApiTeamsTeamIdCrmProspectsUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdCrmCarriersResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmCarriersResponse401 = {
  data: GetApiTeamsTeamIdCrmCarriers401
  status: 401
}

export type getApiTeamsTeamIdCrmCarriersResponseSuccess = (getApiTeamsTeamIdCrmCarriersResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmCarriersResponseError = (getApiTeamsTeamIdCrmCarriersResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmCarriersResponse = (getApiTeamsTeamIdCrmCarriersResponseSuccess | getApiTeamsTeamIdCrmCarriersResponseError)

export const getGetApiTeamsTeamIdCrmCarriersUrl = (teamId: string,
    params?: GetApiTeamsTeamIdCrmCarriersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/crm/carriers?${stringifiedParams}` : `/api/teams/${teamId}/crm/carriers`
}

export const getApiTeamsTeamIdCrmCarriers = async (teamId: string,
    params?: GetApiTeamsTeamIdCrmCarriersParams, options?: RequestInit): Promise<getApiTeamsTeamIdCrmCarriersResponse> => {

  return fetcher<getApiTeamsTeamIdCrmCarriersResponse>(getGetApiTeamsTeamIdCrmCarriersUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdCrmCarrierCatalogResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmCarrierCatalogResponse401 = {
  data: GetApiTeamsTeamIdCrmCarrierCatalog401
  status: 401
}

export type getApiTeamsTeamIdCrmCarrierCatalogResponseSuccess = (getApiTeamsTeamIdCrmCarrierCatalogResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmCarrierCatalogResponseError = (getApiTeamsTeamIdCrmCarrierCatalogResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmCarrierCatalogResponse = (getApiTeamsTeamIdCrmCarrierCatalogResponseSuccess | getApiTeamsTeamIdCrmCarrierCatalogResponseError)

export const getGetApiTeamsTeamIdCrmCarrierCatalogUrl = (teamId: string,
    params?: GetApiTeamsTeamIdCrmCarrierCatalogParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/crm/carrier-catalog?${stringifiedParams}` : `/api/teams/${teamId}/crm/carrier-catalog`
}

export const getApiTeamsTeamIdCrmCarrierCatalog = async (teamId: string,
    params?: GetApiTeamsTeamIdCrmCarrierCatalogParams, options?: RequestInit): Promise<getApiTeamsTeamIdCrmCarrierCatalogResponse> => {

  return fetcher<getApiTeamsTeamIdCrmCarrierCatalogResponse>(getGetApiTeamsTeamIdCrmCarrierCatalogUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdCrmInsuranceTypeCodesResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmInsuranceTypeCodesResponse401 = {
  data: GetApiTeamsTeamIdCrmInsuranceTypeCodes401
  status: 401
}

export type getApiTeamsTeamIdCrmInsuranceTypeCodesResponseSuccess = (getApiTeamsTeamIdCrmInsuranceTypeCodesResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmInsuranceTypeCodesResponseError = (getApiTeamsTeamIdCrmInsuranceTypeCodesResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmInsuranceTypeCodesResponse = (getApiTeamsTeamIdCrmInsuranceTypeCodesResponseSuccess | getApiTeamsTeamIdCrmInsuranceTypeCodesResponseError)

export const getGetApiTeamsTeamIdCrmInsuranceTypeCodesUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/crm/insurance-type-codes`
}

export const getApiTeamsTeamIdCrmInsuranceTypeCodes = async (teamId: string, options?: RequestInit): Promise<getApiTeamsTeamIdCrmInsuranceTypeCodesResponse> => {

  return fetcher<getApiTeamsTeamIdCrmInsuranceTypeCodesResponse>(getGetApiTeamsTeamIdCrmInsuranceTypeCodesUrl(teamId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdCrmLifecycleContextsResolveResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmLifecycleContextsResolveResponse401 = {
  data: GetApiTeamsTeamIdCrmLifecycleContextsResolve401
  status: 401
}

export type getApiTeamsTeamIdCrmLifecycleContextsResolveResponseSuccess = (getApiTeamsTeamIdCrmLifecycleContextsResolveResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmLifecycleContextsResolveResponseError = (getApiTeamsTeamIdCrmLifecycleContextsResolveResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmLifecycleContextsResolveResponse = (getApiTeamsTeamIdCrmLifecycleContextsResolveResponseSuccess | getApiTeamsTeamIdCrmLifecycleContextsResolveResponseError)

export const getGetApiTeamsTeamIdCrmLifecycleContextsResolveUrl = (teamId: string,
    params?: GetApiTeamsTeamIdCrmLifecycleContextsResolveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/crm/lifecycle-contexts/resolve?${stringifiedParams}` : `/api/teams/${teamId}/crm/lifecycle-contexts/resolve`
}

export const getApiTeamsTeamIdCrmLifecycleContextsResolve = async (teamId: string,
    params?: GetApiTeamsTeamIdCrmLifecycleContextsResolveParams, options?: RequestInit): Promise<getApiTeamsTeamIdCrmLifecycleContextsResolveResponse> => {

  return fetcher<getApiTeamsTeamIdCrmLifecycleContextsResolveResponse>(getGetApiTeamsTeamIdCrmLifecycleContextsResolveUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdCrmPoliciesResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmPoliciesResponse401 = {
  data: GetApiTeamsTeamIdCrmPolicies401
  status: 401
}

export type getApiTeamsTeamIdCrmPoliciesResponseSuccess = (getApiTeamsTeamIdCrmPoliciesResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmPoliciesResponseError = (getApiTeamsTeamIdCrmPoliciesResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmPoliciesResponse = (getApiTeamsTeamIdCrmPoliciesResponseSuccess | getApiTeamsTeamIdCrmPoliciesResponseError)

export const getGetApiTeamsTeamIdCrmPoliciesUrl = (teamId: string,
    params?: GetApiTeamsTeamIdCrmPoliciesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/crm/policies?${stringifiedParams}` : `/api/teams/${teamId}/crm/policies`
}

export const getApiTeamsTeamIdCrmPolicies = async (teamId: string,
    params?: GetApiTeamsTeamIdCrmPoliciesParams, options?: RequestInit): Promise<getApiTeamsTeamIdCrmPoliciesResponse> => {

  return fetcher<getApiTeamsTeamIdCrmPoliciesResponse>(getGetApiTeamsTeamIdCrmPoliciesUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdCrmPoliciesRenewalsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmPoliciesRenewalsResponse401 = {
  data: GetApiTeamsTeamIdCrmPoliciesRenewals401
  status: 401
}

export type getApiTeamsTeamIdCrmPoliciesRenewalsResponseSuccess = (getApiTeamsTeamIdCrmPoliciesRenewalsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmPoliciesRenewalsResponseError = (getApiTeamsTeamIdCrmPoliciesRenewalsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmPoliciesRenewalsResponse = (getApiTeamsTeamIdCrmPoliciesRenewalsResponseSuccess | getApiTeamsTeamIdCrmPoliciesRenewalsResponseError)

export const getGetApiTeamsTeamIdCrmPoliciesRenewalsUrl = (teamId: string,
    params?: GetApiTeamsTeamIdCrmPoliciesRenewalsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/crm/policies/renewals?${stringifiedParams}` : `/api/teams/${teamId}/crm/policies/renewals`
}

export const getApiTeamsTeamIdCrmPoliciesRenewals = async (teamId: string,
    params?: GetApiTeamsTeamIdCrmPoliciesRenewalsParams, options?: RequestInit): Promise<getApiTeamsTeamIdCrmPoliciesRenewalsResponse> => {

  return fetcher<getApiTeamsTeamIdCrmPoliciesRenewalsResponse>(getGetApiTeamsTeamIdCrmPoliciesRenewalsUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdCrmPoliciesSummaryResponse200TextPlain = {
  data: CrmPolicySummaryPayload[]
  status: 200
}

export type getApiTeamsTeamIdCrmPoliciesSummaryResponse200ApplicationJson = {
  data: CrmPolicySummaryPayload[]
  status: 200
}

export type getApiTeamsTeamIdCrmPoliciesSummaryResponse200TextJson = {
  data: CrmPolicySummaryPayload[]
  status: 200
}

export type getApiTeamsTeamIdCrmPoliciesSummaryResponse401 = {
  data: GetApiTeamsTeamIdCrmPoliciesSummary401
  status: 401
}

export type getApiTeamsTeamIdCrmPoliciesSummaryResponseSuccess = (getApiTeamsTeamIdCrmPoliciesSummaryResponse200TextPlain | getApiTeamsTeamIdCrmPoliciesSummaryResponse200ApplicationJson | getApiTeamsTeamIdCrmPoliciesSummaryResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmPoliciesSummaryResponseError = (getApiTeamsTeamIdCrmPoliciesSummaryResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmPoliciesSummaryResponse = (getApiTeamsTeamIdCrmPoliciesSummaryResponseSuccess | getApiTeamsTeamIdCrmPoliciesSummaryResponseError)

export const getGetApiTeamsTeamIdCrmPoliciesSummaryUrl = (teamId: string,
    params?: GetApiTeamsTeamIdCrmPoliciesSummaryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/crm/policies/summary?${stringifiedParams}` : `/api/teams/${teamId}/crm/policies/summary`
}

export const getApiTeamsTeamIdCrmPoliciesSummary = async (teamId: string,
    params?: GetApiTeamsTeamIdCrmPoliciesSummaryParams, options?: RequestInit): Promise<getApiTeamsTeamIdCrmPoliciesSummaryResponse> => {

  return fetcher<getApiTeamsTeamIdCrmPoliciesSummaryResponse>(getGetApiTeamsTeamIdCrmPoliciesSummaryUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdCrmSubmissionsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmSubmissionsResponse401 = {
  data: GetApiTeamsTeamIdCrmSubmissions401
  status: 401
}

export type getApiTeamsTeamIdCrmSubmissionsResponseSuccess = (getApiTeamsTeamIdCrmSubmissionsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmSubmissionsResponseError = (getApiTeamsTeamIdCrmSubmissionsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmSubmissionsResponse = (getApiTeamsTeamIdCrmSubmissionsResponseSuccess | getApiTeamsTeamIdCrmSubmissionsResponseError)

export const getGetApiTeamsTeamIdCrmSubmissionsUrl = (teamId: string,
    params?: GetApiTeamsTeamIdCrmSubmissionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/crm/submissions?${stringifiedParams}` : `/api/teams/${teamId}/crm/submissions`
}

export const getApiTeamsTeamIdCrmSubmissions = async (teamId: string,
    params?: GetApiTeamsTeamIdCrmSubmissionsParams, options?: RequestInit): Promise<getApiTeamsTeamIdCrmSubmissionsResponse> => {

  return fetcher<getApiTeamsTeamIdCrmSubmissionsResponse>(getGetApiTeamsTeamIdCrmSubmissionsUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdCrmSubmissionsResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmSubmissionsResponse401 = {
  data: PostApiTeamsTeamIdCrmSubmissions401
  status: 401
}

export type postApiTeamsTeamIdCrmSubmissionsResponse402 = {
  data: PostApiTeamsTeamIdCrmSubmissions402
  status: 402
}

export type postApiTeamsTeamIdCrmSubmissionsResponseSuccess = (postApiTeamsTeamIdCrmSubmissionsResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmSubmissionsResponseError = (postApiTeamsTeamIdCrmSubmissionsResponse401 | postApiTeamsTeamIdCrmSubmissionsResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmSubmissionsResponse = (postApiTeamsTeamIdCrmSubmissionsResponseSuccess | postApiTeamsTeamIdCrmSubmissionsResponseError)

export const getPostApiTeamsTeamIdCrmSubmissionsUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/crm/submissions`
}

export const postApiTeamsTeamIdCrmSubmissions = async (teamId: string,
    createSubmissionRequest: CreateSubmissionRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmSubmissionsResponse> => {

  return fetcher<postApiTeamsTeamIdCrmSubmissionsResponse>(getPostApiTeamsTeamIdCrmSubmissionsUrl(teamId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createSubmissionRequest,)
  }
);}



export type getApiTeamsTeamIdCrmSubmissionsAggregateResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmSubmissionsAggregateResponse401 = {
  data: GetApiTeamsTeamIdCrmSubmissionsAggregate401
  status: 401
}

export type getApiTeamsTeamIdCrmSubmissionsAggregateResponseSuccess = (getApiTeamsTeamIdCrmSubmissionsAggregateResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmSubmissionsAggregateResponseError = (getApiTeamsTeamIdCrmSubmissionsAggregateResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmSubmissionsAggregateResponse = (getApiTeamsTeamIdCrmSubmissionsAggregateResponseSuccess | getApiTeamsTeamIdCrmSubmissionsAggregateResponseError)

export const getGetApiTeamsTeamIdCrmSubmissionsAggregateUrl = (teamId: string,
    params?: GetApiTeamsTeamIdCrmSubmissionsAggregateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/crm/submissions/aggregate?${stringifiedParams}` : `/api/teams/${teamId}/crm/submissions/aggregate`
}

export const getApiTeamsTeamIdCrmSubmissionsAggregate = async (teamId: string,
    params?: GetApiTeamsTeamIdCrmSubmissionsAggregateParams, options?: RequestInit): Promise<getApiTeamsTeamIdCrmSubmissionsAggregateResponse> => {

  return fetcher<getApiTeamsTeamIdCrmSubmissionsAggregateResponse>(getGetApiTeamsTeamIdCrmSubmissionsAggregateUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdCrmSubmissionsPipelineResponse200TextPlain = {
  data: CrmSubmissionPipelinePayload
  status: 200
}

export type getApiTeamsTeamIdCrmSubmissionsPipelineResponse200ApplicationJson = {
  data: CrmSubmissionPipelinePayload
  status: 200
}

export type getApiTeamsTeamIdCrmSubmissionsPipelineResponse200TextJson = {
  data: CrmSubmissionPipelinePayload
  status: 200
}

export type getApiTeamsTeamIdCrmSubmissionsPipelineResponse401 = {
  data: GetApiTeamsTeamIdCrmSubmissionsPipeline401
  status: 401
}

export type getApiTeamsTeamIdCrmSubmissionsPipelineResponseSuccess = (getApiTeamsTeamIdCrmSubmissionsPipelineResponse200TextPlain | getApiTeamsTeamIdCrmSubmissionsPipelineResponse200ApplicationJson | getApiTeamsTeamIdCrmSubmissionsPipelineResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmSubmissionsPipelineResponseError = (getApiTeamsTeamIdCrmSubmissionsPipelineResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmSubmissionsPipelineResponse = (getApiTeamsTeamIdCrmSubmissionsPipelineResponseSuccess | getApiTeamsTeamIdCrmSubmissionsPipelineResponseError)

export const getGetApiTeamsTeamIdCrmSubmissionsPipelineUrl = (teamId: string,
    params?: GetApiTeamsTeamIdCrmSubmissionsPipelineParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/crm/submissions/pipeline?${stringifiedParams}` : `/api/teams/${teamId}/crm/submissions/pipeline`
}

export const getApiTeamsTeamIdCrmSubmissionsPipeline = async (teamId: string,
    params?: GetApiTeamsTeamIdCrmSubmissionsPipelineParams, options?: RequestInit): Promise<getApiTeamsTeamIdCrmSubmissionsPipelineResponse> => {

  return fetcher<getApiTeamsTeamIdCrmSubmissionsPipelineResponse>(getGetApiTeamsTeamIdCrmSubmissionsPipelineUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdCrmSubmissionsReadinessAggregateResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmSubmissionsReadinessAggregateResponse401 = {
  data: GetApiTeamsTeamIdCrmSubmissionsReadinessAggregate401
  status: 401
}

export type getApiTeamsTeamIdCrmSubmissionsReadinessAggregateResponseSuccess = (getApiTeamsTeamIdCrmSubmissionsReadinessAggregateResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmSubmissionsReadinessAggregateResponseError = (getApiTeamsTeamIdCrmSubmissionsReadinessAggregateResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmSubmissionsReadinessAggregateResponse = (getApiTeamsTeamIdCrmSubmissionsReadinessAggregateResponseSuccess | getApiTeamsTeamIdCrmSubmissionsReadinessAggregateResponseError)

export const getGetApiTeamsTeamIdCrmSubmissionsReadinessAggregateUrl = (teamId: string,
    params?: GetApiTeamsTeamIdCrmSubmissionsReadinessAggregateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/crm/submissions/readiness-aggregate?${stringifiedParams}` : `/api/teams/${teamId}/crm/submissions/readiness-aggregate`
}

export const getApiTeamsTeamIdCrmSubmissionsReadinessAggregate = async (teamId: string,
    params?: GetApiTeamsTeamIdCrmSubmissionsReadinessAggregateParams, options?: RequestInit): Promise<getApiTeamsTeamIdCrmSubmissionsReadinessAggregateResponse> => {

  return fetcher<getApiTeamsTeamIdCrmSubmissionsReadinessAggregateResponse>(getGetApiTeamsTeamIdCrmSubmissionsReadinessAggregateUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdCrmOpportunitiesOpportunityIdQuoteComparisonResponse200TextPlain = {
  data: CrmOpportunityQuoteComparisonPayload
  status: 200
}

export type getApiTeamsTeamIdCrmOpportunitiesOpportunityIdQuoteComparisonResponse200ApplicationJson = {
  data: CrmOpportunityQuoteComparisonPayload
  status: 200
}

export type getApiTeamsTeamIdCrmOpportunitiesOpportunityIdQuoteComparisonResponse200TextJson = {
  data: CrmOpportunityQuoteComparisonPayload
  status: 200
}

export type getApiTeamsTeamIdCrmOpportunitiesOpportunityIdQuoteComparisonResponse401 = {
  data: GetApiTeamsTeamIdCrmOpportunitiesOpportunityIdQuoteComparison401
  status: 401
}

export type getApiTeamsTeamIdCrmOpportunitiesOpportunityIdQuoteComparisonResponseSuccess = (getApiTeamsTeamIdCrmOpportunitiesOpportunityIdQuoteComparisonResponse200TextPlain | getApiTeamsTeamIdCrmOpportunitiesOpportunityIdQuoteComparisonResponse200ApplicationJson | getApiTeamsTeamIdCrmOpportunitiesOpportunityIdQuoteComparisonResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmOpportunitiesOpportunityIdQuoteComparisonResponseError = (getApiTeamsTeamIdCrmOpportunitiesOpportunityIdQuoteComparisonResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmOpportunitiesOpportunityIdQuoteComparisonResponse = (getApiTeamsTeamIdCrmOpportunitiesOpportunityIdQuoteComparisonResponseSuccess | getApiTeamsTeamIdCrmOpportunitiesOpportunityIdQuoteComparisonResponseError)

export const getGetApiTeamsTeamIdCrmOpportunitiesOpportunityIdQuoteComparisonUrl = (teamId: string,
    opportunityId: string,) => {




  return `/api/teams/${teamId}/crm/opportunities/${opportunityId}/quote-comparison`
}

export const getApiTeamsTeamIdCrmOpportunitiesOpportunityIdQuoteComparison = async (teamId: string,
    opportunityId: string, options?: RequestInit): Promise<getApiTeamsTeamIdCrmOpportunitiesOpportunityIdQuoteComparisonResponse> => {

  return fetcher<getApiTeamsTeamIdCrmOpportunitiesOpportunityIdQuoteComparisonResponse>(getGetApiTeamsTeamIdCrmOpportunitiesOpportunityIdQuoteComparisonUrl(teamId,opportunityId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdCrmOpportunitiesOpportunityIdQuoteOptionsResponse200TextPlain = {
  data: CrmOpportunityQuoteComparisonOptionPayload
  status: 200
}

export type postApiTeamsTeamIdCrmOpportunitiesOpportunityIdQuoteOptionsResponse200ApplicationJson = {
  data: CrmOpportunityQuoteComparisonOptionPayload
  status: 200
}

export type postApiTeamsTeamIdCrmOpportunitiesOpportunityIdQuoteOptionsResponse200TextJson = {
  data: CrmOpportunityQuoteComparisonOptionPayload
  status: 200
}

export type postApiTeamsTeamIdCrmOpportunitiesOpportunityIdQuoteOptionsResponse401 = {
  data: PostApiTeamsTeamIdCrmOpportunitiesOpportunityIdQuoteOptions401
  status: 401
}

export type postApiTeamsTeamIdCrmOpportunitiesOpportunityIdQuoteOptionsResponse402 = {
  data: PostApiTeamsTeamIdCrmOpportunitiesOpportunityIdQuoteOptions402
  status: 402
}

export type postApiTeamsTeamIdCrmOpportunitiesOpportunityIdQuoteOptionsResponseSuccess = (postApiTeamsTeamIdCrmOpportunitiesOpportunityIdQuoteOptionsResponse200TextPlain | postApiTeamsTeamIdCrmOpportunitiesOpportunityIdQuoteOptionsResponse200ApplicationJson | postApiTeamsTeamIdCrmOpportunitiesOpportunityIdQuoteOptionsResponse200TextJson) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmOpportunitiesOpportunityIdQuoteOptionsResponseError = (postApiTeamsTeamIdCrmOpportunitiesOpportunityIdQuoteOptionsResponse401 | postApiTeamsTeamIdCrmOpportunitiesOpportunityIdQuoteOptionsResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmOpportunitiesOpportunityIdQuoteOptionsResponse = (postApiTeamsTeamIdCrmOpportunitiesOpportunityIdQuoteOptionsResponseSuccess | postApiTeamsTeamIdCrmOpportunitiesOpportunityIdQuoteOptionsResponseError)

export const getPostApiTeamsTeamIdCrmOpportunitiesOpportunityIdQuoteOptionsUrl = (teamId: string,
    opportunityId: string,) => {




  return `/api/teams/${teamId}/crm/opportunities/${opportunityId}/quote-options`
}

export const postApiTeamsTeamIdCrmOpportunitiesOpportunityIdQuoteOptions = async (teamId: string,
    opportunityId: string,
    upsertQuoteOptionRequest: UpsertQuoteOptionRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmOpportunitiesOpportunityIdQuoteOptionsResponse> => {

  return fetcher<postApiTeamsTeamIdCrmOpportunitiesOpportunityIdQuoteOptionsResponse>(getPostApiTeamsTeamIdCrmOpportunitiesOpportunityIdQuoteOptionsUrl(teamId,opportunityId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upsertQuoteOptionRequest,)
  }
);}



export type putApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdResponse200TextPlain = {
  data: CrmOpportunityQuoteComparisonOptionPayload
  status: 200
}

export type putApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdResponse200ApplicationJson = {
  data: CrmOpportunityQuoteComparisonOptionPayload
  status: 200
}

export type putApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdResponse200TextJson = {
  data: CrmOpportunityQuoteComparisonOptionPayload
  status: 200
}

export type putApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdResponse401 = {
  data: PutApiTeamsTeamIdCrmQuoteOptionsQuoteOptionId401
  status: 401
}

export type putApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdResponse402 = {
  data: PutApiTeamsTeamIdCrmQuoteOptionsQuoteOptionId402
  status: 402
}

export type putApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdResponseSuccess = (putApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdResponse200TextPlain | putApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdResponse200ApplicationJson | putApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdResponse200TextJson) & {
  headers: Headers;
};
export type putApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdResponseError = (putApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdResponse401 | putApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdResponse402) & {
  headers: Headers;
};

export type putApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdResponse = (putApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdResponseSuccess | putApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdResponseError)

export const getPutApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdUrl = (teamId: string,
    quoteOptionId: string,) => {




  return `/api/teams/${teamId}/crm/quote-options/${quoteOptionId}`
}

export const putApiTeamsTeamIdCrmQuoteOptionsQuoteOptionId = async (teamId: string,
    quoteOptionId: string,
    upsertQuoteOptionRequest: UpsertQuoteOptionRequest, options?: RequestInit): Promise<putApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdResponse> => {

  return fetcher<putApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdResponse>(getPutApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdUrl(teamId,quoteOptionId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upsertQuoteOptionRequest,)
  }
);}



export type deleteApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdResponse200TextPlain = {
  data: CrmQuoteOptionOperationPayload
  status: 200
}

export type deleteApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdResponse200ApplicationJson = {
  data: CrmQuoteOptionOperationPayload
  status: 200
}

export type deleteApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdResponse200TextJson = {
  data: CrmQuoteOptionOperationPayload
  status: 200
}

export type deleteApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdResponse401 = {
  data: DeleteApiTeamsTeamIdCrmQuoteOptionsQuoteOptionId401
  status: 401
}

export type deleteApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdResponse402 = {
  data: DeleteApiTeamsTeamIdCrmQuoteOptionsQuoteOptionId402
  status: 402
}

export type deleteApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdResponseSuccess = (deleteApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdResponse200TextPlain | deleteApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdResponse200ApplicationJson | deleteApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdResponse200TextJson) & {
  headers: Headers;
};
export type deleteApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdResponseError = (deleteApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdResponse401 | deleteApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdResponse402) & {
  headers: Headers;
};

export type deleteApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdResponse = (deleteApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdResponseSuccess | deleteApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdResponseError)

export const getDeleteApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdUrl = (teamId: string,
    quoteOptionId: string,) => {




  return `/api/teams/${teamId}/crm/quote-options/${quoteOptionId}`
}

export const deleteApiTeamsTeamIdCrmQuoteOptionsQuoteOptionId = async (teamId: string,
    quoteOptionId: string, options?: RequestInit): Promise<deleteApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdResponse> => {

  return fetcher<deleteApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdResponse>(getDeleteApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdUrl(teamId,quoteOptionId),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type postApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdBindResponse200TextPlain = {
  data: CrmQuoteOptionBindPayload
  status: 200
}

export type postApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdBindResponse200ApplicationJson = {
  data: CrmQuoteOptionBindPayload
  status: 200
}

export type postApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdBindResponse200TextJson = {
  data: CrmQuoteOptionBindPayload
  status: 200
}

export type postApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdBindResponse401 = {
  data: PostApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdBind401
  status: 401
}

export type postApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdBindResponse402 = {
  data: PostApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdBind402
  status: 402
}

export type postApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdBindResponseSuccess = (postApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdBindResponse200TextPlain | postApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdBindResponse200ApplicationJson | postApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdBindResponse200TextJson) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdBindResponseError = (postApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdBindResponse401 | postApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdBindResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdBindResponse = (postApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdBindResponseSuccess | postApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdBindResponseError)

export const getPostApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdBindUrl = (teamId: string,
    quoteOptionId: string,) => {




  return `/api/teams/${teamId}/crm/quote-options/${quoteOptionId}/bind`
}

export const postApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdBind = async (teamId: string,
    quoteOptionId: string,
    nullBindQuoteRequest: null | BindQuoteRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdBindResponse> => {

  return fetcher<postApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdBindResponse>(getPostApiTeamsTeamIdCrmQuoteOptionsQuoteOptionIdBindUrl(teamId,quoteOptionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullBindQuoteRequest,)
  }
);}



export type getApiTeamsTeamIdCrmQuotesQuoteIdCoveragesResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmQuotesQuoteIdCoveragesResponse401 = {
  data: GetApiTeamsTeamIdCrmQuotesQuoteIdCoverages401
  status: 401
}

export type getApiTeamsTeamIdCrmQuotesQuoteIdCoveragesResponseSuccess = (getApiTeamsTeamIdCrmQuotesQuoteIdCoveragesResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmQuotesQuoteIdCoveragesResponseError = (getApiTeamsTeamIdCrmQuotesQuoteIdCoveragesResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmQuotesQuoteIdCoveragesResponse = (getApiTeamsTeamIdCrmQuotesQuoteIdCoveragesResponseSuccess | getApiTeamsTeamIdCrmQuotesQuoteIdCoveragesResponseError)

export const getGetApiTeamsTeamIdCrmQuotesQuoteIdCoveragesUrl = (teamId: string,
    quoteId: string,) => {




  return `/api/teams/${teamId}/crm/quotes/${quoteId}/coverages`
}

export const getApiTeamsTeamIdCrmQuotesQuoteIdCoverages = async (teamId: string,
    quoteId: string, options?: RequestInit): Promise<getApiTeamsTeamIdCrmQuotesQuoteIdCoveragesResponse> => {

  return fetcher<getApiTeamsTeamIdCrmQuotesQuoteIdCoveragesResponse>(getGetApiTeamsTeamIdCrmQuotesQuoteIdCoveragesUrl(teamId,quoteId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdCrmQuotesQuoteIdCoveragesResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmQuotesQuoteIdCoveragesResponse401 = {
  data: PostApiTeamsTeamIdCrmQuotesQuoteIdCoverages401
  status: 401
}

export type postApiTeamsTeamIdCrmQuotesQuoteIdCoveragesResponse402 = {
  data: PostApiTeamsTeamIdCrmQuotesQuoteIdCoverages402
  status: 402
}

export type postApiTeamsTeamIdCrmQuotesQuoteIdCoveragesResponseSuccess = (postApiTeamsTeamIdCrmQuotesQuoteIdCoveragesResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmQuotesQuoteIdCoveragesResponseError = (postApiTeamsTeamIdCrmQuotesQuoteIdCoveragesResponse401 | postApiTeamsTeamIdCrmQuotesQuoteIdCoveragesResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmQuotesQuoteIdCoveragesResponse = (postApiTeamsTeamIdCrmQuotesQuoteIdCoveragesResponseSuccess | postApiTeamsTeamIdCrmQuotesQuoteIdCoveragesResponseError)

export const getPostApiTeamsTeamIdCrmQuotesQuoteIdCoveragesUrl = (teamId: string,
    quoteId: string,) => {




  return `/api/teams/${teamId}/crm/quotes/${quoteId}/coverages`
}

export const postApiTeamsTeamIdCrmQuotesQuoteIdCoverages = async (teamId: string,
    quoteId: string,
    upsertCoverageRequest: UpsertCoverageRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmQuotesQuoteIdCoveragesResponse> => {

  return fetcher<postApiTeamsTeamIdCrmQuotesQuoteIdCoveragesResponse>(getPostApiTeamsTeamIdCrmQuotesQuoteIdCoveragesUrl(teamId,quoteId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upsertCoverageRequest,)
  }
);}



export type putApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdResponse200 = {
  data: void
  status: 200
}

export type putApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdResponse401 = {
  data: PutApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageId401
  status: 401
}

export type putApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdResponse402 = {
  data: PutApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageId402
  status: 402
}

export type putApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdResponseSuccess = (putApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdResponse200) & {
  headers: Headers;
};
export type putApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdResponseError = (putApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdResponse401 | putApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdResponse402) & {
  headers: Headers;
};

export type putApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdResponse = (putApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdResponseSuccess | putApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdResponseError)

export const getPutApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdUrl = (teamId: string,
    quoteCoverageId: string,) => {




  return `/api/teams/${teamId}/crm/quote-coverages/${quoteCoverageId}`
}

export const putApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageId = async (teamId: string,
    quoteCoverageId: string,
    upsertCoverageRequest: UpsertCoverageRequest, options?: RequestInit): Promise<putApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdResponse> => {

  return fetcher<putApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdResponse>(getPutApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdUrl(teamId,quoteCoverageId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upsertCoverageRequest,)
  }
);}



export type postApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdLimitsResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdLimitsResponse401 = {
  data: PostApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdLimits401
  status: 401
}

export type postApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdLimitsResponse402 = {
  data: PostApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdLimits402
  status: 402
}

export type postApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdLimitsResponseSuccess = (postApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdLimitsResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdLimitsResponseError = (postApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdLimitsResponse401 | postApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdLimitsResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdLimitsResponse = (postApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdLimitsResponseSuccess | postApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdLimitsResponseError)

export const getPostApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdLimitsUrl = (teamId: string,
    quoteCoverageId: string,) => {




  return `/api/teams/${teamId}/crm/quote-coverages/${quoteCoverageId}/limits`
}

export const postApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdLimits = async (teamId: string,
    quoteCoverageId: string,
    upsertCoverageLimitRequest: UpsertCoverageLimitRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdLimitsResponse> => {

  return fetcher<postApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdLimitsResponse>(getPostApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdLimitsUrl(teamId,quoteCoverageId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upsertCoverageLimitRequest,)
  }
);}



export type putApiTeamsTeamIdCrmQuoteCoverageLimitsQuoteCoverageLimitIdResponse200 = {
  data: void
  status: 200
}

export type putApiTeamsTeamIdCrmQuoteCoverageLimitsQuoteCoverageLimitIdResponse401 = {
  data: PutApiTeamsTeamIdCrmQuoteCoverageLimitsQuoteCoverageLimitId401
  status: 401
}

export type putApiTeamsTeamIdCrmQuoteCoverageLimitsQuoteCoverageLimitIdResponse402 = {
  data: PutApiTeamsTeamIdCrmQuoteCoverageLimitsQuoteCoverageLimitId402
  status: 402
}

export type putApiTeamsTeamIdCrmQuoteCoverageLimitsQuoteCoverageLimitIdResponseSuccess = (putApiTeamsTeamIdCrmQuoteCoverageLimitsQuoteCoverageLimitIdResponse200) & {
  headers: Headers;
};
export type putApiTeamsTeamIdCrmQuoteCoverageLimitsQuoteCoverageLimitIdResponseError = (putApiTeamsTeamIdCrmQuoteCoverageLimitsQuoteCoverageLimitIdResponse401 | putApiTeamsTeamIdCrmQuoteCoverageLimitsQuoteCoverageLimitIdResponse402) & {
  headers: Headers;
};

export type putApiTeamsTeamIdCrmQuoteCoverageLimitsQuoteCoverageLimitIdResponse = (putApiTeamsTeamIdCrmQuoteCoverageLimitsQuoteCoverageLimitIdResponseSuccess | putApiTeamsTeamIdCrmQuoteCoverageLimitsQuoteCoverageLimitIdResponseError)

export const getPutApiTeamsTeamIdCrmQuoteCoverageLimitsQuoteCoverageLimitIdUrl = (teamId: string,
    quoteCoverageLimitId: string,) => {




  return `/api/teams/${teamId}/crm/quote-coverage-limits/${quoteCoverageLimitId}`
}

export const putApiTeamsTeamIdCrmQuoteCoverageLimitsQuoteCoverageLimitId = async (teamId: string,
    quoteCoverageLimitId: string,
    upsertCoverageLimitRequest: UpsertCoverageLimitRequest, options?: RequestInit): Promise<putApiTeamsTeamIdCrmQuoteCoverageLimitsQuoteCoverageLimitIdResponse> => {

  return fetcher<putApiTeamsTeamIdCrmQuoteCoverageLimitsQuoteCoverageLimitIdResponse>(getPutApiTeamsTeamIdCrmQuoteCoverageLimitsQuoteCoverageLimitIdUrl(teamId,quoteCoverageLimitId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upsertCoverageLimitRequest,)
  }
);}



export type postApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdDeductiblesResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdDeductiblesResponse401 = {
  data: PostApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdDeductibles401
  status: 401
}

export type postApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdDeductiblesResponse402 = {
  data: PostApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdDeductibles402
  status: 402
}

export type postApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdDeductiblesResponseSuccess = (postApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdDeductiblesResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdDeductiblesResponseError = (postApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdDeductiblesResponse401 | postApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdDeductiblesResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdDeductiblesResponse = (postApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdDeductiblesResponseSuccess | postApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdDeductiblesResponseError)

export const getPostApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdDeductiblesUrl = (teamId: string,
    quoteCoverageId: string,) => {




  return `/api/teams/${teamId}/crm/quote-coverages/${quoteCoverageId}/deductibles`
}

export const postApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdDeductibles = async (teamId: string,
    quoteCoverageId: string,
    upsertCoverageDeductibleRequest: UpsertCoverageDeductibleRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdDeductiblesResponse> => {

  return fetcher<postApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdDeductiblesResponse>(getPostApiTeamsTeamIdCrmQuoteCoveragesQuoteCoverageIdDeductiblesUrl(teamId,quoteCoverageId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upsertCoverageDeductibleRequest,)
  }
);}



export type putApiTeamsTeamIdCrmQuoteCoverageDeductiblesQuoteCoverageDeductibleIdResponse200 = {
  data: void
  status: 200
}

export type putApiTeamsTeamIdCrmQuoteCoverageDeductiblesQuoteCoverageDeductibleIdResponse401 = {
  data: PutApiTeamsTeamIdCrmQuoteCoverageDeductiblesQuoteCoverageDeductibleId401
  status: 401
}

export type putApiTeamsTeamIdCrmQuoteCoverageDeductiblesQuoteCoverageDeductibleIdResponse402 = {
  data: PutApiTeamsTeamIdCrmQuoteCoverageDeductiblesQuoteCoverageDeductibleId402
  status: 402
}

export type putApiTeamsTeamIdCrmQuoteCoverageDeductiblesQuoteCoverageDeductibleIdResponseSuccess = (putApiTeamsTeamIdCrmQuoteCoverageDeductiblesQuoteCoverageDeductibleIdResponse200) & {
  headers: Headers;
};
export type putApiTeamsTeamIdCrmQuoteCoverageDeductiblesQuoteCoverageDeductibleIdResponseError = (putApiTeamsTeamIdCrmQuoteCoverageDeductiblesQuoteCoverageDeductibleIdResponse401 | putApiTeamsTeamIdCrmQuoteCoverageDeductiblesQuoteCoverageDeductibleIdResponse402) & {
  headers: Headers;
};

export type putApiTeamsTeamIdCrmQuoteCoverageDeductiblesQuoteCoverageDeductibleIdResponse = (putApiTeamsTeamIdCrmQuoteCoverageDeductiblesQuoteCoverageDeductibleIdResponseSuccess | putApiTeamsTeamIdCrmQuoteCoverageDeductiblesQuoteCoverageDeductibleIdResponseError)

export const getPutApiTeamsTeamIdCrmQuoteCoverageDeductiblesQuoteCoverageDeductibleIdUrl = (teamId: string,
    quoteCoverageDeductibleId: string,) => {




  return `/api/teams/${teamId}/crm/quote-coverage-deductibles/${quoteCoverageDeductibleId}`
}

export const putApiTeamsTeamIdCrmQuoteCoverageDeductiblesQuoteCoverageDeductibleId = async (teamId: string,
    quoteCoverageDeductibleId: string,
    upsertCoverageDeductibleRequest: UpsertCoverageDeductibleRequest, options?: RequestInit): Promise<putApiTeamsTeamIdCrmQuoteCoverageDeductiblesQuoteCoverageDeductibleIdResponse> => {

  return fetcher<putApiTeamsTeamIdCrmQuoteCoverageDeductiblesQuoteCoverageDeductibleIdResponse>(getPutApiTeamsTeamIdCrmQuoteCoverageDeductiblesQuoteCoverageDeductibleIdUrl(teamId,quoteCoverageDeductibleId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upsertCoverageDeductibleRequest,)
  }
);}



export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdResponse401 = {
  data: GetApiTeamsTeamIdCrmSubmissionsSubmissionId401
  status: 401
}

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdResponseSuccess = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdResponseError = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdResponse = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdResponseSuccess | getApiTeamsTeamIdCrmSubmissionsSubmissionIdResponseError)

export const getGetApiTeamsTeamIdCrmSubmissionsSubmissionIdUrl = (teamId: string,
    submissionId: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${submissionId}`
}

export const getApiTeamsTeamIdCrmSubmissionsSubmissionId = async (teamId: string,
    submissionId: string, options?: RequestInit): Promise<getApiTeamsTeamIdCrmSubmissionsSubmissionIdResponse> => {

  return fetcher<getApiTeamsTeamIdCrmSubmissionsSubmissionIdResponse>(getGetApiTeamsTeamIdCrmSubmissionsSubmissionIdUrl(teamId,submissionId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdChangeLogResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdChangeLogResponse401 = {
  data: GetApiTeamsTeamIdCrmSubmissionsSubmissionIdChangeLog401
  status: 401
}

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdChangeLogResponseSuccess = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdChangeLogResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdChangeLogResponseError = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdChangeLogResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdChangeLogResponse = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdChangeLogResponseSuccess | getApiTeamsTeamIdCrmSubmissionsSubmissionIdChangeLogResponseError)

export const getGetApiTeamsTeamIdCrmSubmissionsSubmissionIdChangeLogUrl = (teamId: string,
    submissionId: string,
    params?: GetApiTeamsTeamIdCrmSubmissionsSubmissionIdChangeLogParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/crm/submissions/${submissionId}/change-log?${stringifiedParams}` : `/api/teams/${teamId}/crm/submissions/${submissionId}/change-log`
}

export const getApiTeamsTeamIdCrmSubmissionsSubmissionIdChangeLog = async (teamId: string,
    submissionId: string,
    params?: GetApiTeamsTeamIdCrmSubmissionsSubmissionIdChangeLogParams, options?: RequestInit): Promise<getApiTeamsTeamIdCrmSubmissionsSubmissionIdChangeLogResponse> => {

  return fetcher<getApiTeamsTeamIdCrmSubmissionsSubmissionIdChangeLogResponse>(getGetApiTeamsTeamIdCrmSubmissionsSubmissionIdChangeLogUrl(teamId,submissionId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type putApiTeamsTeamIdCrmSubmissionsSubmissionIdSetupResponse200 = {
  data: void
  status: 200
}

export type putApiTeamsTeamIdCrmSubmissionsSubmissionIdSetupResponse401 = {
  data: PutApiTeamsTeamIdCrmSubmissionsSubmissionIdSetup401
  status: 401
}

export type putApiTeamsTeamIdCrmSubmissionsSubmissionIdSetupResponse402 = {
  data: PutApiTeamsTeamIdCrmSubmissionsSubmissionIdSetup402
  status: 402
}

export type putApiTeamsTeamIdCrmSubmissionsSubmissionIdSetupResponseSuccess = (putApiTeamsTeamIdCrmSubmissionsSubmissionIdSetupResponse200) & {
  headers: Headers;
};
export type putApiTeamsTeamIdCrmSubmissionsSubmissionIdSetupResponseError = (putApiTeamsTeamIdCrmSubmissionsSubmissionIdSetupResponse401 | putApiTeamsTeamIdCrmSubmissionsSubmissionIdSetupResponse402) & {
  headers: Headers;
};

export type putApiTeamsTeamIdCrmSubmissionsSubmissionIdSetupResponse = (putApiTeamsTeamIdCrmSubmissionsSubmissionIdSetupResponseSuccess | putApiTeamsTeamIdCrmSubmissionsSubmissionIdSetupResponseError)

export const getPutApiTeamsTeamIdCrmSubmissionsSubmissionIdSetupUrl = (teamId: string,
    submissionId: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${submissionId}/setup`
}

export const putApiTeamsTeamIdCrmSubmissionsSubmissionIdSetup = async (teamId: string,
    submissionId: string,
    updateSubmissionSetupRequest: UpdateSubmissionSetupRequest, options?: RequestInit): Promise<putApiTeamsTeamIdCrmSubmissionsSubmissionIdSetupResponse> => {

  return fetcher<putApiTeamsTeamIdCrmSubmissionsSubmissionIdSetupResponse>(getPutApiTeamsTeamIdCrmSubmissionsSubmissionIdSetupUrl(teamId,submissionId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateSubmissionSetupRequest,)
  }
);}



export type putApiTeamsTeamIdCrmSubmissionsSubmissionIdAssigneeResponse200 = {
  data: void
  status: 200
}

export type putApiTeamsTeamIdCrmSubmissionsSubmissionIdAssigneeResponse401 = {
  data: PutApiTeamsTeamIdCrmSubmissionsSubmissionIdAssignee401
  status: 401
}

export type putApiTeamsTeamIdCrmSubmissionsSubmissionIdAssigneeResponse402 = {
  data: PutApiTeamsTeamIdCrmSubmissionsSubmissionIdAssignee402
  status: 402
}

export type putApiTeamsTeamIdCrmSubmissionsSubmissionIdAssigneeResponseSuccess = (putApiTeamsTeamIdCrmSubmissionsSubmissionIdAssigneeResponse200) & {
  headers: Headers;
};
export type putApiTeamsTeamIdCrmSubmissionsSubmissionIdAssigneeResponseError = (putApiTeamsTeamIdCrmSubmissionsSubmissionIdAssigneeResponse401 | putApiTeamsTeamIdCrmSubmissionsSubmissionIdAssigneeResponse402) & {
  headers: Headers;
};

export type putApiTeamsTeamIdCrmSubmissionsSubmissionIdAssigneeResponse = (putApiTeamsTeamIdCrmSubmissionsSubmissionIdAssigneeResponseSuccess | putApiTeamsTeamIdCrmSubmissionsSubmissionIdAssigneeResponseError)

export const getPutApiTeamsTeamIdCrmSubmissionsSubmissionIdAssigneeUrl = (teamId: string,
    submissionId: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${submissionId}/assignee`
}

export const putApiTeamsTeamIdCrmSubmissionsSubmissionIdAssignee = async (teamId: string,
    submissionId: string,
    setSubmissionAssigneeRequest: SetSubmissionAssigneeRequest, options?: RequestInit): Promise<putApiTeamsTeamIdCrmSubmissionsSubmissionIdAssigneeResponse> => {

  return fetcher<putApiTeamsTeamIdCrmSubmissionsSubmissionIdAssigneeResponse>(getPutApiTeamsTeamIdCrmSubmissionsSubmissionIdAssigneeUrl(teamId,submissionId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      setSubmissionAssigneeRequest,)
  }
);}



export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdCloseResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdCloseResponse401 = {
  data: PostApiTeamsTeamIdCrmSubmissionsSubmissionIdClose401
  status: 401
}

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdCloseResponse402 = {
  data: PostApiTeamsTeamIdCrmSubmissionsSubmissionIdClose402
  status: 402
}

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdCloseResponseSuccess = (postApiTeamsTeamIdCrmSubmissionsSubmissionIdCloseResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdCloseResponseError = (postApiTeamsTeamIdCrmSubmissionsSubmissionIdCloseResponse401 | postApiTeamsTeamIdCrmSubmissionsSubmissionIdCloseResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdCloseResponse = (postApiTeamsTeamIdCrmSubmissionsSubmissionIdCloseResponseSuccess | postApiTeamsTeamIdCrmSubmissionsSubmissionIdCloseResponseError)

export const getPostApiTeamsTeamIdCrmSubmissionsSubmissionIdCloseUrl = (teamId: string,
    submissionId: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${submissionId}/close`
}

export const postApiTeamsTeamIdCrmSubmissionsSubmissionIdClose = async (teamId: string,
    submissionId: string,
    closeSubmissionRequest: CloseSubmissionRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmSubmissionsSubmissionIdCloseResponse> => {

  return fetcher<postApiTeamsTeamIdCrmSubmissionsSubmissionIdCloseResponse>(getPostApiTeamsTeamIdCrmSubmissionsSubmissionIdCloseUrl(teamId,submissionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      closeSubmissionRequest,)
  }
);}



export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdSourcePolicyOptionsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdSourcePolicyOptionsResponse401 = {
  data: GetApiTeamsTeamIdCrmSubmissionsSubmissionIdSourcePolicyOptions401
  status: 401
}

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdSourcePolicyOptionsResponseSuccess = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdSourcePolicyOptionsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdSourcePolicyOptionsResponseError = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdSourcePolicyOptionsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdSourcePolicyOptionsResponse = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdSourcePolicyOptionsResponseSuccess | getApiTeamsTeamIdCrmSubmissionsSubmissionIdSourcePolicyOptionsResponseError)

export const getGetApiTeamsTeamIdCrmSubmissionsSubmissionIdSourcePolicyOptionsUrl = (teamId: string,
    submissionId: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${submissionId}/source-policy-options`
}

export const getApiTeamsTeamIdCrmSubmissionsSubmissionIdSourcePolicyOptions = async (teamId: string,
    submissionId: string, options?: RequestInit): Promise<getApiTeamsTeamIdCrmSubmissionsSubmissionIdSourcePolicyOptionsResponse> => {

  return fetcher<getApiTeamsTeamIdCrmSubmissionsSubmissionIdSourcePolicyOptionsResponse>(getGetApiTeamsTeamIdCrmSubmissionsSubmissionIdSourcePolicyOptionsUrl(teamId,submissionId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsResponse401 = {
  data: GetApiTeamsTeamIdCrmSubmissionsSubmissionIdTags401
  status: 401
}

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsResponseSuccess = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsResponseError = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsResponse = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsResponseSuccess | getApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsResponseError)

export const getGetApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsUrl = (teamId: string,
    submissionId: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${submissionId}/tags`
}

export const getApiTeamsTeamIdCrmSubmissionsSubmissionIdTags = async (teamId: string,
    submissionId: string, options?: RequestInit): Promise<getApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsResponse> => {

  return fetcher<getApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsResponse>(getGetApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsUrl(teamId,submissionId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsResponse401 = {
  data: PostApiTeamsTeamIdCrmSubmissionsSubmissionIdTags401
  status: 401
}

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsResponse402 = {
  data: PostApiTeamsTeamIdCrmSubmissionsSubmissionIdTags402
  status: 402
}

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsResponseSuccess = (postApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsResponseError = (postApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsResponse401 | postApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsResponse = (postApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsResponseSuccess | postApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsResponseError)

export const getPostApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsUrl = (teamId: string,
    submissionId: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${submissionId}/tags`
}

export const postApiTeamsTeamIdCrmSubmissionsSubmissionIdTags = async (teamId: string,
    submissionId: string,
    tagSubmissionRequest: TagSubmissionRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsResponse> => {

  return fetcher<postApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsResponse>(getPostApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsUrl(teamId,submissionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      tagSubmissionRequest,)
  }
);}



export type deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsTagCodeResponse200 = {
  data: void
  status: 200
}

export type deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsTagCodeResponse401 = {
  data: DeleteApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsTagCode401
  status: 401
}

export type deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsTagCodeResponse402 = {
  data: DeleteApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsTagCode402
  status: 402
}

export type deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsTagCodeResponseSuccess = (deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsTagCodeResponse200) & {
  headers: Headers;
};
export type deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsTagCodeResponseError = (deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsTagCodeResponse401 | deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsTagCodeResponse402) & {
  headers: Headers;
};

export type deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsTagCodeResponse = (deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsTagCodeResponseSuccess | deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsTagCodeResponseError)

export const getDeleteApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsTagCodeUrl = (teamId: string,
    submissionId: string,
    tagCode: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${submissionId}/tags/${tagCode}`
}

export const deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsTagCode = async (teamId: string,
    submissionId: string,
    tagCode: string, options?: RequestInit): Promise<deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsTagCodeResponse> => {

  return fetcher<deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsTagCodeResponse>(getDeleteApiTeamsTeamIdCrmSubmissionsSubmissionIdTagsTagCodeUrl(teamId,submissionId,tagCode),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsResponse401 = {
  data: GetApiTeamsTeamIdCrmSubmissionsSubmissionIdMarkets401
  status: 401
}

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsResponseSuccess = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsResponseError = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsResponse = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsResponseSuccess | getApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsResponseError)

export const getGetApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsUrl = (teamId: string,
    submissionId: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${submissionId}/markets`
}

export const getApiTeamsTeamIdCrmSubmissionsSubmissionIdMarkets = async (teamId: string,
    submissionId: string, options?: RequestInit): Promise<getApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsResponse> => {

  return fetcher<getApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsResponse>(getGetApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsUrl(teamId,submissionId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsResponse401 = {
  data: PostApiTeamsTeamIdCrmSubmissionsSubmissionIdMarkets401
  status: 401
}

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsResponse402 = {
  data: PostApiTeamsTeamIdCrmSubmissionsSubmissionIdMarkets402
  status: 402
}

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsResponseSuccess = (postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsResponseError = (postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsResponse401 | postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsResponse = (postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsResponseSuccess | postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsResponseError)

export const getPostApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsUrl = (teamId: string,
    submissionId: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${submissionId}/markets`
}

export const postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarkets = async (teamId: string,
    submissionId: string,
    addMarketAttemptRequest: AddMarketAttemptRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsResponse> => {

  return fetcher<postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsResponse>(getPostApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsUrl(teamId,submissionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      addMarketAttemptRequest,)
  }
);}



export type putApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdResponse200 = {
  data: void
  status: 200
}

export type putApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdResponse401 = {
  data: PutApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketId401
  status: 401
}

export type putApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdResponse402 = {
  data: PutApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketId402
  status: 402
}

export type putApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdResponseSuccess = (putApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdResponse200) & {
  headers: Headers;
};
export type putApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdResponseError = (putApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdResponse401 | putApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdResponse402) & {
  headers: Headers;
};

export type putApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdResponse = (putApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdResponseSuccess | putApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdResponseError)

export const getPutApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdUrl = (teamId: string,
    submissionId: string,
    submissionMarketId: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${submissionId}/markets/${submissionMarketId}`
}

export const putApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketId = async (teamId: string,
    submissionId: string,
    submissionMarketId: string,
    updateSubmissionMarketRequest: UpdateSubmissionMarketRequest, options?: RequestInit): Promise<putApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdResponse> => {

  return fetcher<putApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdResponse>(getPutApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdUrl(teamId,submissionId,submissionMarketId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateSubmissionMarketRequest,)
  }
);}



export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdQuotesResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdQuotesResponse401 = {
  data: GetApiTeamsTeamIdCrmSubmissionsSubmissionIdQuotes401
  status: 401
}

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdQuotesResponseSuccess = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdQuotesResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdQuotesResponseError = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdQuotesResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdQuotesResponse = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdQuotesResponseSuccess | getApiTeamsTeamIdCrmSubmissionsSubmissionIdQuotesResponseError)

export const getGetApiTeamsTeamIdCrmSubmissionsSubmissionIdQuotesUrl = (teamId: string,
    submissionId: string,
    params?: GetApiTeamsTeamIdCrmSubmissionsSubmissionIdQuotesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/crm/submissions/${submissionId}/quotes?${stringifiedParams}` : `/api/teams/${teamId}/crm/submissions/${submissionId}/quotes`
}

export const getApiTeamsTeamIdCrmSubmissionsSubmissionIdQuotes = async (teamId: string,
    submissionId: string,
    params?: GetApiTeamsTeamIdCrmSubmissionsSubmissionIdQuotesParams, options?: RequestInit): Promise<getApiTeamsTeamIdCrmSubmissionsSubmissionIdQuotesResponse> => {

  return fetcher<getApiTeamsTeamIdCrmSubmissionsSubmissionIdQuotesResponse>(getGetApiTeamsTeamIdCrmSubmissionsSubmissionIdQuotesUrl(teamId,submissionId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdQuotesResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdQuotesResponse401 = {
  data: PostApiTeamsTeamIdCrmSubmissionsSubmissionIdQuotes401
  status: 401
}

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdQuotesResponse402 = {
  data: PostApiTeamsTeamIdCrmSubmissionsSubmissionIdQuotes402
  status: 402
}

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdQuotesResponseSuccess = (postApiTeamsTeamIdCrmSubmissionsSubmissionIdQuotesResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdQuotesResponseError = (postApiTeamsTeamIdCrmSubmissionsSubmissionIdQuotesResponse401 | postApiTeamsTeamIdCrmSubmissionsSubmissionIdQuotesResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdQuotesResponse = (postApiTeamsTeamIdCrmSubmissionsSubmissionIdQuotesResponseSuccess | postApiTeamsTeamIdCrmSubmissionsSubmissionIdQuotesResponseError)

export const getPostApiTeamsTeamIdCrmSubmissionsSubmissionIdQuotesUrl = (teamId: string,
    submissionId: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${submissionId}/quotes`
}

export const postApiTeamsTeamIdCrmSubmissionsSubmissionIdQuotes = async (teamId: string,
    submissionId: string,
    upsertQuoteRequest: UpsertQuoteRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmSubmissionsSubmissionIdQuotesResponse> => {

  return fetcher<postApiTeamsTeamIdCrmSubmissionsSubmissionIdQuotesResponse>(getPostApiTeamsTeamIdCrmSubmissionsSubmissionIdQuotesUrl(teamId,submissionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upsertQuoteRequest,)
  }
);}



export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdQuoteWorkbenchResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdQuoteWorkbenchResponse401 = {
  data: GetApiTeamsTeamIdCrmSubmissionsSubmissionIdQuoteWorkbench401
  status: 401
}

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdQuoteWorkbenchResponseSuccess = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdQuoteWorkbenchResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdQuoteWorkbenchResponseError = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdQuoteWorkbenchResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdQuoteWorkbenchResponse = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdQuoteWorkbenchResponseSuccess | getApiTeamsTeamIdCrmSubmissionsSubmissionIdQuoteWorkbenchResponseError)

export const getGetApiTeamsTeamIdCrmSubmissionsSubmissionIdQuoteWorkbenchUrl = (teamId: string,
    submissionId: string,
    params?: GetApiTeamsTeamIdCrmSubmissionsSubmissionIdQuoteWorkbenchParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/crm/submissions/${submissionId}/quote-workbench?${stringifiedParams}` : `/api/teams/${teamId}/crm/submissions/${submissionId}/quote-workbench`
}

export const getApiTeamsTeamIdCrmSubmissionsSubmissionIdQuoteWorkbench = async (teamId: string,
    submissionId: string,
    params?: GetApiTeamsTeamIdCrmSubmissionsSubmissionIdQuoteWorkbenchParams, options?: RequestInit): Promise<getApiTeamsTeamIdCrmSubmissionsSubmissionIdQuoteWorkbenchResponse> => {

  return fetcher<getApiTeamsTeamIdCrmSubmissionsSubmissionIdQuoteWorkbenchResponse>(getGetApiTeamsTeamIdCrmSubmissionsSubmissionIdQuoteWorkbenchUrl(teamId,submissionId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type putApiTeamsTeamIdCrmQuotesQuoteIdResponse200 = {
  data: void
  status: 200
}

export type putApiTeamsTeamIdCrmQuotesQuoteIdResponse401 = {
  data: PutApiTeamsTeamIdCrmQuotesQuoteId401
  status: 401
}

export type putApiTeamsTeamIdCrmQuotesQuoteIdResponse402 = {
  data: PutApiTeamsTeamIdCrmQuotesQuoteId402
  status: 402
}

export type putApiTeamsTeamIdCrmQuotesQuoteIdResponseSuccess = (putApiTeamsTeamIdCrmQuotesQuoteIdResponse200) & {
  headers: Headers;
};
export type putApiTeamsTeamIdCrmQuotesQuoteIdResponseError = (putApiTeamsTeamIdCrmQuotesQuoteIdResponse401 | putApiTeamsTeamIdCrmQuotesQuoteIdResponse402) & {
  headers: Headers;
};

export type putApiTeamsTeamIdCrmQuotesQuoteIdResponse = (putApiTeamsTeamIdCrmQuotesQuoteIdResponseSuccess | putApiTeamsTeamIdCrmQuotesQuoteIdResponseError)

export const getPutApiTeamsTeamIdCrmQuotesQuoteIdUrl = (teamId: string,
    quoteId: string,) => {




  return `/api/teams/${teamId}/crm/quotes/${quoteId}`
}

export const putApiTeamsTeamIdCrmQuotesQuoteId = async (teamId: string,
    quoteId: string,
    upsertQuoteRequest: UpsertQuoteRequest, options?: RequestInit): Promise<putApiTeamsTeamIdCrmQuotesQuoteIdResponse> => {

  return fetcher<putApiTeamsTeamIdCrmQuotesQuoteIdResponse>(getPutApiTeamsTeamIdCrmQuotesQuoteIdUrl(teamId,quoteId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upsertQuoteRequest,)
  }
);}



export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdQuoteSelectionRequestsResponse200TextPlain = {
  data: CrmQuoteSelectionRequestPayload[]
  status: 200
}

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdQuoteSelectionRequestsResponse200ApplicationJson = {
  data: CrmQuoteSelectionRequestPayload[]
  status: 200
}

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdQuoteSelectionRequestsResponse200TextJson = {
  data: CrmQuoteSelectionRequestPayload[]
  status: 200
}

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdQuoteSelectionRequestsResponse401 = {
  data: GetApiTeamsTeamIdCrmSubmissionsSubmissionIdQuoteSelectionRequests401
  status: 401
}

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdQuoteSelectionRequestsResponseSuccess = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdQuoteSelectionRequestsResponse200TextPlain | getApiTeamsTeamIdCrmSubmissionsSubmissionIdQuoteSelectionRequestsResponse200ApplicationJson | getApiTeamsTeamIdCrmSubmissionsSubmissionIdQuoteSelectionRequestsResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdQuoteSelectionRequestsResponseError = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdQuoteSelectionRequestsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdQuoteSelectionRequestsResponse = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdQuoteSelectionRequestsResponseSuccess | getApiTeamsTeamIdCrmSubmissionsSubmissionIdQuoteSelectionRequestsResponseError)

export const getGetApiTeamsTeamIdCrmSubmissionsSubmissionIdQuoteSelectionRequestsUrl = (teamId: string,
    submissionId: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${submissionId}/quote-selection-requests`
}

export const getApiTeamsTeamIdCrmSubmissionsSubmissionIdQuoteSelectionRequests = async (teamId: string,
    submissionId: string, options?: RequestInit): Promise<getApiTeamsTeamIdCrmSubmissionsSubmissionIdQuoteSelectionRequestsResponse> => {

  return fetcher<getApiTeamsTeamIdCrmSubmissionsSubmissionIdQuoteSelectionRequestsResponse>(getGetApiTeamsTeamIdCrmSubmissionsSubmissionIdQuoteSelectionRequestsUrl(teamId,submissionId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdCrmQuotesQuoteIdSelectionRequestSetupResponse200TextPlain = {
  data: CrmQuoteSelectionSetupPayload
  status: 200
}

export type getApiTeamsTeamIdCrmQuotesQuoteIdSelectionRequestSetupResponse200ApplicationJson = {
  data: CrmQuoteSelectionSetupPayload
  status: 200
}

export type getApiTeamsTeamIdCrmQuotesQuoteIdSelectionRequestSetupResponse200TextJson = {
  data: CrmQuoteSelectionSetupPayload
  status: 200
}

export type getApiTeamsTeamIdCrmQuotesQuoteIdSelectionRequestSetupResponse401 = {
  data: GetApiTeamsTeamIdCrmQuotesQuoteIdSelectionRequestSetup401
  status: 401
}

export type getApiTeamsTeamIdCrmQuotesQuoteIdSelectionRequestSetupResponseSuccess = (getApiTeamsTeamIdCrmQuotesQuoteIdSelectionRequestSetupResponse200TextPlain | getApiTeamsTeamIdCrmQuotesQuoteIdSelectionRequestSetupResponse200ApplicationJson | getApiTeamsTeamIdCrmQuotesQuoteIdSelectionRequestSetupResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmQuotesQuoteIdSelectionRequestSetupResponseError = (getApiTeamsTeamIdCrmQuotesQuoteIdSelectionRequestSetupResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmQuotesQuoteIdSelectionRequestSetupResponse = (getApiTeamsTeamIdCrmQuotesQuoteIdSelectionRequestSetupResponseSuccess | getApiTeamsTeamIdCrmQuotesQuoteIdSelectionRequestSetupResponseError)

export const getGetApiTeamsTeamIdCrmQuotesQuoteIdSelectionRequestSetupUrl = (teamId: string,
    quoteId: string,) => {




  return `/api/teams/${teamId}/crm/quotes/${quoteId}/selection-request/setup`
}

export const getApiTeamsTeamIdCrmQuotesQuoteIdSelectionRequestSetup = async (teamId: string,
    quoteId: string, options?: RequestInit): Promise<getApiTeamsTeamIdCrmQuotesQuoteIdSelectionRequestSetupResponse> => {

  return fetcher<getApiTeamsTeamIdCrmQuotesQuoteIdSelectionRequestSetupResponse>(getGetApiTeamsTeamIdCrmQuotesQuoteIdSelectionRequestSetupUrl(teamId,quoteId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdCrmQuotesQuoteIdSelectionRequestsResponse200TextPlain = {
  data: CrmQuoteSelectionSendPayload
  status: 200
}

export type postApiTeamsTeamIdCrmQuotesQuoteIdSelectionRequestsResponse200ApplicationJson = {
  data: CrmQuoteSelectionSendPayload
  status: 200
}

export type postApiTeamsTeamIdCrmQuotesQuoteIdSelectionRequestsResponse200TextJson = {
  data: CrmQuoteSelectionSendPayload
  status: 200
}

export type postApiTeamsTeamIdCrmQuotesQuoteIdSelectionRequestsResponse401 = {
  data: PostApiTeamsTeamIdCrmQuotesQuoteIdSelectionRequests401
  status: 401
}

export type postApiTeamsTeamIdCrmQuotesQuoteIdSelectionRequestsResponse402 = {
  data: PostApiTeamsTeamIdCrmQuotesQuoteIdSelectionRequests402
  status: 402
}

export type postApiTeamsTeamIdCrmQuotesQuoteIdSelectionRequestsResponseSuccess = (postApiTeamsTeamIdCrmQuotesQuoteIdSelectionRequestsResponse200TextPlain | postApiTeamsTeamIdCrmQuotesQuoteIdSelectionRequestsResponse200ApplicationJson | postApiTeamsTeamIdCrmQuotesQuoteIdSelectionRequestsResponse200TextJson) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmQuotesQuoteIdSelectionRequestsResponseError = (postApiTeamsTeamIdCrmQuotesQuoteIdSelectionRequestsResponse401 | postApiTeamsTeamIdCrmQuotesQuoteIdSelectionRequestsResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmQuotesQuoteIdSelectionRequestsResponse = (postApiTeamsTeamIdCrmQuotesQuoteIdSelectionRequestsResponseSuccess | postApiTeamsTeamIdCrmQuotesQuoteIdSelectionRequestsResponseError)

export const getPostApiTeamsTeamIdCrmQuotesQuoteIdSelectionRequestsUrl = (teamId: string,
    quoteId: string,) => {




  return `/api/teams/${teamId}/crm/quotes/${quoteId}/selection-requests`
}

export const postApiTeamsTeamIdCrmQuotesQuoteIdSelectionRequests = async (teamId: string,
    quoteId: string,
    sendQuoteSelectionRequestBody: SendQuoteSelectionRequestBody, options?: RequestInit): Promise<postApiTeamsTeamIdCrmQuotesQuoteIdSelectionRequestsResponse> => {

  return fetcher<postApiTeamsTeamIdCrmQuotesQuoteIdSelectionRequestsResponse>(getPostApiTeamsTeamIdCrmQuotesQuoteIdSelectionRequestsUrl(teamId,quoteId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sendQuoteSelectionRequestBody,)
  }
);}



export type postApiTeamsTeamIdCrmQuotesQuoteIdEsignRefreshResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmQuotesQuoteIdEsignRefreshResponse401 = {
  data: PostApiTeamsTeamIdCrmQuotesQuoteIdEsignRefresh401
  status: 401
}

export type postApiTeamsTeamIdCrmQuotesQuoteIdEsignRefreshResponse402 = {
  data: PostApiTeamsTeamIdCrmQuotesQuoteIdEsignRefresh402
  status: 402
}

export type postApiTeamsTeamIdCrmQuotesQuoteIdEsignRefreshResponseSuccess = (postApiTeamsTeamIdCrmQuotesQuoteIdEsignRefreshResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmQuotesQuoteIdEsignRefreshResponseError = (postApiTeamsTeamIdCrmQuotesQuoteIdEsignRefreshResponse401 | postApiTeamsTeamIdCrmQuotesQuoteIdEsignRefreshResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmQuotesQuoteIdEsignRefreshResponse = (postApiTeamsTeamIdCrmQuotesQuoteIdEsignRefreshResponseSuccess | postApiTeamsTeamIdCrmQuotesQuoteIdEsignRefreshResponseError)

export const getPostApiTeamsTeamIdCrmQuotesQuoteIdEsignRefreshUrl = (teamId: string,
    quoteId: string,) => {




  return `/api/teams/${teamId}/crm/quotes/${quoteId}/esign/refresh`
}

export const postApiTeamsTeamIdCrmQuotesQuoteIdEsignRefresh = async (teamId: string,
    quoteId: string, options?: RequestInit): Promise<postApiTeamsTeamIdCrmQuotesQuoteIdEsignRefreshResponse> => {

  return fetcher<postApiTeamsTeamIdCrmQuotesQuoteIdEsignRefreshResponse>(getPostApiTeamsTeamIdCrmQuotesQuoteIdEsignRefreshUrl(teamId,quoteId),
  {
    ...options,
    method: 'POST'


  }
);}



export type postApiTeamsTeamIdCrmQuotesQuoteIdEsignSendResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmQuotesQuoteIdEsignSendResponse401 = {
  data: PostApiTeamsTeamIdCrmQuotesQuoteIdEsignSend401
  status: 401
}

export type postApiTeamsTeamIdCrmQuotesQuoteIdEsignSendResponse402 = {
  data: PostApiTeamsTeamIdCrmQuotesQuoteIdEsignSend402
  status: 402
}

export type postApiTeamsTeamIdCrmQuotesQuoteIdEsignSendResponseSuccess = (postApiTeamsTeamIdCrmQuotesQuoteIdEsignSendResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmQuotesQuoteIdEsignSendResponseError = (postApiTeamsTeamIdCrmQuotesQuoteIdEsignSendResponse401 | postApiTeamsTeamIdCrmQuotesQuoteIdEsignSendResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmQuotesQuoteIdEsignSendResponse = (postApiTeamsTeamIdCrmQuotesQuoteIdEsignSendResponseSuccess | postApiTeamsTeamIdCrmQuotesQuoteIdEsignSendResponseError)

export const getPostApiTeamsTeamIdCrmQuotesQuoteIdEsignSendUrl = (teamId: string,
    quoteId: string,) => {




  return `/api/teams/${teamId}/crm/quotes/${quoteId}/esign/send`
}

export const postApiTeamsTeamIdCrmQuotesQuoteIdEsignSend = async (teamId: string,
    quoteId: string,
    sendQuoteESignRequest: SendQuoteESignRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmQuotesQuoteIdEsignSendResponse> => {

  return fetcher<postApiTeamsTeamIdCrmQuotesQuoteIdEsignSendResponse>(getPostApiTeamsTeamIdCrmQuotesQuoteIdEsignSendUrl(teamId,quoteId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sendQuoteESignRequest,)
  }
);}



export type postApiTeamsTeamIdCrmQuotesQuoteIdBindResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmQuotesQuoteIdBindResponse401 = {
  data: PostApiTeamsTeamIdCrmQuotesQuoteIdBind401
  status: 401
}

export type postApiTeamsTeamIdCrmQuotesQuoteIdBindResponse402 = {
  data: PostApiTeamsTeamIdCrmQuotesQuoteIdBind402
  status: 402
}

export type postApiTeamsTeamIdCrmQuotesQuoteIdBindResponseSuccess = (postApiTeamsTeamIdCrmQuotesQuoteIdBindResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmQuotesQuoteIdBindResponseError = (postApiTeamsTeamIdCrmQuotesQuoteIdBindResponse401 | postApiTeamsTeamIdCrmQuotesQuoteIdBindResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmQuotesQuoteIdBindResponse = (postApiTeamsTeamIdCrmQuotesQuoteIdBindResponseSuccess | postApiTeamsTeamIdCrmQuotesQuoteIdBindResponseError)

export const getPostApiTeamsTeamIdCrmQuotesQuoteIdBindUrl = (teamId: string,
    quoteId: string,) => {




  return `/api/teams/${teamId}/crm/quotes/${quoteId}/bind`
}

export const postApiTeamsTeamIdCrmQuotesQuoteIdBind = async (teamId: string,
    quoteId: string,
    nullBindQuoteRequest: null | BindQuoteRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmQuotesQuoteIdBindResponse> => {

  return fetcher<postApiTeamsTeamIdCrmQuotesQuoteIdBindResponse>(getPostApiTeamsTeamIdCrmQuotesQuoteIdBindUrl(teamId,quoteId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullBindQuoteRequest,)
  }
);}



export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendReadinessResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendReadinessResponse401 = {
  data: GetApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendReadiness401
  status: 401
}

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendReadinessResponseSuccess = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendReadinessResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendReadinessResponseError = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendReadinessResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendReadinessResponse = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendReadinessResponseSuccess | getApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendReadinessResponseError)

export const getGetApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendReadinessUrl = (teamId: string,
    submissionId: string,
    submissionMarketId: string,
    params?: GetApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendReadinessParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/crm/submissions/${submissionId}/markets/${submissionMarketId}/send-readiness?${stringifiedParams}` : `/api/teams/${teamId}/crm/submissions/${submissionId}/markets/${submissionMarketId}/send-readiness`
}

export const getApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendReadiness = async (teamId: string,
    submissionId: string,
    submissionMarketId: string,
    params?: GetApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendReadinessParams, options?: RequestInit): Promise<getApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendReadinessResponse> => {

  return fetcher<getApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendReadinessResponse>(getGetApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendReadinessUrl(teamId,submissionId,submissionMarketId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdPrepareResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdPrepareResponse401 = {
  data: PostApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdPrepare401
  status: 401
}

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdPrepareResponse402 = {
  data: PostApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdPrepare402
  status: 402
}

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdPrepareResponseSuccess = (postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdPrepareResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdPrepareResponseError = (postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdPrepareResponse401 | postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdPrepareResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdPrepareResponse = (postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdPrepareResponseSuccess | postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdPrepareResponseError)

export const getPostApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdPrepareUrl = (teamId: string,
    submissionId: string,
    submissionMarketId: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${submissionId}/markets/${submissionMarketId}/prepare`
}

export const postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdPrepare = async (teamId: string,
    submissionId: string,
    submissionMarketId: string,
    nullPrepareSubmissionMarketRequest: null | PrepareSubmissionMarketRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdPrepareResponse> => {

  return fetcher<postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdPrepareResponse>(getPostApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdPrepareUrl(teamId,submissionId,submissionMarketId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullPrepareSubmissionMarketRequest,)
  }
);}



export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendResponse401 = {
  data: PostApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSend401
  status: 401
}

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendResponse402 = {
  data: PostApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSend402
  status: 402
}

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendResponseSuccess = (postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendResponseError = (postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendResponse401 | postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendResponse = (postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendResponseSuccess | postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendResponseError)

export const getPostApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendUrl = (teamId: string,
    submissionId: string,
    submissionMarketId: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${submissionId}/markets/${submissionMarketId}/send`
}

export const postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSend = async (teamId: string,
    submissionId: string,
    submissionMarketId: string,
    nullSendSubmissionMarketRequest: null | SendSubmissionMarketRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendResponse> => {

  return fetcher<postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendResponse>(getPostApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendUrl(teamId,submissionId,submissionMarketId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullSendSubmissionMarketRequest,)
  }
);}



export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendEmailResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendEmailResponse401 = {
  data: PostApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendEmail401
  status: 401
}

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendEmailResponse402 = {
  data: PostApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendEmail402
  status: 402
}

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendEmailResponseSuccess = (postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendEmailResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendEmailResponseError = (postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendEmailResponse401 | postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendEmailResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendEmailResponse = (postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendEmailResponseSuccess | postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendEmailResponseError)

export const getPostApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendEmailUrl = (teamId: string,
    submissionId: string,
    submissionMarketId: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${submissionId}/markets/${submissionMarketId}/send-email`
}

export const postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendEmail = async (teamId: string,
    submissionId: string,
    submissionMarketId: string,
    nullSendSubmissionMarketEmailRequest: null | SendSubmissionMarketEmailRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendEmailResponse> => {

  return fetcher<postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendEmailResponse>(getPostApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdSendEmailUrl(teamId,submissionId,submissionMarketId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullSendSubmissionMarketEmailRequest,)
  }
);}



export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdDeclineResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdDeclineResponse401 = {
  data: PostApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdDecline401
  status: 401
}

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdDeclineResponse402 = {
  data: PostApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdDecline402
  status: 402
}

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdDeclineResponseSuccess = (postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdDeclineResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdDeclineResponseError = (postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdDeclineResponse401 | postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdDeclineResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdDeclineResponse = (postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdDeclineResponseSuccess | postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdDeclineResponseError)

export const getPostApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdDeclineUrl = (teamId: string,
    submissionId: string,
    submissionMarketId: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${submissionId}/markets/${submissionMarketId}/decline`
}

export const postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdDecline = async (teamId: string,
    submissionId: string,
    submissionMarketId: string,
    nullDeclineSubmissionMarketRequest: null | DeclineSubmissionMarketRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdDeclineResponse> => {

  return fetcher<postApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdDeclineResponse>(getPostApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdDeclineUrl(teamId,submissionId,submissionMarketId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullDeclineSubmissionMarketRequest,)
  }
);}



export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdEventsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdEventsResponse401 = {
  data: GetApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdEvents401
  status: 401
}

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdEventsResponseSuccess = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdEventsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdEventsResponseError = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdEventsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdEventsResponse = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdEventsResponseSuccess | getApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdEventsResponseError)

export const getGetApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdEventsUrl = (teamId: string,
    submissionId: string,
    submissionMarketId: string,
    params?: GetApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdEventsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/crm/submissions/${submissionId}/markets/${submissionMarketId}/events?${stringifiedParams}` : `/api/teams/${teamId}/crm/submissions/${submissionId}/markets/${submissionMarketId}/events`
}

export const getApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdEvents = async (teamId: string,
    submissionId: string,
    submissionMarketId: string,
    params?: GetApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdEventsParams, options?: RequestInit): Promise<getApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdEventsResponse> => {

  return fetcher<getApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdEventsResponse>(getGetApiTeamsTeamIdCrmSubmissionsSubmissionIdMarketsSubmissionMarketIdEventsUrl(teamId,submissionId,submissionMarketId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdApplicationReadinessResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdApplicationReadinessResponse401 = {
  data: GetApiTeamsTeamIdCrmSubmissionsSubmissionIdApplicationReadiness401
  status: 401
}

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdApplicationReadinessResponseSuccess = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdApplicationReadinessResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdApplicationReadinessResponseError = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdApplicationReadinessResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdApplicationReadinessResponse = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdApplicationReadinessResponseSuccess | getApiTeamsTeamIdCrmSubmissionsSubmissionIdApplicationReadinessResponseError)

export const getGetApiTeamsTeamIdCrmSubmissionsSubmissionIdApplicationReadinessUrl = (teamId: string,
    submissionId: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${submissionId}/application-readiness`
}

export const getApiTeamsTeamIdCrmSubmissionsSubmissionIdApplicationReadiness = async (teamId: string,
    submissionId: string, options?: RequestInit): Promise<getApiTeamsTeamIdCrmSubmissionsSubmissionIdApplicationReadinessResponse> => {

  return fetcher<getApiTeamsTeamIdCrmSubmissionsSubmissionIdApplicationReadinessResponse>(getGetApiTeamsTeamIdCrmSubmissionsSubmissionIdApplicationReadinessUrl(teamId,submissionId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdRequiredDataResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdRequiredDataResponse401 = {
  data: GetApiTeamsTeamIdCrmSubmissionsSubmissionIdRequiredData401
  status: 401
}

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdRequiredDataResponseSuccess = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdRequiredDataResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdRequiredDataResponseError = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdRequiredDataResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdRequiredDataResponse = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdRequiredDataResponseSuccess | getApiTeamsTeamIdCrmSubmissionsSubmissionIdRequiredDataResponseError)

export const getGetApiTeamsTeamIdCrmSubmissionsSubmissionIdRequiredDataUrl = (teamId: string,
    submissionId: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${submissionId}/required-data`
}

export const getApiTeamsTeamIdCrmSubmissionsSubmissionIdRequiredData = async (teamId: string,
    submissionId: string, options?: RequestInit): Promise<getApiTeamsTeamIdCrmSubmissionsSubmissionIdRequiredDataResponse> => {

  return fetcher<getApiTeamsTeamIdCrmSubmissionsSubmissionIdRequiredDataResponse>(getGetApiTeamsTeamIdCrmSubmissionsSubmissionIdRequiredDataUrl(teamId,submissionId),
  {
    ...options,
    method: 'GET'


  }
);}



export type putApiTeamsTeamIdCrmSubmissionsSubmissionIdRequiredDataResponse200 = {
  data: void
  status: 200
}

export type putApiTeamsTeamIdCrmSubmissionsSubmissionIdRequiredDataResponse401 = {
  data: PutApiTeamsTeamIdCrmSubmissionsSubmissionIdRequiredData401
  status: 401
}

export type putApiTeamsTeamIdCrmSubmissionsSubmissionIdRequiredDataResponse402 = {
  data: PutApiTeamsTeamIdCrmSubmissionsSubmissionIdRequiredData402
  status: 402
}

export type putApiTeamsTeamIdCrmSubmissionsSubmissionIdRequiredDataResponseSuccess = (putApiTeamsTeamIdCrmSubmissionsSubmissionIdRequiredDataResponse200) & {
  headers: Headers;
};
export type putApiTeamsTeamIdCrmSubmissionsSubmissionIdRequiredDataResponseError = (putApiTeamsTeamIdCrmSubmissionsSubmissionIdRequiredDataResponse401 | putApiTeamsTeamIdCrmSubmissionsSubmissionIdRequiredDataResponse402) & {
  headers: Headers;
};

export type putApiTeamsTeamIdCrmSubmissionsSubmissionIdRequiredDataResponse = (putApiTeamsTeamIdCrmSubmissionsSubmissionIdRequiredDataResponseSuccess | putApiTeamsTeamIdCrmSubmissionsSubmissionIdRequiredDataResponseError)

export const getPutApiTeamsTeamIdCrmSubmissionsSubmissionIdRequiredDataUrl = (teamId: string,
    submissionId: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${submissionId}/required-data`
}

export const putApiTeamsTeamIdCrmSubmissionsSubmissionIdRequiredData = async (teamId: string,
    submissionId: string,
    saveSubmissionRequiredDataRequest: SaveSubmissionRequiredDataRequest, options?: RequestInit): Promise<putApiTeamsTeamIdCrmSubmissionsSubmissionIdRequiredDataResponse> => {

  return fetcher<putApiTeamsTeamIdCrmSubmissionsSubmissionIdRequiredDataResponse>(getPutApiTeamsTeamIdCrmSubmissionsSubmissionIdRequiredDataUrl(teamId,submissionId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      saveSubmissionRequiredDataRequest,)
  }
);}



export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesResponse401 = {
  data: GetApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehicles401
  status: 401
}

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesResponseSuccess = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesResponseError = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesResponse = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesResponseSuccess | getApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesResponseError)

export const getGetApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesUrl = (teamId: string,
    submissionId: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${submissionId}/auto/vehicles`
}

export const getApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehicles = async (teamId: string,
    submissionId: string, options?: RequestInit): Promise<getApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesResponse> => {

  return fetcher<getApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesResponse>(getGetApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesUrl(teamId,submissionId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesResponse401 = {
  data: PostApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehicles401
  status: 401
}

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesResponse402 = {
  data: PostApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehicles402
  status: 402
}

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesResponseSuccess = (postApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesResponseError = (postApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesResponse401 | postApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesResponse = (postApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesResponseSuccess | postApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesResponseError)

export const getPostApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesUrl = (teamId: string,
    submissionId: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${submissionId}/auto/vehicles`
}

export const postApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehicles = async (teamId: string,
    submissionId: string,
    nullSubmissionScheduleDraftRequest: null | SubmissionScheduleDraftRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesResponse> => {

  return fetcher<postApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesResponse>(getPostApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesUrl(teamId,submissionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullSubmissionScheduleDraftRequest,)
  }
);}



export type patchApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesDraftIdResponse200 = {
  data: void
  status: 200
}

export type patchApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesDraftIdResponse401 = {
  data: PatchApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesDraftId401
  status: 401
}

export type patchApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesDraftIdResponse402 = {
  data: PatchApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesDraftId402
  status: 402
}

export type patchApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesDraftIdResponseSuccess = (patchApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesDraftIdResponse200) & {
  headers: Headers;
};
export type patchApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesDraftIdResponseError = (patchApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesDraftIdResponse401 | patchApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesDraftIdResponse402) & {
  headers: Headers;
};

export type patchApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesDraftIdResponse = (patchApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesDraftIdResponseSuccess | patchApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesDraftIdResponseError)

export const getPatchApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesDraftIdUrl = (teamId: string,
    submissionId: string,
    draftId: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${submissionId}/auto/vehicles/${draftId}`
}

export const patchApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesDraftId = async (teamId: string,
    submissionId: string,
    draftId: string,
    nullSubmissionScheduleDraftUpdateRequest: null | SubmissionScheduleDraftUpdateRequest, options?: RequestInit): Promise<patchApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesDraftIdResponse> => {

  return fetcher<patchApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesDraftIdResponse>(getPatchApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesDraftIdUrl(teamId,submissionId,draftId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullSubmissionScheduleDraftUpdateRequest,)
  }
);}



export type deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesDraftIdResponse200 = {
  data: void
  status: 200
}

export type deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesDraftIdResponse401 = {
  data: DeleteApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesDraftId401
  status: 401
}

export type deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesDraftIdResponse402 = {
  data: DeleteApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesDraftId402
  status: 402
}

export type deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesDraftIdResponseSuccess = (deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesDraftIdResponse200) & {
  headers: Headers;
};
export type deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesDraftIdResponseError = (deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesDraftIdResponse401 | deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesDraftIdResponse402) & {
  headers: Headers;
};

export type deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesDraftIdResponse = (deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesDraftIdResponseSuccess | deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesDraftIdResponseError)

export const getDeleteApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesDraftIdUrl = (teamId: string,
    submissionId: string,
    draftId: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${submissionId}/auto/vehicles/${draftId}`
}

export const deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesDraftId = async (teamId: string,
    submissionId: string,
    draftId: string, options?: RequestInit): Promise<deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesDraftIdResponse> => {

  return fetcher<deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesDraftIdResponse>(getDeleteApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoVehiclesDraftIdUrl(teamId,submissionId,draftId),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversResponse401 = {
  data: GetApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDrivers401
  status: 401
}

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversResponseSuccess = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversResponseError = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversResponse = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversResponseSuccess | getApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversResponseError)

export const getGetApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversUrl = (teamId: string,
    submissionId: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${submissionId}/auto/drivers`
}

export const getApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDrivers = async (teamId: string,
    submissionId: string, options?: RequestInit): Promise<getApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversResponse> => {

  return fetcher<getApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversResponse>(getGetApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversUrl(teamId,submissionId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversResponse401 = {
  data: PostApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDrivers401
  status: 401
}

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversResponse402 = {
  data: PostApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDrivers402
  status: 402
}

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversResponseSuccess = (postApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversResponseError = (postApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversResponse401 | postApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversResponse = (postApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversResponseSuccess | postApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversResponseError)

export const getPostApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversUrl = (teamId: string,
    submissionId: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${submissionId}/auto/drivers`
}

export const postApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDrivers = async (teamId: string,
    submissionId: string,
    nullSubmissionScheduleDraftRequest: null | SubmissionScheduleDraftRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversResponse> => {

  return fetcher<postApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversResponse>(getPostApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversUrl(teamId,submissionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullSubmissionScheduleDraftRequest,)
  }
);}



export type patchApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversDraftIdResponse200 = {
  data: void
  status: 200
}

export type patchApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversDraftIdResponse401 = {
  data: PatchApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversDraftId401
  status: 401
}

export type patchApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversDraftIdResponse402 = {
  data: PatchApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversDraftId402
  status: 402
}

export type patchApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversDraftIdResponseSuccess = (patchApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversDraftIdResponse200) & {
  headers: Headers;
};
export type patchApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversDraftIdResponseError = (patchApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversDraftIdResponse401 | patchApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversDraftIdResponse402) & {
  headers: Headers;
};

export type patchApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversDraftIdResponse = (patchApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversDraftIdResponseSuccess | patchApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversDraftIdResponseError)

export const getPatchApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversDraftIdUrl = (teamId: string,
    submissionId: string,
    draftId: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${submissionId}/auto/drivers/${draftId}`
}

export const patchApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversDraftId = async (teamId: string,
    submissionId: string,
    draftId: string,
    nullSubmissionScheduleDraftUpdateRequest: null | SubmissionScheduleDraftUpdateRequest, options?: RequestInit): Promise<patchApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversDraftIdResponse> => {

  return fetcher<patchApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversDraftIdResponse>(getPatchApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversDraftIdUrl(teamId,submissionId,draftId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullSubmissionScheduleDraftUpdateRequest,)
  }
);}



export type deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversDraftIdResponse200 = {
  data: void
  status: 200
}

export type deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversDraftIdResponse401 = {
  data: DeleteApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversDraftId401
  status: 401
}

export type deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversDraftIdResponse402 = {
  data: DeleteApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversDraftId402
  status: 402
}

export type deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversDraftIdResponseSuccess = (deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversDraftIdResponse200) & {
  headers: Headers;
};
export type deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversDraftIdResponseError = (deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversDraftIdResponse401 | deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversDraftIdResponse402) & {
  headers: Headers;
};

export type deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversDraftIdResponse = (deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversDraftIdResponseSuccess | deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversDraftIdResponseError)

export const getDeleteApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversDraftIdUrl = (teamId: string,
    submissionId: string,
    draftId: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${submissionId}/auto/drivers/${draftId}`
}

export const deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversDraftId = async (teamId: string,
    submissionId: string,
    draftId: string, options?: RequestInit): Promise<deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversDraftIdResponse> => {

  return fetcher<deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversDraftIdResponse>(getDeleteApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoDriversDraftIdUrl(teamId,submissionId,draftId),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoFinalizeSchedulesResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoFinalizeSchedulesResponse401 = {
  data: PostApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoFinalizeSchedules401
  status: 401
}

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoFinalizeSchedulesResponse402 = {
  data: PostApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoFinalizeSchedules402
  status: 402
}

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoFinalizeSchedulesResponseSuccess = (postApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoFinalizeSchedulesResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoFinalizeSchedulesResponseError = (postApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoFinalizeSchedulesResponse401 | postApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoFinalizeSchedulesResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoFinalizeSchedulesResponse = (postApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoFinalizeSchedulesResponseSuccess | postApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoFinalizeSchedulesResponseError)

export const getPostApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoFinalizeSchedulesUrl = (teamId: string,
    submissionId: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${submissionId}/auto/finalize-schedules`
}

export const postApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoFinalizeSchedules = async (teamId: string,
    submissionId: string,
    nullSubmissionAutoSchedulesFinalizeRequest: null | SubmissionAutoSchedulesFinalizeRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoFinalizeSchedulesResponse> => {

  return fetcher<postApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoFinalizeSchedulesResponse>(getPostApiTeamsTeamIdCrmSubmissionsSubmissionIdAutoFinalizeSchedulesUrl(teamId,submissionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullSubmissionAutoSchedulesFinalizeRequest,)
  }
);}



export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsResponse401 = {
  data: GetApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDrafts401
  status: 401
}

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsResponseSuccess = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsResponseError = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsResponse = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsResponseSuccess | getApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsResponseError)

export const getGetApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsUrl = (teamId: string,
    submissionId: string,
    scheduleType: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${submissionId}/schedules/${scheduleType}/drafts`
}

export const getApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDrafts = async (teamId: string,
    submissionId: string,
    scheduleType: string, options?: RequestInit): Promise<getApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsResponse> => {

  return fetcher<getApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsResponse>(getGetApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsUrl(teamId,submissionId,scheduleType),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsResponse401 = {
  data: PostApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDrafts401
  status: 401
}

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsResponse402 = {
  data: PostApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDrafts402
  status: 402
}

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsResponseSuccess = (postApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsResponseError = (postApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsResponse401 | postApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsResponse = (postApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsResponseSuccess | postApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsResponseError)

export const getPostApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsUrl = (teamId: string,
    submissionId: string,
    scheduleType: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${submissionId}/schedules/${scheduleType}/drafts`
}

export const postApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDrafts = async (teamId: string,
    submissionId: string,
    scheduleType: string,
    nullSubmissionScheduleDraftRequest: null | SubmissionScheduleDraftRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsResponse> => {

  return fetcher<postApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsResponse>(getPostApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsUrl(teamId,submissionId,scheduleType),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullSubmissionScheduleDraftRequest,)
  }
);}



export type patchApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsDraftIdResponse200 = {
  data: void
  status: 200
}

export type patchApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsDraftIdResponse401 = {
  data: PatchApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsDraftId401
  status: 401
}

export type patchApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsDraftIdResponse402 = {
  data: PatchApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsDraftId402
  status: 402
}

export type patchApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsDraftIdResponseSuccess = (patchApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsDraftIdResponse200) & {
  headers: Headers;
};
export type patchApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsDraftIdResponseError = (patchApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsDraftIdResponse401 | patchApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsDraftIdResponse402) & {
  headers: Headers;
};

export type patchApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsDraftIdResponse = (patchApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsDraftIdResponseSuccess | patchApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsDraftIdResponseError)

export const getPatchApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsDraftIdUrl = (teamId: string,
    submissionId: string,
    scheduleType: string,
    draftId: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${submissionId}/schedules/${scheduleType}/drafts/${draftId}`
}

export const patchApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsDraftId = async (teamId: string,
    submissionId: string,
    scheduleType: string,
    draftId: string,
    nullSubmissionScheduleDraftUpdateRequest: null | SubmissionScheduleDraftUpdateRequest, options?: RequestInit): Promise<patchApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsDraftIdResponse> => {

  return fetcher<patchApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsDraftIdResponse>(getPatchApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsDraftIdUrl(teamId,submissionId,scheduleType,draftId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullSubmissionScheduleDraftUpdateRequest,)
  }
);}



export type deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsDraftIdResponse200 = {
  data: void
  status: 200
}

export type deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsDraftIdResponse401 = {
  data: DeleteApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsDraftId401
  status: 401
}

export type deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsDraftIdResponse402 = {
  data: DeleteApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsDraftId402
  status: 402
}

export type deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsDraftIdResponseSuccess = (deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsDraftIdResponse200) & {
  headers: Headers;
};
export type deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsDraftIdResponseError = (deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsDraftIdResponse401 | deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsDraftIdResponse402) & {
  headers: Headers;
};

export type deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsDraftIdResponse = (deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsDraftIdResponseSuccess | deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsDraftIdResponseError)

export const getDeleteApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsDraftIdUrl = (teamId: string,
    submissionId: string,
    scheduleType: string,
    draftId: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${submissionId}/schedules/${scheduleType}/drafts/${draftId}`
}

export const deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsDraftId = async (teamId: string,
    submissionId: string,
    scheduleType: string,
    draftId: string, options?: RequestInit): Promise<deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsDraftIdResponse> => {

  return fetcher<deleteApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsDraftIdResponse>(getDeleteApiTeamsTeamIdCrmSubmissionsSubmissionIdSchedulesScheduleTypeDraftsDraftIdUrl(teamId,submissionId,scheduleType,draftId),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdDetailContextResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdDetailContextResponse401 = {
  data: GetApiTeamsTeamIdCrmSubmissionsSubmissionIdDetailContext401
  status: 401
}

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdDetailContextResponseSuccess = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdDetailContextResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdDetailContextResponseError = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdDetailContextResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmSubmissionsSubmissionIdDetailContextResponse = (getApiTeamsTeamIdCrmSubmissionsSubmissionIdDetailContextResponseSuccess | getApiTeamsTeamIdCrmSubmissionsSubmissionIdDetailContextResponseError)

export const getGetApiTeamsTeamIdCrmSubmissionsSubmissionIdDetailContextUrl = (teamId: string,
    submissionId: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${submissionId}/detail-context`
}

export const getApiTeamsTeamIdCrmSubmissionsSubmissionIdDetailContext = async (teamId: string,
    submissionId: string, options?: RequestInit): Promise<getApiTeamsTeamIdCrmSubmissionsSubmissionIdDetailContextResponse> => {

  return fetcher<getApiTeamsTeamIdCrmSubmissionsSubmissionIdDetailContextResponse>(getGetApiTeamsTeamIdCrmSubmissionsSubmissionIdDetailContextUrl(teamId,submissionId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdCrmPartiesResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmPartiesResponse401 = {
  data: GetApiTeamsTeamIdCrmParties401
  status: 401
}

export type getApiTeamsTeamIdCrmPartiesResponseSuccess = (getApiTeamsTeamIdCrmPartiesResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmPartiesResponseError = (getApiTeamsTeamIdCrmPartiesResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmPartiesResponse = (getApiTeamsTeamIdCrmPartiesResponseSuccess | getApiTeamsTeamIdCrmPartiesResponseError)

export const getGetApiTeamsTeamIdCrmPartiesUrl = (teamId: string,
    params?: GetApiTeamsTeamIdCrmPartiesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/crm/parties?${stringifiedParams}` : `/api/teams/${teamId}/crm/parties`
}

export const getApiTeamsTeamIdCrmParties = async (teamId: string,
    params?: GetApiTeamsTeamIdCrmPartiesParams, options?: RequestInit): Promise<getApiTeamsTeamIdCrmPartiesResponse> => {

  return fetcher<getApiTeamsTeamIdCrmPartiesResponse>(getGetApiTeamsTeamIdCrmPartiesUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdCrmPartiesResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmPartiesResponse401 = {
  data: PostApiTeamsTeamIdCrmParties401
  status: 401
}

export type postApiTeamsTeamIdCrmPartiesResponse402 = {
  data: PostApiTeamsTeamIdCrmParties402
  status: 402
}

export type postApiTeamsTeamIdCrmPartiesResponseSuccess = (postApiTeamsTeamIdCrmPartiesResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmPartiesResponseError = (postApiTeamsTeamIdCrmPartiesResponse401 | postApiTeamsTeamIdCrmPartiesResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmPartiesResponse = (postApiTeamsTeamIdCrmPartiesResponseSuccess | postApiTeamsTeamIdCrmPartiesResponseError)

export const getPostApiTeamsTeamIdCrmPartiesUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/crm/parties`
}

export const postApiTeamsTeamIdCrmParties = async (teamId: string,
    nullCreatePartyRequest: null | CreatePartyRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmPartiesResponse> => {

  return fetcher<postApiTeamsTeamIdCrmPartiesResponse>(getPostApiTeamsTeamIdCrmPartiesUrl(teamId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullCreatePartyRequest,)
  }
);}



export type getApiTeamsTeamIdCrmPartiesPartyIdResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmPartiesPartyIdResponse401 = {
  data: GetApiTeamsTeamIdCrmPartiesPartyId401
  status: 401
}

export type getApiTeamsTeamIdCrmPartiesPartyIdResponseSuccess = (getApiTeamsTeamIdCrmPartiesPartyIdResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmPartiesPartyIdResponseError = (getApiTeamsTeamIdCrmPartiesPartyIdResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmPartiesPartyIdResponse = (getApiTeamsTeamIdCrmPartiesPartyIdResponseSuccess | getApiTeamsTeamIdCrmPartiesPartyIdResponseError)

export const getGetApiTeamsTeamIdCrmPartiesPartyIdUrl = (teamId: string,
    partyId: string,) => {




  return `/api/teams/${teamId}/crm/parties/${partyId}`
}

export const getApiTeamsTeamIdCrmPartiesPartyId = async (teamId: string,
    partyId: string, options?: RequestInit): Promise<getApiTeamsTeamIdCrmPartiesPartyIdResponse> => {

  return fetcher<getApiTeamsTeamIdCrmPartiesPartyIdResponse>(getGetApiTeamsTeamIdCrmPartiesPartyIdUrl(teamId,partyId),
  {
    ...options,
    method: 'GET'


  }
);}



export type putApiTeamsTeamIdCrmPartiesPartyIdResponse200 = {
  data: void
  status: 200
}

export type putApiTeamsTeamIdCrmPartiesPartyIdResponse401 = {
  data: PutApiTeamsTeamIdCrmPartiesPartyId401
  status: 401
}

export type putApiTeamsTeamIdCrmPartiesPartyIdResponse402 = {
  data: PutApiTeamsTeamIdCrmPartiesPartyId402
  status: 402
}

export type putApiTeamsTeamIdCrmPartiesPartyIdResponseSuccess = (putApiTeamsTeamIdCrmPartiesPartyIdResponse200) & {
  headers: Headers;
};
export type putApiTeamsTeamIdCrmPartiesPartyIdResponseError = (putApiTeamsTeamIdCrmPartiesPartyIdResponse401 | putApiTeamsTeamIdCrmPartiesPartyIdResponse402) & {
  headers: Headers;
};

export type putApiTeamsTeamIdCrmPartiesPartyIdResponse = (putApiTeamsTeamIdCrmPartiesPartyIdResponseSuccess | putApiTeamsTeamIdCrmPartiesPartyIdResponseError)

export const getPutApiTeamsTeamIdCrmPartiesPartyIdUrl = (teamId: string,
    partyId: string,) => {




  return `/api/teams/${teamId}/crm/parties/${partyId}`
}

export const putApiTeamsTeamIdCrmPartiesPartyId = async (teamId: string,
    partyId: string,
    updatePartyRequest: UpdatePartyRequest, options?: RequestInit): Promise<putApiTeamsTeamIdCrmPartiesPartyIdResponse> => {

  return fetcher<putApiTeamsTeamIdCrmPartiesPartyIdResponse>(getPutApiTeamsTeamIdCrmPartiesPartyIdUrl(teamId,partyId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updatePartyRequest,)
  }
);}



export type getApiTeamsTeamIdCrmPartiesPartyIdRolesResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmPartiesPartyIdRolesResponse401 = {
  data: GetApiTeamsTeamIdCrmPartiesPartyIdRoles401
  status: 401
}

export type getApiTeamsTeamIdCrmPartiesPartyIdRolesResponseSuccess = (getApiTeamsTeamIdCrmPartiesPartyIdRolesResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmPartiesPartyIdRolesResponseError = (getApiTeamsTeamIdCrmPartiesPartyIdRolesResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmPartiesPartyIdRolesResponse = (getApiTeamsTeamIdCrmPartiesPartyIdRolesResponseSuccess | getApiTeamsTeamIdCrmPartiesPartyIdRolesResponseError)

export const getGetApiTeamsTeamIdCrmPartiesPartyIdRolesUrl = (teamId: string,
    partyId: string,) => {




  return `/api/teams/${teamId}/crm/parties/${partyId}/roles`
}

export const getApiTeamsTeamIdCrmPartiesPartyIdRoles = async (teamId: string,
    partyId: string, options?: RequestInit): Promise<getApiTeamsTeamIdCrmPartiesPartyIdRolesResponse> => {

  return fetcher<getApiTeamsTeamIdCrmPartiesPartyIdRolesResponse>(getGetApiTeamsTeamIdCrmPartiesPartyIdRolesUrl(teamId,partyId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdCrmPartiesPartyIdRolesResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmPartiesPartyIdRolesResponse401 = {
  data: PostApiTeamsTeamIdCrmPartiesPartyIdRoles401
  status: 401
}

export type postApiTeamsTeamIdCrmPartiesPartyIdRolesResponse402 = {
  data: PostApiTeamsTeamIdCrmPartiesPartyIdRoles402
  status: 402
}

export type postApiTeamsTeamIdCrmPartiesPartyIdRolesResponseSuccess = (postApiTeamsTeamIdCrmPartiesPartyIdRolesResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmPartiesPartyIdRolesResponseError = (postApiTeamsTeamIdCrmPartiesPartyIdRolesResponse401 | postApiTeamsTeamIdCrmPartiesPartyIdRolesResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmPartiesPartyIdRolesResponse = (postApiTeamsTeamIdCrmPartiesPartyIdRolesResponseSuccess | postApiTeamsTeamIdCrmPartiesPartyIdRolesResponseError)

export const getPostApiTeamsTeamIdCrmPartiesPartyIdRolesUrl = (teamId: string,
    partyId: string,) => {




  return `/api/teams/${teamId}/crm/parties/${partyId}/roles`
}

export const postApiTeamsTeamIdCrmPartiesPartyIdRoles = async (teamId: string,
    partyId: string,
    upsertRoleRequest: UpsertRoleRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmPartiesPartyIdRolesResponse> => {

  return fetcher<postApiTeamsTeamIdCrmPartiesPartyIdRolesResponse>(getPostApiTeamsTeamIdCrmPartiesPartyIdRolesUrl(teamId,partyId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upsertRoleRequest,)
  }
);}



export type getApiTeamsTeamIdCrmPartiesPartyIdCommResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmPartiesPartyIdCommResponse401 = {
  data: GetApiTeamsTeamIdCrmPartiesPartyIdComm401
  status: 401
}

export type getApiTeamsTeamIdCrmPartiesPartyIdCommResponseSuccess = (getApiTeamsTeamIdCrmPartiesPartyIdCommResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmPartiesPartyIdCommResponseError = (getApiTeamsTeamIdCrmPartiesPartyIdCommResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmPartiesPartyIdCommResponse = (getApiTeamsTeamIdCrmPartiesPartyIdCommResponseSuccess | getApiTeamsTeamIdCrmPartiesPartyIdCommResponseError)

export const getGetApiTeamsTeamIdCrmPartiesPartyIdCommUrl = (teamId: string,
    partyId: string,) => {




  return `/api/teams/${teamId}/crm/parties/${partyId}/comm`
}

export const getApiTeamsTeamIdCrmPartiesPartyIdComm = async (teamId: string,
    partyId: string, options?: RequestInit): Promise<getApiTeamsTeamIdCrmPartiesPartyIdCommResponse> => {

  return fetcher<getApiTeamsTeamIdCrmPartiesPartyIdCommResponse>(getGetApiTeamsTeamIdCrmPartiesPartyIdCommUrl(teamId,partyId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdCrmPartiesPartyIdCommResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmPartiesPartyIdCommResponse401 = {
  data: PostApiTeamsTeamIdCrmPartiesPartyIdComm401
  status: 401
}

export type postApiTeamsTeamIdCrmPartiesPartyIdCommResponse402 = {
  data: PostApiTeamsTeamIdCrmPartiesPartyIdComm402
  status: 402
}

export type postApiTeamsTeamIdCrmPartiesPartyIdCommResponseSuccess = (postApiTeamsTeamIdCrmPartiesPartyIdCommResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmPartiesPartyIdCommResponseError = (postApiTeamsTeamIdCrmPartiesPartyIdCommResponse401 | postApiTeamsTeamIdCrmPartiesPartyIdCommResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmPartiesPartyIdCommResponse = (postApiTeamsTeamIdCrmPartiesPartyIdCommResponseSuccess | postApiTeamsTeamIdCrmPartiesPartyIdCommResponseError)

export const getPostApiTeamsTeamIdCrmPartiesPartyIdCommUrl = (teamId: string,
    partyId: string,) => {




  return `/api/teams/${teamId}/crm/parties/${partyId}/comm`
}

export const postApiTeamsTeamIdCrmPartiesPartyIdComm = async (teamId: string,
    partyId: string,
    upsertCommRequest: UpsertCommRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmPartiesPartyIdCommResponse> => {

  return fetcher<postApiTeamsTeamIdCrmPartiesPartyIdCommResponse>(getPostApiTeamsTeamIdCrmPartiesPartyIdCommUrl(teamId,partyId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upsertCommRequest,)
  }
);}



export type getApiTeamsTeamIdCrmPartiesPartyIdAddressesResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmPartiesPartyIdAddressesResponse401 = {
  data: GetApiTeamsTeamIdCrmPartiesPartyIdAddresses401
  status: 401
}

export type getApiTeamsTeamIdCrmPartiesPartyIdAddressesResponseSuccess = (getApiTeamsTeamIdCrmPartiesPartyIdAddressesResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmPartiesPartyIdAddressesResponseError = (getApiTeamsTeamIdCrmPartiesPartyIdAddressesResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmPartiesPartyIdAddressesResponse = (getApiTeamsTeamIdCrmPartiesPartyIdAddressesResponseSuccess | getApiTeamsTeamIdCrmPartiesPartyIdAddressesResponseError)

export const getGetApiTeamsTeamIdCrmPartiesPartyIdAddressesUrl = (teamId: string,
    partyId: string,) => {




  return `/api/teams/${teamId}/crm/parties/${partyId}/addresses`
}

export const getApiTeamsTeamIdCrmPartiesPartyIdAddresses = async (teamId: string,
    partyId: string, options?: RequestInit): Promise<getApiTeamsTeamIdCrmPartiesPartyIdAddressesResponse> => {

  return fetcher<getApiTeamsTeamIdCrmPartiesPartyIdAddressesResponse>(getGetApiTeamsTeamIdCrmPartiesPartyIdAddressesUrl(teamId,partyId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdCrmPartiesPartyIdAddressesResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmPartiesPartyIdAddressesResponse401 = {
  data: PostApiTeamsTeamIdCrmPartiesPartyIdAddresses401
  status: 401
}

export type postApiTeamsTeamIdCrmPartiesPartyIdAddressesResponse402 = {
  data: PostApiTeamsTeamIdCrmPartiesPartyIdAddresses402
  status: 402
}

export type postApiTeamsTeamIdCrmPartiesPartyIdAddressesResponseSuccess = (postApiTeamsTeamIdCrmPartiesPartyIdAddressesResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmPartiesPartyIdAddressesResponseError = (postApiTeamsTeamIdCrmPartiesPartyIdAddressesResponse401 | postApiTeamsTeamIdCrmPartiesPartyIdAddressesResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmPartiesPartyIdAddressesResponse = (postApiTeamsTeamIdCrmPartiesPartyIdAddressesResponseSuccess | postApiTeamsTeamIdCrmPartiesPartyIdAddressesResponseError)

export const getPostApiTeamsTeamIdCrmPartiesPartyIdAddressesUrl = (teamId: string,
    partyId: string,) => {




  return `/api/teams/${teamId}/crm/parties/${partyId}/addresses`
}

export const postApiTeamsTeamIdCrmPartiesPartyIdAddresses = async (teamId: string,
    partyId: string,
    upsertAddressRequest: UpsertAddressRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmPartiesPartyIdAddressesResponse> => {

  return fetcher<postApiTeamsTeamIdCrmPartiesPartyIdAddressesResponse>(getPostApiTeamsTeamIdCrmPartiesPartyIdAddressesUrl(teamId,partyId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upsertAddressRequest,)
  }
);}



export type getApiTeamsTeamIdCrmPartiesPartyIdAccountsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmPartiesPartyIdAccountsResponse401 = {
  data: GetApiTeamsTeamIdCrmPartiesPartyIdAccounts401
  status: 401
}

export type getApiTeamsTeamIdCrmPartiesPartyIdAccountsResponseSuccess = (getApiTeamsTeamIdCrmPartiesPartyIdAccountsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmPartiesPartyIdAccountsResponseError = (getApiTeamsTeamIdCrmPartiesPartyIdAccountsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmPartiesPartyIdAccountsResponse = (getApiTeamsTeamIdCrmPartiesPartyIdAccountsResponseSuccess | getApiTeamsTeamIdCrmPartiesPartyIdAccountsResponseError)

export const getGetApiTeamsTeamIdCrmPartiesPartyIdAccountsUrl = (teamId: string,
    partyId: string,) => {




  return `/api/teams/${teamId}/crm/parties/${partyId}/accounts`
}

export const getApiTeamsTeamIdCrmPartiesPartyIdAccounts = async (teamId: string,
    partyId: string, options?: RequestInit): Promise<getApiTeamsTeamIdCrmPartiesPartyIdAccountsResponse> => {

  return fetcher<getApiTeamsTeamIdCrmPartiesPartyIdAccountsResponse>(getGetApiTeamsTeamIdCrmPartiesPartyIdAccountsUrl(teamId,partyId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsResponse401 = {
  data: GetApiTeamsTeamIdCrmClientAccountsClientAccountIdContacts401
  status: 401
}

export type getApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsResponseSuccess = (getApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsResponseError = (getApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsResponse = (getApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsResponseSuccess | getApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsResponseError)

export const getGetApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsUrl = (teamId: string,
    clientAccountId: string,) => {




  return `/api/teams/${teamId}/crm/client-accounts/${clientAccountId}/contacts`
}

export const getApiTeamsTeamIdCrmClientAccountsClientAccountIdContacts = async (teamId: string,
    clientAccountId: string, options?: RequestInit): Promise<getApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsResponse> => {

  return fetcher<getApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsResponse>(getGetApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsUrl(teamId,clientAccountId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsResponse401 = {
  data: PostApiTeamsTeamIdCrmClientAccountsClientAccountIdContacts401
  status: 401
}

export type postApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsResponse402 = {
  data: PostApiTeamsTeamIdCrmClientAccountsClientAccountIdContacts402
  status: 402
}

export type postApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsResponseSuccess = (postApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsResponseError = (postApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsResponse401 | postApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsResponse = (postApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsResponseSuccess | postApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsResponseError)

export const getPostApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsUrl = (teamId: string,
    clientAccountId: string,) => {




  return `/api/teams/${teamId}/crm/client-accounts/${clientAccountId}/contacts`
}

export const postApiTeamsTeamIdCrmClientAccountsClientAccountIdContacts = async (teamId: string,
    clientAccountId: string,
    upsertAccountContactRequest: UpsertAccountContactRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsResponse> => {

  return fetcher<postApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsResponse>(getPostApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsUrl(teamId,clientAccountId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upsertAccountContactRequest,)
  }
);}



export type getApiTeamsTeamIdCrmClientAccountsClientAccountIdChangeLogResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmClientAccountsClientAccountIdChangeLogResponse401 = {
  data: GetApiTeamsTeamIdCrmClientAccountsClientAccountIdChangeLog401
  status: 401
}

export type getApiTeamsTeamIdCrmClientAccountsClientAccountIdChangeLogResponseSuccess = (getApiTeamsTeamIdCrmClientAccountsClientAccountIdChangeLogResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmClientAccountsClientAccountIdChangeLogResponseError = (getApiTeamsTeamIdCrmClientAccountsClientAccountIdChangeLogResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmClientAccountsClientAccountIdChangeLogResponse = (getApiTeamsTeamIdCrmClientAccountsClientAccountIdChangeLogResponseSuccess | getApiTeamsTeamIdCrmClientAccountsClientAccountIdChangeLogResponseError)

export const getGetApiTeamsTeamIdCrmClientAccountsClientAccountIdChangeLogUrl = (teamId: string,
    clientAccountId: string,
    params?: GetApiTeamsTeamIdCrmClientAccountsClientAccountIdChangeLogParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/crm/client-accounts/${clientAccountId}/change-log?${stringifiedParams}` : `/api/teams/${teamId}/crm/client-accounts/${clientAccountId}/change-log`
}

export const getApiTeamsTeamIdCrmClientAccountsClientAccountIdChangeLog = async (teamId: string,
    clientAccountId: string,
    params?: GetApiTeamsTeamIdCrmClientAccountsClientAccountIdChangeLogParams, options?: RequestInit): Promise<getApiTeamsTeamIdCrmClientAccountsClientAccountIdChangeLogResponse> => {

  return fetcher<getApiTeamsTeamIdCrmClientAccountsClientAccountIdChangeLogResponse>(getGetApiTeamsTeamIdCrmClientAccountsClientAccountIdChangeLogUrl(teamId,clientAccountId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdCrmClientAccountsClientAccountIdStatusResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmClientAccountsClientAccountIdStatusResponse401 = {
  data: PostApiTeamsTeamIdCrmClientAccountsClientAccountIdStatus401
  status: 401
}

export type postApiTeamsTeamIdCrmClientAccountsClientAccountIdStatusResponse402 = {
  data: PostApiTeamsTeamIdCrmClientAccountsClientAccountIdStatus402
  status: 402
}

export type postApiTeamsTeamIdCrmClientAccountsClientAccountIdStatusResponseSuccess = (postApiTeamsTeamIdCrmClientAccountsClientAccountIdStatusResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmClientAccountsClientAccountIdStatusResponseError = (postApiTeamsTeamIdCrmClientAccountsClientAccountIdStatusResponse401 | postApiTeamsTeamIdCrmClientAccountsClientAccountIdStatusResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmClientAccountsClientAccountIdStatusResponse = (postApiTeamsTeamIdCrmClientAccountsClientAccountIdStatusResponseSuccess | postApiTeamsTeamIdCrmClientAccountsClientAccountIdStatusResponseError)

export const getPostApiTeamsTeamIdCrmClientAccountsClientAccountIdStatusUrl = (teamId: string,
    clientAccountId: string,) => {




  return `/api/teams/${teamId}/crm/client-accounts/${clientAccountId}/status`
}

export const postApiTeamsTeamIdCrmClientAccountsClientAccountIdStatus = async (teamId: string,
    clientAccountId: string,
    nullSetClientAccountStatusRequest: null | SetClientAccountStatusRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmClientAccountsClientAccountIdStatusResponse> => {

  return fetcher<postApiTeamsTeamIdCrmClientAccountsClientAccountIdStatusResponse>(getPostApiTeamsTeamIdCrmClientAccountsClientAccountIdStatusUrl(teamId,clientAccountId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullSetClientAccountStatusRequest,)
  }
);}



export type postApiTeamsTeamIdCrmClientAccountsClientAccountIdOwnerResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmClientAccountsClientAccountIdOwnerResponse401 = {
  data: PostApiTeamsTeamIdCrmClientAccountsClientAccountIdOwner401
  status: 401
}

export type postApiTeamsTeamIdCrmClientAccountsClientAccountIdOwnerResponse402 = {
  data: PostApiTeamsTeamIdCrmClientAccountsClientAccountIdOwner402
  status: 402
}

export type postApiTeamsTeamIdCrmClientAccountsClientAccountIdOwnerResponseSuccess = (postApiTeamsTeamIdCrmClientAccountsClientAccountIdOwnerResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmClientAccountsClientAccountIdOwnerResponseError = (postApiTeamsTeamIdCrmClientAccountsClientAccountIdOwnerResponse401 | postApiTeamsTeamIdCrmClientAccountsClientAccountIdOwnerResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmClientAccountsClientAccountIdOwnerResponse = (postApiTeamsTeamIdCrmClientAccountsClientAccountIdOwnerResponseSuccess | postApiTeamsTeamIdCrmClientAccountsClientAccountIdOwnerResponseError)

export const getPostApiTeamsTeamIdCrmClientAccountsClientAccountIdOwnerUrl = (teamId: string,
    clientAccountId: string,) => {




  return `/api/teams/${teamId}/crm/client-accounts/${clientAccountId}/owner`
}

export const postApiTeamsTeamIdCrmClientAccountsClientAccountIdOwner = async (teamId: string,
    clientAccountId: string,
    nullSetClientAccountOwnerRequest: null | SetClientAccountOwnerRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmClientAccountsClientAccountIdOwnerResponse> => {

  return fetcher<postApiTeamsTeamIdCrmClientAccountsClientAccountIdOwnerResponse>(getPostApiTeamsTeamIdCrmClientAccountsClientAccountIdOwnerUrl(teamId,clientAccountId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullSetClientAccountOwnerRequest,)
  }
);}



export type postApiTeamsTeamIdCrmContactsImportSingleResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmContactsImportSingleResponse401 = {
  data: PostApiTeamsTeamIdCrmContactsImportSingle401
  status: 401
}

export type postApiTeamsTeamIdCrmContactsImportSingleResponse402 = {
  data: PostApiTeamsTeamIdCrmContactsImportSingle402
  status: 402
}

export type postApiTeamsTeamIdCrmContactsImportSingleResponseSuccess = (postApiTeamsTeamIdCrmContactsImportSingleResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmContactsImportSingleResponseError = (postApiTeamsTeamIdCrmContactsImportSingleResponse401 | postApiTeamsTeamIdCrmContactsImportSingleResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmContactsImportSingleResponse = (postApiTeamsTeamIdCrmContactsImportSingleResponseSuccess | postApiTeamsTeamIdCrmContactsImportSingleResponseError)

export const getPostApiTeamsTeamIdCrmContactsImportSingleUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/crm/contacts/import-single`
}

export const postApiTeamsTeamIdCrmContactsImportSingle = async (teamId: string,
    nullSingleContactImportRequest: null | SingleContactImportRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmContactsImportSingleResponse> => {

  return fetcher<postApiTeamsTeamIdCrmContactsImportSingleResponse>(getPostApiTeamsTeamIdCrmContactsImportSingleUrl(teamId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullSingleContactImportRequest,)
  }
);}



export type deleteApiTeamsTeamIdCrmPartiesPartyIdRolesRoleCodeResponse200 = {
  data: void
  status: 200
}

export type deleteApiTeamsTeamIdCrmPartiesPartyIdRolesRoleCodeResponse401 = {
  data: DeleteApiTeamsTeamIdCrmPartiesPartyIdRolesRoleCode401
  status: 401
}

export type deleteApiTeamsTeamIdCrmPartiesPartyIdRolesRoleCodeResponse402 = {
  data: DeleteApiTeamsTeamIdCrmPartiesPartyIdRolesRoleCode402
  status: 402
}

export type deleteApiTeamsTeamIdCrmPartiesPartyIdRolesRoleCodeResponseSuccess = (deleteApiTeamsTeamIdCrmPartiesPartyIdRolesRoleCodeResponse200) & {
  headers: Headers;
};
export type deleteApiTeamsTeamIdCrmPartiesPartyIdRolesRoleCodeResponseError = (deleteApiTeamsTeamIdCrmPartiesPartyIdRolesRoleCodeResponse401 | deleteApiTeamsTeamIdCrmPartiesPartyIdRolesRoleCodeResponse402) & {
  headers: Headers;
};

export type deleteApiTeamsTeamIdCrmPartiesPartyIdRolesRoleCodeResponse = (deleteApiTeamsTeamIdCrmPartiesPartyIdRolesRoleCodeResponseSuccess | deleteApiTeamsTeamIdCrmPartiesPartyIdRolesRoleCodeResponseError)

export const getDeleteApiTeamsTeamIdCrmPartiesPartyIdRolesRoleCodeUrl = (teamId: string,
    partyId: string,
    roleCode: string,) => {




  return `/api/teams/${teamId}/crm/parties/${partyId}/roles/${roleCode}`
}

export const deleteApiTeamsTeamIdCrmPartiesPartyIdRolesRoleCode = async (teamId: string,
    partyId: string,
    roleCode: string, options?: RequestInit): Promise<deleteApiTeamsTeamIdCrmPartiesPartyIdRolesRoleCodeResponse> => {

  return fetcher<deleteApiTeamsTeamIdCrmPartiesPartyIdRolesRoleCodeResponse>(getDeleteApiTeamsTeamIdCrmPartiesPartyIdRolesRoleCodeUrl(teamId,partyId,roleCode),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type putApiTeamsTeamIdCrmPartiesPartyIdCommIdResponse200 = {
  data: void
  status: 200
}

export type putApiTeamsTeamIdCrmPartiesPartyIdCommIdResponse401 = {
  data: PutApiTeamsTeamIdCrmPartiesPartyIdCommId401
  status: 401
}

export type putApiTeamsTeamIdCrmPartiesPartyIdCommIdResponse402 = {
  data: PutApiTeamsTeamIdCrmPartiesPartyIdCommId402
  status: 402
}

export type putApiTeamsTeamIdCrmPartiesPartyIdCommIdResponseSuccess = (putApiTeamsTeamIdCrmPartiesPartyIdCommIdResponse200) & {
  headers: Headers;
};
export type putApiTeamsTeamIdCrmPartiesPartyIdCommIdResponseError = (putApiTeamsTeamIdCrmPartiesPartyIdCommIdResponse401 | putApiTeamsTeamIdCrmPartiesPartyIdCommIdResponse402) & {
  headers: Headers;
};

export type putApiTeamsTeamIdCrmPartiesPartyIdCommIdResponse = (putApiTeamsTeamIdCrmPartiesPartyIdCommIdResponseSuccess | putApiTeamsTeamIdCrmPartiesPartyIdCommIdResponseError)

export const getPutApiTeamsTeamIdCrmPartiesPartyIdCommIdUrl = (teamId: string,
    partyId: string,
    id: string,) => {




  return `/api/teams/${teamId}/crm/parties/${partyId}/comm/${id}`
}

export const putApiTeamsTeamIdCrmPartiesPartyIdCommId = async (teamId: string,
    partyId: string,
    id: string,
    upsertCommRequest: UpsertCommRequest, options?: RequestInit): Promise<putApiTeamsTeamIdCrmPartiesPartyIdCommIdResponse> => {

  return fetcher<putApiTeamsTeamIdCrmPartiesPartyIdCommIdResponse>(getPutApiTeamsTeamIdCrmPartiesPartyIdCommIdUrl(teamId,partyId,id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upsertCommRequest,)
  }
);}



export type deleteApiTeamsTeamIdCrmPartiesPartyIdCommIdResponse200 = {
  data: void
  status: 200
}

export type deleteApiTeamsTeamIdCrmPartiesPartyIdCommIdResponse401 = {
  data: DeleteApiTeamsTeamIdCrmPartiesPartyIdCommId401
  status: 401
}

export type deleteApiTeamsTeamIdCrmPartiesPartyIdCommIdResponse402 = {
  data: DeleteApiTeamsTeamIdCrmPartiesPartyIdCommId402
  status: 402
}

export type deleteApiTeamsTeamIdCrmPartiesPartyIdCommIdResponseSuccess = (deleteApiTeamsTeamIdCrmPartiesPartyIdCommIdResponse200) & {
  headers: Headers;
};
export type deleteApiTeamsTeamIdCrmPartiesPartyIdCommIdResponseError = (deleteApiTeamsTeamIdCrmPartiesPartyIdCommIdResponse401 | deleteApiTeamsTeamIdCrmPartiesPartyIdCommIdResponse402) & {
  headers: Headers;
};

export type deleteApiTeamsTeamIdCrmPartiesPartyIdCommIdResponse = (deleteApiTeamsTeamIdCrmPartiesPartyIdCommIdResponseSuccess | deleteApiTeamsTeamIdCrmPartiesPartyIdCommIdResponseError)

export const getDeleteApiTeamsTeamIdCrmPartiesPartyIdCommIdUrl = (teamId: string,
    partyId: string,
    id: string,) => {




  return `/api/teams/${teamId}/crm/parties/${partyId}/comm/${id}`
}

export const deleteApiTeamsTeamIdCrmPartiesPartyIdCommId = async (teamId: string,
    partyId: string,
    id: string, options?: RequestInit): Promise<deleteApiTeamsTeamIdCrmPartiesPartyIdCommIdResponse> => {

  return fetcher<deleteApiTeamsTeamIdCrmPartiesPartyIdCommIdResponse>(getDeleteApiTeamsTeamIdCrmPartiesPartyIdCommIdUrl(teamId,partyId,id),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type putApiTeamsTeamIdCrmPartiesPartyIdAddressesAddressIdResponse200 = {
  data: void
  status: 200
}

export type putApiTeamsTeamIdCrmPartiesPartyIdAddressesAddressIdResponse401 = {
  data: PutApiTeamsTeamIdCrmPartiesPartyIdAddressesAddressId401
  status: 401
}

export type putApiTeamsTeamIdCrmPartiesPartyIdAddressesAddressIdResponse402 = {
  data: PutApiTeamsTeamIdCrmPartiesPartyIdAddressesAddressId402
  status: 402
}

export type putApiTeamsTeamIdCrmPartiesPartyIdAddressesAddressIdResponseSuccess = (putApiTeamsTeamIdCrmPartiesPartyIdAddressesAddressIdResponse200) & {
  headers: Headers;
};
export type putApiTeamsTeamIdCrmPartiesPartyIdAddressesAddressIdResponseError = (putApiTeamsTeamIdCrmPartiesPartyIdAddressesAddressIdResponse401 | putApiTeamsTeamIdCrmPartiesPartyIdAddressesAddressIdResponse402) & {
  headers: Headers;
};

export type putApiTeamsTeamIdCrmPartiesPartyIdAddressesAddressIdResponse = (putApiTeamsTeamIdCrmPartiesPartyIdAddressesAddressIdResponseSuccess | putApiTeamsTeamIdCrmPartiesPartyIdAddressesAddressIdResponseError)

export const getPutApiTeamsTeamIdCrmPartiesPartyIdAddressesAddressIdUrl = (teamId: string,
    partyId: string,
    addressId: string,) => {




  return `/api/teams/${teamId}/crm/parties/${partyId}/addresses/${addressId}`
}

export const putApiTeamsTeamIdCrmPartiesPartyIdAddressesAddressId = async (teamId: string,
    partyId: string,
    addressId: string,
    upsertAddressRequest: UpsertAddressRequest, options?: RequestInit): Promise<putApiTeamsTeamIdCrmPartiesPartyIdAddressesAddressIdResponse> => {

  return fetcher<putApiTeamsTeamIdCrmPartiesPartyIdAddressesAddressIdResponse>(getPutApiTeamsTeamIdCrmPartiesPartyIdAddressesAddressIdUrl(teamId,partyId,addressId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upsertAddressRequest,)
  }
);}



export type deleteApiTeamsTeamIdCrmPartiesPartyIdAddressesAddressIdResponse200 = {
  data: void
  status: 200
}

export type deleteApiTeamsTeamIdCrmPartiesPartyIdAddressesAddressIdResponse401 = {
  data: DeleteApiTeamsTeamIdCrmPartiesPartyIdAddressesAddressId401
  status: 401
}

export type deleteApiTeamsTeamIdCrmPartiesPartyIdAddressesAddressIdResponse402 = {
  data: DeleteApiTeamsTeamIdCrmPartiesPartyIdAddressesAddressId402
  status: 402
}

export type deleteApiTeamsTeamIdCrmPartiesPartyIdAddressesAddressIdResponseSuccess = (deleteApiTeamsTeamIdCrmPartiesPartyIdAddressesAddressIdResponse200) & {
  headers: Headers;
};
export type deleteApiTeamsTeamIdCrmPartiesPartyIdAddressesAddressIdResponseError = (deleteApiTeamsTeamIdCrmPartiesPartyIdAddressesAddressIdResponse401 | deleteApiTeamsTeamIdCrmPartiesPartyIdAddressesAddressIdResponse402) & {
  headers: Headers;
};

export type deleteApiTeamsTeamIdCrmPartiesPartyIdAddressesAddressIdResponse = (deleteApiTeamsTeamIdCrmPartiesPartyIdAddressesAddressIdResponseSuccess | deleteApiTeamsTeamIdCrmPartiesPartyIdAddressesAddressIdResponseError)

export const getDeleteApiTeamsTeamIdCrmPartiesPartyIdAddressesAddressIdUrl = (teamId: string,
    partyId: string,
    addressId: string,) => {




  return `/api/teams/${teamId}/crm/parties/${partyId}/addresses/${addressId}`
}

export const deleteApiTeamsTeamIdCrmPartiesPartyIdAddressesAddressId = async (teamId: string,
    partyId: string,
    addressId: string, options?: RequestInit): Promise<deleteApiTeamsTeamIdCrmPartiesPartyIdAddressesAddressIdResponse> => {

  return fetcher<deleteApiTeamsTeamIdCrmPartiesPartyIdAddressesAddressIdResponse>(getDeleteApiTeamsTeamIdCrmPartiesPartyIdAddressesAddressIdUrl(teamId,partyId,addressId),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type postApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsContactPartyIdRoleLabelPrimaryResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsContactPartyIdRoleLabelPrimaryResponse401 = {
  data: PostApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsContactPartyIdRoleLabelPrimary401
  status: 401
}

export type postApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsContactPartyIdRoleLabelPrimaryResponse402 = {
  data: PostApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsContactPartyIdRoleLabelPrimary402
  status: 402
}

export type postApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsContactPartyIdRoleLabelPrimaryResponseSuccess = (postApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsContactPartyIdRoleLabelPrimaryResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsContactPartyIdRoleLabelPrimaryResponseError = (postApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsContactPartyIdRoleLabelPrimaryResponse401 | postApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsContactPartyIdRoleLabelPrimaryResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsContactPartyIdRoleLabelPrimaryResponse = (postApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsContactPartyIdRoleLabelPrimaryResponseSuccess | postApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsContactPartyIdRoleLabelPrimaryResponseError)

export const getPostApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsContactPartyIdRoleLabelPrimaryUrl = (teamId: string,
    clientAccountId: string,
    contactPartyId: string,
    roleLabel: string,) => {




  return `/api/teams/${teamId}/crm/client-accounts/${clientAccountId}/contacts/${contactPartyId}/${roleLabel}/primary`
}

export const postApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsContactPartyIdRoleLabelPrimary = async (teamId: string,
    clientAccountId: string,
    contactPartyId: string,
    roleLabel: string, options?: RequestInit): Promise<postApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsContactPartyIdRoleLabelPrimaryResponse> => {

  return fetcher<postApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsContactPartyIdRoleLabelPrimaryResponse>(getPostApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsContactPartyIdRoleLabelPrimaryUrl(teamId,clientAccountId,contactPartyId,roleLabel),
  {
    ...options,
    method: 'POST'


  }
);}



export type deleteApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsContactPartyIdRoleLabelResponse200 = {
  data: void
  status: 200
}

export type deleteApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsContactPartyIdRoleLabelResponse401 = {
  data: DeleteApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsContactPartyIdRoleLabel401
  status: 401
}

export type deleteApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsContactPartyIdRoleLabelResponse402 = {
  data: DeleteApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsContactPartyIdRoleLabel402
  status: 402
}

export type deleteApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsContactPartyIdRoleLabelResponseSuccess = (deleteApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsContactPartyIdRoleLabelResponse200) & {
  headers: Headers;
};
export type deleteApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsContactPartyIdRoleLabelResponseError = (deleteApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsContactPartyIdRoleLabelResponse401 | deleteApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsContactPartyIdRoleLabelResponse402) & {
  headers: Headers;
};

export type deleteApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsContactPartyIdRoleLabelResponse = (deleteApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsContactPartyIdRoleLabelResponseSuccess | deleteApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsContactPartyIdRoleLabelResponseError)

export const getDeleteApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsContactPartyIdRoleLabelUrl = (teamId: string,
    clientAccountId: string,
    contactPartyId: string,
    roleLabel: string,) => {




  return `/api/teams/${teamId}/crm/client-accounts/${clientAccountId}/contacts/${contactPartyId}/${roleLabel}`
}

export const deleteApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsContactPartyIdRoleLabel = async (teamId: string,
    clientAccountId: string,
    contactPartyId: string,
    roleLabel: string, options?: RequestInit): Promise<deleteApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsContactPartyIdRoleLabelResponse> => {

  return fetcher<deleteApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsContactPartyIdRoleLabelResponse>(getDeleteApiTeamsTeamIdCrmClientAccountsClientAccountIdContactsContactPartyIdRoleLabelUrl(teamId,clientAccountId,contactPartyId,roleLabel),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type getApiTeamsTeamIdCrmPoliciesPolicyIdTermsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmPoliciesPolicyIdTermsResponse401 = {
  data: GetApiTeamsTeamIdCrmPoliciesPolicyIdTerms401
  status: 401
}

export type getApiTeamsTeamIdCrmPoliciesPolicyIdTermsResponseSuccess = (getApiTeamsTeamIdCrmPoliciesPolicyIdTermsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmPoliciesPolicyIdTermsResponseError = (getApiTeamsTeamIdCrmPoliciesPolicyIdTermsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmPoliciesPolicyIdTermsResponse = (getApiTeamsTeamIdCrmPoliciesPolicyIdTermsResponseSuccess | getApiTeamsTeamIdCrmPoliciesPolicyIdTermsResponseError)

export const getGetApiTeamsTeamIdCrmPoliciesPolicyIdTermsUrl = (teamId: string,
    policyId: string,
    params?: GetApiTeamsTeamIdCrmPoliciesPolicyIdTermsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/crm/policies/${policyId}/terms?${stringifiedParams}` : `/api/teams/${teamId}/crm/policies/${policyId}/terms`
}

export const getApiTeamsTeamIdCrmPoliciesPolicyIdTerms = async (teamId: string,
    policyId: string,
    params?: GetApiTeamsTeamIdCrmPoliciesPolicyIdTermsParams, options?: RequestInit): Promise<getApiTeamsTeamIdCrmPoliciesPolicyIdTermsResponse> => {

  return fetcher<getApiTeamsTeamIdCrmPoliciesPolicyIdTermsResponse>(getGetApiTeamsTeamIdCrmPoliciesPolicyIdTermsUrl(teamId,policyId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdCrmPoliciesPolicyIdCurrentTermResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmPoliciesPolicyIdCurrentTermResponse401 = {
  data: GetApiTeamsTeamIdCrmPoliciesPolicyIdCurrentTerm401
  status: 401
}

export type getApiTeamsTeamIdCrmPoliciesPolicyIdCurrentTermResponseSuccess = (getApiTeamsTeamIdCrmPoliciesPolicyIdCurrentTermResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmPoliciesPolicyIdCurrentTermResponseError = (getApiTeamsTeamIdCrmPoliciesPolicyIdCurrentTermResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmPoliciesPolicyIdCurrentTermResponse = (getApiTeamsTeamIdCrmPoliciesPolicyIdCurrentTermResponseSuccess | getApiTeamsTeamIdCrmPoliciesPolicyIdCurrentTermResponseError)

export const getGetApiTeamsTeamIdCrmPoliciesPolicyIdCurrentTermUrl = (teamId: string,
    policyId: string,) => {




  return `/api/teams/${teamId}/crm/policies/${policyId}/current-term`
}

export const getApiTeamsTeamIdCrmPoliciesPolicyIdCurrentTerm = async (teamId: string,
    policyId: string, options?: RequestInit): Promise<getApiTeamsTeamIdCrmPoliciesPolicyIdCurrentTermResponse> => {

  return fetcher<getApiTeamsTeamIdCrmPoliciesPolicyIdCurrentTermResponse>(getGetApiTeamsTeamIdCrmPoliciesPolicyIdCurrentTermUrl(teamId,policyId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdCrmPoliciesPolicyIdChangeLogResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmPoliciesPolicyIdChangeLogResponse401 = {
  data: GetApiTeamsTeamIdCrmPoliciesPolicyIdChangeLog401
  status: 401
}

export type getApiTeamsTeamIdCrmPoliciesPolicyIdChangeLogResponseSuccess = (getApiTeamsTeamIdCrmPoliciesPolicyIdChangeLogResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmPoliciesPolicyIdChangeLogResponseError = (getApiTeamsTeamIdCrmPoliciesPolicyIdChangeLogResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmPoliciesPolicyIdChangeLogResponse = (getApiTeamsTeamIdCrmPoliciesPolicyIdChangeLogResponseSuccess | getApiTeamsTeamIdCrmPoliciesPolicyIdChangeLogResponseError)

export const getGetApiTeamsTeamIdCrmPoliciesPolicyIdChangeLogUrl = (teamId: string,
    policyId: string,
    params?: GetApiTeamsTeamIdCrmPoliciesPolicyIdChangeLogParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/crm/policies/${policyId}/change-log?${stringifiedParams}` : `/api/teams/${teamId}/crm/policies/${policyId}/change-log`
}

export const getApiTeamsTeamIdCrmPoliciesPolicyIdChangeLog = async (teamId: string,
    policyId: string,
    params?: GetApiTeamsTeamIdCrmPoliciesPolicyIdChangeLogParams, options?: RequestInit): Promise<getApiTeamsTeamIdCrmPoliciesPolicyIdChangeLogResponse> => {

  return fetcher<getApiTeamsTeamIdCrmPoliciesPolicyIdChangeLogResponse>(getGetApiTeamsTeamIdCrmPoliciesPolicyIdChangeLogUrl(teamId,policyId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdCrmPoliciesPolicyIdTransactionsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmPoliciesPolicyIdTransactionsResponse401 = {
  data: GetApiTeamsTeamIdCrmPoliciesPolicyIdTransactions401
  status: 401
}

export type getApiTeamsTeamIdCrmPoliciesPolicyIdTransactionsResponseSuccess = (getApiTeamsTeamIdCrmPoliciesPolicyIdTransactionsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmPoliciesPolicyIdTransactionsResponseError = (getApiTeamsTeamIdCrmPoliciesPolicyIdTransactionsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmPoliciesPolicyIdTransactionsResponse = (getApiTeamsTeamIdCrmPoliciesPolicyIdTransactionsResponseSuccess | getApiTeamsTeamIdCrmPoliciesPolicyIdTransactionsResponseError)

export const getGetApiTeamsTeamIdCrmPoliciesPolicyIdTransactionsUrl = (teamId: string,
    policyId: string,
    params?: GetApiTeamsTeamIdCrmPoliciesPolicyIdTransactionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/crm/policies/${policyId}/transactions?${stringifiedParams}` : `/api/teams/${teamId}/crm/policies/${policyId}/transactions`
}

export const getApiTeamsTeamIdCrmPoliciesPolicyIdTransactions = async (teamId: string,
    policyId: string,
    params?: GetApiTeamsTeamIdCrmPoliciesPolicyIdTransactionsParams, options?: RequestInit): Promise<getApiTeamsTeamIdCrmPoliciesPolicyIdTransactionsResponse> => {

  return fetcher<getApiTeamsTeamIdCrmPoliciesPolicyIdTransactionsResponse>(getGetApiTeamsTeamIdCrmPoliciesPolicyIdTransactionsUrl(teamId,policyId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdCrmPoliciesPolicyIdTransactionsResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmPoliciesPolicyIdTransactionsResponse401 = {
  data: PostApiTeamsTeamIdCrmPoliciesPolicyIdTransactions401
  status: 401
}

export type postApiTeamsTeamIdCrmPoliciesPolicyIdTransactionsResponse402 = {
  data: PostApiTeamsTeamIdCrmPoliciesPolicyIdTransactions402
  status: 402
}

export type postApiTeamsTeamIdCrmPoliciesPolicyIdTransactionsResponseSuccess = (postApiTeamsTeamIdCrmPoliciesPolicyIdTransactionsResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmPoliciesPolicyIdTransactionsResponseError = (postApiTeamsTeamIdCrmPoliciesPolicyIdTransactionsResponse401 | postApiTeamsTeamIdCrmPoliciesPolicyIdTransactionsResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmPoliciesPolicyIdTransactionsResponse = (postApiTeamsTeamIdCrmPoliciesPolicyIdTransactionsResponseSuccess | postApiTeamsTeamIdCrmPoliciesPolicyIdTransactionsResponseError)

export const getPostApiTeamsTeamIdCrmPoliciesPolicyIdTransactionsUrl = (teamId: string,
    policyId: string,) => {




  return `/api/teams/${teamId}/crm/policies/${policyId}/transactions`
}

export const postApiTeamsTeamIdCrmPoliciesPolicyIdTransactions = async (teamId: string,
    policyId: string,
    upsertPolicyTransactionRequest: UpsertPolicyTransactionRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmPoliciesPolicyIdTransactionsResponse> => {

  return fetcher<postApiTeamsTeamIdCrmPoliciesPolicyIdTransactionsResponse>(getPostApiTeamsTeamIdCrmPoliciesPolicyIdTransactionsUrl(teamId,policyId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upsertPolicyTransactionRequest,)
  }
);}



export type getApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsResponse401 = {
  data: GetApiTeamsTeamIdCrmPoliciesPolicyIdParticipants401
  status: 401
}

export type getApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsResponseSuccess = (getApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsResponseError = (getApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsResponse = (getApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsResponseSuccess | getApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsResponseError)

export const getGetApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsUrl = (teamId: string,
    policyId: string,) => {




  return `/api/teams/${teamId}/crm/policies/${policyId}/participants`
}

export const getApiTeamsTeamIdCrmPoliciesPolicyIdParticipants = async (teamId: string,
    policyId: string, options?: RequestInit): Promise<getApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsResponse> => {

  return fetcher<getApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsResponse>(getGetApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsUrl(teamId,policyId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsResponse401 = {
  data: PostApiTeamsTeamIdCrmPoliciesPolicyIdParticipants401
  status: 401
}

export type postApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsResponse402 = {
  data: PostApiTeamsTeamIdCrmPoliciesPolicyIdParticipants402
  status: 402
}

export type postApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsResponseSuccess = (postApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsResponseError = (postApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsResponse401 | postApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsResponse = (postApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsResponseSuccess | postApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsResponseError)

export const getPostApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsUrl = (teamId: string,
    policyId: string,) => {




  return `/api/teams/${teamId}/crm/policies/${policyId}/participants`
}

export const postApiTeamsTeamIdCrmPoliciesPolicyIdParticipants = async (teamId: string,
    policyId: string,
    upsertPolicyParticipantRequest: UpsertPolicyParticipantRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsResponse> => {

  return fetcher<postApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsResponse>(getPostApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsUrl(teamId,policyId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upsertPolicyParticipantRequest,)
  }
);}



export type deleteApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsPolicyParticipantIdResponse200 = {
  data: void
  status: 200
}

export type deleteApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsPolicyParticipantIdResponse401 = {
  data: DeleteApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsPolicyParticipantId401
  status: 401
}

export type deleteApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsPolicyParticipantIdResponse402 = {
  data: DeleteApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsPolicyParticipantId402
  status: 402
}

export type deleteApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsPolicyParticipantIdResponseSuccess = (deleteApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsPolicyParticipantIdResponse200) & {
  headers: Headers;
};
export type deleteApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsPolicyParticipantIdResponseError = (deleteApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsPolicyParticipantIdResponse401 | deleteApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsPolicyParticipantIdResponse402) & {
  headers: Headers;
};

export type deleteApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsPolicyParticipantIdResponse = (deleteApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsPolicyParticipantIdResponseSuccess | deleteApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsPolicyParticipantIdResponseError)

export const getDeleteApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsPolicyParticipantIdUrl = (teamId: string,
    policyId: string,
    policyParticipantId: string,) => {




  return `/api/teams/${teamId}/crm/policies/${policyId}/participants/${policyParticipantId}`
}

export const deleteApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsPolicyParticipantId = async (teamId: string,
    policyId: string,
    policyParticipantId: string, options?: RequestInit): Promise<deleteApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsPolicyParticipantIdResponse> => {

  return fetcher<deleteApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsPolicyParticipantIdResponse>(getDeleteApiTeamsTeamIdCrmPoliciesPolicyIdParticipantsPolicyParticipantIdUrl(teamId,policyId,policyParticipantId),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type getApiTeamsTeamIdCrmPoliciesPolicyIdCoveragesResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmPoliciesPolicyIdCoveragesResponse401 = {
  data: GetApiTeamsTeamIdCrmPoliciesPolicyIdCoverages401
  status: 401
}

export type getApiTeamsTeamIdCrmPoliciesPolicyIdCoveragesResponseSuccess = (getApiTeamsTeamIdCrmPoliciesPolicyIdCoveragesResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmPoliciesPolicyIdCoveragesResponseError = (getApiTeamsTeamIdCrmPoliciesPolicyIdCoveragesResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmPoliciesPolicyIdCoveragesResponse = (getApiTeamsTeamIdCrmPoliciesPolicyIdCoveragesResponseSuccess | getApiTeamsTeamIdCrmPoliciesPolicyIdCoveragesResponseError)

export const getGetApiTeamsTeamIdCrmPoliciesPolicyIdCoveragesUrl = (teamId: string,
    policyId: string,) => {




  return `/api/teams/${teamId}/crm/policies/${policyId}/coverages`
}

export const getApiTeamsTeamIdCrmPoliciesPolicyIdCoverages = async (teamId: string,
    policyId: string, options?: RequestInit): Promise<getApiTeamsTeamIdCrmPoliciesPolicyIdCoveragesResponse> => {

  return fetcher<getApiTeamsTeamIdCrmPoliciesPolicyIdCoveragesResponse>(getGetApiTeamsTeamIdCrmPoliciesPolicyIdCoveragesUrl(teamId,policyId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdCrmPoliciesPolicyIdCoveragesResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmPoliciesPolicyIdCoveragesResponse401 = {
  data: PostApiTeamsTeamIdCrmPoliciesPolicyIdCoverages401
  status: 401
}

export type postApiTeamsTeamIdCrmPoliciesPolicyIdCoveragesResponse402 = {
  data: PostApiTeamsTeamIdCrmPoliciesPolicyIdCoverages402
  status: 402
}

export type postApiTeamsTeamIdCrmPoliciesPolicyIdCoveragesResponseSuccess = (postApiTeamsTeamIdCrmPoliciesPolicyIdCoveragesResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmPoliciesPolicyIdCoveragesResponseError = (postApiTeamsTeamIdCrmPoliciesPolicyIdCoveragesResponse401 | postApiTeamsTeamIdCrmPoliciesPolicyIdCoveragesResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmPoliciesPolicyIdCoveragesResponse = (postApiTeamsTeamIdCrmPoliciesPolicyIdCoveragesResponseSuccess | postApiTeamsTeamIdCrmPoliciesPolicyIdCoveragesResponseError)

export const getPostApiTeamsTeamIdCrmPoliciesPolicyIdCoveragesUrl = (teamId: string,
    policyId: string,) => {




  return `/api/teams/${teamId}/crm/policies/${policyId}/coverages`
}

export const postApiTeamsTeamIdCrmPoliciesPolicyIdCoverages = async (teamId: string,
    policyId: string,
    upsertCoverageRequest: UpsertCoverageRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmPoliciesPolicyIdCoveragesResponse> => {

  return fetcher<postApiTeamsTeamIdCrmPoliciesPolicyIdCoveragesResponse>(getPostApiTeamsTeamIdCrmPoliciesPolicyIdCoveragesUrl(teamId,policyId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upsertCoverageRequest,)
  }
);}



export type putApiTeamsTeamIdCrmCoveragesPolicyCoverageIdResponse200 = {
  data: void
  status: 200
}

export type putApiTeamsTeamIdCrmCoveragesPolicyCoverageIdResponse401 = {
  data: PutApiTeamsTeamIdCrmCoveragesPolicyCoverageId401
  status: 401
}

export type putApiTeamsTeamIdCrmCoveragesPolicyCoverageIdResponse402 = {
  data: PutApiTeamsTeamIdCrmCoveragesPolicyCoverageId402
  status: 402
}

export type putApiTeamsTeamIdCrmCoveragesPolicyCoverageIdResponseSuccess = (putApiTeamsTeamIdCrmCoveragesPolicyCoverageIdResponse200) & {
  headers: Headers;
};
export type putApiTeamsTeamIdCrmCoveragesPolicyCoverageIdResponseError = (putApiTeamsTeamIdCrmCoveragesPolicyCoverageIdResponse401 | putApiTeamsTeamIdCrmCoveragesPolicyCoverageIdResponse402) & {
  headers: Headers;
};

export type putApiTeamsTeamIdCrmCoveragesPolicyCoverageIdResponse = (putApiTeamsTeamIdCrmCoveragesPolicyCoverageIdResponseSuccess | putApiTeamsTeamIdCrmCoveragesPolicyCoverageIdResponseError)

export const getPutApiTeamsTeamIdCrmCoveragesPolicyCoverageIdUrl = (teamId: string,
    policyCoverageId: string,) => {




  return `/api/teams/${teamId}/crm/coverages/${policyCoverageId}`
}

export const putApiTeamsTeamIdCrmCoveragesPolicyCoverageId = async (teamId: string,
    policyCoverageId: string,
    upsertCoverageRequest: UpsertCoverageRequest, options?: RequestInit): Promise<putApiTeamsTeamIdCrmCoveragesPolicyCoverageIdResponse> => {

  return fetcher<putApiTeamsTeamIdCrmCoveragesPolicyCoverageIdResponse>(getPutApiTeamsTeamIdCrmCoveragesPolicyCoverageIdUrl(teamId,policyCoverageId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upsertCoverageRequest,)
  }
);}



export type postApiTeamsTeamIdCrmCoveragesPolicyCoverageIdLimitsResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmCoveragesPolicyCoverageIdLimitsResponse401 = {
  data: PostApiTeamsTeamIdCrmCoveragesPolicyCoverageIdLimits401
  status: 401
}

export type postApiTeamsTeamIdCrmCoveragesPolicyCoverageIdLimitsResponse402 = {
  data: PostApiTeamsTeamIdCrmCoveragesPolicyCoverageIdLimits402
  status: 402
}

export type postApiTeamsTeamIdCrmCoveragesPolicyCoverageIdLimitsResponseSuccess = (postApiTeamsTeamIdCrmCoveragesPolicyCoverageIdLimitsResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmCoveragesPolicyCoverageIdLimitsResponseError = (postApiTeamsTeamIdCrmCoveragesPolicyCoverageIdLimitsResponse401 | postApiTeamsTeamIdCrmCoveragesPolicyCoverageIdLimitsResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmCoveragesPolicyCoverageIdLimitsResponse = (postApiTeamsTeamIdCrmCoveragesPolicyCoverageIdLimitsResponseSuccess | postApiTeamsTeamIdCrmCoveragesPolicyCoverageIdLimitsResponseError)

export const getPostApiTeamsTeamIdCrmCoveragesPolicyCoverageIdLimitsUrl = (teamId: string,
    policyCoverageId: string,) => {




  return `/api/teams/${teamId}/crm/coverages/${policyCoverageId}/limits`
}

export const postApiTeamsTeamIdCrmCoveragesPolicyCoverageIdLimits = async (teamId: string,
    policyCoverageId: string,
    upsertCoverageLimitRequest: UpsertCoverageLimitRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmCoveragesPolicyCoverageIdLimitsResponse> => {

  return fetcher<postApiTeamsTeamIdCrmCoveragesPolicyCoverageIdLimitsResponse>(getPostApiTeamsTeamIdCrmCoveragesPolicyCoverageIdLimitsUrl(teamId,policyCoverageId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upsertCoverageLimitRequest,)
  }
);}



export type putApiTeamsTeamIdCrmLimitsPolicyCoverageLimitIdResponse200 = {
  data: void
  status: 200
}

export type putApiTeamsTeamIdCrmLimitsPolicyCoverageLimitIdResponse401 = {
  data: PutApiTeamsTeamIdCrmLimitsPolicyCoverageLimitId401
  status: 401
}

export type putApiTeamsTeamIdCrmLimitsPolicyCoverageLimitIdResponse402 = {
  data: PutApiTeamsTeamIdCrmLimitsPolicyCoverageLimitId402
  status: 402
}

export type putApiTeamsTeamIdCrmLimitsPolicyCoverageLimitIdResponseSuccess = (putApiTeamsTeamIdCrmLimitsPolicyCoverageLimitIdResponse200) & {
  headers: Headers;
};
export type putApiTeamsTeamIdCrmLimitsPolicyCoverageLimitIdResponseError = (putApiTeamsTeamIdCrmLimitsPolicyCoverageLimitIdResponse401 | putApiTeamsTeamIdCrmLimitsPolicyCoverageLimitIdResponse402) & {
  headers: Headers;
};

export type putApiTeamsTeamIdCrmLimitsPolicyCoverageLimitIdResponse = (putApiTeamsTeamIdCrmLimitsPolicyCoverageLimitIdResponseSuccess | putApiTeamsTeamIdCrmLimitsPolicyCoverageLimitIdResponseError)

export const getPutApiTeamsTeamIdCrmLimitsPolicyCoverageLimitIdUrl = (teamId: string,
    policyCoverageLimitId: string,) => {




  return `/api/teams/${teamId}/crm/limits/${policyCoverageLimitId}`
}

export const putApiTeamsTeamIdCrmLimitsPolicyCoverageLimitId = async (teamId: string,
    policyCoverageLimitId: string,
    upsertCoverageLimitRequest: UpsertCoverageLimitRequest, options?: RequestInit): Promise<putApiTeamsTeamIdCrmLimitsPolicyCoverageLimitIdResponse> => {

  return fetcher<putApiTeamsTeamIdCrmLimitsPolicyCoverageLimitIdResponse>(getPutApiTeamsTeamIdCrmLimitsPolicyCoverageLimitIdUrl(teamId,policyCoverageLimitId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upsertCoverageLimitRequest,)
  }
);}



export type postApiTeamsTeamIdCrmCoveragesPolicyCoverageIdDeductiblesResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmCoveragesPolicyCoverageIdDeductiblesResponse401 = {
  data: PostApiTeamsTeamIdCrmCoveragesPolicyCoverageIdDeductibles401
  status: 401
}

export type postApiTeamsTeamIdCrmCoveragesPolicyCoverageIdDeductiblesResponse402 = {
  data: PostApiTeamsTeamIdCrmCoveragesPolicyCoverageIdDeductibles402
  status: 402
}

export type postApiTeamsTeamIdCrmCoveragesPolicyCoverageIdDeductiblesResponseSuccess = (postApiTeamsTeamIdCrmCoveragesPolicyCoverageIdDeductiblesResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmCoveragesPolicyCoverageIdDeductiblesResponseError = (postApiTeamsTeamIdCrmCoveragesPolicyCoverageIdDeductiblesResponse401 | postApiTeamsTeamIdCrmCoveragesPolicyCoverageIdDeductiblesResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmCoveragesPolicyCoverageIdDeductiblesResponse = (postApiTeamsTeamIdCrmCoveragesPolicyCoverageIdDeductiblesResponseSuccess | postApiTeamsTeamIdCrmCoveragesPolicyCoverageIdDeductiblesResponseError)

export const getPostApiTeamsTeamIdCrmCoveragesPolicyCoverageIdDeductiblesUrl = (teamId: string,
    policyCoverageId: string,) => {




  return `/api/teams/${teamId}/crm/coverages/${policyCoverageId}/deductibles`
}

export const postApiTeamsTeamIdCrmCoveragesPolicyCoverageIdDeductibles = async (teamId: string,
    policyCoverageId: string,
    upsertCoverageDeductibleRequest: UpsertCoverageDeductibleRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmCoveragesPolicyCoverageIdDeductiblesResponse> => {

  return fetcher<postApiTeamsTeamIdCrmCoveragesPolicyCoverageIdDeductiblesResponse>(getPostApiTeamsTeamIdCrmCoveragesPolicyCoverageIdDeductiblesUrl(teamId,policyCoverageId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upsertCoverageDeductibleRequest,)
  }
);}



export type putApiTeamsTeamIdCrmDeductiblesPolicyCoverageDeductibleIdResponse200 = {
  data: void
  status: 200
}

export type putApiTeamsTeamIdCrmDeductiblesPolicyCoverageDeductibleIdResponse401 = {
  data: PutApiTeamsTeamIdCrmDeductiblesPolicyCoverageDeductibleId401
  status: 401
}

export type putApiTeamsTeamIdCrmDeductiblesPolicyCoverageDeductibleIdResponse402 = {
  data: PutApiTeamsTeamIdCrmDeductiblesPolicyCoverageDeductibleId402
  status: 402
}

export type putApiTeamsTeamIdCrmDeductiblesPolicyCoverageDeductibleIdResponseSuccess = (putApiTeamsTeamIdCrmDeductiblesPolicyCoverageDeductibleIdResponse200) & {
  headers: Headers;
};
export type putApiTeamsTeamIdCrmDeductiblesPolicyCoverageDeductibleIdResponseError = (putApiTeamsTeamIdCrmDeductiblesPolicyCoverageDeductibleIdResponse401 | putApiTeamsTeamIdCrmDeductiblesPolicyCoverageDeductibleIdResponse402) & {
  headers: Headers;
};

export type putApiTeamsTeamIdCrmDeductiblesPolicyCoverageDeductibleIdResponse = (putApiTeamsTeamIdCrmDeductiblesPolicyCoverageDeductibleIdResponseSuccess | putApiTeamsTeamIdCrmDeductiblesPolicyCoverageDeductibleIdResponseError)

export const getPutApiTeamsTeamIdCrmDeductiblesPolicyCoverageDeductibleIdUrl = (teamId: string,
    policyCoverageDeductibleId: string,) => {




  return `/api/teams/${teamId}/crm/deductibles/${policyCoverageDeductibleId}`
}

export const putApiTeamsTeamIdCrmDeductiblesPolicyCoverageDeductibleId = async (teamId: string,
    policyCoverageDeductibleId: string,
    upsertCoverageDeductibleRequest: UpsertCoverageDeductibleRequest, options?: RequestInit): Promise<putApiTeamsTeamIdCrmDeductiblesPolicyCoverageDeductibleIdResponse> => {

  return fetcher<putApiTeamsTeamIdCrmDeductiblesPolicyCoverageDeductibleIdResponse>(getPutApiTeamsTeamIdCrmDeductiblesPolicyCoverageDeductibleIdUrl(teamId,policyCoverageDeductibleId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upsertCoverageDeductibleRequest,)
  }
);}



export type getApiTeamsTeamIdCrmPoliciesPolicyIdFormsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmPoliciesPolicyIdFormsResponse401 = {
  data: GetApiTeamsTeamIdCrmPoliciesPolicyIdForms401
  status: 401
}

export type getApiTeamsTeamIdCrmPoliciesPolicyIdFormsResponseSuccess = (getApiTeamsTeamIdCrmPoliciesPolicyIdFormsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmPoliciesPolicyIdFormsResponseError = (getApiTeamsTeamIdCrmPoliciesPolicyIdFormsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmPoliciesPolicyIdFormsResponse = (getApiTeamsTeamIdCrmPoliciesPolicyIdFormsResponseSuccess | getApiTeamsTeamIdCrmPoliciesPolicyIdFormsResponseError)

export const getGetApiTeamsTeamIdCrmPoliciesPolicyIdFormsUrl = (teamId: string,
    policyId: string,) => {




  return `/api/teams/${teamId}/crm/policies/${policyId}/forms`
}

export const getApiTeamsTeamIdCrmPoliciesPolicyIdForms = async (teamId: string,
    policyId: string, options?: RequestInit): Promise<getApiTeamsTeamIdCrmPoliciesPolicyIdFormsResponse> => {

  return fetcher<getApiTeamsTeamIdCrmPoliciesPolicyIdFormsResponse>(getGetApiTeamsTeamIdCrmPoliciesPolicyIdFormsUrl(teamId,policyId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdCrmPoliciesPolicyIdFormsResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmPoliciesPolicyIdFormsResponse401 = {
  data: PostApiTeamsTeamIdCrmPoliciesPolicyIdForms401
  status: 401
}

export type postApiTeamsTeamIdCrmPoliciesPolicyIdFormsResponse402 = {
  data: PostApiTeamsTeamIdCrmPoliciesPolicyIdForms402
  status: 402
}

export type postApiTeamsTeamIdCrmPoliciesPolicyIdFormsResponseSuccess = (postApiTeamsTeamIdCrmPoliciesPolicyIdFormsResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmPoliciesPolicyIdFormsResponseError = (postApiTeamsTeamIdCrmPoliciesPolicyIdFormsResponse401 | postApiTeamsTeamIdCrmPoliciesPolicyIdFormsResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmPoliciesPolicyIdFormsResponse = (postApiTeamsTeamIdCrmPoliciesPolicyIdFormsResponseSuccess | postApiTeamsTeamIdCrmPoliciesPolicyIdFormsResponseError)

export const getPostApiTeamsTeamIdCrmPoliciesPolicyIdFormsUrl = (teamId: string,
    policyId: string,) => {




  return `/api/teams/${teamId}/crm/policies/${policyId}/forms`
}

export const postApiTeamsTeamIdCrmPoliciesPolicyIdForms = async (teamId: string,
    policyId: string,
    upsertPolicyFormRequest: UpsertPolicyFormRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmPoliciesPolicyIdFormsResponse> => {

  return fetcher<postApiTeamsTeamIdCrmPoliciesPolicyIdFormsResponse>(getPostApiTeamsTeamIdCrmPoliciesPolicyIdFormsUrl(teamId,policyId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upsertPolicyFormRequest,)
  }
);}



export type getApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsResponse401 = {
  data: GetApiTeamsTeamIdCrmPoliciesPolicyIdPremiums401
  status: 401
}

export type getApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsResponseSuccess = (getApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsResponseError = (getApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsResponse = (getApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsResponseSuccess | getApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsResponseError)

export const getGetApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsUrl = (teamId: string,
    policyId: string,
    params?: GetApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/crm/policies/${policyId}/premiums?${stringifiedParams}` : `/api/teams/${teamId}/crm/policies/${policyId}/premiums`
}

export const getApiTeamsTeamIdCrmPoliciesPolicyIdPremiums = async (teamId: string,
    policyId: string,
    params?: GetApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsParams, options?: RequestInit): Promise<getApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsResponse> => {

  return fetcher<getApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsResponse>(getGetApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsUrl(teamId,policyId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsResponse401 = {
  data: PostApiTeamsTeamIdCrmPoliciesPolicyIdPremiums401
  status: 401
}

export type postApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsResponse402 = {
  data: PostApiTeamsTeamIdCrmPoliciesPolicyIdPremiums402
  status: 402
}

export type postApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsResponseSuccess = (postApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsResponseError = (postApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsResponse401 | postApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsResponse = (postApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsResponseSuccess | postApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsResponseError)

export const getPostApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsUrl = (teamId: string,
    policyId: string,) => {




  return `/api/teams/${teamId}/crm/policies/${policyId}/premiums`
}

export const postApiTeamsTeamIdCrmPoliciesPolicyIdPremiums = async (teamId: string,
    policyId: string,
    upsertPolicyPremiumRequest: UpsertPolicyPremiumRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsResponse> => {

  return fetcher<postApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsResponse>(getPostApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsUrl(teamId,policyId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upsertPolicyPremiumRequest,)
  }
);}



export type putApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsPolicyPremiumIdResponse200 = {
  data: void
  status: 200
}

export type putApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsPolicyPremiumIdResponse401 = {
  data: PutApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsPolicyPremiumId401
  status: 401
}

export type putApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsPolicyPremiumIdResponse402 = {
  data: PutApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsPolicyPremiumId402
  status: 402
}

export type putApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsPolicyPremiumIdResponseSuccess = (putApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsPolicyPremiumIdResponse200) & {
  headers: Headers;
};
export type putApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsPolicyPremiumIdResponseError = (putApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsPolicyPremiumIdResponse401 | putApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsPolicyPremiumIdResponse402) & {
  headers: Headers;
};

export type putApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsPolicyPremiumIdResponse = (putApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsPolicyPremiumIdResponseSuccess | putApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsPolicyPremiumIdResponseError)

export const getPutApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsPolicyPremiumIdUrl = (teamId: string,
    policyId: string,
    policyPremiumId: string,) => {




  return `/api/teams/${teamId}/crm/policies/${policyId}/premiums/${policyPremiumId}`
}

export const putApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsPolicyPremiumId = async (teamId: string,
    policyId: string,
    policyPremiumId: string,
    upsertPolicyPremiumRequest: UpsertPolicyPremiumRequest, options?: RequestInit): Promise<putApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsPolicyPremiumIdResponse> => {

  return fetcher<putApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsPolicyPremiumIdResponse>(getPutApiTeamsTeamIdCrmPoliciesPolicyIdPremiumsPolicyPremiumIdUrl(teamId,policyId,policyPremiumId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upsertPolicyPremiumRequest,)
  }
);}



export type getApiTeamsTeamIdCrmPoliciesPolicyIdLocationsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmPoliciesPolicyIdLocationsResponse401 = {
  data: GetApiTeamsTeamIdCrmPoliciesPolicyIdLocations401
  status: 401
}

export type getApiTeamsTeamIdCrmPoliciesPolicyIdLocationsResponseSuccess = (getApiTeamsTeamIdCrmPoliciesPolicyIdLocationsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmPoliciesPolicyIdLocationsResponseError = (getApiTeamsTeamIdCrmPoliciesPolicyIdLocationsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmPoliciesPolicyIdLocationsResponse = (getApiTeamsTeamIdCrmPoliciesPolicyIdLocationsResponseSuccess | getApiTeamsTeamIdCrmPoliciesPolicyIdLocationsResponseError)

export const getGetApiTeamsTeamIdCrmPoliciesPolicyIdLocationsUrl = (teamId: string,
    policyId: string,) => {




  return `/api/teams/${teamId}/crm/policies/${policyId}/locations`
}

export const getApiTeamsTeamIdCrmPoliciesPolicyIdLocations = async (teamId: string,
    policyId: string, options?: RequestInit): Promise<getApiTeamsTeamIdCrmPoliciesPolicyIdLocationsResponse> => {

  return fetcher<getApiTeamsTeamIdCrmPoliciesPolicyIdLocationsResponse>(getGetApiTeamsTeamIdCrmPoliciesPolicyIdLocationsUrl(teamId,policyId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdCrmPoliciesPolicyIdLocationsResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmPoliciesPolicyIdLocationsResponse401 = {
  data: PostApiTeamsTeamIdCrmPoliciesPolicyIdLocations401
  status: 401
}

export type postApiTeamsTeamIdCrmPoliciesPolicyIdLocationsResponse402 = {
  data: PostApiTeamsTeamIdCrmPoliciesPolicyIdLocations402
  status: 402
}

export type postApiTeamsTeamIdCrmPoliciesPolicyIdLocationsResponseSuccess = (postApiTeamsTeamIdCrmPoliciesPolicyIdLocationsResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmPoliciesPolicyIdLocationsResponseError = (postApiTeamsTeamIdCrmPoliciesPolicyIdLocationsResponse401 | postApiTeamsTeamIdCrmPoliciesPolicyIdLocationsResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmPoliciesPolicyIdLocationsResponse = (postApiTeamsTeamIdCrmPoliciesPolicyIdLocationsResponseSuccess | postApiTeamsTeamIdCrmPoliciesPolicyIdLocationsResponseError)

export const getPostApiTeamsTeamIdCrmPoliciesPolicyIdLocationsUrl = (teamId: string,
    policyId: string,) => {




  return `/api/teams/${teamId}/crm/policies/${policyId}/locations`
}

export const postApiTeamsTeamIdCrmPoliciesPolicyIdLocations = async (teamId: string,
    policyId: string,
    upsertPolicyLocationRequest: UpsertPolicyLocationRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmPoliciesPolicyIdLocationsResponse> => {

  return fetcher<postApiTeamsTeamIdCrmPoliciesPolicyIdLocationsResponse>(getPostApiTeamsTeamIdCrmPoliciesPolicyIdLocationsUrl(teamId,policyId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upsertPolicyLocationRequest,)
  }
);}



export type getApiTeamsTeamIdCrmPoliciesPolicyIdEndorsementsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmPoliciesPolicyIdEndorsementsResponse401 = {
  data: GetApiTeamsTeamIdCrmPoliciesPolicyIdEndorsements401
  status: 401
}

export type getApiTeamsTeamIdCrmPoliciesPolicyIdEndorsementsResponseSuccess = (getApiTeamsTeamIdCrmPoliciesPolicyIdEndorsementsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmPoliciesPolicyIdEndorsementsResponseError = (getApiTeamsTeamIdCrmPoliciesPolicyIdEndorsementsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmPoliciesPolicyIdEndorsementsResponse = (getApiTeamsTeamIdCrmPoliciesPolicyIdEndorsementsResponseSuccess | getApiTeamsTeamIdCrmPoliciesPolicyIdEndorsementsResponseError)

export const getGetApiTeamsTeamIdCrmPoliciesPolicyIdEndorsementsUrl = (teamId: string,
    policyId: string,
    params?: GetApiTeamsTeamIdCrmPoliciesPolicyIdEndorsementsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/crm/policies/${policyId}/endorsements?${stringifiedParams}` : `/api/teams/${teamId}/crm/policies/${policyId}/endorsements`
}

export const getApiTeamsTeamIdCrmPoliciesPolicyIdEndorsements = async (teamId: string,
    policyId: string,
    params?: GetApiTeamsTeamIdCrmPoliciesPolicyIdEndorsementsParams, options?: RequestInit): Promise<getApiTeamsTeamIdCrmPoliciesPolicyIdEndorsementsResponse> => {

  return fetcher<getApiTeamsTeamIdCrmPoliciesPolicyIdEndorsementsResponse>(getGetApiTeamsTeamIdCrmPoliciesPolicyIdEndorsementsUrl(teamId,policyId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdCrmPoliciesPolicyIdEndorsementsResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmPoliciesPolicyIdEndorsementsResponse401 = {
  data: PostApiTeamsTeamIdCrmPoliciesPolicyIdEndorsements401
  status: 401
}

export type postApiTeamsTeamIdCrmPoliciesPolicyIdEndorsementsResponse402 = {
  data: PostApiTeamsTeamIdCrmPoliciesPolicyIdEndorsements402
  status: 402
}

export type postApiTeamsTeamIdCrmPoliciesPolicyIdEndorsementsResponseSuccess = (postApiTeamsTeamIdCrmPoliciesPolicyIdEndorsementsResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmPoliciesPolicyIdEndorsementsResponseError = (postApiTeamsTeamIdCrmPoliciesPolicyIdEndorsementsResponse401 | postApiTeamsTeamIdCrmPoliciesPolicyIdEndorsementsResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmPoliciesPolicyIdEndorsementsResponse = (postApiTeamsTeamIdCrmPoliciesPolicyIdEndorsementsResponseSuccess | postApiTeamsTeamIdCrmPoliciesPolicyIdEndorsementsResponseError)

export const getPostApiTeamsTeamIdCrmPoliciesPolicyIdEndorsementsUrl = (teamId: string,
    policyId: string,) => {




  return `/api/teams/${teamId}/crm/policies/${policyId}/endorsements`
}

export const postApiTeamsTeamIdCrmPoliciesPolicyIdEndorsements = async (teamId: string,
    policyId: string,
    upsertEndorsementRequest: UpsertEndorsementRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmPoliciesPolicyIdEndorsementsResponse> => {

  return fetcher<postApiTeamsTeamIdCrmPoliciesPolicyIdEndorsementsResponse>(getPostApiTeamsTeamIdCrmPoliciesPolicyIdEndorsementsUrl(teamId,policyId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upsertEndorsementRequest,)
  }
);}



export type getApiTeamsTeamIdCrmPoliciesPolicyIdCertificatesResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmPoliciesPolicyIdCertificatesResponse401 = {
  data: GetApiTeamsTeamIdCrmPoliciesPolicyIdCertificates401
  status: 401
}

export type getApiTeamsTeamIdCrmPoliciesPolicyIdCertificatesResponseSuccess = (getApiTeamsTeamIdCrmPoliciesPolicyIdCertificatesResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmPoliciesPolicyIdCertificatesResponseError = (getApiTeamsTeamIdCrmPoliciesPolicyIdCertificatesResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmPoliciesPolicyIdCertificatesResponse = (getApiTeamsTeamIdCrmPoliciesPolicyIdCertificatesResponseSuccess | getApiTeamsTeamIdCrmPoliciesPolicyIdCertificatesResponseError)

export const getGetApiTeamsTeamIdCrmPoliciesPolicyIdCertificatesUrl = (teamId: string,
    policyId: string,
    params?: GetApiTeamsTeamIdCrmPoliciesPolicyIdCertificatesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/crm/policies/${policyId}/certificates?${stringifiedParams}` : `/api/teams/${teamId}/crm/policies/${policyId}/certificates`
}

export const getApiTeamsTeamIdCrmPoliciesPolicyIdCertificates = async (teamId: string,
    policyId: string,
    params?: GetApiTeamsTeamIdCrmPoliciesPolicyIdCertificatesParams, options?: RequestInit): Promise<getApiTeamsTeamIdCrmPoliciesPolicyIdCertificatesResponse> => {

  return fetcher<getApiTeamsTeamIdCrmPoliciesPolicyIdCertificatesResponse>(getGetApiTeamsTeamIdCrmPoliciesPolicyIdCertificatesUrl(teamId,policyId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdCrmPoliciesPolicyIdCertificatesReadinessResponse200TextPlain = {
  data: CrmCertificateReadinessPayload
  status: 200
}

export type getApiTeamsTeamIdCrmPoliciesPolicyIdCertificatesReadinessResponse200ApplicationJson = {
  data: CrmCertificateReadinessPayload
  status: 200
}

export type getApiTeamsTeamIdCrmPoliciesPolicyIdCertificatesReadinessResponse200TextJson = {
  data: CrmCertificateReadinessPayload
  status: 200
}

export type getApiTeamsTeamIdCrmPoliciesPolicyIdCertificatesReadinessResponse401 = {
  data: GetApiTeamsTeamIdCrmPoliciesPolicyIdCertificatesReadiness401
  status: 401
}

export type getApiTeamsTeamIdCrmPoliciesPolicyIdCertificatesReadinessResponseSuccess = (getApiTeamsTeamIdCrmPoliciesPolicyIdCertificatesReadinessResponse200TextPlain | getApiTeamsTeamIdCrmPoliciesPolicyIdCertificatesReadinessResponse200ApplicationJson | getApiTeamsTeamIdCrmPoliciesPolicyIdCertificatesReadinessResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmPoliciesPolicyIdCertificatesReadinessResponseError = (getApiTeamsTeamIdCrmPoliciesPolicyIdCertificatesReadinessResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmPoliciesPolicyIdCertificatesReadinessResponse = (getApiTeamsTeamIdCrmPoliciesPolicyIdCertificatesReadinessResponseSuccess | getApiTeamsTeamIdCrmPoliciesPolicyIdCertificatesReadinessResponseError)

export const getGetApiTeamsTeamIdCrmPoliciesPolicyIdCertificatesReadinessUrl = (teamId: string,
    policyId: string,
    params?: GetApiTeamsTeamIdCrmPoliciesPolicyIdCertificatesReadinessParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/crm/policies/${policyId}/certificates/readiness?${stringifiedParams}` : `/api/teams/${teamId}/crm/policies/${policyId}/certificates/readiness`
}

export const getApiTeamsTeamIdCrmPoliciesPolicyIdCertificatesReadiness = async (teamId: string,
    policyId: string,
    params?: GetApiTeamsTeamIdCrmPoliciesPolicyIdCertificatesReadinessParams, options?: RequestInit): Promise<getApiTeamsTeamIdCrmPoliciesPolicyIdCertificatesReadinessResponse> => {

  return fetcher<getApiTeamsTeamIdCrmPoliciesPolicyIdCertificatesReadinessResponse>(getGetApiTeamsTeamIdCrmPoliciesPolicyIdCertificatesReadinessUrl(teamId,policyId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdCrmCertificatesCertificateIdResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmCertificatesCertificateIdResponse401 = {
  data: GetApiTeamsTeamIdCrmCertificatesCertificateId401
  status: 401
}

export type getApiTeamsTeamIdCrmCertificatesCertificateIdResponseSuccess = (getApiTeamsTeamIdCrmCertificatesCertificateIdResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmCertificatesCertificateIdResponseError = (getApiTeamsTeamIdCrmCertificatesCertificateIdResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmCertificatesCertificateIdResponse = (getApiTeamsTeamIdCrmCertificatesCertificateIdResponseSuccess | getApiTeamsTeamIdCrmCertificatesCertificateIdResponseError)

export const getGetApiTeamsTeamIdCrmCertificatesCertificateIdUrl = (teamId: string,
    certificateId: string,) => {




  return `/api/teams/${teamId}/crm/certificates/${certificateId}`
}

export const getApiTeamsTeamIdCrmCertificatesCertificateId = async (teamId: string,
    certificateId: string, options?: RequestInit): Promise<getApiTeamsTeamIdCrmCertificatesCertificateIdResponse> => {

  return fetcher<getApiTeamsTeamIdCrmCertificatesCertificateIdResponse>(getGetApiTeamsTeamIdCrmCertificatesCertificateIdUrl(teamId,certificateId),
  {
    ...options,
    method: 'GET'


  }
);}



export type putApiTeamsTeamIdCrmCertificatesCertificateIdResponse200 = {
  data: void
  status: 200
}

export type putApiTeamsTeamIdCrmCertificatesCertificateIdResponse401 = {
  data: PutApiTeamsTeamIdCrmCertificatesCertificateId401
  status: 401
}

export type putApiTeamsTeamIdCrmCertificatesCertificateIdResponse402 = {
  data: PutApiTeamsTeamIdCrmCertificatesCertificateId402
  status: 402
}

export type putApiTeamsTeamIdCrmCertificatesCertificateIdResponseSuccess = (putApiTeamsTeamIdCrmCertificatesCertificateIdResponse200) & {
  headers: Headers;
};
export type putApiTeamsTeamIdCrmCertificatesCertificateIdResponseError = (putApiTeamsTeamIdCrmCertificatesCertificateIdResponse401 | putApiTeamsTeamIdCrmCertificatesCertificateIdResponse402) & {
  headers: Headers;
};

export type putApiTeamsTeamIdCrmCertificatesCertificateIdResponse = (putApiTeamsTeamIdCrmCertificatesCertificateIdResponseSuccess | putApiTeamsTeamIdCrmCertificatesCertificateIdResponseError)

export const getPutApiTeamsTeamIdCrmCertificatesCertificateIdUrl = (teamId: string,
    certificateId: string,) => {




  return `/api/teams/${teamId}/crm/certificates/${certificateId}`
}

export const putApiTeamsTeamIdCrmCertificatesCertificateId = async (teamId: string,
    certificateId: string,
    upsertCertificateRequest: UpsertCertificateRequest, options?: RequestInit): Promise<putApiTeamsTeamIdCrmCertificatesCertificateIdResponse> => {

  return fetcher<putApiTeamsTeamIdCrmCertificatesCertificateIdResponse>(getPutApiTeamsTeamIdCrmCertificatesCertificateIdUrl(teamId,certificateId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upsertCertificateRequest,)
  }
);}



export type getApiTeamsTeamIdCrmCertificatesCertificateIdDownloadResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmCertificatesCertificateIdDownloadResponse401 = {
  data: GetApiTeamsTeamIdCrmCertificatesCertificateIdDownload401
  status: 401
}

export type getApiTeamsTeamIdCrmCertificatesCertificateIdDownloadResponseSuccess = (getApiTeamsTeamIdCrmCertificatesCertificateIdDownloadResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmCertificatesCertificateIdDownloadResponseError = (getApiTeamsTeamIdCrmCertificatesCertificateIdDownloadResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmCertificatesCertificateIdDownloadResponse = (getApiTeamsTeamIdCrmCertificatesCertificateIdDownloadResponseSuccess | getApiTeamsTeamIdCrmCertificatesCertificateIdDownloadResponseError)

export const getGetApiTeamsTeamIdCrmCertificatesCertificateIdDownloadUrl = (teamId: string,
    certificateId: string,
    params?: GetApiTeamsTeamIdCrmCertificatesCertificateIdDownloadParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/crm/certificates/${certificateId}/download?${stringifiedParams}` : `/api/teams/${teamId}/crm/certificates/${certificateId}/download`
}

export const getApiTeamsTeamIdCrmCertificatesCertificateIdDownload = async (teamId: string,
    certificateId: string,
    params?: GetApiTeamsTeamIdCrmCertificatesCertificateIdDownloadParams, options?: RequestInit): Promise<getApiTeamsTeamIdCrmCertificatesCertificateIdDownloadResponse> => {

  return fetcher<getApiTeamsTeamIdCrmCertificatesCertificateIdDownloadResponse>(getGetApiTeamsTeamIdCrmCertificatesCertificateIdDownloadUrl(teamId,certificateId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdCrmPoliciesPolicyIdStatusResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmPoliciesPolicyIdStatusResponse401 = {
  data: PostApiTeamsTeamIdCrmPoliciesPolicyIdStatus401
  status: 401
}

export type postApiTeamsTeamIdCrmPoliciesPolicyIdStatusResponse402 = {
  data: PostApiTeamsTeamIdCrmPoliciesPolicyIdStatus402
  status: 402
}

export type postApiTeamsTeamIdCrmPoliciesPolicyIdStatusResponseSuccess = (postApiTeamsTeamIdCrmPoliciesPolicyIdStatusResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmPoliciesPolicyIdStatusResponseError = (postApiTeamsTeamIdCrmPoliciesPolicyIdStatusResponse401 | postApiTeamsTeamIdCrmPoliciesPolicyIdStatusResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmPoliciesPolicyIdStatusResponse = (postApiTeamsTeamIdCrmPoliciesPolicyIdStatusResponseSuccess | postApiTeamsTeamIdCrmPoliciesPolicyIdStatusResponseError)

export const getPostApiTeamsTeamIdCrmPoliciesPolicyIdStatusUrl = (teamId: string,
    policyId: string,) => {




  return `/api/teams/${teamId}/crm/policies/${policyId}/status`
}

export const postApiTeamsTeamIdCrmPoliciesPolicyIdStatus = async (teamId: string,
    policyId: string,
    nullSetPolicyStatusRequest: null | SetPolicyStatusRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmPoliciesPolicyIdStatusResponse> => {

  return fetcher<postApiTeamsTeamIdCrmPoliciesPolicyIdStatusResponse>(getPostApiTeamsTeamIdCrmPoliciesPolicyIdStatusUrl(teamId,policyId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullSetPolicyStatusRequest,)
  }
);}



export type postApiTeamsTeamIdCrmPoliciesPolicyIdCancelResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmPoliciesPolicyIdCancelResponse401 = {
  data: PostApiTeamsTeamIdCrmPoliciesPolicyIdCancel401
  status: 401
}

export type postApiTeamsTeamIdCrmPoliciesPolicyIdCancelResponse402 = {
  data: PostApiTeamsTeamIdCrmPoliciesPolicyIdCancel402
  status: 402
}

export type postApiTeamsTeamIdCrmPoliciesPolicyIdCancelResponseSuccess = (postApiTeamsTeamIdCrmPoliciesPolicyIdCancelResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmPoliciesPolicyIdCancelResponseError = (postApiTeamsTeamIdCrmPoliciesPolicyIdCancelResponse401 | postApiTeamsTeamIdCrmPoliciesPolicyIdCancelResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmPoliciesPolicyIdCancelResponse = (postApiTeamsTeamIdCrmPoliciesPolicyIdCancelResponseSuccess | postApiTeamsTeamIdCrmPoliciesPolicyIdCancelResponseError)

export const getPostApiTeamsTeamIdCrmPoliciesPolicyIdCancelUrl = (teamId: string,
    policyId: string,) => {




  return `/api/teams/${teamId}/crm/policies/${policyId}/cancel`
}

export const postApiTeamsTeamIdCrmPoliciesPolicyIdCancel = async (teamId: string,
    policyId: string,
    upsertPolicyTransactionRequest: UpsertPolicyTransactionRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmPoliciesPolicyIdCancelResponse> => {

  return fetcher<postApiTeamsTeamIdCrmPoliciesPolicyIdCancelResponse>(getPostApiTeamsTeamIdCrmPoliciesPolicyIdCancelUrl(teamId,policyId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upsertPolicyTransactionRequest,)
  }
);}



export type postApiTeamsTeamIdCrmPoliciesPolicyIdReinstateResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmPoliciesPolicyIdReinstateResponse401 = {
  data: PostApiTeamsTeamIdCrmPoliciesPolicyIdReinstate401
  status: 401
}

export type postApiTeamsTeamIdCrmPoliciesPolicyIdReinstateResponse402 = {
  data: PostApiTeamsTeamIdCrmPoliciesPolicyIdReinstate402
  status: 402
}

export type postApiTeamsTeamIdCrmPoliciesPolicyIdReinstateResponseSuccess = (postApiTeamsTeamIdCrmPoliciesPolicyIdReinstateResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmPoliciesPolicyIdReinstateResponseError = (postApiTeamsTeamIdCrmPoliciesPolicyIdReinstateResponse401 | postApiTeamsTeamIdCrmPoliciesPolicyIdReinstateResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmPoliciesPolicyIdReinstateResponse = (postApiTeamsTeamIdCrmPoliciesPolicyIdReinstateResponseSuccess | postApiTeamsTeamIdCrmPoliciesPolicyIdReinstateResponseError)

export const getPostApiTeamsTeamIdCrmPoliciesPolicyIdReinstateUrl = (teamId: string,
    policyId: string,) => {




  return `/api/teams/${teamId}/crm/policies/${policyId}/reinstate`
}

export const postApiTeamsTeamIdCrmPoliciesPolicyIdReinstate = async (teamId: string,
    policyId: string,
    upsertPolicyTransactionRequest: UpsertPolicyTransactionRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmPoliciesPolicyIdReinstateResponse> => {

  return fetcher<postApiTeamsTeamIdCrmPoliciesPolicyIdReinstateResponse>(getPostApiTeamsTeamIdCrmPoliciesPolicyIdReinstateUrl(teamId,policyId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upsertPolicyTransactionRequest,)
  }
);}



export type putApiTeamsTeamIdCrmPolicyTermsPolicyTermIdRenewalWorkResponse200 = {
  data: void
  status: 200
}

export type putApiTeamsTeamIdCrmPolicyTermsPolicyTermIdRenewalWorkResponse401 = {
  data: PutApiTeamsTeamIdCrmPolicyTermsPolicyTermIdRenewalWork401
  status: 401
}

export type putApiTeamsTeamIdCrmPolicyTermsPolicyTermIdRenewalWorkResponse402 = {
  data: PutApiTeamsTeamIdCrmPolicyTermsPolicyTermIdRenewalWork402
  status: 402
}

export type putApiTeamsTeamIdCrmPolicyTermsPolicyTermIdRenewalWorkResponseSuccess = (putApiTeamsTeamIdCrmPolicyTermsPolicyTermIdRenewalWorkResponse200) & {
  headers: Headers;
};
export type putApiTeamsTeamIdCrmPolicyTermsPolicyTermIdRenewalWorkResponseError = (putApiTeamsTeamIdCrmPolicyTermsPolicyTermIdRenewalWorkResponse401 | putApiTeamsTeamIdCrmPolicyTermsPolicyTermIdRenewalWorkResponse402) & {
  headers: Headers;
};

export type putApiTeamsTeamIdCrmPolicyTermsPolicyTermIdRenewalWorkResponse = (putApiTeamsTeamIdCrmPolicyTermsPolicyTermIdRenewalWorkResponseSuccess | putApiTeamsTeamIdCrmPolicyTermsPolicyTermIdRenewalWorkResponseError)

export const getPutApiTeamsTeamIdCrmPolicyTermsPolicyTermIdRenewalWorkUrl = (teamId: string,
    policyTermId: string,) => {




  return `/api/teams/${teamId}/crm/policy-terms/${policyTermId}/renewal-work`
}

export const putApiTeamsTeamIdCrmPolicyTermsPolicyTermIdRenewalWork = async (teamId: string,
    policyTermId: string,
    upsertPolicyRenewalWorkRequest: UpsertPolicyRenewalWorkRequest, options?: RequestInit): Promise<putApiTeamsTeamIdCrmPolicyTermsPolicyTermIdRenewalWorkResponse> => {

  return fetcher<putApiTeamsTeamIdCrmPolicyTermsPolicyTermIdRenewalWorkResponse>(getPutApiTeamsTeamIdCrmPolicyTermsPolicyTermIdRenewalWorkUrl(teamId,policyTermId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upsertPolicyRenewalWorkRequest,)
  }
);}



export type postApiTeamsTeamIdCrmPoliciesPolicyIdRenewalSubmissionResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmPoliciesPolicyIdRenewalSubmissionResponse401 = {
  data: PostApiTeamsTeamIdCrmPoliciesPolicyIdRenewalSubmission401
  status: 401
}

export type postApiTeamsTeamIdCrmPoliciesPolicyIdRenewalSubmissionResponse402 = {
  data: PostApiTeamsTeamIdCrmPoliciesPolicyIdRenewalSubmission402
  status: 402
}

export type postApiTeamsTeamIdCrmPoliciesPolicyIdRenewalSubmissionResponseSuccess = (postApiTeamsTeamIdCrmPoliciesPolicyIdRenewalSubmissionResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmPoliciesPolicyIdRenewalSubmissionResponseError = (postApiTeamsTeamIdCrmPoliciesPolicyIdRenewalSubmissionResponse401 | postApiTeamsTeamIdCrmPoliciesPolicyIdRenewalSubmissionResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmPoliciesPolicyIdRenewalSubmissionResponse = (postApiTeamsTeamIdCrmPoliciesPolicyIdRenewalSubmissionResponseSuccess | postApiTeamsTeamIdCrmPoliciesPolicyIdRenewalSubmissionResponseError)

export const getPostApiTeamsTeamIdCrmPoliciesPolicyIdRenewalSubmissionUrl = (teamId: string,
    policyId: string,) => {




  return `/api/teams/${teamId}/crm/policies/${policyId}/renewal-submission`
}

export const postApiTeamsTeamIdCrmPoliciesPolicyIdRenewalSubmission = async (teamId: string,
    policyId: string,
    nullStartPolicyRenewalSubmissionRequest: null | StartPolicyRenewalSubmissionRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmPoliciesPolicyIdRenewalSubmissionResponse> => {

  return fetcher<postApiTeamsTeamIdCrmPoliciesPolicyIdRenewalSubmissionResponse>(getPostApiTeamsTeamIdCrmPoliciesPolicyIdRenewalSubmissionUrl(teamId,policyId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullStartPolicyRenewalSubmissionRequest,)
  }
);}



export type postApiTeamsTeamIdCrmPoliciesPolicyIdRemarketSubmissionResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmPoliciesPolicyIdRemarketSubmissionResponse401 = {
  data: PostApiTeamsTeamIdCrmPoliciesPolicyIdRemarketSubmission401
  status: 401
}

export type postApiTeamsTeamIdCrmPoliciesPolicyIdRemarketSubmissionResponse402 = {
  data: PostApiTeamsTeamIdCrmPoliciesPolicyIdRemarketSubmission402
  status: 402
}

export type postApiTeamsTeamIdCrmPoliciesPolicyIdRemarketSubmissionResponseSuccess = (postApiTeamsTeamIdCrmPoliciesPolicyIdRemarketSubmissionResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmPoliciesPolicyIdRemarketSubmissionResponseError = (postApiTeamsTeamIdCrmPoliciesPolicyIdRemarketSubmissionResponse401 | postApiTeamsTeamIdCrmPoliciesPolicyIdRemarketSubmissionResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmPoliciesPolicyIdRemarketSubmissionResponse = (postApiTeamsTeamIdCrmPoliciesPolicyIdRemarketSubmissionResponseSuccess | postApiTeamsTeamIdCrmPoliciesPolicyIdRemarketSubmissionResponseError)

export const getPostApiTeamsTeamIdCrmPoliciesPolicyIdRemarketSubmissionUrl = (teamId: string,
    policyId: string,) => {




  return `/api/teams/${teamId}/crm/policies/${policyId}/remarket-submission`
}

export const postApiTeamsTeamIdCrmPoliciesPolicyIdRemarketSubmission = async (teamId: string,
    policyId: string,
    nullStartPolicyRenewalSubmissionRequest: null | StartPolicyRenewalSubmissionRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmPoliciesPolicyIdRemarketSubmissionResponse> => {

  return fetcher<postApiTeamsTeamIdCrmPoliciesPolicyIdRemarketSubmissionResponse>(getPostApiTeamsTeamIdCrmPoliciesPolicyIdRemarketSubmissionUrl(teamId,policyId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullStartPolicyRenewalSubmissionRequest,)
  }
);}



export type postApiTeamsTeamIdCrmCertificatesResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmCertificatesResponse401 = {
  data: PostApiTeamsTeamIdCrmCertificates401
  status: 401
}

export type postApiTeamsTeamIdCrmCertificatesResponse402 = {
  data: PostApiTeamsTeamIdCrmCertificates402
  status: 402
}

export type postApiTeamsTeamIdCrmCertificatesResponseSuccess = (postApiTeamsTeamIdCrmCertificatesResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmCertificatesResponseError = (postApiTeamsTeamIdCrmCertificatesResponse401 | postApiTeamsTeamIdCrmCertificatesResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmCertificatesResponse = (postApiTeamsTeamIdCrmCertificatesResponseSuccess | postApiTeamsTeamIdCrmCertificatesResponseError)

export const getPostApiTeamsTeamIdCrmCertificatesUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/crm/certificates`
}

export const postApiTeamsTeamIdCrmCertificates = async (teamId: string,
    upsertCertificateRequest: UpsertCertificateRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmCertificatesResponse> => {

  return fetcher<postApiTeamsTeamIdCrmCertificatesResponse>(getPostApiTeamsTeamIdCrmCertificatesUrl(teamId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upsertCertificateRequest,)
  }
);}



export type postApiTeamsTeamIdCrmCertificatesCertificateIdIssueResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmCertificatesCertificateIdIssueResponse401 = {
  data: PostApiTeamsTeamIdCrmCertificatesCertificateIdIssue401
  status: 401
}

export type postApiTeamsTeamIdCrmCertificatesCertificateIdIssueResponse402 = {
  data: PostApiTeamsTeamIdCrmCertificatesCertificateIdIssue402
  status: 402
}

export type postApiTeamsTeamIdCrmCertificatesCertificateIdIssueResponseSuccess = (postApiTeamsTeamIdCrmCertificatesCertificateIdIssueResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmCertificatesCertificateIdIssueResponseError = (postApiTeamsTeamIdCrmCertificatesCertificateIdIssueResponse401 | postApiTeamsTeamIdCrmCertificatesCertificateIdIssueResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmCertificatesCertificateIdIssueResponse = (postApiTeamsTeamIdCrmCertificatesCertificateIdIssueResponseSuccess | postApiTeamsTeamIdCrmCertificatesCertificateIdIssueResponseError)

export const getPostApiTeamsTeamIdCrmCertificatesCertificateIdIssueUrl = (teamId: string,
    certificateId: string,) => {




  return `/api/teams/${teamId}/crm/certificates/${certificateId}/issue`
}

export const postApiTeamsTeamIdCrmCertificatesCertificateIdIssue = async (teamId: string,
    certificateId: string,
    nullIssueCertificateRequest: null | IssueCertificateRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmCertificatesCertificateIdIssueResponse> => {

  return fetcher<postApiTeamsTeamIdCrmCertificatesCertificateIdIssueResponse>(getPostApiTeamsTeamIdCrmCertificatesCertificateIdIssueUrl(teamId,certificateId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullIssueCertificateRequest,)
  }
);}



export type postApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderResponse200TextPlain = {
  data: CrmCertificateOutputRenderPayload
  status: 200
}

export type postApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderResponse200ApplicationJson = {
  data: CrmCertificateOutputRenderPayload
  status: 200
}

export type postApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderResponse200TextJson = {
  data: CrmCertificateOutputRenderPayload
  status: 200
}

export type postApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderResponse401 = {
  data: PostApiTeamsTeamIdCrmCertificatesCertificateIdOutputRender401
  status: 401
}

export type postApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderResponse402 = {
  data: PostApiTeamsTeamIdCrmCertificatesCertificateIdOutputRender402
  status: 402
}

export type postApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderResponseSuccess = (postApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderResponse200TextPlain | postApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderResponse200ApplicationJson | postApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderResponse200TextJson) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderResponseError = (postApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderResponse401 | postApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderResponse = (postApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderResponseSuccess | postApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderResponseError)

export const getPostApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderUrl = (teamId: string,
    certificateId: string,) => {




  return `/api/teams/${teamId}/crm/certificates/${certificateId}/output-render`
}

export const postApiTeamsTeamIdCrmCertificatesCertificateIdOutputRender = async (teamId: string,
    certificateId: string,
    nullQueueCertificateOutputRenderRequest: null | QueueCertificateOutputRenderRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderResponse> => {

  return fetcher<postApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderResponse>(getPostApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderUrl(teamId,certificateId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullQueueCertificateOutputRenderRequest,)
  }
);}



export type getApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderResponse200TextPlain = {
  data: CrmCertificateOutputRenderPayload
  status: 200
}

export type getApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderResponse200ApplicationJson = {
  data: CrmCertificateOutputRenderPayload
  status: 200
}

export type getApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderResponse200TextJson = {
  data: CrmCertificateOutputRenderPayload
  status: 200
}

export type getApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderResponse401 = {
  data: GetApiTeamsTeamIdCrmCertificatesCertificateIdOutputRender401
  status: 401
}

export type getApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderResponseSuccess = (getApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderResponse200TextPlain | getApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderResponse200ApplicationJson | getApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderResponseError = (getApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderResponse = (getApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderResponseSuccess | getApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderResponseError)

export const getGetApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderUrl = (teamId: string,
    certificateId: string,) => {




  return `/api/teams/${teamId}/crm/certificates/${certificateId}/output-render`
}

export const getApiTeamsTeamIdCrmCertificatesCertificateIdOutputRender = async (teamId: string,
    certificateId: string, options?: RequestInit): Promise<getApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderResponse> => {

  return fetcher<getApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderResponse>(getGetApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderUrl(teamId,certificateId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderContentResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderContentResponse401 = {
  data: GetApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderContent401
  status: 401
}

export type getApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderContentResponseSuccess = (getApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderContentResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderContentResponseError = (getApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderContentResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderContentResponse = (getApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderContentResponseSuccess | getApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderContentResponseError)

export const getGetApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderContentUrl = (teamId: string,
    certificateId: string,
    params?: GetApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderContentParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/crm/certificates/${certificateId}/output-render/content?${stringifiedParams}` : `/api/teams/${teamId}/crm/certificates/${certificateId}/output-render/content`
}

export const getApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderContent = async (teamId: string,
    certificateId: string,
    params?: GetApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderContentParams, options?: RequestInit): Promise<getApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderContentResponse> => {

  return fetcher<getApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderContentResponse>(getGetApiTeamsTeamIdCrmCertificatesCertificateIdOutputRenderContentUrl(teamId,certificateId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdCrmCertificatesCertificateIdDeliverResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmCertificatesCertificateIdDeliverResponse401 = {
  data: PostApiTeamsTeamIdCrmCertificatesCertificateIdDeliver401
  status: 401
}

export type postApiTeamsTeamIdCrmCertificatesCertificateIdDeliverResponse402 = {
  data: PostApiTeamsTeamIdCrmCertificatesCertificateIdDeliver402
  status: 402
}

export type postApiTeamsTeamIdCrmCertificatesCertificateIdDeliverResponseSuccess = (postApiTeamsTeamIdCrmCertificatesCertificateIdDeliverResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmCertificatesCertificateIdDeliverResponseError = (postApiTeamsTeamIdCrmCertificatesCertificateIdDeliverResponse401 | postApiTeamsTeamIdCrmCertificatesCertificateIdDeliverResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmCertificatesCertificateIdDeliverResponse = (postApiTeamsTeamIdCrmCertificatesCertificateIdDeliverResponseSuccess | postApiTeamsTeamIdCrmCertificatesCertificateIdDeliverResponseError)

export const getPostApiTeamsTeamIdCrmCertificatesCertificateIdDeliverUrl = (teamId: string,
    certificateId: string,) => {




  return `/api/teams/${teamId}/crm/certificates/${certificateId}/deliver`
}

export const postApiTeamsTeamIdCrmCertificatesCertificateIdDeliver = async (teamId: string,
    certificateId: string,
    nullDeliverCertificateRequest: null | DeliverCertificateRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmCertificatesCertificateIdDeliverResponse> => {

  return fetcher<postApiTeamsTeamIdCrmCertificatesCertificateIdDeliverResponse>(getPostApiTeamsTeamIdCrmCertificatesCertificateIdDeliverUrl(teamId,certificateId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullDeliverCertificateRequest,)
  }
);}



export type postApiTeamsTeamIdCrmCertificatesCertificateIdVoidResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmCertificatesCertificateIdVoidResponse401 = {
  data: PostApiTeamsTeamIdCrmCertificatesCertificateIdVoid401
  status: 401
}

export type postApiTeamsTeamIdCrmCertificatesCertificateIdVoidResponse402 = {
  data: PostApiTeamsTeamIdCrmCertificatesCertificateIdVoid402
  status: 402
}

export type postApiTeamsTeamIdCrmCertificatesCertificateIdVoidResponseSuccess = (postApiTeamsTeamIdCrmCertificatesCertificateIdVoidResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmCertificatesCertificateIdVoidResponseError = (postApiTeamsTeamIdCrmCertificatesCertificateIdVoidResponse401 | postApiTeamsTeamIdCrmCertificatesCertificateIdVoidResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmCertificatesCertificateIdVoidResponse = (postApiTeamsTeamIdCrmCertificatesCertificateIdVoidResponseSuccess | postApiTeamsTeamIdCrmCertificatesCertificateIdVoidResponseError)

export const getPostApiTeamsTeamIdCrmCertificatesCertificateIdVoidUrl = (teamId: string,
    certificateId: string,) => {




  return `/api/teams/${teamId}/crm/certificates/${certificateId}/void`
}

export const postApiTeamsTeamIdCrmCertificatesCertificateIdVoid = async (teamId: string,
    certificateId: string,
    voidCertificateRequest: VoidCertificateRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmCertificatesCertificateIdVoidResponse> => {

  return fetcher<postApiTeamsTeamIdCrmCertificatesCertificateIdVoidResponse>(getPostApiTeamsTeamIdCrmCertificatesCertificateIdVoidUrl(teamId,certificateId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      voidCertificateRequest,)
  }
);}



export type getApiTeamsTeamIdCrmGlExposuresResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmGlExposuresResponse401 = {
  data: GetApiTeamsTeamIdCrmGlExposures401
  status: 401
}

export type getApiTeamsTeamIdCrmGlExposuresResponseSuccess = (getApiTeamsTeamIdCrmGlExposuresResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmGlExposuresResponseError = (getApiTeamsTeamIdCrmGlExposuresResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmGlExposuresResponse = (getApiTeamsTeamIdCrmGlExposuresResponseSuccess | getApiTeamsTeamIdCrmGlExposuresResponseError)

export const getGetApiTeamsTeamIdCrmGlExposuresUrl = (teamId: string,
    params?: GetApiTeamsTeamIdCrmGlExposuresParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/crm/gl-exposures?${stringifiedParams}` : `/api/teams/${teamId}/crm/gl-exposures`
}

export const getApiTeamsTeamIdCrmGlExposures = async (teamId: string,
    params?: GetApiTeamsTeamIdCrmGlExposuresParams, options?: RequestInit): Promise<getApiTeamsTeamIdCrmGlExposuresResponse> => {

  return fetcher<getApiTeamsTeamIdCrmGlExposuresResponse>(getGetApiTeamsTeamIdCrmGlExposuresUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdCrmGlExposuresResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmGlExposuresResponse401 = {
  data: PostApiTeamsTeamIdCrmGlExposures401
  status: 401
}

export type postApiTeamsTeamIdCrmGlExposuresResponse402 = {
  data: PostApiTeamsTeamIdCrmGlExposures402
  status: 402
}

export type postApiTeamsTeamIdCrmGlExposuresResponseSuccess = (postApiTeamsTeamIdCrmGlExposuresResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmGlExposuresResponseError = (postApiTeamsTeamIdCrmGlExposuresResponse401 | postApiTeamsTeamIdCrmGlExposuresResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmGlExposuresResponse = (postApiTeamsTeamIdCrmGlExposuresResponseSuccess | postApiTeamsTeamIdCrmGlExposuresResponseError)

export const getPostApiTeamsTeamIdCrmGlExposuresUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/crm/gl-exposures`
}

export const postApiTeamsTeamIdCrmGlExposures = async (teamId: string,
    upsertGlExposureRequest: UpsertGlExposureRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmGlExposuresResponse> => {

  return fetcher<postApiTeamsTeamIdCrmGlExposuresResponse>(getPostApiTeamsTeamIdCrmGlExposuresUrl(teamId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upsertGlExposureRequest,)
  }
);}



export type getApiTeamsTeamIdCrmAdditionalInterestsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmAdditionalInterestsResponse401 = {
  data: GetApiTeamsTeamIdCrmAdditionalInterests401
  status: 401
}

export type getApiTeamsTeamIdCrmAdditionalInterestsResponseSuccess = (getApiTeamsTeamIdCrmAdditionalInterestsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmAdditionalInterestsResponseError = (getApiTeamsTeamIdCrmAdditionalInterestsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmAdditionalInterestsResponse = (getApiTeamsTeamIdCrmAdditionalInterestsResponseSuccess | getApiTeamsTeamIdCrmAdditionalInterestsResponseError)

export const getGetApiTeamsTeamIdCrmAdditionalInterestsUrl = (teamId: string,
    params?: GetApiTeamsTeamIdCrmAdditionalInterestsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/crm/additional-interests?${stringifiedParams}` : `/api/teams/${teamId}/crm/additional-interests`
}

export const getApiTeamsTeamIdCrmAdditionalInterests = async (teamId: string,
    params?: GetApiTeamsTeamIdCrmAdditionalInterestsParams, options?: RequestInit): Promise<getApiTeamsTeamIdCrmAdditionalInterestsResponse> => {

  return fetcher<getApiTeamsTeamIdCrmAdditionalInterestsResponse>(getGetApiTeamsTeamIdCrmAdditionalInterestsUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdCrmAdditionalInterestsResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmAdditionalInterestsResponse401 = {
  data: PostApiTeamsTeamIdCrmAdditionalInterests401
  status: 401
}

export type postApiTeamsTeamIdCrmAdditionalInterestsResponse402 = {
  data: PostApiTeamsTeamIdCrmAdditionalInterests402
  status: 402
}

export type postApiTeamsTeamIdCrmAdditionalInterestsResponseSuccess = (postApiTeamsTeamIdCrmAdditionalInterestsResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmAdditionalInterestsResponseError = (postApiTeamsTeamIdCrmAdditionalInterestsResponse401 | postApiTeamsTeamIdCrmAdditionalInterestsResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmAdditionalInterestsResponse = (postApiTeamsTeamIdCrmAdditionalInterestsResponseSuccess | postApiTeamsTeamIdCrmAdditionalInterestsResponseError)

export const getPostApiTeamsTeamIdCrmAdditionalInterestsUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/crm/additional-interests`
}

export const postApiTeamsTeamIdCrmAdditionalInterests = async (teamId: string,
    createAdditionalInterestRequest: CreateAdditionalInterestRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmAdditionalInterestsResponse> => {

  return fetcher<postApiTeamsTeamIdCrmAdditionalInterestsResponse>(getPostApiTeamsTeamIdCrmAdditionalInterestsUrl(teamId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createAdditionalInterestRequest,)
  }
);}



export type postApiTeamsTeamIdCrmPoliciesPolicyIdAdditionalInterestsResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmPoliciesPolicyIdAdditionalInterestsResponse401 = {
  data: PostApiTeamsTeamIdCrmPoliciesPolicyIdAdditionalInterests401
  status: 401
}

export type postApiTeamsTeamIdCrmPoliciesPolicyIdAdditionalInterestsResponse402 = {
  data: PostApiTeamsTeamIdCrmPoliciesPolicyIdAdditionalInterests402
  status: 402
}

export type postApiTeamsTeamIdCrmPoliciesPolicyIdAdditionalInterestsResponseSuccess = (postApiTeamsTeamIdCrmPoliciesPolicyIdAdditionalInterestsResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmPoliciesPolicyIdAdditionalInterestsResponseError = (postApiTeamsTeamIdCrmPoliciesPolicyIdAdditionalInterestsResponse401 | postApiTeamsTeamIdCrmPoliciesPolicyIdAdditionalInterestsResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmPoliciesPolicyIdAdditionalInterestsResponse = (postApiTeamsTeamIdCrmPoliciesPolicyIdAdditionalInterestsResponseSuccess | postApiTeamsTeamIdCrmPoliciesPolicyIdAdditionalInterestsResponseError)

export const getPostApiTeamsTeamIdCrmPoliciesPolicyIdAdditionalInterestsUrl = (teamId: string,
    policyId: string,) => {




  return `/api/teams/${teamId}/crm/policies/${policyId}/additional-interests`
}

export const postApiTeamsTeamIdCrmPoliciesPolicyIdAdditionalInterests = async (teamId: string,
    policyId: string,
    linkAdditionalInterestRequest: LinkAdditionalInterestRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmPoliciesPolicyIdAdditionalInterestsResponse> => {

  return fetcher<postApiTeamsTeamIdCrmPoliciesPolicyIdAdditionalInterestsResponse>(getPostApiTeamsTeamIdCrmPoliciesPolicyIdAdditionalInterestsUrl(teamId,policyId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      linkAdditionalInterestRequest,)
  }
);}



export type deleteApiTeamsTeamIdCrmPoliciesPolicyIdAdditionalInterestsAdditionalInterestIdResponse200 = {
  data: void
  status: 200
}

export type deleteApiTeamsTeamIdCrmPoliciesPolicyIdAdditionalInterestsAdditionalInterestIdResponse401 = {
  data: DeleteApiTeamsTeamIdCrmPoliciesPolicyIdAdditionalInterestsAdditionalInterestId401
  status: 401
}

export type deleteApiTeamsTeamIdCrmPoliciesPolicyIdAdditionalInterestsAdditionalInterestIdResponse402 = {
  data: DeleteApiTeamsTeamIdCrmPoliciesPolicyIdAdditionalInterestsAdditionalInterestId402
  status: 402
}

export type deleteApiTeamsTeamIdCrmPoliciesPolicyIdAdditionalInterestsAdditionalInterestIdResponseSuccess = (deleteApiTeamsTeamIdCrmPoliciesPolicyIdAdditionalInterestsAdditionalInterestIdResponse200) & {
  headers: Headers;
};
export type deleteApiTeamsTeamIdCrmPoliciesPolicyIdAdditionalInterestsAdditionalInterestIdResponseError = (deleteApiTeamsTeamIdCrmPoliciesPolicyIdAdditionalInterestsAdditionalInterestIdResponse401 | deleteApiTeamsTeamIdCrmPoliciesPolicyIdAdditionalInterestsAdditionalInterestIdResponse402) & {
  headers: Headers;
};

export type deleteApiTeamsTeamIdCrmPoliciesPolicyIdAdditionalInterestsAdditionalInterestIdResponse = (deleteApiTeamsTeamIdCrmPoliciesPolicyIdAdditionalInterestsAdditionalInterestIdResponseSuccess | deleteApiTeamsTeamIdCrmPoliciesPolicyIdAdditionalInterestsAdditionalInterestIdResponseError)

export const getDeleteApiTeamsTeamIdCrmPoliciesPolicyIdAdditionalInterestsAdditionalInterestIdUrl = (teamId: string,
    policyId: string,
    additionalInterestId: string,) => {




  return `/api/teams/${teamId}/crm/policies/${policyId}/additional-interests/${additionalInterestId}`
}

export const deleteApiTeamsTeamIdCrmPoliciesPolicyIdAdditionalInterestsAdditionalInterestId = async (teamId: string,
    policyId: string,
    additionalInterestId: string, options?: RequestInit): Promise<deleteApiTeamsTeamIdCrmPoliciesPolicyIdAdditionalInterestsAdditionalInterestIdResponse> => {

  return fetcher<deleteApiTeamsTeamIdCrmPoliciesPolicyIdAdditionalInterestsAdditionalInterestIdResponse>(getDeleteApiTeamsTeamIdCrmPoliciesPolicyIdAdditionalInterestsAdditionalInterestIdUrl(teamId,policyId,additionalInterestId),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type getApiTeamsTeamIdCrmUmbrellaUnderlyingResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmUmbrellaUnderlyingResponse401 = {
  data: GetApiTeamsTeamIdCrmUmbrellaUnderlying401
  status: 401
}

export type getApiTeamsTeamIdCrmUmbrellaUnderlyingResponseSuccess = (getApiTeamsTeamIdCrmUmbrellaUnderlyingResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmUmbrellaUnderlyingResponseError = (getApiTeamsTeamIdCrmUmbrellaUnderlyingResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmUmbrellaUnderlyingResponse = (getApiTeamsTeamIdCrmUmbrellaUnderlyingResponseSuccess | getApiTeamsTeamIdCrmUmbrellaUnderlyingResponseError)

export const getGetApiTeamsTeamIdCrmUmbrellaUnderlyingUrl = (teamId: string,
    params?: GetApiTeamsTeamIdCrmUmbrellaUnderlyingParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/crm/umbrella-underlying?${stringifiedParams}` : `/api/teams/${teamId}/crm/umbrella-underlying`
}

export const getApiTeamsTeamIdCrmUmbrellaUnderlying = async (teamId: string,
    params?: GetApiTeamsTeamIdCrmUmbrellaUnderlyingParams, options?: RequestInit): Promise<getApiTeamsTeamIdCrmUmbrellaUnderlyingResponse> => {

  return fetcher<getApiTeamsTeamIdCrmUmbrellaUnderlyingResponse>(getGetApiTeamsTeamIdCrmUmbrellaUnderlyingUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdCrmUmbrellaUnderlyingResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmUmbrellaUnderlyingResponse401 = {
  data: PostApiTeamsTeamIdCrmUmbrellaUnderlying401
  status: 401
}

export type postApiTeamsTeamIdCrmUmbrellaUnderlyingResponse402 = {
  data: PostApiTeamsTeamIdCrmUmbrellaUnderlying402
  status: 402
}

export type postApiTeamsTeamIdCrmUmbrellaUnderlyingResponseSuccess = (postApiTeamsTeamIdCrmUmbrellaUnderlyingResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmUmbrellaUnderlyingResponseError = (postApiTeamsTeamIdCrmUmbrellaUnderlyingResponse401 | postApiTeamsTeamIdCrmUmbrellaUnderlyingResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmUmbrellaUnderlyingResponse = (postApiTeamsTeamIdCrmUmbrellaUnderlyingResponseSuccess | postApiTeamsTeamIdCrmUmbrellaUnderlyingResponseError)

export const getPostApiTeamsTeamIdCrmUmbrellaUnderlyingUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/crm/umbrella-underlying`
}

export const postApiTeamsTeamIdCrmUmbrellaUnderlying = async (teamId: string,
    upsertUmbrellaUnderlyingRequest: UpsertUmbrellaUnderlyingRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmUmbrellaUnderlyingResponse> => {

  return fetcher<postApiTeamsTeamIdCrmUmbrellaUnderlyingResponse>(getPostApiTeamsTeamIdCrmUmbrellaUnderlyingUrl(teamId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upsertUmbrellaUnderlyingRequest,)
  }
);}



export type getApiTeamsTeamIdCrmUmbrellaUnderlyingIdResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmUmbrellaUnderlyingIdResponse401 = {
  data: GetApiTeamsTeamIdCrmUmbrellaUnderlyingId401
  status: 401
}

export type getApiTeamsTeamIdCrmUmbrellaUnderlyingIdResponseSuccess = (getApiTeamsTeamIdCrmUmbrellaUnderlyingIdResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmUmbrellaUnderlyingIdResponseError = (getApiTeamsTeamIdCrmUmbrellaUnderlyingIdResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmUmbrellaUnderlyingIdResponse = (getApiTeamsTeamIdCrmUmbrellaUnderlyingIdResponseSuccess | getApiTeamsTeamIdCrmUmbrellaUnderlyingIdResponseError)

export const getGetApiTeamsTeamIdCrmUmbrellaUnderlyingIdUrl = (teamId: string,
    id: string,) => {




  return `/api/teams/${teamId}/crm/umbrella-underlying/${id}`
}

export const getApiTeamsTeamIdCrmUmbrellaUnderlyingId = async (teamId: string,
    id: string, options?: RequestInit): Promise<getApiTeamsTeamIdCrmUmbrellaUnderlyingIdResponse> => {

  return fetcher<getApiTeamsTeamIdCrmUmbrellaUnderlyingIdResponse>(getGetApiTeamsTeamIdCrmUmbrellaUnderlyingIdUrl(teamId,id),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdCrmVehiclesResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmVehiclesResponse401 = {
  data: GetApiTeamsTeamIdCrmVehicles401
  status: 401
}

export type getApiTeamsTeamIdCrmVehiclesResponseSuccess = (getApiTeamsTeamIdCrmVehiclesResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmVehiclesResponseError = (getApiTeamsTeamIdCrmVehiclesResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmVehiclesResponse = (getApiTeamsTeamIdCrmVehiclesResponseSuccess | getApiTeamsTeamIdCrmVehiclesResponseError)

export const getGetApiTeamsTeamIdCrmVehiclesUrl = (teamId: string,
    params?: GetApiTeamsTeamIdCrmVehiclesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/crm/vehicles?${stringifiedParams}` : `/api/teams/${teamId}/crm/vehicles`
}

export const getApiTeamsTeamIdCrmVehicles = async (teamId: string,
    params?: GetApiTeamsTeamIdCrmVehiclesParams, options?: RequestInit): Promise<getApiTeamsTeamIdCrmVehiclesResponse> => {

  return fetcher<getApiTeamsTeamIdCrmVehiclesResponse>(getGetApiTeamsTeamIdCrmVehiclesUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdCrmVehiclesResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmVehiclesResponse401 = {
  data: PostApiTeamsTeamIdCrmVehicles401
  status: 401
}

export type postApiTeamsTeamIdCrmVehiclesResponse402 = {
  data: PostApiTeamsTeamIdCrmVehicles402
  status: 402
}

export type postApiTeamsTeamIdCrmVehiclesResponseSuccess = (postApiTeamsTeamIdCrmVehiclesResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmVehiclesResponseError = (postApiTeamsTeamIdCrmVehiclesResponse401 | postApiTeamsTeamIdCrmVehiclesResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmVehiclesResponse = (postApiTeamsTeamIdCrmVehiclesResponseSuccess | postApiTeamsTeamIdCrmVehiclesResponseError)

export const getPostApiTeamsTeamIdCrmVehiclesUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/crm/vehicles`
}

export const postApiTeamsTeamIdCrmVehicles = async (teamId: string,
    createVehicleRequest: CreateVehicleRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmVehiclesResponse> => {

  return fetcher<postApiTeamsTeamIdCrmVehiclesResponse>(getPostApiTeamsTeamIdCrmVehiclesUrl(teamId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createVehicleRequest,)
  }
);}



export type getApiTeamsTeamIdCrmDriversResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmDriversResponse401 = {
  data: GetApiTeamsTeamIdCrmDrivers401
  status: 401
}

export type getApiTeamsTeamIdCrmDriversResponseSuccess = (getApiTeamsTeamIdCrmDriversResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmDriversResponseError = (getApiTeamsTeamIdCrmDriversResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmDriversResponse = (getApiTeamsTeamIdCrmDriversResponseSuccess | getApiTeamsTeamIdCrmDriversResponseError)

export const getGetApiTeamsTeamIdCrmDriversUrl = (teamId: string,
    params?: GetApiTeamsTeamIdCrmDriversParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/crm/drivers?${stringifiedParams}` : `/api/teams/${teamId}/crm/drivers`
}

export const getApiTeamsTeamIdCrmDrivers = async (teamId: string,
    params?: GetApiTeamsTeamIdCrmDriversParams, options?: RequestInit): Promise<getApiTeamsTeamIdCrmDriversResponse> => {

  return fetcher<getApiTeamsTeamIdCrmDriversResponse>(getGetApiTeamsTeamIdCrmDriversUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdCrmDriversResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmDriversResponse401 = {
  data: PostApiTeamsTeamIdCrmDrivers401
  status: 401
}

export type postApiTeamsTeamIdCrmDriversResponse402 = {
  data: PostApiTeamsTeamIdCrmDrivers402
  status: 402
}

export type postApiTeamsTeamIdCrmDriversResponseSuccess = (postApiTeamsTeamIdCrmDriversResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmDriversResponseError = (postApiTeamsTeamIdCrmDriversResponse401 | postApiTeamsTeamIdCrmDriversResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmDriversResponse = (postApiTeamsTeamIdCrmDriversResponseSuccess | postApiTeamsTeamIdCrmDriversResponseError)

export const getPostApiTeamsTeamIdCrmDriversUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/crm/drivers`
}

export const postApiTeamsTeamIdCrmDrivers = async (teamId: string,
    createDriverRequest: CreateDriverRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmDriversResponse> => {

  return fetcher<postApiTeamsTeamIdCrmDriversResponse>(getPostApiTeamsTeamIdCrmDriversUrl(teamId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createDriverRequest,)
  }
);}



export type getApiTeamsTeamIdCrmLossesResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmLossesResponse401 = {
  data: GetApiTeamsTeamIdCrmLosses401
  status: 401
}

export type getApiTeamsTeamIdCrmLossesResponseSuccess = (getApiTeamsTeamIdCrmLossesResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmLossesResponseError = (getApiTeamsTeamIdCrmLossesResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmLossesResponse = (getApiTeamsTeamIdCrmLossesResponseSuccess | getApiTeamsTeamIdCrmLossesResponseError)

export const getGetApiTeamsTeamIdCrmLossesUrl = (teamId: string,
    params?: GetApiTeamsTeamIdCrmLossesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/crm/losses?${stringifiedParams}` : `/api/teams/${teamId}/crm/losses`
}

export const getApiTeamsTeamIdCrmLosses = async (teamId: string,
    params?: GetApiTeamsTeamIdCrmLossesParams, options?: RequestInit): Promise<getApiTeamsTeamIdCrmLossesResponse> => {

  return fetcher<getApiTeamsTeamIdCrmLossesResponse>(getGetApiTeamsTeamIdCrmLossesUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdCrmLossesResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmLossesResponse401 = {
  data: PostApiTeamsTeamIdCrmLosses401
  status: 401
}

export type postApiTeamsTeamIdCrmLossesResponse402 = {
  data: PostApiTeamsTeamIdCrmLosses402
  status: 402
}

export type postApiTeamsTeamIdCrmLossesResponseSuccess = (postApiTeamsTeamIdCrmLossesResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmLossesResponseError = (postApiTeamsTeamIdCrmLossesResponse401 | postApiTeamsTeamIdCrmLossesResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmLossesResponse = (postApiTeamsTeamIdCrmLossesResponseSuccess | postApiTeamsTeamIdCrmLossesResponseError)

export const getPostApiTeamsTeamIdCrmLossesUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/crm/losses`
}

export const postApiTeamsTeamIdCrmLosses = async (teamId: string,
    createLossRequest: CreateLossRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmLossesResponse> => {

  return fetcher<postApiTeamsTeamIdCrmLossesResponse>(getPostApiTeamsTeamIdCrmLossesUrl(teamId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createLossRequest,)
  }
);}



export type getApiTeamsTeamIdCrmPriorCarriersResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmPriorCarriersResponse401 = {
  data: GetApiTeamsTeamIdCrmPriorCarriers401
  status: 401
}

export type getApiTeamsTeamIdCrmPriorCarriersResponseSuccess = (getApiTeamsTeamIdCrmPriorCarriersResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmPriorCarriersResponseError = (getApiTeamsTeamIdCrmPriorCarriersResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmPriorCarriersResponse = (getApiTeamsTeamIdCrmPriorCarriersResponseSuccess | getApiTeamsTeamIdCrmPriorCarriersResponseError)

export const getGetApiTeamsTeamIdCrmPriorCarriersUrl = (teamId: string,
    params?: GetApiTeamsTeamIdCrmPriorCarriersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/crm/prior-carriers?${stringifiedParams}` : `/api/teams/${teamId}/crm/prior-carriers`
}

export const getApiTeamsTeamIdCrmPriorCarriers = async (teamId: string,
    params?: GetApiTeamsTeamIdCrmPriorCarriersParams, options?: RequestInit): Promise<getApiTeamsTeamIdCrmPriorCarriersResponse> => {

  return fetcher<getApiTeamsTeamIdCrmPriorCarriersResponse>(getGetApiTeamsTeamIdCrmPriorCarriersUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdCrmWcExperienceResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmWcExperienceResponse401 = {
  data: GetApiTeamsTeamIdCrmWcExperience401
  status: 401
}

export type getApiTeamsTeamIdCrmWcExperienceResponseSuccess = (getApiTeamsTeamIdCrmWcExperienceResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmWcExperienceResponseError = (getApiTeamsTeamIdCrmWcExperienceResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmWcExperienceResponse = (getApiTeamsTeamIdCrmWcExperienceResponseSuccess | getApiTeamsTeamIdCrmWcExperienceResponseError)

export const getGetApiTeamsTeamIdCrmWcExperienceUrl = (teamId: string,
    params?: GetApiTeamsTeamIdCrmWcExperienceParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/crm/wc-experience?${stringifiedParams}` : `/api/teams/${teamId}/crm/wc-experience`
}

export const getApiTeamsTeamIdCrmWcExperience = async (teamId: string,
    params?: GetApiTeamsTeamIdCrmWcExperienceParams, options?: RequestInit): Promise<getApiTeamsTeamIdCrmWcExperienceResponse> => {

  return fetcher<getApiTeamsTeamIdCrmWcExperienceResponse>(getGetApiTeamsTeamIdCrmWcExperienceUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdCrmLocationsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmLocationsResponse401 = {
  data: GetApiTeamsTeamIdCrmLocations401
  status: 401
}

export type getApiTeamsTeamIdCrmLocationsResponseSuccess = (getApiTeamsTeamIdCrmLocationsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmLocationsResponseError = (getApiTeamsTeamIdCrmLocationsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmLocationsResponse = (getApiTeamsTeamIdCrmLocationsResponseSuccess | getApiTeamsTeamIdCrmLocationsResponseError)

export const getGetApiTeamsTeamIdCrmLocationsUrl = (teamId: string,
    params?: GetApiTeamsTeamIdCrmLocationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/crm/locations?${stringifiedParams}` : `/api/teams/${teamId}/crm/locations`
}

export const getApiTeamsTeamIdCrmLocations = async (teamId: string,
    params?: GetApiTeamsTeamIdCrmLocationsParams, options?: RequestInit): Promise<getApiTeamsTeamIdCrmLocationsResponse> => {

  return fetcher<getApiTeamsTeamIdCrmLocationsResponse>(getGetApiTeamsTeamIdCrmLocationsUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdCrmLocationsResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmLocationsResponse401 = {
  data: PostApiTeamsTeamIdCrmLocations401
  status: 401
}

export type postApiTeamsTeamIdCrmLocationsResponse402 = {
  data: PostApiTeamsTeamIdCrmLocations402
  status: 402
}

export type postApiTeamsTeamIdCrmLocationsResponseSuccess = (postApiTeamsTeamIdCrmLocationsResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmLocationsResponseError = (postApiTeamsTeamIdCrmLocationsResponse401 | postApiTeamsTeamIdCrmLocationsResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmLocationsResponse = (postApiTeamsTeamIdCrmLocationsResponseSuccess | postApiTeamsTeamIdCrmLocationsResponseError)

export const getPostApiTeamsTeamIdCrmLocationsUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/crm/locations`
}

export const postApiTeamsTeamIdCrmLocations = async (teamId: string,
    createLocationRequest: CreateLocationRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmLocationsResponse> => {

  return fetcher<postApiTeamsTeamIdCrmLocationsResponse>(getPostApiTeamsTeamIdCrmLocationsUrl(teamId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createLocationRequest,)
  }
);}



export type getApiTeamsTeamIdCrmLocationsLocationIdResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmLocationsLocationIdResponse401 = {
  data: GetApiTeamsTeamIdCrmLocationsLocationId401
  status: 401
}

export type getApiTeamsTeamIdCrmLocationsLocationIdResponseSuccess = (getApiTeamsTeamIdCrmLocationsLocationIdResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmLocationsLocationIdResponseError = (getApiTeamsTeamIdCrmLocationsLocationIdResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmLocationsLocationIdResponse = (getApiTeamsTeamIdCrmLocationsLocationIdResponseSuccess | getApiTeamsTeamIdCrmLocationsLocationIdResponseError)

export const getGetApiTeamsTeamIdCrmLocationsLocationIdUrl = (teamId: string,
    locationId: string,) => {




  return `/api/teams/${teamId}/crm/locations/${locationId}`
}

export const getApiTeamsTeamIdCrmLocationsLocationId = async (teamId: string,
    locationId: string, options?: RequestInit): Promise<getApiTeamsTeamIdCrmLocationsLocationIdResponse> => {

  return fetcher<getApiTeamsTeamIdCrmLocationsLocationIdResponse>(getGetApiTeamsTeamIdCrmLocationsLocationIdUrl(teamId,locationId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdCrmBuildingsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmBuildingsResponse401 = {
  data: GetApiTeamsTeamIdCrmBuildings401
  status: 401
}

export type getApiTeamsTeamIdCrmBuildingsResponseSuccess = (getApiTeamsTeamIdCrmBuildingsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmBuildingsResponseError = (getApiTeamsTeamIdCrmBuildingsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmBuildingsResponse = (getApiTeamsTeamIdCrmBuildingsResponseSuccess | getApiTeamsTeamIdCrmBuildingsResponseError)

export const getGetApiTeamsTeamIdCrmBuildingsUrl = (teamId: string,
    params?: GetApiTeamsTeamIdCrmBuildingsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/crm/buildings?${stringifiedParams}` : `/api/teams/${teamId}/crm/buildings`
}

export const getApiTeamsTeamIdCrmBuildings = async (teamId: string,
    params?: GetApiTeamsTeamIdCrmBuildingsParams, options?: RequestInit): Promise<getApiTeamsTeamIdCrmBuildingsResponse> => {

  return fetcher<getApiTeamsTeamIdCrmBuildingsResponse>(getGetApiTeamsTeamIdCrmBuildingsUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdCrmBuildingsResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmBuildingsResponse401 = {
  data: PostApiTeamsTeamIdCrmBuildings401
  status: 401
}

export type postApiTeamsTeamIdCrmBuildingsResponse402 = {
  data: PostApiTeamsTeamIdCrmBuildings402
  status: 402
}

export type postApiTeamsTeamIdCrmBuildingsResponseSuccess = (postApiTeamsTeamIdCrmBuildingsResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmBuildingsResponseError = (postApiTeamsTeamIdCrmBuildingsResponse401 | postApiTeamsTeamIdCrmBuildingsResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmBuildingsResponse = (postApiTeamsTeamIdCrmBuildingsResponseSuccess | postApiTeamsTeamIdCrmBuildingsResponseError)

export const getPostApiTeamsTeamIdCrmBuildingsUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/crm/buildings`
}

export const postApiTeamsTeamIdCrmBuildings = async (teamId: string,
    createBuildingRequest: CreateBuildingRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmBuildingsResponse> => {

  return fetcher<postApiTeamsTeamIdCrmBuildingsResponse>(getPostApiTeamsTeamIdCrmBuildingsUrl(teamId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createBuildingRequest,)
  }
);}



export type getApiTeamsTeamIdCrmBuildingsBuildingIdResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmBuildingsBuildingIdResponse401 = {
  data: GetApiTeamsTeamIdCrmBuildingsBuildingId401
  status: 401
}

export type getApiTeamsTeamIdCrmBuildingsBuildingIdResponseSuccess = (getApiTeamsTeamIdCrmBuildingsBuildingIdResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmBuildingsBuildingIdResponseError = (getApiTeamsTeamIdCrmBuildingsBuildingIdResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmBuildingsBuildingIdResponse = (getApiTeamsTeamIdCrmBuildingsBuildingIdResponseSuccess | getApiTeamsTeamIdCrmBuildingsBuildingIdResponseError)

export const getGetApiTeamsTeamIdCrmBuildingsBuildingIdUrl = (teamId: string,
    buildingId: string,) => {




  return `/api/teams/${teamId}/crm/buildings/${buildingId}`
}

export const getApiTeamsTeamIdCrmBuildingsBuildingId = async (teamId: string,
    buildingId: string, options?: RequestInit): Promise<getApiTeamsTeamIdCrmBuildingsBuildingIdResponse> => {

  return fetcher<getApiTeamsTeamIdCrmBuildingsBuildingIdResponse>(getGetApiTeamsTeamIdCrmBuildingsBuildingIdUrl(teamId,buildingId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsStartResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsStartResponse401 = {
  data: PostApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsStart401
  status: 401
}

export type postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsStartResponse402 = {
  data: PostApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsStart402
  status: 402
}

export type postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsStartResponseSuccess = (postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsStartResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsStartResponseError = (postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsStartResponse401 | postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsStartResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsStartResponse = (postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsStartResponseSuccess | postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsStartResponseError)

export const getPostApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsStartUrl = (teamId: string,
    crmSubmissionId: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${crmSubmissionId}/packets/start`
}

export const postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsStart = async (teamId: string,
    crmSubmissionId: string,
    nullTeamStartCrmPacketRequest: null | TeamStartCrmPacketRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsStartResponse> => {

  return fetcher<postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsStartResponse>(getPostApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsStartUrl(teamId,crmSubmissionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullTeamStartCrmPacketRequest,)
  }
);}



export type postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsStartFromInsuranceModelResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsStartFromInsuranceModelResponse401 = {
  data: PostApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsStartFromInsuranceModel401
  status: 401
}

export type postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsStartFromInsuranceModelResponse402 = {
  data: PostApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsStartFromInsuranceModel402
  status: 402
}

export type postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsStartFromInsuranceModelResponseSuccess = (postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsStartFromInsuranceModelResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsStartFromInsuranceModelResponseError = (postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsStartFromInsuranceModelResponse401 | postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsStartFromInsuranceModelResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsStartFromInsuranceModelResponse = (postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsStartFromInsuranceModelResponseSuccess | postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsStartFromInsuranceModelResponseError)

export const getPostApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsStartFromInsuranceModelUrl = (teamId: string,
    crmSubmissionId: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${crmSubmissionId}/packets/start-from-insurance-model`
}

export const postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsStartFromInsuranceModel = async (teamId: string,
    crmSubmissionId: string,
    nullTeamStartCrmPacketFromInsuranceModelRequest: null | TeamStartCrmPacketFromInsuranceModelRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsStartFromInsuranceModelResponse> => {

  return fetcher<postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsStartFromInsuranceModelResponse>(getPostApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsStartFromInsuranceModelUrl(teamId,crmSubmissionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullTeamStartCrmPacketFromInsuranceModelRequest,)
  }
);}



export type getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsResponse401 = {
  data: GetApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackets401
  status: 401
}

export type getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsResponseSuccess = (getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsResponseError = (getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsResponse = (getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsResponseSuccess | getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsResponseError)

export const getGetApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsUrl = (teamId: string,
    crmSubmissionId: string,
    params?: GetApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/crm/submissions/${crmSubmissionId}/packets?${stringifiedParams}` : `/api/teams/${teamId}/crm/submissions/${crmSubmissionId}/packets`
}

export const getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackets = async (teamId: string,
    crmSubmissionId: string,
    params?: GetApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsParams, options?: RequestInit): Promise<getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsResponse> => {

  return fetcher<getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsResponse>(getGetApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsUrl(teamId,crmSubmissionId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsApplyDatakeysResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsApplyDatakeysResponse401 = {
  data: PostApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsApplyDatakeys401
  status: 401
}

export type postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsApplyDatakeysResponse402 = {
  data: PostApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsApplyDatakeys402
  status: 402
}

export type postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsApplyDatakeysResponseSuccess = (postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsApplyDatakeysResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsApplyDatakeysResponseError = (postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsApplyDatakeysResponse401 | postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsApplyDatakeysResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsApplyDatakeysResponse = (postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsApplyDatakeysResponseSuccess | postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsApplyDatakeysResponseError)

export const getPostApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsApplyDatakeysUrl = (teamId: string,
    crmSubmissionId: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${crmSubmissionId}/packets/apply-datakeys`
}

export const postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsApplyDatakeys = async (teamId: string,
    crmSubmissionId: string,
    nullTeamApplyPacketPrefillRequest: null | TeamApplyPacketPrefillRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsApplyDatakeysResponse> => {

  return fetcher<postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsApplyDatakeysResponse>(getPostApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsApplyDatakeysUrl(teamId,crmSubmissionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullTeamApplyPacketPrefillRequest,)
  }
);}



export type postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsApplySchedulesResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsApplySchedulesResponse401 = {
  data: PostApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsApplySchedules401
  status: 401
}

export type postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsApplySchedulesResponse402 = {
  data: PostApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsApplySchedules402
  status: 402
}

export type postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsApplySchedulesResponseSuccess = (postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsApplySchedulesResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsApplySchedulesResponseError = (postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsApplySchedulesResponse401 | postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsApplySchedulesResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsApplySchedulesResponse = (postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsApplySchedulesResponseSuccess | postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsApplySchedulesResponseError)

export const getPostApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsApplySchedulesUrl = (teamId: string,
    crmSubmissionId: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${crmSubmissionId}/packets/apply-schedules`
}

export const postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsApplySchedules = async (teamId: string,
    crmSubmissionId: string,
    nullTeamApplyPacketPrefillRequest: null | TeamApplyPacketPrefillRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsApplySchedulesResponse> => {

  return fetcher<postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsApplySchedulesResponse>(getPostApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsApplySchedulesUrl(teamId,crmSubmissionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullTeamApplyPacketPrefillRequest,)
  }
);}



export type getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsFormSubmissionIdRunnerResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsFormSubmissionIdRunnerResponse401 = {
  data: GetApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsFormSubmissionIdRunner401
  status: 401
}

export type getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsFormSubmissionIdRunnerResponseSuccess = (getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsFormSubmissionIdRunnerResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsFormSubmissionIdRunnerResponseError = (getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsFormSubmissionIdRunnerResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsFormSubmissionIdRunnerResponse = (getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsFormSubmissionIdRunnerResponseSuccess | getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsFormSubmissionIdRunnerResponseError)

export const getGetApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsFormSubmissionIdRunnerUrl = (teamId: string,
    crmSubmissionId: string,
    formSubmissionId: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${crmSubmissionId}/packets/${formSubmissionId}/runner`
}

export const getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsFormSubmissionIdRunner = async (teamId: string,
    crmSubmissionId: string,
    formSubmissionId: string, options?: RequestInit): Promise<getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsFormSubmissionIdRunnerResponse> => {

  return fetcher<getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsFormSubmissionIdRunnerResponse>(getGetApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsFormSubmissionIdRunnerUrl(teamId,crmSubmissionId,formSubmissionId),
  {
    ...options,
    method: 'GET'


  }
);}



export type patchApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsFormSubmissionIdRunnerAnswersResponse200 = {
  data: void
  status: 200
}

export type patchApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsFormSubmissionIdRunnerAnswersResponse401 = {
  data: PatchApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsFormSubmissionIdRunnerAnswers401
  status: 401
}

export type patchApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsFormSubmissionIdRunnerAnswersResponse402 = {
  data: PatchApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsFormSubmissionIdRunnerAnswers402
  status: 402
}

export type patchApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsFormSubmissionIdRunnerAnswersResponseSuccess = (patchApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsFormSubmissionIdRunnerAnswersResponse200) & {
  headers: Headers;
};
export type patchApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsFormSubmissionIdRunnerAnswersResponseError = (patchApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsFormSubmissionIdRunnerAnswersResponse401 | patchApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsFormSubmissionIdRunnerAnswersResponse402) & {
  headers: Headers;
};

export type patchApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsFormSubmissionIdRunnerAnswersResponse = (patchApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsFormSubmissionIdRunnerAnswersResponseSuccess | patchApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsFormSubmissionIdRunnerAnswersResponseError)

export const getPatchApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsFormSubmissionIdRunnerAnswersUrl = (teamId: string,
    crmSubmissionId: string,
    formSubmissionId: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${crmSubmissionId}/packets/${formSubmissionId}/runner/answers`
}

export const patchApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsFormSubmissionIdRunnerAnswers = async (teamId: string,
    crmSubmissionId: string,
    formSubmissionId: string,
    nullTeamPatchPacketRunnerAnswersRequest: null | TeamPatchPacketRunnerAnswersRequest, options?: RequestInit): Promise<patchApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsFormSubmissionIdRunnerAnswersResponse> => {

  return fetcher<patchApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsFormSubmissionIdRunnerAnswersResponse>(getPatchApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPacketsFormSubmissionIdRunnerAnswersUrl(teamId,crmSubmissionId,formSubmissionId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullTeamPatchPacketRunnerAnswersRequest,)
  }
);}



export type getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdDocumentsChecklistResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdDocumentsChecklistResponse401 = {
  data: GetApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdDocumentsChecklist401
  status: 401
}

export type getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdDocumentsChecklistResponseSuccess = (getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdDocumentsChecklistResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdDocumentsChecklistResponseError = (getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdDocumentsChecklistResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdDocumentsChecklistResponse = (getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdDocumentsChecklistResponseSuccess | getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdDocumentsChecklistResponseError)

export const getGetApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdDocumentsChecklistUrl = (teamId: string,
    crmSubmissionId: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${crmSubmissionId}/documents/checklist`
}

export const getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdDocumentsChecklist = async (teamId: string,
    crmSubmissionId: string, options?: RequestInit): Promise<getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdDocumentsChecklistResponse> => {

  return fetcher<getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdDocumentsChecklistResponse>(getGetApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdDocumentsChecklistUrl(teamId,crmSubmissionId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleReadinessResponse200TextPlain = {
  data: AdminSubmissionPackageReadinessPayload
  status: 200
}

export type getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleReadinessResponse200ApplicationJson = {
  data: AdminSubmissionPackageReadinessPayload
  status: 200
}

export type getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleReadinessResponse200TextJson = {
  data: AdminSubmissionPackageReadinessPayload
  status: 200
}

export type getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleReadinessResponse401 = {
  data: GetApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleReadiness401
  status: 401
}

export type getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleReadinessResponseSuccess = (getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleReadinessResponse200TextPlain | getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleReadinessResponse200ApplicationJson | getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleReadinessResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleReadinessResponseError = (getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleReadinessResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleReadinessResponse = (getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleReadinessResponseSuccess | getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleReadinessResponseError)

export const getGetApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleReadinessUrl = (teamId: string,
    crmSubmissionId: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${crmSubmissionId}/package-bundle/readiness`
}

export const getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleReadiness = async (teamId: string,
    crmSubmissionId: string, options?: RequestInit): Promise<getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleReadinessResponse> => {

  return fetcher<getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleReadinessResponse>(getGetApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleReadinessUrl(teamId,crmSubmissionId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleRenderWorkersResponse200TextPlain = {
  data: AdminSubmissionPackageRenderQueuePayload
  status: 200
}

export type postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleRenderWorkersResponse200ApplicationJson = {
  data: AdminSubmissionPackageRenderQueuePayload
  status: 200
}

export type postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleRenderWorkersResponse200TextJson = {
  data: AdminSubmissionPackageRenderQueuePayload
  status: 200
}

export type postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleRenderWorkersResponse401 = {
  data: PostApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleRenderWorkers401
  status: 401
}

export type postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleRenderWorkersResponse402 = {
  data: PostApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleRenderWorkers402
  status: 402
}

export type postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleRenderWorkersResponseSuccess = (postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleRenderWorkersResponse200TextPlain | postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleRenderWorkersResponse200ApplicationJson | postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleRenderWorkersResponse200TextJson) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleRenderWorkersResponseError = (postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleRenderWorkersResponse401 | postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleRenderWorkersResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleRenderWorkersResponse = (postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleRenderWorkersResponseSuccess | postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleRenderWorkersResponseError)

export const getPostApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleRenderWorkersUrl = (teamId: string,
    crmSubmissionId: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${crmSubmissionId}/package-bundle/render-workers`
}

export const postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleRenderWorkers = async (teamId: string,
    crmSubmissionId: string, options?: RequestInit): Promise<postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleRenderWorkersResponse> => {

  return fetcher<postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleRenderWorkersResponse>(getPostApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleRenderWorkersUrl(teamId,crmSubmissionId),
  {
    ...options,
    method: 'POST'


  }
);}



export type postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleResponse401 = {
  data: PostApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundle401
  status: 401
}

export type postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleResponse402 = {
  data: PostApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundle402
  status: 402
}

export type postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleResponseSuccess = (postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleResponseError = (postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleResponse401 | postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleResponse = (postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleResponseSuccess | postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleResponseError)

export const getPostApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleUrl = (teamId: string,
    crmSubmissionId: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${crmSubmissionId}/package-bundle`
}

export const postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundle = async (teamId: string,
    crmSubmissionId: string,
    nullTeamBuildSubmissionPackageRequest: null | TeamBuildSubmissionPackageRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleResponse> => {

  return fetcher<postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleResponse>(getPostApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdPackageBundleUrl(teamId,crmSubmissionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullTeamBuildSubmissionPackageRequest,)
  }
);}



export type getApiTeamsTeamIdDashboardHomeResponse200TextPlain = {
  data: TeamDashboardHomeSummaryDto
  status: 200
}

export type getApiTeamsTeamIdDashboardHomeResponse200ApplicationJson = {
  data: TeamDashboardHomeSummaryDto
  status: 200
}

export type getApiTeamsTeamIdDashboardHomeResponse200TextJson = {
  data: TeamDashboardHomeSummaryDto
  status: 200
}

export type getApiTeamsTeamIdDashboardHomeResponse401 = {
  data: GetApiTeamsTeamIdDashboardHome401
  status: 401
}

export type getApiTeamsTeamIdDashboardHomeResponseSuccess = (getApiTeamsTeamIdDashboardHomeResponse200TextPlain | getApiTeamsTeamIdDashboardHomeResponse200ApplicationJson | getApiTeamsTeamIdDashboardHomeResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsTeamIdDashboardHomeResponseError = (getApiTeamsTeamIdDashboardHomeResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdDashboardHomeResponse = (getApiTeamsTeamIdDashboardHomeResponseSuccess | getApiTeamsTeamIdDashboardHomeResponseError)

export const getGetApiTeamsTeamIdDashboardHomeUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/dashboard/home`
}

export const getApiTeamsTeamIdDashboardHome = async (teamId: string, options?: RequestInit): Promise<getApiTeamsTeamIdDashboardHomeResponse> => {

  return fetcher<getApiTeamsTeamIdDashboardHomeResponse>(getGetApiTeamsTeamIdDashboardHomeUrl(teamId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdAgentsEdgeEchoRunsResponse200TextPlain = {
  data: EdgeEchoAgentRunResponse
  status: 200
}

export type postApiTeamsTeamIdAgentsEdgeEchoRunsResponse200ApplicationJson = {
  data: EdgeEchoAgentRunResponse
  status: 200
}

export type postApiTeamsTeamIdAgentsEdgeEchoRunsResponse200TextJson = {
  data: EdgeEchoAgentRunResponse
  status: 200
}

export type postApiTeamsTeamIdAgentsEdgeEchoRunsResponse400TextPlain = {
  data: TeamAgentErrorResponse
  status: 400
}

export type postApiTeamsTeamIdAgentsEdgeEchoRunsResponse400ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 400
}

export type postApiTeamsTeamIdAgentsEdgeEchoRunsResponse400TextJson = {
  data: TeamAgentErrorResponse
  status: 400
}

export type postApiTeamsTeamIdAgentsEdgeEchoRunsResponse401TextPlain = {
  data: TeamAgentErrorResponse
  status: 401
}

export type postApiTeamsTeamIdAgentsEdgeEchoRunsResponse401ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 401
}

export type postApiTeamsTeamIdAgentsEdgeEchoRunsResponse401TextJson = {
  data: TeamAgentErrorResponse
  status: 401
}

export type postApiTeamsTeamIdAgentsEdgeEchoRunsResponse402 = {
  data: PostApiTeamsTeamIdAgentsEdgeEchoRuns402
  status: 402
}

export type postApiTeamsTeamIdAgentsEdgeEchoRunsResponse403TextPlain = {
  data: TeamAgentErrorResponse
  status: 403
}

export type postApiTeamsTeamIdAgentsEdgeEchoRunsResponse403ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type postApiTeamsTeamIdAgentsEdgeEchoRunsResponse403TextJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type postApiTeamsTeamIdAgentsEdgeEchoRunsResponseSuccess = (postApiTeamsTeamIdAgentsEdgeEchoRunsResponse200TextPlain | postApiTeamsTeamIdAgentsEdgeEchoRunsResponse200ApplicationJson | postApiTeamsTeamIdAgentsEdgeEchoRunsResponse200TextJson) & {
  headers: Headers;
};
export type postApiTeamsTeamIdAgentsEdgeEchoRunsResponseError = (postApiTeamsTeamIdAgentsEdgeEchoRunsResponse400TextPlain | postApiTeamsTeamIdAgentsEdgeEchoRunsResponse400ApplicationJson | postApiTeamsTeamIdAgentsEdgeEchoRunsResponse400TextJson | postApiTeamsTeamIdAgentsEdgeEchoRunsResponse401TextPlain | postApiTeamsTeamIdAgentsEdgeEchoRunsResponse401ApplicationJson | postApiTeamsTeamIdAgentsEdgeEchoRunsResponse401TextJson | postApiTeamsTeamIdAgentsEdgeEchoRunsResponse402 | postApiTeamsTeamIdAgentsEdgeEchoRunsResponse403TextPlain | postApiTeamsTeamIdAgentsEdgeEchoRunsResponse403ApplicationJson | postApiTeamsTeamIdAgentsEdgeEchoRunsResponse403TextJson) & {
  headers: Headers;
};

export type postApiTeamsTeamIdAgentsEdgeEchoRunsResponse = (postApiTeamsTeamIdAgentsEdgeEchoRunsResponseSuccess | postApiTeamsTeamIdAgentsEdgeEchoRunsResponseError)

export const getPostApiTeamsTeamIdAgentsEdgeEchoRunsUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/agents/edge-echo/runs`
}

export const postApiTeamsTeamIdAgentsEdgeEchoRuns = async (teamId: string, options?: RequestInit): Promise<postApiTeamsTeamIdAgentsEdgeEchoRunsResponse> => {

  return fetcher<postApiTeamsTeamIdAgentsEdgeEchoRunsResponse>(getPostApiTeamsTeamIdAgentsEdgeEchoRunsUrl(teamId),
  {
    ...options,
    method: 'POST'


  }
);}



export type getApiTeamsTeamIdAgentsEdgeEchoRunsRunIdResponse200TextPlain = {
  data: EdgeEchoAgentRunStateResponse
  status: 200
}

export type getApiTeamsTeamIdAgentsEdgeEchoRunsRunIdResponse200ApplicationJson = {
  data: EdgeEchoAgentRunStateResponse
  status: 200
}

export type getApiTeamsTeamIdAgentsEdgeEchoRunsRunIdResponse200TextJson = {
  data: EdgeEchoAgentRunStateResponse
  status: 200
}

export type getApiTeamsTeamIdAgentsEdgeEchoRunsRunIdResponse400TextPlain = {
  data: TeamAgentErrorResponse
  status: 400
}

export type getApiTeamsTeamIdAgentsEdgeEchoRunsRunIdResponse400ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 400
}

export type getApiTeamsTeamIdAgentsEdgeEchoRunsRunIdResponse400TextJson = {
  data: TeamAgentErrorResponse
  status: 400
}

export type getApiTeamsTeamIdAgentsEdgeEchoRunsRunIdResponse401TextPlain = {
  data: TeamAgentErrorResponse
  status: 401
}

export type getApiTeamsTeamIdAgentsEdgeEchoRunsRunIdResponse401ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 401
}

export type getApiTeamsTeamIdAgentsEdgeEchoRunsRunIdResponse401TextJson = {
  data: TeamAgentErrorResponse
  status: 401
}

export type getApiTeamsTeamIdAgentsEdgeEchoRunsRunIdResponse403TextPlain = {
  data: TeamAgentErrorResponse
  status: 403
}

export type getApiTeamsTeamIdAgentsEdgeEchoRunsRunIdResponse403ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type getApiTeamsTeamIdAgentsEdgeEchoRunsRunIdResponse403TextJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type getApiTeamsTeamIdAgentsEdgeEchoRunsRunIdResponse404TextPlain = {
  data: TeamAgentErrorResponse
  status: 404
}

export type getApiTeamsTeamIdAgentsEdgeEchoRunsRunIdResponse404ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 404
}

export type getApiTeamsTeamIdAgentsEdgeEchoRunsRunIdResponse404TextJson = {
  data: TeamAgentErrorResponse
  status: 404
}

export type getApiTeamsTeamIdAgentsEdgeEchoRunsRunIdResponseSuccess = (getApiTeamsTeamIdAgentsEdgeEchoRunsRunIdResponse200TextPlain | getApiTeamsTeamIdAgentsEdgeEchoRunsRunIdResponse200ApplicationJson | getApiTeamsTeamIdAgentsEdgeEchoRunsRunIdResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsTeamIdAgentsEdgeEchoRunsRunIdResponseError = (getApiTeamsTeamIdAgentsEdgeEchoRunsRunIdResponse400TextPlain | getApiTeamsTeamIdAgentsEdgeEchoRunsRunIdResponse400ApplicationJson | getApiTeamsTeamIdAgentsEdgeEchoRunsRunIdResponse400TextJson | getApiTeamsTeamIdAgentsEdgeEchoRunsRunIdResponse401TextPlain | getApiTeamsTeamIdAgentsEdgeEchoRunsRunIdResponse401ApplicationJson | getApiTeamsTeamIdAgentsEdgeEchoRunsRunIdResponse401TextJson | getApiTeamsTeamIdAgentsEdgeEchoRunsRunIdResponse403TextPlain | getApiTeamsTeamIdAgentsEdgeEchoRunsRunIdResponse403ApplicationJson | getApiTeamsTeamIdAgentsEdgeEchoRunsRunIdResponse403TextJson | getApiTeamsTeamIdAgentsEdgeEchoRunsRunIdResponse404TextPlain | getApiTeamsTeamIdAgentsEdgeEchoRunsRunIdResponse404ApplicationJson | getApiTeamsTeamIdAgentsEdgeEchoRunsRunIdResponse404TextJson) & {
  headers: Headers;
};

export type getApiTeamsTeamIdAgentsEdgeEchoRunsRunIdResponse = (getApiTeamsTeamIdAgentsEdgeEchoRunsRunIdResponseSuccess | getApiTeamsTeamIdAgentsEdgeEchoRunsRunIdResponseError)

export const getGetApiTeamsTeamIdAgentsEdgeEchoRunsRunIdUrl = (teamId: string,
    runId: string,) => {




  return `/api/teams/${teamId}/agents/edge-echo/runs/${runId}`
}

export const getApiTeamsTeamIdAgentsEdgeEchoRunsRunId = async (teamId: string,
    runId: string, options?: RequestInit): Promise<getApiTeamsTeamIdAgentsEdgeEchoRunsRunIdResponse> => {

  return fetcher<getApiTeamsTeamIdAgentsEdgeEchoRunsRunIdResponse>(getGetApiTeamsTeamIdAgentsEdgeEchoRunsRunIdUrl(teamId,runId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResumeResponse200TextPlain = {
  data: EdgeEchoAgentRunStateResponse
  status: 200
}

export type postApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResumeResponse200ApplicationJson = {
  data: EdgeEchoAgentRunStateResponse
  status: 200
}

export type postApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResumeResponse200TextJson = {
  data: EdgeEchoAgentRunStateResponse
  status: 200
}

export type postApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResumeResponse400TextPlain = {
  data: TeamAgentErrorResponse
  status: 400
}

export type postApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResumeResponse400ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 400
}

export type postApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResumeResponse400TextJson = {
  data: TeamAgentErrorResponse
  status: 400
}

export type postApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResumeResponse401TextPlain = {
  data: TeamAgentErrorResponse
  status: 401
}

export type postApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResumeResponse401ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 401
}

export type postApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResumeResponse401TextJson = {
  data: TeamAgentErrorResponse
  status: 401
}

export type postApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResumeResponse403TextPlain = {
  data: TeamAgentErrorResponse
  status: 403
}

export type postApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResumeResponse403ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type postApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResumeResponse403TextJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type postApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResumeResponse404TextPlain = {
  data: TeamAgentErrorResponse
  status: 404
}

export type postApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResumeResponse404ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 404
}

export type postApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResumeResponse404TextJson = {
  data: TeamAgentErrorResponse
  status: 404
}

export type postApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResumeResponse409TextPlain = {
  data: TeamAgentErrorResponse
  status: 409
}

export type postApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResumeResponse409ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 409
}

export type postApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResumeResponse409TextJson = {
  data: TeamAgentErrorResponse
  status: 409
}

export type postApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResumeResponseSuccess = (postApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResumeResponse200TextPlain | postApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResumeResponse200ApplicationJson | postApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResumeResponse200TextJson) & {
  headers: Headers;
};
export type postApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResumeResponseError = (postApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResumeResponse400TextPlain | postApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResumeResponse400ApplicationJson | postApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResumeResponse400TextJson | postApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResumeResponse401TextPlain | postApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResumeResponse401ApplicationJson | postApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResumeResponse401TextJson | postApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResumeResponse403TextPlain | postApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResumeResponse403ApplicationJson | postApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResumeResponse403TextJson | postApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResumeResponse404TextPlain | postApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResumeResponse404ApplicationJson | postApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResumeResponse404TextJson | postApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResumeResponse409TextPlain | postApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResumeResponse409ApplicationJson | postApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResumeResponse409TextJson) & {
  headers: Headers;
};

export type postApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResumeResponse = (postApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResumeResponseSuccess | postApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResumeResponseError)

export const getPostApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResumeUrl = (teamId: string,
    runId: string,) => {




  return `/api/teams/${teamId}/agents/edge-echo/runs/${runId}/checkpoints/edge-result/resume`
}

export const postApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResume = async (teamId: string,
    runId: string, options?: RequestInit): Promise<postApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResumeResponse> => {

  return fetcher<postApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResumeResponse>(getPostApiTeamsTeamIdAgentsEdgeEchoRunsRunIdCheckpointsEdgeResultResumeUrl(teamId,runId),
  {
    ...options,
    method: 'POST'


  }
);}



export type getApiTeamsTeamIdFormsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdFormsResponse401 = {
  data: GetApiTeamsTeamIdForms401
  status: 401
}

export type getApiTeamsTeamIdFormsResponseSuccess = (getApiTeamsTeamIdFormsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdFormsResponseError = (getApiTeamsTeamIdFormsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdFormsResponse = (getApiTeamsTeamIdFormsResponseSuccess | getApiTeamsTeamIdFormsResponseError)

export const getGetApiTeamsTeamIdFormsUrl = (teamId: string,
    params?: GetApiTeamsTeamIdFormsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/forms?${stringifiedParams}` : `/api/teams/${teamId}/forms`
}

export const getApiTeamsTeamIdForms = async (teamId: string,
    params?: GetApiTeamsTeamIdFormsParams, options?: RequestInit): Promise<getApiTeamsTeamIdFormsResponse> => {

  return fetcher<getApiTeamsTeamIdFormsResponse>(getGetApiTeamsTeamIdFormsUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdFormVersionsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdFormVersionsResponse401 = {
  data: GetApiTeamsTeamIdFormVersions401
  status: 401
}

export type getApiTeamsTeamIdFormVersionsResponseSuccess = (getApiTeamsTeamIdFormVersionsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdFormVersionsResponseError = (getApiTeamsTeamIdFormVersionsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdFormVersionsResponse = (getApiTeamsTeamIdFormVersionsResponseSuccess | getApiTeamsTeamIdFormVersionsResponseError)

export const getGetApiTeamsTeamIdFormVersionsUrl = (teamId: string,
    params?: GetApiTeamsTeamIdFormVersionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/form-versions?${stringifiedParams}` : `/api/teams/${teamId}/form-versions`
}

export const getApiTeamsTeamIdFormVersions = async (teamId: string,
    params?: GetApiTeamsTeamIdFormVersionsParams, options?: RequestInit): Promise<getApiTeamsTeamIdFormVersionsResponse> => {

  return fetcher<getApiTeamsTeamIdFormVersionsResponse>(getGetApiTeamsTeamIdFormVersionsUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdFormsVersionsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdFormsVersionsResponse401 = {
  data: GetApiTeamsTeamIdFormsVersions401
  status: 401
}

export type getApiTeamsTeamIdFormsVersionsResponseSuccess = (getApiTeamsTeamIdFormsVersionsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdFormsVersionsResponseError = (getApiTeamsTeamIdFormsVersionsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdFormsVersionsResponse = (getApiTeamsTeamIdFormsVersionsResponseSuccess | getApiTeamsTeamIdFormsVersionsResponseError)

export const getGetApiTeamsTeamIdFormsVersionsUrl = (teamId: string,
    params?: GetApiTeamsTeamIdFormsVersionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/forms/versions?${stringifiedParams}` : `/api/teams/${teamId}/forms/versions`
}

export const getApiTeamsTeamIdFormsVersions = async (teamId: string,
    params?: GetApiTeamsTeamIdFormsVersionsParams, options?: RequestInit): Promise<getApiTeamsTeamIdFormsVersionsResponse> => {

  return fetcher<getApiTeamsTeamIdFormsVersionsResponse>(getGetApiTeamsTeamIdFormsVersionsUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdFormsAvailableVersionsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdFormsAvailableVersionsResponse401 = {
  data: GetApiTeamsTeamIdFormsAvailableVersions401
  status: 401
}

export type getApiTeamsTeamIdFormsAvailableVersionsResponseSuccess = (getApiTeamsTeamIdFormsAvailableVersionsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdFormsAvailableVersionsResponseError = (getApiTeamsTeamIdFormsAvailableVersionsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdFormsAvailableVersionsResponse = (getApiTeamsTeamIdFormsAvailableVersionsResponseSuccess | getApiTeamsTeamIdFormsAvailableVersionsResponseError)

export const getGetApiTeamsTeamIdFormsAvailableVersionsUrl = (teamId: string,
    params?: GetApiTeamsTeamIdFormsAvailableVersionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/forms/available-versions?${stringifiedParams}` : `/api/teams/${teamId}/forms/available-versions`
}

export const getApiTeamsTeamIdFormsAvailableVersions = async (teamId: string,
    params?: GetApiTeamsTeamIdFormsAvailableVersionsParams, options?: RequestInit): Promise<getApiTeamsTeamIdFormsAvailableVersionsResponse> => {

  return fetcher<getApiTeamsTeamIdFormsAvailableVersionsResponse>(getGetApiTeamsTeamIdFormsAvailableVersionsUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdFormsSummaryResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdFormsSummaryResponse401 = {
  data: GetApiTeamsTeamIdFormsSummary401
  status: 401
}

export type getApiTeamsTeamIdFormsSummaryResponseSuccess = (getApiTeamsTeamIdFormsSummaryResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdFormsSummaryResponseError = (getApiTeamsTeamIdFormsSummaryResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdFormsSummaryResponse = (getApiTeamsTeamIdFormsSummaryResponseSuccess | getApiTeamsTeamIdFormsSummaryResponseError)

export const getGetApiTeamsTeamIdFormsSummaryUrl = (teamId: string,
    params?: GetApiTeamsTeamIdFormsSummaryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/forms/summary?${stringifiedParams}` : `/api/teams/${teamId}/forms/summary`
}

export const getApiTeamsTeamIdFormsSummary = async (teamId: string,
    params?: GetApiTeamsTeamIdFormsSummaryParams, options?: RequestInit): Promise<getApiTeamsTeamIdFormsSummaryResponse> => {

  return fetcher<getApiTeamsTeamIdFormsSummaryResponse>(getGetApiTeamsTeamIdFormsSummaryUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdPdfResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdPdfResponse401 = {
  data: GetApiTeamsTeamIdFormsFormIdVersionsFormVersionIdPdf401
  status: 401
}

export type getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdPdfResponseSuccess = (getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdPdfResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdPdfResponseError = (getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdPdfResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdPdfResponse = (getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdPdfResponseSuccess | getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdPdfResponseError)

export const getGetApiTeamsTeamIdFormsFormIdVersionsFormVersionIdPdfUrl = (teamId: string,
    formId: string,
    formVersionId: string,
    params?: GetApiTeamsTeamIdFormsFormIdVersionsFormVersionIdPdfParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/forms/${formId}/versions/${formVersionId}/pdf?${stringifiedParams}` : `/api/teams/${teamId}/forms/${formId}/versions/${formVersionId}/pdf`
}

export const getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdPdf = async (teamId: string,
    formId: string,
    formVersionId: string,
    params?: GetApiTeamsTeamIdFormsFormIdVersionsFormVersionIdPdfParams, options?: RequestInit): Promise<getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdPdfResponse> => {

  return fetcher<getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdPdfResponse>(getGetApiTeamsTeamIdFormsFormIdVersionsFormVersionIdPdfUrl(teamId,formId,formVersionId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdFormsFormIdVersionsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdFormsFormIdVersionsResponse401 = {
  data: GetApiTeamsTeamIdFormsFormIdVersions401
  status: 401
}

export type getApiTeamsTeamIdFormsFormIdVersionsResponseSuccess = (getApiTeamsTeamIdFormsFormIdVersionsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdFormsFormIdVersionsResponseError = (getApiTeamsTeamIdFormsFormIdVersionsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdFormsFormIdVersionsResponse = (getApiTeamsTeamIdFormsFormIdVersionsResponseSuccess | getApiTeamsTeamIdFormsFormIdVersionsResponseError)

export const getGetApiTeamsTeamIdFormsFormIdVersionsUrl = (teamId: string,
    formId: string,) => {




  return `/api/teams/${teamId}/forms/${formId}/versions`
}

export const getApiTeamsTeamIdFormsFormIdVersions = async (teamId: string,
    formId: string, options?: RequestInit): Promise<getApiTeamsTeamIdFormsFormIdVersionsResponse> => {

  return fetcher<getApiTeamsTeamIdFormsFormIdVersionsResponse>(getGetApiTeamsTeamIdFormsFormIdVersionsUrl(teamId,formId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdEffectiveResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdEffectiveResponse401 = {
  data: GetApiTeamsTeamIdFormsFormIdVersionsFormVersionIdEffective401
  status: 401
}

export type getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdEffectiveResponseSuccess = (getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdEffectiveResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdEffectiveResponseError = (getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdEffectiveResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdEffectiveResponse = (getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdEffectiveResponseSuccess | getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdEffectiveResponseError)

export const getGetApiTeamsTeamIdFormsFormIdVersionsFormVersionIdEffectiveUrl = (teamId: string,
    formId: string,
    formVersionId: string,) => {




  return `/api/teams/${teamId}/forms/${formId}/versions/${formVersionId}/effective`
}

export const getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdEffective = async (teamId: string,
    formId: string,
    formVersionId: string, options?: RequestInit): Promise<getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdEffectiveResponse> => {

  return fetcher<getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdEffectiveResponse>(getGetApiTeamsTeamIdFormsFormIdVersionsFormVersionIdEffectiveUrl(teamId,formId,formVersionId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdFormVersionsFormVersionIdEffectiveResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdFormVersionsFormVersionIdEffectiveResponse401 = {
  data: GetApiTeamsTeamIdFormVersionsFormVersionIdEffective401
  status: 401
}

export type getApiTeamsTeamIdFormVersionsFormVersionIdEffectiveResponseSuccess = (getApiTeamsTeamIdFormVersionsFormVersionIdEffectiveResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdFormVersionsFormVersionIdEffectiveResponseError = (getApiTeamsTeamIdFormVersionsFormVersionIdEffectiveResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdFormVersionsFormVersionIdEffectiveResponse = (getApiTeamsTeamIdFormVersionsFormVersionIdEffectiveResponseSuccess | getApiTeamsTeamIdFormVersionsFormVersionIdEffectiveResponseError)

export const getGetApiTeamsTeamIdFormVersionsFormVersionIdEffectiveUrl = (teamId: string,
    formVersionId: string,) => {




  return `/api/teams/${teamId}/form-versions/${formVersionId}/effective`
}

export const getApiTeamsTeamIdFormVersionsFormVersionIdEffective = async (teamId: string,
    formVersionId: string, options?: RequestInit): Promise<getApiTeamsTeamIdFormVersionsFormVersionIdEffectiveResponse> => {

  return fetcher<getApiTeamsTeamIdFormVersionsFormVersionIdEffectiveResponse>(getGetApiTeamsTeamIdFormVersionsFormVersionIdEffectiveUrl(teamId,formVersionId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdSlotsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdSlotsResponse401 = {
  data: GetApiTeamsTeamIdFormsFormIdVersionsFormVersionIdSlots401
  status: 401
}

export type getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdSlotsResponseSuccess = (getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdSlotsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdSlotsResponseError = (getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdSlotsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdSlotsResponse = (getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdSlotsResponseSuccess | getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdSlotsResponseError)

export const getGetApiTeamsTeamIdFormsFormIdVersionsFormVersionIdSlotsUrl = (teamId: string,
    formId: string,
    formVersionId: string,
    params?: GetApiTeamsTeamIdFormsFormIdVersionsFormVersionIdSlotsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/forms/${formId}/versions/${formVersionId}/slots?${stringifiedParams}` : `/api/teams/${teamId}/forms/${formId}/versions/${formVersionId}/slots`
}

export const getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdSlots = async (teamId: string,
    formId: string,
    formVersionId: string,
    params?: GetApiTeamsTeamIdFormsFormIdVersionsFormVersionIdSlotsParams, options?: RequestInit): Promise<getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdSlotsResponse> => {

  return fetcher<getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdSlotsResponse>(getGetApiTeamsTeamIdFormsFormIdVersionsFormVersionIdSlotsUrl(teamId,formId,formVersionId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdSectionsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdSectionsResponse401 = {
  data: GetApiTeamsTeamIdFormsFormIdVersionsFormVersionIdSections401
  status: 401
}

export type getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdSectionsResponseSuccess = (getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdSectionsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdSectionsResponseError = (getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdSectionsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdSectionsResponse = (getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdSectionsResponseSuccess | getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdSectionsResponseError)

export const getGetApiTeamsTeamIdFormsFormIdVersionsFormVersionIdSectionsUrl = (teamId: string,
    formId: string,
    formVersionId: string,) => {




  return `/api/teams/${teamId}/forms/${formId}/versions/${formVersionId}/sections`
}

export const getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdSections = async (teamId: string,
    formId: string,
    formVersionId: string, options?: RequestInit): Promise<getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdSectionsResponse> => {

  return fetcher<getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdSectionsResponse>(getGetApiTeamsTeamIdFormsFormIdVersionsFormVersionIdSectionsUrl(teamId,formId,formVersionId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdYamlResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdYamlResponse401 = {
  data: GetApiTeamsTeamIdFormsFormIdVersionsFormVersionIdYaml401
  status: 401
}

export type getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdYamlResponseSuccess = (getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdYamlResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdYamlResponseError = (getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdYamlResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdYamlResponse = (getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdYamlResponseSuccess | getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdYamlResponseError)

export const getGetApiTeamsTeamIdFormsFormIdVersionsFormVersionIdYamlUrl = (teamId: string,
    formId: string,
    formVersionId: string,) => {




  return `/api/teams/${teamId}/forms/${formId}/versions/${formVersionId}/yaml`
}

export const getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdYaml = async (teamId: string,
    formId: string,
    formVersionId: string, options?: RequestInit): Promise<getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdYamlResponse> => {

  return fetcher<getApiTeamsTeamIdFormsFormIdVersionsFormVersionIdYamlResponse>(getGetApiTeamsTeamIdFormsFormIdVersionsFormVersionIdYamlUrl(teamId,formId,formVersionId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdFormVersionsFormVersionIdMetaResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdFormVersionsFormVersionIdMetaResponse401 = {
  data: GetApiTeamsTeamIdFormVersionsFormVersionIdMeta401
  status: 401
}

export type getApiTeamsTeamIdFormVersionsFormVersionIdMetaResponseSuccess = (getApiTeamsTeamIdFormVersionsFormVersionIdMetaResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdFormVersionsFormVersionIdMetaResponseError = (getApiTeamsTeamIdFormVersionsFormVersionIdMetaResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdFormVersionsFormVersionIdMetaResponse = (getApiTeamsTeamIdFormVersionsFormVersionIdMetaResponseSuccess | getApiTeamsTeamIdFormVersionsFormVersionIdMetaResponseError)

export const getGetApiTeamsTeamIdFormVersionsFormVersionIdMetaUrl = (teamId: string,
    formVersionId: string,) => {




  return `/api/teams/${teamId}/form-versions/${formVersionId}/meta`
}

export const getApiTeamsTeamIdFormVersionsFormVersionIdMeta = async (teamId: string,
    formVersionId: string, options?: RequestInit): Promise<getApiTeamsTeamIdFormVersionsFormVersionIdMetaResponse> => {

  return fetcher<getApiTeamsTeamIdFormVersionsFormVersionIdMetaResponse>(getGetApiTeamsTeamIdFormVersionsFormVersionIdMetaUrl(teamId,formVersionId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdGenaBookContextResponse200TextPlain = {
  data: TeamGenaBookContextDto
  status: 200
}

export type getApiTeamsTeamIdGenaBookContextResponse200ApplicationJson = {
  data: TeamGenaBookContextDto
  status: 200
}

export type getApiTeamsTeamIdGenaBookContextResponse200TextJson = {
  data: TeamGenaBookContextDto
  status: 200
}

export type getApiTeamsTeamIdGenaBookContextResponse401 = {
  data: GetApiTeamsTeamIdGenaBookContext401
  status: 401
}

export type getApiTeamsTeamIdGenaBookContextResponseSuccess = (getApiTeamsTeamIdGenaBookContextResponse200TextPlain | getApiTeamsTeamIdGenaBookContextResponse200ApplicationJson | getApiTeamsTeamIdGenaBookContextResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsTeamIdGenaBookContextResponseError = (getApiTeamsTeamIdGenaBookContextResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdGenaBookContextResponse = (getApiTeamsTeamIdGenaBookContextResponseSuccess | getApiTeamsTeamIdGenaBookContextResponseError)

export const getGetApiTeamsTeamIdGenaBookContextUrl = (teamId: string,
    params?: GetApiTeamsTeamIdGenaBookContextParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/gena/book-context?${stringifiedParams}` : `/api/teams/${teamId}/gena/book-context`
}

export const getApiTeamsTeamIdGenaBookContext = async (teamId: string,
    params?: GetApiTeamsTeamIdGenaBookContextParams, options?: RequestInit): Promise<getApiTeamsTeamIdGenaBookContextResponse> => {

  return fetcher<getApiTeamsTeamIdGenaBookContextResponse>(getGetApiTeamsTeamIdGenaBookContextUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsResponse200TextPlain = {
  data: TeamInsuranceTypeActivationPayload[]
  status: 200
}

export type getApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsResponse200ApplicationJson = {
  data: TeamInsuranceTypeActivationPayload[]
  status: 200
}

export type getApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsResponse200TextJson = {
  data: TeamInsuranceTypeActivationPayload[]
  status: 200
}

export type getApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsResponse401 = {
  data: GetApiTeamsTeamIdInsuranceModelInsuranceTypeActivations401
  status: 401
}

export type getApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsResponseSuccess = (getApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsResponse200TextPlain | getApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsResponse200ApplicationJson | getApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsResponseError = (getApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsResponse = (getApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsResponseSuccess | getApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsResponseError)

export const getGetApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/insurance-model/insurance-type-activations`
}

export const getApiTeamsTeamIdInsuranceModelInsuranceTypeActivations = async (teamId: string, options?: RequestInit): Promise<getApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsResponse> => {

  return fetcher<getApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsResponse>(getGetApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsUrl(teamId),
  {
    ...options,
    method: 'GET'


  }
);}



export type putApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCodeResponse200TextPlain = {
  data: TeamInsuranceTypeActivationPayload
  status: 200
}

export type putApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCodeResponse200ApplicationJson = {
  data: TeamInsuranceTypeActivationPayload
  status: 200
}

export type putApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCodeResponse200TextJson = {
  data: TeamInsuranceTypeActivationPayload
  status: 200
}

export type putApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCodeResponse401 = {
  data: PutApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCode401
  status: 401
}

export type putApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCodeResponse402 = {
  data: PutApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCode402
  status: 402
}

export type putApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCodeResponseSuccess = (putApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCodeResponse200TextPlain | putApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCodeResponse200ApplicationJson | putApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCodeResponse200TextJson) & {
  headers: Headers;
};
export type putApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCodeResponseError = (putApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCodeResponse401 | putApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCodeResponse402) & {
  headers: Headers;
};

export type putApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCodeResponse = (putApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCodeResponseSuccess | putApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCodeResponseError)

export const getPutApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCodeUrl = (teamId: string,
    insuranceTypeCode: string,) => {




  return `/api/teams/${teamId}/insurance-model/insurance-type-activations/${insuranceTypeCode}`
}

export const putApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCode = async (teamId: string,
    insuranceTypeCode: string,
    teamInsuranceTypeActivationRequest: TeamInsuranceTypeActivationRequest, options?: RequestInit): Promise<putApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCodeResponse> => {

  return fetcher<putApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCodeResponse>(getPutApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCodeUrl(teamId,insuranceTypeCode),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      teamInsuranceTypeActivationRequest,)
  }
);}



export type deleteApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCodeResponse200TextPlain = {
  data: TeamInsuranceTypeActivationPayload
  status: 200
}

export type deleteApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCodeResponse200ApplicationJson = {
  data: TeamInsuranceTypeActivationPayload
  status: 200
}

export type deleteApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCodeResponse200TextJson = {
  data: TeamInsuranceTypeActivationPayload
  status: 200
}

export type deleteApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCodeResponse401 = {
  data: DeleteApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCode401
  status: 401
}

export type deleteApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCodeResponse402 = {
  data: DeleteApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCode402
  status: 402
}

export type deleteApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCodeResponseSuccess = (deleteApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCodeResponse200TextPlain | deleteApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCodeResponse200ApplicationJson | deleteApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCodeResponse200TextJson) & {
  headers: Headers;
};
export type deleteApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCodeResponseError = (deleteApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCodeResponse401 | deleteApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCodeResponse402) & {
  headers: Headers;
};

export type deleteApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCodeResponse = (deleteApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCodeResponseSuccess | deleteApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCodeResponseError)

export const getDeleteApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCodeUrl = (teamId: string,
    insuranceTypeCode: string,) => {




  return `/api/teams/${teamId}/insurance-model/insurance-type-activations/${insuranceTypeCode}`
}

export const deleteApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCode = async (teamId: string,
    insuranceTypeCode: string, options?: RequestInit): Promise<deleteApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCodeResponse> => {

  return fetcher<deleteApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCodeResponse>(getDeleteApiTeamsTeamIdInsuranceModelInsuranceTypeActivationsInsuranceTypeCodeUrl(teamId,insuranceTypeCode),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type getApiTeamsTeamIdInsuranceModelOverviewResponse200TextPlain = {
  data: TeamInsuranceModelOverviewPayload
  status: 200
}

export type getApiTeamsTeamIdInsuranceModelOverviewResponse200ApplicationJson = {
  data: TeamInsuranceModelOverviewPayload
  status: 200
}

export type getApiTeamsTeamIdInsuranceModelOverviewResponse200TextJson = {
  data: TeamInsuranceModelOverviewPayload
  status: 200
}

export type getApiTeamsTeamIdInsuranceModelOverviewResponse401 = {
  data: GetApiTeamsTeamIdInsuranceModelOverview401
  status: 401
}

export type getApiTeamsTeamIdInsuranceModelOverviewResponseSuccess = (getApiTeamsTeamIdInsuranceModelOverviewResponse200TextPlain | getApiTeamsTeamIdInsuranceModelOverviewResponse200ApplicationJson | getApiTeamsTeamIdInsuranceModelOverviewResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsTeamIdInsuranceModelOverviewResponseError = (getApiTeamsTeamIdInsuranceModelOverviewResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdInsuranceModelOverviewResponse = (getApiTeamsTeamIdInsuranceModelOverviewResponseSuccess | getApiTeamsTeamIdInsuranceModelOverviewResponseError)

export const getGetApiTeamsTeamIdInsuranceModelOverviewUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/insurance-model/overview`
}

export const getApiTeamsTeamIdInsuranceModelOverview = async (teamId: string, options?: RequestInit): Promise<getApiTeamsTeamIdInsuranceModelOverviewResponse> => {

  return fetcher<getApiTeamsTeamIdInsuranceModelOverviewResponse>(getGetApiTeamsTeamIdInsuranceModelOverviewUrl(teamId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdIntegrationsEsignResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdIntegrationsEsignResponse401 = {
  data: GetApiTeamsTeamIdIntegrationsEsign401
  status: 401
}

export type getApiTeamsTeamIdIntegrationsEsignResponseSuccess = (getApiTeamsTeamIdIntegrationsEsignResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdIntegrationsEsignResponseError = (getApiTeamsTeamIdIntegrationsEsignResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdIntegrationsEsignResponse = (getApiTeamsTeamIdIntegrationsEsignResponseSuccess | getApiTeamsTeamIdIntegrationsEsignResponseError)

export const getGetApiTeamsTeamIdIntegrationsEsignUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/integrations/esign`
}

export const getApiTeamsTeamIdIntegrationsEsign = async (teamId: string, options?: RequestInit): Promise<getApiTeamsTeamIdIntegrationsEsignResponse> => {

  return fetcher<getApiTeamsTeamIdIntegrationsEsignResponse>(getGetApiTeamsTeamIdIntegrationsEsignUrl(teamId),
  {
    ...options,
    method: 'GET'


  }
);}



export type putApiTeamsTeamIdIntegrationsEsignResponse200 = {
  data: void
  status: 200
}

export type putApiTeamsTeamIdIntegrationsEsignResponse401 = {
  data: PutApiTeamsTeamIdIntegrationsEsign401
  status: 401
}

export type putApiTeamsTeamIdIntegrationsEsignResponse402 = {
  data: PutApiTeamsTeamIdIntegrationsEsign402
  status: 402
}

export type putApiTeamsTeamIdIntegrationsEsignResponseSuccess = (putApiTeamsTeamIdIntegrationsEsignResponse200) & {
  headers: Headers;
};
export type putApiTeamsTeamIdIntegrationsEsignResponseError = (putApiTeamsTeamIdIntegrationsEsignResponse401 | putApiTeamsTeamIdIntegrationsEsignResponse402) & {
  headers: Headers;
};

export type putApiTeamsTeamIdIntegrationsEsignResponse = (putApiTeamsTeamIdIntegrationsEsignResponseSuccess | putApiTeamsTeamIdIntegrationsEsignResponseError)

export const getPutApiTeamsTeamIdIntegrationsEsignUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/integrations/esign`
}

export const putApiTeamsTeamIdIntegrationsEsign = async (teamId: string,
    teamEsignSettingsRequest: TeamEsignSettingsRequest, options?: RequestInit): Promise<putApiTeamsTeamIdIntegrationsEsignResponse> => {

  return fetcher<putApiTeamsTeamIdIntegrationsEsignResponse>(getPutApiTeamsTeamIdIntegrationsEsignUrl(teamId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      teamEsignSettingsRequest,)
  }
);}



export type postApiTeamsTeamIdIntegrationsEsignDocusignConnectStartResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdIntegrationsEsignDocusignConnectStartResponse401 = {
  data: PostApiTeamsTeamIdIntegrationsEsignDocusignConnectStart401
  status: 401
}

export type postApiTeamsTeamIdIntegrationsEsignDocusignConnectStartResponse402 = {
  data: PostApiTeamsTeamIdIntegrationsEsignDocusignConnectStart402
  status: 402
}

export type postApiTeamsTeamIdIntegrationsEsignDocusignConnectStartResponseSuccess = (postApiTeamsTeamIdIntegrationsEsignDocusignConnectStartResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdIntegrationsEsignDocusignConnectStartResponseError = (postApiTeamsTeamIdIntegrationsEsignDocusignConnectStartResponse401 | postApiTeamsTeamIdIntegrationsEsignDocusignConnectStartResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdIntegrationsEsignDocusignConnectStartResponse = (postApiTeamsTeamIdIntegrationsEsignDocusignConnectStartResponseSuccess | postApiTeamsTeamIdIntegrationsEsignDocusignConnectStartResponseError)

export const getPostApiTeamsTeamIdIntegrationsEsignDocusignConnectStartUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/integrations/esign/docusign/connect/start`
}

export const postApiTeamsTeamIdIntegrationsEsignDocusignConnectStart = async (teamId: string,
    nullDocusignConnectStartRequest: null | DocusignConnectStartRequest, options?: RequestInit): Promise<postApiTeamsTeamIdIntegrationsEsignDocusignConnectStartResponse> => {

  return fetcher<postApiTeamsTeamIdIntegrationsEsignDocusignConnectStartResponse>(getPostApiTeamsTeamIdIntegrationsEsignDocusignConnectStartUrl(teamId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullDocusignConnectStartRequest,)
  }
);}



export type postApiTeamsTeamIdIntegrationsEsignDocusignDisconnectResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdIntegrationsEsignDocusignDisconnectResponse401 = {
  data: PostApiTeamsTeamIdIntegrationsEsignDocusignDisconnect401
  status: 401
}

export type postApiTeamsTeamIdIntegrationsEsignDocusignDisconnectResponse402 = {
  data: PostApiTeamsTeamIdIntegrationsEsignDocusignDisconnect402
  status: 402
}

export type postApiTeamsTeamIdIntegrationsEsignDocusignDisconnectResponseSuccess = (postApiTeamsTeamIdIntegrationsEsignDocusignDisconnectResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdIntegrationsEsignDocusignDisconnectResponseError = (postApiTeamsTeamIdIntegrationsEsignDocusignDisconnectResponse401 | postApiTeamsTeamIdIntegrationsEsignDocusignDisconnectResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdIntegrationsEsignDocusignDisconnectResponse = (postApiTeamsTeamIdIntegrationsEsignDocusignDisconnectResponseSuccess | postApiTeamsTeamIdIntegrationsEsignDocusignDisconnectResponseError)

export const getPostApiTeamsTeamIdIntegrationsEsignDocusignDisconnectUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/integrations/esign/docusign/disconnect`
}

export const postApiTeamsTeamIdIntegrationsEsignDocusignDisconnect = async (teamId: string, options?: RequestInit): Promise<postApiTeamsTeamIdIntegrationsEsignDocusignDisconnectResponse> => {

  return fetcher<postApiTeamsTeamIdIntegrationsEsignDocusignDisconnectResponse>(getPostApiTeamsTeamIdIntegrationsEsignDocusignDisconnectUrl(teamId),
  {
    ...options,
    method: 'POST'


  }
);}



export type postApiTeamsTeamIdIntegrationsEsignSendResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdIntegrationsEsignSendResponse401 = {
  data: PostApiTeamsTeamIdIntegrationsEsignSend401
  status: 401
}

export type postApiTeamsTeamIdIntegrationsEsignSendResponse402 = {
  data: PostApiTeamsTeamIdIntegrationsEsignSend402
  status: 402
}

export type postApiTeamsTeamIdIntegrationsEsignSendResponseSuccess = (postApiTeamsTeamIdIntegrationsEsignSendResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdIntegrationsEsignSendResponseError = (postApiTeamsTeamIdIntegrationsEsignSendResponse401 | postApiTeamsTeamIdIntegrationsEsignSendResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdIntegrationsEsignSendResponse = (postApiTeamsTeamIdIntegrationsEsignSendResponseSuccess | postApiTeamsTeamIdIntegrationsEsignSendResponseError)

export const getPostApiTeamsTeamIdIntegrationsEsignSendUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/integrations/esign/send`
}

export const postApiTeamsTeamIdIntegrationsEsignSend = async (teamId: string,
    teamEsignSendRequest: TeamEsignSendRequest, options?: RequestInit): Promise<postApiTeamsTeamIdIntegrationsEsignSendResponse> => {

  return fetcher<postApiTeamsTeamIdIntegrationsEsignSendResponse>(getPostApiTeamsTeamIdIntegrationsEsignSendUrl(teamId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      teamEsignSendRequest,)
  }
);}



export type getApiTeamsTeamIdIntegrationsPaymentsStripeResponse200TextPlain = {
  data: TeamPaymentAccountStatusDto
  status: 200
}

export type getApiTeamsTeamIdIntegrationsPaymentsStripeResponse200ApplicationJson = {
  data: TeamPaymentAccountStatusDto
  status: 200
}

export type getApiTeamsTeamIdIntegrationsPaymentsStripeResponse200TextJson = {
  data: TeamPaymentAccountStatusDto
  status: 200
}

export type getApiTeamsTeamIdIntegrationsPaymentsStripeResponse401 = {
  data: GetApiTeamsTeamIdIntegrationsPaymentsStripe401
  status: 401
}

export type getApiTeamsTeamIdIntegrationsPaymentsStripeResponseSuccess = (getApiTeamsTeamIdIntegrationsPaymentsStripeResponse200TextPlain | getApiTeamsTeamIdIntegrationsPaymentsStripeResponse200ApplicationJson | getApiTeamsTeamIdIntegrationsPaymentsStripeResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsTeamIdIntegrationsPaymentsStripeResponseError = (getApiTeamsTeamIdIntegrationsPaymentsStripeResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdIntegrationsPaymentsStripeResponse = (getApiTeamsTeamIdIntegrationsPaymentsStripeResponseSuccess | getApiTeamsTeamIdIntegrationsPaymentsStripeResponseError)

export const getGetApiTeamsTeamIdIntegrationsPaymentsStripeUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/integrations/payments/stripe`
}

export const getApiTeamsTeamIdIntegrationsPaymentsStripe = async (teamId: string, options?: RequestInit): Promise<getApiTeamsTeamIdIntegrationsPaymentsStripeResponse> => {

  return fetcher<getApiTeamsTeamIdIntegrationsPaymentsStripeResponse>(getGetApiTeamsTeamIdIntegrationsPaymentsStripeUrl(teamId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdIntegrationsPaymentsStripeOnboardingLinkResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdIntegrationsPaymentsStripeOnboardingLinkResponse401 = {
  data: PostApiTeamsTeamIdIntegrationsPaymentsStripeOnboardingLink401
  status: 401
}

export type postApiTeamsTeamIdIntegrationsPaymentsStripeOnboardingLinkResponse402 = {
  data: PostApiTeamsTeamIdIntegrationsPaymentsStripeOnboardingLink402
  status: 402
}

export type postApiTeamsTeamIdIntegrationsPaymentsStripeOnboardingLinkResponseSuccess = (postApiTeamsTeamIdIntegrationsPaymentsStripeOnboardingLinkResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdIntegrationsPaymentsStripeOnboardingLinkResponseError = (postApiTeamsTeamIdIntegrationsPaymentsStripeOnboardingLinkResponse401 | postApiTeamsTeamIdIntegrationsPaymentsStripeOnboardingLinkResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdIntegrationsPaymentsStripeOnboardingLinkResponse = (postApiTeamsTeamIdIntegrationsPaymentsStripeOnboardingLinkResponseSuccess | postApiTeamsTeamIdIntegrationsPaymentsStripeOnboardingLinkResponseError)

export const getPostApiTeamsTeamIdIntegrationsPaymentsStripeOnboardingLinkUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/integrations/payments/stripe/onboarding-link`
}

export const postApiTeamsTeamIdIntegrationsPaymentsStripeOnboardingLink = async (teamId: string,
    nullTeamPaymentOnboardingLinkRequest: null | TeamPaymentOnboardingLinkRequest, options?: RequestInit): Promise<postApiTeamsTeamIdIntegrationsPaymentsStripeOnboardingLinkResponse> => {

  return fetcher<postApiTeamsTeamIdIntegrationsPaymentsStripeOnboardingLinkResponse>(getPostApiTeamsTeamIdIntegrationsPaymentsStripeOnboardingLinkUrl(teamId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullTeamPaymentOnboardingLinkRequest,)
  }
);}



export type postApiTeamsTeamIdIntegrationsPaymentsStripeRefreshResponse200TextPlain = {
  data: TeamPaymentAccountStatusDto
  status: 200
}

export type postApiTeamsTeamIdIntegrationsPaymentsStripeRefreshResponse200ApplicationJson = {
  data: TeamPaymentAccountStatusDto
  status: 200
}

export type postApiTeamsTeamIdIntegrationsPaymentsStripeRefreshResponse200TextJson = {
  data: TeamPaymentAccountStatusDto
  status: 200
}

export type postApiTeamsTeamIdIntegrationsPaymentsStripeRefreshResponse401 = {
  data: PostApiTeamsTeamIdIntegrationsPaymentsStripeRefresh401
  status: 401
}

export type postApiTeamsTeamIdIntegrationsPaymentsStripeRefreshResponse402 = {
  data: PostApiTeamsTeamIdIntegrationsPaymentsStripeRefresh402
  status: 402
}

export type postApiTeamsTeamIdIntegrationsPaymentsStripeRefreshResponseSuccess = (postApiTeamsTeamIdIntegrationsPaymentsStripeRefreshResponse200TextPlain | postApiTeamsTeamIdIntegrationsPaymentsStripeRefreshResponse200ApplicationJson | postApiTeamsTeamIdIntegrationsPaymentsStripeRefreshResponse200TextJson) & {
  headers: Headers;
};
export type postApiTeamsTeamIdIntegrationsPaymentsStripeRefreshResponseError = (postApiTeamsTeamIdIntegrationsPaymentsStripeRefreshResponse401 | postApiTeamsTeamIdIntegrationsPaymentsStripeRefreshResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdIntegrationsPaymentsStripeRefreshResponse = (postApiTeamsTeamIdIntegrationsPaymentsStripeRefreshResponseSuccess | postApiTeamsTeamIdIntegrationsPaymentsStripeRefreshResponseError)

export const getPostApiTeamsTeamIdIntegrationsPaymentsStripeRefreshUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/integrations/payments/stripe/refresh`
}

export const postApiTeamsTeamIdIntegrationsPaymentsStripeRefresh = async (teamId: string, options?: RequestInit): Promise<postApiTeamsTeamIdIntegrationsPaymentsStripeRefreshResponse> => {

  return fetcher<postApiTeamsTeamIdIntegrationsPaymentsStripeRefreshResponse>(getPostApiTeamsTeamIdIntegrationsPaymentsStripeRefreshUrl(teamId),
  {
    ...options,
    method: 'POST'


  }
);}



export type getApiTeamsTeamIdIntegrationsEsignDocusignCallbackResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdIntegrationsEsignDocusignCallbackResponseSuccess = (getApiTeamsTeamIdIntegrationsEsignDocusignCallbackResponse200) & {
  headers: Headers;
};
;

export type getApiTeamsTeamIdIntegrationsEsignDocusignCallbackResponse = (getApiTeamsTeamIdIntegrationsEsignDocusignCallbackResponseSuccess)

export const getGetApiTeamsTeamIdIntegrationsEsignDocusignCallbackUrl = (teamId: string,
    params?: GetApiTeamsTeamIdIntegrationsEsignDocusignCallbackParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/integrations/esign/docusign/callback?${stringifiedParams}` : `/api/teams/${teamId}/integrations/esign/docusign/callback`
}

export const getApiTeamsTeamIdIntegrationsEsignDocusignCallback = async (teamId: string,
    params?: GetApiTeamsTeamIdIntegrationsEsignDocusignCallbackParams, options?: RequestInit): Promise<getApiTeamsTeamIdIntegrationsEsignDocusignCallbackResponse> => {

  return fetcher<getApiTeamsTeamIdIntegrationsEsignDocusignCallbackResponse>(getGetApiTeamsTeamIdIntegrationsEsignDocusignCallbackUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdAgentsLeadPreparationRunsResponse200TextPlain = {
  data: LeadPreparationRunListResponse
  status: 200
}

export type getApiTeamsTeamIdAgentsLeadPreparationRunsResponse200ApplicationJson = {
  data: LeadPreparationRunListResponse
  status: 200
}

export type getApiTeamsTeamIdAgentsLeadPreparationRunsResponse200TextJson = {
  data: LeadPreparationRunListResponse
  status: 200
}

export type getApiTeamsTeamIdAgentsLeadPreparationRunsResponse400TextPlain = {
  data: TeamAgentErrorResponse
  status: 400
}

export type getApiTeamsTeamIdAgentsLeadPreparationRunsResponse400ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 400
}

export type getApiTeamsTeamIdAgentsLeadPreparationRunsResponse400TextJson = {
  data: TeamAgentErrorResponse
  status: 400
}

export type getApiTeamsTeamIdAgentsLeadPreparationRunsResponse401TextPlain = {
  data: TeamAgentErrorResponse
  status: 401
}

export type getApiTeamsTeamIdAgentsLeadPreparationRunsResponse401ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 401
}

export type getApiTeamsTeamIdAgentsLeadPreparationRunsResponse401TextJson = {
  data: TeamAgentErrorResponse
  status: 401
}

export type getApiTeamsTeamIdAgentsLeadPreparationRunsResponse403TextPlain = {
  data: TeamAgentErrorResponse
  status: 403
}

export type getApiTeamsTeamIdAgentsLeadPreparationRunsResponse403ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type getApiTeamsTeamIdAgentsLeadPreparationRunsResponse403TextJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type getApiTeamsTeamIdAgentsLeadPreparationRunsResponse500TextPlain = {
  data: TeamAgentErrorResponse
  status: 500
}

export type getApiTeamsTeamIdAgentsLeadPreparationRunsResponse500ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 500
}

export type getApiTeamsTeamIdAgentsLeadPreparationRunsResponse500TextJson = {
  data: TeamAgentErrorResponse
  status: 500
}

export type getApiTeamsTeamIdAgentsLeadPreparationRunsResponseSuccess = (getApiTeamsTeamIdAgentsLeadPreparationRunsResponse200TextPlain | getApiTeamsTeamIdAgentsLeadPreparationRunsResponse200ApplicationJson | getApiTeamsTeamIdAgentsLeadPreparationRunsResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsTeamIdAgentsLeadPreparationRunsResponseError = (getApiTeamsTeamIdAgentsLeadPreparationRunsResponse400TextPlain | getApiTeamsTeamIdAgentsLeadPreparationRunsResponse400ApplicationJson | getApiTeamsTeamIdAgentsLeadPreparationRunsResponse400TextJson | getApiTeamsTeamIdAgentsLeadPreparationRunsResponse401TextPlain | getApiTeamsTeamIdAgentsLeadPreparationRunsResponse401ApplicationJson | getApiTeamsTeamIdAgentsLeadPreparationRunsResponse401TextJson | getApiTeamsTeamIdAgentsLeadPreparationRunsResponse403TextPlain | getApiTeamsTeamIdAgentsLeadPreparationRunsResponse403ApplicationJson | getApiTeamsTeamIdAgentsLeadPreparationRunsResponse403TextJson | getApiTeamsTeamIdAgentsLeadPreparationRunsResponse500TextPlain | getApiTeamsTeamIdAgentsLeadPreparationRunsResponse500ApplicationJson | getApiTeamsTeamIdAgentsLeadPreparationRunsResponse500TextJson) & {
  headers: Headers;
};

export type getApiTeamsTeamIdAgentsLeadPreparationRunsResponse = (getApiTeamsTeamIdAgentsLeadPreparationRunsResponseSuccess | getApiTeamsTeamIdAgentsLeadPreparationRunsResponseError)

export const getGetApiTeamsTeamIdAgentsLeadPreparationRunsUrl = (teamId: string,
    params?: GetApiTeamsTeamIdAgentsLeadPreparationRunsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/agents/lead-preparation/runs?${stringifiedParams}` : `/api/teams/${teamId}/agents/lead-preparation/runs`
}

export const getApiTeamsTeamIdAgentsLeadPreparationRuns = async (teamId: string,
    params?: GetApiTeamsTeamIdAgentsLeadPreparationRunsParams, options?: RequestInit): Promise<getApiTeamsTeamIdAgentsLeadPreparationRunsResponse> => {

  return fetcher<getApiTeamsTeamIdAgentsLeadPreparationRunsResponse>(getGetApiTeamsTeamIdAgentsLeadPreparationRunsUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdAgentsLeadPreparationRunsResponse201TextPlain = {
  data: LeadPreparationRunStateResponse
  status: 201
}

export type postApiTeamsTeamIdAgentsLeadPreparationRunsResponse201ApplicationJson = {
  data: LeadPreparationRunStateResponse
  status: 201
}

export type postApiTeamsTeamIdAgentsLeadPreparationRunsResponse201TextJson = {
  data: LeadPreparationRunStateResponse
  status: 201
}

export type postApiTeamsTeamIdAgentsLeadPreparationRunsResponse400TextPlain = {
  data: TeamAgentErrorResponse
  status: 400
}

export type postApiTeamsTeamIdAgentsLeadPreparationRunsResponse400ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 400
}

export type postApiTeamsTeamIdAgentsLeadPreparationRunsResponse400TextJson = {
  data: TeamAgentErrorResponse
  status: 400
}

export type postApiTeamsTeamIdAgentsLeadPreparationRunsResponse401TextPlain = {
  data: TeamAgentErrorResponse
  status: 401
}

export type postApiTeamsTeamIdAgentsLeadPreparationRunsResponse401ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 401
}

export type postApiTeamsTeamIdAgentsLeadPreparationRunsResponse401TextJson = {
  data: TeamAgentErrorResponse
  status: 401
}

export type postApiTeamsTeamIdAgentsLeadPreparationRunsResponse402 = {
  data: PostApiTeamsTeamIdAgentsLeadPreparationRuns402
  status: 402
}

export type postApiTeamsTeamIdAgentsLeadPreparationRunsResponse403TextPlain = {
  data: TeamAgentErrorResponse
  status: 403
}

export type postApiTeamsTeamIdAgentsLeadPreparationRunsResponse403ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type postApiTeamsTeamIdAgentsLeadPreparationRunsResponse403TextJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type postApiTeamsTeamIdAgentsLeadPreparationRunsResponse500TextPlain = {
  data: TeamAgentErrorResponse
  status: 500
}

export type postApiTeamsTeamIdAgentsLeadPreparationRunsResponse500ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 500
}

export type postApiTeamsTeamIdAgentsLeadPreparationRunsResponse500TextJson = {
  data: TeamAgentErrorResponse
  status: 500
}

export type postApiTeamsTeamIdAgentsLeadPreparationRunsResponseSuccess = (postApiTeamsTeamIdAgentsLeadPreparationRunsResponse201TextPlain | postApiTeamsTeamIdAgentsLeadPreparationRunsResponse201ApplicationJson | postApiTeamsTeamIdAgentsLeadPreparationRunsResponse201TextJson) & {
  headers: Headers;
};
export type postApiTeamsTeamIdAgentsLeadPreparationRunsResponseError = (postApiTeamsTeamIdAgentsLeadPreparationRunsResponse400TextPlain | postApiTeamsTeamIdAgentsLeadPreparationRunsResponse400ApplicationJson | postApiTeamsTeamIdAgentsLeadPreparationRunsResponse400TextJson | postApiTeamsTeamIdAgentsLeadPreparationRunsResponse401TextPlain | postApiTeamsTeamIdAgentsLeadPreparationRunsResponse401ApplicationJson | postApiTeamsTeamIdAgentsLeadPreparationRunsResponse401TextJson | postApiTeamsTeamIdAgentsLeadPreparationRunsResponse402 | postApiTeamsTeamIdAgentsLeadPreparationRunsResponse403TextPlain | postApiTeamsTeamIdAgentsLeadPreparationRunsResponse403ApplicationJson | postApiTeamsTeamIdAgentsLeadPreparationRunsResponse403TextJson | postApiTeamsTeamIdAgentsLeadPreparationRunsResponse500TextPlain | postApiTeamsTeamIdAgentsLeadPreparationRunsResponse500ApplicationJson | postApiTeamsTeamIdAgentsLeadPreparationRunsResponse500TextJson) & {
  headers: Headers;
};

export type postApiTeamsTeamIdAgentsLeadPreparationRunsResponse = (postApiTeamsTeamIdAgentsLeadPreparationRunsResponseSuccess | postApiTeamsTeamIdAgentsLeadPreparationRunsResponseError)

export const getPostApiTeamsTeamIdAgentsLeadPreparationRunsUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/agents/lead-preparation/runs`
}

export const postApiTeamsTeamIdAgentsLeadPreparationRuns = async (teamId: string,
    leadPreparationRunStartRequest: LeadPreparationRunStartRequest, options?: RequestInit): Promise<postApiTeamsTeamIdAgentsLeadPreparationRunsResponse> => {

  return fetcher<postApiTeamsTeamIdAgentsLeadPreparationRunsResponse>(getPostApiTeamsTeamIdAgentsLeadPreparationRunsUrl(teamId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      leadPreparationRunStartRequest,)
  }
);}



export type getApiTeamsTeamIdAgentsLeadPreparationRunsRunIdResponse200TextPlain = {
  data: LeadPreparationRunStateResponse
  status: 200
}

export type getApiTeamsTeamIdAgentsLeadPreparationRunsRunIdResponse200ApplicationJson = {
  data: LeadPreparationRunStateResponse
  status: 200
}

export type getApiTeamsTeamIdAgentsLeadPreparationRunsRunIdResponse200TextJson = {
  data: LeadPreparationRunStateResponse
  status: 200
}

export type getApiTeamsTeamIdAgentsLeadPreparationRunsRunIdResponse400TextPlain = {
  data: TeamAgentErrorResponse
  status: 400
}

export type getApiTeamsTeamIdAgentsLeadPreparationRunsRunIdResponse400ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 400
}

export type getApiTeamsTeamIdAgentsLeadPreparationRunsRunIdResponse400TextJson = {
  data: TeamAgentErrorResponse
  status: 400
}

export type getApiTeamsTeamIdAgentsLeadPreparationRunsRunIdResponse401TextPlain = {
  data: TeamAgentErrorResponse
  status: 401
}

export type getApiTeamsTeamIdAgentsLeadPreparationRunsRunIdResponse401ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 401
}

export type getApiTeamsTeamIdAgentsLeadPreparationRunsRunIdResponse401TextJson = {
  data: TeamAgentErrorResponse
  status: 401
}

export type getApiTeamsTeamIdAgentsLeadPreparationRunsRunIdResponse403TextPlain = {
  data: TeamAgentErrorResponse
  status: 403
}

export type getApiTeamsTeamIdAgentsLeadPreparationRunsRunIdResponse403ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type getApiTeamsTeamIdAgentsLeadPreparationRunsRunIdResponse403TextJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type getApiTeamsTeamIdAgentsLeadPreparationRunsRunIdResponse404TextPlain = {
  data: TeamAgentErrorResponse
  status: 404
}

export type getApiTeamsTeamIdAgentsLeadPreparationRunsRunIdResponse404ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 404
}

export type getApiTeamsTeamIdAgentsLeadPreparationRunsRunIdResponse404TextJson = {
  data: TeamAgentErrorResponse
  status: 404
}

export type getApiTeamsTeamIdAgentsLeadPreparationRunsRunIdResponse500TextPlain = {
  data: TeamAgentErrorResponse
  status: 500
}

export type getApiTeamsTeamIdAgentsLeadPreparationRunsRunIdResponse500ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 500
}

export type getApiTeamsTeamIdAgentsLeadPreparationRunsRunIdResponse500TextJson = {
  data: TeamAgentErrorResponse
  status: 500
}

export type getApiTeamsTeamIdAgentsLeadPreparationRunsRunIdResponseSuccess = (getApiTeamsTeamIdAgentsLeadPreparationRunsRunIdResponse200TextPlain | getApiTeamsTeamIdAgentsLeadPreparationRunsRunIdResponse200ApplicationJson | getApiTeamsTeamIdAgentsLeadPreparationRunsRunIdResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsTeamIdAgentsLeadPreparationRunsRunIdResponseError = (getApiTeamsTeamIdAgentsLeadPreparationRunsRunIdResponse400TextPlain | getApiTeamsTeamIdAgentsLeadPreparationRunsRunIdResponse400ApplicationJson | getApiTeamsTeamIdAgentsLeadPreparationRunsRunIdResponse400TextJson | getApiTeamsTeamIdAgentsLeadPreparationRunsRunIdResponse401TextPlain | getApiTeamsTeamIdAgentsLeadPreparationRunsRunIdResponse401ApplicationJson | getApiTeamsTeamIdAgentsLeadPreparationRunsRunIdResponse401TextJson | getApiTeamsTeamIdAgentsLeadPreparationRunsRunIdResponse403TextPlain | getApiTeamsTeamIdAgentsLeadPreparationRunsRunIdResponse403ApplicationJson | getApiTeamsTeamIdAgentsLeadPreparationRunsRunIdResponse403TextJson | getApiTeamsTeamIdAgentsLeadPreparationRunsRunIdResponse404TextPlain | getApiTeamsTeamIdAgentsLeadPreparationRunsRunIdResponse404ApplicationJson | getApiTeamsTeamIdAgentsLeadPreparationRunsRunIdResponse404TextJson | getApiTeamsTeamIdAgentsLeadPreparationRunsRunIdResponse500TextPlain | getApiTeamsTeamIdAgentsLeadPreparationRunsRunIdResponse500ApplicationJson | getApiTeamsTeamIdAgentsLeadPreparationRunsRunIdResponse500TextJson) & {
  headers: Headers;
};

export type getApiTeamsTeamIdAgentsLeadPreparationRunsRunIdResponse = (getApiTeamsTeamIdAgentsLeadPreparationRunsRunIdResponseSuccess | getApiTeamsTeamIdAgentsLeadPreparationRunsRunIdResponseError)

export const getGetApiTeamsTeamIdAgentsLeadPreparationRunsRunIdUrl = (teamId: string,
    runId: string,) => {




  return `/api/teams/${teamId}/agents/lead-preparation/runs/${runId}`
}

export const getApiTeamsTeamIdAgentsLeadPreparationRunsRunId = async (teamId: string,
    runId: string, options?: RequestInit): Promise<getApiTeamsTeamIdAgentsLeadPreparationRunsRunIdResponse> => {

  return fetcher<getApiTeamsTeamIdAgentsLeadPreparationRunsRunIdResponse>(getGetApiTeamsTeamIdAgentsLeadPreparationRunsRunIdUrl(teamId,runId),
  {
    ...options,
    method: 'GET'


  }
);}



export type patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse200TextPlain = {
  data: LeadPreparationRunStateResponse
  status: 200
}

export type patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse200ApplicationJson = {
  data: LeadPreparationRunStateResponse
  status: 200
}

export type patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse200TextJson = {
  data: LeadPreparationRunStateResponse
  status: 200
}

export type patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse400TextPlain = {
  data: TeamAgentErrorResponse
  status: 400
}

export type patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse400ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 400
}

export type patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse400TextJson = {
  data: TeamAgentErrorResponse
  status: 400
}

export type patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse401TextPlain = {
  data: TeamAgentErrorResponse
  status: 401
}

export type patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse401ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 401
}

export type patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse401TextJson = {
  data: TeamAgentErrorResponse
  status: 401
}

export type patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse402 = {
  data: PatchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposal402
  status: 402
}

export type patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse403TextPlain = {
  data: TeamAgentErrorResponse
  status: 403
}

export type patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse403ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse403TextJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse404TextPlain = {
  data: TeamAgentErrorResponse
  status: 404
}

export type patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse404ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 404
}

export type patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse404TextJson = {
  data: TeamAgentErrorResponse
  status: 404
}

export type patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse409TextPlain = {
  data: LeadPreparationMutationConflictResponse
  status: 409
}

export type patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse409ApplicationJson = {
  data: LeadPreparationMutationConflictResponse
  status: 409
}

export type patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse409TextJson = {
  data: LeadPreparationMutationConflictResponse
  status: 409
}

export type patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse500TextPlain = {
  data: TeamAgentErrorResponse
  status: 500
}

export type patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse500ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 500
}

export type patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse500TextJson = {
  data: TeamAgentErrorResponse
  status: 500
}

export type patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponseSuccess = (patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse200TextPlain | patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse200ApplicationJson | patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse200TextJson) & {
  headers: Headers;
};
export type patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponseError = (patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse400TextPlain | patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse400ApplicationJson | patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse400TextJson | patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse401TextPlain | patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse401ApplicationJson | patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse401TextJson | patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse402 | patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse403TextPlain | patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse403ApplicationJson | patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse403TextJson | patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse404TextPlain | patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse404ApplicationJson | patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse404TextJson | patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse409TextPlain | patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse409ApplicationJson | patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse409TextJson | patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse500TextPlain | patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse500ApplicationJson | patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse500TextJson) & {
  headers: Headers;
};

export type patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse = (patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponseSuccess | patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponseError)

export const getPatchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalUrl = (teamId: string,
    runId: string,) => {




  return `/api/teams/${teamId}/agents/lead-preparation/runs/${runId}/checkpoints/create-lead/proposal`
}

export const patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposal = async (teamId: string,
    runId: string,
    leadPreparationProposalEditRequest: LeadPreparationProposalEditRequest, options?: RequestInit): Promise<patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse> => {

  return fetcher<patchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalResponse>(getPatchApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadProposalUrl(teamId,runId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      leadPreparationProposalEditRequest,)
  }
);}



export type postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse200TextPlain = {
  data: LeadPreparationRunStateResponse
  status: 200
}

export type postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse200ApplicationJson = {
  data: LeadPreparationRunStateResponse
  status: 200
}

export type postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse200TextJson = {
  data: LeadPreparationRunStateResponse
  status: 200
}

export type postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse400TextPlain = {
  data: TeamAgentErrorResponse
  status: 400
}

export type postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse400ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 400
}

export type postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse400TextJson = {
  data: TeamAgentErrorResponse
  status: 400
}

export type postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse401TextPlain = {
  data: TeamAgentErrorResponse
  status: 401
}

export type postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse401ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 401
}

export type postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse401TextJson = {
  data: TeamAgentErrorResponse
  status: 401
}

export type postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse402 = {
  data: PostApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecision402
  status: 402
}

export type postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse403TextPlain = {
  data: TeamAgentErrorResponse
  status: 403
}

export type postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse403ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse403TextJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse404TextPlain = {
  data: TeamAgentErrorResponse
  status: 404
}

export type postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse404ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 404
}

export type postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse404TextJson = {
  data: TeamAgentErrorResponse
  status: 404
}

export type postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse409TextPlain = {
  data: LeadPreparationMutationConflictResponse
  status: 409
}

export type postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse409ApplicationJson = {
  data: LeadPreparationMutationConflictResponse
  status: 409
}

export type postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse409TextJson = {
  data: LeadPreparationMutationConflictResponse
  status: 409
}

export type postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse500TextPlain = {
  data: TeamAgentErrorResponse
  status: 500
}

export type postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse500ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 500
}

export type postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse500TextJson = {
  data: TeamAgentErrorResponse
  status: 500
}

export type postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponseSuccess = (postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse200TextPlain | postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse200ApplicationJson | postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse200TextJson) & {
  headers: Headers;
};
export type postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponseError = (postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse400TextPlain | postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse400ApplicationJson | postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse400TextJson | postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse401TextPlain | postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse401ApplicationJson | postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse401TextJson | postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse402 | postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse403TextPlain | postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse403ApplicationJson | postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse403TextJson | postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse404TextPlain | postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse404ApplicationJson | postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse404TextJson | postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse409TextPlain | postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse409ApplicationJson | postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse409TextJson | postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse500TextPlain | postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse500ApplicationJson | postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse500TextJson) & {
  headers: Headers;
};

export type postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse = (postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponseSuccess | postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponseError)

export const getPostApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionUrl = (teamId: string,
    runId: string,) => {




  return `/api/teams/${teamId}/agents/lead-preparation/runs/${runId}/checkpoints/create-lead/decision`
}

export const postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecision = async (teamId: string,
    runId: string,
    leadPreparationCheckpointDecisionRequest: LeadPreparationCheckpointDecisionRequest, options?: RequestInit): Promise<postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse> => {

  return fetcher<postApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionResponse>(getPostApiTeamsTeamIdAgentsLeadPreparationRunsRunIdCheckpointsCreateLeadDecisionUrl(teamId,runId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      leadPreparationCheckpointDecisionRequest,)
  }
);}



export type getApiTeamsTeamIdLeadsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdLeadsResponse401 = {
  data: GetApiTeamsTeamIdLeads401
  status: 401
}

export type getApiTeamsTeamIdLeadsResponseSuccess = (getApiTeamsTeamIdLeadsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdLeadsResponseError = (getApiTeamsTeamIdLeadsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdLeadsResponse = (getApiTeamsTeamIdLeadsResponseSuccess | getApiTeamsTeamIdLeadsResponseError)

export const getGetApiTeamsTeamIdLeadsUrl = (teamId: string,
    params?: GetApiTeamsTeamIdLeadsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/leads?${stringifiedParams}` : `/api/teams/${teamId}/leads`
}

export const getApiTeamsTeamIdLeads = async (teamId: string,
    params?: GetApiTeamsTeamIdLeadsParams, options?: RequestInit): Promise<getApiTeamsTeamIdLeadsResponse> => {

  return fetcher<getApiTeamsTeamIdLeadsResponse>(getGetApiTeamsTeamIdLeadsUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdLeadsResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdLeadsResponse401 = {
  data: PostApiTeamsTeamIdLeads401
  status: 401
}

export type postApiTeamsTeamIdLeadsResponse402 = {
  data: PostApiTeamsTeamIdLeads402
  status: 402
}

export type postApiTeamsTeamIdLeadsResponseSuccess = (postApiTeamsTeamIdLeadsResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdLeadsResponseError = (postApiTeamsTeamIdLeadsResponse401 | postApiTeamsTeamIdLeadsResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdLeadsResponse = (postApiTeamsTeamIdLeadsResponseSuccess | postApiTeamsTeamIdLeadsResponseError)

export const getPostApiTeamsTeamIdLeadsUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/leads`
}

export const postApiTeamsTeamIdLeads = async (teamId: string,
    createLeadRequest: CreateLeadRequest, options?: RequestInit): Promise<postApiTeamsTeamIdLeadsResponse> => {

  return fetcher<postApiTeamsTeamIdLeadsResponse>(getPostApiTeamsTeamIdLeadsUrl(teamId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createLeadRequest,)
  }
);}



export type getApiTeamsTeamIdLeadsSummaryResponse200TextPlain = {
  data: LeadSummaryResponse
  status: 200
}

export type getApiTeamsTeamIdLeadsSummaryResponse200ApplicationJson = {
  data: LeadSummaryResponse
  status: 200
}

export type getApiTeamsTeamIdLeadsSummaryResponse200TextJson = {
  data: LeadSummaryResponse
  status: 200
}

export type getApiTeamsTeamIdLeadsSummaryResponse401 = {
  data: GetApiTeamsTeamIdLeadsSummary401
  status: 401
}

export type getApiTeamsTeamIdLeadsSummaryResponseSuccess = (getApiTeamsTeamIdLeadsSummaryResponse200TextPlain | getApiTeamsTeamIdLeadsSummaryResponse200ApplicationJson | getApiTeamsTeamIdLeadsSummaryResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsTeamIdLeadsSummaryResponseError = (getApiTeamsTeamIdLeadsSummaryResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdLeadsSummaryResponse = (getApiTeamsTeamIdLeadsSummaryResponseSuccess | getApiTeamsTeamIdLeadsSummaryResponseError)

export const getGetApiTeamsTeamIdLeadsSummaryUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/leads/summary`
}

export const getApiTeamsTeamIdLeadsSummary = async (teamId: string, options?: RequestInit): Promise<getApiTeamsTeamIdLeadsSummaryResponse> => {

  return fetcher<getApiTeamsTeamIdLeadsSummaryResponse>(getGetApiTeamsTeamIdLeadsSummaryUrl(teamId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdLeadsLeadIdResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdLeadsLeadIdResponse401 = {
  data: GetApiTeamsTeamIdLeadsLeadId401
  status: 401
}

export type getApiTeamsTeamIdLeadsLeadIdResponseSuccess = (getApiTeamsTeamIdLeadsLeadIdResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdLeadsLeadIdResponseError = (getApiTeamsTeamIdLeadsLeadIdResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdLeadsLeadIdResponse = (getApiTeamsTeamIdLeadsLeadIdResponseSuccess | getApiTeamsTeamIdLeadsLeadIdResponseError)

export const getGetApiTeamsTeamIdLeadsLeadIdUrl = (teamId: string,
    leadId: string,) => {




  return `/api/teams/${teamId}/leads/${leadId}`
}

export const getApiTeamsTeamIdLeadsLeadId = async (teamId: string,
    leadId: string, options?: RequestInit): Promise<getApiTeamsTeamIdLeadsLeadIdResponse> => {

  return fetcher<getApiTeamsTeamIdLeadsLeadIdResponse>(getGetApiTeamsTeamIdLeadsLeadIdUrl(teamId,leadId),
  {
    ...options,
    method: 'GET'


  }
);}



export type putApiTeamsTeamIdLeadsLeadIdResponse200 = {
  data: void
  status: 200
}

export type putApiTeamsTeamIdLeadsLeadIdResponse401 = {
  data: PutApiTeamsTeamIdLeadsLeadId401
  status: 401
}

export type putApiTeamsTeamIdLeadsLeadIdResponse402 = {
  data: PutApiTeamsTeamIdLeadsLeadId402
  status: 402
}

export type putApiTeamsTeamIdLeadsLeadIdResponseSuccess = (putApiTeamsTeamIdLeadsLeadIdResponse200) & {
  headers: Headers;
};
export type putApiTeamsTeamIdLeadsLeadIdResponseError = (putApiTeamsTeamIdLeadsLeadIdResponse401 | putApiTeamsTeamIdLeadsLeadIdResponse402) & {
  headers: Headers;
};

export type putApiTeamsTeamIdLeadsLeadIdResponse = (putApiTeamsTeamIdLeadsLeadIdResponseSuccess | putApiTeamsTeamIdLeadsLeadIdResponseError)

export const getPutApiTeamsTeamIdLeadsLeadIdUrl = (teamId: string,
    leadId: string,) => {




  return `/api/teams/${teamId}/leads/${leadId}`
}

export const putApiTeamsTeamIdLeadsLeadId = async (teamId: string,
    leadId: string,
    updateLeadRequest: UpdateLeadRequest, options?: RequestInit): Promise<putApiTeamsTeamIdLeadsLeadIdResponse> => {

  return fetcher<putApiTeamsTeamIdLeadsLeadIdResponse>(getPutApiTeamsTeamIdLeadsLeadIdUrl(teamId,leadId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateLeadRequest,)
  }
);}



export type deleteApiTeamsTeamIdLeadsLeadIdResponse200 = {
  data: void
  status: 200
}

export type deleteApiTeamsTeamIdLeadsLeadIdResponse401 = {
  data: DeleteApiTeamsTeamIdLeadsLeadId401
  status: 401
}

export type deleteApiTeamsTeamIdLeadsLeadIdResponse402 = {
  data: DeleteApiTeamsTeamIdLeadsLeadId402
  status: 402
}

export type deleteApiTeamsTeamIdLeadsLeadIdResponseSuccess = (deleteApiTeamsTeamIdLeadsLeadIdResponse200) & {
  headers: Headers;
};
export type deleteApiTeamsTeamIdLeadsLeadIdResponseError = (deleteApiTeamsTeamIdLeadsLeadIdResponse401 | deleteApiTeamsTeamIdLeadsLeadIdResponse402) & {
  headers: Headers;
};

export type deleteApiTeamsTeamIdLeadsLeadIdResponse = (deleteApiTeamsTeamIdLeadsLeadIdResponseSuccess | deleteApiTeamsTeamIdLeadsLeadIdResponseError)

export const getDeleteApiTeamsTeamIdLeadsLeadIdUrl = (teamId: string,
    leadId: string,) => {




  return `/api/teams/${teamId}/leads/${leadId}`
}

export const deleteApiTeamsTeamIdLeadsLeadId = async (teamId: string,
    leadId: string, options?: RequestInit): Promise<deleteApiTeamsTeamIdLeadsLeadIdResponse> => {

  return fetcher<deleteApiTeamsTeamIdLeadsLeadIdResponse>(getDeleteApiTeamsTeamIdLeadsLeadIdUrl(teamId,leadId),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type postApiTeamsTeamIdLeadsImportFromCardResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdLeadsImportFromCardResponse401 = {
  data: PostApiTeamsTeamIdLeadsImportFromCard401
  status: 401
}

export type postApiTeamsTeamIdLeadsImportFromCardResponse402 = {
  data: PostApiTeamsTeamIdLeadsImportFromCard402
  status: 402
}

export type postApiTeamsTeamIdLeadsImportFromCardResponseSuccess = (postApiTeamsTeamIdLeadsImportFromCardResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdLeadsImportFromCardResponseError = (postApiTeamsTeamIdLeadsImportFromCardResponse401 | postApiTeamsTeamIdLeadsImportFromCardResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdLeadsImportFromCardResponse = (postApiTeamsTeamIdLeadsImportFromCardResponseSuccess | postApiTeamsTeamIdLeadsImportFromCardResponseError)

export const getPostApiTeamsTeamIdLeadsImportFromCardUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/leads/import-from-card`
}

export const postApiTeamsTeamIdLeadsImportFromCard = async (teamId: string,
    postApiTeamsTeamIdLeadsImportFromCardBody: PostApiTeamsTeamIdLeadsImportFromCardBody, options?: RequestInit): Promise<postApiTeamsTeamIdLeadsImportFromCardResponse> => {
    const formData = new FormData();
if(postApiTeamsTeamIdLeadsImportFromCardBody.file !== undefined) {
 formData.append(`file`, postApiTeamsTeamIdLeadsImportFromCardBody.file);
 }

  return fetcher<postApiTeamsTeamIdLeadsImportFromCardResponse>(getPostApiTeamsTeamIdLeadsImportFromCardUrl(teamId),
  {
    ...options,
    method: 'POST'
    ,
    body:
      formData,
  }
);}



export type postApiTeamsTeamIdLeadsCheckMatchResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdLeadsCheckMatchResponse401 = {
  data: PostApiTeamsTeamIdLeadsCheckMatch401
  status: 401
}

export type postApiTeamsTeamIdLeadsCheckMatchResponseSuccess = (postApiTeamsTeamIdLeadsCheckMatchResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdLeadsCheckMatchResponseError = (postApiTeamsTeamIdLeadsCheckMatchResponse401) & {
  headers: Headers;
};

export type postApiTeamsTeamIdLeadsCheckMatchResponse = (postApiTeamsTeamIdLeadsCheckMatchResponseSuccess | postApiTeamsTeamIdLeadsCheckMatchResponseError)

export const getPostApiTeamsTeamIdLeadsCheckMatchUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/leads/check-match`
}

export const postApiTeamsTeamIdLeadsCheckMatch = async (teamId: string,
    checkLeadMatchRequest: CheckLeadMatchRequest, options?: RequestInit): Promise<postApiTeamsTeamIdLeadsCheckMatchResponse> => {

  return fetcher<postApiTeamsTeamIdLeadsCheckMatchResponse>(getPostApiTeamsTeamIdLeadsCheckMatchUrl(teamId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      checkLeadMatchRequest,)
  }
);}



export type postApiTeamsTeamIdLeadsLeadIdMatchResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdLeadsLeadIdMatchResponse401 = {
  data: PostApiTeamsTeamIdLeadsLeadIdMatch401
  status: 401
}

export type postApiTeamsTeamIdLeadsLeadIdMatchResponse402 = {
  data: PostApiTeamsTeamIdLeadsLeadIdMatch402
  status: 402
}

export type postApiTeamsTeamIdLeadsLeadIdMatchResponseSuccess = (postApiTeamsTeamIdLeadsLeadIdMatchResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdLeadsLeadIdMatchResponseError = (postApiTeamsTeamIdLeadsLeadIdMatchResponse401 | postApiTeamsTeamIdLeadsLeadIdMatchResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdLeadsLeadIdMatchResponse = (postApiTeamsTeamIdLeadsLeadIdMatchResponseSuccess | postApiTeamsTeamIdLeadsLeadIdMatchResponseError)

export const getPostApiTeamsTeamIdLeadsLeadIdMatchUrl = (teamId: string,
    leadId: string,) => {




  return `/api/teams/${teamId}/leads/${leadId}/match`
}

export const postApiTeamsTeamIdLeadsLeadIdMatch = async (teamId: string,
    leadId: string,
    matchLeadRequest: MatchLeadRequest, options?: RequestInit): Promise<postApiTeamsTeamIdLeadsLeadIdMatchResponse> => {

  return fetcher<postApiTeamsTeamIdLeadsLeadIdMatchResponse>(getPostApiTeamsTeamIdLeadsLeadIdMatchUrl(teamId,leadId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      matchLeadRequest,)
  }
);}



export type postApiTeamsTeamIdLeadsLeadIdConvertResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdLeadsLeadIdConvertResponse401 = {
  data: PostApiTeamsTeamIdLeadsLeadIdConvert401
  status: 401
}

export type postApiTeamsTeamIdLeadsLeadIdConvertResponse402 = {
  data: PostApiTeamsTeamIdLeadsLeadIdConvert402
  status: 402
}

export type postApiTeamsTeamIdLeadsLeadIdConvertResponseSuccess = (postApiTeamsTeamIdLeadsLeadIdConvertResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdLeadsLeadIdConvertResponseError = (postApiTeamsTeamIdLeadsLeadIdConvertResponse401 | postApiTeamsTeamIdLeadsLeadIdConvertResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdLeadsLeadIdConvertResponse = (postApiTeamsTeamIdLeadsLeadIdConvertResponseSuccess | postApiTeamsTeamIdLeadsLeadIdConvertResponseError)

export const getPostApiTeamsTeamIdLeadsLeadIdConvertUrl = (teamId: string,
    leadId: string,) => {




  return `/api/teams/${teamId}/leads/${leadId}/convert`
}

export const postApiTeamsTeamIdLeadsLeadIdConvert = async (teamId: string,
    leadId: string,
    convertLeadRequest: ConvertLeadRequest, options?: RequestInit): Promise<postApiTeamsTeamIdLeadsLeadIdConvertResponse> => {

  return fetcher<postApiTeamsTeamIdLeadsLeadIdConvertResponse>(getPostApiTeamsTeamIdLeadsLeadIdConvertUrl(teamId,leadId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      convertLeadRequest,)
  }
);}



export type postApiTeamsTeamIdLeadsLeadIdRestoreResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdLeadsLeadIdRestoreResponse401 = {
  data: PostApiTeamsTeamIdLeadsLeadIdRestore401
  status: 401
}

export type postApiTeamsTeamIdLeadsLeadIdRestoreResponse402 = {
  data: PostApiTeamsTeamIdLeadsLeadIdRestore402
  status: 402
}

export type postApiTeamsTeamIdLeadsLeadIdRestoreResponseSuccess = (postApiTeamsTeamIdLeadsLeadIdRestoreResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdLeadsLeadIdRestoreResponseError = (postApiTeamsTeamIdLeadsLeadIdRestoreResponse401 | postApiTeamsTeamIdLeadsLeadIdRestoreResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdLeadsLeadIdRestoreResponse = (postApiTeamsTeamIdLeadsLeadIdRestoreResponseSuccess | postApiTeamsTeamIdLeadsLeadIdRestoreResponseError)

export const getPostApiTeamsTeamIdLeadsLeadIdRestoreUrl = (teamId: string,
    leadId: string,) => {




  return `/api/teams/${teamId}/leads/${leadId}/restore`
}

export const postApiTeamsTeamIdLeadsLeadIdRestore = async (teamId: string,
    leadId: string, options?: RequestInit): Promise<postApiTeamsTeamIdLeadsLeadIdRestoreResponse> => {

  return fetcher<postApiTeamsTeamIdLeadsLeadIdRestoreResponse>(getPostApiTeamsTeamIdLeadsLeadIdRestoreUrl(teamId,leadId),
  {
    ...options,
    method: 'POST'


  }
);}



export type postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsResponse200TextPlain = {
  data: PolicyDocumentRetrievalRunResponse
  status: 200
}

export type postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsResponse200ApplicationJson = {
  data: PolicyDocumentRetrievalRunResponse
  status: 200
}

export type postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsResponse200TextJson = {
  data: PolicyDocumentRetrievalRunResponse
  status: 200
}

export type postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsResponse400TextPlain = {
  data: TeamAgentErrorResponse
  status: 400
}

export type postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsResponse400ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 400
}

export type postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsResponse400TextJson = {
  data: TeamAgentErrorResponse
  status: 400
}

export type postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsResponse401TextPlain = {
  data: TeamAgentErrorResponse
  status: 401
}

export type postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsResponse401ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 401
}

export type postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsResponse401TextJson = {
  data: TeamAgentErrorResponse
  status: 401
}

export type postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsResponse402 = {
  data: PostApiTeamsTeamIdAgentsPolicyDocumentRetrievalRuns402
  status: 402
}

export type postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsResponse403TextPlain = {
  data: TeamAgentErrorResponse
  status: 403
}

export type postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsResponse403ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsResponse403TextJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsResponseSuccess = (postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsResponse200TextPlain | postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsResponse200ApplicationJson | postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsResponse200TextJson) & {
  headers: Headers;
};
export type postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsResponseError = (postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsResponse400TextPlain | postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsResponse400ApplicationJson | postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsResponse400TextJson | postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsResponse401TextPlain | postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsResponse401ApplicationJson | postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsResponse401TextJson | postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsResponse402 | postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsResponse403TextPlain | postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsResponse403ApplicationJson | postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsResponse403TextJson) & {
  headers: Headers;
};

export type postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsResponse = (postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsResponseSuccess | postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsResponseError)

export const getPostApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/agents/policy-document-retrieval/runs`
}

export const postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRuns = async (teamId: string,
    nullInvokeRetrievalRequest: null | InvokeRetrievalRequest, options?: RequestInit): Promise<postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsResponse> => {

  return fetcher<postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsResponse>(getPostApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsUrl(teamId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullInvokeRetrievalRequest,)
  }
);}



export type getApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdResponse200TextPlain = {
  data: PolicyDocumentRetrievalRunStateResponse
  status: 200
}

export type getApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdResponse200ApplicationJson = {
  data: PolicyDocumentRetrievalRunStateResponse
  status: 200
}

export type getApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdResponse200TextJson = {
  data: PolicyDocumentRetrievalRunStateResponse
  status: 200
}

export type getApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdResponse400TextPlain = {
  data: TeamAgentErrorResponse
  status: 400
}

export type getApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdResponse400ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 400
}

export type getApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdResponse400TextJson = {
  data: TeamAgentErrorResponse
  status: 400
}

export type getApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdResponse401TextPlain = {
  data: TeamAgentErrorResponse
  status: 401
}

export type getApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdResponse401ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 401
}

export type getApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdResponse401TextJson = {
  data: TeamAgentErrorResponse
  status: 401
}

export type getApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdResponse403TextPlain = {
  data: TeamAgentErrorResponse
  status: 403
}

export type getApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdResponse403ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type getApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdResponse403TextJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type getApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdResponse404TextPlain = {
  data: TeamAgentErrorResponse
  status: 404
}

export type getApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdResponse404ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 404
}

export type getApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdResponse404TextJson = {
  data: TeamAgentErrorResponse
  status: 404
}

export type getApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdResponseSuccess = (getApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdResponse200TextPlain | getApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdResponse200ApplicationJson | getApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdResponseError = (getApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdResponse400TextPlain | getApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdResponse400ApplicationJson | getApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdResponse400TextJson | getApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdResponse401TextPlain | getApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdResponse401ApplicationJson | getApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdResponse401TextJson | getApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdResponse403TextPlain | getApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdResponse403ApplicationJson | getApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdResponse403TextJson | getApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdResponse404TextPlain | getApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdResponse404ApplicationJson | getApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdResponse404TextJson) & {
  headers: Headers;
};

export type getApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdResponse = (getApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdResponseSuccess | getApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdResponseError)

export const getGetApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdUrl = (teamId: string,
    runId: string,) => {




  return `/api/teams/${teamId}/agents/policy-document-retrieval/runs/${runId}`
}

export const getApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunId = async (teamId: string,
    runId: string, options?: RequestInit): Promise<getApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdResponse> => {

  return fetcher<getApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdResponse>(getGetApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdUrl(teamId,runId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResumeResponse200TextPlain = {
  data: PolicyDocumentRetrievalRunStateResponse
  status: 200
}

export type postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResumeResponse200ApplicationJson = {
  data: PolicyDocumentRetrievalRunStateResponse
  status: 200
}

export type postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResumeResponse200TextJson = {
  data: PolicyDocumentRetrievalRunStateResponse
  status: 200
}

export type postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResumeResponse400TextPlain = {
  data: TeamAgentErrorResponse
  status: 400
}

export type postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResumeResponse400ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 400
}

export type postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResumeResponse400TextJson = {
  data: TeamAgentErrorResponse
  status: 400
}

export type postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResumeResponse401TextPlain = {
  data: TeamAgentErrorResponse
  status: 401
}

export type postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResumeResponse401ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 401
}

export type postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResumeResponse401TextJson = {
  data: TeamAgentErrorResponse
  status: 401
}

export type postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResumeResponse403TextPlain = {
  data: TeamAgentErrorResponse
  status: 403
}

export type postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResumeResponse403ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResumeResponse403TextJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResumeResponse404TextPlain = {
  data: TeamAgentErrorResponse
  status: 404
}

export type postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResumeResponse404ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 404
}

export type postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResumeResponse404TextJson = {
  data: TeamAgentErrorResponse
  status: 404
}

export type postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResumeResponse409TextPlain = {
  data: TeamAgentErrorResponse
  status: 409
}

export type postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResumeResponse409ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 409
}

export type postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResumeResponse409TextJson = {
  data: TeamAgentErrorResponse
  status: 409
}

export type postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResumeResponseSuccess = (postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResumeResponse200TextPlain | postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResumeResponse200ApplicationJson | postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResumeResponse200TextJson) & {
  headers: Headers;
};
export type postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResumeResponseError = (postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResumeResponse400TextPlain | postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResumeResponse400ApplicationJson | postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResumeResponse400TextJson | postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResumeResponse401TextPlain | postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResumeResponse401ApplicationJson | postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResumeResponse401TextJson | postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResumeResponse403TextPlain | postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResumeResponse403ApplicationJson | postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResumeResponse403TextJson | postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResumeResponse404TextPlain | postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResumeResponse404ApplicationJson | postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResumeResponse404TextJson | postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResumeResponse409TextPlain | postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResumeResponse409ApplicationJson | postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResumeResponse409TextJson) & {
  headers: Headers;
};

export type postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResumeResponse = (postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResumeResponseSuccess | postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResumeResponseError)

export const getPostApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResumeUrl = (teamId: string,
    runId: string,) => {




  return `/api/teams/${teamId}/agents/policy-document-retrieval/runs/${runId}/checkpoints/edge-result/resume`
}

export const postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResume = async (teamId: string,
    runId: string, options?: RequestInit): Promise<postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResumeResponse> => {

  return fetcher<postApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResumeResponse>(getPostApiTeamsTeamIdAgentsPolicyDocumentRetrievalRunsRunIdCheckpointsEdgeResultResumeUrl(teamId,runId),
  {
    ...options,
    method: 'POST'


  }
);}



export type getApiTeamsTeamIdPortalsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdPortalsResponse401 = {
  data: GetApiTeamsTeamIdPortals401
  status: 401
}

export type getApiTeamsTeamIdPortalsResponseSuccess = (getApiTeamsTeamIdPortalsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdPortalsResponseError = (getApiTeamsTeamIdPortalsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdPortalsResponse = (getApiTeamsTeamIdPortalsResponseSuccess | getApiTeamsTeamIdPortalsResponseError)

export const getGetApiTeamsTeamIdPortalsUrl = (teamId: string,
    params?: GetApiTeamsTeamIdPortalsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/portals?${stringifiedParams}` : `/api/teams/${teamId}/portals`
}

export const getApiTeamsTeamIdPortals = async (teamId: string,
    params?: GetApiTeamsTeamIdPortalsParams, options?: RequestInit): Promise<getApiTeamsTeamIdPortalsResponse> => {

  return fetcher<getApiTeamsTeamIdPortalsResponse>(getGetApiTeamsTeamIdPortalsUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdPortalsResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdPortalsResponse401 = {
  data: PostApiTeamsTeamIdPortals401
  status: 401
}

export type postApiTeamsTeamIdPortalsResponse402 = {
  data: PostApiTeamsTeamIdPortals402
  status: 402
}

export type postApiTeamsTeamIdPortalsResponseSuccess = (postApiTeamsTeamIdPortalsResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdPortalsResponseError = (postApiTeamsTeamIdPortalsResponse401 | postApiTeamsTeamIdPortalsResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdPortalsResponse = (postApiTeamsTeamIdPortalsResponseSuccess | postApiTeamsTeamIdPortalsResponseError)

export const getPostApiTeamsTeamIdPortalsUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/portals`
}

export const postApiTeamsTeamIdPortals = async (teamId: string,
    nullTeamUpsertPortalRequest: null | TeamUpsertPortalRequest, options?: RequestInit): Promise<postApiTeamsTeamIdPortalsResponse> => {

  return fetcher<postApiTeamsTeamIdPortalsResponse>(getPostApiTeamsTeamIdPortalsUrl(teamId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullTeamUpsertPortalRequest,)
  }
);}



export type getApiTeamsTeamIdPortalsPaymentsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdPortalsPaymentsResponse401 = {
  data: GetApiTeamsTeamIdPortalsPayments401
  status: 401
}

export type getApiTeamsTeamIdPortalsPaymentsResponseSuccess = (getApiTeamsTeamIdPortalsPaymentsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdPortalsPaymentsResponseError = (getApiTeamsTeamIdPortalsPaymentsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdPortalsPaymentsResponse = (getApiTeamsTeamIdPortalsPaymentsResponseSuccess | getApiTeamsTeamIdPortalsPaymentsResponseError)

export const getGetApiTeamsTeamIdPortalsPaymentsUrl = (teamId: string,
    params?: GetApiTeamsTeamIdPortalsPaymentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/portals/payments?${stringifiedParams}` : `/api/teams/${teamId}/portals/payments`
}

export const getApiTeamsTeamIdPortalsPayments = async (teamId: string,
    params?: GetApiTeamsTeamIdPortalsPaymentsParams, options?: RequestInit): Promise<getApiTeamsTeamIdPortalsPaymentsResponse> => {

  return fetcher<getApiTeamsTeamIdPortalsPaymentsResponse>(getGetApiTeamsTeamIdPortalsPaymentsUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdPortalsPaymentsResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdPortalsPaymentsResponse401 = {
  data: PostApiTeamsTeamIdPortalsPayments401
  status: 401
}

export type postApiTeamsTeamIdPortalsPaymentsResponse402 = {
  data: PostApiTeamsTeamIdPortalsPayments402
  status: 402
}

export type postApiTeamsTeamIdPortalsPaymentsResponseSuccess = (postApiTeamsTeamIdPortalsPaymentsResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdPortalsPaymentsResponseError = (postApiTeamsTeamIdPortalsPaymentsResponse401 | postApiTeamsTeamIdPortalsPaymentsResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdPortalsPaymentsResponse = (postApiTeamsTeamIdPortalsPaymentsResponseSuccess | postApiTeamsTeamIdPortalsPaymentsResponseError)

export const getPostApiTeamsTeamIdPortalsPaymentsUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/portals/payments`
}

export const postApiTeamsTeamIdPortalsPayments = async (teamId: string,
    nullTeamCreatePaymentLinkRequest: null | TeamCreatePaymentLinkRequest, options?: RequestInit): Promise<postApiTeamsTeamIdPortalsPaymentsResponse> => {

  return fetcher<postApiTeamsTeamIdPortalsPaymentsResponse>(getPostApiTeamsTeamIdPortalsPaymentsUrl(teamId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullTeamCreatePaymentLinkRequest,)
  }
);}



export type postApiTeamsTeamIdTeamRagRefreshResponse200TextPlain = {
  data: TeamRagRefreshDto
  status: 200
}

export type postApiTeamsTeamIdTeamRagRefreshResponse200ApplicationJson = {
  data: TeamRagRefreshDto
  status: 200
}

export type postApiTeamsTeamIdTeamRagRefreshResponse200TextJson = {
  data: TeamRagRefreshDto
  status: 200
}

export type postApiTeamsTeamIdTeamRagRefreshResponse401 = {
  data: PostApiTeamsTeamIdTeamRagRefresh401
  status: 401
}

export type postApiTeamsTeamIdTeamRagRefreshResponse402 = {
  data: PostApiTeamsTeamIdTeamRagRefresh402
  status: 402
}

export type postApiTeamsTeamIdTeamRagRefreshResponseSuccess = (postApiTeamsTeamIdTeamRagRefreshResponse200TextPlain | postApiTeamsTeamIdTeamRagRefreshResponse200ApplicationJson | postApiTeamsTeamIdTeamRagRefreshResponse200TextJson) & {
  headers: Headers;
};
export type postApiTeamsTeamIdTeamRagRefreshResponseError = (postApiTeamsTeamIdTeamRagRefreshResponse401 | postApiTeamsTeamIdTeamRagRefreshResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdTeamRagRefreshResponse = (postApiTeamsTeamIdTeamRagRefreshResponseSuccess | postApiTeamsTeamIdTeamRagRefreshResponseError)

export const getPostApiTeamsTeamIdTeamRagRefreshUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/team-rag/refresh`
}

export const postApiTeamsTeamIdTeamRagRefresh = async (teamId: string, options?: RequestInit): Promise<postApiTeamsTeamIdTeamRagRefreshResponse> => {

  return fetcher<postApiTeamsTeamIdTeamRagRefreshResponse>(getPostApiTeamsTeamIdTeamRagRefreshUrl(teamId),
  {
    ...options,
    method: 'POST'


  }
);}



export type getApiTeamsTeamIdReportsBookOfBusinessResponse200TextPlain = {
  data: ReportPageDtoOfBookOfBusinessRowAndBookOfBusinessSummary
  status: 200
}

export type getApiTeamsTeamIdReportsBookOfBusinessResponse200ApplicationJson = {
  data: ReportPageDtoOfBookOfBusinessRowAndBookOfBusinessSummary
  status: 200
}

export type getApiTeamsTeamIdReportsBookOfBusinessResponse200TextJson = {
  data: ReportPageDtoOfBookOfBusinessRowAndBookOfBusinessSummary
  status: 200
}

export type getApiTeamsTeamIdReportsBookOfBusinessResponse401 = {
  data: GetApiTeamsTeamIdReportsBookOfBusiness401
  status: 401
}

export type getApiTeamsTeamIdReportsBookOfBusinessResponseSuccess = (getApiTeamsTeamIdReportsBookOfBusinessResponse200TextPlain | getApiTeamsTeamIdReportsBookOfBusinessResponse200ApplicationJson | getApiTeamsTeamIdReportsBookOfBusinessResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsTeamIdReportsBookOfBusinessResponseError = (getApiTeamsTeamIdReportsBookOfBusinessResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdReportsBookOfBusinessResponse = (getApiTeamsTeamIdReportsBookOfBusinessResponseSuccess | getApiTeamsTeamIdReportsBookOfBusinessResponseError)

export const getGetApiTeamsTeamIdReportsBookOfBusinessUrl = (teamId: string,
    params?: GetApiTeamsTeamIdReportsBookOfBusinessParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/reports/book-of-business?${stringifiedParams}` : `/api/teams/${teamId}/reports/book-of-business`
}

export const getApiTeamsTeamIdReportsBookOfBusiness = async (teamId: string,
    params?: GetApiTeamsTeamIdReportsBookOfBusinessParams, options?: RequestInit): Promise<getApiTeamsTeamIdReportsBookOfBusinessResponse> => {

  return fetcher<getApiTeamsTeamIdReportsBookOfBusinessResponse>(getGetApiTeamsTeamIdReportsBookOfBusinessUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdReportsRenewalForecastResponse200TextPlain = {
  data: ReportPageDtoOfRenewalForecastRowAndRenewalForecastSummary
  status: 200
}

export type getApiTeamsTeamIdReportsRenewalForecastResponse200ApplicationJson = {
  data: ReportPageDtoOfRenewalForecastRowAndRenewalForecastSummary
  status: 200
}

export type getApiTeamsTeamIdReportsRenewalForecastResponse200TextJson = {
  data: ReportPageDtoOfRenewalForecastRowAndRenewalForecastSummary
  status: 200
}

export type getApiTeamsTeamIdReportsRenewalForecastResponse401 = {
  data: GetApiTeamsTeamIdReportsRenewalForecast401
  status: 401
}

export type getApiTeamsTeamIdReportsRenewalForecastResponseSuccess = (getApiTeamsTeamIdReportsRenewalForecastResponse200TextPlain | getApiTeamsTeamIdReportsRenewalForecastResponse200ApplicationJson | getApiTeamsTeamIdReportsRenewalForecastResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsTeamIdReportsRenewalForecastResponseError = (getApiTeamsTeamIdReportsRenewalForecastResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdReportsRenewalForecastResponse = (getApiTeamsTeamIdReportsRenewalForecastResponseSuccess | getApiTeamsTeamIdReportsRenewalForecastResponseError)

export const getGetApiTeamsTeamIdReportsRenewalForecastUrl = (teamId: string,
    params?: GetApiTeamsTeamIdReportsRenewalForecastParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/reports/renewal-forecast?${stringifiedParams}` : `/api/teams/${teamId}/reports/renewal-forecast`
}

export const getApiTeamsTeamIdReportsRenewalForecast = async (teamId: string,
    params?: GetApiTeamsTeamIdReportsRenewalForecastParams, options?: RequestInit): Promise<getApiTeamsTeamIdReportsRenewalForecastResponse> => {

  return fetcher<getApiTeamsTeamIdReportsRenewalForecastResponse>(getGetApiTeamsTeamIdReportsRenewalForecastUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdReportsPipelineResponse200TextPlain = {
  data: ReportPageDtoOfPipelineRowAndPipelineSummary
  status: 200
}

export type getApiTeamsTeamIdReportsPipelineResponse200ApplicationJson = {
  data: ReportPageDtoOfPipelineRowAndPipelineSummary
  status: 200
}

export type getApiTeamsTeamIdReportsPipelineResponse200TextJson = {
  data: ReportPageDtoOfPipelineRowAndPipelineSummary
  status: 200
}

export type getApiTeamsTeamIdReportsPipelineResponse401 = {
  data: GetApiTeamsTeamIdReportsPipeline401
  status: 401
}

export type getApiTeamsTeamIdReportsPipelineResponseSuccess = (getApiTeamsTeamIdReportsPipelineResponse200TextPlain | getApiTeamsTeamIdReportsPipelineResponse200ApplicationJson | getApiTeamsTeamIdReportsPipelineResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsTeamIdReportsPipelineResponseError = (getApiTeamsTeamIdReportsPipelineResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdReportsPipelineResponse = (getApiTeamsTeamIdReportsPipelineResponseSuccess | getApiTeamsTeamIdReportsPipelineResponseError)

export const getGetApiTeamsTeamIdReportsPipelineUrl = (teamId: string,
    params?: GetApiTeamsTeamIdReportsPipelineParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/reports/pipeline?${stringifiedParams}` : `/api/teams/${teamId}/reports/pipeline`
}

export const getApiTeamsTeamIdReportsPipeline = async (teamId: string,
    params?: GetApiTeamsTeamIdReportsPipelineParams, options?: RequestInit): Promise<getApiTeamsTeamIdReportsPipelineResponse> => {

  return fetcher<getApiTeamsTeamIdReportsPipelineResponse>(getGetApiTeamsTeamIdReportsPipelineUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdReportsProducerProductionResponse200TextPlain = {
  data: ReportPageDtoOfProducerProductionRowAndProducerProductionSummary
  status: 200
}

export type getApiTeamsTeamIdReportsProducerProductionResponse200ApplicationJson = {
  data: ReportPageDtoOfProducerProductionRowAndProducerProductionSummary
  status: 200
}

export type getApiTeamsTeamIdReportsProducerProductionResponse200TextJson = {
  data: ReportPageDtoOfProducerProductionRowAndProducerProductionSummary
  status: 200
}

export type getApiTeamsTeamIdReportsProducerProductionResponse401 = {
  data: GetApiTeamsTeamIdReportsProducerProduction401
  status: 401
}

export type getApiTeamsTeamIdReportsProducerProductionResponseSuccess = (getApiTeamsTeamIdReportsProducerProductionResponse200TextPlain | getApiTeamsTeamIdReportsProducerProductionResponse200ApplicationJson | getApiTeamsTeamIdReportsProducerProductionResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsTeamIdReportsProducerProductionResponseError = (getApiTeamsTeamIdReportsProducerProductionResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdReportsProducerProductionResponse = (getApiTeamsTeamIdReportsProducerProductionResponseSuccess | getApiTeamsTeamIdReportsProducerProductionResponseError)

export const getGetApiTeamsTeamIdReportsProducerProductionUrl = (teamId: string,
    params?: GetApiTeamsTeamIdReportsProducerProductionParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/reports/producer-production?${stringifiedParams}` : `/api/teams/${teamId}/reports/producer-production`
}

export const getApiTeamsTeamIdReportsProducerProduction = async (teamId: string,
    params?: GetApiTeamsTeamIdReportsProducerProductionParams, options?: RequestInit): Promise<getApiTeamsTeamIdReportsProducerProductionResponse> => {

  return fetcher<getApiTeamsTeamIdReportsProducerProductionResponse>(getGetApiTeamsTeamIdReportsProducerProductionUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsResponse200TextPlain = {
  data: TeamSummaryDto[]
  status: 200
}

export type getApiTeamsResponse200ApplicationJson = {
  data: TeamSummaryDto[]
  status: 200
}

export type getApiTeamsResponse200TextJson = {
  data: TeamSummaryDto[]
  status: 200
}

export type getApiTeamsResponse401 = {
  data: GetApiTeams401
  status: 401
}

export type getApiTeamsResponseSuccess = (getApiTeamsResponse200TextPlain | getApiTeamsResponse200ApplicationJson | getApiTeamsResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsResponseError = (getApiTeamsResponse401) & {
  headers: Headers;
};

export type getApiTeamsResponse = (getApiTeamsResponseSuccess | getApiTeamsResponseError)

export const getGetApiTeamsUrl = (params?: GetApiTeamsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Teams?${stringifiedParams}` : `/api/Teams`
}

export const getApiTeams = async (params?: GetApiTeamsParams, options?: RequestInit): Promise<getApiTeamsResponse> => {

  return fetcher<getApiTeamsResponse>(getGetApiTeamsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsResponse200TextPlain = {
  data: TeamDetailDto
  status: 200
}

export type postApiTeamsResponse200ApplicationJson = {
  data: TeamDetailDto
  status: 200
}

export type postApiTeamsResponse200TextJson = {
  data: TeamDetailDto
  status: 200
}

export type postApiTeamsResponse401 = {
  data: PostApiTeams401
  status: 401
}

export type postApiTeamsResponse402 = {
  data: PostApiTeams402
  status: 402
}

export type postApiTeamsResponseSuccess = (postApiTeamsResponse200TextPlain | postApiTeamsResponse200ApplicationJson | postApiTeamsResponse200TextJson) & {
  headers: Headers;
};
export type postApiTeamsResponseError = (postApiTeamsResponse401 | postApiTeamsResponse402) & {
  headers: Headers;
};

export type postApiTeamsResponse = (postApiTeamsResponseSuccess | postApiTeamsResponseError)

export const getPostApiTeamsUrl = () => {




  return `/api/Teams`
}

export const postApiTeams = async (createTeamRequest: CreateTeamRequest, options?: RequestInit): Promise<postApiTeamsResponse> => {

  return fetcher<postApiTeamsResponse>(getPostApiTeamsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createTeamRequest,)
  }
);}



export type getApiTeamsIdBookAnalyticsResponse200TextPlain = {
  data: TeamBookAnalyticsDto
  status: 200
}

export type getApiTeamsIdBookAnalyticsResponse200ApplicationJson = {
  data: TeamBookAnalyticsDto
  status: 200
}

export type getApiTeamsIdBookAnalyticsResponse200TextJson = {
  data: TeamBookAnalyticsDto
  status: 200
}

export type getApiTeamsIdBookAnalyticsResponse401 = {
  data: GetApiTeamsIdBookAnalytics401
  status: 401
}

export type getApiTeamsIdBookAnalyticsResponseSuccess = (getApiTeamsIdBookAnalyticsResponse200TextPlain | getApiTeamsIdBookAnalyticsResponse200ApplicationJson | getApiTeamsIdBookAnalyticsResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsIdBookAnalyticsResponseError = (getApiTeamsIdBookAnalyticsResponse401) & {
  headers: Headers;
};

export type getApiTeamsIdBookAnalyticsResponse = (getApiTeamsIdBookAnalyticsResponseSuccess | getApiTeamsIdBookAnalyticsResponseError)

export const getGetApiTeamsIdBookAnalyticsUrl = (id: string,) => {




  return `/api/Teams/${id}/book-analytics`
}

export const getApiTeamsIdBookAnalytics = async (id: string, options?: RequestInit): Promise<getApiTeamsIdBookAnalyticsResponse> => {

  return fetcher<getApiTeamsIdBookAnalyticsResponse>(getGetApiTeamsIdBookAnalyticsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsIdRevenueProducersResponse200TextPlain = {
  data: TeamRevenueProducerDto[]
  status: 200
}

export type getApiTeamsIdRevenueProducersResponse200ApplicationJson = {
  data: TeamRevenueProducerDto[]
  status: 200
}

export type getApiTeamsIdRevenueProducersResponse200TextJson = {
  data: TeamRevenueProducerDto[]
  status: 200
}

export type getApiTeamsIdRevenueProducersResponse401 = {
  data: GetApiTeamsIdRevenueProducers401
  status: 401
}

export type getApiTeamsIdRevenueProducersResponseSuccess = (getApiTeamsIdRevenueProducersResponse200TextPlain | getApiTeamsIdRevenueProducersResponse200ApplicationJson | getApiTeamsIdRevenueProducersResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsIdRevenueProducersResponseError = (getApiTeamsIdRevenueProducersResponse401) & {
  headers: Headers;
};

export type getApiTeamsIdRevenueProducersResponse = (getApiTeamsIdRevenueProducersResponseSuccess | getApiTeamsIdRevenueProducersResponseError)

export const getGetApiTeamsIdRevenueProducersUrl = (id: string,) => {




  return `/api/Teams/${id}/revenue/producers`
}

export const getApiTeamsIdRevenueProducers = async (id: string, options?: RequestInit): Promise<getApiTeamsIdRevenueProducersResponse> => {

  return fetcher<getApiTeamsIdRevenueProducersResponse>(getGetApiTeamsIdRevenueProducersUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsIdRevenueLobsResponse200TextPlain = {
  data: TeamRevenueLobDto[]
  status: 200
}

export type getApiTeamsIdRevenueLobsResponse200ApplicationJson = {
  data: TeamRevenueLobDto[]
  status: 200
}

export type getApiTeamsIdRevenueLobsResponse200TextJson = {
  data: TeamRevenueLobDto[]
  status: 200
}

export type getApiTeamsIdRevenueLobsResponse401 = {
  data: GetApiTeamsIdRevenueLobs401
  status: 401
}

export type getApiTeamsIdRevenueLobsResponseSuccess = (getApiTeamsIdRevenueLobsResponse200TextPlain | getApiTeamsIdRevenueLobsResponse200ApplicationJson | getApiTeamsIdRevenueLobsResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsIdRevenueLobsResponseError = (getApiTeamsIdRevenueLobsResponse401) & {
  headers: Headers;
};

export type getApiTeamsIdRevenueLobsResponse = (getApiTeamsIdRevenueLobsResponseSuccess | getApiTeamsIdRevenueLobsResponseError)

export const getGetApiTeamsIdRevenueLobsUrl = (id: string,) => {




  return `/api/Teams/${id}/revenue/lobs`
}

export const getApiTeamsIdRevenueLobs = async (id: string, options?: RequestInit): Promise<getApiTeamsIdRevenueLobsResponse> => {

  return fetcher<getApiTeamsIdRevenueLobsResponse>(getGetApiTeamsIdRevenueLobsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsIdRevenueRenewalsResponse200TextPlain = {
  data: TeamRenewalForecastDto
  status: 200
}

export type getApiTeamsIdRevenueRenewalsResponse200ApplicationJson = {
  data: TeamRenewalForecastDto
  status: 200
}

export type getApiTeamsIdRevenueRenewalsResponse200TextJson = {
  data: TeamRenewalForecastDto
  status: 200
}

export type getApiTeamsIdRevenueRenewalsResponse401 = {
  data: GetApiTeamsIdRevenueRenewals401
  status: 401
}

export type getApiTeamsIdRevenueRenewalsResponseSuccess = (getApiTeamsIdRevenueRenewalsResponse200TextPlain | getApiTeamsIdRevenueRenewalsResponse200ApplicationJson | getApiTeamsIdRevenueRenewalsResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsIdRevenueRenewalsResponseError = (getApiTeamsIdRevenueRenewalsResponse401) & {
  headers: Headers;
};

export type getApiTeamsIdRevenueRenewalsResponse = (getApiTeamsIdRevenueRenewalsResponseSuccess | getApiTeamsIdRevenueRenewalsResponseError)

export const getGetApiTeamsIdRevenueRenewalsUrl = (id: string,
    params?: GetApiTeamsIdRevenueRenewalsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Teams/${id}/revenue/renewals?${stringifiedParams}` : `/api/Teams/${id}/revenue/renewals`
}

export const getApiTeamsIdRevenueRenewals = async (id: string,
    params?: GetApiTeamsIdRevenueRenewalsParams, options?: RequestInit): Promise<getApiTeamsIdRevenueRenewalsResponse> => {

  return fetcher<getApiTeamsIdRevenueRenewalsResponse>(getGetApiTeamsIdRevenueRenewalsUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsIdRevenuePipelineResponse200TextPlain = {
  data: TeamPipelineForecastDto
  status: 200
}

export type getApiTeamsIdRevenuePipelineResponse200ApplicationJson = {
  data: TeamPipelineForecastDto
  status: 200
}

export type getApiTeamsIdRevenuePipelineResponse200TextJson = {
  data: TeamPipelineForecastDto
  status: 200
}

export type getApiTeamsIdRevenuePipelineResponse401 = {
  data: GetApiTeamsIdRevenuePipeline401
  status: 401
}

export type getApiTeamsIdRevenuePipelineResponseSuccess = (getApiTeamsIdRevenuePipelineResponse200TextPlain | getApiTeamsIdRevenuePipelineResponse200ApplicationJson | getApiTeamsIdRevenuePipelineResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsIdRevenuePipelineResponseError = (getApiTeamsIdRevenuePipelineResponse401) & {
  headers: Headers;
};

export type getApiTeamsIdRevenuePipelineResponse = (getApiTeamsIdRevenuePipelineResponseSuccess | getApiTeamsIdRevenuePipelineResponseError)

export const getGetApiTeamsIdRevenuePipelineUrl = (id: string,) => {




  return `/api/Teams/${id}/revenue/pipeline`
}

export const getApiTeamsIdRevenuePipeline = async (id: string, options?: RequestInit): Promise<getApiTeamsIdRevenuePipelineResponse> => {

  return fetcher<getApiTeamsIdRevenuePipelineResponse>(getGetApiTeamsIdRevenuePipelineUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsIdResponse200TextPlain = {
  data: TeamDetailDto
  status: 200
}

export type getApiTeamsIdResponse200ApplicationJson = {
  data: TeamDetailDto
  status: 200
}

export type getApiTeamsIdResponse200TextJson = {
  data: TeamDetailDto
  status: 200
}

export type getApiTeamsIdResponse401 = {
  data: GetApiTeamsId401
  status: 401
}

export type getApiTeamsIdResponseSuccess = (getApiTeamsIdResponse200TextPlain | getApiTeamsIdResponse200ApplicationJson | getApiTeamsIdResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsIdResponseError = (getApiTeamsIdResponse401) & {
  headers: Headers;
};

export type getApiTeamsIdResponse = (getApiTeamsIdResponseSuccess | getApiTeamsIdResponseError)

export const getGetApiTeamsIdUrl = (id: string,) => {




  return `/api/Teams/${id}`
}

export const getApiTeamsId = async (id: string, options?: RequestInit): Promise<getApiTeamsIdResponse> => {

  return fetcher<getApiTeamsIdResponse>(getGetApiTeamsIdUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}



export type putApiTeamsIdResponse200TextPlain = {
  data: TeamDetailDto
  status: 200
}

export type putApiTeamsIdResponse200ApplicationJson = {
  data: TeamDetailDto
  status: 200
}

export type putApiTeamsIdResponse200TextJson = {
  data: TeamDetailDto
  status: 200
}

export type putApiTeamsIdResponse401 = {
  data: PutApiTeamsId401
  status: 401
}

export type putApiTeamsIdResponse402 = {
  data: PutApiTeamsId402
  status: 402
}

export type putApiTeamsIdResponseSuccess = (putApiTeamsIdResponse200TextPlain | putApiTeamsIdResponse200ApplicationJson | putApiTeamsIdResponse200TextJson) & {
  headers: Headers;
};
export type putApiTeamsIdResponseError = (putApiTeamsIdResponse401 | putApiTeamsIdResponse402) & {
  headers: Headers;
};

export type putApiTeamsIdResponse = (putApiTeamsIdResponseSuccess | putApiTeamsIdResponseError)

export const getPutApiTeamsIdUrl = (id: string,) => {




  return `/api/Teams/${id}`
}

export const putApiTeamsId = async (id: string,
    updateTeamRequest: UpdateTeamRequest, options?: RequestInit): Promise<putApiTeamsIdResponse> => {

  return fetcher<putApiTeamsIdResponse>(getPutApiTeamsIdUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateTeamRequest,)
  }
);}



export type getApiTeamsIdBillingResponse200TextPlain = {
  data: TeamBillingStatusDto
  status: 200
}

export type getApiTeamsIdBillingResponse200ApplicationJson = {
  data: TeamBillingStatusDto
  status: 200
}

export type getApiTeamsIdBillingResponse200TextJson = {
  data: TeamBillingStatusDto
  status: 200
}

export type getApiTeamsIdBillingResponse401 = {
  data: GetApiTeamsIdBilling401
  status: 401
}

export type getApiTeamsIdBillingResponseSuccess = (getApiTeamsIdBillingResponse200TextPlain | getApiTeamsIdBillingResponse200ApplicationJson | getApiTeamsIdBillingResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsIdBillingResponseError = (getApiTeamsIdBillingResponse401) & {
  headers: Headers;
};

export type getApiTeamsIdBillingResponse = (getApiTeamsIdBillingResponseSuccess | getApiTeamsIdBillingResponseError)

export const getGetApiTeamsIdBillingUrl = (id: string,) => {




  return `/api/Teams/${id}/billing`
}

export const getApiTeamsIdBilling = async (id: string, options?: RequestInit): Promise<getApiTeamsIdBillingResponse> => {

  return fetcher<getApiTeamsIdBillingResponse>(getGetApiTeamsIdBillingUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsIdBillingCheckoutSessionResponse200TextPlain = {
  data: TeamBillingCheckoutSessionDto
  status: 200
}

export type postApiTeamsIdBillingCheckoutSessionResponse200ApplicationJson = {
  data: TeamBillingCheckoutSessionDto
  status: 200
}

export type postApiTeamsIdBillingCheckoutSessionResponse200TextJson = {
  data: TeamBillingCheckoutSessionDto
  status: 200
}

export type postApiTeamsIdBillingCheckoutSessionResponse401 = {
  data: PostApiTeamsIdBillingCheckoutSession401
  status: 401
}

export type postApiTeamsIdBillingCheckoutSessionResponse402 = {
  data: PostApiTeamsIdBillingCheckoutSession402
  status: 402
}

export type postApiTeamsIdBillingCheckoutSessionResponseSuccess = (postApiTeamsIdBillingCheckoutSessionResponse200TextPlain | postApiTeamsIdBillingCheckoutSessionResponse200ApplicationJson | postApiTeamsIdBillingCheckoutSessionResponse200TextJson) & {
  headers: Headers;
};
export type postApiTeamsIdBillingCheckoutSessionResponseError = (postApiTeamsIdBillingCheckoutSessionResponse401 | postApiTeamsIdBillingCheckoutSessionResponse402) & {
  headers: Headers;
};

export type postApiTeamsIdBillingCheckoutSessionResponse = (postApiTeamsIdBillingCheckoutSessionResponseSuccess | postApiTeamsIdBillingCheckoutSessionResponseError)

export const getPostApiTeamsIdBillingCheckoutSessionUrl = (id: string,) => {




  return `/api/Teams/${id}/billing/checkout-session`
}

export const postApiTeamsIdBillingCheckoutSession = async (id: string,
    teamBillingCheckoutRequest: TeamBillingCheckoutRequest, options?: RequestInit): Promise<postApiTeamsIdBillingCheckoutSessionResponse> => {

  return fetcher<postApiTeamsIdBillingCheckoutSessionResponse>(getPostApiTeamsIdBillingCheckoutSessionUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      teamBillingCheckoutRequest,)
  }
);}



export type getApiTeamsIdBillingAdminResponse200TextPlain = {
  data: TeamBillingAdminDetailDto
  status: 200
}

export type getApiTeamsIdBillingAdminResponse200ApplicationJson = {
  data: TeamBillingAdminDetailDto
  status: 200
}

export type getApiTeamsIdBillingAdminResponse200TextJson = {
  data: TeamBillingAdminDetailDto
  status: 200
}

export type getApiTeamsIdBillingAdminResponse401 = {
  data: GetApiTeamsIdBillingAdmin401
  status: 401
}

export type getApiTeamsIdBillingAdminResponseSuccess = (getApiTeamsIdBillingAdminResponse200TextPlain | getApiTeamsIdBillingAdminResponse200ApplicationJson | getApiTeamsIdBillingAdminResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsIdBillingAdminResponseError = (getApiTeamsIdBillingAdminResponse401) & {
  headers: Headers;
};

export type getApiTeamsIdBillingAdminResponse = (getApiTeamsIdBillingAdminResponseSuccess | getApiTeamsIdBillingAdminResponseError)

export const getGetApiTeamsIdBillingAdminUrl = (id: string,) => {




  return `/api/Teams/${id}/billing/admin`
}

export const getApiTeamsIdBillingAdmin = async (id: string, options?: RequestInit): Promise<getApiTeamsIdBillingAdminResponse> => {

  return fetcher<getApiTeamsIdBillingAdminResponse>(getGetApiTeamsIdBillingAdminUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsIdBillingAdjustmentsResponse200TextPlain = {
  data: TeamEntitlementAdjustmentDto
  status: 200
}

export type postApiTeamsIdBillingAdjustmentsResponse200ApplicationJson = {
  data: TeamEntitlementAdjustmentDto
  status: 200
}

export type postApiTeamsIdBillingAdjustmentsResponse200TextJson = {
  data: TeamEntitlementAdjustmentDto
  status: 200
}

export type postApiTeamsIdBillingAdjustmentsResponse401 = {
  data: PostApiTeamsIdBillingAdjustments401
  status: 401
}

export type postApiTeamsIdBillingAdjustmentsResponse402 = {
  data: PostApiTeamsIdBillingAdjustments402
  status: 402
}

export type postApiTeamsIdBillingAdjustmentsResponseSuccess = (postApiTeamsIdBillingAdjustmentsResponse200TextPlain | postApiTeamsIdBillingAdjustmentsResponse200ApplicationJson | postApiTeamsIdBillingAdjustmentsResponse200TextJson) & {
  headers: Headers;
};
export type postApiTeamsIdBillingAdjustmentsResponseError = (postApiTeamsIdBillingAdjustmentsResponse401 | postApiTeamsIdBillingAdjustmentsResponse402) & {
  headers: Headers;
};

export type postApiTeamsIdBillingAdjustmentsResponse = (postApiTeamsIdBillingAdjustmentsResponseSuccess | postApiTeamsIdBillingAdjustmentsResponseError)

export const getPostApiTeamsIdBillingAdjustmentsUrl = (id: string,) => {




  return `/api/Teams/${id}/billing/adjustments`
}

export const postApiTeamsIdBillingAdjustments = async (id: string,
    createTeamEntitlementAdjustmentRequest: CreateTeamEntitlementAdjustmentRequest, options?: RequestInit): Promise<postApiTeamsIdBillingAdjustmentsResponse> => {

  return fetcher<postApiTeamsIdBillingAdjustmentsResponse>(getPostApiTeamsIdBillingAdjustmentsUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createTeamEntitlementAdjustmentRequest,)
  }
);}



export type postApiTeamsIdBillingAdjustmentsAdjustmentIdRevokeResponse200TextPlain = {
  data: TeamEntitlementAdjustmentDto
  status: 200
}

export type postApiTeamsIdBillingAdjustmentsAdjustmentIdRevokeResponse200ApplicationJson = {
  data: TeamEntitlementAdjustmentDto
  status: 200
}

export type postApiTeamsIdBillingAdjustmentsAdjustmentIdRevokeResponse200TextJson = {
  data: TeamEntitlementAdjustmentDto
  status: 200
}

export type postApiTeamsIdBillingAdjustmentsAdjustmentIdRevokeResponse401 = {
  data: PostApiTeamsIdBillingAdjustmentsAdjustmentIdRevoke401
  status: 401
}

export type postApiTeamsIdBillingAdjustmentsAdjustmentIdRevokeResponse402 = {
  data: PostApiTeamsIdBillingAdjustmentsAdjustmentIdRevoke402
  status: 402
}

export type postApiTeamsIdBillingAdjustmentsAdjustmentIdRevokeResponseSuccess = (postApiTeamsIdBillingAdjustmentsAdjustmentIdRevokeResponse200TextPlain | postApiTeamsIdBillingAdjustmentsAdjustmentIdRevokeResponse200ApplicationJson | postApiTeamsIdBillingAdjustmentsAdjustmentIdRevokeResponse200TextJson) & {
  headers: Headers;
};
export type postApiTeamsIdBillingAdjustmentsAdjustmentIdRevokeResponseError = (postApiTeamsIdBillingAdjustmentsAdjustmentIdRevokeResponse401 | postApiTeamsIdBillingAdjustmentsAdjustmentIdRevokeResponse402) & {
  headers: Headers;
};

export type postApiTeamsIdBillingAdjustmentsAdjustmentIdRevokeResponse = (postApiTeamsIdBillingAdjustmentsAdjustmentIdRevokeResponseSuccess | postApiTeamsIdBillingAdjustmentsAdjustmentIdRevokeResponseError)

export const getPostApiTeamsIdBillingAdjustmentsAdjustmentIdRevokeUrl = (id: string,
    adjustmentId: string,) => {




  return `/api/Teams/${id}/billing/adjustments/${adjustmentId}/revoke`
}

export const postApiTeamsIdBillingAdjustmentsAdjustmentIdRevoke = async (id: string,
    adjustmentId: string, options?: RequestInit): Promise<postApiTeamsIdBillingAdjustmentsAdjustmentIdRevokeResponse> => {

  return fetcher<postApiTeamsIdBillingAdjustmentsAdjustmentIdRevokeResponse>(getPostApiTeamsIdBillingAdjustmentsAdjustmentIdRevokeUrl(id,adjustmentId),
  {
    ...options,
    method: 'POST'


  }
);}



export type postApiTeamsIdAgencyResponse200TextPlain = {
  data: TeamDetailDto
  status: 200
}

export type postApiTeamsIdAgencyResponse200ApplicationJson = {
  data: TeamDetailDto
  status: 200
}

export type postApiTeamsIdAgencyResponse200TextJson = {
  data: TeamDetailDto
  status: 200
}

export type postApiTeamsIdAgencyResponse401 = {
  data: PostApiTeamsIdAgency401
  status: 401
}

export type postApiTeamsIdAgencyResponse402 = {
  data: PostApiTeamsIdAgency402
  status: 402
}

export type postApiTeamsIdAgencyResponseSuccess = (postApiTeamsIdAgencyResponse200TextPlain | postApiTeamsIdAgencyResponse200ApplicationJson | postApiTeamsIdAgencyResponse200TextJson) & {
  headers: Headers;
};
export type postApiTeamsIdAgencyResponseError = (postApiTeamsIdAgencyResponse401 | postApiTeamsIdAgencyResponse402) & {
  headers: Headers;
};

export type postApiTeamsIdAgencyResponse = (postApiTeamsIdAgencyResponseSuccess | postApiTeamsIdAgencyResponseError)

export const getPostApiTeamsIdAgencyUrl = (id: string,) => {




  return `/api/Teams/${id}/agency`
}

export const postApiTeamsIdAgency = async (id: string,
    createAgencyRequest: CreateAgencyRequest, options?: RequestInit): Promise<postApiTeamsIdAgencyResponse> => {

  return fetcher<postApiTeamsIdAgencyResponse>(getPostApiTeamsIdAgencyUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createAgencyRequest,)
  }
);}



export type deleteApiTeamsIdAgencyResponse200TextPlain = {
  data: TeamDetailDto
  status: 200
}

export type deleteApiTeamsIdAgencyResponse200ApplicationJson = {
  data: TeamDetailDto
  status: 200
}

export type deleteApiTeamsIdAgencyResponse200TextJson = {
  data: TeamDetailDto
  status: 200
}

export type deleteApiTeamsIdAgencyResponse401 = {
  data: DeleteApiTeamsIdAgency401
  status: 401
}

export type deleteApiTeamsIdAgencyResponse402 = {
  data: DeleteApiTeamsIdAgency402
  status: 402
}

export type deleteApiTeamsIdAgencyResponseSuccess = (deleteApiTeamsIdAgencyResponse200TextPlain | deleteApiTeamsIdAgencyResponse200ApplicationJson | deleteApiTeamsIdAgencyResponse200TextJson) & {
  headers: Headers;
};
export type deleteApiTeamsIdAgencyResponseError = (deleteApiTeamsIdAgencyResponse401 | deleteApiTeamsIdAgencyResponse402) & {
  headers: Headers;
};

export type deleteApiTeamsIdAgencyResponse = (deleteApiTeamsIdAgencyResponseSuccess | deleteApiTeamsIdAgencyResponseError)

export const getDeleteApiTeamsIdAgencyUrl = (id: string,) => {




  return `/api/Teams/${id}/agency`
}

export const deleteApiTeamsIdAgency = async (id: string, options?: RequestInit): Promise<deleteApiTeamsIdAgencyResponse> => {

  return fetcher<deleteApiTeamsIdAgencyResponse>(getDeleteApiTeamsIdAgencyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type postApiTeamsIdAgencyLinkResponse200TextPlain = {
  data: TeamDetailDto
  status: 200
}

export type postApiTeamsIdAgencyLinkResponse200ApplicationJson = {
  data: TeamDetailDto
  status: 200
}

export type postApiTeamsIdAgencyLinkResponse200TextJson = {
  data: TeamDetailDto
  status: 200
}

export type postApiTeamsIdAgencyLinkResponse401 = {
  data: PostApiTeamsIdAgencyLink401
  status: 401
}

export type postApiTeamsIdAgencyLinkResponse402 = {
  data: PostApiTeamsIdAgencyLink402
  status: 402
}

export type postApiTeamsIdAgencyLinkResponseSuccess = (postApiTeamsIdAgencyLinkResponse200TextPlain | postApiTeamsIdAgencyLinkResponse200ApplicationJson | postApiTeamsIdAgencyLinkResponse200TextJson) & {
  headers: Headers;
};
export type postApiTeamsIdAgencyLinkResponseError = (postApiTeamsIdAgencyLinkResponse401 | postApiTeamsIdAgencyLinkResponse402) & {
  headers: Headers;
};

export type postApiTeamsIdAgencyLinkResponse = (postApiTeamsIdAgencyLinkResponseSuccess | postApiTeamsIdAgencyLinkResponseError)

export const getPostApiTeamsIdAgencyLinkUrl = (id: string,) => {




  return `/api/Teams/${id}/agency/link`
}

export const postApiTeamsIdAgencyLink = async (id: string,
    linkAgencyRequest: LinkAgencyRequest, options?: RequestInit): Promise<postApiTeamsIdAgencyLinkResponse> => {

  return fetcher<postApiTeamsIdAgencyLinkResponse>(getPostApiTeamsIdAgencyLinkUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      linkAgencyRequest,)
  }
);}



export type putApiTeamsIdAgencyProfileResponse200TextPlain = {
  data: TeamAgencyProfileDto
  status: 200
}

export type putApiTeamsIdAgencyProfileResponse200ApplicationJson = {
  data: TeamAgencyProfileDto
  status: 200
}

export type putApiTeamsIdAgencyProfileResponse200TextJson = {
  data: TeamAgencyProfileDto
  status: 200
}

export type putApiTeamsIdAgencyProfileResponse401 = {
  data: PutApiTeamsIdAgencyProfile401
  status: 401
}

export type putApiTeamsIdAgencyProfileResponse402 = {
  data: PutApiTeamsIdAgencyProfile402
  status: 402
}

export type putApiTeamsIdAgencyProfileResponseSuccess = (putApiTeamsIdAgencyProfileResponse200TextPlain | putApiTeamsIdAgencyProfileResponse200ApplicationJson | putApiTeamsIdAgencyProfileResponse200TextJson) & {
  headers: Headers;
};
export type putApiTeamsIdAgencyProfileResponseError = (putApiTeamsIdAgencyProfileResponse401 | putApiTeamsIdAgencyProfileResponse402) & {
  headers: Headers;
};

export type putApiTeamsIdAgencyProfileResponse = (putApiTeamsIdAgencyProfileResponseSuccess | putApiTeamsIdAgencyProfileResponseError)

export const getPutApiTeamsIdAgencyProfileUrl = (id: string,) => {




  return `/api/Teams/${id}/agency/profile`
}

export const putApiTeamsIdAgencyProfile = async (id: string,
    updateTeamAgencyProfileRequest: UpdateTeamAgencyProfileRequest, options?: RequestInit): Promise<putApiTeamsIdAgencyProfileResponse> => {

  return fetcher<putApiTeamsIdAgencyProfileResponse>(getPutApiTeamsIdAgencyProfileUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateTeamAgencyProfileRequest,)
  }
);}



export type getApiTeamsAgenciesResponse200TextPlain = {
  data: unknown[]
  status: 200
}

export type getApiTeamsAgenciesResponse200ApplicationJson = {
  data: unknown[]
  status: 200
}

export type getApiTeamsAgenciesResponse200TextJson = {
  data: unknown[]
  status: 200
}

export type getApiTeamsAgenciesResponse401 = {
  data: GetApiTeamsAgencies401
  status: 401
}

export type getApiTeamsAgenciesResponseSuccess = (getApiTeamsAgenciesResponse200TextPlain | getApiTeamsAgenciesResponse200ApplicationJson | getApiTeamsAgenciesResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsAgenciesResponseError = (getApiTeamsAgenciesResponse401) & {
  headers: Headers;
};

export type getApiTeamsAgenciesResponse = (getApiTeamsAgenciesResponseSuccess | getApiTeamsAgenciesResponseError)

export const getGetApiTeamsAgenciesUrl = (params?: GetApiTeamsAgenciesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Teams/agencies?${stringifiedParams}` : `/api/Teams/agencies`
}

export const getApiTeamsAgencies = async (params?: GetApiTeamsAgenciesParams, options?: RequestInit): Promise<getApiTeamsAgenciesResponse> => {

  return fetcher<getApiTeamsAgenciesResponse>(getGetApiTeamsAgenciesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsIdMembersResponse200TextPlain = {
  data: TeamDetailDto
  status: 200
}

export type postApiTeamsIdMembersResponse200ApplicationJson = {
  data: TeamDetailDto
  status: 200
}

export type postApiTeamsIdMembersResponse200TextJson = {
  data: TeamDetailDto
  status: 200
}

export type postApiTeamsIdMembersResponse401 = {
  data: PostApiTeamsIdMembers401
  status: 401
}

export type postApiTeamsIdMembersResponse402 = {
  data: PostApiTeamsIdMembers402
  status: 402
}

export type postApiTeamsIdMembersResponseSuccess = (postApiTeamsIdMembersResponse200TextPlain | postApiTeamsIdMembersResponse200ApplicationJson | postApiTeamsIdMembersResponse200TextJson) & {
  headers: Headers;
};
export type postApiTeamsIdMembersResponseError = (postApiTeamsIdMembersResponse401 | postApiTeamsIdMembersResponse402) & {
  headers: Headers;
};

export type postApiTeamsIdMembersResponse = (postApiTeamsIdMembersResponseSuccess | postApiTeamsIdMembersResponseError)

export const getPostApiTeamsIdMembersUrl = (id: string,) => {




  return `/api/Teams/${id}/members`
}

export const postApiTeamsIdMembers = async (id: string,
    addTeamMemberRequest: AddTeamMemberRequest, options?: RequestInit): Promise<postApiTeamsIdMembersResponse> => {

  return fetcher<postApiTeamsIdMembersResponse>(getPostApiTeamsIdMembersUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      addTeamMemberRequest,)
  }
);}



export type postApiTeamsIdStaffAgencyStaffIdAssignSeatResponse200TextPlain = {
  data: TeamDetailDto
  status: 200
}

export type postApiTeamsIdStaffAgencyStaffIdAssignSeatResponse200ApplicationJson = {
  data: TeamDetailDto
  status: 200
}

export type postApiTeamsIdStaffAgencyStaffIdAssignSeatResponse200TextJson = {
  data: TeamDetailDto
  status: 200
}

export type postApiTeamsIdStaffAgencyStaffIdAssignSeatResponse401 = {
  data: PostApiTeamsIdStaffAgencyStaffIdAssignSeat401
  status: 401
}

export type postApiTeamsIdStaffAgencyStaffIdAssignSeatResponse402 = {
  data: PostApiTeamsIdStaffAgencyStaffIdAssignSeat402
  status: 402
}

export type postApiTeamsIdStaffAgencyStaffIdAssignSeatResponseSuccess = (postApiTeamsIdStaffAgencyStaffIdAssignSeatResponse200TextPlain | postApiTeamsIdStaffAgencyStaffIdAssignSeatResponse200ApplicationJson | postApiTeamsIdStaffAgencyStaffIdAssignSeatResponse200TextJson) & {
  headers: Headers;
};
export type postApiTeamsIdStaffAgencyStaffIdAssignSeatResponseError = (postApiTeamsIdStaffAgencyStaffIdAssignSeatResponse401 | postApiTeamsIdStaffAgencyStaffIdAssignSeatResponse402) & {
  headers: Headers;
};

export type postApiTeamsIdStaffAgencyStaffIdAssignSeatResponse = (postApiTeamsIdStaffAgencyStaffIdAssignSeatResponseSuccess | postApiTeamsIdStaffAgencyStaffIdAssignSeatResponseError)

export const getPostApiTeamsIdStaffAgencyStaffIdAssignSeatUrl = (id: string,
    agencyStaffId: string,
    params?: PostApiTeamsIdStaffAgencyStaffIdAssignSeatParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Teams/${id}/staff/${agencyStaffId}/assign-seat?${stringifiedParams}` : `/api/Teams/${id}/staff/${agencyStaffId}/assign-seat`
}

export const postApiTeamsIdStaffAgencyStaffIdAssignSeat = async (id: string,
    agencyStaffId: string,
    params?: PostApiTeamsIdStaffAgencyStaffIdAssignSeatParams, options?: RequestInit): Promise<postApiTeamsIdStaffAgencyStaffIdAssignSeatResponse> => {

  return fetcher<postApiTeamsIdStaffAgencyStaffIdAssignSeatResponse>(getPostApiTeamsIdStaffAgencyStaffIdAssignSeatUrl(id,agencyStaffId,params),
  {
    ...options,
    method: 'POST'


  }
);}



export type postApiTeamsIdMembersUserIdActivateResponse200TextPlain = {
  data: TeamDetailDto
  status: 200
}

export type postApiTeamsIdMembersUserIdActivateResponse200ApplicationJson = {
  data: TeamDetailDto
  status: 200
}

export type postApiTeamsIdMembersUserIdActivateResponse200TextJson = {
  data: TeamDetailDto
  status: 200
}

export type postApiTeamsIdMembersUserIdActivateResponse401 = {
  data: PostApiTeamsIdMembersUserIdActivate401
  status: 401
}

export type postApiTeamsIdMembersUserIdActivateResponse402 = {
  data: PostApiTeamsIdMembersUserIdActivate402
  status: 402
}

export type postApiTeamsIdMembersUserIdActivateResponseSuccess = (postApiTeamsIdMembersUserIdActivateResponse200TextPlain | postApiTeamsIdMembersUserIdActivateResponse200ApplicationJson | postApiTeamsIdMembersUserIdActivateResponse200TextJson) & {
  headers: Headers;
};
export type postApiTeamsIdMembersUserIdActivateResponseError = (postApiTeamsIdMembersUserIdActivateResponse401 | postApiTeamsIdMembersUserIdActivateResponse402) & {
  headers: Headers;
};

export type postApiTeamsIdMembersUserIdActivateResponse = (postApiTeamsIdMembersUserIdActivateResponseSuccess | postApiTeamsIdMembersUserIdActivateResponseError)

export const getPostApiTeamsIdMembersUserIdActivateUrl = (id: string,
    userId: string,) => {




  return `/api/Teams/${id}/members/${userId}/activate`
}

export const postApiTeamsIdMembersUserIdActivate = async (id: string,
    userId: string, options?: RequestInit): Promise<postApiTeamsIdMembersUserIdActivateResponse> => {

  return fetcher<postApiTeamsIdMembersUserIdActivateResponse>(getPostApiTeamsIdMembersUserIdActivateUrl(id,userId),
  {
    ...options,
    method: 'POST'


  }
);}



export type postApiTeamsIdMembersUserIdReassignResponse200TextPlain = {
  data: TeamDetailDto
  status: 200
}

export type postApiTeamsIdMembersUserIdReassignResponse200ApplicationJson = {
  data: TeamDetailDto
  status: 200
}

export type postApiTeamsIdMembersUserIdReassignResponse200TextJson = {
  data: TeamDetailDto
  status: 200
}

export type postApiTeamsIdMembersUserIdReassignResponse401 = {
  data: PostApiTeamsIdMembersUserIdReassign401
  status: 401
}

export type postApiTeamsIdMembersUserIdReassignResponse402 = {
  data: PostApiTeamsIdMembersUserIdReassign402
  status: 402
}

export type postApiTeamsIdMembersUserIdReassignResponseSuccess = (postApiTeamsIdMembersUserIdReassignResponse200TextPlain | postApiTeamsIdMembersUserIdReassignResponse200ApplicationJson | postApiTeamsIdMembersUserIdReassignResponse200TextJson) & {
  headers: Headers;
};
export type postApiTeamsIdMembersUserIdReassignResponseError = (postApiTeamsIdMembersUserIdReassignResponse401 | postApiTeamsIdMembersUserIdReassignResponse402) & {
  headers: Headers;
};

export type postApiTeamsIdMembersUserIdReassignResponse = (postApiTeamsIdMembersUserIdReassignResponseSuccess | postApiTeamsIdMembersUserIdReassignResponseError)

export const getPostApiTeamsIdMembersUserIdReassignUrl = (id: string,
    userId: string,) => {




  return `/api/Teams/${id}/members/${userId}/reassign`
}

export const postApiTeamsIdMembersUserIdReassign = async (id: string,
    userId: string,
    reassignPendingTeamMemberRequest: ReassignPendingTeamMemberRequest, options?: RequestInit): Promise<postApiTeamsIdMembersUserIdReassignResponse> => {

  return fetcher<postApiTeamsIdMembersUserIdReassignResponse>(getPostApiTeamsIdMembersUserIdReassignUrl(id,userId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      reassignPendingTeamMemberRequest,)
  }
);}



export type deleteApiTeamsIdMembersUserIdResponse200TextPlain = {
  data: TeamDetailDto
  status: 200
}

export type deleteApiTeamsIdMembersUserIdResponse200ApplicationJson = {
  data: TeamDetailDto
  status: 200
}

export type deleteApiTeamsIdMembersUserIdResponse200TextJson = {
  data: TeamDetailDto
  status: 200
}

export type deleteApiTeamsIdMembersUserIdResponse401 = {
  data: DeleteApiTeamsIdMembersUserId401
  status: 401
}

export type deleteApiTeamsIdMembersUserIdResponse402 = {
  data: DeleteApiTeamsIdMembersUserId402
  status: 402
}

export type deleteApiTeamsIdMembersUserIdResponseSuccess = (deleteApiTeamsIdMembersUserIdResponse200TextPlain | deleteApiTeamsIdMembersUserIdResponse200ApplicationJson | deleteApiTeamsIdMembersUserIdResponse200TextJson) & {
  headers: Headers;
};
export type deleteApiTeamsIdMembersUserIdResponseError = (deleteApiTeamsIdMembersUserIdResponse401 | deleteApiTeamsIdMembersUserIdResponse402) & {
  headers: Headers;
};

export type deleteApiTeamsIdMembersUserIdResponse = (deleteApiTeamsIdMembersUserIdResponseSuccess | deleteApiTeamsIdMembersUserIdResponseError)

export const getDeleteApiTeamsIdMembersUserIdUrl = (id: string,
    userId: string,) => {




  return `/api/Teams/${id}/members/${userId}`
}

export const deleteApiTeamsIdMembersUserId = async (id: string,
    userId: string, options?: RequestInit): Promise<deleteApiTeamsIdMembersUserIdResponse> => {

  return fetcher<deleteApiTeamsIdMembersUserIdResponse>(getDeleteApiTeamsIdMembersUserIdUrl(id,userId),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type getApiTeamsIdStaffResponse200TextPlain = {
  data: TeamStaffDto[]
  status: 200
}

export type getApiTeamsIdStaffResponse200ApplicationJson = {
  data: TeamStaffDto[]
  status: 200
}

export type getApiTeamsIdStaffResponse200TextJson = {
  data: TeamStaffDto[]
  status: 200
}

export type getApiTeamsIdStaffResponse401 = {
  data: GetApiTeamsIdStaff401
  status: 401
}

export type getApiTeamsIdStaffResponseSuccess = (getApiTeamsIdStaffResponse200TextPlain | getApiTeamsIdStaffResponse200ApplicationJson | getApiTeamsIdStaffResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsIdStaffResponseError = (getApiTeamsIdStaffResponse401) & {
  headers: Headers;
};

export type getApiTeamsIdStaffResponse = (getApiTeamsIdStaffResponseSuccess | getApiTeamsIdStaffResponseError)

export const getGetApiTeamsIdStaffUrl = (id: string,) => {




  return `/api/Teams/${id}/staff`
}

export const getApiTeamsIdStaff = async (id: string, options?: RequestInit): Promise<getApiTeamsIdStaffResponse> => {

  return fetcher<getApiTeamsIdStaffResponse>(getGetApiTeamsIdStaffUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsIdStaffResponse200TextPlain = {
  data: TeamStaffDto
  status: 200
}

export type postApiTeamsIdStaffResponse200ApplicationJson = {
  data: TeamStaffDto
  status: 200
}

export type postApiTeamsIdStaffResponse200TextJson = {
  data: TeamStaffDto
  status: 200
}

export type postApiTeamsIdStaffResponse401 = {
  data: PostApiTeamsIdStaff401
  status: 401
}

export type postApiTeamsIdStaffResponse402 = {
  data: PostApiTeamsIdStaff402
  status: 402
}

export type postApiTeamsIdStaffResponseSuccess = (postApiTeamsIdStaffResponse200TextPlain | postApiTeamsIdStaffResponse200ApplicationJson | postApiTeamsIdStaffResponse200TextJson) & {
  headers: Headers;
};
export type postApiTeamsIdStaffResponseError = (postApiTeamsIdStaffResponse401 | postApiTeamsIdStaffResponse402) & {
  headers: Headers;
};

export type postApiTeamsIdStaffResponse = (postApiTeamsIdStaffResponseSuccess | postApiTeamsIdStaffResponseError)

export const getPostApiTeamsIdStaffUrl = (id: string,) => {




  return `/api/Teams/${id}/staff`
}

export const postApiTeamsIdStaff = async (id: string,
    createTeamStaffRequest: CreateTeamStaffRequest, options?: RequestInit): Promise<postApiTeamsIdStaffResponse> => {

  return fetcher<postApiTeamsIdStaffResponse>(getPostApiTeamsIdStaffUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createTeamStaffRequest,)
  }
);}



export type getApiTeamsIdProducerLicensesResponse200TextPlain = {
  data: TeamProducerLicenseDto[]
  status: 200
}

export type getApiTeamsIdProducerLicensesResponse200ApplicationJson = {
  data: TeamProducerLicenseDto[]
  status: 200
}

export type getApiTeamsIdProducerLicensesResponse200TextJson = {
  data: TeamProducerLicenseDto[]
  status: 200
}

export type getApiTeamsIdProducerLicensesResponse401 = {
  data: GetApiTeamsIdProducerLicenses401
  status: 401
}

export type getApiTeamsIdProducerLicensesResponseSuccess = (getApiTeamsIdProducerLicensesResponse200TextPlain | getApiTeamsIdProducerLicensesResponse200ApplicationJson | getApiTeamsIdProducerLicensesResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsIdProducerLicensesResponseError = (getApiTeamsIdProducerLicensesResponse401) & {
  headers: Headers;
};

export type getApiTeamsIdProducerLicensesResponse = (getApiTeamsIdProducerLicensesResponseSuccess | getApiTeamsIdProducerLicensesResponseError)

export const getGetApiTeamsIdProducerLicensesUrl = (id: string,) => {




  return `/api/Teams/${id}/producer-licenses`
}

export const getApiTeamsIdProducerLicenses = async (id: string, options?: RequestInit): Promise<getApiTeamsIdProducerLicensesResponse> => {

  return fetcher<getApiTeamsIdProducerLicensesResponse>(getGetApiTeamsIdProducerLicensesUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsIdProducerLicensesResponse200TextPlain = {
  data: TeamProducerLicenseDto
  status: 200
}

export type postApiTeamsIdProducerLicensesResponse200ApplicationJson = {
  data: TeamProducerLicenseDto
  status: 200
}

export type postApiTeamsIdProducerLicensesResponse200TextJson = {
  data: TeamProducerLicenseDto
  status: 200
}

export type postApiTeamsIdProducerLicensesResponse401 = {
  data: PostApiTeamsIdProducerLicenses401
  status: 401
}

export type postApiTeamsIdProducerLicensesResponse402 = {
  data: PostApiTeamsIdProducerLicenses402
  status: 402
}

export type postApiTeamsIdProducerLicensesResponseSuccess = (postApiTeamsIdProducerLicensesResponse200TextPlain | postApiTeamsIdProducerLicensesResponse200ApplicationJson | postApiTeamsIdProducerLicensesResponse200TextJson) & {
  headers: Headers;
};
export type postApiTeamsIdProducerLicensesResponseError = (postApiTeamsIdProducerLicensesResponse401 | postApiTeamsIdProducerLicensesResponse402) & {
  headers: Headers;
};

export type postApiTeamsIdProducerLicensesResponse = (postApiTeamsIdProducerLicensesResponseSuccess | postApiTeamsIdProducerLicensesResponseError)

export const getPostApiTeamsIdProducerLicensesUrl = (id: string,) => {




  return `/api/Teams/${id}/producer-licenses`
}

export const postApiTeamsIdProducerLicenses = async (id: string,
    createProducerLicenseRequest: CreateProducerLicenseRequest, options?: RequestInit): Promise<postApiTeamsIdProducerLicensesResponse> => {

  return fetcher<postApiTeamsIdProducerLicensesResponse>(getPostApiTeamsIdProducerLicensesUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createProducerLicenseRequest,)
  }
);}



export type patchApiTeamsIdProducerLicensesProducerLicenseIdResponse200TextPlain = {
  data: TeamProducerLicenseDto
  status: 200
}

export type patchApiTeamsIdProducerLicensesProducerLicenseIdResponse200ApplicationJson = {
  data: TeamProducerLicenseDto
  status: 200
}

export type patchApiTeamsIdProducerLicensesProducerLicenseIdResponse200TextJson = {
  data: TeamProducerLicenseDto
  status: 200
}

export type patchApiTeamsIdProducerLicensesProducerLicenseIdResponse401 = {
  data: PatchApiTeamsIdProducerLicensesProducerLicenseId401
  status: 401
}

export type patchApiTeamsIdProducerLicensesProducerLicenseIdResponse402 = {
  data: PatchApiTeamsIdProducerLicensesProducerLicenseId402
  status: 402
}

export type patchApiTeamsIdProducerLicensesProducerLicenseIdResponseSuccess = (patchApiTeamsIdProducerLicensesProducerLicenseIdResponse200TextPlain | patchApiTeamsIdProducerLicensesProducerLicenseIdResponse200ApplicationJson | patchApiTeamsIdProducerLicensesProducerLicenseIdResponse200TextJson) & {
  headers: Headers;
};
export type patchApiTeamsIdProducerLicensesProducerLicenseIdResponseError = (patchApiTeamsIdProducerLicensesProducerLicenseIdResponse401 | patchApiTeamsIdProducerLicensesProducerLicenseIdResponse402) & {
  headers: Headers;
};

export type patchApiTeamsIdProducerLicensesProducerLicenseIdResponse = (patchApiTeamsIdProducerLicensesProducerLicenseIdResponseSuccess | patchApiTeamsIdProducerLicensesProducerLicenseIdResponseError)

export const getPatchApiTeamsIdProducerLicensesProducerLicenseIdUrl = (id: string,
    producerLicenseId: string,) => {




  return `/api/Teams/${id}/producer-licenses/${producerLicenseId}`
}

export const patchApiTeamsIdProducerLicensesProducerLicenseId = async (id: string,
    producerLicenseId: string,
    updateProducerLicenseRequest: UpdateProducerLicenseRequest, options?: RequestInit): Promise<patchApiTeamsIdProducerLicensesProducerLicenseIdResponse> => {

  return fetcher<patchApiTeamsIdProducerLicensesProducerLicenseIdResponse>(getPatchApiTeamsIdProducerLicensesProducerLicenseIdUrl(id,producerLicenseId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateProducerLicenseRequest,)
  }
);}



export type deleteApiTeamsIdProducerLicensesProducerLicenseIdResponse200 = {
  data: void
  status: 200
}

export type deleteApiTeamsIdProducerLicensesProducerLicenseIdResponse401 = {
  data: DeleteApiTeamsIdProducerLicensesProducerLicenseId401
  status: 401
}

export type deleteApiTeamsIdProducerLicensesProducerLicenseIdResponse402 = {
  data: DeleteApiTeamsIdProducerLicensesProducerLicenseId402
  status: 402
}

export type deleteApiTeamsIdProducerLicensesProducerLicenseIdResponseSuccess = (deleteApiTeamsIdProducerLicensesProducerLicenseIdResponse200) & {
  headers: Headers;
};
export type deleteApiTeamsIdProducerLicensesProducerLicenseIdResponseError = (deleteApiTeamsIdProducerLicensesProducerLicenseIdResponse401 | deleteApiTeamsIdProducerLicensesProducerLicenseIdResponse402) & {
  headers: Headers;
};

export type deleteApiTeamsIdProducerLicensesProducerLicenseIdResponse = (deleteApiTeamsIdProducerLicensesProducerLicenseIdResponseSuccess | deleteApiTeamsIdProducerLicensesProducerLicenseIdResponseError)

export const getDeleteApiTeamsIdProducerLicensesProducerLicenseIdUrl = (id: string,
    producerLicenseId: string,) => {




  return `/api/Teams/${id}/producer-licenses/${producerLicenseId}`
}

export const deleteApiTeamsIdProducerLicensesProducerLicenseId = async (id: string,
    producerLicenseId: string, options?: RequestInit): Promise<deleteApiTeamsIdProducerLicensesProducerLicenseIdResponse> => {

  return fetcher<deleteApiTeamsIdProducerLicensesProducerLicenseIdResponse>(getDeleteApiTeamsIdProducerLicensesProducerLicenseIdUrl(id,producerLicenseId),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type getApiTeamsIdAgencyLicensesResponse200TextPlain = {
  data: TeamAgencyLicenseDto[]
  status: 200
}

export type getApiTeamsIdAgencyLicensesResponse200ApplicationJson = {
  data: TeamAgencyLicenseDto[]
  status: 200
}

export type getApiTeamsIdAgencyLicensesResponse200TextJson = {
  data: TeamAgencyLicenseDto[]
  status: 200
}

export type getApiTeamsIdAgencyLicensesResponse401 = {
  data: GetApiTeamsIdAgencyLicenses401
  status: 401
}

export type getApiTeamsIdAgencyLicensesResponseSuccess = (getApiTeamsIdAgencyLicensesResponse200TextPlain | getApiTeamsIdAgencyLicensesResponse200ApplicationJson | getApiTeamsIdAgencyLicensesResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsIdAgencyLicensesResponseError = (getApiTeamsIdAgencyLicensesResponse401) & {
  headers: Headers;
};

export type getApiTeamsIdAgencyLicensesResponse = (getApiTeamsIdAgencyLicensesResponseSuccess | getApiTeamsIdAgencyLicensesResponseError)

export const getGetApiTeamsIdAgencyLicensesUrl = (id: string,) => {




  return `/api/Teams/${id}/agency-licenses`
}

export const getApiTeamsIdAgencyLicenses = async (id: string, options?: RequestInit): Promise<getApiTeamsIdAgencyLicensesResponse> => {

  return fetcher<getApiTeamsIdAgencyLicensesResponse>(getGetApiTeamsIdAgencyLicensesUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsIdAgencyLicensesResponse200TextPlain = {
  data: TeamAgencyLicenseDto
  status: 200
}

export type postApiTeamsIdAgencyLicensesResponse200ApplicationJson = {
  data: TeamAgencyLicenseDto
  status: 200
}

export type postApiTeamsIdAgencyLicensesResponse200TextJson = {
  data: TeamAgencyLicenseDto
  status: 200
}

export type postApiTeamsIdAgencyLicensesResponse401 = {
  data: PostApiTeamsIdAgencyLicenses401
  status: 401
}

export type postApiTeamsIdAgencyLicensesResponse402 = {
  data: PostApiTeamsIdAgencyLicenses402
  status: 402
}

export type postApiTeamsIdAgencyLicensesResponseSuccess = (postApiTeamsIdAgencyLicensesResponse200TextPlain | postApiTeamsIdAgencyLicensesResponse200ApplicationJson | postApiTeamsIdAgencyLicensesResponse200TextJson) & {
  headers: Headers;
};
export type postApiTeamsIdAgencyLicensesResponseError = (postApiTeamsIdAgencyLicensesResponse401 | postApiTeamsIdAgencyLicensesResponse402) & {
  headers: Headers;
};

export type postApiTeamsIdAgencyLicensesResponse = (postApiTeamsIdAgencyLicensesResponseSuccess | postApiTeamsIdAgencyLicensesResponseError)

export const getPostApiTeamsIdAgencyLicensesUrl = (id: string,) => {




  return `/api/Teams/${id}/agency-licenses`
}

export const postApiTeamsIdAgencyLicenses = async (id: string,
    createAgencyLicenseRequest: CreateAgencyLicenseRequest, options?: RequestInit): Promise<postApiTeamsIdAgencyLicensesResponse> => {

  return fetcher<postApiTeamsIdAgencyLicensesResponse>(getPostApiTeamsIdAgencyLicensesUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createAgencyLicenseRequest,)
  }
);}



export type patchApiTeamsIdAgencyLicensesAgencyLicenseIdResponse200TextPlain = {
  data: TeamAgencyLicenseDto
  status: 200
}

export type patchApiTeamsIdAgencyLicensesAgencyLicenseIdResponse200ApplicationJson = {
  data: TeamAgencyLicenseDto
  status: 200
}

export type patchApiTeamsIdAgencyLicensesAgencyLicenseIdResponse200TextJson = {
  data: TeamAgencyLicenseDto
  status: 200
}

export type patchApiTeamsIdAgencyLicensesAgencyLicenseIdResponse401 = {
  data: PatchApiTeamsIdAgencyLicensesAgencyLicenseId401
  status: 401
}

export type patchApiTeamsIdAgencyLicensesAgencyLicenseIdResponse402 = {
  data: PatchApiTeamsIdAgencyLicensesAgencyLicenseId402
  status: 402
}

export type patchApiTeamsIdAgencyLicensesAgencyLicenseIdResponseSuccess = (patchApiTeamsIdAgencyLicensesAgencyLicenseIdResponse200TextPlain | patchApiTeamsIdAgencyLicensesAgencyLicenseIdResponse200ApplicationJson | patchApiTeamsIdAgencyLicensesAgencyLicenseIdResponse200TextJson) & {
  headers: Headers;
};
export type patchApiTeamsIdAgencyLicensesAgencyLicenseIdResponseError = (patchApiTeamsIdAgencyLicensesAgencyLicenseIdResponse401 | patchApiTeamsIdAgencyLicensesAgencyLicenseIdResponse402) & {
  headers: Headers;
};

export type patchApiTeamsIdAgencyLicensesAgencyLicenseIdResponse = (patchApiTeamsIdAgencyLicensesAgencyLicenseIdResponseSuccess | patchApiTeamsIdAgencyLicensesAgencyLicenseIdResponseError)

export const getPatchApiTeamsIdAgencyLicensesAgencyLicenseIdUrl = (id: string,
    agencyLicenseId: string,) => {




  return `/api/Teams/${id}/agency-licenses/${agencyLicenseId}`
}

export const patchApiTeamsIdAgencyLicensesAgencyLicenseId = async (id: string,
    agencyLicenseId: string,
    updateAgencyLicenseRequest: UpdateAgencyLicenseRequest, options?: RequestInit): Promise<patchApiTeamsIdAgencyLicensesAgencyLicenseIdResponse> => {

  return fetcher<patchApiTeamsIdAgencyLicensesAgencyLicenseIdResponse>(getPatchApiTeamsIdAgencyLicensesAgencyLicenseIdUrl(id,agencyLicenseId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateAgencyLicenseRequest,)
  }
);}



export type deleteApiTeamsIdAgencyLicensesAgencyLicenseIdResponse200 = {
  data: void
  status: 200
}

export type deleteApiTeamsIdAgencyLicensesAgencyLicenseIdResponse401 = {
  data: DeleteApiTeamsIdAgencyLicensesAgencyLicenseId401
  status: 401
}

export type deleteApiTeamsIdAgencyLicensesAgencyLicenseIdResponse402 = {
  data: DeleteApiTeamsIdAgencyLicensesAgencyLicenseId402
  status: 402
}

export type deleteApiTeamsIdAgencyLicensesAgencyLicenseIdResponseSuccess = (deleteApiTeamsIdAgencyLicensesAgencyLicenseIdResponse200) & {
  headers: Headers;
};
export type deleteApiTeamsIdAgencyLicensesAgencyLicenseIdResponseError = (deleteApiTeamsIdAgencyLicensesAgencyLicenseIdResponse401 | deleteApiTeamsIdAgencyLicensesAgencyLicenseIdResponse402) & {
  headers: Headers;
};

export type deleteApiTeamsIdAgencyLicensesAgencyLicenseIdResponse = (deleteApiTeamsIdAgencyLicensesAgencyLicenseIdResponseSuccess | deleteApiTeamsIdAgencyLicensesAgencyLicenseIdResponseError)

export const getDeleteApiTeamsIdAgencyLicensesAgencyLicenseIdUrl = (id: string,
    agencyLicenseId: string,) => {




  return `/api/Teams/${id}/agency-licenses/${agencyLicenseId}`
}

export const deleteApiTeamsIdAgencyLicensesAgencyLicenseId = async (id: string,
    agencyLicenseId: string, options?: RequestInit): Promise<deleteApiTeamsIdAgencyLicensesAgencyLicenseIdResponse> => {

  return fetcher<deleteApiTeamsIdAgencyLicensesAgencyLicenseIdResponse>(getDeleteApiTeamsIdAgencyLicensesAgencyLicenseIdUrl(id,agencyLicenseId),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type getApiTeamsIdCarrierAppointmentsResponse200TextPlain = {
  data: TeamCarrierAppointmentDto[]
  status: 200
}

export type getApiTeamsIdCarrierAppointmentsResponse200ApplicationJson = {
  data: TeamCarrierAppointmentDto[]
  status: 200
}

export type getApiTeamsIdCarrierAppointmentsResponse200TextJson = {
  data: TeamCarrierAppointmentDto[]
  status: 200
}

export type getApiTeamsIdCarrierAppointmentsResponse401 = {
  data: GetApiTeamsIdCarrierAppointments401
  status: 401
}

export type getApiTeamsIdCarrierAppointmentsResponseSuccess = (getApiTeamsIdCarrierAppointmentsResponse200TextPlain | getApiTeamsIdCarrierAppointmentsResponse200ApplicationJson | getApiTeamsIdCarrierAppointmentsResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsIdCarrierAppointmentsResponseError = (getApiTeamsIdCarrierAppointmentsResponse401) & {
  headers: Headers;
};

export type getApiTeamsIdCarrierAppointmentsResponse = (getApiTeamsIdCarrierAppointmentsResponseSuccess | getApiTeamsIdCarrierAppointmentsResponseError)

export const getGetApiTeamsIdCarrierAppointmentsUrl = (id: string,) => {




  return `/api/Teams/${id}/carrier-appointments`
}

export const getApiTeamsIdCarrierAppointments = async (id: string, options?: RequestInit): Promise<getApiTeamsIdCarrierAppointmentsResponse> => {

  return fetcher<getApiTeamsIdCarrierAppointmentsResponse>(getGetApiTeamsIdCarrierAppointmentsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsIdCarrierAppointmentsResponse200TextPlain = {
  data: TeamCarrierAppointmentDto
  status: 200
}

export type postApiTeamsIdCarrierAppointmentsResponse200ApplicationJson = {
  data: TeamCarrierAppointmentDto
  status: 200
}

export type postApiTeamsIdCarrierAppointmentsResponse200TextJson = {
  data: TeamCarrierAppointmentDto
  status: 200
}

export type postApiTeamsIdCarrierAppointmentsResponse401 = {
  data: PostApiTeamsIdCarrierAppointments401
  status: 401
}

export type postApiTeamsIdCarrierAppointmentsResponse402 = {
  data: PostApiTeamsIdCarrierAppointments402
  status: 402
}

export type postApiTeamsIdCarrierAppointmentsResponseSuccess = (postApiTeamsIdCarrierAppointmentsResponse200TextPlain | postApiTeamsIdCarrierAppointmentsResponse200ApplicationJson | postApiTeamsIdCarrierAppointmentsResponse200TextJson) & {
  headers: Headers;
};
export type postApiTeamsIdCarrierAppointmentsResponseError = (postApiTeamsIdCarrierAppointmentsResponse401 | postApiTeamsIdCarrierAppointmentsResponse402) & {
  headers: Headers;
};

export type postApiTeamsIdCarrierAppointmentsResponse = (postApiTeamsIdCarrierAppointmentsResponseSuccess | postApiTeamsIdCarrierAppointmentsResponseError)

export const getPostApiTeamsIdCarrierAppointmentsUrl = (id: string,) => {




  return `/api/Teams/${id}/carrier-appointments`
}

export const postApiTeamsIdCarrierAppointments = async (id: string,
    createCarrierAppointmentRequest: CreateCarrierAppointmentRequest, options?: RequestInit): Promise<postApiTeamsIdCarrierAppointmentsResponse> => {

  return fetcher<postApiTeamsIdCarrierAppointmentsResponse>(getPostApiTeamsIdCarrierAppointmentsUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createCarrierAppointmentRequest,)
  }
);}



export type patchApiTeamsIdCarrierAppointmentsCarrierAppointmentIdResponse200TextPlain = {
  data: TeamCarrierAppointmentDto
  status: 200
}

export type patchApiTeamsIdCarrierAppointmentsCarrierAppointmentIdResponse200ApplicationJson = {
  data: TeamCarrierAppointmentDto
  status: 200
}

export type patchApiTeamsIdCarrierAppointmentsCarrierAppointmentIdResponse200TextJson = {
  data: TeamCarrierAppointmentDto
  status: 200
}

export type patchApiTeamsIdCarrierAppointmentsCarrierAppointmentIdResponse401 = {
  data: PatchApiTeamsIdCarrierAppointmentsCarrierAppointmentId401
  status: 401
}

export type patchApiTeamsIdCarrierAppointmentsCarrierAppointmentIdResponse402 = {
  data: PatchApiTeamsIdCarrierAppointmentsCarrierAppointmentId402
  status: 402
}

export type patchApiTeamsIdCarrierAppointmentsCarrierAppointmentIdResponseSuccess = (patchApiTeamsIdCarrierAppointmentsCarrierAppointmentIdResponse200TextPlain | patchApiTeamsIdCarrierAppointmentsCarrierAppointmentIdResponse200ApplicationJson | patchApiTeamsIdCarrierAppointmentsCarrierAppointmentIdResponse200TextJson) & {
  headers: Headers;
};
export type patchApiTeamsIdCarrierAppointmentsCarrierAppointmentIdResponseError = (patchApiTeamsIdCarrierAppointmentsCarrierAppointmentIdResponse401 | patchApiTeamsIdCarrierAppointmentsCarrierAppointmentIdResponse402) & {
  headers: Headers;
};

export type patchApiTeamsIdCarrierAppointmentsCarrierAppointmentIdResponse = (patchApiTeamsIdCarrierAppointmentsCarrierAppointmentIdResponseSuccess | patchApiTeamsIdCarrierAppointmentsCarrierAppointmentIdResponseError)

export const getPatchApiTeamsIdCarrierAppointmentsCarrierAppointmentIdUrl = (id: string,
    carrierAppointmentId: string,) => {




  return `/api/Teams/${id}/carrier-appointments/${carrierAppointmentId}`
}

export const patchApiTeamsIdCarrierAppointmentsCarrierAppointmentId = async (id: string,
    carrierAppointmentId: string,
    updateCarrierAppointmentRequest: UpdateCarrierAppointmentRequest, options?: RequestInit): Promise<patchApiTeamsIdCarrierAppointmentsCarrierAppointmentIdResponse> => {

  return fetcher<patchApiTeamsIdCarrierAppointmentsCarrierAppointmentIdResponse>(getPatchApiTeamsIdCarrierAppointmentsCarrierAppointmentIdUrl(id,carrierAppointmentId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateCarrierAppointmentRequest,)
  }
);}



export type deleteApiTeamsIdCarrierAppointmentsCarrierAppointmentIdResponse200 = {
  data: void
  status: 200
}

export type deleteApiTeamsIdCarrierAppointmentsCarrierAppointmentIdResponse401 = {
  data: DeleteApiTeamsIdCarrierAppointmentsCarrierAppointmentId401
  status: 401
}

export type deleteApiTeamsIdCarrierAppointmentsCarrierAppointmentIdResponse402 = {
  data: DeleteApiTeamsIdCarrierAppointmentsCarrierAppointmentId402
  status: 402
}

export type deleteApiTeamsIdCarrierAppointmentsCarrierAppointmentIdResponseSuccess = (deleteApiTeamsIdCarrierAppointmentsCarrierAppointmentIdResponse200) & {
  headers: Headers;
};
export type deleteApiTeamsIdCarrierAppointmentsCarrierAppointmentIdResponseError = (deleteApiTeamsIdCarrierAppointmentsCarrierAppointmentIdResponse401 | deleteApiTeamsIdCarrierAppointmentsCarrierAppointmentIdResponse402) & {
  headers: Headers;
};

export type deleteApiTeamsIdCarrierAppointmentsCarrierAppointmentIdResponse = (deleteApiTeamsIdCarrierAppointmentsCarrierAppointmentIdResponseSuccess | deleteApiTeamsIdCarrierAppointmentsCarrierAppointmentIdResponseError)

export const getDeleteApiTeamsIdCarrierAppointmentsCarrierAppointmentIdUrl = (id: string,
    carrierAppointmentId: string,) => {




  return `/api/Teams/${id}/carrier-appointments/${carrierAppointmentId}`
}

export const deleteApiTeamsIdCarrierAppointmentsCarrierAppointmentId = async (id: string,
    carrierAppointmentId: string, options?: RequestInit): Promise<deleteApiTeamsIdCarrierAppointmentsCarrierAppointmentIdResponse> => {

  return fetcher<deleteApiTeamsIdCarrierAppointmentsCarrierAppointmentIdResponse>(getDeleteApiTeamsIdCarrierAppointmentsCarrierAppointmentIdUrl(id,carrierAppointmentId),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type getApiTeamsStaffRoleCodesResponse200TextPlain = {
  data: unknown[]
  status: 200
}

export type getApiTeamsStaffRoleCodesResponse200ApplicationJson = {
  data: unknown[]
  status: 200
}

export type getApiTeamsStaffRoleCodesResponse200TextJson = {
  data: unknown[]
  status: 200
}

export type getApiTeamsStaffRoleCodesResponse401 = {
  data: GetApiTeamsStaffRoleCodes401
  status: 401
}

export type getApiTeamsStaffRoleCodesResponseSuccess = (getApiTeamsStaffRoleCodesResponse200TextPlain | getApiTeamsStaffRoleCodesResponse200ApplicationJson | getApiTeamsStaffRoleCodesResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsStaffRoleCodesResponseError = (getApiTeamsStaffRoleCodesResponse401) & {
  headers: Headers;
};

export type getApiTeamsStaffRoleCodesResponse = (getApiTeamsStaffRoleCodesResponseSuccess | getApiTeamsStaffRoleCodesResponseError)

export const getGetApiTeamsStaffRoleCodesUrl = () => {




  return `/api/Teams/staff-role-codes`
}

export const getApiTeamsStaffRoleCodes = async ( options?: RequestInit): Promise<getApiTeamsStaffRoleCodesResponse> => {

  return fetcher<getApiTeamsStaffRoleCodesResponse>(getGetApiTeamsStaffRoleCodesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type patchApiTeamsIdStaffAgencyStaffIdResponse200TextPlain = {
  data: TeamStaffDto
  status: 200
}

export type patchApiTeamsIdStaffAgencyStaffIdResponse200ApplicationJson = {
  data: TeamStaffDto
  status: 200
}

export type patchApiTeamsIdStaffAgencyStaffIdResponse200TextJson = {
  data: TeamStaffDto
  status: 200
}

export type patchApiTeamsIdStaffAgencyStaffIdResponse401 = {
  data: PatchApiTeamsIdStaffAgencyStaffId401
  status: 401
}

export type patchApiTeamsIdStaffAgencyStaffIdResponse402 = {
  data: PatchApiTeamsIdStaffAgencyStaffId402
  status: 402
}

export type patchApiTeamsIdStaffAgencyStaffIdResponseSuccess = (patchApiTeamsIdStaffAgencyStaffIdResponse200TextPlain | patchApiTeamsIdStaffAgencyStaffIdResponse200ApplicationJson | patchApiTeamsIdStaffAgencyStaffIdResponse200TextJson) & {
  headers: Headers;
};
export type patchApiTeamsIdStaffAgencyStaffIdResponseError = (patchApiTeamsIdStaffAgencyStaffIdResponse401 | patchApiTeamsIdStaffAgencyStaffIdResponse402) & {
  headers: Headers;
};

export type patchApiTeamsIdStaffAgencyStaffIdResponse = (patchApiTeamsIdStaffAgencyStaffIdResponseSuccess | patchApiTeamsIdStaffAgencyStaffIdResponseError)

export const getPatchApiTeamsIdStaffAgencyStaffIdUrl = (id: string,
    agencyStaffId: string,) => {




  return `/api/Teams/${id}/staff/${agencyStaffId}`
}

export const patchApiTeamsIdStaffAgencyStaffId = async (id: string,
    agencyStaffId: string,
    updateTeamStaffRequest: UpdateTeamStaffRequest, options?: RequestInit): Promise<patchApiTeamsIdStaffAgencyStaffIdResponse> => {

  return fetcher<patchApiTeamsIdStaffAgencyStaffIdResponse>(getPatchApiTeamsIdStaffAgencyStaffIdUrl(id,agencyStaffId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateTeamStaffRequest,)
  }
);}



export type getApiTeamsIdLogoResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsIdLogoResponseSuccess = (getApiTeamsIdLogoResponse200) & {
  headers: Headers;
};
;

export type getApiTeamsIdLogoResponse = (getApiTeamsIdLogoResponseSuccess)

export const getGetApiTeamsIdLogoUrl = (id: string,
    params?: GetApiTeamsIdLogoParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Teams/${id}/logo?${stringifiedParams}` : `/api/Teams/${id}/logo`
}

export const getApiTeamsIdLogo = async (id: string,
    params?: GetApiTeamsIdLogoParams, options?: RequestInit): Promise<getApiTeamsIdLogoResponse> => {

  return fetcher<getApiTeamsIdLogoResponse>(getGetApiTeamsIdLogoUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsIdLogoResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsIdLogoResponse401 = {
  data: PostApiTeamsIdLogo401
  status: 401
}

export type postApiTeamsIdLogoResponse402 = {
  data: PostApiTeamsIdLogo402
  status: 402
}

export type postApiTeamsIdLogoResponseSuccess = (postApiTeamsIdLogoResponse200) & {
  headers: Headers;
};
export type postApiTeamsIdLogoResponseError = (postApiTeamsIdLogoResponse401 | postApiTeamsIdLogoResponse402) & {
  headers: Headers;
};

export type postApiTeamsIdLogoResponse = (postApiTeamsIdLogoResponseSuccess | postApiTeamsIdLogoResponseError)

export const getPostApiTeamsIdLogoUrl = (id: string,) => {




  return `/api/Teams/${id}/logo`
}

export const postApiTeamsIdLogo = async (id: string,
    postApiTeamsIdLogoBody: PostApiTeamsIdLogoBody, options?: RequestInit): Promise<postApiTeamsIdLogoResponse> => {
    const formData = new FormData();
if(postApiTeamsIdLogoBody.file !== undefined) {
 formData.append(`file`, postApiTeamsIdLogoBody.file);
 }

  return fetcher<postApiTeamsIdLogoResponse>(getPostApiTeamsIdLogoUrl(id),
  {
    ...options,
    method: 'POST'
    ,
    body:
      formData,
  }
);}



export type deleteApiTeamsIdLogoResponse200 = {
  data: void
  status: 200
}

export type deleteApiTeamsIdLogoResponse401 = {
  data: DeleteApiTeamsIdLogo401
  status: 401
}

export type deleteApiTeamsIdLogoResponse402 = {
  data: DeleteApiTeamsIdLogo402
  status: 402
}

export type deleteApiTeamsIdLogoResponseSuccess = (deleteApiTeamsIdLogoResponse200) & {
  headers: Headers;
};
export type deleteApiTeamsIdLogoResponseError = (deleteApiTeamsIdLogoResponse401 | deleteApiTeamsIdLogoResponse402) & {
  headers: Headers;
};

export type deleteApiTeamsIdLogoResponse = (deleteApiTeamsIdLogoResponseSuccess | deleteApiTeamsIdLogoResponseError)

export const getDeleteApiTeamsIdLogoUrl = (id: string,) => {




  return `/api/Teams/${id}/logo`
}

export const deleteApiTeamsIdLogo = async (id: string, options?: RequestInit): Promise<deleteApiTeamsIdLogoResponse> => {

  return fetcher<deleteApiTeamsIdLogoResponse>(getDeleteApiTeamsIdLogoUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type postApiTeamsIdLogoRemoveResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsIdLogoRemoveResponse401 = {
  data: PostApiTeamsIdLogoRemove401
  status: 401
}

export type postApiTeamsIdLogoRemoveResponse402 = {
  data: PostApiTeamsIdLogoRemove402
  status: 402
}

export type postApiTeamsIdLogoRemoveResponseSuccess = (postApiTeamsIdLogoRemoveResponse200) & {
  headers: Headers;
};
export type postApiTeamsIdLogoRemoveResponseError = (postApiTeamsIdLogoRemoveResponse401 | postApiTeamsIdLogoRemoveResponse402) & {
  headers: Headers;
};

export type postApiTeamsIdLogoRemoveResponse = (postApiTeamsIdLogoRemoveResponseSuccess | postApiTeamsIdLogoRemoveResponseError)

export const getPostApiTeamsIdLogoRemoveUrl = (id: string,) => {




  return `/api/Teams/${id}/logo/remove`
}

export const postApiTeamsIdLogoRemove = async (id: string, options?: RequestInit): Promise<postApiTeamsIdLogoRemoveResponse> => {

  return fetcher<postApiTeamsIdLogoRemoveResponse>(getPostApiTeamsIdLogoRemoveUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}



export type postApiTeamsIdLogoUseUploadIdResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsIdLogoUseUploadIdResponse401 = {
  data: PostApiTeamsIdLogoUseUploadId401
  status: 401
}

export type postApiTeamsIdLogoUseUploadIdResponse402 = {
  data: PostApiTeamsIdLogoUseUploadId402
  status: 402
}

export type postApiTeamsIdLogoUseUploadIdResponseSuccess = (postApiTeamsIdLogoUseUploadIdResponse200) & {
  headers: Headers;
};
export type postApiTeamsIdLogoUseUploadIdResponseError = (postApiTeamsIdLogoUseUploadIdResponse401 | postApiTeamsIdLogoUseUploadIdResponse402) & {
  headers: Headers;
};

export type postApiTeamsIdLogoUseUploadIdResponse = (postApiTeamsIdLogoUseUploadIdResponseSuccess | postApiTeamsIdLogoUseUploadIdResponseError)

export const getPostApiTeamsIdLogoUseUploadIdUrl = (id: string,
    uploadId: string,) => {




  return `/api/Teams/${id}/logo/use/${uploadId}`
}

export const postApiTeamsIdLogoUseUploadId = async (id: string,
    uploadId: string, options?: RequestInit): Promise<postApiTeamsIdLogoUseUploadIdResponse> => {

  return fetcher<postApiTeamsIdLogoUseUploadIdResponse>(getPostApiTeamsIdLogoUseUploadIdUrl(id,uploadId),
  {
    ...options,
    method: 'POST'


  }
);}



export type postApiTeamsTeamIdAgentsShelfNoteRunsResponse200TextPlain = {
  data: ShelfNoteAgentRunResponse
  status: 200
}

export type postApiTeamsTeamIdAgentsShelfNoteRunsResponse200ApplicationJson = {
  data: ShelfNoteAgentRunResponse
  status: 200
}

export type postApiTeamsTeamIdAgentsShelfNoteRunsResponse200TextJson = {
  data: ShelfNoteAgentRunResponse
  status: 200
}

export type postApiTeamsTeamIdAgentsShelfNoteRunsResponse400TextPlain = {
  data: TeamAgentErrorResponse
  status: 400
}

export type postApiTeamsTeamIdAgentsShelfNoteRunsResponse400ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 400
}

export type postApiTeamsTeamIdAgentsShelfNoteRunsResponse400TextJson = {
  data: TeamAgentErrorResponse
  status: 400
}

export type postApiTeamsTeamIdAgentsShelfNoteRunsResponse401TextPlain = {
  data: TeamAgentErrorResponse
  status: 401
}

export type postApiTeamsTeamIdAgentsShelfNoteRunsResponse401ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 401
}

export type postApiTeamsTeamIdAgentsShelfNoteRunsResponse401TextJson = {
  data: TeamAgentErrorResponse
  status: 401
}

export type postApiTeamsTeamIdAgentsShelfNoteRunsResponse402 = {
  data: PostApiTeamsTeamIdAgentsShelfNoteRuns402
  status: 402
}

export type postApiTeamsTeamIdAgentsShelfNoteRunsResponse403TextPlain = {
  data: TeamAgentErrorResponse
  status: 403
}

export type postApiTeamsTeamIdAgentsShelfNoteRunsResponse403ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type postApiTeamsTeamIdAgentsShelfNoteRunsResponse403TextJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type postApiTeamsTeamIdAgentsShelfNoteRunsResponseSuccess = (postApiTeamsTeamIdAgentsShelfNoteRunsResponse200TextPlain | postApiTeamsTeamIdAgentsShelfNoteRunsResponse200ApplicationJson | postApiTeamsTeamIdAgentsShelfNoteRunsResponse200TextJson) & {
  headers: Headers;
};
export type postApiTeamsTeamIdAgentsShelfNoteRunsResponseError = (postApiTeamsTeamIdAgentsShelfNoteRunsResponse400TextPlain | postApiTeamsTeamIdAgentsShelfNoteRunsResponse400ApplicationJson | postApiTeamsTeamIdAgentsShelfNoteRunsResponse400TextJson | postApiTeamsTeamIdAgentsShelfNoteRunsResponse401TextPlain | postApiTeamsTeamIdAgentsShelfNoteRunsResponse401ApplicationJson | postApiTeamsTeamIdAgentsShelfNoteRunsResponse401TextJson | postApiTeamsTeamIdAgentsShelfNoteRunsResponse402 | postApiTeamsTeamIdAgentsShelfNoteRunsResponse403TextPlain | postApiTeamsTeamIdAgentsShelfNoteRunsResponse403ApplicationJson | postApiTeamsTeamIdAgentsShelfNoteRunsResponse403TextJson) & {
  headers: Headers;
};

export type postApiTeamsTeamIdAgentsShelfNoteRunsResponse = (postApiTeamsTeamIdAgentsShelfNoteRunsResponseSuccess | postApiTeamsTeamIdAgentsShelfNoteRunsResponseError)

export const getPostApiTeamsTeamIdAgentsShelfNoteRunsUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/agents/shelf-note/runs`
}

export const postApiTeamsTeamIdAgentsShelfNoteRuns = async (teamId: string,
    nullShelfNoteAgentRunRequest: null | ShelfNoteAgentRunRequest, options?: RequestInit): Promise<postApiTeamsTeamIdAgentsShelfNoteRunsResponse> => {

  return fetcher<postApiTeamsTeamIdAgentsShelfNoteRunsResponse>(getPostApiTeamsTeamIdAgentsShelfNoteRunsUrl(teamId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullShelfNoteAgentRunRequest,)
  }
);}



export type getApiTeamsTeamIdAgentsShelfNoteRunsRunIdResponse200TextPlain = {
  data: ShelfNoteAgentRunStateResponse
  status: 200
}

export type getApiTeamsTeamIdAgentsShelfNoteRunsRunIdResponse200ApplicationJson = {
  data: ShelfNoteAgentRunStateResponse
  status: 200
}

export type getApiTeamsTeamIdAgentsShelfNoteRunsRunIdResponse200TextJson = {
  data: ShelfNoteAgentRunStateResponse
  status: 200
}

export type getApiTeamsTeamIdAgentsShelfNoteRunsRunIdResponse400TextPlain = {
  data: TeamAgentErrorResponse
  status: 400
}

export type getApiTeamsTeamIdAgentsShelfNoteRunsRunIdResponse400ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 400
}

export type getApiTeamsTeamIdAgentsShelfNoteRunsRunIdResponse400TextJson = {
  data: TeamAgentErrorResponse
  status: 400
}

export type getApiTeamsTeamIdAgentsShelfNoteRunsRunIdResponse401TextPlain = {
  data: TeamAgentErrorResponse
  status: 401
}

export type getApiTeamsTeamIdAgentsShelfNoteRunsRunIdResponse401ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 401
}

export type getApiTeamsTeamIdAgentsShelfNoteRunsRunIdResponse401TextJson = {
  data: TeamAgentErrorResponse
  status: 401
}

export type getApiTeamsTeamIdAgentsShelfNoteRunsRunIdResponse403TextPlain = {
  data: TeamAgentErrorResponse
  status: 403
}

export type getApiTeamsTeamIdAgentsShelfNoteRunsRunIdResponse403ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type getApiTeamsTeamIdAgentsShelfNoteRunsRunIdResponse403TextJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type getApiTeamsTeamIdAgentsShelfNoteRunsRunIdResponse404TextPlain = {
  data: TeamAgentErrorResponse
  status: 404
}

export type getApiTeamsTeamIdAgentsShelfNoteRunsRunIdResponse404ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 404
}

export type getApiTeamsTeamIdAgentsShelfNoteRunsRunIdResponse404TextJson = {
  data: TeamAgentErrorResponse
  status: 404
}

export type getApiTeamsTeamIdAgentsShelfNoteRunsRunIdResponseSuccess = (getApiTeamsTeamIdAgentsShelfNoteRunsRunIdResponse200TextPlain | getApiTeamsTeamIdAgentsShelfNoteRunsRunIdResponse200ApplicationJson | getApiTeamsTeamIdAgentsShelfNoteRunsRunIdResponse200TextJson) & {
  headers: Headers;
};
export type getApiTeamsTeamIdAgentsShelfNoteRunsRunIdResponseError = (getApiTeamsTeamIdAgentsShelfNoteRunsRunIdResponse400TextPlain | getApiTeamsTeamIdAgentsShelfNoteRunsRunIdResponse400ApplicationJson | getApiTeamsTeamIdAgentsShelfNoteRunsRunIdResponse400TextJson | getApiTeamsTeamIdAgentsShelfNoteRunsRunIdResponse401TextPlain | getApiTeamsTeamIdAgentsShelfNoteRunsRunIdResponse401ApplicationJson | getApiTeamsTeamIdAgentsShelfNoteRunsRunIdResponse401TextJson | getApiTeamsTeamIdAgentsShelfNoteRunsRunIdResponse403TextPlain | getApiTeamsTeamIdAgentsShelfNoteRunsRunIdResponse403ApplicationJson | getApiTeamsTeamIdAgentsShelfNoteRunsRunIdResponse403TextJson | getApiTeamsTeamIdAgentsShelfNoteRunsRunIdResponse404TextPlain | getApiTeamsTeamIdAgentsShelfNoteRunsRunIdResponse404ApplicationJson | getApiTeamsTeamIdAgentsShelfNoteRunsRunIdResponse404TextJson) & {
  headers: Headers;
};

export type getApiTeamsTeamIdAgentsShelfNoteRunsRunIdResponse = (getApiTeamsTeamIdAgentsShelfNoteRunsRunIdResponseSuccess | getApiTeamsTeamIdAgentsShelfNoteRunsRunIdResponseError)

export const getGetApiTeamsTeamIdAgentsShelfNoteRunsRunIdUrl = (teamId: string,
    runId: string,) => {




  return `/api/teams/${teamId}/agents/shelf-note/runs/${runId}`
}

export const getApiTeamsTeamIdAgentsShelfNoteRunsRunId = async (teamId: string,
    runId: string, options?: RequestInit): Promise<getApiTeamsTeamIdAgentsShelfNoteRunsRunIdResponse> => {

  return fetcher<getApiTeamsTeamIdAgentsShelfNoteRunsRunIdResponse>(getGetApiTeamsTeamIdAgentsShelfNoteRunsRunIdUrl(teamId,runId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionResponse200TextPlain = {
  data: ShelfNoteAgentRunStateResponse
  status: 200
}

export type postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionResponse200ApplicationJson = {
  data: ShelfNoteAgentRunStateResponse
  status: 200
}

export type postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionResponse200TextJson = {
  data: ShelfNoteAgentRunStateResponse
  status: 200
}

export type postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionResponse400TextPlain = {
  data: TeamAgentErrorResponse
  status: 400
}

export type postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionResponse400ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 400
}

export type postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionResponse400TextJson = {
  data: TeamAgentErrorResponse
  status: 400
}

export type postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionResponse401TextPlain = {
  data: TeamAgentErrorResponse
  status: 401
}

export type postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionResponse401ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 401
}

export type postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionResponse401TextJson = {
  data: TeamAgentErrorResponse
  status: 401
}

export type postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionResponse402 = {
  data: PostApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecision402
  status: 402
}

export type postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionResponse403TextPlain = {
  data: TeamAgentErrorResponse
  status: 403
}

export type postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionResponse403ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionResponse403TextJson = {
  data: TeamAgentErrorResponse
  status: 403
}

export type postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionResponse404TextPlain = {
  data: TeamAgentErrorResponse
  status: 404
}

export type postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionResponse404ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 404
}

export type postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionResponse404TextJson = {
  data: TeamAgentErrorResponse
  status: 404
}

export type postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionResponse409TextPlain = {
  data: TeamAgentErrorResponse
  status: 409
}

export type postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionResponse409ApplicationJson = {
  data: TeamAgentErrorResponse
  status: 409
}

export type postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionResponse409TextJson = {
  data: TeamAgentErrorResponse
  status: 409
}

export type postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionResponseSuccess = (postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionResponse200TextPlain | postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionResponse200ApplicationJson | postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionResponse200TextJson) & {
  headers: Headers;
};
export type postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionResponseError = (postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionResponse400TextPlain | postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionResponse400ApplicationJson | postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionResponse400TextJson | postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionResponse401TextPlain | postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionResponse401ApplicationJson | postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionResponse401TextJson | postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionResponse402 | postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionResponse403TextPlain | postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionResponse403ApplicationJson | postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionResponse403TextJson | postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionResponse404TextPlain | postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionResponse404ApplicationJson | postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionResponse404TextJson | postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionResponse409TextPlain | postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionResponse409ApplicationJson | postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionResponse409TextJson) & {
  headers: Headers;
};

export type postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionResponse = (postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionResponseSuccess | postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionResponseError)

export const getPostApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionUrl = (teamId: string,
    runId: string,) => {




  return `/api/teams/${teamId}/agents/shelf-note/runs/${runId}/checkpoints/action-approval/decision`
}

export const postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecision = async (teamId: string,
    runId: string,
    teamAgentCheckpointDecisionRequest: TeamAgentCheckpointDecisionRequest, options?: RequestInit): Promise<postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionResponse> => {

  return fetcher<postApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionResponse>(getPostApiTeamsTeamIdAgentsShelfNoteRunsRunIdCheckpointsActionApprovalDecisionUrl(teamId,runId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      teamAgentCheckpointDecisionRequest,)
  }
);}



export type getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdIntakesResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdIntakesResponse401 = {
  data: GetApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdIntakes401
  status: 401
}

export type getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdIntakesResponseSuccess = (getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdIntakesResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdIntakesResponseError = (getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdIntakesResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdIntakesResponse = (getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdIntakesResponseSuccess | getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdIntakesResponseError)

export const getGetApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdIntakesUrl = (teamId: string,
    crmSubmissionId: string,
    params?: GetApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdIntakesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/crm/submissions/${crmSubmissionId}/intakes?${stringifiedParams}` : `/api/teams/${teamId}/crm/submissions/${crmSubmissionId}/intakes`
}

export const getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdIntakes = async (teamId: string,
    crmSubmissionId: string,
    params?: GetApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdIntakesParams, options?: RequestInit): Promise<getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdIntakesResponse> => {

  return fetcher<getApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdIntakesResponse>(getGetApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdIntakesUrl(teamId,crmSubmissionId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdIntakesResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdIntakesResponse401 = {
  data: PostApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdIntakes401
  status: 401
}

export type postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdIntakesResponse402 = {
  data: PostApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdIntakes402
  status: 402
}

export type postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdIntakesResponseSuccess = (postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdIntakesResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdIntakesResponseError = (postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdIntakesResponse401 | postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdIntakesResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdIntakesResponse = (postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdIntakesResponseSuccess | postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdIntakesResponseError)

export const getPostApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdIntakesUrl = (teamId: string,
    crmSubmissionId: string,) => {




  return `/api/teams/${teamId}/crm/submissions/${crmSubmissionId}/intakes`
}

export const postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdIntakes = async (teamId: string,
    crmSubmissionId: string,
    nullTeamCreateIntakeRequest: null | TeamCreateIntakeRequest, options?: RequestInit): Promise<postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdIntakesResponse> => {

  return fetcher<postApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdIntakesResponse>(getPostApiTeamsTeamIdCrmSubmissionsCrmSubmissionIdIntakesUrl(teamId,crmSubmissionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullTeamCreateIntakeRequest,)
  }
);}



export type getApiTeamsTeamIdSubmissionsIntakesRunsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdSubmissionsIntakesRunsResponse401 = {
  data: GetApiTeamsTeamIdSubmissionsIntakesRuns401
  status: 401
}

export type getApiTeamsTeamIdSubmissionsIntakesRunsResponseSuccess = (getApiTeamsTeamIdSubmissionsIntakesRunsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdSubmissionsIntakesRunsResponseError = (getApiTeamsTeamIdSubmissionsIntakesRunsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdSubmissionsIntakesRunsResponse = (getApiTeamsTeamIdSubmissionsIntakesRunsResponseSuccess | getApiTeamsTeamIdSubmissionsIntakesRunsResponseError)

export const getGetApiTeamsTeamIdSubmissionsIntakesRunsUrl = (teamId: string,
    params?: GetApiTeamsTeamIdSubmissionsIntakesRunsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/submissions/intakes/runs?${stringifiedParams}` : `/api/teams/${teamId}/submissions/intakes/runs`
}

export const getApiTeamsTeamIdSubmissionsIntakesRuns = async (teamId: string,
    params?: GetApiTeamsTeamIdSubmissionsIntakesRunsParams, options?: RequestInit): Promise<getApiTeamsTeamIdSubmissionsIntakesRunsResponse> => {

  return fetcher<getApiTeamsTeamIdSubmissionsIntakesRunsResponse>(getGetApiTeamsTeamIdSubmissionsIntakesRunsUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdLinkProspectResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdLinkProspectResponse401 = {
  data: PostApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdLinkProspect401
  status: 401
}

export type postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdLinkProspectResponse402 = {
  data: PostApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdLinkProspect402
  status: 402
}

export type postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdLinkProspectResponseSuccess = (postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdLinkProspectResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdLinkProspectResponseError = (postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdLinkProspectResponse401 | postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdLinkProspectResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdLinkProspectResponse = (postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdLinkProspectResponseSuccess | postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdLinkProspectResponseError)

export const getPostApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdLinkProspectUrl = (teamId: string,
    intakeRunId: string,) => {




  return `/api/teams/${teamId}/submissions/intakes/runs/${intakeRunId}/link-prospect`
}

export const postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdLinkProspect = async (teamId: string,
    intakeRunId: string,
    nullTeamLinkIntakeRunProspectRequest: null | TeamLinkIntakeRunProspectRequest, options?: RequestInit): Promise<postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdLinkProspectResponse> => {

  return fetcher<postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdLinkProspectResponse>(getPostApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdLinkProspectUrl(teamId,intakeRunId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullTeamLinkIntakeRunProspectRequest,)
  }
);}



export type postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInviteResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInviteResponse401 = {
  data: PostApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInvite401
  status: 401
}

export type postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInviteResponse402 = {
  data: PostApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInvite402
  status: 402
}

export type postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInviteResponseSuccess = (postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInviteResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInviteResponseError = (postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInviteResponse401 | postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInviteResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInviteResponse = (postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInviteResponseSuccess | postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInviteResponseError)

export const getPostApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInviteUrl = (teamId: string,
    intakeRunId: string,) => {




  return `/api/teams/${teamId}/submissions/intakes/runs/${intakeRunId}/invite`
}

export const postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInvite = async (teamId: string,
    intakeRunId: string,
    nullTeamCreateIntakeInviteRequest: null | TeamCreateIntakeInviteRequest, options?: RequestInit): Promise<postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInviteResponse> => {

  return fetcher<postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInviteResponse>(getPostApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInviteUrl(teamId,intakeRunId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullTeamCreateIntakeInviteRequest,)
  }
);}



export type getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInvitesResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInvitesResponse401 = {
  data: GetApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInvites401
  status: 401
}

export type getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInvitesResponseSuccess = (getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInvitesResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInvitesResponseError = (getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInvitesResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInvitesResponse = (getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInvitesResponseSuccess | getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInvitesResponseError)

export const getGetApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInvitesUrl = (teamId: string,
    intakeRunId: string,) => {




  return `/api/teams/${teamId}/submissions/intakes/runs/${intakeRunId}/invites`
}

export const getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInvites = async (teamId: string,
    intakeRunId: string, options?: RequestInit): Promise<getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInvitesResponse> => {

  return fetcher<getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInvitesResponse>(getGetApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInvitesUrl(teamId,intakeRunId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInviteRevokeResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInviteRevokeResponse401 = {
  data: PostApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInviteRevoke401
  status: 401
}

export type postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInviteRevokeResponse402 = {
  data: PostApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInviteRevoke402
  status: 402
}

export type postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInviteRevokeResponseSuccess = (postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInviteRevokeResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInviteRevokeResponseError = (postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInviteRevokeResponse401 | postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInviteRevokeResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInviteRevokeResponse = (postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInviteRevokeResponseSuccess | postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInviteRevokeResponseError)

export const getPostApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInviteRevokeUrl = (teamId: string,
    intakeRunId: string,) => {




  return `/api/teams/${teamId}/submissions/intakes/runs/${intakeRunId}/invite/revoke`
}

export const postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInviteRevoke = async (teamId: string,
    intakeRunId: string,
    nullTeamRevokeIntakeInviteRequest: null | TeamRevokeIntakeInviteRequest, options?: RequestInit): Promise<postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInviteRevokeResponse> => {

  return fetcher<postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInviteRevokeResponse>(getPostApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdInviteRevokeUrl(teamId,intakeRunId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullTeamRevokeIntakeInviteRequest,)
  }
);}



export type postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdCloseResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdCloseResponse401 = {
  data: PostApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdClose401
  status: 401
}

export type postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdCloseResponse402 = {
  data: PostApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdClose402
  status: 402
}

export type postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdCloseResponseSuccess = (postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdCloseResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdCloseResponseError = (postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdCloseResponse401 | postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdCloseResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdCloseResponse = (postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdCloseResponseSuccess | postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdCloseResponseError)

export const getPostApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdCloseUrl = (teamId: string,
    intakeRunId: string,) => {




  return `/api/teams/${teamId}/submissions/intakes/runs/${intakeRunId}/close`
}

export const postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdClose = async (teamId: string,
    intakeRunId: string,
    nullTeamCloseIntakeRunRequest: null | TeamCloseIntakeRunRequest, options?: RequestInit): Promise<postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdCloseResponse> => {

  return fetcher<postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdCloseResponse>(getPostApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdCloseUrl(teamId,intakeRunId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullTeamCloseIntakeRunRequest,)
  }
);}



export type getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdEventsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdEventsResponse401 = {
  data: GetApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdEvents401
  status: 401
}

export type getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdEventsResponseSuccess = (getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdEventsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdEventsResponseError = (getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdEventsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdEventsResponse = (getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdEventsResponseSuccess | getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdEventsResponseError)

export const getGetApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdEventsUrl = (teamId: string,
    intakeRunId: string,
    params?: GetApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdEventsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/submissions/intakes/runs/${intakeRunId}/events?${stringifiedParams}` : `/api/teams/${teamId}/submissions/intakes/runs/${intakeRunId}/events`
}

export const getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdEvents = async (teamId: string,
    intakeRunId: string,
    params?: GetApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdEventsParams, options?: RequestInit): Promise<getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdEventsResponse> => {

  return fetcher<getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdEventsResponse>(getGetApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdEventsUrl(teamId,intakeRunId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdSlotDiffResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdSlotDiffResponse401 = {
  data: GetApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdSlotDiff401
  status: 401
}

export type getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdSlotDiffResponseSuccess = (getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdSlotDiffResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdSlotDiffResponseError = (getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdSlotDiffResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdSlotDiffResponse = (getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdSlotDiffResponseSuccess | getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdSlotDiffResponseError)

export const getGetApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdSlotDiffUrl = (teamId: string,
    intakeRunId: string,) => {




  return `/api/teams/${teamId}/submissions/intakes/runs/${intakeRunId}/slot-diff`
}

export const getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdSlotDiff = async (teamId: string,
    intakeRunId: string, options?: RequestInit): Promise<getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdSlotDiffResponse> => {

  return fetcher<getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdSlotDiffResponse>(getGetApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdSlotDiffUrl(teamId,intakeRunId),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdProposedValuesResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdProposedValuesResponse401 = {
  data: GetApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdProposedValues401
  status: 401
}

export type getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdProposedValuesResponseSuccess = (getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdProposedValuesResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdProposedValuesResponseError = (getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdProposedValuesResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdProposedValuesResponse = (getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdProposedValuesResponseSuccess | getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdProposedValuesResponseError)

export const getGetApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdProposedValuesUrl = (teamId: string,
    intakeRunId: string,) => {




  return `/api/teams/${teamId}/submissions/intakes/runs/${intakeRunId}/proposed-values`
}

export const getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdProposedValues = async (teamId: string,
    intakeRunId: string, options?: RequestInit): Promise<getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdProposedValuesResponse> => {

  return fetcher<getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdProposedValuesResponse>(getGetApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdProposedValuesUrl(teamId,intakeRunId),
  {
    ...options,
    method: 'GET'


  }
);}



export type putApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdProposedValuesResponse200 = {
  data: void
  status: 200
}

export type putApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdProposedValuesResponse401 = {
  data: PutApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdProposedValues401
  status: 401
}

export type putApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdProposedValuesResponse402 = {
  data: PutApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdProposedValues402
  status: 402
}

export type putApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdProposedValuesResponseSuccess = (putApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdProposedValuesResponse200) & {
  headers: Headers;
};
export type putApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdProposedValuesResponseError = (putApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdProposedValuesResponse401 | putApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdProposedValuesResponse402) & {
  headers: Headers;
};

export type putApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdProposedValuesResponse = (putApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdProposedValuesResponseSuccess | putApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdProposedValuesResponseError)

export const getPutApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdProposedValuesUrl = (teamId: string,
    intakeRunId: string,) => {




  return `/api/teams/${teamId}/submissions/intakes/runs/${intakeRunId}/proposed-values`
}

export const putApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdProposedValues = async (teamId: string,
    intakeRunId: string,
    nullTeamUpsertIntakeProposedValuesRequest: null | TeamUpsertIntakeProposedValuesRequest, options?: RequestInit): Promise<putApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdProposedValuesResponse> => {

  return fetcher<putApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdProposedValuesResponse>(getPutApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdProposedValuesUrl(teamId,intakeRunId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullTeamUpsertIntakeProposedValuesRequest,)
  }
);}



export type getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdReviewResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdReviewResponse401 = {
  data: GetApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdReview401
  status: 401
}

export type getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdReviewResponseSuccess = (getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdReviewResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdReviewResponseError = (getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdReviewResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdReviewResponse = (getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdReviewResponseSuccess | getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdReviewResponseError)

export const getGetApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdReviewUrl = (teamId: string,
    intakeRunId: string,) => {




  return `/api/teams/${teamId}/submissions/intakes/runs/${intakeRunId}/review`
}

export const getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdReview = async (teamId: string,
    intakeRunId: string, options?: RequestInit): Promise<getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdReviewResponse> => {

  return fetcher<getApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdReviewResponse>(getGetApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdReviewUrl(teamId,intakeRunId),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdApplyReviewResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdApplyReviewResponse401 = {
  data: PostApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdApplyReview401
  status: 401
}

export type postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdApplyReviewResponse402 = {
  data: PostApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdApplyReview402
  status: 402
}

export type postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdApplyReviewResponseSuccess = (postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdApplyReviewResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdApplyReviewResponseError = (postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdApplyReviewResponse401 | postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdApplyReviewResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdApplyReviewResponse = (postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdApplyReviewResponseSuccess | postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdApplyReviewResponseError)

export const getPostApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdApplyReviewUrl = (teamId: string,
    intakeRunId: string,) => {




  return `/api/teams/${teamId}/submissions/intakes/runs/${intakeRunId}/apply-review`
}

export const postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdApplyReview = async (teamId: string,
    intakeRunId: string,
    nullTeamApplyIntakeReviewRequest: null | TeamApplyIntakeReviewRequest, options?: RequestInit): Promise<postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdApplyReviewResponse> => {

  return fetcher<postApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdApplyReviewResponse>(getPostApiTeamsTeamIdSubmissionsIntakesRunsIntakeRunIdApplyReviewUrl(teamId,intakeRunId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      nullTeamApplyIntakeReviewRequest,)
  }
);}



export type getApiTeamsTeamIdSubmissionsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdSubmissionsResponse401 = {
  data: GetApiTeamsTeamIdSubmissions401
  status: 401
}

export type getApiTeamsTeamIdSubmissionsResponseSuccess = (getApiTeamsTeamIdSubmissionsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdSubmissionsResponseError = (getApiTeamsTeamIdSubmissionsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdSubmissionsResponse = (getApiTeamsTeamIdSubmissionsResponseSuccess | getApiTeamsTeamIdSubmissionsResponseError)

export const getGetApiTeamsTeamIdSubmissionsUrl = (teamId: string,
    params?: GetApiTeamsTeamIdSubmissionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/submissions?${stringifiedParams}` : `/api/teams/${teamId}/submissions`
}

export const getApiTeamsTeamIdSubmissions = async (teamId: string,
    params?: GetApiTeamsTeamIdSubmissionsParams, options?: RequestInit): Promise<getApiTeamsTeamIdSubmissionsResponse> => {

  return fetcher<getApiTeamsTeamIdSubmissionsResponse>(getGetApiTeamsTeamIdSubmissionsUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getApiTeamsTeamIdUploadsResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdUploadsResponse401 = {
  data: GetApiTeamsTeamIdUploads401
  status: 401
}

export type getApiTeamsTeamIdUploadsResponseSuccess = (getApiTeamsTeamIdUploadsResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdUploadsResponseError = (getApiTeamsTeamIdUploadsResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdUploadsResponse = (getApiTeamsTeamIdUploadsResponseSuccess | getApiTeamsTeamIdUploadsResponseError)

export const getGetApiTeamsTeamIdUploadsUrl = (teamId: string,
    params?: GetApiTeamsTeamIdUploadsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/uploads?${stringifiedParams}` : `/api/teams/${teamId}/uploads`
}

export const getApiTeamsTeamIdUploads = async (teamId: string,
    params?: GetApiTeamsTeamIdUploadsParams, options?: RequestInit): Promise<getApiTeamsTeamIdUploadsResponse> => {

  return fetcher<getApiTeamsTeamIdUploadsResponse>(getGetApiTeamsTeamIdUploadsUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiTeamsTeamIdUploadsResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdUploadsResponse401 = {
  data: PostApiTeamsTeamIdUploads401
  status: 401
}

export type postApiTeamsTeamIdUploadsResponse402 = {
  data: PostApiTeamsTeamIdUploads402
  status: 402
}

export type postApiTeamsTeamIdUploadsResponseSuccess = (postApiTeamsTeamIdUploadsResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdUploadsResponseError = (postApiTeamsTeamIdUploadsResponse401 | postApiTeamsTeamIdUploadsResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdUploadsResponse = (postApiTeamsTeamIdUploadsResponseSuccess | postApiTeamsTeamIdUploadsResponseError)

export const getPostApiTeamsTeamIdUploadsUrl = (teamId: string,) => {




  return `/api/teams/${teamId}/uploads`
}

export const postApiTeamsTeamIdUploads = async (teamId: string,
    postApiTeamsTeamIdUploadsBody: PostApiTeamsTeamIdUploadsBody, options?: RequestInit): Promise<postApiTeamsTeamIdUploadsResponse> => {
    const formData = new FormData();
if(postApiTeamsTeamIdUploadsBody.file !== undefined) {
 formData.append(`file`, postApiTeamsTeamIdUploadsBody.file);
 }
if(postApiTeamsTeamIdUploadsBody.displayName !== undefined) {
 formData.append(`displayName`, postApiTeamsTeamIdUploadsBody.displayName);
 }
if(postApiTeamsTeamIdUploadsBody.description !== undefined) {
 formData.append(`description`, postApiTeamsTeamIdUploadsBody.description);
 }

  return fetcher<postApiTeamsTeamIdUploadsResponse>(getPostApiTeamsTeamIdUploadsUrl(teamId),
  {
    ...options,
    method: 'POST'
    ,
    body:
      formData,
  }
);}



export type getApiTeamsTeamIdUploadsUploadIdContentResponse200 = {
  data: void
  status: 200
}

export type getApiTeamsTeamIdUploadsUploadIdContentResponse401 = {
  data: GetApiTeamsTeamIdUploadsUploadIdContent401
  status: 401
}

export type getApiTeamsTeamIdUploadsUploadIdContentResponseSuccess = (getApiTeamsTeamIdUploadsUploadIdContentResponse200) & {
  headers: Headers;
};
export type getApiTeamsTeamIdUploadsUploadIdContentResponseError = (getApiTeamsTeamIdUploadsUploadIdContentResponse401) & {
  headers: Headers;
};

export type getApiTeamsTeamIdUploadsUploadIdContentResponse = (getApiTeamsTeamIdUploadsUploadIdContentResponseSuccess | getApiTeamsTeamIdUploadsUploadIdContentResponseError)

export const getGetApiTeamsTeamIdUploadsUploadIdContentUrl = (teamId: string,
    uploadId: string,
    params?: GetApiTeamsTeamIdUploadsUploadIdContentParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teams/${teamId}/uploads/${uploadId}/content?${stringifiedParams}` : `/api/teams/${teamId}/uploads/${uploadId}/content`
}

export const getApiTeamsTeamIdUploadsUploadIdContent = async (teamId: string,
    uploadId: string,
    params?: GetApiTeamsTeamIdUploadsUploadIdContentParams, options?: RequestInit): Promise<getApiTeamsTeamIdUploadsUploadIdContentResponse> => {

  return fetcher<getApiTeamsTeamIdUploadsUploadIdContentResponse>(getGetApiTeamsTeamIdUploadsUploadIdContentUrl(teamId,uploadId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type deleteApiTeamsTeamIdUploadsUploadIdResponse200 = {
  data: void
  status: 200
}

export type deleteApiTeamsTeamIdUploadsUploadIdResponse401 = {
  data: DeleteApiTeamsTeamIdUploadsUploadId401
  status: 401
}

export type deleteApiTeamsTeamIdUploadsUploadIdResponse402 = {
  data: DeleteApiTeamsTeamIdUploadsUploadId402
  status: 402
}

export type deleteApiTeamsTeamIdUploadsUploadIdResponseSuccess = (deleteApiTeamsTeamIdUploadsUploadIdResponse200) & {
  headers: Headers;
};
export type deleteApiTeamsTeamIdUploadsUploadIdResponseError = (deleteApiTeamsTeamIdUploadsUploadIdResponse401 | deleteApiTeamsTeamIdUploadsUploadIdResponse402) & {
  headers: Headers;
};

export type deleteApiTeamsTeamIdUploadsUploadIdResponse = (deleteApiTeamsTeamIdUploadsUploadIdResponseSuccess | deleteApiTeamsTeamIdUploadsUploadIdResponseError)

export const getDeleteApiTeamsTeamIdUploadsUploadIdUrl = (teamId: string,
    uploadId: string,) => {




  return `/api/teams/${teamId}/uploads/${uploadId}`
}

export const deleteApiTeamsTeamIdUploadsUploadId = async (teamId: string,
    uploadId: string, options?: RequestInit): Promise<deleteApiTeamsTeamIdUploadsUploadIdResponse> => {

  return fetcher<deleteApiTeamsTeamIdUploadsUploadIdResponse>(getDeleteApiTeamsTeamIdUploadsUploadIdUrl(teamId,uploadId),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type postApiTeamsTeamIdUploadsUploadIdRestoreResponse200 = {
  data: void
  status: 200
}

export type postApiTeamsTeamIdUploadsUploadIdRestoreResponse401 = {
  data: PostApiTeamsTeamIdUploadsUploadIdRestore401
  status: 401
}

export type postApiTeamsTeamIdUploadsUploadIdRestoreResponse402 = {
  data: PostApiTeamsTeamIdUploadsUploadIdRestore402
  status: 402
}

export type postApiTeamsTeamIdUploadsUploadIdRestoreResponseSuccess = (postApiTeamsTeamIdUploadsUploadIdRestoreResponse200) & {
  headers: Headers;
};
export type postApiTeamsTeamIdUploadsUploadIdRestoreResponseError = (postApiTeamsTeamIdUploadsUploadIdRestoreResponse401 | postApiTeamsTeamIdUploadsUploadIdRestoreResponse402) & {
  headers: Headers;
};

export type postApiTeamsTeamIdUploadsUploadIdRestoreResponse = (postApiTeamsTeamIdUploadsUploadIdRestoreResponseSuccess | postApiTeamsTeamIdUploadsUploadIdRestoreResponseError)

export const getPostApiTeamsTeamIdUploadsUploadIdRestoreUrl = (teamId: string,
    uploadId: string,) => {




  return `/api/teams/${teamId}/uploads/${uploadId}/restore`
}

export const postApiTeamsTeamIdUploadsUploadIdRestore = async (teamId: string,
    uploadId: string, options?: RequestInit): Promise<postApiTeamsTeamIdUploadsUploadIdRestoreResponse> => {

  return fetcher<postApiTeamsTeamIdUploadsUploadIdRestoreResponse>(getPostApiTeamsTeamIdUploadsUploadIdRestoreUrl(teamId,uploadId),
  {
    ...options,
    method: 'POST'


  }
);}



export type deleteApiTeamsTeamIdUploadsUploadIdHardResponse200 = {
  data: void
  status: 200
}

export type deleteApiTeamsTeamIdUploadsUploadIdHardResponse401 = {
  data: DeleteApiTeamsTeamIdUploadsUploadIdHard401
  status: 401
}

export type deleteApiTeamsTeamIdUploadsUploadIdHardResponse402 = {
  data: DeleteApiTeamsTeamIdUploadsUploadIdHard402
  status: 402
}

export type deleteApiTeamsTeamIdUploadsUploadIdHardResponseSuccess = (deleteApiTeamsTeamIdUploadsUploadIdHardResponse200) & {
  headers: Headers;
};
export type deleteApiTeamsTeamIdUploadsUploadIdHardResponseError = (deleteApiTeamsTeamIdUploadsUploadIdHardResponse401 | deleteApiTeamsTeamIdUploadsUploadIdHardResponse402) & {
  headers: Headers;
};

export type deleteApiTeamsTeamIdUploadsUploadIdHardResponse = (deleteApiTeamsTeamIdUploadsUploadIdHardResponseSuccess | deleteApiTeamsTeamIdUploadsUploadIdHardResponseError)

export const getDeleteApiTeamsTeamIdUploadsUploadIdHardUrl = (teamId: string,
    uploadId: string,) => {




  return `/api/teams/${teamId}/uploads/${uploadId}/hard`
}

export const deleteApiTeamsTeamIdUploadsUploadIdHard = async (teamId: string,
    uploadId: string, options?: RequestInit): Promise<deleteApiTeamsTeamIdUploadsUploadIdHardResponse> => {

  return fetcher<deleteApiTeamsTeamIdUploadsUploadIdHardResponse>(getDeleteApiTeamsTeamIdUploadsUploadIdHardUrl(teamId,uploadId),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type getApiUsersResponse200TextPlain = {
  data: UserDto[]
  status: 200
}

export type getApiUsersResponse200ApplicationJson = {
  data: UserDto[]
  status: 200
}

export type getApiUsersResponse200TextJson = {
  data: UserDto[]
  status: 200
}

export type getApiUsersResponse401 = {
  data: GetApiUsers401
  status: 401
}

export type getApiUsersResponseSuccess = (getApiUsersResponse200TextPlain | getApiUsersResponse200ApplicationJson | getApiUsersResponse200TextJson) & {
  headers: Headers;
};
export type getApiUsersResponseError = (getApiUsersResponse401) & {
  headers: Headers;
};

export type getApiUsersResponse = (getApiUsersResponseSuccess | getApiUsersResponseError)

export const getGetApiUsersUrl = (params?: GetApiUsersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Users?${stringifiedParams}` : `/api/Users`
}

export const getApiUsers = async (params?: GetApiUsersParams, options?: RequestInit): Promise<getApiUsersResponse> => {

  return fetcher<getApiUsersResponse>(getGetApiUsersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type postApiUsersResponse200TextPlain = {
  data: UserDto
  status: 200
}

export type postApiUsersResponse200ApplicationJson = {
  data: UserDto
  status: 200
}

export type postApiUsersResponse200TextJson = {
  data: UserDto
  status: 200
}

export type postApiUsersResponse401 = {
  data: PostApiUsers401
  status: 401
}

export type postApiUsersResponse402 = {
  data: PostApiUsers402
  status: 402
}

export type postApiUsersResponseSuccess = (postApiUsersResponse200TextPlain | postApiUsersResponse200ApplicationJson | postApiUsersResponse200TextJson) & {
  headers: Headers;
};
export type postApiUsersResponseError = (postApiUsersResponse401 | postApiUsersResponse402) & {
  headers: Headers;
};

export type postApiUsersResponse = (postApiUsersResponseSuccess | postApiUsersResponseError)

export const getPostApiUsersUrl = () => {




  return `/api/Users`
}

export const postApiUsers = async (createUserRequest: CreateUserRequest, options?: RequestInit): Promise<postApiUsersResponse> => {

  return fetcher<postApiUsersResponse>(getPostApiUsersUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createUserRequest,)
  }
);}



export type getApiUsersIdResponse200TextPlain = {
  data: UserDetailDto
  status: 200
}

export type getApiUsersIdResponse200ApplicationJson = {
  data: UserDetailDto
  status: 200
}

export type getApiUsersIdResponse200TextJson = {
  data: UserDetailDto
  status: 200
}

export type getApiUsersIdResponse401 = {
  data: GetApiUsersId401
  status: 401
}

export type getApiUsersIdResponseSuccess = (getApiUsersIdResponse200TextPlain | getApiUsersIdResponse200ApplicationJson | getApiUsersIdResponse200TextJson) & {
  headers: Headers;
};
export type getApiUsersIdResponseError = (getApiUsersIdResponse401) & {
  headers: Headers;
};

export type getApiUsersIdResponse = (getApiUsersIdResponseSuccess | getApiUsersIdResponseError)

export const getGetApiUsersIdUrl = (id: string,) => {




  return `/api/Users/${id}`
}

export const getApiUsersId = async (id: string, options?: RequestInit): Promise<getApiUsersIdResponse> => {

  return fetcher<getApiUsersIdResponse>(getGetApiUsersIdUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}



export type putApiUsersIdResponse200TextPlain = {
  data: UserDto
  status: 200
}

export type putApiUsersIdResponse200ApplicationJson = {
  data: UserDto
  status: 200
}

export type putApiUsersIdResponse200TextJson = {
  data: UserDto
  status: 200
}

export type putApiUsersIdResponse401 = {
  data: PutApiUsersId401
  status: 401
}

export type putApiUsersIdResponse402 = {
  data: PutApiUsersId402
  status: 402
}

export type putApiUsersIdResponseSuccess = (putApiUsersIdResponse200TextPlain | putApiUsersIdResponse200ApplicationJson | putApiUsersIdResponse200TextJson) & {
  headers: Headers;
};
export type putApiUsersIdResponseError = (putApiUsersIdResponse401 | putApiUsersIdResponse402) & {
  headers: Headers;
};

export type putApiUsersIdResponse = (putApiUsersIdResponseSuccess | putApiUsersIdResponseError)

export const getPutApiUsersIdUrl = (id: string,) => {




  return `/api/Users/${id}`
}

export const putApiUsersId = async (id: string,
    updateUserRequest: UpdateUserRequest, options?: RequestInit): Promise<putApiUsersIdResponse> => {

  return fetcher<putApiUsersIdResponse>(getPutApiUsersIdUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateUserRequest,)
  }
);}



export type deleteApiUsersIdResponse200 = {
  data: void
  status: 200
}

export type deleteApiUsersIdResponse401 = {
  data: DeleteApiUsersId401
  status: 401
}

export type deleteApiUsersIdResponse402 = {
  data: DeleteApiUsersId402
  status: 402
}

export type deleteApiUsersIdResponseSuccess = (deleteApiUsersIdResponse200) & {
  headers: Headers;
};
export type deleteApiUsersIdResponseError = (deleteApiUsersIdResponse401 | deleteApiUsersIdResponse402) & {
  headers: Headers;
};

export type deleteApiUsersIdResponse = (deleteApiUsersIdResponseSuccess | deleteApiUsersIdResponseError)

export const getDeleteApiUsersIdUrl = (id: string,) => {




  return `/api/Users/${id}`
}

export const deleteApiUsersId = async (id: string, options?: RequestInit): Promise<deleteApiUsersIdResponse> => {

  return fetcher<deleteApiUsersIdResponse>(getDeleteApiUsersIdUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type postApiUsersIdToggleStatusResponse200TextPlain = {
  data: UserDto
  status: 200
}

export type postApiUsersIdToggleStatusResponse200ApplicationJson = {
  data: UserDto
  status: 200
}

export type postApiUsersIdToggleStatusResponse200TextJson = {
  data: UserDto
  status: 200
}

export type postApiUsersIdToggleStatusResponse401 = {
  data: PostApiUsersIdToggleStatus401
  status: 401
}

export type postApiUsersIdToggleStatusResponse402 = {
  data: PostApiUsersIdToggleStatus402
  status: 402
}

export type postApiUsersIdToggleStatusResponseSuccess = (postApiUsersIdToggleStatusResponse200TextPlain | postApiUsersIdToggleStatusResponse200ApplicationJson | postApiUsersIdToggleStatusResponse200TextJson) & {
  headers: Headers;
};
export type postApiUsersIdToggleStatusResponseError = (postApiUsersIdToggleStatusResponse401 | postApiUsersIdToggleStatusResponse402) & {
  headers: Headers;
};

export type postApiUsersIdToggleStatusResponse = (postApiUsersIdToggleStatusResponseSuccess | postApiUsersIdToggleStatusResponseError)

export const getPostApiUsersIdToggleStatusUrl = (id: string,) => {




  return `/api/Users/${id}/toggle-status`
}

export const postApiUsersIdToggleStatus = async (id: string, options?: RequestInit): Promise<postApiUsersIdToggleStatusResponse> => {

  return fetcher<postApiUsersIdToggleStatusResponse>(getPostApiUsersIdToggleStatusUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}



export type getApiUsersStatsResponse200TextPlain = {
  data: UserStatsDto
  status: 200
}

export type getApiUsersStatsResponse200ApplicationJson = {
  data: UserStatsDto
  status: 200
}

export type getApiUsersStatsResponse200TextJson = {
  data: UserStatsDto
  status: 200
}

export type getApiUsersStatsResponse401 = {
  data: GetApiUsersStats401
  status: 401
}

export type getApiUsersStatsResponseSuccess = (getApiUsersStatsResponse200TextPlain | getApiUsersStatsResponse200ApplicationJson | getApiUsersStatsResponse200TextJson) & {
  headers: Headers;
};
export type getApiUsersStatsResponseError = (getApiUsersStatsResponse401) & {
  headers: Headers;
};

export type getApiUsersStatsResponse = (getApiUsersStatsResponseSuccess | getApiUsersStatsResponseError)

export const getGetApiUsersStatsUrl = () => {




  return `/api/Users/stats`
}

export const getApiUsersStats = async ( options?: RequestInit): Promise<getApiUsersStatsResponse> => {

  return fetcher<getApiUsersStatsResponse>(getGetApiUsersStatsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type putApiUsersIdSettingsResponse200 = {
  data: void
  status: 200
}

export type putApiUsersIdSettingsResponse401 = {
  data: PutApiUsersIdSettings401
  status: 401
}

export type putApiUsersIdSettingsResponseSuccess = (putApiUsersIdSettingsResponse200) & {
  headers: Headers;
};
export type putApiUsersIdSettingsResponseError = (putApiUsersIdSettingsResponse401) & {
  headers: Headers;
};

export type putApiUsersIdSettingsResponse = (putApiUsersIdSettingsResponseSuccess | putApiUsersIdSettingsResponseError)

export const getPutApiUsersIdSettingsUrl = (id: string,) => {




  return `/api/Users/${id}/settings`
}

export const putApiUsersIdSettings = async (id: string,
    updateUserSettingsRequest: UpdateUserSettingsRequest, options?: RequestInit): Promise<putApiUsersIdSettingsResponse> => {

  return fetcher<putApiUsersIdSettingsResponse>(getPutApiUsersIdSettingsUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateUserSettingsRequest,)
  }
);}



export type postApiVinDecodeHybridResponse200TextPlain = {
  data: VinDecodeResponse
  status: 200
}

export type postApiVinDecodeHybridResponse200ApplicationJson = {
  data: VinDecodeResponse
  status: 200
}

export type postApiVinDecodeHybridResponse200TextJson = {
  data: VinDecodeResponse
  status: 200
}

export type postApiVinDecodeHybridResponse401 = {
  data: PostApiVinDecodeHybrid401
  status: 401
}

export type postApiVinDecodeHybridResponseSuccess = (postApiVinDecodeHybridResponse200TextPlain | postApiVinDecodeHybridResponse200ApplicationJson | postApiVinDecodeHybridResponse200TextJson) & {
  headers: Headers;
};
export type postApiVinDecodeHybridResponseError = (postApiVinDecodeHybridResponse401) & {
  headers: Headers;
};

export type postApiVinDecodeHybridResponse = (postApiVinDecodeHybridResponseSuccess | postApiVinDecodeHybridResponseError)

export const getPostApiVinDecodeHybridUrl = () => {




  return `/api/vin/decode-hybrid`
}

export const postApiVinDecodeHybrid = async (vinDecodeRequest: VinDecodeRequest, options?: RequestInit): Promise<postApiVinDecodeHybridResponse> => {

  return fetcher<postApiVinDecodeHybridResponse>(getPostApiVinDecodeHybridUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      vinDecodeRequest,)
  }
);}



export type postApiVinDecodeResponse200TextPlain = {
  data: VinDecodeResponse
  status: 200
}

export type postApiVinDecodeResponse200ApplicationJson = {
  data: VinDecodeResponse
  status: 200
}

export type postApiVinDecodeResponse200TextJson = {
  data: VinDecodeResponse
  status: 200
}

export type postApiVinDecodeResponse401 = {
  data: PostApiVinDecode401
  status: 401
}

export type postApiVinDecodeResponseSuccess = (postApiVinDecodeResponse200TextPlain | postApiVinDecodeResponse200ApplicationJson | postApiVinDecodeResponse200TextJson) & {
  headers: Headers;
};
export type postApiVinDecodeResponseError = (postApiVinDecodeResponse401) & {
  headers: Headers;
};

export type postApiVinDecodeResponse = (postApiVinDecodeResponseSuccess | postApiVinDecodeResponseError)

export const getPostApiVinDecodeUrl = () => {




  return `/api/vin/decode`
}

export const postApiVinDecode = async (vinDecodeRequest: VinDecodeRequest, options?: RequestInit): Promise<postApiVinDecodeResponse> => {

  return fetcher<postApiVinDecodeResponse>(getPostApiVinDecodeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      vinDecodeRequest,)
  }
);}



export type postApiVinDecodeApiResponse200TextPlain = {
  data: VinDecodeResponse
  status: 200
}

export type postApiVinDecodeApiResponse200ApplicationJson = {
  data: VinDecodeResponse
  status: 200
}

export type postApiVinDecodeApiResponse200TextJson = {
  data: VinDecodeResponse
  status: 200
}

export type postApiVinDecodeApiResponse401 = {
  data: PostApiVinDecodeApi401
  status: 401
}

export type postApiVinDecodeApiResponseSuccess = (postApiVinDecodeApiResponse200TextPlain | postApiVinDecodeApiResponse200ApplicationJson | postApiVinDecodeApiResponse200TextJson) & {
  headers: Headers;
};
export type postApiVinDecodeApiResponseError = (postApiVinDecodeApiResponse401) & {
  headers: Headers;
};

export type postApiVinDecodeApiResponse = (postApiVinDecodeApiResponseSuccess | postApiVinDecodeApiResponseError)

export const getPostApiVinDecodeApiUrl = () => {




  return `/api/vin/decode-api`
}

export const postApiVinDecodeApi = async (vinDecodeRequest: VinDecodeRequest, options?: RequestInit): Promise<postApiVinDecodeApiResponse> => {

  return fetcher<postApiVinDecodeApiResponse>(getPostApiVinDecodeApiUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      vinDecodeRequest,)
  }
);}



export type postApiVinDecodeRawResponse200TextPlain = {
  data: VinDecodeRawResponse
  status: 200
}

export type postApiVinDecodeRawResponse200ApplicationJson = {
  data: VinDecodeRawResponse
  status: 200
}

export type postApiVinDecodeRawResponse200TextJson = {
  data: VinDecodeRawResponse
  status: 200
}

export type postApiVinDecodeRawResponse401 = {
  data: PostApiVinDecodeRaw401
  status: 401
}

export type postApiVinDecodeRawResponseSuccess = (postApiVinDecodeRawResponse200TextPlain | postApiVinDecodeRawResponse200ApplicationJson | postApiVinDecodeRawResponse200TextJson) & {
  headers: Headers;
};
export type postApiVinDecodeRawResponseError = (postApiVinDecodeRawResponse401) & {
  headers: Headers;
};

export type postApiVinDecodeRawResponse = (postApiVinDecodeRawResponseSuccess | postApiVinDecodeRawResponseError)

export const getPostApiVinDecodeRawUrl = () => {




  return `/api/vin/decode-raw`
}

export const postApiVinDecodeRaw = async (vinDecodeRequest: VinDecodeRequest, options?: RequestInit): Promise<postApiVinDecodeRawResponse> => {

  return fetcher<postApiVinDecodeRawResponse>(getPostApiVinDecodeRawUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      vinDecodeRequest,)
  }
);}
